(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hltpo", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ca0b35bf0cc201ef$export$6503ec6e8aabbaf; }, function (v) { return $ca0b35bf0cc201ef$export$6503ec6e8aabbaf = v; });
var $ca0b35bf0cc201ef$export$6503ec6e8aabbaf;
var $ca0b35bf0cc201ef$export$f7ad0328861e2f03;
"use strict";
var $ca0b35bf0cc201ef$var$mapping = new Map();
function $ca0b35bf0cc201ef$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ca0b35bf0cc201ef$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ca0b35bf0cc201ef$var$resolve(id) {
    var resolved = $ca0b35bf0cc201ef$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ca0b35bf0cc201ef$export$6503ec6e8aabbaf = $ca0b35bf0cc201ef$var$register;
$ca0b35bf0cc201ef$export$f7ad0328861e2f03 = $ca0b35bf0cc201ef$var$resolve;

});

parcelRegister("7Hfbu", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $59a853de6408f6aa$export$bdfd709ae4826697; }, function (v) { return $59a853de6408f6aa$export$bdfd709ae4826697 = v; });
var $59a853de6408f6aa$export$bdfd709ae4826697;
var $59a853de6408f6aa$export$c9e73fbda7da57b6;
var $59a853de6408f6aa$export$5a759dc7a1cfb72a;
"use strict";
var $59a853de6408f6aa$var$bundleURL = {};
function $59a853de6408f6aa$var$getBundleURLCached(id) {
    var value = $59a853de6408f6aa$var$bundleURL[id];
    if (!value) {
        value = $59a853de6408f6aa$var$getBundleURL();
        $59a853de6408f6aa$var$bundleURL[id] = value;
    }
    return value;
}
function $59a853de6408f6aa$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $59a853de6408f6aa$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $59a853de6408f6aa$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $59a853de6408f6aa$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$59a853de6408f6aa$export$bdfd709ae4826697 = $59a853de6408f6aa$var$getBundleURLCached;
$59a853de6408f6aa$export$c9e73fbda7da57b6 = $59a853de6408f6aa$var$getBaseURL;
$59a853de6408f6aa$export$5a759dc7a1cfb72a = $59a853de6408f6aa$var$getOrigin;

});

parcelRegister("9twll", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6e5fe92f4867cc87$export$ffb0004e005737fa; }, function (v) { return $6e5fe92f4867cc87$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $6e5fe92f4867cc87$export$34b9dba7ce09269b; }, function (v) { return $6e5fe92f4867cc87$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $6e5fe92f4867cc87$export$25062201e9e25d76; }, function (v) { return $6e5fe92f4867cc87$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6e5fe92f4867cc87$export$ffb0004e005737fa;
var $6e5fe92f4867cc87$export$34b9dba7ce09269b;
var $6e5fe92f4867cc87$export$25062201e9e25d76;
"use strict";
var $6e5fe92f4867cc87$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6e5fe92f4867cc87$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $6e5fe92f4867cc87$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $6e5fe92f4867cc87$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$6e5fe92f4867cc87$export$ffb0004e005737fa = $6e5fe92f4867cc87$var$REACT_FRAGMENT_TYPE;
$6e5fe92f4867cc87$export$34b9dba7ce09269b = $6e5fe92f4867cc87$var$jsxProd;
$6e5fe92f4867cc87$export$25062201e9e25d76 = $6e5fe92f4867cc87$var$jsxProd;

});

parcelRegister("1Pgvo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ch6Tv"));

});
parcelRegister("ch6Tv", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $8efc6b98fbebfba5$export$dca3b0875bd9a954; }, function (v) { return $8efc6b98fbebfba5$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $8efc6b98fbebfba5$export$16fa2f45be04daa8; }, function (v) { return $8efc6b98fbebfba5$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8efc6b98fbebfba5$export$ffb0004e005737fa; }, function (v) { return $8efc6b98fbebfba5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $8efc6b98fbebfba5$export$e2c29f18771995cb; }, function (v) { return $8efc6b98fbebfba5$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $8efc6b98fbebfba5$export$221d75b3f55bb0bd; }, function (v) { return $8efc6b98fbebfba5$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8efc6b98fbebfba5$export$5f8d39834fd61797; }, function (v) { return $8efc6b98fbebfba5$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8efc6b98fbebfba5$export$74bf444e3cd11ea5; }, function (v) { return $8efc6b98fbebfba5$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $8efc6b98fbebfba5$export$1ced07cd6b1985ce; }, function (v) { return $8efc6b98fbebfba5$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "act", function () { return $8efc6b98fbebfba5$export$3ba232387fd5d6dd; }, function (v) { return $8efc6b98fbebfba5$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cache", function () { return $8efc6b98fbebfba5$export$69a3209f1a06c04d; }, function (v) { return $8efc6b98fbebfba5$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $8efc6b98fbebfba5$export$e530037191fcd5d7; }, function (v) { return $8efc6b98fbebfba5$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $8efc6b98fbebfba5$export$fd42f52fd3ae1109; }, function (v) { return $8efc6b98fbebfba5$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $8efc6b98fbebfba5$export$c8a8987d4410bf2d; }, function (v) { return $8efc6b98fbebfba5$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $8efc6b98fbebfba5$export$7d1e3a5e95ceca43; }, function (v) { return $8efc6b98fbebfba5$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $8efc6b98fbebfba5$export$257a8862b851cb5b; }, function (v) { return $8efc6b98fbebfba5$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $8efc6b98fbebfba5$export$a8257692ac88316c; }, function (v) { return $8efc6b98fbebfba5$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $8efc6b98fbebfba5$export$488013bae63b21da; }, function (v) { return $8efc6b98fbebfba5$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $8efc6b98fbebfba5$export$7c73462e0d25e514; }, function (v) { return $8efc6b98fbebfba5$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $8efc6b98fbebfba5$export$7568632d0d33d16d; }, function (v) { return $8efc6b98fbebfba5$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $8efc6b98fbebfba5$export$f93f40ac0ca7e3a8; }, function (v) { return $8efc6b98fbebfba5$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $8efc6b98fbebfba5$export$1f96ae73734a86cc; }, function (v) { return $8efc6b98fbebfba5$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $8efc6b98fbebfba5$export$9a47ced3238df325; }, function (v) { return $8efc6b98fbebfba5$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $8efc6b98fbebfba5$export$35808ee640e87ca7; }, function (v) { return $8efc6b98fbebfba5$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $8efc6b98fbebfba5$export$fae74005e78b1a27; }, function (v) { return $8efc6b98fbebfba5$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $8efc6b98fbebfba5$export$dc8fbce3eb94dc1e; }, function (v) { return $8efc6b98fbebfba5$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $8efc6b98fbebfba5$export$6a7bc4e911dc01cf; }, function (v) { return $8efc6b98fbebfba5$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $8efc6b98fbebfba5$export$6d9c69b0de29b591; }, function (v) { return $8efc6b98fbebfba5$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $8efc6b98fbebfba5$export$f680877a34711e37; }, function (v) { return $8efc6b98fbebfba5$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $8efc6b98fbebfba5$export$d5a552a76deda3c2; }, function (v) { return $8efc6b98fbebfba5$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $8efc6b98fbebfba5$export$aaabe4eda9ed9969; }, function (v) { return $8efc6b98fbebfba5$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $8efc6b98fbebfba5$export$e5c5a5f917a5871c; }, function (v) { return $8efc6b98fbebfba5$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $8efc6b98fbebfba5$export$1538c33de8887b59; }, function (v) { return $8efc6b98fbebfba5$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $8efc6b98fbebfba5$export$fca7f784ae7a249a; }, function (v) { return $8efc6b98fbebfba5$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $8efc6b98fbebfba5$export$13e3392192263954; }, function (v) { return $8efc6b98fbebfba5$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $8efc6b98fbebfba5$export$b8f5890fc79d6aca; }, function (v) { return $8efc6b98fbebfba5$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $8efc6b98fbebfba5$export$60241385465d0a34; }, function (v) { return $8efc6b98fbebfba5$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $8efc6b98fbebfba5$export$306c0aa65ff9ec16; }, function (v) { return $8efc6b98fbebfba5$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $8efc6b98fbebfba5$export$7b286972b8d8ccbf; }, function (v) { return $8efc6b98fbebfba5$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $8efc6b98fbebfba5$export$83d89fbfd8236492; }, function (v) { return $8efc6b98fbebfba5$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8efc6b98fbebfba5$export$dca3b0875bd9a954;
var $8efc6b98fbebfba5$export$16fa2f45be04daa8;
var $8efc6b98fbebfba5$export$ffb0004e005737fa;
var $8efc6b98fbebfba5$export$e2c29f18771995cb;
var $8efc6b98fbebfba5$export$221d75b3f55bb0bd;
var $8efc6b98fbebfba5$export$5f8d39834fd61797;
var $8efc6b98fbebfba5$export$74bf444e3cd11ea5;
var $8efc6b98fbebfba5$export$1ced07cd6b1985ce;
var $8efc6b98fbebfba5$export$3ba232387fd5d6dd;
var $8efc6b98fbebfba5$export$69a3209f1a06c04d;
var $8efc6b98fbebfba5$export$e530037191fcd5d7;
var $8efc6b98fbebfba5$export$fd42f52fd3ae1109;
var $8efc6b98fbebfba5$export$c8a8987d4410bf2d;
var $8efc6b98fbebfba5$export$7d1e3a5e95ceca43;
var $8efc6b98fbebfba5$export$257a8862b851cb5b;
var $8efc6b98fbebfba5$export$a8257692ac88316c;
var $8efc6b98fbebfba5$export$488013bae63b21da;
var $8efc6b98fbebfba5$export$7c73462e0d25e514;
var $8efc6b98fbebfba5$export$7568632d0d33d16d;
var $8efc6b98fbebfba5$export$f93f40ac0ca7e3a8;
var $8efc6b98fbebfba5$export$1f96ae73734a86cc;
var $8efc6b98fbebfba5$export$9a47ced3238df325;
var $8efc6b98fbebfba5$export$35808ee640e87ca7;
var $8efc6b98fbebfba5$export$fae74005e78b1a27;
var $8efc6b98fbebfba5$export$dc8fbce3eb94dc1e;
var $8efc6b98fbebfba5$export$6a7bc4e911dc01cf;
var $8efc6b98fbebfba5$export$6d9c69b0de29b591;
var $8efc6b98fbebfba5$export$f680877a34711e37;
var $8efc6b98fbebfba5$export$d5a552a76deda3c2;
var $8efc6b98fbebfba5$export$aaabe4eda9ed9969;
var $8efc6b98fbebfba5$export$e5c5a5f917a5871c;
var $8efc6b98fbebfba5$export$1538c33de8887b59;
var $8efc6b98fbebfba5$export$fca7f784ae7a249a;
var $8efc6b98fbebfba5$export$13e3392192263954;
var $8efc6b98fbebfba5$export$b8f5890fc79d6aca;
var $8efc6b98fbebfba5$export$60241385465d0a34;
var $8efc6b98fbebfba5$export$306c0aa65ff9ec16;
var $8efc6b98fbebfba5$export$7b286972b8d8ccbf;
var $8efc6b98fbebfba5$export$83d89fbfd8236492;

var $8HpnZ = parcelRequire("8HpnZ");
"use strict";
var $8efc6b98fbebfba5$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8efc6b98fbebfba5$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $8efc6b98fbebfba5$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $8efc6b98fbebfba5$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $8efc6b98fbebfba5$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $8efc6b98fbebfba5$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $8efc6b98fbebfba5$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $8efc6b98fbebfba5$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $8efc6b98fbebfba5$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $8efc6b98fbebfba5$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $8efc6b98fbebfba5$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $8efc6b98fbebfba5$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $8efc6b98fbebfba5$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $8efc6b98fbebfba5$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$8efc6b98fbebfba5$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $8efc6b98fbebfba5$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8efc6b98fbebfba5$var$assign = Object.assign, $8efc6b98fbebfba5$var$emptyObject = {};
function $8efc6b98fbebfba5$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $8efc6b98fbebfba5$var$emptyObject;
    this.updater = updater || $8efc6b98fbebfba5$var$ReactNoopUpdateQueue;
}
$8efc6b98fbebfba5$var$Component.prototype.isReactComponent = {};
$8efc6b98fbebfba5$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$8efc6b98fbebfba5$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $8efc6b98fbebfba5$var$ComponentDummy() {}
$8efc6b98fbebfba5$var$ComponentDummy.prototype = $8efc6b98fbebfba5$var$Component.prototype;
function $8efc6b98fbebfba5$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $8efc6b98fbebfba5$var$emptyObject;
    this.updater = updater || $8efc6b98fbebfba5$var$ReactNoopUpdateQueue;
}
var $8efc6b98fbebfba5$var$pureComponentPrototype = $8efc6b98fbebfba5$var$PureComponent.prototype = new $8efc6b98fbebfba5$var$ComponentDummy();
$8efc6b98fbebfba5$var$pureComponentPrototype.constructor = $8efc6b98fbebfba5$var$PureComponent;
$8efc6b98fbebfba5$var$assign($8efc6b98fbebfba5$var$pureComponentPrototype, $8efc6b98fbebfba5$var$Component.prototype);
$8efc6b98fbebfba5$var$pureComponentPrototype.isPureReactComponent = !0;
var $8efc6b98fbebfba5$var$isArrayImpl = Array.isArray, $8efc6b98fbebfba5$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $8efc6b98fbebfba5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $8efc6b98fbebfba5$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $8efc6b98fbebfba5$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $8efc6b98fbebfba5$var$cloneAndReplaceKey(oldElement, newKey) {
    return $8efc6b98fbebfba5$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $8efc6b98fbebfba5$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $8efc6b98fbebfba5$var$REACT_ELEMENT_TYPE;
}
function $8efc6b98fbebfba5$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $8efc6b98fbebfba5$var$userProvidedKeyEscapeRegex = /\/+/g;
function $8efc6b98fbebfba5$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $8efc6b98fbebfba5$var$escape("" + element.key) : index.toString(36);
}
function $8efc6b98fbebfba5$var$noop$1() {}
function $8efc6b98fbebfba5$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($8efc6b98fbebfba5$var$noop$1, $8efc6b98fbebfba5$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $8efc6b98fbebfba5$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $8efc6b98fbebfba5$var$REACT_ELEMENT_TYPE:
                case $8efc6b98fbebfba5$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $8efc6b98fbebfba5$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $8efc6b98fbebfba5$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $8efc6b98fbebfba5$var$getElementKey(children, 0) : nameSoFar, $8efc6b98fbebfba5$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($8efc6b98fbebfba5$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $8efc6b98fbebfba5$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($8efc6b98fbebfba5$var$isValidElement(callback) && (callback = $8efc6b98fbebfba5$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($8efc6b98fbebfba5$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($8efc6b98fbebfba5$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $8efc6b98fbebfba5$var$getElementKey(nameSoFar, i), invokeCallback += $8efc6b98fbebfba5$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $8efc6b98fbebfba5$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $8efc6b98fbebfba5$var$getElementKey(nameSoFar, i++), invokeCallback += $8efc6b98fbebfba5$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $8efc6b98fbebfba5$var$mapIntoArray($8efc6b98fbebfba5$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $8efc6b98fbebfba5$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $8efc6b98fbebfba5$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $8efc6b98fbebfba5$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $8efc6b98fbebfba5$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $8HpnZ && "function" === typeof $8HpnZ.emit) {
        $8HpnZ.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $8efc6b98fbebfba5$var$noop() {}
$8efc6b98fbebfba5$export$dca3b0875bd9a954 = {
    map: $8efc6b98fbebfba5$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $8efc6b98fbebfba5$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $8efc6b98fbebfba5$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $8efc6b98fbebfba5$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$8efc6b98fbebfba5$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$8efc6b98fbebfba5$export$16fa2f45be04daa8 = $8efc6b98fbebfba5$var$Component;
$8efc6b98fbebfba5$export$ffb0004e005737fa = $8efc6b98fbebfba5$var$REACT_FRAGMENT_TYPE;
$8efc6b98fbebfba5$export$e2c29f18771995cb = $8efc6b98fbebfba5$var$REACT_PROFILER_TYPE;
$8efc6b98fbebfba5$export$221d75b3f55bb0bd = $8efc6b98fbebfba5$var$PureComponent;
$8efc6b98fbebfba5$export$5f8d39834fd61797 = $8efc6b98fbebfba5$var$REACT_STRICT_MODE_TYPE;
$8efc6b98fbebfba5$export$74bf444e3cd11ea5 = $8efc6b98fbebfba5$var$REACT_SUSPENSE_TYPE;
$8efc6b98fbebfba5$export$1ced07cd6b1985ce = $8efc6b98fbebfba5$var$ReactSharedInternals;
$8efc6b98fbebfba5$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$8efc6b98fbebfba5$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$8efc6b98fbebfba5$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $8efc6b98fbebfba5$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$8efc6b98fbebfba5$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $8efc6b98fbebfba5$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$8efc6b98fbebfba5$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $8efc6b98fbebfba5$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $8efc6b98fbebfba5$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$8efc6b98fbebfba5$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$8efc6b98fbebfba5$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $8efc6b98fbebfba5$var$ReactElement(type, key, void 0, void 0, null, props);
};
$8efc6b98fbebfba5$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8efc6b98fbebfba5$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $8efc6b98fbebfba5$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$8efc6b98fbebfba5$export$a8257692ac88316c = $8efc6b98fbebfba5$var$isValidElement;
$8efc6b98fbebfba5$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $8efc6b98fbebfba5$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $8efc6b98fbebfba5$var$lazyInitializer
    };
};
$8efc6b98fbebfba5$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $8efc6b98fbebfba5$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$8efc6b98fbebfba5$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $8efc6b98fbebfba5$var$ReactSharedInternals.T, currentTransition = {};
    $8efc6b98fbebfba5$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $8efc6b98fbebfba5$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($8efc6b98fbebfba5$var$noop, $8efc6b98fbebfba5$var$reportGlobalError);
    } catch (error) {
        $8efc6b98fbebfba5$var$reportGlobalError(error);
    } finally{
        $8efc6b98fbebfba5$var$ReactSharedInternals.T = prevTransition;
    }
};
$8efc6b98fbebfba5$export$f93f40ac0ca7e3a8 = function() {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useCacheRefresh();
};
$8efc6b98fbebfba5$export$1f96ae73734a86cc = function(usable) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.use(usable);
};
$8efc6b98fbebfba5$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$8efc6b98fbebfba5$export$35808ee640e87ca7 = function(callback, deps) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$8efc6b98fbebfba5$export$fae74005e78b1a27 = function(Context) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useContext(Context);
};
$8efc6b98fbebfba5$export$dc8fbce3eb94dc1e = function() {};
$8efc6b98fbebfba5$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$8efc6b98fbebfba5$export$6d9c69b0de29b591 = function(create, deps) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useEffect(create, deps);
};
$8efc6b98fbebfba5$export$f680877a34711e37 = function() {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useId();
};
$8efc6b98fbebfba5$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$8efc6b98fbebfba5$export$aaabe4eda9ed9969 = function(create, deps) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$8efc6b98fbebfba5$export$e5c5a5f917a5871c = function(create, deps) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$8efc6b98fbebfba5$export$1538c33de8887b59 = function(create, deps) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useMemo(create, deps);
};
$8efc6b98fbebfba5$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$8efc6b98fbebfba5$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$8efc6b98fbebfba5$export$b8f5890fc79d6aca = function(initialValue) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useRef(initialValue);
};
$8efc6b98fbebfba5$export$60241385465d0a34 = function(initialState) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useState(initialState);
};
$8efc6b98fbebfba5$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$8efc6b98fbebfba5$export$7b286972b8d8ccbf = function() {
    return $8efc6b98fbebfba5$var$ReactSharedInternals.H.useTransition();
};
$8efc6b98fbebfba5$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("8HpnZ", function(module, exports) {
// shim for using process in browser
var $655608054d19555b$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $655608054d19555b$var$cachedSetTimeout;
var $655608054d19555b$var$cachedClearTimeout;
function $655608054d19555b$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $655608054d19555b$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $655608054d19555b$var$cachedSetTimeout = setTimeout;
        else $655608054d19555b$var$cachedSetTimeout = $655608054d19555b$var$defaultSetTimout;
    } catch (e) {
        $655608054d19555b$var$cachedSetTimeout = $655608054d19555b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $655608054d19555b$var$cachedClearTimeout = clearTimeout;
        else $655608054d19555b$var$cachedClearTimeout = $655608054d19555b$var$defaultClearTimeout;
    } catch (e) {
        $655608054d19555b$var$cachedClearTimeout = $655608054d19555b$var$defaultClearTimeout;
    }
})();
function $655608054d19555b$var$runTimeout(fun) {
    if ($655608054d19555b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($655608054d19555b$var$cachedSetTimeout === $655608054d19555b$var$defaultSetTimout || !$655608054d19555b$var$cachedSetTimeout) && setTimeout) {
        $655608054d19555b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $655608054d19555b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $655608054d19555b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $655608054d19555b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $655608054d19555b$var$runClearTimeout(marker) {
    if ($655608054d19555b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($655608054d19555b$var$cachedClearTimeout === $655608054d19555b$var$defaultClearTimeout || !$655608054d19555b$var$cachedClearTimeout) && clearTimeout) {
        $655608054d19555b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $655608054d19555b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $655608054d19555b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $655608054d19555b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $655608054d19555b$var$queue = [];
var $655608054d19555b$var$draining = false;
var $655608054d19555b$var$currentQueue;
var $655608054d19555b$var$queueIndex = -1;
function $655608054d19555b$var$cleanUpNextTick() {
    if (!$655608054d19555b$var$draining || !$655608054d19555b$var$currentQueue) return;
    $655608054d19555b$var$draining = false;
    if ($655608054d19555b$var$currentQueue.length) $655608054d19555b$var$queue = $655608054d19555b$var$currentQueue.concat($655608054d19555b$var$queue);
    else $655608054d19555b$var$queueIndex = -1;
    if ($655608054d19555b$var$queue.length) $655608054d19555b$var$drainQueue();
}
function $655608054d19555b$var$drainQueue() {
    if ($655608054d19555b$var$draining) return;
    var timeout = $655608054d19555b$var$runTimeout($655608054d19555b$var$cleanUpNextTick);
    $655608054d19555b$var$draining = true;
    var len = $655608054d19555b$var$queue.length;
    while(len){
        $655608054d19555b$var$currentQueue = $655608054d19555b$var$queue;
        $655608054d19555b$var$queue = [];
        while(++$655608054d19555b$var$queueIndex < len)if ($655608054d19555b$var$currentQueue) $655608054d19555b$var$currentQueue[$655608054d19555b$var$queueIndex].run();
        $655608054d19555b$var$queueIndex = -1;
        len = $655608054d19555b$var$queue.length;
    }
    $655608054d19555b$var$currentQueue = null;
    $655608054d19555b$var$draining = false;
    $655608054d19555b$var$runClearTimeout(timeout);
}
$655608054d19555b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $655608054d19555b$var$queue.push(new $655608054d19555b$var$Item(fun, args));
    if ($655608054d19555b$var$queue.length === 1 && !$655608054d19555b$var$draining) $655608054d19555b$var$runTimeout($655608054d19555b$var$drainQueue);
};
// v8 likes predictible objects
function $655608054d19555b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$655608054d19555b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$655608054d19555b$var$process.title = 'browser';
$655608054d19555b$var$process.browser = true;
$655608054d19555b$var$process.env = {};
$655608054d19555b$var$process.argv = [];
$655608054d19555b$var$process.version = ''; // empty string to avoid regexp issues
$655608054d19555b$var$process.versions = {};
function $655608054d19555b$var$noop() {}
$655608054d19555b$var$process.on = $655608054d19555b$var$noop;
$655608054d19555b$var$process.addListener = $655608054d19555b$var$noop;
$655608054d19555b$var$process.once = $655608054d19555b$var$noop;
$655608054d19555b$var$process.off = $655608054d19555b$var$noop;
$655608054d19555b$var$process.removeListener = $655608054d19555b$var$noop;
$655608054d19555b$var$process.removeAllListeners = $655608054d19555b$var$noop;
$655608054d19555b$var$process.emit = $655608054d19555b$var$noop;
$655608054d19555b$var$process.prependListener = $655608054d19555b$var$noop;
$655608054d19555b$var$process.prependOnceListener = $655608054d19555b$var$noop;
$655608054d19555b$var$process.listeners = function(name) {
    return [];
};
$655608054d19555b$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$655608054d19555b$var$process.cwd = function() {
    return '/';
};
$655608054d19555b$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$655608054d19555b$var$process.umask = function() {
    return 0;
};

});



parcelRegister("jGakj", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $e539f33816e64990$export$882461b6382ed46c; }, function (v) { return $e539f33816e64990$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e539f33816e64990$export$757ceba2d55c277e; }, function (v) { return $e539f33816e64990$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $e539f33816e64990$export$83d89fbfd8236492; }, function (v) { return $e539f33816e64990$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e539f33816e64990$export$882461b6382ed46c;
var $e539f33816e64990$export$757ceba2d55c277e;
var $e539f33816e64990$export$83d89fbfd8236492;

var $8HpnZ = parcelRequire("8HpnZ");
"use strict";

var $VGsl0 = parcelRequire("VGsl0");

var $1Pgvo = parcelRequire("1Pgvo");

var $kZ6Vu = parcelRequire("kZ6Vu");
function $e539f33816e64990$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $e539f33816e64990$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $e539f33816e64990$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $e539f33816e64990$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e539f33816e64990$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e539f33816e64990$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $e539f33816e64990$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $e539f33816e64990$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $e539f33816e64990$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $e539f33816e64990$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $e539f33816e64990$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $e539f33816e64990$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $e539f33816e64990$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $e539f33816e64990$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $e539f33816e64990$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $e539f33816e64990$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e539f33816e64990$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $e539f33816e64990$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $e539f33816e64990$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $e539f33816e64990$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $e539f33816e64990$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$e539f33816e64990$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $e539f33816e64990$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $e539f33816e64990$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $e539f33816e64990$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $e539f33816e64990$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $e539f33816e64990$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $e539f33816e64990$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $e539f33816e64990$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $e539f33816e64990$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $e539f33816e64990$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $e539f33816e64990$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $e539f33816e64990$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $e539f33816e64990$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $e539f33816e64990$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $e539f33816e64990$var$getComponentNameFromType(type.type) || "Memo";
        case $e539f33816e64990$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $e539f33816e64990$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $e539f33816e64990$var$ReactSharedInternals = $1Pgvo.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $e539f33816e64990$var$assign = Object.assign, $e539f33816e64990$var$prefix, $e539f33816e64990$var$suffix;
function $e539f33816e64990$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $e539f33816e64990$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $e539f33816e64990$var$prefix = match && match[1] || "";
        $e539f33816e64990$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $e539f33816e64990$var$prefix + name + $e539f33816e64990$var$suffix;
}
var $e539f33816e64990$var$reentry = !1;
function $e539f33816e64990$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $e539f33816e64990$var$reentry) return "";
    $e539f33816e64990$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $e539f33816e64990$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $e539f33816e64990$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $e539f33816e64990$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $e539f33816e64990$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $e539f33816e64990$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $e539f33816e64990$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $e539f33816e64990$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $e539f33816e64990$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $e539f33816e64990$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $e539f33816e64990$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $e539f33816e64990$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $e539f33816e64990$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $e539f33816e64990$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $e539f33816e64990$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $e539f33816e64990$var$assertIsMounted(fiber) {
    if ($e539f33816e64990$var$getNearestMountedFiber(fiber) !== fiber) throw Error($e539f33816e64990$var$formatProdErrorMessage(188));
}
function $e539f33816e64990$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $e539f33816e64990$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($e539f33816e64990$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $e539f33816e64990$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $e539f33816e64990$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($e539f33816e64990$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($e539f33816e64990$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($e539f33816e64990$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($e539f33816e64990$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $e539f33816e64990$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $e539f33816e64990$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $e539f33816e64990$var$isArrayImpl = Array.isArray, $e539f33816e64990$var$ReactDOMSharedInternals = $kZ6Vu.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $e539f33816e64990$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $e539f33816e64990$var$valueStack = [], $e539f33816e64990$var$index = -1;
function $e539f33816e64990$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $e539f33816e64990$var$pop(cursor) {
    0 > $e539f33816e64990$var$index || (cursor.current = $e539f33816e64990$var$valueStack[$e539f33816e64990$var$index], $e539f33816e64990$var$valueStack[$e539f33816e64990$var$index] = null, $e539f33816e64990$var$index--);
}
function $e539f33816e64990$var$push(cursor, value) {
    $e539f33816e64990$var$index++;
    $e539f33816e64990$var$valueStack[$e539f33816e64990$var$index] = cursor.current;
    cursor.current = value;
}
var $e539f33816e64990$var$contextStackCursor = $e539f33816e64990$var$createCursor(null), $e539f33816e64990$var$contextFiberStackCursor = $e539f33816e64990$var$createCursor(null), $e539f33816e64990$var$rootInstanceStackCursor = $e539f33816e64990$var$createCursor(null), $e539f33816e64990$var$hostTransitionProviderCursor = $e539f33816e64990$var$createCursor(null);
function $e539f33816e64990$var$pushHostContainer(fiber, nextRootInstance) {
    $e539f33816e64990$var$push($e539f33816e64990$var$rootInstanceStackCursor, nextRootInstance);
    $e539f33816e64990$var$push($e539f33816e64990$var$contextFiberStackCursor, fiber);
    $e539f33816e64990$var$push($e539f33816e64990$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $e539f33816e64990$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $e539f33816e64990$var$getOwnHostContext(fiber), nextRootInstance = $e539f33816e64990$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $e539f33816e64990$var$pop($e539f33816e64990$var$contextStackCursor);
    $e539f33816e64990$var$push($e539f33816e64990$var$contextStackCursor, nextRootInstance);
}
function $e539f33816e64990$var$popHostContainer() {
    $e539f33816e64990$var$pop($e539f33816e64990$var$contextStackCursor);
    $e539f33816e64990$var$pop($e539f33816e64990$var$contextFiberStackCursor);
    $e539f33816e64990$var$pop($e539f33816e64990$var$rootInstanceStackCursor);
}
function $e539f33816e64990$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $e539f33816e64990$var$push($e539f33816e64990$var$hostTransitionProviderCursor, fiber);
    var context = $e539f33816e64990$var$contextStackCursor.current;
    var JSCompiler_inline_result = $e539f33816e64990$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($e539f33816e64990$var$push($e539f33816e64990$var$contextFiberStackCursor, fiber), $e539f33816e64990$var$push($e539f33816e64990$var$contextStackCursor, JSCompiler_inline_result));
}
function $e539f33816e64990$var$popHostContext(fiber) {
    $e539f33816e64990$var$contextFiberStackCursor.current === fiber && ($e539f33816e64990$var$pop($e539f33816e64990$var$contextStackCursor), $e539f33816e64990$var$pop($e539f33816e64990$var$contextFiberStackCursor));
    $e539f33816e64990$var$hostTransitionProviderCursor.current === fiber && ($e539f33816e64990$var$pop($e539f33816e64990$var$hostTransitionProviderCursor), $e539f33816e64990$var$HostTransitionContext._currentValue = $e539f33816e64990$var$sharedNotPendingObject);
}
var $e539f33816e64990$var$hasOwnProperty = Object.prototype.hasOwnProperty, $e539f33816e64990$var$scheduleCallback$3 = $VGsl0.unstable_scheduleCallback, $e539f33816e64990$var$cancelCallback$1 = $VGsl0.unstable_cancelCallback, $e539f33816e64990$var$shouldYield = $VGsl0.unstable_shouldYield, $e539f33816e64990$var$requestPaint = $VGsl0.unstable_requestPaint, $e539f33816e64990$var$now = $VGsl0.unstable_now, $e539f33816e64990$var$getCurrentPriorityLevel = $VGsl0.unstable_getCurrentPriorityLevel, $e539f33816e64990$var$ImmediatePriority = $VGsl0.unstable_ImmediatePriority, $e539f33816e64990$var$UserBlockingPriority = $VGsl0.unstable_UserBlockingPriority, $e539f33816e64990$var$NormalPriority$1 = $VGsl0.unstable_NormalPriority, $e539f33816e64990$var$LowPriority = $VGsl0.unstable_LowPriority, $e539f33816e64990$var$IdlePriority = $VGsl0.unstable_IdlePriority, $e539f33816e64990$var$log$1 = $VGsl0.log, $e539f33816e64990$var$unstable_setDisableYieldValue = $VGsl0.unstable_setDisableYieldValue, $e539f33816e64990$var$rendererID = null, $e539f33816e64990$var$injectedHook = null;
function $e539f33816e64990$var$onCommitRoot(root) {
    if ($e539f33816e64990$var$injectedHook && "function" === typeof $e539f33816e64990$var$injectedHook.onCommitFiberRoot) try {
        $e539f33816e64990$var$injectedHook.onCommitFiberRoot($e539f33816e64990$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $e539f33816e64990$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $e539f33816e64990$var$log$1 && $e539f33816e64990$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($e539f33816e64990$var$injectedHook && "function" === typeof $e539f33816e64990$var$injectedHook.setStrictMode) try {
        $e539f33816e64990$var$injectedHook.setStrictMode($e539f33816e64990$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $e539f33816e64990$var$clz32 = Math.clz32 ? Math.clz32 : $e539f33816e64990$var$clz32Fallback, $e539f33816e64990$var$log = Math.log, $e539f33816e64990$var$LN2 = Math.LN2;
function $e539f33816e64990$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($e539f33816e64990$var$log(x) / $e539f33816e64990$var$LN2 | 0) | 0;
}
var $e539f33816e64990$var$nextTransitionLane = 128, $e539f33816e64990$var$nextRetryLane = 4194304;
function $e539f33816e64990$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $e539f33816e64990$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $e539f33816e64990$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $e539f33816e64990$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $e539f33816e64990$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $e539f33816e64990$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $e539f33816e64990$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $e539f33816e64990$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $e539f33816e64990$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $e539f33816e64990$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e539f33816e64990$var$claimNextTransitionLane() {
    var lane = $e539f33816e64990$var$nextTransitionLane;
    $e539f33816e64990$var$nextTransitionLane <<= 1;
    0 === ($e539f33816e64990$var$nextTransitionLane & 4194176) && ($e539f33816e64990$var$nextTransitionLane = 128);
    return lane;
}
function $e539f33816e64990$var$claimNextRetryLane() {
    var lane = $e539f33816e64990$var$nextRetryLane;
    $e539f33816e64990$var$nextRetryLane <<= 1;
    0 === ($e539f33816e64990$var$nextRetryLane & 62914560) && ($e539f33816e64990$var$nextRetryLane = 4194304);
    return lane;
}
function $e539f33816e64990$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $e539f33816e64990$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $e539f33816e64990$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $e539f33816e64990$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $e539f33816e64990$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $e539f33816e64990$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $e539f33816e64990$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $e539f33816e64990$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $e539f33816e64990$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $e539f33816e64990$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $e539f33816e64990$var$resolveUpdatePriority() {
    var updatePriority = $e539f33816e64990$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $e539f33816e64990$var$getEventPriority(updatePriority.type);
}
function $e539f33816e64990$var$runWithPriority(priority, fn) {
    var previousPriority = $e539f33816e64990$var$ReactDOMSharedInternals.p;
    try {
        return $e539f33816e64990$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $e539f33816e64990$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $e539f33816e64990$var$randomKey = Math.random().toString(36).slice(2), $e539f33816e64990$var$internalInstanceKey = "__reactFiber$" + $e539f33816e64990$var$randomKey, $e539f33816e64990$var$internalPropsKey = "__reactProps$" + $e539f33816e64990$var$randomKey, $e539f33816e64990$var$internalContainerInstanceKey = "__reactContainer$" + $e539f33816e64990$var$randomKey, $e539f33816e64990$var$internalEventHandlersKey = "__reactEvents$" + $e539f33816e64990$var$randomKey, $e539f33816e64990$var$internalEventHandlerListenersKey = "__reactListeners$" + $e539f33816e64990$var$randomKey, $e539f33816e64990$var$internalEventHandlesSetKey = "__reactHandles$" + $e539f33816e64990$var$randomKey, $e539f33816e64990$var$internalRootNodeResourcesKey = "__reactResources$" + $e539f33816e64990$var$randomKey, $e539f33816e64990$var$internalHoistableMarker = "__reactMarker$" + $e539f33816e64990$var$randomKey;
function $e539f33816e64990$var$detachDeletedInstance(node) {
    delete node[$e539f33816e64990$var$internalInstanceKey];
    delete node[$e539f33816e64990$var$internalPropsKey];
    delete node[$e539f33816e64990$var$internalEventHandlersKey];
    delete node[$e539f33816e64990$var$internalEventHandlerListenersKey];
    delete node[$e539f33816e64990$var$internalEventHandlesSetKey];
}
function $e539f33816e64990$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$e539f33816e64990$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$e539f33816e64990$var$internalContainerInstanceKey] || parentNode[$e539f33816e64990$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $e539f33816e64990$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$e539f33816e64990$var$internalInstanceKey]) return parentNode;
                targetNode = $e539f33816e64990$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $e539f33816e64990$var$getInstanceFromNode(node) {
    if (node = node[$e539f33816e64990$var$internalInstanceKey] || node[$e539f33816e64990$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $e539f33816e64990$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($e539f33816e64990$var$formatProdErrorMessage(33));
}
function $e539f33816e64990$var$getResourcesFromRoot(root) {
    var resources = root[$e539f33816e64990$var$internalRootNodeResourcesKey];
    resources || (resources = root[$e539f33816e64990$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $e539f33816e64990$var$markNodeAsHoistable(node) {
    node[$e539f33816e64990$var$internalHoistableMarker] = !0;
}
var $e539f33816e64990$var$allNativeEvents = new Set(), $e539f33816e64990$var$registrationNameDependencies = {};
function $e539f33816e64990$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $e539f33816e64990$var$registerDirectEvent(registrationName, dependencies);
    $e539f33816e64990$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $e539f33816e64990$var$registerDirectEvent(registrationName, dependencies) {
    $e539f33816e64990$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$e539f33816e64990$var$allNativeEvents.add(dependencies[registrationName]);
}
var $e539f33816e64990$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e539f33816e64990$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $e539f33816e64990$var$illegalAttributeNameCache = {}, $e539f33816e64990$var$validatedAttributeNameCache = {};
function $e539f33816e64990$var$isAttributeNameSafe(attributeName) {
    if ($e539f33816e64990$var$hasOwnProperty.call($e539f33816e64990$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($e539f33816e64990$var$hasOwnProperty.call($e539f33816e64990$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($e539f33816e64990$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $e539f33816e64990$var$validatedAttributeNameCache[attributeName] = !0;
    $e539f33816e64990$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $e539f33816e64990$var$setValueForAttribute(node, name, value) {
    if ($e539f33816e64990$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $e539f33816e64990$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $e539f33816e64990$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $e539f33816e64990$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $e539f33816e64990$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $e539f33816e64990$var$trackValueOnNode(node) {
    var valueField = $e539f33816e64990$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $e539f33816e64990$var$track(node) {
    node._valueTracker || (node._valueTracker = $e539f33816e64990$var$trackValueOnNode(node));
}
function $e539f33816e64990$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $e539f33816e64990$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $e539f33816e64990$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $e539f33816e64990$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $e539f33816e64990$var$getToStringValue(value);
        } else element.value !== "" + $e539f33816e64990$var$getToStringValue(value) && (element.value = "" + $e539f33816e64990$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $e539f33816e64990$var$setDefaultValue(element, type, $e539f33816e64990$var$getToStringValue(value)) : null != defaultValue ? $e539f33816e64990$var$setDefaultValue(element, type, $e539f33816e64990$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $e539f33816e64990$var$getToStringValue(name) : element.removeAttribute("name");
}
function $e539f33816e64990$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $e539f33816e64990$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $e539f33816e64990$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $e539f33816e64990$var$setDefaultValue(node, type, value) {
    "number" === type && $e539f33816e64990$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $e539f33816e64990$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $e539f33816e64990$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $e539f33816e64990$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $e539f33816e64990$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $e539f33816e64990$var$getToStringValue(defaultValue) : "";
}
function $e539f33816e64990$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($e539f33816e64990$var$formatProdErrorMessage(92));
            if ($e539f33816e64990$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($e539f33816e64990$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $e539f33816e64990$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $e539f33816e64990$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $e539f33816e64990$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $e539f33816e64990$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $e539f33816e64990$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $e539f33816e64990$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($e539f33816e64990$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $e539f33816e64990$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $e539f33816e64990$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $e539f33816e64990$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e539f33816e64990$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $e539f33816e64990$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $e539f33816e64990$var$sanitizeURL(url) {
    return $e539f33816e64990$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $e539f33816e64990$var$currentReplayingEvent = null;
function $e539f33816e64990$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $e539f33816e64990$var$restoreTarget = null, $e539f33816e64990$var$restoreQueue = null;
function $e539f33816e64990$var$restoreStateOfTarget(target) {
    var internalInstance = $e539f33816e64990$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$e539f33816e64990$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $e539f33816e64990$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$e539f33816e64990$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($e539f33816e64990$var$formatProdErrorMessage(90));
                            $e539f33816e64990$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $e539f33816e64990$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $e539f33816e64990$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $e539f33816e64990$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $e539f33816e64990$var$isInsideEventHandler = !1;
function $e539f33816e64990$var$batchedUpdates$1(fn, a, b) {
    if ($e539f33816e64990$var$isInsideEventHandler) return fn(a, b);
    $e539f33816e64990$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($e539f33816e64990$var$isInsideEventHandler = !1, null !== $e539f33816e64990$var$restoreTarget || null !== $e539f33816e64990$var$restoreQueue) {
            if ($e539f33816e64990$var$flushSyncWork$1(), $e539f33816e64990$var$restoreTarget && (a = $e539f33816e64990$var$restoreTarget, fn = $e539f33816e64990$var$restoreQueue, $e539f33816e64990$var$restoreQueue = $e539f33816e64990$var$restoreTarget = null, $e539f33816e64990$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$e539f33816e64990$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $e539f33816e64990$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$e539f33816e64990$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($e539f33816e64990$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $e539f33816e64990$var$passiveBrowserEventsSupported = !1;
if ($e539f33816e64990$var$canUseDOM) try {
    var $e539f33816e64990$var$options = {};
    Object.defineProperty($e539f33816e64990$var$options, "passive", {
        get: function() {
            $e539f33816e64990$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $e539f33816e64990$var$options, $e539f33816e64990$var$options);
    window.removeEventListener("test", $e539f33816e64990$var$options, $e539f33816e64990$var$options);
} catch (e) {
    $e539f33816e64990$var$passiveBrowserEventsSupported = !1;
}
var $e539f33816e64990$var$root = null, $e539f33816e64990$var$startText = null, $e539f33816e64990$var$fallbackText = null;
function $e539f33816e64990$var$getData() {
    if ($e539f33816e64990$var$fallbackText) return $e539f33816e64990$var$fallbackText;
    var start, startValue = $e539f33816e64990$var$startText, startLength = startValue.length, end, endValue = "value" in $e539f33816e64990$var$root ? $e539f33816e64990$var$root.value : $e539f33816e64990$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $e539f33816e64990$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $e539f33816e64990$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $e539f33816e64990$var$functionThatReturnsTrue() {
    return !0;
}
function $e539f33816e64990$var$functionThatReturnsFalse() {
    return !1;
}
function $e539f33816e64990$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $e539f33816e64990$var$functionThatReturnsTrue : $e539f33816e64990$var$functionThatReturnsFalse;
        this.isPropagationStopped = $e539f33816e64990$var$functionThatReturnsFalse;
        return this;
    }
    $e539f33816e64990$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $e539f33816e64990$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $e539f33816e64990$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $e539f33816e64990$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $e539f33816e64990$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e539f33816e64990$var$SyntheticEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$EventInterface), $e539f33816e64990$var$UIEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$EventInterface, {
    view: 0,
    detail: 0
}), $e539f33816e64990$var$SyntheticUIEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$UIEventInterface), $e539f33816e64990$var$lastMovementX, $e539f33816e64990$var$lastMovementY, $e539f33816e64990$var$lastMouseEvent, $e539f33816e64990$var$MouseEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e539f33816e64990$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $e539f33816e64990$var$lastMouseEvent && ($e539f33816e64990$var$lastMouseEvent && "mousemove" === event.type ? ($e539f33816e64990$var$lastMovementX = event.screenX - $e539f33816e64990$var$lastMouseEvent.screenX, $e539f33816e64990$var$lastMovementY = event.screenY - $e539f33816e64990$var$lastMouseEvent.screenY) : $e539f33816e64990$var$lastMovementY = $e539f33816e64990$var$lastMovementX = 0, $e539f33816e64990$var$lastMouseEvent = event);
        return $e539f33816e64990$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $e539f33816e64990$var$lastMovementY;
    }
}), $e539f33816e64990$var$SyntheticMouseEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$MouseEventInterface), $e539f33816e64990$var$DragEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$MouseEventInterface, {
    dataTransfer: 0
}), $e539f33816e64990$var$SyntheticDragEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$DragEventInterface), $e539f33816e64990$var$FocusEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$UIEventInterface, {
    relatedTarget: 0
}), $e539f33816e64990$var$SyntheticFocusEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$FocusEventInterface), $e539f33816e64990$var$AnimationEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e539f33816e64990$var$SyntheticAnimationEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$AnimationEventInterface), $e539f33816e64990$var$ClipboardEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $e539f33816e64990$var$SyntheticClipboardEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$ClipboardEventInterface), $e539f33816e64990$var$CompositionEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$EventInterface, {
    data: 0
}), $e539f33816e64990$var$SyntheticCompositionEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$CompositionEventInterface), $e539f33816e64990$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e539f33816e64990$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e539f33816e64990$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e539f33816e64990$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $e539f33816e64990$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $e539f33816e64990$var$getEventModifierState() {
    return $e539f33816e64990$var$modifierStateGetter;
}
var $e539f33816e64990$var$KeyboardEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $e539f33816e64990$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $e539f33816e64990$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $e539f33816e64990$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e539f33816e64990$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $e539f33816e64990$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $e539f33816e64990$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $e539f33816e64990$var$SyntheticKeyboardEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$KeyboardEventInterface), $e539f33816e64990$var$PointerEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e539f33816e64990$var$SyntheticPointerEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$PointerEventInterface), $e539f33816e64990$var$TouchEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e539f33816e64990$var$getEventModifierState
}), $e539f33816e64990$var$SyntheticTouchEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$TouchEventInterface), $e539f33816e64990$var$TransitionEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e539f33816e64990$var$SyntheticTransitionEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$TransitionEventInterface), $e539f33816e64990$var$WheelEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e539f33816e64990$var$SyntheticWheelEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$WheelEventInterface), $e539f33816e64990$var$ToggleEventInterface = $e539f33816e64990$var$assign({}, $e539f33816e64990$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $e539f33816e64990$var$SyntheticToggleEvent = $e539f33816e64990$var$createSyntheticEvent($e539f33816e64990$var$ToggleEventInterface), $e539f33816e64990$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $e539f33816e64990$var$canUseCompositionEvent = $e539f33816e64990$var$canUseDOM && "CompositionEvent" in window, $e539f33816e64990$var$documentMode = null;
$e539f33816e64990$var$canUseDOM && "documentMode" in document && ($e539f33816e64990$var$documentMode = document.documentMode);
var $e539f33816e64990$var$canUseTextInputEvent = $e539f33816e64990$var$canUseDOM && "TextEvent" in window && !$e539f33816e64990$var$documentMode, $e539f33816e64990$var$useFallbackCompositionData = $e539f33816e64990$var$canUseDOM && (!$e539f33816e64990$var$canUseCompositionEvent || $e539f33816e64990$var$documentMode && 8 < $e539f33816e64990$var$documentMode && 11 >= $e539f33816e64990$var$documentMode), $e539f33816e64990$var$SPACEBAR_CHAR = String.fromCharCode(32), $e539f33816e64990$var$hasSpaceKeypress = !1;
function $e539f33816e64990$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $e539f33816e64990$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e539f33816e64990$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $e539f33816e64990$var$isComposing = !1;
function $e539f33816e64990$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $e539f33816e64990$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $e539f33816e64990$var$hasSpaceKeypress = !0;
            return $e539f33816e64990$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $e539f33816e64990$var$SPACEBAR_CHAR && $e539f33816e64990$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $e539f33816e64990$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($e539f33816e64990$var$isComposing) return "compositionend" === domEventName || !$e539f33816e64990$var$canUseCompositionEvent && $e539f33816e64990$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $e539f33816e64990$var$getData(), $e539f33816e64990$var$fallbackText = $e539f33816e64990$var$startText = $e539f33816e64990$var$root = null, $e539f33816e64990$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $e539f33816e64990$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $e539f33816e64990$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e539f33816e64990$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$e539f33816e64990$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $e539f33816e64990$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $e539f33816e64990$var$restoreTarget ? $e539f33816e64990$var$restoreQueue ? $e539f33816e64990$var$restoreQueue.push(target) : $e539f33816e64990$var$restoreQueue = [
        target
    ] : $e539f33816e64990$var$restoreTarget = target;
    inst = $e539f33816e64990$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $e539f33816e64990$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $e539f33816e64990$var$activeElement$1 = null, $e539f33816e64990$var$activeElementInst$1 = null;
function $e539f33816e64990$var$runEventInBatch(dispatchQueue) {
    $e539f33816e64990$var$processDispatchQueue(dispatchQueue, 0);
}
function $e539f33816e64990$var$getInstIfValueChanged(targetInst) {
    var targetNode = $e539f33816e64990$var$getNodeFromInstance(targetInst);
    if ($e539f33816e64990$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $e539f33816e64990$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $e539f33816e64990$var$isInputEventSupported = !1;
if ($e539f33816e64990$var$canUseDOM) {
    var $e539f33816e64990$var$JSCompiler_inline_result$jscomp$283;
    if ($e539f33816e64990$var$canUseDOM) {
        var $e539f33816e64990$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$e539f33816e64990$var$isSupported$jscomp$inline_418) {
            var $e539f33816e64990$var$element$jscomp$inline_419 = document.createElement("div");
            $e539f33816e64990$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $e539f33816e64990$var$isSupported$jscomp$inline_418 = "function" === typeof $e539f33816e64990$var$element$jscomp$inline_419.oninput;
        }
        $e539f33816e64990$var$JSCompiler_inline_result$jscomp$283 = $e539f33816e64990$var$isSupported$jscomp$inline_418;
    } else $e539f33816e64990$var$JSCompiler_inline_result$jscomp$283 = !1;
    $e539f33816e64990$var$isInputEventSupported = $e539f33816e64990$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $e539f33816e64990$var$stopWatchingForValueChange() {
    $e539f33816e64990$var$activeElement$1 && ($e539f33816e64990$var$activeElement$1.detachEvent("onpropertychange", $e539f33816e64990$var$handlePropertyChange), $e539f33816e64990$var$activeElementInst$1 = $e539f33816e64990$var$activeElement$1 = null);
}
function $e539f33816e64990$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $e539f33816e64990$var$getInstIfValueChanged($e539f33816e64990$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $e539f33816e64990$var$createAndAccumulateChangeEvent(dispatchQueue, $e539f33816e64990$var$activeElementInst$1, nativeEvent, $e539f33816e64990$var$getEventTarget(nativeEvent));
        $e539f33816e64990$var$batchedUpdates$1($e539f33816e64990$var$runEventInBatch, dispatchQueue);
    }
}
function $e539f33816e64990$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($e539f33816e64990$var$stopWatchingForValueChange(), $e539f33816e64990$var$activeElement$1 = target, $e539f33816e64990$var$activeElementInst$1 = targetInst, $e539f33816e64990$var$activeElement$1.attachEvent("onpropertychange", $e539f33816e64990$var$handlePropertyChange)) : "focusout" === domEventName && $e539f33816e64990$var$stopWatchingForValueChange();
}
function $e539f33816e64990$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $e539f33816e64990$var$getInstIfValueChanged($e539f33816e64990$var$activeElementInst$1);
}
function $e539f33816e64990$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $e539f33816e64990$var$getInstIfValueChanged(targetInst);
}
function $e539f33816e64990$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $e539f33816e64990$var$getInstIfValueChanged(targetInst);
}
function $e539f33816e64990$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $e539f33816e64990$var$objectIs = "function" === typeof Object.is ? Object.is : $e539f33816e64990$var$is;
function $e539f33816e64990$var$shallowEqual(objA, objB) {
    if ($e539f33816e64990$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$e539f33816e64990$var$hasOwnProperty.call(objB, currentKey) || !$e539f33816e64990$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $e539f33816e64990$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $e539f33816e64990$var$getNodeForCharacterOffset(root, offset) {
    var node = $e539f33816e64990$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $e539f33816e64990$var$getLeafNode(node);
    }
}
function $e539f33816e64990$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $e539f33816e64990$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $e539f33816e64990$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $e539f33816e64990$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $e539f33816e64990$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $e539f33816e64990$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $e539f33816e64990$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $e539f33816e64990$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $e539f33816e64990$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $e539f33816e64990$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $e539f33816e64990$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $e539f33816e64990$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $e539f33816e64990$var$skipSelectionChangeEvent = $e539f33816e64990$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $e539f33816e64990$var$activeElement = null, $e539f33816e64990$var$activeElementInst = null, $e539f33816e64990$var$lastSelection = null, $e539f33816e64990$var$mouseDown = !1;
function $e539f33816e64990$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $e539f33816e64990$var$mouseDown || null == $e539f33816e64990$var$activeElement || $e539f33816e64990$var$activeElement !== $e539f33816e64990$var$getActiveElement(doc) || (doc = $e539f33816e64990$var$activeElement, "selectionStart" in doc && $e539f33816e64990$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $e539f33816e64990$var$lastSelection && $e539f33816e64990$var$shallowEqual($e539f33816e64990$var$lastSelection, doc) || ($e539f33816e64990$var$lastSelection = doc, doc = $e539f33816e64990$var$accumulateTwoPhaseListeners($e539f33816e64990$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $e539f33816e64990$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $e539f33816e64990$var$activeElement)));
}
function $e539f33816e64990$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $e539f33816e64990$var$vendorPrefixes = {
    animationend: $e539f33816e64990$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $e539f33816e64990$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $e539f33816e64990$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $e539f33816e64990$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $e539f33816e64990$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $e539f33816e64990$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $e539f33816e64990$var$makePrefixMap("Transition", "TransitionEnd")
}, $e539f33816e64990$var$prefixedEventNames = {}, $e539f33816e64990$var$style = {};
$e539f33816e64990$var$canUseDOM && ($e539f33816e64990$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $e539f33816e64990$var$vendorPrefixes.animationend.animation, delete $e539f33816e64990$var$vendorPrefixes.animationiteration.animation, delete $e539f33816e64990$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $e539f33816e64990$var$vendorPrefixes.transitionend.transition);
function $e539f33816e64990$var$getVendorPrefixedEventName(eventName) {
    if ($e539f33816e64990$var$prefixedEventNames[eventName]) return $e539f33816e64990$var$prefixedEventNames[eventName];
    if (!$e539f33816e64990$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $e539f33816e64990$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $e539f33816e64990$var$style) return $e539f33816e64990$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $e539f33816e64990$var$ANIMATION_END = $e539f33816e64990$var$getVendorPrefixedEventName("animationend"), $e539f33816e64990$var$ANIMATION_ITERATION = $e539f33816e64990$var$getVendorPrefixedEventName("animationiteration"), $e539f33816e64990$var$ANIMATION_START = $e539f33816e64990$var$getVendorPrefixedEventName("animationstart"), $e539f33816e64990$var$TRANSITION_RUN = $e539f33816e64990$var$getVendorPrefixedEventName("transitionrun"), $e539f33816e64990$var$TRANSITION_START = $e539f33816e64990$var$getVendorPrefixedEventName("transitionstart"), $e539f33816e64990$var$TRANSITION_CANCEL = $e539f33816e64990$var$getVendorPrefixedEventName("transitioncancel"), $e539f33816e64990$var$TRANSITION_END = $e539f33816e64990$var$getVendorPrefixedEventName("transitionend"), $e539f33816e64990$var$topLevelEventsToReactNames = new Map(), $e539f33816e64990$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $e539f33816e64990$var$registerSimpleEvent(domEventName, reactName) {
    $e539f33816e64990$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $e539f33816e64990$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $e539f33816e64990$var$concurrentQueues = [], $e539f33816e64990$var$concurrentQueuesIndex = 0, $e539f33816e64990$var$concurrentlyUpdatedLanes = 0;
function $e539f33816e64990$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $e539f33816e64990$var$concurrentQueuesIndex, i = $e539f33816e64990$var$concurrentlyUpdatedLanes = $e539f33816e64990$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $e539f33816e64990$var$concurrentQueues[i];
        $e539f33816e64990$var$concurrentQueues[i++] = null;
        var queue = $e539f33816e64990$var$concurrentQueues[i];
        $e539f33816e64990$var$concurrentQueues[i++] = null;
        var update = $e539f33816e64990$var$concurrentQueues[i];
        $e539f33816e64990$var$concurrentQueues[i++] = null;
        var lane = $e539f33816e64990$var$concurrentQueues[i];
        $e539f33816e64990$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $e539f33816e64990$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $e539f33816e64990$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $e539f33816e64990$var$concurrentQueues[$e539f33816e64990$var$concurrentQueuesIndex++] = fiber;
    $e539f33816e64990$var$concurrentQueues[$e539f33816e64990$var$concurrentQueuesIndex++] = queue;
    $e539f33816e64990$var$concurrentQueues[$e539f33816e64990$var$concurrentQueuesIndex++] = update;
    $e539f33816e64990$var$concurrentQueues[$e539f33816e64990$var$concurrentQueuesIndex++] = lane;
    $e539f33816e64990$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $e539f33816e64990$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $e539f33816e64990$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $e539f33816e64990$var$getRootForUpdatedFiber(fiber);
}
function $e539f33816e64990$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $e539f33816e64990$var$enqueueUpdate$1(fiber, null, null, lane);
    return $e539f33816e64990$var$getRootForUpdatedFiber(fiber);
}
function $e539f33816e64990$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $e539f33816e64990$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $e539f33816e64990$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $e539f33816e64990$var$nestedUpdateCount) throw $e539f33816e64990$var$nestedUpdateCount = 0, $e539f33816e64990$var$rootWithNestedUpdates = null, Error($e539f33816e64990$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $e539f33816e64990$var$emptyContextObject = {}, $e539f33816e64990$var$CapturedStacks = new WeakMap();
function $e539f33816e64990$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $e539f33816e64990$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $e539f33816e64990$var$getStackByFiberInDevAndProd(source)
        };
        $e539f33816e64990$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $e539f33816e64990$var$getStackByFiberInDevAndProd(source)
    };
}
var $e539f33816e64990$var$forkStack = [], $e539f33816e64990$var$forkStackIndex = 0, $e539f33816e64990$var$treeForkProvider = null, $e539f33816e64990$var$treeForkCount = 0, $e539f33816e64990$var$idStack = [], $e539f33816e64990$var$idStackIndex = 0, $e539f33816e64990$var$treeContextProvider = null, $e539f33816e64990$var$treeContextId = 1, $e539f33816e64990$var$treeContextOverflow = "";
function $e539f33816e64990$var$pushTreeFork(workInProgress, totalChildren) {
    $e539f33816e64990$var$forkStack[$e539f33816e64990$var$forkStackIndex++] = $e539f33816e64990$var$treeForkCount;
    $e539f33816e64990$var$forkStack[$e539f33816e64990$var$forkStackIndex++] = $e539f33816e64990$var$treeForkProvider;
    $e539f33816e64990$var$treeForkProvider = workInProgress;
    $e539f33816e64990$var$treeForkCount = totalChildren;
}
function $e539f33816e64990$var$pushTreeId(workInProgress, totalChildren, index) {
    $e539f33816e64990$var$idStack[$e539f33816e64990$var$idStackIndex++] = $e539f33816e64990$var$treeContextId;
    $e539f33816e64990$var$idStack[$e539f33816e64990$var$idStackIndex++] = $e539f33816e64990$var$treeContextOverflow;
    $e539f33816e64990$var$idStack[$e539f33816e64990$var$idStackIndex++] = $e539f33816e64990$var$treeContextProvider;
    $e539f33816e64990$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $e539f33816e64990$var$treeContextId;
    workInProgress = $e539f33816e64990$var$treeContextOverflow;
    var baseLength = 32 - $e539f33816e64990$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $e539f33816e64990$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $e539f33816e64990$var$treeContextId = 1 << 32 - $e539f33816e64990$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $e539f33816e64990$var$treeContextOverflow = length + workInProgress;
    } else $e539f33816e64990$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $e539f33816e64990$var$treeContextOverflow = workInProgress;
}
function $e539f33816e64990$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($e539f33816e64990$var$pushTreeFork(workInProgress, 1), $e539f33816e64990$var$pushTreeId(workInProgress, 1, 0));
}
function $e539f33816e64990$var$popTreeContext(workInProgress) {
    for(; workInProgress === $e539f33816e64990$var$treeForkProvider;)$e539f33816e64990$var$treeForkProvider = $e539f33816e64990$var$forkStack[--$e539f33816e64990$var$forkStackIndex], $e539f33816e64990$var$forkStack[$e539f33816e64990$var$forkStackIndex] = null, $e539f33816e64990$var$treeForkCount = $e539f33816e64990$var$forkStack[--$e539f33816e64990$var$forkStackIndex], $e539f33816e64990$var$forkStack[$e539f33816e64990$var$forkStackIndex] = null;
    for(; workInProgress === $e539f33816e64990$var$treeContextProvider;)$e539f33816e64990$var$treeContextProvider = $e539f33816e64990$var$idStack[--$e539f33816e64990$var$idStackIndex], $e539f33816e64990$var$idStack[$e539f33816e64990$var$idStackIndex] = null, $e539f33816e64990$var$treeContextOverflow = $e539f33816e64990$var$idStack[--$e539f33816e64990$var$idStackIndex], $e539f33816e64990$var$idStack[$e539f33816e64990$var$idStackIndex] = null, $e539f33816e64990$var$treeContextId = $e539f33816e64990$var$idStack[--$e539f33816e64990$var$idStackIndex], $e539f33816e64990$var$idStack[$e539f33816e64990$var$idStackIndex] = null;
}
var $e539f33816e64990$var$hydrationParentFiber = null, $e539f33816e64990$var$nextHydratableInstance = null, $e539f33816e64990$var$isHydrating = !1, $e539f33816e64990$var$hydrationErrors = null, $e539f33816e64990$var$rootOrSingletonContext = !1, $e539f33816e64990$var$HydrationMismatchException = Error($e539f33816e64990$var$formatProdErrorMessage(519));
function $e539f33816e64990$var$throwOnHydrationMismatch(fiber) {
    var error = Error($e539f33816e64990$var$formatProdErrorMessage(418, ""));
    $e539f33816e64990$var$queueHydrationError($e539f33816e64990$var$createCapturedValueAtFiber(error, fiber));
    throw $e539f33816e64990$var$HydrationMismatchException;
}
function $e539f33816e64990$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$e539f33816e64990$var$internalInstanceKey] = fiber;
    instance[$e539f33816e64990$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $e539f33816e64990$var$listenToNonDelegatedEvent("cancel", instance);
            $e539f33816e64990$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $e539f33816e64990$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $e539f33816e64990$var$mediaEventTypes.length; type++)$e539f33816e64990$var$listenToNonDelegatedEvent($e539f33816e64990$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $e539f33816e64990$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $e539f33816e64990$var$listenToNonDelegatedEvent("error", instance);
            $e539f33816e64990$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $e539f33816e64990$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $e539f33816e64990$var$listenToNonDelegatedEvent("invalid", instance);
            $e539f33816e64990$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $e539f33816e64990$var$track(instance);
            break;
        case "select":
            $e539f33816e64990$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $e539f33816e64990$var$listenToNonDelegatedEvent("invalid", instance), $e539f33816e64990$var$initTextarea(instance, props.value, props.defaultValue, props.children), $e539f33816e64990$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $e539f33816e64990$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($e539f33816e64990$var$listenToNonDelegatedEvent("beforetoggle", instance), $e539f33816e64990$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $e539f33816e64990$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $e539f33816e64990$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $e539f33816e64990$var$noop$1), instance = !0) : instance = !1;
    instance || $e539f33816e64990$var$throwOnHydrationMismatch(fiber);
}
function $e539f33816e64990$var$popToNextHostParent(fiber) {
    for($e539f33816e64990$var$hydrationParentFiber = fiber.return; $e539f33816e64990$var$hydrationParentFiber;)switch($e539f33816e64990$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $e539f33816e64990$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $e539f33816e64990$var$rootOrSingletonContext = !1;
            return;
        default:
            $e539f33816e64990$var$hydrationParentFiber = $e539f33816e64990$var$hydrationParentFiber.return;
    }
}
function $e539f33816e64990$var$popHydrationState(fiber) {
    if (fiber !== $e539f33816e64990$var$hydrationParentFiber) return !1;
    if (!$e539f33816e64990$var$isHydrating) return $e539f33816e64990$var$popToNextHostParent(fiber), $e539f33816e64990$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $e539f33816e64990$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $e539f33816e64990$var$nextHydratableInstance && $e539f33816e64990$var$throwOnHydrationMismatch(fiber);
    $e539f33816e64990$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($e539f33816e64990$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $e539f33816e64990$var$nextHydratableInstance = $e539f33816e64990$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $e539f33816e64990$var$nextHydratableInstance = null;
        }
    } else $e539f33816e64990$var$nextHydratableInstance = $e539f33816e64990$var$hydrationParentFiber ? $e539f33816e64990$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $e539f33816e64990$var$resetHydrationState() {
    $e539f33816e64990$var$nextHydratableInstance = $e539f33816e64990$var$hydrationParentFiber = null;
    $e539f33816e64990$var$isHydrating = !1;
}
function $e539f33816e64990$var$queueHydrationError(error) {
    null === $e539f33816e64990$var$hydrationErrors ? $e539f33816e64990$var$hydrationErrors = [
        error
    ] : $e539f33816e64990$var$hydrationErrors.push(error);
}
var $e539f33816e64990$var$SuspenseException = Error($e539f33816e64990$var$formatProdErrorMessage(460)), $e539f33816e64990$var$SuspenseyCommitException = Error($e539f33816e64990$var$formatProdErrorMessage(474)), $e539f33816e64990$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $e539f33816e64990$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $e539f33816e64990$var$noop$3() {}
function $e539f33816e64990$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($e539f33816e64990$var$noop$3, $e539f33816e64990$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $e539f33816e64990$var$SuspenseException) throw Error($e539f33816e64990$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($e539f33816e64990$var$noop$3, $e539f33816e64990$var$noop$3);
            else {
                thenableState = $e539f33816e64990$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($e539f33816e64990$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $e539f33816e64990$var$SuspenseException) throw Error($e539f33816e64990$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $e539f33816e64990$var$suspendedThenable = thenable;
            throw $e539f33816e64990$var$SuspenseException;
    }
}
var $e539f33816e64990$var$suspendedThenable = null;
function $e539f33816e64990$var$getSuspendedThenable() {
    if (null === $e539f33816e64990$var$suspendedThenable) throw Error($e539f33816e64990$var$formatProdErrorMessage(459));
    var thenable = $e539f33816e64990$var$suspendedThenable;
    $e539f33816e64990$var$suspendedThenable = null;
    return thenable;
}
var $e539f33816e64990$var$thenableState$1 = null, $e539f33816e64990$var$thenableIndexCounter$1 = 0;
function $e539f33816e64990$var$unwrapThenable(thenable) {
    var index = $e539f33816e64990$var$thenableIndexCounter$1;
    $e539f33816e64990$var$thenableIndexCounter$1 += 1;
    null === $e539f33816e64990$var$thenableState$1 && ($e539f33816e64990$var$thenableState$1 = []);
    return $e539f33816e64990$var$trackUsedThenable($e539f33816e64990$var$thenableState$1, thenable, index);
}
function $e539f33816e64990$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $e539f33816e64990$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $e539f33816e64990$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($e539f33816e64990$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($e539f33816e64990$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $e539f33816e64990$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $e539f33816e64990$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $e539f33816e64990$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $e539f33816e64990$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $e539f33816e64990$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $e539f33816e64990$var$REACT_LAZY_TYPE && $e539f33816e64990$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $e539f33816e64990$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $e539f33816e64990$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $e539f33816e64990$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $e539f33816e64990$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $e539f33816e64990$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $e539f33816e64990$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e539f33816e64990$var$REACT_ELEMENT_TYPE:
                    return lanes = $e539f33816e64990$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $e539f33816e64990$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $e539f33816e64990$var$REACT_PORTAL_TYPE:
                    return newChild = $e539f33816e64990$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $e539f33816e64990$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($e539f33816e64990$var$isArrayImpl(newChild) || $e539f33816e64990$var$getIteratorFn(newChild)) return newChild = $e539f33816e64990$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $e539f33816e64990$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e539f33816e64990$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $e539f33816e64990$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e539f33816e64990$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e539f33816e64990$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $e539f33816e64990$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $e539f33816e64990$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($e539f33816e64990$var$isArrayImpl(newChild) || $e539f33816e64990$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $e539f33816e64990$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e539f33816e64990$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $e539f33816e64990$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e539f33816e64990$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e539f33816e64990$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $e539f33816e64990$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $e539f33816e64990$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($e539f33816e64990$var$isArrayImpl(newChild) || $e539f33816e64990$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $e539f33816e64990$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e539f33816e64990$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $e539f33816e64990$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e539f33816e64990$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $e539f33816e64990$var$isHydrating && $e539f33816e64990$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $e539f33816e64990$var$isHydrating && $e539f33816e64990$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $e539f33816e64990$var$isHydrating && $e539f33816e64990$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($e539f33816e64990$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $e539f33816e64990$var$isHydrating && $e539f33816e64990$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $e539f33816e64990$var$isHydrating && $e539f33816e64990$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $e539f33816e64990$var$isHydrating && $e539f33816e64990$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $e539f33816e64990$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e539f33816e64990$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $e539f33816e64990$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $e539f33816e64990$var$REACT_LAZY_TYPE && $e539f33816e64990$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $e539f33816e64990$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $e539f33816e64990$var$REACT_FRAGMENT_TYPE ? (lanes = $e539f33816e64990$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $e539f33816e64990$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $e539f33816e64990$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $e539f33816e64990$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $e539f33816e64990$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $e539f33816e64990$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($e539f33816e64990$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($e539f33816e64990$var$getIteratorFn(newChild)) {
                key = $e539f33816e64990$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($e539f33816e64990$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $e539f33816e64990$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e539f33816e64990$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $e539f33816e64990$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e539f33816e64990$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $e539f33816e64990$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $e539f33816e64990$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $e539f33816e64990$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $e539f33816e64990$var$SuspenseException) throw x;
            var fiber = $e539f33816e64990$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $e539f33816e64990$var$reconcileChildFibers = $e539f33816e64990$var$createChildReconciler(!0), $e539f33816e64990$var$mountChildFibers = $e539f33816e64990$var$createChildReconciler(!1), $e539f33816e64990$var$currentTreeHiddenStackCursor = $e539f33816e64990$var$createCursor(null), $e539f33816e64990$var$prevEntangledRenderLanesCursor = $e539f33816e64990$var$createCursor(0);
function $e539f33816e64990$var$pushHiddenContext(fiber, context) {
    fiber = $e539f33816e64990$var$entangledRenderLanes;
    $e539f33816e64990$var$push($e539f33816e64990$var$prevEntangledRenderLanesCursor, fiber);
    $e539f33816e64990$var$push($e539f33816e64990$var$currentTreeHiddenStackCursor, context);
    $e539f33816e64990$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $e539f33816e64990$var$reuseHiddenContextOnStack() {
    $e539f33816e64990$var$push($e539f33816e64990$var$prevEntangledRenderLanesCursor, $e539f33816e64990$var$entangledRenderLanes);
    $e539f33816e64990$var$push($e539f33816e64990$var$currentTreeHiddenStackCursor, $e539f33816e64990$var$currentTreeHiddenStackCursor.current);
}
function $e539f33816e64990$var$popHiddenContext() {
    $e539f33816e64990$var$entangledRenderLanes = $e539f33816e64990$var$prevEntangledRenderLanesCursor.current;
    $e539f33816e64990$var$pop($e539f33816e64990$var$currentTreeHiddenStackCursor);
    $e539f33816e64990$var$pop($e539f33816e64990$var$prevEntangledRenderLanesCursor);
}
var $e539f33816e64990$var$suspenseHandlerStackCursor = $e539f33816e64990$var$createCursor(null), $e539f33816e64990$var$shellBoundary = null;
function $e539f33816e64990$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $e539f33816e64990$var$push($e539f33816e64990$var$suspenseStackCursor, $e539f33816e64990$var$suspenseStackCursor.current & 1);
    $e539f33816e64990$var$push($e539f33816e64990$var$suspenseHandlerStackCursor, handler);
    null === $e539f33816e64990$var$shellBoundary && (null === current || null !== $e539f33816e64990$var$currentTreeHiddenStackCursor.current ? $e539f33816e64990$var$shellBoundary = handler : null !== current.memoizedState && ($e539f33816e64990$var$shellBoundary = handler));
}
function $e539f33816e64990$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($e539f33816e64990$var$push($e539f33816e64990$var$suspenseStackCursor, $e539f33816e64990$var$suspenseStackCursor.current), $e539f33816e64990$var$push($e539f33816e64990$var$suspenseHandlerStackCursor, fiber), null === $e539f33816e64990$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($e539f33816e64990$var$shellBoundary = fiber);
        }
    } else $e539f33816e64990$var$reuseSuspenseHandlerOnStack(fiber);
}
function $e539f33816e64990$var$reuseSuspenseHandlerOnStack() {
    $e539f33816e64990$var$push($e539f33816e64990$var$suspenseStackCursor, $e539f33816e64990$var$suspenseStackCursor.current);
    $e539f33816e64990$var$push($e539f33816e64990$var$suspenseHandlerStackCursor, $e539f33816e64990$var$suspenseHandlerStackCursor.current);
}
function $e539f33816e64990$var$popSuspenseHandler(fiber) {
    $e539f33816e64990$var$pop($e539f33816e64990$var$suspenseHandlerStackCursor);
    $e539f33816e64990$var$shellBoundary === fiber && ($e539f33816e64990$var$shellBoundary = null);
    $e539f33816e64990$var$pop($e539f33816e64990$var$suspenseStackCursor);
}
var $e539f33816e64990$var$suspenseStackCursor = $e539f33816e64990$var$createCursor(0);
function $e539f33816e64990$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $e539f33816e64990$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $e539f33816e64990$var$scheduleCallback$2 = $VGsl0.unstable_scheduleCallback, $e539f33816e64990$var$NormalPriority = $VGsl0.unstable_NormalPriority, $e539f33816e64990$var$CacheContext = {
    $$typeof: $e539f33816e64990$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $e539f33816e64990$var$createCache() {
    return {
        controller: new $e539f33816e64990$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $e539f33816e64990$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $e539f33816e64990$var$scheduleCallback$2($e539f33816e64990$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $e539f33816e64990$var$currentEntangledListeners = null, $e539f33816e64990$var$currentEntangledPendingCount = 0, $e539f33816e64990$var$currentEntangledLane = 0, $e539f33816e64990$var$currentEntangledActionThenable = null;
function $e539f33816e64990$var$entangleAsyncAction(transition, thenable) {
    if (null === $e539f33816e64990$var$currentEntangledListeners) {
        var entangledListeners = $e539f33816e64990$var$currentEntangledListeners = [];
        $e539f33816e64990$var$currentEntangledPendingCount = 0;
        $e539f33816e64990$var$currentEntangledLane = $e539f33816e64990$var$requestTransitionLane();
        $e539f33816e64990$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $e539f33816e64990$var$currentEntangledPendingCount++;
    thenable.then($e539f33816e64990$var$pingEngtangledActionScope, $e539f33816e64990$var$pingEngtangledActionScope);
    return thenable;
}
function $e539f33816e64990$var$pingEngtangledActionScope() {
    if (0 === --$e539f33816e64990$var$currentEntangledPendingCount && null !== $e539f33816e64990$var$currentEntangledListeners) {
        null !== $e539f33816e64990$var$currentEntangledActionThenable && ($e539f33816e64990$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $e539f33816e64990$var$currentEntangledListeners;
        $e539f33816e64990$var$currentEntangledListeners = null;
        $e539f33816e64990$var$currentEntangledLane = 0;
        $e539f33816e64990$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $e539f33816e64990$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $e539f33816e64990$var$prevOnStartTransitionFinish = $e539f33816e64990$var$ReactSharedInternals.S;
$e539f33816e64990$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $e539f33816e64990$var$entangleAsyncAction(transition, returnValue);
    null !== $e539f33816e64990$var$prevOnStartTransitionFinish && $e539f33816e64990$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $e539f33816e64990$var$resumedCache = $e539f33816e64990$var$createCursor(null);
function $e539f33816e64990$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $e539f33816e64990$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $e539f33816e64990$var$workInProgressRoot.pooledCache;
}
function $e539f33816e64990$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $e539f33816e64990$var$push($e539f33816e64990$var$resumedCache, $e539f33816e64990$var$resumedCache.current) : $e539f33816e64990$var$push($e539f33816e64990$var$resumedCache, prevCachePool.pool);
}
function $e539f33816e64990$var$getSuspendedCache() {
    var cacheFromPool = $e539f33816e64990$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $e539f33816e64990$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $e539f33816e64990$var$renderLanes = 0, $e539f33816e64990$var$currentlyRenderingFiber$1 = null, $e539f33816e64990$var$currentHook = null, $e539f33816e64990$var$workInProgressHook = null, $e539f33816e64990$var$didScheduleRenderPhaseUpdate = !1, $e539f33816e64990$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $e539f33816e64990$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $e539f33816e64990$var$localIdCounter = 0, $e539f33816e64990$var$thenableIndexCounter = 0, $e539f33816e64990$var$thenableState = null, $e539f33816e64990$var$globalClientIdCounter = 0;
function $e539f33816e64990$var$throwInvalidHookError() {
    throw Error($e539f33816e64990$var$formatProdErrorMessage(321));
}
function $e539f33816e64990$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$e539f33816e64990$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $e539f33816e64990$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $e539f33816e64990$var$renderLanes = nextRenderLanes;
    $e539f33816e64990$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $e539f33816e64990$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $e539f33816e64990$var$HooksDispatcherOnMount : $e539f33816e64990$var$HooksDispatcherOnUpdate;
    $e539f33816e64990$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $e539f33816e64990$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $e539f33816e64990$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $e539f33816e64990$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $e539f33816e64990$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $e539f33816e64990$var$finishRenderingHooks(current) {
    $e539f33816e64990$var$ReactSharedInternals.H = $e539f33816e64990$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $e539f33816e64990$var$currentHook && null !== $e539f33816e64990$var$currentHook.next;
    $e539f33816e64990$var$renderLanes = 0;
    $e539f33816e64990$var$workInProgressHook = $e539f33816e64990$var$currentHook = $e539f33816e64990$var$currentlyRenderingFiber$1 = null;
    $e539f33816e64990$var$didScheduleRenderPhaseUpdate = !1;
    $e539f33816e64990$var$thenableIndexCounter = 0;
    $e539f33816e64990$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($e539f33816e64990$var$formatProdErrorMessage(300));
    null === current || $e539f33816e64990$var$didReceiveUpdate || (current = current.dependencies, null !== current && $e539f33816e64990$var$checkIfContextChanged(current) && ($e539f33816e64990$var$didReceiveUpdate = !0));
}
function $e539f33816e64990$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $e539f33816e64990$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $e539f33816e64990$var$didScheduleRenderPhaseUpdateDuringThisPass && ($e539f33816e64990$var$thenableState = null);
        $e539f33816e64990$var$thenableIndexCounter = 0;
        $e539f33816e64990$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($e539f33816e64990$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $e539f33816e64990$var$workInProgressHook = $e539f33816e64990$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $e539f33816e64990$var$ReactSharedInternals.H = $e539f33816e64990$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($e539f33816e64990$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $e539f33816e64990$var$TransitionAwareHostComponent() {
    var dispatcher = $e539f33816e64990$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $e539f33816e64990$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $e539f33816e64990$var$currentHook ? $e539f33816e64990$var$currentHook.memoizedState : null) !== dispatcher && ($e539f33816e64990$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $e539f33816e64990$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $e539f33816e64990$var$localIdCounter;
    $e539f33816e64990$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $e539f33816e64990$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $e539f33816e64990$var$resetHooksOnUnwind(workInProgress) {
    if ($e539f33816e64990$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $e539f33816e64990$var$didScheduleRenderPhaseUpdate = !1;
    }
    $e539f33816e64990$var$renderLanes = 0;
    $e539f33816e64990$var$workInProgressHook = $e539f33816e64990$var$currentHook = $e539f33816e64990$var$currentlyRenderingFiber$1 = null;
    $e539f33816e64990$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $e539f33816e64990$var$thenableIndexCounter = $e539f33816e64990$var$localIdCounter = 0;
    $e539f33816e64990$var$thenableState = null;
}
function $e539f33816e64990$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e539f33816e64990$var$workInProgressHook ? $e539f33816e64990$var$currentlyRenderingFiber$1.memoizedState = $e539f33816e64990$var$workInProgressHook = hook : $e539f33816e64990$var$workInProgressHook = $e539f33816e64990$var$workInProgressHook.next = hook;
    return $e539f33816e64990$var$workInProgressHook;
}
function $e539f33816e64990$var$updateWorkInProgressHook() {
    if (null === $e539f33816e64990$var$currentHook) {
        var nextCurrentHook = $e539f33816e64990$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $e539f33816e64990$var$currentHook.next;
    var nextWorkInProgressHook = null === $e539f33816e64990$var$workInProgressHook ? $e539f33816e64990$var$currentlyRenderingFiber$1.memoizedState : $e539f33816e64990$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $e539f33816e64990$var$workInProgressHook = nextWorkInProgressHook, $e539f33816e64990$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $e539f33816e64990$var$currentlyRenderingFiber$1.alternate) throw Error($e539f33816e64990$var$formatProdErrorMessage(467));
            throw Error($e539f33816e64990$var$formatProdErrorMessage(310));
        }
        $e539f33816e64990$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $e539f33816e64990$var$currentHook.memoizedState,
            baseState: $e539f33816e64990$var$currentHook.baseState,
            baseQueue: $e539f33816e64990$var$currentHook.baseQueue,
            queue: $e539f33816e64990$var$currentHook.queue,
            next: null
        };
        null === $e539f33816e64990$var$workInProgressHook ? $e539f33816e64990$var$currentlyRenderingFiber$1.memoizedState = $e539f33816e64990$var$workInProgressHook = nextCurrentHook : $e539f33816e64990$var$workInProgressHook = $e539f33816e64990$var$workInProgressHook.next = nextCurrentHook;
    }
    return $e539f33816e64990$var$workInProgressHook;
}
var $e539f33816e64990$var$createFunctionComponentUpdateQueue;
$e539f33816e64990$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $e539f33816e64990$var$useThenable(thenable) {
    var index = $e539f33816e64990$var$thenableIndexCounter;
    $e539f33816e64990$var$thenableIndexCounter += 1;
    null === $e539f33816e64990$var$thenableState && ($e539f33816e64990$var$thenableState = []);
    thenable = $e539f33816e64990$var$trackUsedThenable($e539f33816e64990$var$thenableState, thenable, index);
    index = $e539f33816e64990$var$currentlyRenderingFiber$1;
    null === (null === $e539f33816e64990$var$workInProgressHook ? index.memoizedState : $e539f33816e64990$var$workInProgressHook.next) && (index = index.alternate, $e539f33816e64990$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $e539f33816e64990$var$HooksDispatcherOnMount : $e539f33816e64990$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $e539f33816e64990$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $e539f33816e64990$var$useThenable(usable);
        if (usable.$$typeof === $e539f33816e64990$var$REACT_CONTEXT_TYPE) return $e539f33816e64990$var$readContext(usable);
    }
    throw Error($e539f33816e64990$var$formatProdErrorMessage(438, String(usable)));
}
function $e539f33816e64990$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $e539f33816e64990$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $e539f33816e64990$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $e539f33816e64990$var$createFunctionComponentUpdateQueue(), $e539f33816e64990$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $e539f33816e64990$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $e539f33816e64990$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $e539f33816e64990$var$updateReducer(reducer) {
    var hook = $e539f33816e64990$var$updateWorkInProgressHook();
    return $e539f33816e64990$var$updateReducerImpl(hook, $e539f33816e64990$var$currentHook, reducer);
}
function $e539f33816e64990$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($e539f33816e64990$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($e539f33816e64990$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($e539f33816e64990$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $e539f33816e64990$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($e539f33816e64990$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $e539f33816e64990$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $e539f33816e64990$var$currentlyRenderingFiber$1.lanes |= revertLane, $e539f33816e64990$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $e539f33816e64990$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $e539f33816e64990$var$currentlyRenderingFiber$1.lanes |= updateLane, $e539f33816e64990$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$e539f33816e64990$var$objectIs(pendingQueue, hook.memoizedState) && ($e539f33816e64990$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $e539f33816e64990$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $e539f33816e64990$var$rerenderReducer(reducer) {
    var hook = $e539f33816e64990$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($e539f33816e64990$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $e539f33816e64990$var$objectIs(newState, hook.memoizedState) || ($e539f33816e64990$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $e539f33816e64990$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $e539f33816e64990$var$currentlyRenderingFiber$1, hook = $e539f33816e64990$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $e539f33816e64990$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($e539f33816e64990$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$e539f33816e64990$var$objectIs(($e539f33816e64990$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $e539f33816e64990$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $e539f33816e64990$var$updateEffect($e539f33816e64990$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $e539f33816e64990$var$workInProgressHook && $e539f33816e64990$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $e539f33816e64990$var$pushEffect(9, $e539f33816e64990$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $e539f33816e64990$var$workInProgressRoot) throw Error($e539f33816e64990$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($e539f33816e64990$var$renderLanes & 60) || $e539f33816e64990$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $e539f33816e64990$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $e539f33816e64990$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $e539f33816e64990$var$createFunctionComponentUpdateQueue(), $e539f33816e64990$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $e539f33816e64990$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $e539f33816e64990$var$checkIfSnapshotChanged(inst) && $e539f33816e64990$var$forceStoreRerender(fiber);
}
function $e539f33816e64990$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $e539f33816e64990$var$checkIfSnapshotChanged(inst) && $e539f33816e64990$var$forceStoreRerender(fiber);
    });
}
function $e539f33816e64990$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$e539f33816e64990$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $e539f33816e64990$var$forceStoreRerender(fiber) {
    var root = $e539f33816e64990$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $e539f33816e64990$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $e539f33816e64990$var$mountStateImpl(initialState) {
    var hook = $e539f33816e64990$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($e539f33816e64990$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $e539f33816e64990$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $e539f33816e64990$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e539f33816e64990$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $e539f33816e64990$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $e539f33816e64990$var$updateReducerImpl(hook, $e539f33816e64990$var$currentHook, "function" === typeof reducer ? reducer : $e539f33816e64990$var$basicStateReducer);
}
function $e539f33816e64990$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($e539f33816e64990$var$isRenderPhaseUpdate(fiber)) throw Error($e539f33816e64990$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $e539f33816e64990$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $e539f33816e64990$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $e539f33816e64990$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $e539f33816e64990$var$ReactSharedInternals.T, currentTransition = {};
        $e539f33816e64990$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $e539f33816e64990$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $e539f33816e64990$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $e539f33816e64990$var$onActionError(actionQueue, node, error);
        } finally{
            $e539f33816e64990$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $e539f33816e64990$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $e539f33816e64990$var$onActionError(actionQueue, node, error$60);
    }
}
function $e539f33816e64990$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $e539f33816e64990$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $e539f33816e64990$var$onActionError(actionQueue, node, error);
    }) : $e539f33816e64990$var$onActionSuccess(actionQueue, node, returnValue);
}
function $e539f33816e64990$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $e539f33816e64990$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $e539f33816e64990$var$runActionStateAction(actionQueue, nextState)));
}
function $e539f33816e64990$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $e539f33816e64990$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $e539f33816e64990$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $e539f33816e64990$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $e539f33816e64990$var$mountActionState(action, initialStateProp) {
    if ($e539f33816e64990$var$isHydrating) {
        var ssrFormState = $e539f33816e64990$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $e539f33816e64990$var$currentlyRenderingFiber$1;
                if ($e539f33816e64990$var$isHydrating) {
                    if ($e539f33816e64990$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $e539f33816e64990$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $e539f33816e64990$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $e539f33816e64990$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $e539f33816e64990$var$nextHydratableInstance = $e539f33816e64990$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $e539f33816e64990$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $e539f33816e64990$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e539f33816e64990$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $e539f33816e64990$var$dispatchSetState.bind(null, $e539f33816e64990$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $e539f33816e64990$var$mountStateImpl(!1);
    inRootOrSingleton = $e539f33816e64990$var$dispatchOptimisticSetState.bind(null, $e539f33816e64990$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $e539f33816e64990$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $e539f33816e64990$var$dispatchActionState.bind(null, $e539f33816e64990$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $e539f33816e64990$var$updateActionState(action) {
    var stateHook = $e539f33816e64990$var$updateWorkInProgressHook();
    return $e539f33816e64990$var$updateActionStateImpl(stateHook, $e539f33816e64990$var$currentHook, action);
}
function $e539f33816e64990$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $e539f33816e64990$var$updateReducerImpl(stateHook, currentStateHook, $e539f33816e64990$var$actionStateReducer)[0];
    stateHook = $e539f33816e64990$var$updateReducer($e539f33816e64990$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $e539f33816e64990$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $e539f33816e64990$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($e539f33816e64990$var$currentlyRenderingFiber$1.flags |= 2048, $e539f33816e64990$var$pushEffect(9, $e539f33816e64990$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $e539f33816e64990$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $e539f33816e64990$var$rerenderActionState(action) {
    var stateHook = $e539f33816e64990$var$updateWorkInProgressHook(), currentStateHook = $e539f33816e64990$var$currentHook;
    if (null !== currentStateHook) return $e539f33816e64990$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $e539f33816e64990$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $e539f33816e64990$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $e539f33816e64990$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $e539f33816e64990$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $e539f33816e64990$var$createFunctionComponentUpdateQueue(), $e539f33816e64990$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $e539f33816e64990$var$updateRef() {
    return $e539f33816e64990$var$updateWorkInProgressHook().memoizedState;
}
function $e539f33816e64990$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $e539f33816e64990$var$mountWorkInProgressHook();
    $e539f33816e64990$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $e539f33816e64990$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $e539f33816e64990$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $e539f33816e64990$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $e539f33816e64990$var$currentHook && null !== deps && $e539f33816e64990$var$areHookInputsEqual(deps, $e539f33816e64990$var$currentHook.memoizedState.deps) ? hook.memoizedState = $e539f33816e64990$var$pushEffect(hookFlags, create, inst, deps) : ($e539f33816e64990$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $e539f33816e64990$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $e539f33816e64990$var$mountEffect(create, deps) {
    $e539f33816e64990$var$mountEffectImpl(8390656, 8, create, deps);
}
function $e539f33816e64990$var$updateEffect(create, deps) {
    $e539f33816e64990$var$updateEffectImpl(2048, 8, create, deps);
}
function $e539f33816e64990$var$updateInsertionEffect(create, deps) {
    return $e539f33816e64990$var$updateEffectImpl(4, 2, create, deps);
}
function $e539f33816e64990$var$updateLayoutEffect(create, deps) {
    return $e539f33816e64990$var$updateEffectImpl(4, 4, create, deps);
}
function $e539f33816e64990$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $e539f33816e64990$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $e539f33816e64990$var$updateEffectImpl(4, 4, $e539f33816e64990$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $e539f33816e64990$var$mountDebugValue() {}
function $e539f33816e64990$var$updateCallback(callback, deps) {
    var hook = $e539f33816e64990$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $e539f33816e64990$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $e539f33816e64990$var$updateMemo(nextCreate, deps) {
    var hook = $e539f33816e64990$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $e539f33816e64990$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($e539f33816e64990$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $e539f33816e64990$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $e539f33816e64990$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $e539f33816e64990$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($e539f33816e64990$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $e539f33816e64990$var$requestDeferredLane();
    $e539f33816e64990$var$currentlyRenderingFiber$1.lanes |= hook;
    $e539f33816e64990$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $e539f33816e64990$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($e539f33816e64990$var$objectIs(value, prevValue)) return value;
    if (null !== $e539f33816e64990$var$currentTreeHiddenStackCursor.current) return hook = $e539f33816e64990$var$mountDeferredValueImpl(hook, value, initialValue), $e539f33816e64990$var$objectIs(hook, prevValue) || ($e539f33816e64990$var$didReceiveUpdate = !0), hook;
    if (0 === ($e539f33816e64990$var$renderLanes & 42)) return $e539f33816e64990$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $e539f33816e64990$var$requestDeferredLane();
    $e539f33816e64990$var$currentlyRenderingFiber$1.lanes |= hook;
    $e539f33816e64990$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $e539f33816e64990$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $e539f33816e64990$var$ReactDOMSharedInternals.p;
    $e539f33816e64990$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $e539f33816e64990$var$ReactSharedInternals.T, currentTransition = {};
    $e539f33816e64990$var$ReactSharedInternals.T = currentTransition;
    $e539f33816e64990$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $e539f33816e64990$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $e539f33816e64990$var$chainThenableValue(returnValue, finishedState);
            $e539f33816e64990$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $e539f33816e64990$var$requestUpdateLane(fiber));
        } else $e539f33816e64990$var$dispatchSetStateInternal(fiber, queue, finishedState, $e539f33816e64990$var$requestUpdateLane(fiber));
    } catch (error) {
        $e539f33816e64990$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $e539f33816e64990$var$requestUpdateLane());
    } finally{
        $e539f33816e64990$var$ReactDOMSharedInternals.p = previousPriority, $e539f33816e64990$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e539f33816e64990$var$noop$2() {}
function $e539f33816e64990$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($e539f33816e64990$var$formatProdErrorMessage(476));
    var queue = $e539f33816e64990$var$ensureFormComponentIsStateful(formFiber).queue;
    $e539f33816e64990$var$startTransition(formFiber, queue, pendingState, $e539f33816e64990$var$sharedNotPendingObject, null === action ? $e539f33816e64990$var$noop$2 : function() {
        $e539f33816e64990$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $e539f33816e64990$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $e539f33816e64990$var$sharedNotPendingObject,
        baseState: $e539f33816e64990$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $e539f33816e64990$var$basicStateReducer,
            lastRenderedState: $e539f33816e64990$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $e539f33816e64990$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $e539f33816e64990$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $e539f33816e64990$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $e539f33816e64990$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $e539f33816e64990$var$requestUpdateLane());
}
function $e539f33816e64990$var$useHostTransitionStatus() {
    return $e539f33816e64990$var$readContext($e539f33816e64990$var$HostTransitionContext);
}
function $e539f33816e64990$var$updateId() {
    return $e539f33816e64990$var$updateWorkInProgressHook().memoizedState;
}
function $e539f33816e64990$var$updateRefresh() {
    return $e539f33816e64990$var$updateWorkInProgressHook().memoizedState;
}
function $e539f33816e64990$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $e539f33816e64990$var$requestUpdateLane();
                fiber = $e539f33816e64990$var$createUpdate(lane);
                var root$63 = $e539f33816e64990$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($e539f33816e64990$var$scheduleUpdateOnFiber(root$63, provider, lane), $e539f33816e64990$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $e539f33816e64990$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $e539f33816e64990$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $e539f33816e64990$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $e539f33816e64990$var$isRenderPhaseUpdate(fiber) ? $e539f33816e64990$var$enqueueRenderPhaseUpdate(queue, action) : (action = $e539f33816e64990$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($e539f33816e64990$var$scheduleUpdateOnFiber(action, fiber, lane), $e539f33816e64990$var$entangleTransitionUpdate(action, queue, lane)));
}
function $e539f33816e64990$var$dispatchSetState(fiber, queue, action) {
    var lane = $e539f33816e64990$var$requestUpdateLane();
    $e539f33816e64990$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $e539f33816e64990$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e539f33816e64990$var$isRenderPhaseUpdate(fiber)) $e539f33816e64990$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($e539f33816e64990$var$objectIs(eagerState, currentState)) return $e539f33816e64990$var$enqueueUpdate$1(fiber, queue, update, 0), null === $e539f33816e64990$var$workInProgressRoot && $e539f33816e64990$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $e539f33816e64990$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $e539f33816e64990$var$scheduleUpdateOnFiber(action, fiber, lane), $e539f33816e64990$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $e539f33816e64990$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $e539f33816e64990$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e539f33816e64990$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($e539f33816e64990$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $e539f33816e64990$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $e539f33816e64990$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $e539f33816e64990$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $e539f33816e64990$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $e539f33816e64990$var$currentlyRenderingFiber$1;
}
function $e539f33816e64990$var$enqueueRenderPhaseUpdate(queue, update) {
    $e539f33816e64990$var$didScheduleRenderPhaseUpdateDuringThisPass = $e539f33816e64990$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $e539f33816e64990$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $e539f33816e64990$var$markRootEntangled(root, lane);
    }
}
var $e539f33816e64990$var$ContextOnlyDispatcher = {
    readContext: $e539f33816e64990$var$readContext,
    use: $e539f33816e64990$var$use,
    useCallback: $e539f33816e64990$var$throwInvalidHookError,
    useContext: $e539f33816e64990$var$throwInvalidHookError,
    useEffect: $e539f33816e64990$var$throwInvalidHookError,
    useImperativeHandle: $e539f33816e64990$var$throwInvalidHookError,
    useLayoutEffect: $e539f33816e64990$var$throwInvalidHookError,
    useInsertionEffect: $e539f33816e64990$var$throwInvalidHookError,
    useMemo: $e539f33816e64990$var$throwInvalidHookError,
    useReducer: $e539f33816e64990$var$throwInvalidHookError,
    useRef: $e539f33816e64990$var$throwInvalidHookError,
    useState: $e539f33816e64990$var$throwInvalidHookError,
    useDebugValue: $e539f33816e64990$var$throwInvalidHookError,
    useDeferredValue: $e539f33816e64990$var$throwInvalidHookError,
    useTransition: $e539f33816e64990$var$throwInvalidHookError,
    useSyncExternalStore: $e539f33816e64990$var$throwInvalidHookError,
    useId: $e539f33816e64990$var$throwInvalidHookError
};
$e539f33816e64990$var$ContextOnlyDispatcher.useCacheRefresh = $e539f33816e64990$var$throwInvalidHookError;
$e539f33816e64990$var$ContextOnlyDispatcher.useMemoCache = $e539f33816e64990$var$throwInvalidHookError;
$e539f33816e64990$var$ContextOnlyDispatcher.useHostTransitionStatus = $e539f33816e64990$var$throwInvalidHookError;
$e539f33816e64990$var$ContextOnlyDispatcher.useFormState = $e539f33816e64990$var$throwInvalidHookError;
$e539f33816e64990$var$ContextOnlyDispatcher.useActionState = $e539f33816e64990$var$throwInvalidHookError;
$e539f33816e64990$var$ContextOnlyDispatcher.useOptimistic = $e539f33816e64990$var$throwInvalidHookError;
var $e539f33816e64990$var$HooksDispatcherOnMount = {
    readContext: $e539f33816e64990$var$readContext,
    use: $e539f33816e64990$var$use,
    useCallback: function(callback, deps) {
        $e539f33816e64990$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $e539f33816e64990$var$readContext,
    useEffect: $e539f33816e64990$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $e539f33816e64990$var$mountEffectImpl(4194308, 4, $e539f33816e64990$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $e539f33816e64990$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $e539f33816e64990$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $e539f33816e64990$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($e539f33816e64990$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $e539f33816e64990$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $e539f33816e64990$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $e539f33816e64990$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($e539f33816e64990$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $e539f33816e64990$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $e539f33816e64990$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $e539f33816e64990$var$dispatchReducerAction.bind(null, $e539f33816e64990$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $e539f33816e64990$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $e539f33816e64990$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $e539f33816e64990$var$dispatchSetState.bind(null, $e539f33816e64990$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $e539f33816e64990$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e539f33816e64990$var$mountWorkInProgressHook();
        return $e539f33816e64990$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $e539f33816e64990$var$mountStateImpl(!1);
        stateHook = $e539f33816e64990$var$startTransition.bind(null, $e539f33816e64990$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $e539f33816e64990$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $e539f33816e64990$var$currentlyRenderingFiber$1, hook = $e539f33816e64990$var$mountWorkInProgressHook();
        if ($e539f33816e64990$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($e539f33816e64990$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $e539f33816e64990$var$workInProgressRoot) throw Error($e539f33816e64990$var$formatProdErrorMessage(349));
            0 !== ($e539f33816e64990$var$workInProgressRootRenderLanes & 60) || $e539f33816e64990$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $e539f33816e64990$var$mountEffect($e539f33816e64990$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $e539f33816e64990$var$pushEffect(9, $e539f33816e64990$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $e539f33816e64990$var$mountWorkInProgressHook(), identifierPrefix = $e539f33816e64990$var$workInProgressRoot.identifierPrefix;
        if ($e539f33816e64990$var$isHydrating) {
            var JSCompiler_inline_result = $e539f33816e64990$var$treeContextOverflow;
            var idWithLeadingBit = $e539f33816e64990$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $e539f33816e64990$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $e539f33816e64990$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $e539f33816e64990$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $e539f33816e64990$var$mountWorkInProgressHook().memoizedState = $e539f33816e64990$var$refreshCache.bind(null, $e539f33816e64990$var$currentlyRenderingFiber$1);
    }
};
$e539f33816e64990$var$HooksDispatcherOnMount.useMemoCache = $e539f33816e64990$var$useMemoCache;
$e539f33816e64990$var$HooksDispatcherOnMount.useHostTransitionStatus = $e539f33816e64990$var$useHostTransitionStatus;
$e539f33816e64990$var$HooksDispatcherOnMount.useFormState = $e539f33816e64990$var$mountActionState;
$e539f33816e64990$var$HooksDispatcherOnMount.useActionState = $e539f33816e64990$var$mountActionState;
$e539f33816e64990$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $e539f33816e64990$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $e539f33816e64990$var$dispatchOptimisticSetState.bind(null, $e539f33816e64990$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $e539f33816e64990$var$HooksDispatcherOnUpdate = {
    readContext: $e539f33816e64990$var$readContext,
    use: $e539f33816e64990$var$use,
    useCallback: $e539f33816e64990$var$updateCallback,
    useContext: $e539f33816e64990$var$readContext,
    useEffect: $e539f33816e64990$var$updateEffect,
    useImperativeHandle: $e539f33816e64990$var$updateImperativeHandle,
    useInsertionEffect: $e539f33816e64990$var$updateInsertionEffect,
    useLayoutEffect: $e539f33816e64990$var$updateLayoutEffect,
    useMemo: $e539f33816e64990$var$updateMemo,
    useReducer: $e539f33816e64990$var$updateReducer,
    useRef: $e539f33816e64990$var$updateRef,
    useState: function() {
        return $e539f33816e64990$var$updateReducer($e539f33816e64990$var$basicStateReducer);
    },
    useDebugValue: $e539f33816e64990$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e539f33816e64990$var$updateWorkInProgressHook();
        return $e539f33816e64990$var$updateDeferredValueImpl(hook, $e539f33816e64990$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $e539f33816e64990$var$updateReducer($e539f33816e64990$var$basicStateReducer)[0], start = $e539f33816e64990$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $e539f33816e64990$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $e539f33816e64990$var$updateSyncExternalStore,
    useId: $e539f33816e64990$var$updateId
};
$e539f33816e64990$var$HooksDispatcherOnUpdate.useCacheRefresh = $e539f33816e64990$var$updateRefresh;
$e539f33816e64990$var$HooksDispatcherOnUpdate.useMemoCache = $e539f33816e64990$var$useMemoCache;
$e539f33816e64990$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $e539f33816e64990$var$useHostTransitionStatus;
$e539f33816e64990$var$HooksDispatcherOnUpdate.useFormState = $e539f33816e64990$var$updateActionState;
$e539f33816e64990$var$HooksDispatcherOnUpdate.useActionState = $e539f33816e64990$var$updateActionState;
$e539f33816e64990$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $e539f33816e64990$var$updateWorkInProgressHook();
    return $e539f33816e64990$var$updateOptimisticImpl(hook, $e539f33816e64990$var$currentHook, passthrough, reducer);
};
var $e539f33816e64990$var$HooksDispatcherOnRerender = {
    readContext: $e539f33816e64990$var$readContext,
    use: $e539f33816e64990$var$use,
    useCallback: $e539f33816e64990$var$updateCallback,
    useContext: $e539f33816e64990$var$readContext,
    useEffect: $e539f33816e64990$var$updateEffect,
    useImperativeHandle: $e539f33816e64990$var$updateImperativeHandle,
    useInsertionEffect: $e539f33816e64990$var$updateInsertionEffect,
    useLayoutEffect: $e539f33816e64990$var$updateLayoutEffect,
    useMemo: $e539f33816e64990$var$updateMemo,
    useReducer: $e539f33816e64990$var$rerenderReducer,
    useRef: $e539f33816e64990$var$updateRef,
    useState: function() {
        return $e539f33816e64990$var$rerenderReducer($e539f33816e64990$var$basicStateReducer);
    },
    useDebugValue: $e539f33816e64990$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e539f33816e64990$var$updateWorkInProgressHook();
        return null === $e539f33816e64990$var$currentHook ? $e539f33816e64990$var$mountDeferredValueImpl(hook, value, initialValue) : $e539f33816e64990$var$updateDeferredValueImpl(hook, $e539f33816e64990$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $e539f33816e64990$var$rerenderReducer($e539f33816e64990$var$basicStateReducer)[0], start = $e539f33816e64990$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $e539f33816e64990$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $e539f33816e64990$var$updateSyncExternalStore,
    useId: $e539f33816e64990$var$updateId
};
$e539f33816e64990$var$HooksDispatcherOnRerender.useCacheRefresh = $e539f33816e64990$var$updateRefresh;
$e539f33816e64990$var$HooksDispatcherOnRerender.useMemoCache = $e539f33816e64990$var$useMemoCache;
$e539f33816e64990$var$HooksDispatcherOnRerender.useHostTransitionStatus = $e539f33816e64990$var$useHostTransitionStatus;
$e539f33816e64990$var$HooksDispatcherOnRerender.useFormState = $e539f33816e64990$var$rerenderActionState;
$e539f33816e64990$var$HooksDispatcherOnRerender.useActionState = $e539f33816e64990$var$rerenderActionState;
$e539f33816e64990$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $e539f33816e64990$var$updateWorkInProgressHook();
    if (null !== $e539f33816e64990$var$currentHook) return $e539f33816e64990$var$updateOptimisticImpl(hook, $e539f33816e64990$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $e539f33816e64990$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $e539f33816e64990$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $e539f33816e64990$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $e539f33816e64990$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $e539f33816e64990$var$requestUpdateLane(), update = $e539f33816e64990$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $e539f33816e64990$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($e539f33816e64990$var$scheduleUpdateOnFiber(payload, inst, lane), $e539f33816e64990$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $e539f33816e64990$var$requestUpdateLane(), update = $e539f33816e64990$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $e539f33816e64990$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($e539f33816e64990$var$scheduleUpdateOnFiber(payload, inst, lane), $e539f33816e64990$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $e539f33816e64990$var$requestUpdateLane(), update = $e539f33816e64990$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $e539f33816e64990$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($e539f33816e64990$var$scheduleUpdateOnFiber(callback, inst, lane), $e539f33816e64990$var$entangleTransitions(callback, inst, lane));
    }
};
function $e539f33816e64990$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$e539f33816e64990$var$shallowEqual(oldProps, newProps) || !$e539f33816e64990$var$shallowEqual(oldState, newState) : !0;
}
function $e539f33816e64990$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $e539f33816e64990$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $e539f33816e64990$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $e539f33816e64990$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $e539f33816e64990$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $8HpnZ && "function" === typeof $8HpnZ.emit) {
        $8HpnZ.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $e539f33816e64990$var$defaultOnUncaughtError(error) {
    $e539f33816e64990$var$reportGlobalError(error);
}
function $e539f33816e64990$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $e539f33816e64990$var$defaultOnRecoverableError(error) {
    $e539f33816e64990$var$reportGlobalError(error);
}
function $e539f33816e64990$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $e539f33816e64990$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $e539f33816e64990$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $e539f33816e64990$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $e539f33816e64990$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $e539f33816e64990$var$createClassErrorUpdate(lane) {
    lane = $e539f33816e64990$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $e539f33816e64990$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $e539f33816e64990$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $e539f33816e64990$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $e539f33816e64990$var$legacyErrorBoundariesThatAlreadyFailed ? $e539f33816e64990$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $e539f33816e64990$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $e539f33816e64990$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $e539f33816e64990$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $e539f33816e64990$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $e539f33816e64990$var$shellBoundary ? $e539f33816e64990$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $e539f33816e64990$var$workInProgressRootExitStatus && ($e539f33816e64990$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $e539f33816e64990$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $e539f33816e64990$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $e539f33816e64990$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $e539f33816e64990$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($e539f33816e64990$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $e539f33816e64990$var$attachPingListener(root, value, rootRenderLanes);
        $e539f33816e64990$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($e539f33816e64990$var$isHydrating) return returnFiber = $e539f33816e64990$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $e539f33816e64990$var$HydrationMismatchException && (root = Error($e539f33816e64990$var$formatProdErrorMessage(422), {
        cause: value
    }), $e539f33816e64990$var$queueHydrationError($e539f33816e64990$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $e539f33816e64990$var$HydrationMismatchException && (returnFiber = Error($e539f33816e64990$var$formatProdErrorMessage(423), {
        cause: value
    }), $e539f33816e64990$var$queueHydrationError($e539f33816e64990$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $e539f33816e64990$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $e539f33816e64990$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $e539f33816e64990$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $e539f33816e64990$var$workInProgressRootExitStatus && ($e539f33816e64990$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($e539f33816e64990$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $e539f33816e64990$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $e539f33816e64990$var$workInProgressRootConcurrentErrors ? $e539f33816e64990$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $e539f33816e64990$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $e539f33816e64990$var$workInProgressRootExitStatus && ($e539f33816e64990$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $e539f33816e64990$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $e539f33816e64990$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $e539f33816e64990$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $e539f33816e64990$var$legacyErrorBoundariesThatAlreadyFailed || !$e539f33816e64990$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $e539f33816e64990$var$createClassErrorUpdate(rootRenderLanes), $e539f33816e64990$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $e539f33816e64990$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $e539f33816e64990$var$SelectiveHydrationException = Error($e539f33816e64990$var$formatProdErrorMessage(461)), $e539f33816e64990$var$didReceiveUpdate = !1;
function $e539f33816e64990$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $e539f33816e64990$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $e539f33816e64990$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $e539f33816e64990$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $e539f33816e64990$var$prepareToReadContext(workInProgress);
    nextProps = $e539f33816e64990$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $e539f33816e64990$var$checkDidRenderIdHook();
    if (null !== current && !$e539f33816e64990$var$didReceiveUpdate) return $e539f33816e64990$var$bailoutHooks(current, workInProgress, renderLanes), $e539f33816e64990$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e539f33816e64990$var$isHydrating && key && $e539f33816e64990$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e539f33816e64990$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $e539f33816e64990$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$e539f33816e64990$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $e539f33816e64990$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $e539f33816e64990$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$e539f33816e64990$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $e539f33816e64990$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $e539f33816e64990$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $e539f33816e64990$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $e539f33816e64990$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($e539f33816e64990$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($e539f33816e64990$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $e539f33816e64990$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($e539f33816e64990$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $e539f33816e64990$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $e539f33816e64990$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $e539f33816e64990$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $e539f33816e64990$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $e539f33816e64990$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $e539f33816e64990$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $e539f33816e64990$var$pushHiddenContext(workInProgress, prevState) : $e539f33816e64990$var$reuseHiddenContextOnStack(), $e539f33816e64990$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $e539f33816e64990$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($e539f33816e64990$var$pushTransition(workInProgress, prevState.cachePool), $e539f33816e64990$var$pushHiddenContext(workInProgress, prevState), $e539f33816e64990$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $e539f33816e64990$var$pushTransition(workInProgress, null), $e539f33816e64990$var$reuseHiddenContextOnStack(), $e539f33816e64990$var$reuseSuspenseHandlerOnStack(workInProgress));
    $e539f33816e64990$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $e539f33816e64990$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $e539f33816e64990$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $e539f33816e64990$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $e539f33816e64990$var$pushTransition(workInProgress, null);
    $e539f33816e64990$var$reuseHiddenContextOnStack();
    $e539f33816e64990$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $e539f33816e64990$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $e539f33816e64990$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($e539f33816e64990$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $e539f33816e64990$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $e539f33816e64990$var$prepareToReadContext(workInProgress);
    Component = $e539f33816e64990$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $e539f33816e64990$var$checkDidRenderIdHook();
    if (null !== current && !$e539f33816e64990$var$didReceiveUpdate) return $e539f33816e64990$var$bailoutHooks(current, workInProgress, renderLanes), $e539f33816e64990$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e539f33816e64990$var$isHydrating && nextProps && $e539f33816e64990$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e539f33816e64990$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $e539f33816e64990$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $e539f33816e64990$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $e539f33816e64990$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $e539f33816e64990$var$finishRenderingHooks(current);
    Component = $e539f33816e64990$var$checkDidRenderIdHook();
    if (null !== current && !$e539f33816e64990$var$didReceiveUpdate) return $e539f33816e64990$var$bailoutHooks(current, workInProgress, renderLanes), $e539f33816e64990$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e539f33816e64990$var$isHydrating && Component && $e539f33816e64990$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e539f33816e64990$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $e539f33816e64990$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $e539f33816e64990$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $e539f33816e64990$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $e539f33816e64990$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $e539f33816e64990$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $e539f33816e64990$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $e539f33816e64990$var$readContext(contextType) : $e539f33816e64990$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($e539f33816e64990$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $e539f33816e64990$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $e539f33816e64990$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $e539f33816e64990$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $e539f33816e64990$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $e539f33816e64990$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $e539f33816e64990$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $e539f33816e64990$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $e539f33816e64990$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $e539f33816e64990$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $e539f33816e64990$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $e539f33816e64990$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($e539f33816e64990$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $e539f33816e64990$var$hasForceUpdate || $e539f33816e64990$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $e539f33816e64990$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $e539f33816e64990$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $e539f33816e64990$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $e539f33816e64990$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $e539f33816e64990$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $e539f33816e64990$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $e539f33816e64990$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $e539f33816e64990$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $e539f33816e64990$var$hasForceUpdate || null !== current && null !== current.dependencies && $e539f33816e64990$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($e539f33816e64990$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $e539f33816e64990$var$hasForceUpdate || $e539f33816e64990$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $e539f33816e64990$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $e539f33816e64990$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $e539f33816e64990$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $e539f33816e64990$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $e539f33816e64990$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $e539f33816e64990$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $e539f33816e64990$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $e539f33816e64990$var$resetHydrationState();
    workInProgress.flags |= 256;
    $e539f33816e64990$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $e539f33816e64990$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e539f33816e64990$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $e539f33816e64990$var$getSuspendedCache()
    };
}
function $e539f33816e64990$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $e539f33816e64990$var$workInProgressDeferredLane);
    return current;
}
function $e539f33816e64990$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($e539f33816e64990$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($e539f33816e64990$var$isHydrating) {
            showFallback ? $e539f33816e64990$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $e539f33816e64990$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($e539f33816e64990$var$isHydrating) {
                var nextInstance = $e539f33816e64990$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $e539f33816e64990$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $e539f33816e64990$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $e539f33816e64990$var$treeContextProvider ? {
                            id: $e539f33816e64990$var$treeContextId,
                            overflow: $e539f33816e64990$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $e539f33816e64990$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $e539f33816e64990$var$hydrationParentFiber = workInProgress, $e539f33816e64990$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $e539f33816e64990$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $e539f33816e64990$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $e539f33816e64990$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $e539f33816e64990$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $e539f33816e64990$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $e539f33816e64990$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $e539f33816e64990$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e539f33816e64990$var$SUSPENDED_MARKER, nextProps;
        $e539f33816e64990$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $e539f33816e64990$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($e539f33816e64990$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $e539f33816e64990$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($e539f33816e64990$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($e539f33816e64990$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $e539f33816e64990$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $e539f33816e64990$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $e539f33816e64990$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $e539f33816e64990$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $e539f33816e64990$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e539f33816e64990$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($e539f33816e64990$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($e539f33816e64990$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $e539f33816e64990$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $e539f33816e64990$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($e539f33816e64990$var$didReceiveUpdate || $e539f33816e64990$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $e539f33816e64990$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $e539f33816e64990$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $e539f33816e64990$var$enqueueConcurrentRenderForLane(current, nextProps), $e539f33816e64990$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $e539f33816e64990$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $e539f33816e64990$var$renderDidSuspendDelayIfPossible();
            workInProgress = $e539f33816e64990$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $e539f33816e64990$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $e539f33816e64990$var$nextHydratableInstance = $e539f33816e64990$var$getNextHydratable(nextInstance.nextSibling), $e539f33816e64990$var$hydrationParentFiber = workInProgress, $e539f33816e64990$var$isHydrating = !0, $e539f33816e64990$var$hydrationErrors = null, $e539f33816e64990$var$rootOrSingletonContext = !1, null !== current && ($e539f33816e64990$var$idStack[$e539f33816e64990$var$idStackIndex++] = $e539f33816e64990$var$treeContextId, $e539f33816e64990$var$idStack[$e539f33816e64990$var$idStackIndex++] = $e539f33816e64990$var$treeContextOverflow, $e539f33816e64990$var$idStack[$e539f33816e64990$var$idStackIndex++] = $e539f33816e64990$var$treeContextProvider, $e539f33816e64990$var$treeContextId = current.id, $e539f33816e64990$var$treeContextOverflow = current.overflow, $e539f33816e64990$var$treeContextProvider = workInProgress), workInProgress = $e539f33816e64990$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $e539f33816e64990$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $e539f33816e64990$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $e539f33816e64990$var$createWorkInProgress(digest, showFallback) : (showFallback = $e539f33816e64990$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $e539f33816e64990$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $e539f33816e64990$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $e539f33816e64990$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $e539f33816e64990$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e539f33816e64990$var$SUSPENDED_MARKER, nextProps;
    $e539f33816e64990$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $e539f33816e64990$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $e539f33816e64990$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $e539f33816e64990$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $e539f33816e64990$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $e539f33816e64990$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $e539f33816e64990$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $e539f33816e64990$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $e539f33816e64990$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $e539f33816e64990$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $e539f33816e64990$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $e539f33816e64990$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $e539f33816e64990$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $e539f33816e64990$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $e539f33816e64990$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $e539f33816e64990$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $e539f33816e64990$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $e539f33816e64990$var$push($e539f33816e64990$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $e539f33816e64990$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $e539f33816e64990$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $e539f33816e64990$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $e539f33816e64990$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $e539f33816e64990$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $e539f33816e64990$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $e539f33816e64990$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($e539f33816e64990$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($e539f33816e64990$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $e539f33816e64990$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $e539f33816e64990$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $e539f33816e64990$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $e539f33816e64990$var$checkIfContextChanged(current) ? !0 : !1;
}
function $e539f33816e64990$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $e539f33816e64990$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $e539f33816e64990$var$pushProvider(workInProgress, $e539f33816e64990$var$CacheContext, current.memoizedState.cache);
            $e539f33816e64990$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $e539f33816e64990$var$pushHostContext(workInProgress);
            break;
        case 4:
            $e539f33816e64990$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $e539f33816e64990$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $e539f33816e64990$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $e539f33816e64990$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $e539f33816e64990$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $e539f33816e64990$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $e539f33816e64990$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($e539f33816e64990$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $e539f33816e64990$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $e539f33816e64990$var$push($e539f33816e64990$var$suspenseStackCursor, $e539f33816e64990$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $e539f33816e64990$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $e539f33816e64990$var$pushProvider(workInProgress, $e539f33816e64990$var$CacheContext, current.memoizedState.cache);
    }
    return $e539f33816e64990$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $e539f33816e64990$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $e539f33816e64990$var$didReceiveUpdate = !0;
        else {
            if (!$e539f33816e64990$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $e539f33816e64990$var$didReceiveUpdate = !1, $e539f33816e64990$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $e539f33816e64990$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $e539f33816e64990$var$didReceiveUpdate = !1, $e539f33816e64990$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $e539f33816e64990$var$pushTreeId(workInProgress, $e539f33816e64990$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $e539f33816e64990$var$shouldConstruct(lazyComponent) ? (current = $e539f33816e64990$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $e539f33816e64990$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $e539f33816e64990$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $e539f33816e64990$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $e539f33816e64990$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $e539f33816e64990$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $e539f33816e64990$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $e539f33816e64990$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($e539f33816e64990$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $e539f33816e64990$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $e539f33816e64990$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $e539f33816e64990$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $e539f33816e64990$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($e539f33816e64990$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $e539f33816e64990$var$cloneUpdateQueue(current, workInProgress);
                $e539f33816e64990$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $e539f33816e64990$var$pushProvider(workInProgress, $e539f33816e64990$var$CacheContext, nextProps);
                nextProps !== init.cache && $e539f33816e64990$var$propagateContextChanges(workInProgress, [
                    $e539f33816e64990$var$CacheContext
                ], renderLanes, !0);
                $e539f33816e64990$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $e539f33816e64990$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $e539f33816e64990$var$createCapturedValueAtFiber(Error($e539f33816e64990$var$formatProdErrorMessage(424)), workInProgress);
                        $e539f33816e64990$var$queueHydrationError(lazyComponent);
                        workInProgress = $e539f33816e64990$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($e539f33816e64990$var$nextHydratableInstance = $e539f33816e64990$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $e539f33816e64990$var$hydrationParentFiber = workInProgress, $e539f33816e64990$var$isHydrating = !0, $e539f33816e64990$var$hydrationErrors = null, $e539f33816e64990$var$rootOrSingletonContext = !0, renderLanes = $e539f33816e64990$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $e539f33816e64990$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $e539f33816e64990$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $e539f33816e64990$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $e539f33816e64990$var$markRef(current, workInProgress), null === current ? (renderLanes = $e539f33816e64990$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $e539f33816e64990$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $e539f33816e64990$var$getOwnerDocumentFromRootContainer($e539f33816e64990$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$e539f33816e64990$var$internalInstanceKey] = workInProgress, lazyComponent[$e539f33816e64990$var$internalPropsKey] = current, $e539f33816e64990$var$setInitialProperties(lazyComponent, renderLanes, current), $e539f33816e64990$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $e539f33816e64990$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $e539f33816e64990$var$pushHostContext(workInProgress), null === current && $e539f33816e64990$var$isHydrating && (lazyComponent = workInProgress.stateNode = $e539f33816e64990$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $e539f33816e64990$var$rootInstanceStackCursor.current), $e539f33816e64990$var$hydrationParentFiber = workInProgress, $e539f33816e64990$var$rootOrSingletonContext = !0, $e539f33816e64990$var$nextHydratableInstance = $e539f33816e64990$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $e539f33816e64990$var$isHydrating ? $e539f33816e64990$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $e539f33816e64990$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $e539f33816e64990$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $e539f33816e64990$var$isHydrating) {
                if (init = lazyComponent = $e539f33816e64990$var$nextHydratableInstance) lazyComponent = $e539f33816e64990$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $e539f33816e64990$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $e539f33816e64990$var$hydrationParentFiber = workInProgress, $e539f33816e64990$var$nextHydratableInstance = $e539f33816e64990$var$getNextHydratable(lazyComponent.firstChild), $e539f33816e64990$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $e539f33816e64990$var$throwOnHydrationMismatch(workInProgress);
            }
            $e539f33816e64990$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $e539f33816e64990$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $e539f33816e64990$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $e539f33816e64990$var$renderWithHooks(current, workInProgress, $e539f33816e64990$var$TransitionAwareHostComponent, null, null, renderLanes), $e539f33816e64990$var$HostTransitionContext._currentValue = init);
            $e539f33816e64990$var$markRef(current, workInProgress);
            $e539f33816e64990$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $e539f33816e64990$var$isHydrating) {
                if (current = renderLanes = $e539f33816e64990$var$nextHydratableInstance) renderLanes = $e539f33816e64990$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $e539f33816e64990$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $e539f33816e64990$var$hydrationParentFiber = workInProgress, $e539f33816e64990$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $e539f33816e64990$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $e539f33816e64990$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $e539f33816e64990$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $e539f33816e64990$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $e539f33816e64990$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $e539f33816e64990$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $e539f33816e64990$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $e539f33816e64990$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $e539f33816e64990$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $e539f33816e64990$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $e539f33816e64990$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $e539f33816e64990$var$prepareToReadContext(workInProgress), init = $e539f33816e64990$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $e539f33816e64990$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $e539f33816e64990$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $e539f33816e64990$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $e539f33816e64990$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $e539f33816e64990$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $e539f33816e64990$var$prepareToReadContext(workInProgress), lazyComponent = $e539f33816e64990$var$readContext($e539f33816e64990$var$CacheContext), null === current ? (init = $e539f33816e64990$var$peekCacheFromPool(), null === init && (init = $e539f33816e64990$var$workInProgressRoot, nextProps = $e539f33816e64990$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $e539f33816e64990$var$initializeUpdateQueue(workInProgress), $e539f33816e64990$var$pushProvider(workInProgress, $e539f33816e64990$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($e539f33816e64990$var$cloneUpdateQueue(current, workInProgress), $e539f33816e64990$var$processUpdateQueue(workInProgress, null, null, renderLanes), $e539f33816e64990$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $e539f33816e64990$var$pushProvider(workInProgress, $e539f33816e64990$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $e539f33816e64990$var$pushProvider(workInProgress, $e539f33816e64990$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $e539f33816e64990$var$propagateContextChanges(workInProgress, [
                $e539f33816e64990$var$CacheContext
            ], renderLanes, !0))), $e539f33816e64990$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($e539f33816e64990$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $e539f33816e64990$var$valueCursor = $e539f33816e64990$var$createCursor(null), $e539f33816e64990$var$currentlyRenderingFiber = null, $e539f33816e64990$var$lastContextDependency = null;
function $e539f33816e64990$var$pushProvider(providerFiber, context, nextValue) {
    $e539f33816e64990$var$push($e539f33816e64990$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $e539f33816e64990$var$popProvider(context) {
    context._currentValue = $e539f33816e64990$var$valueCursor.current;
    $e539f33816e64990$var$pop($e539f33816e64990$var$valueCursor);
}
function $e539f33816e64990$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $e539f33816e64990$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $e539f33816e64990$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($e539f33816e64990$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $e539f33816e64990$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $e539f33816e64990$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($e539f33816e64990$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $e539f33816e64990$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $e539f33816e64990$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($e539f33816e64990$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($e539f33816e64990$var$HostTransitionContext) : current = [
                $e539f33816e64990$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $e539f33816e64990$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $e539f33816e64990$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$e539f33816e64990$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $e539f33816e64990$var$prepareToReadContext(workInProgress) {
    $e539f33816e64990$var$currentlyRenderingFiber = workInProgress;
    $e539f33816e64990$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $e539f33816e64990$var$readContext(context) {
    return $e539f33816e64990$var$readContextForConsumer($e539f33816e64990$var$currentlyRenderingFiber, context);
}
function $e539f33816e64990$var$readContextDuringReconciliation(consumer, context) {
    null === $e539f33816e64990$var$currentlyRenderingFiber && $e539f33816e64990$var$prepareToReadContext(consumer);
    return $e539f33816e64990$var$readContextForConsumer(consumer, context);
}
function $e539f33816e64990$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $e539f33816e64990$var$lastContextDependency) {
        if (null === consumer) throw Error($e539f33816e64990$var$formatProdErrorMessage(308));
        $e539f33816e64990$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $e539f33816e64990$var$lastContextDependency = $e539f33816e64990$var$lastContextDependency.next = context;
    return value;
}
var $e539f33816e64990$var$hasForceUpdate = !1;
function $e539f33816e64990$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $e539f33816e64990$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $e539f33816e64990$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e539f33816e64990$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($e539f33816e64990$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $e539f33816e64990$var$getRootForUpdatedFiber(fiber);
        $e539f33816e64990$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $e539f33816e64990$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $e539f33816e64990$var$getRootForUpdatedFiber(fiber);
}
function $e539f33816e64990$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $e539f33816e64990$var$markRootEntangled(root, lane);
    }
}
function $e539f33816e64990$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $e539f33816e64990$var$didReadFromEntangledAsyncAction = !1;
function $e539f33816e64990$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($e539f33816e64990$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $e539f33816e64990$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $e539f33816e64990$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $e539f33816e64990$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $e539f33816e64990$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($e539f33816e64990$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $e539f33816e64990$var$currentEntangledLane && ($e539f33816e64990$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $e539f33816e64990$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $e539f33816e64990$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $e539f33816e64990$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $e539f33816e64990$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($e539f33816e64990$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $e539f33816e64990$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$e539f33816e64990$var$callCallback(callbacks[updateQueue], context);
}
function $e539f33816e64990$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e539f33816e64990$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $e539f33816e64990$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e539f33816e64990$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $e539f33816e64990$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $e539f33816e64990$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $e539f33816e64990$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $e539f33816e64990$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $e539f33816e64990$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $e539f33816e64990$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $e539f33816e64990$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $e539f33816e64990$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $e539f33816e64990$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $e539f33816e64990$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e539f33816e64990$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $e539f33816e64990$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$e539f33816e64990$var$internalPropsKey] = newProps;
    } catch (error) {
        $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e539f33816e64990$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $e539f33816e64990$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $e539f33816e64990$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $e539f33816e64990$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $e539f33816e64990$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($e539f33816e64990$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$e539f33816e64990$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $e539f33816e64990$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($e539f33816e64990$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$e539f33816e64990$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $e539f33816e64990$var$offscreenSubtreeIsHidden = !1, $e539f33816e64990$var$offscreenSubtreeWasHidden = !1, $e539f33816e64990$var$needsFormReset = !1, $e539f33816e64990$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $e539f33816e64990$var$nextEffect = null, $e539f33816e64990$var$shouldFireAfterActiveInstanceBlur = !1;
function $e539f33816e64990$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $e539f33816e64990$var$eventsEnabled = $e539f33816e64990$var$_enabled;
    root = $e539f33816e64990$var$getActiveElementDeep(root);
    if ($e539f33816e64990$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $e539f33816e64990$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $e539f33816e64990$var$_enabled = !1;
    for($e539f33816e64990$var$nextEffect = firstChild; null !== $e539f33816e64990$var$nextEffect;)if (firstChild = $e539f33816e64990$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $e539f33816e64990$var$nextEffect = root;
    else for(; null !== $e539f33816e64990$var$nextEffect;){
        firstChild = $e539f33816e64990$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $e539f33816e64990$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $e539f33816e64990$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $e539f33816e64990$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $e539f33816e64990$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($e539f33816e64990$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $e539f33816e64990$var$nextEffect = root;
            break;
        }
        $e539f33816e64990$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $e539f33816e64990$var$shouldFireAfterActiveInstanceBlur;
    $e539f33816e64990$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $e539f33816e64990$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e539f33816e64990$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e539f33816e64990$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $e539f33816e64990$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $e539f33816e64990$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $e539f33816e64990$var$commitClassCallbacks(finishedWork);
            flags & 512 && $e539f33816e64990$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $e539f33816e64990$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $e539f33816e64990$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $e539f33816e64990$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $e539f33816e64990$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $e539f33816e64990$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $e539f33816e64990$var$commitHostMount(finishedWork);
            flags & 512 && $e539f33816e64990$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $e539f33816e64990$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $e539f33816e64990$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e539f33816e64990$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $e539f33816e64990$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $e539f33816e64990$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $e539f33816e64990$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $e539f33816e64990$var$offscreenSubtreeWasHidden;
                $e539f33816e64990$var$offscreenSubtreeIsHidden = prevProps;
                ($e539f33816e64990$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $e539f33816e64990$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $e539f33816e64990$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $e539f33816e64990$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $e539f33816e64990$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $e539f33816e64990$var$safelyAttachRef(finishedWork, finishedWork.return) : $e539f33816e64990$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $e539f33816e64990$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $e539f33816e64990$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $e539f33816e64990$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $e539f33816e64990$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $e539f33816e64990$var$hostParent = null, $e539f33816e64990$var$hostParentIsContainer = !1;
function $e539f33816e64990$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$e539f33816e64990$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $e539f33816e64990$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($e539f33816e64990$var$injectedHook && "function" === typeof $e539f33816e64990$var$injectedHook.onCommitFiberUnmount) try {
        $e539f33816e64990$var$injectedHook.onCommitFiberUnmount($e539f33816e64990$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $e539f33816e64990$var$offscreenSubtreeWasHidden || $e539f33816e64990$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $e539f33816e64990$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $e539f33816e64990$var$offscreenSubtreeWasHidden || $e539f33816e64990$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $e539f33816e64990$var$hostParent, prevHostParentIsContainer = $e539f33816e64990$var$hostParentIsContainer;
            $e539f33816e64990$var$hostParent = deletedFiber.stateNode;
            $e539f33816e64990$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $e539f33816e64990$var$detachDeletedInstance(deletedFiber);
            $e539f33816e64990$var$hostParent = prevHostParent;
            $e539f33816e64990$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $e539f33816e64990$var$offscreenSubtreeWasHidden || $e539f33816e64990$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $e539f33816e64990$var$hostParent;
            var prevHostParentIsContainer$119 = $e539f33816e64990$var$hostParentIsContainer;
            $e539f33816e64990$var$hostParent = null;
            $e539f33816e64990$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e539f33816e64990$var$hostParent = prevHostParentIsContainer;
            $e539f33816e64990$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $e539f33816e64990$var$hostParent) {
                if ($e539f33816e64990$var$hostParentIsContainer) try {
                    finishedRoot = $e539f33816e64990$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $e539f33816e64990$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $e539f33816e64990$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $e539f33816e64990$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $e539f33816e64990$var$hostParent && ($e539f33816e64990$var$hostParentIsContainer ? (nearestMountedAncestor = $e539f33816e64990$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $e539f33816e64990$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $e539f33816e64990$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $e539f33816e64990$var$retryIfBlockedOn(nearestMountedAncestor)) : $e539f33816e64990$var$clearSuspenseBoundary($e539f33816e64990$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $e539f33816e64990$var$hostParent;
            prevHostParentIsContainer = $e539f33816e64990$var$hostParentIsContainer;
            $e539f33816e64990$var$hostParent = deletedFiber.stateNode.containerInfo;
            $e539f33816e64990$var$hostParentIsContainer = !0;
            $e539f33816e64990$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e539f33816e64990$var$hostParent = prevHostParent;
            $e539f33816e64990$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $e539f33816e64990$var$offscreenSubtreeWasHidden || $e539f33816e64990$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $e539f33816e64990$var$offscreenSubtreeWasHidden || $e539f33816e64990$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $e539f33816e64990$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $e539f33816e64990$var$offscreenSubtreeWasHidden || ($e539f33816e64990$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $e539f33816e64990$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $e539f33816e64990$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $e539f33816e64990$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $e539f33816e64990$var$offscreenSubtreeWasHidden || $e539f33816e64990$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $e539f33816e64990$var$offscreenSubtreeWasHidden = (prevHostParent = $e539f33816e64990$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $e539f33816e64990$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e539f33816e64990$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $e539f33816e64990$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $e539f33816e64990$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $e539f33816e64990$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e539f33816e64990$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $e539f33816e64990$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $e539f33816e64990$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($e539f33816e64990$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $e539f33816e64990$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $e539f33816e64990$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $e539f33816e64990$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $e539f33816e64990$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $e539f33816e64990$var$hostParent = parent.stateNode;
                    $e539f33816e64990$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $e539f33816e64990$var$hostParent = parent.stateNode.containerInfo;
                    $e539f33816e64990$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $e539f33816e64990$var$hostParent = parent.stateNode.containerInfo;
                    $e539f33816e64990$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $e539f33816e64990$var$hostParent) throw Error($e539f33816e64990$var$formatProdErrorMessage(160));
        $e539f33816e64990$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $e539f33816e64990$var$hostParent = null;
        $e539f33816e64990$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$e539f33816e64990$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $e539f33816e64990$var$currentHoistableRoot = null;
function $e539f33816e64990$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($e539f33816e64990$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $e539f33816e64990$var$commitHookEffectListMount(3, finishedWork), $e539f33816e64990$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e539f33816e64990$var$offscreenSubtreeWasHidden || null === current || $e539f33816e64990$var$safelyDetachRef(current, current.return));
            flags & 64 && $e539f33816e64990$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $e539f33816e64990$var$currentHoistableRoot;
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e539f33816e64990$var$offscreenSubtreeWasHidden || null === current || $e539f33816e64990$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$e539f33816e64990$var$internalHoistableMarker] || currentResource[$e539f33816e64990$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $e539f33816e64990$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$e539f33816e64990$var$internalInstanceKey] = finishedWork;
                                        $e539f33816e64990$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $e539f33816e64990$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $e539f33816e64990$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $e539f33816e64990$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $e539f33816e64990$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($e539f33816e64990$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$e539f33816e64990$var$internalInstanceKey] = finishedWork;
                                $e539f33816e64990$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $e539f33816e64990$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $e539f33816e64990$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $e539f33816e64990$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $e539f33816e64990$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $e539f33816e64990$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$e539f33816e64990$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $e539f33816e64990$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$e539f33816e64990$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$e539f33816e64990$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e539f33816e64990$var$offscreenSubtreeWasHidden || null === current || $e539f33816e64990$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $e539f33816e64990$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $e539f33816e64990$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($e539f33816e64990$var$needsFormReset = !0);
            break;
        case 6:
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($e539f33816e64990$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $e539f33816e64990$var$tagCaches = null;
            hoistableRoot = $e539f33816e64990$var$currentHoistableRoot;
            $e539f33816e64990$var$currentHoistableRoot = $e539f33816e64990$var$getHoistableRoot(root.containerInfo);
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e539f33816e64990$var$currentHoistableRoot = hoistableRoot;
            $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $e539f33816e64990$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $e539f33816e64990$var$needsFormReset && ($e539f33816e64990$var$needsFormReset = !1, $e539f33816e64990$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $e539f33816e64990$var$currentHoistableRoot;
            $e539f33816e64990$var$currentHoistableRoot = $e539f33816e64990$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
            $e539f33816e64990$var$currentHoistableRoot = flags;
            break;
        case 12:
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($e539f33816e64990$var$globalMostRecentFallbackTime = $e539f33816e64990$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $e539f33816e64990$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($e539f33816e64990$var$offscreenSubtreeWasHidden || null === current || $e539f33816e64990$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $e539f33816e64990$var$offscreenSubtreeIsHidden;
            type = $e539f33816e64990$var$offscreenSubtreeWasHidden;
            $e539f33816e64990$var$offscreenSubtreeIsHidden = nodeName || node;
            $e539f33816e64990$var$offscreenSubtreeWasHidden = type || nextNode;
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e539f33816e64990$var$offscreenSubtreeWasHidden = type;
            $e539f33816e64990$var$offscreenSubtreeIsHidden = nodeName;
            $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $e539f33816e64990$var$offscreenSubtreeIsHidden || $e539f33816e64990$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $e539f33816e64990$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $e539f33816e64990$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $e539f33816e64990$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $e539f33816e64990$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $e539f33816e64990$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $e539f33816e64990$var$recursivelyTraverseMutationEffects(root, finishedWork), $e539f33816e64990$var$commitReconciliationEffects(finishedWork);
    }
}
function $e539f33816e64990$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($e539f33816e64990$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($e539f33816e64990$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $e539f33816e64990$var$getHostSibling(finishedWork);
                        $e539f33816e64990$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($e539f33816e64990$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $e539f33816e64990$var$getHostSibling(finishedWork);
                        $e539f33816e64990$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $e539f33816e64990$var$getHostSibling(finishedWork);
                        $e539f33816e64990$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($e539f33816e64990$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $e539f33816e64990$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $e539f33816e64990$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $e539f33816e64990$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$e539f33816e64990$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $e539f33816e64990$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $e539f33816e64990$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $e539f33816e64990$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $e539f33816e64990$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $e539f33816e64990$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $e539f33816e64990$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $e539f33816e64990$var$safelyDetachRef(finishedWork, finishedWork.return);
                $e539f33816e64990$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $e539f33816e64990$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $e539f33816e64990$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $e539f33816e64990$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e539f33816e64990$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $e539f33816e64990$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $e539f33816e64990$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $e539f33816e64990$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $e539f33816e64990$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$e539f33816e64990$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $e539f33816e64990$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $e539f33816e64990$var$commitClassCallbacks(finishedWork);
                $e539f33816e64990$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $e539f33816e64990$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $e539f33816e64990$var$commitHostMount(finishedWork);
                $e539f33816e64990$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $e539f33816e64990$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $e539f33816e64990$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $e539f33816e64990$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $e539f33816e64990$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $e539f33816e64990$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $e539f33816e64990$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e539f33816e64990$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $e539f33816e64990$var$releaseCache(previousCache));
}
function $e539f33816e64990$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $e539f33816e64990$var$releaseCache(current));
}
function $e539f33816e64990$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$e539f33816e64990$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $e539f33816e64990$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e539f33816e64990$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $e539f33816e64990$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $e539f33816e64990$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $e539f33816e64990$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $e539f33816e64990$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $e539f33816e64990$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $e539f33816e64990$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $e539f33816e64990$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $e539f33816e64990$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $e539f33816e64990$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $e539f33816e64990$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $e539f33816e64990$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $e539f33816e64990$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $e539f33816e64990$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $e539f33816e64990$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $e539f33816e64990$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $e539f33816e64990$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $e539f33816e64990$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $e539f33816e64990$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $e539f33816e64990$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $e539f33816e64990$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $e539f33816e64990$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $e539f33816e64990$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $e539f33816e64990$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $e539f33816e64990$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e539f33816e64990$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $e539f33816e64990$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $e539f33816e64990$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $e539f33816e64990$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $e539f33816e64990$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $e539f33816e64990$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $e539f33816e64990$var$suspenseyCommitFlag = 8192;
function $e539f33816e64990$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $e539f33816e64990$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$e539f33816e64990$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $e539f33816e64990$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $e539f33816e64990$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $e539f33816e64990$var$suspenseyCommitFlag && null !== fiber.memoizedState && $e539f33816e64990$var$suspendResource($e539f33816e64990$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $e539f33816e64990$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $e539f33816e64990$var$currentHoistableRoot;
            $e539f33816e64990$var$currentHoistableRoot = $e539f33816e64990$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $e539f33816e64990$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $e539f33816e64990$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $e539f33816e64990$var$suspenseyCommitFlag, $e539f33816e64990$var$suspenseyCommitFlag = 16777216, $e539f33816e64990$var$recursivelyAccumulateSuspenseyCommit(fiber), $e539f33816e64990$var$suspenseyCommitFlag = previousHoistableRoot) : $e539f33816e64990$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $e539f33816e64990$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $e539f33816e64990$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $e539f33816e64990$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $e539f33816e64990$var$nextEffect = childToDelete;
            $e539f33816e64990$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $e539f33816e64990$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$e539f33816e64990$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $e539f33816e64990$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e539f33816e64990$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $e539f33816e64990$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $e539f33816e64990$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $e539f33816e64990$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $e539f33816e64990$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $e539f33816e64990$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $e539f33816e64990$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $e539f33816e64990$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $e539f33816e64990$var$nextEffect = childToDelete;
            $e539f33816e64990$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $e539f33816e64990$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $e539f33816e64990$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $e539f33816e64990$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $e539f33816e64990$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $e539f33816e64990$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e539f33816e64990$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $e539f33816e64990$var$nextEffect;){
        var fiber = $e539f33816e64990$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $e539f33816e64990$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $e539f33816e64990$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $e539f33816e64990$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $e539f33816e64990$var$nextEffect;){
            cache = $e539f33816e64990$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $e539f33816e64990$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $e539f33816e64990$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $e539f33816e64990$var$nextEffect = sibling;
                break a;
            }
            $e539f33816e64990$var$nextEffect = returnFiber;
        }
    }
}
function $e539f33816e64990$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e539f33816e64990$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $e539f33816e64990$var$FiberNode(tag, pendingProps, key, mode);
}
function $e539f33816e64990$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $e539f33816e64990$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $e539f33816e64990$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $e539f33816e64990$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $e539f33816e64990$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $e539f33816e64990$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $e539f33816e64990$var$isHostHoistableType(type, pendingProps, $e539f33816e64990$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $e539f33816e64990$var$REACT_FRAGMENT_TYPE:
            return $e539f33816e64990$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $e539f33816e64990$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $e539f33816e64990$var$REACT_PROFILER_TYPE:
            return type = $e539f33816e64990$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $e539f33816e64990$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $e539f33816e64990$var$REACT_SUSPENSE_TYPE:
            return type = $e539f33816e64990$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $e539f33816e64990$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $e539f33816e64990$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $e539f33816e64990$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $e539f33816e64990$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $e539f33816e64990$var$REACT_OFFSCREEN_TYPE:
            return $e539f33816e64990$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $e539f33816e64990$var$REACT_PROVIDER_TYPE:
                case $e539f33816e64990$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $e539f33816e64990$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $e539f33816e64990$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $e539f33816e64990$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $e539f33816e64990$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($e539f33816e64990$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $e539f33816e64990$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $e539f33816e64990$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $e539f33816e64990$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $e539f33816e64990$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $e539f33816e64990$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $e539f33816e64990$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($e539f33816e64990$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $e539f33816e64990$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $e539f33816e64990$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($e539f33816e64990$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $e539f33816e64990$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $e539f33816e64990$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $e539f33816e64990$var$createFiberFromText(content, mode, lanes) {
    content = $e539f33816e64990$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $e539f33816e64990$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $e539f33816e64990$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $e539f33816e64990$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $e539f33816e64990$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$e539f33816e64990$var$preloadResource(resource)) {
        resource = $e539f33816e64990$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($e539f33816e64990$var$workInProgressRootRenderLanes & 4194176) === $e539f33816e64990$var$workInProgressRootRenderLanes ? null !== $e539f33816e64990$var$shellBoundary : ($e539f33816e64990$var$workInProgressRootRenderLanes & 62914560) !== $e539f33816e64990$var$workInProgressRootRenderLanes && 0 === ($e539f33816e64990$var$workInProgressRootRenderLanes & 536870912) || resource !== $e539f33816e64990$var$shellBoundary)) throw $e539f33816e64990$var$suspendedThenable = $e539f33816e64990$var$noopSuspenseyCommitThenable, $e539f33816e64990$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $e539f33816e64990$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $e539f33816e64990$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $e539f33816e64990$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $e539f33816e64990$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$e539f33816e64990$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $e539f33816e64990$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $e539f33816e64990$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $e539f33816e64990$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e539f33816e64990$var$bubbleProperties(workInProgress), null;
        case 1:
            return $e539f33816e64990$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $e539f33816e64990$var$popProvider($e539f33816e64990$var$CacheContext);
            $e539f33816e64990$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $e539f33816e64990$var$popHydrationState(workInProgress) ? $e539f33816e64990$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $e539f33816e64990$var$hydrationErrors && ($e539f33816e64990$var$queueRecoverableErrors($e539f33816e64990$var$hydrationErrors), $e539f33816e64990$var$hydrationErrors = null));
            $e539f33816e64990$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($e539f33816e64990$var$markUpdate(workInProgress), null !== renderLanes ? ($e539f33816e64990$var$bubbleProperties(workInProgress), $e539f33816e64990$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($e539f33816e64990$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($e539f33816e64990$var$markUpdate(workInProgress), $e539f33816e64990$var$bubbleProperties(workInProgress), $e539f33816e64990$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($e539f33816e64990$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $e539f33816e64990$var$markUpdate(workInProgress), $e539f33816e64990$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $e539f33816e64990$var$popHostContext(workInProgress);
            renderLanes = $e539f33816e64990$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e539f33816e64990$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($e539f33816e64990$var$formatProdErrorMessage(166));
                    $e539f33816e64990$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $e539f33816e64990$var$contextStackCursor.current;
                $e539f33816e64990$var$popHydrationState(workInProgress) ? $e539f33816e64990$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $e539f33816e64990$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $e539f33816e64990$var$markUpdate(workInProgress));
            }
            $e539f33816e64990$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $e539f33816e64990$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e539f33816e64990$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($e539f33816e64990$var$formatProdErrorMessage(166));
                    $e539f33816e64990$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $e539f33816e64990$var$contextStackCursor.current;
                if ($e539f33816e64990$var$popHydrationState(workInProgress)) $e539f33816e64990$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $e539f33816e64990$var$getOwnerDocumentFromRootContainer($e539f33816e64990$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$e539f33816e64990$var$internalInstanceKey] = workInProgress;
                    current[$e539f33816e64990$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($e539f33816e64990$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $e539f33816e64990$var$markUpdate(workInProgress);
                }
            }
            $e539f33816e64990$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e539f33816e64990$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($e539f33816e64990$var$formatProdErrorMessage(166));
                current = $e539f33816e64990$var$rootInstanceStackCursor.current;
                if ($e539f33816e64990$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $e539f33816e64990$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$e539f33816e64990$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $e539f33816e64990$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $e539f33816e64990$var$throwOnHydrationMismatch(workInProgress);
                } else current = $e539f33816e64990$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$e539f33816e64990$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $e539f33816e64990$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $e539f33816e64990$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($e539f33816e64990$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($e539f33816e64990$var$formatProdErrorMessage(317));
                        type[$e539f33816e64990$var$internalInstanceKey] = workInProgress;
                    } else $e539f33816e64990$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $e539f33816e64990$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $e539f33816e64990$var$hydrationErrors && ($e539f33816e64990$var$queueRecoverableErrors($e539f33816e64990$var$hydrationErrors), $e539f33816e64990$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $e539f33816e64990$var$popSuspenseHandler(workInProgress), workInProgress;
                    $e539f33816e64990$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $e539f33816e64990$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $e539f33816e64990$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $e539f33816e64990$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $e539f33816e64990$var$popHostContainer(), null === current && $e539f33816e64990$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $e539f33816e64990$var$bubbleProperties(workInProgress), null;
        case 10:
            return $e539f33816e64990$var$popProvider(workInProgress.type), $e539f33816e64990$var$bubbleProperties(workInProgress), null;
        case 19:
            $e539f33816e64990$var$pop($e539f33816e64990$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $e539f33816e64990$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $e539f33816e64990$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $e539f33816e64990$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $e539f33816e64990$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $e539f33816e64990$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $e539f33816e64990$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$e539f33816e64990$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $e539f33816e64990$var$push($e539f33816e64990$var$suspenseStackCursor, $e539f33816e64990$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $e539f33816e64990$var$now() > $e539f33816e64990$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $e539f33816e64990$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $e539f33816e64990$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $e539f33816e64990$var$scheduleRetryEffect(workInProgress, current), $e539f33816e64990$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$e539f33816e64990$var$isHydrating) return $e539f33816e64990$var$bubbleProperties(workInProgress), null;
                    } else 2 * $e539f33816e64990$var$now() - type.renderingStartTime > $e539f33816e64990$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $e539f33816e64990$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $e539f33816e64990$var$now(), workInProgress.sibling = null, current = $e539f33816e64990$var$suspenseStackCursor.current, $e539f33816e64990$var$push($e539f33816e64990$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $e539f33816e64990$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $e539f33816e64990$var$popSuspenseHandler(workInProgress), $e539f33816e64990$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($e539f33816e64990$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $e539f33816e64990$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $e539f33816e64990$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $e539f33816e64990$var$pop($e539f33816e64990$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $e539f33816e64990$var$popProvider($e539f33816e64990$var$CacheContext), $e539f33816e64990$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($e539f33816e64990$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $e539f33816e64990$var$unwindWork(current, workInProgress) {
    $e539f33816e64990$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $e539f33816e64990$var$popProvider($e539f33816e64990$var$CacheContext), $e539f33816e64990$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $e539f33816e64990$var$popHostContext(workInProgress), null;
        case 13:
            $e539f33816e64990$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($e539f33816e64990$var$formatProdErrorMessage(340));
                $e539f33816e64990$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $e539f33816e64990$var$pop($e539f33816e64990$var$suspenseStackCursor), null;
        case 4:
            return $e539f33816e64990$var$popHostContainer(), null;
        case 10:
            return $e539f33816e64990$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $e539f33816e64990$var$popSuspenseHandler(workInProgress), $e539f33816e64990$var$popHiddenContext(), null !== current && $e539f33816e64990$var$pop($e539f33816e64990$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $e539f33816e64990$var$popProvider($e539f33816e64990$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $e539f33816e64990$var$unwindInterruptedWork(current, interruptedWork) {
    $e539f33816e64990$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $e539f33816e64990$var$popProvider($e539f33816e64990$var$CacheContext);
            $e539f33816e64990$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $e539f33816e64990$var$popHostContext(interruptedWork);
            break;
        case 4:
            $e539f33816e64990$var$popHostContainer();
            break;
        case 13:
            $e539f33816e64990$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $e539f33816e64990$var$pop($e539f33816e64990$var$suspenseStackCursor);
            break;
        case 10:
            $e539f33816e64990$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $e539f33816e64990$var$popSuspenseHandler(interruptedWork);
            $e539f33816e64990$var$popHiddenContext();
            null !== current && $e539f33816e64990$var$pop($e539f33816e64990$var$resumedCache);
            break;
        case 24:
            $e539f33816e64990$var$popProvider($e539f33816e64990$var$CacheContext);
    }
}
var $e539f33816e64990$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $e539f33816e64990$var$readContext($e539f33816e64990$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $e539f33816e64990$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $e539f33816e64990$var$executionContext = 0, $e539f33816e64990$var$workInProgressRoot = null, $e539f33816e64990$var$workInProgress = null, $e539f33816e64990$var$workInProgressRootRenderLanes = 0, $e539f33816e64990$var$workInProgressSuspendedReason = 0, $e539f33816e64990$var$workInProgressThrownValue = null, $e539f33816e64990$var$workInProgressRootDidSkipSuspendedSiblings = !1, $e539f33816e64990$var$workInProgressRootIsPrerendering = !1, $e539f33816e64990$var$workInProgressRootDidAttachPingListener = !1, $e539f33816e64990$var$entangledRenderLanes = 0, $e539f33816e64990$var$workInProgressRootExitStatus = 0, $e539f33816e64990$var$workInProgressRootSkippedLanes = 0, $e539f33816e64990$var$workInProgressRootInterleavedUpdatedLanes = 0, $e539f33816e64990$var$workInProgressRootPingedLanes = 0, $e539f33816e64990$var$workInProgressDeferredLane = 0, $e539f33816e64990$var$workInProgressSuspendedRetryLanes = 0, $e539f33816e64990$var$workInProgressRootConcurrentErrors = null, $e539f33816e64990$var$workInProgressRootRecoverableErrors = null, $e539f33816e64990$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $e539f33816e64990$var$globalMostRecentFallbackTime = 0, $e539f33816e64990$var$workInProgressRootRenderTargetTime = Infinity, $e539f33816e64990$var$workInProgressTransitions = null, $e539f33816e64990$var$legacyErrorBoundariesThatAlreadyFailed = null, $e539f33816e64990$var$rootDoesHavePassiveEffects = !1, $e539f33816e64990$var$rootWithPendingPassiveEffects = null, $e539f33816e64990$var$pendingPassiveEffectsLanes = 0, $e539f33816e64990$var$pendingPassiveEffectsRemainingLanes = 0, $e539f33816e64990$var$pendingPassiveTransitions = null, $e539f33816e64990$var$nestedUpdateCount = 0, $e539f33816e64990$var$rootWithNestedUpdates = null;
function $e539f33816e64990$var$requestUpdateLane() {
    if (0 !== ($e539f33816e64990$var$executionContext & 2) && 0 !== $e539f33816e64990$var$workInProgressRootRenderLanes) return $e539f33816e64990$var$workInProgressRootRenderLanes & -$e539f33816e64990$var$workInProgressRootRenderLanes;
    if (null !== $e539f33816e64990$var$ReactSharedInternals.T) {
        var actionScopeLane = $e539f33816e64990$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $e539f33816e64990$var$requestTransitionLane();
    }
    return $e539f33816e64990$var$resolveUpdatePriority();
}
function $e539f33816e64990$var$requestDeferredLane() {
    0 === $e539f33816e64990$var$workInProgressDeferredLane && ($e539f33816e64990$var$workInProgressDeferredLane = 0 === ($e539f33816e64990$var$workInProgressRootRenderLanes & 536870912) || $e539f33816e64990$var$isHydrating ? $e539f33816e64990$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $e539f33816e64990$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $e539f33816e64990$var$workInProgressDeferredLane;
}
function $e539f33816e64990$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $e539f33816e64990$var$workInProgressRoot && 2 === $e539f33816e64990$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $e539f33816e64990$var$prepareFreshStack(root, 0), $e539f33816e64990$var$markRootSuspended(root, $e539f33816e64990$var$workInProgressRootRenderLanes, $e539f33816e64990$var$workInProgressDeferredLane, !1);
    $e539f33816e64990$var$markRootUpdated$1(root, lane);
    if (0 === ($e539f33816e64990$var$executionContext & 2) || root !== $e539f33816e64990$var$workInProgressRoot) root === $e539f33816e64990$var$workInProgressRoot && (0 === ($e539f33816e64990$var$executionContext & 2) && ($e539f33816e64990$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $e539f33816e64990$var$workInProgressRootExitStatus && $e539f33816e64990$var$markRootSuspended(root, $e539f33816e64990$var$workInProgressRootRenderLanes, $e539f33816e64990$var$workInProgressDeferredLane, !1)), $e539f33816e64990$var$ensureRootIsScheduled(root);
}
function $e539f33816e64990$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($e539f33816e64990$var$executionContext & 6)) throw Error($e539f33816e64990$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $e539f33816e64990$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $e539f33816e64990$var$renderRootConcurrent(root$jscomp$0, lanes) : $e539f33816e64990$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $e539f33816e64990$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $e539f33816e64990$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $e539f33816e64990$var$markRootSuspended(root$jscomp$0, lanes, 0, !$e539f33816e64990$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$e539f33816e64990$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $e539f33816e64990$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $e539f33816e64990$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($e539f33816e64990$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $e539f33816e64990$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($e539f33816e64990$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $e539f33816e64990$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $e539f33816e64990$var$workInProgressRootRecoverableErrors;
                            $e539f33816e64990$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $e539f33816e64990$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $e539f33816e64990$var$prepareFreshStack(root$jscomp$0, 0);
                $e539f33816e64990$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($e539f33816e64990$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $e539f33816e64990$var$markRootSuspended(shouldTimeSlice, lanes, $e539f33816e64990$var$workInProgressDeferredLane, !$e539f33816e64990$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $e539f33816e64990$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($e539f33816e64990$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $e539f33816e64990$var$globalMostRecentFallbackTime + 300 - $e539f33816e64990$var$now(), 10 < renderWasConcurrent)) {
                    $e539f33816e64990$var$markRootSuspended(shouldTimeSlice, lanes, $e539f33816e64990$var$workInProgressDeferredLane, !$e539f33816e64990$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $e539f33816e64990$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $e539f33816e64990$var$scheduleTimeout($e539f33816e64990$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $e539f33816e64990$var$workInProgressRootRecoverableErrors, $e539f33816e64990$var$workInProgressTransitions, $e539f33816e64990$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $e539f33816e64990$var$workInProgressDeferredLane, $e539f33816e64990$var$workInProgressRootInterleavedUpdatedLanes, $e539f33816e64990$var$workInProgressSuspendedRetryLanes, $e539f33816e64990$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $e539f33816e64990$var$commitRootWhenReady(shouldTimeSlice, forceSync, $e539f33816e64990$var$workInProgressRootRecoverableErrors, $e539f33816e64990$var$workInProgressTransitions, $e539f33816e64990$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $e539f33816e64990$var$workInProgressDeferredLane, $e539f33816e64990$var$workInProgressRootInterleavedUpdatedLanes, $e539f33816e64990$var$workInProgressSuspendedRetryLanes, $e539f33816e64990$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $e539f33816e64990$var$ensureRootIsScheduled(root$jscomp$0);
}
function $e539f33816e64990$var$queueRecoverableErrors(errors) {
    null === $e539f33816e64990$var$workInProgressRootRecoverableErrors ? $e539f33816e64990$var$workInProgressRootRecoverableErrors = errors : $e539f33816e64990$var$workInProgressRootRecoverableErrors.push.apply($e539f33816e64990$var$workInProgressRootRecoverableErrors, errors);
}
function $e539f33816e64990$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($e539f33816e64990$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $e539f33816e64990$var$noop
        }, $e539f33816e64990$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $e539f33816e64990$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($e539f33816e64990$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $e539f33816e64990$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $e539f33816e64990$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $e539f33816e64990$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$e539f33816e64990$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $e539f33816e64990$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$e539f33816e64990$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$e539f33816e64990$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $e539f33816e64990$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $e539f33816e64990$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $e539f33816e64990$var$flushSyncWork$1() {
    return 0 === ($e539f33816e64990$var$executionContext & 6) ? ($e539f33816e64990$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $e539f33816e64990$var$resetWorkInProgressStack() {
    if (null !== $e539f33816e64990$var$workInProgress) {
        if (0 === $e539f33816e64990$var$workInProgressSuspendedReason) var interruptedWork = $e539f33816e64990$var$workInProgress.return;
        else interruptedWork = $e539f33816e64990$var$workInProgress, $e539f33816e64990$var$lastContextDependency = $e539f33816e64990$var$currentlyRenderingFiber = null, $e539f33816e64990$var$resetHooksOnUnwind(interruptedWork), $e539f33816e64990$var$thenableState$1 = null, $e539f33816e64990$var$thenableIndexCounter$1 = 0, interruptedWork = $e539f33816e64990$var$workInProgress;
        for(; null !== interruptedWork;)$e539f33816e64990$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $e539f33816e64990$var$workInProgress = null;
    }
}
function $e539f33816e64990$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $e539f33816e64990$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $e539f33816e64990$var$resetWorkInProgressStack();
    $e539f33816e64990$var$workInProgressRoot = root;
    $e539f33816e64990$var$workInProgress = timeoutHandle = $e539f33816e64990$var$createWorkInProgress(root.current, null);
    $e539f33816e64990$var$workInProgressRootRenderLanes = lanes;
    $e539f33816e64990$var$workInProgressSuspendedReason = 0;
    $e539f33816e64990$var$workInProgressThrownValue = null;
    $e539f33816e64990$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $e539f33816e64990$var$workInProgressRootIsPrerendering = $e539f33816e64990$var$checkIfRootIsPrerendering(root, lanes);
    $e539f33816e64990$var$workInProgressRootDidAttachPingListener = !1;
    $e539f33816e64990$var$workInProgressSuspendedRetryLanes = $e539f33816e64990$var$workInProgressDeferredLane = $e539f33816e64990$var$workInProgressRootPingedLanes = $e539f33816e64990$var$workInProgressRootInterleavedUpdatedLanes = $e539f33816e64990$var$workInProgressRootSkippedLanes = $e539f33816e64990$var$workInProgressRootExitStatus = 0;
    $e539f33816e64990$var$workInProgressRootRecoverableErrors = $e539f33816e64990$var$workInProgressRootConcurrentErrors = null;
    $e539f33816e64990$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $e539f33816e64990$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $e539f33816e64990$var$entangledRenderLanes = lanes;
    $e539f33816e64990$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $e539f33816e64990$var$handleThrow(root, thrownValue) {
    $e539f33816e64990$var$currentlyRenderingFiber$1 = null;
    $e539f33816e64990$var$ReactSharedInternals.H = $e539f33816e64990$var$ContextOnlyDispatcher;
    thrownValue === $e539f33816e64990$var$SuspenseException ? (thrownValue = $e539f33816e64990$var$getSuspendedThenable(), $e539f33816e64990$var$workInProgressSuspendedReason = 3) : thrownValue === $e539f33816e64990$var$SuspenseyCommitException ? (thrownValue = $e539f33816e64990$var$getSuspendedThenable(), $e539f33816e64990$var$workInProgressSuspendedReason = 4) : $e539f33816e64990$var$workInProgressSuspendedReason = thrownValue === $e539f33816e64990$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $e539f33816e64990$var$workInProgressThrownValue = thrownValue;
    null === $e539f33816e64990$var$workInProgress && ($e539f33816e64990$var$workInProgressRootExitStatus = 1, $e539f33816e64990$var$logUncaughtError(root, $e539f33816e64990$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $e539f33816e64990$var$pushDispatcher() {
    var prevDispatcher = $e539f33816e64990$var$ReactSharedInternals.H;
    $e539f33816e64990$var$ReactSharedInternals.H = $e539f33816e64990$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $e539f33816e64990$var$ContextOnlyDispatcher : prevDispatcher;
}
function $e539f33816e64990$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $e539f33816e64990$var$ReactSharedInternals.A;
    $e539f33816e64990$var$ReactSharedInternals.A = $e539f33816e64990$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $e539f33816e64990$var$renderDidSuspendDelayIfPossible() {
    $e539f33816e64990$var$workInProgressRootExitStatus = 4;
    $e539f33816e64990$var$workInProgressRootDidSkipSuspendedSiblings || ($e539f33816e64990$var$workInProgressRootRenderLanes & 4194176) !== $e539f33816e64990$var$workInProgressRootRenderLanes && null !== $e539f33816e64990$var$suspenseHandlerStackCursor.current || ($e539f33816e64990$var$workInProgressRootIsPrerendering = !0);
    0 === ($e539f33816e64990$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($e539f33816e64990$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $e539f33816e64990$var$workInProgressRoot || $e539f33816e64990$var$markRootSuspended($e539f33816e64990$var$workInProgressRoot, $e539f33816e64990$var$workInProgressRootRenderLanes, $e539f33816e64990$var$workInProgressDeferredLane, !1);
}
function $e539f33816e64990$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $e539f33816e64990$var$executionContext;
    $e539f33816e64990$var$executionContext |= 2;
    var prevDispatcher = $e539f33816e64990$var$pushDispatcher(), prevAsyncDispatcher = $e539f33816e64990$var$pushAsyncDispatcher();
    if ($e539f33816e64990$var$workInProgressRoot !== root || $e539f33816e64990$var$workInProgressRootRenderLanes !== lanes) $e539f33816e64990$var$workInProgressTransitions = null, $e539f33816e64990$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $e539f33816e64990$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $e539f33816e64990$var$workInProgressSuspendedReason && null !== $e539f33816e64990$var$workInProgress) {
            var unitOfWork = $e539f33816e64990$var$workInProgress, thrownValue = $e539f33816e64990$var$workInProgressThrownValue;
            switch($e539f33816e64990$var$workInProgressSuspendedReason){
                case 8:
                    $e539f33816e64990$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $e539f33816e64990$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $e539f33816e64990$var$workInProgressSuspendedReason;
                    $e539f33816e64990$var$workInProgressSuspendedReason = 0;
                    $e539f33816e64990$var$workInProgressThrownValue = null;
                    $e539f33816e64990$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $e539f33816e64990$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $e539f33816e64990$var$workInProgressSuspendedReason, $e539f33816e64990$var$workInProgressSuspendedReason = 0, $e539f33816e64990$var$workInProgressThrownValue = null, $e539f33816e64990$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $e539f33816e64990$var$workLoopSync();
        exitStatus = $e539f33816e64990$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $e539f33816e64990$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $e539f33816e64990$var$lastContextDependency = $e539f33816e64990$var$currentlyRenderingFiber = null;
    $e539f33816e64990$var$executionContext = prevExecutionContext;
    $e539f33816e64990$var$ReactSharedInternals.H = prevDispatcher;
    $e539f33816e64990$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $e539f33816e64990$var$workInProgress && ($e539f33816e64990$var$workInProgressRoot = null, $e539f33816e64990$var$workInProgressRootRenderLanes = 0, $e539f33816e64990$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $e539f33816e64990$var$workLoopSync() {
    for(; null !== $e539f33816e64990$var$workInProgress;)$e539f33816e64990$var$performUnitOfWork($e539f33816e64990$var$workInProgress);
}
function $e539f33816e64990$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $e539f33816e64990$var$executionContext;
    $e539f33816e64990$var$executionContext |= 2;
    var prevDispatcher = $e539f33816e64990$var$pushDispatcher(), prevAsyncDispatcher = $e539f33816e64990$var$pushAsyncDispatcher();
    $e539f33816e64990$var$workInProgressRoot !== root || $e539f33816e64990$var$workInProgressRootRenderLanes !== lanes ? ($e539f33816e64990$var$workInProgressTransitions = null, $e539f33816e64990$var$workInProgressRootRenderTargetTime = $e539f33816e64990$var$now() + 500, $e539f33816e64990$var$prepareFreshStack(root, lanes)) : $e539f33816e64990$var$workInProgressRootIsPrerendering = $e539f33816e64990$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $e539f33816e64990$var$workInProgressSuspendedReason && null !== $e539f33816e64990$var$workInProgress) {
            lanes = $e539f33816e64990$var$workInProgress;
            var thrownValue = $e539f33816e64990$var$workInProgressThrownValue;
            b: switch($e539f33816e64990$var$workInProgressSuspendedReason){
                case 1:
                    $e539f33816e64990$var$workInProgressSuspendedReason = 0;
                    $e539f33816e64990$var$workInProgressThrownValue = null;
                    $e539f33816e64990$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($e539f33816e64990$var$isThenableResolved(thrownValue)) {
                        $e539f33816e64990$var$workInProgressSuspendedReason = 0;
                        $e539f33816e64990$var$workInProgressThrownValue = null;
                        $e539f33816e64990$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $e539f33816e64990$var$workInProgressSuspendedReason && $e539f33816e64990$var$workInProgressRoot === root && ($e539f33816e64990$var$workInProgressSuspendedReason = 7);
                        $e539f33816e64990$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $e539f33816e64990$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $e539f33816e64990$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $e539f33816e64990$var$isThenableResolved(thrownValue) ? ($e539f33816e64990$var$workInProgressSuspendedReason = 0, $e539f33816e64990$var$workInProgressThrownValue = null, $e539f33816e64990$var$replaySuspendedUnitOfWork(lanes)) : ($e539f33816e64990$var$workInProgressSuspendedReason = 0, $e539f33816e64990$var$workInProgressThrownValue = null, $e539f33816e64990$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($e539f33816e64990$var$workInProgress.tag){
                        case 26:
                            resource = $e539f33816e64990$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $e539f33816e64990$var$workInProgress;
                            if (resource ? $e539f33816e64990$var$preloadResource(resource) : 1) {
                                $e539f33816e64990$var$workInProgressSuspendedReason = 0;
                                $e539f33816e64990$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $e539f33816e64990$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($e539f33816e64990$var$workInProgress = returnFiber, $e539f33816e64990$var$completeUnitOfWork(returnFiber)) : $e539f33816e64990$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $e539f33816e64990$var$workInProgressSuspendedReason = 0;
                    $e539f33816e64990$var$workInProgressThrownValue = null;
                    $e539f33816e64990$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $e539f33816e64990$var$workInProgressSuspendedReason = 0;
                    $e539f33816e64990$var$workInProgressThrownValue = null;
                    $e539f33816e64990$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $e539f33816e64990$var$resetWorkInProgressStack();
                    $e539f33816e64990$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($e539f33816e64990$var$formatProdErrorMessage(462));
            }
        }
        $e539f33816e64990$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $e539f33816e64990$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $e539f33816e64990$var$lastContextDependency = $e539f33816e64990$var$currentlyRenderingFiber = null;
    $e539f33816e64990$var$ReactSharedInternals.H = prevDispatcher;
    $e539f33816e64990$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $e539f33816e64990$var$executionContext = prevExecutionContext;
    if (null !== $e539f33816e64990$var$workInProgress) return 0;
    $e539f33816e64990$var$workInProgressRoot = null;
    $e539f33816e64990$var$workInProgressRootRenderLanes = 0;
    $e539f33816e64990$var$finishQueueingConcurrentUpdates();
    return $e539f33816e64990$var$workInProgressRootExitStatus;
}
function $e539f33816e64990$var$workLoopConcurrent() {
    for(; null !== $e539f33816e64990$var$workInProgress && !$e539f33816e64990$var$shouldYield();)$e539f33816e64990$var$performUnitOfWork($e539f33816e64990$var$workInProgress);
}
function $e539f33816e64990$var$performUnitOfWork(unitOfWork) {
    var next = $e539f33816e64990$var$beginWork(unitOfWork.alternate, unitOfWork, $e539f33816e64990$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $e539f33816e64990$var$completeUnitOfWork(unitOfWork) : $e539f33816e64990$var$workInProgress = next;
}
function $e539f33816e64990$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $e539f33816e64990$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $e539f33816e64990$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $e539f33816e64990$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $e539f33816e64990$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $e539f33816e64990$var$resetHooksOnUnwind(next);
        default:
            $e539f33816e64990$var$unwindInterruptedWork(current, next), next = $e539f33816e64990$var$workInProgress = $e539f33816e64990$var$resetWorkInProgress(next, $e539f33816e64990$var$entangledRenderLanes), next = $e539f33816e64990$var$beginWork(current, next, $e539f33816e64990$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $e539f33816e64990$var$completeUnitOfWork(unitOfWork) : $e539f33816e64990$var$workInProgress = next;
}
function $e539f33816e64990$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $e539f33816e64990$var$lastContextDependency = $e539f33816e64990$var$currentlyRenderingFiber = null;
    $e539f33816e64990$var$resetHooksOnUnwind(unitOfWork);
    $e539f33816e64990$var$thenableState$1 = null;
    $e539f33816e64990$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($e539f33816e64990$var$throwException(root, returnFiber, unitOfWork, thrownValue, $e539f33816e64990$var$workInProgressRootRenderLanes)) {
            $e539f33816e64990$var$workInProgressRootExitStatus = 1;
            $e539f33816e64990$var$logUncaughtError(root, $e539f33816e64990$var$createCapturedValueAtFiber(thrownValue, root.current));
            $e539f33816e64990$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $e539f33816e64990$var$workInProgress = returnFiber, error;
        $e539f33816e64990$var$workInProgressRootExitStatus = 1;
        $e539f33816e64990$var$logUncaughtError(root, $e539f33816e64990$var$createCapturedValueAtFiber(thrownValue, root.current));
        $e539f33816e64990$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($e539f33816e64990$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($e539f33816e64990$var$workInProgressRootIsPrerendering || 0 !== ($e539f33816e64990$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($e539f33816e64990$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $e539f33816e64990$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $e539f33816e64990$var$unwindUnitOfWork(unitOfWork, root);
    } else $e539f33816e64990$var$completeUnitOfWork(unitOfWork);
}
function $e539f33816e64990$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $e539f33816e64990$var$unwindUnitOfWork(completedWork, $e539f33816e64990$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $e539f33816e64990$var$completeWork(completedWork.alternate, completedWork, $e539f33816e64990$var$entangledRenderLanes);
        if (null !== next) {
            $e539f33816e64990$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $e539f33816e64990$var$workInProgress = completedWork;
            return;
        }
        $e539f33816e64990$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $e539f33816e64990$var$workInProgressRootExitStatus && ($e539f33816e64990$var$workInProgressRootExitStatus = 5);
}
function $e539f33816e64990$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $e539f33816e64990$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $e539f33816e64990$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $e539f33816e64990$var$workInProgress = unitOfWork;
            return;
        }
        $e539f33816e64990$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $e539f33816e64990$var$workInProgressRootExitStatus = 6;
    $e539f33816e64990$var$workInProgress = null;
}
function $e539f33816e64990$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $e539f33816e64990$var$ReactSharedInternals.T, previousUpdateLanePriority = $e539f33816e64990$var$ReactDOMSharedInternals.p;
    try {
        $e539f33816e64990$var$ReactDOMSharedInternals.p = 2, $e539f33816e64990$var$ReactSharedInternals.T = null, $e539f33816e64990$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $e539f33816e64990$var$ReactSharedInternals.T = prevTransition, $e539f33816e64990$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $e539f33816e64990$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $e539f33816e64990$var$flushPassiveEffects();
    while (null !== $e539f33816e64990$var$rootWithPendingPassiveEffects);
    if (0 !== ($e539f33816e64990$var$executionContext & 6)) throw Error($e539f33816e64990$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($e539f33816e64990$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $e539f33816e64990$var$concurrentlyUpdatedLanes;
    $e539f33816e64990$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $e539f33816e64990$var$workInProgressRoot && ($e539f33816e64990$var$workInProgress = $e539f33816e64990$var$workInProgressRoot = null, $e539f33816e64990$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $e539f33816e64990$var$rootDoesHavePassiveEffects || ($e539f33816e64990$var$rootDoesHavePassiveEffects = !0, $e539f33816e64990$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $e539f33816e64990$var$pendingPassiveTransitions = transitions, $e539f33816e64990$var$scheduleCallback$1($e539f33816e64990$var$NormalPriority$1, function() {
        $e539f33816e64990$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $e539f33816e64990$var$ReactSharedInternals.T, $e539f33816e64990$var$ReactSharedInternals.T = null, spawnedLane = $e539f33816e64990$var$ReactDOMSharedInternals.p, $e539f33816e64990$var$ReactDOMSharedInternals.p = 2, updatedLanes = $e539f33816e64990$var$executionContext, $e539f33816e64990$var$executionContext |= 4, $e539f33816e64990$var$commitBeforeMutationEffects(root, finishedWork), $e539f33816e64990$var$commitMutationEffectsOnFiber(finishedWork, root), $e539f33816e64990$var$restoreSelection($e539f33816e64990$var$selectionInformation, root.containerInfo), $e539f33816e64990$var$_enabled = !!$e539f33816e64990$var$eventsEnabled, $e539f33816e64990$var$selectionInformation = $e539f33816e64990$var$eventsEnabled = null, root.current = finishedWork, $e539f33816e64990$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $e539f33816e64990$var$requestPaint(), $e539f33816e64990$var$executionContext = updatedLanes, $e539f33816e64990$var$ReactDOMSharedInternals.p = spawnedLane, $e539f33816e64990$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $e539f33816e64990$var$rootDoesHavePassiveEffects ? ($e539f33816e64990$var$rootDoesHavePassiveEffects = !1, $e539f33816e64990$var$rootWithPendingPassiveEffects = root, $e539f33816e64990$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $e539f33816e64990$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($e539f33816e64990$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $e539f33816e64990$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $e539f33816e64990$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($e539f33816e64990$var$pendingPassiveEffectsLanes & 3) && $e539f33816e64990$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $e539f33816e64990$var$rootWithNestedUpdates ? $e539f33816e64990$var$nestedUpdateCount++ : ($e539f33816e64990$var$nestedUpdateCount = 0, $e539f33816e64990$var$rootWithNestedUpdates = root) : $e539f33816e64990$var$nestedUpdateCount = 0;
    $e539f33816e64990$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $e539f33816e64990$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $e539f33816e64990$var$releaseCache(remainingLanes)));
}
function $e539f33816e64990$var$flushPassiveEffects() {
    if (null !== $e539f33816e64990$var$rootWithPendingPassiveEffects) {
        var root$170 = $e539f33816e64990$var$rootWithPendingPassiveEffects, remainingLanes = $e539f33816e64990$var$pendingPassiveEffectsRemainingLanes;
        $e539f33816e64990$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $e539f33816e64990$var$lanesToEventPriority($e539f33816e64990$var$pendingPassiveEffectsLanes), prevTransition = $e539f33816e64990$var$ReactSharedInternals.T, previousPriority = $e539f33816e64990$var$ReactDOMSharedInternals.p;
        try {
            $e539f33816e64990$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $e539f33816e64990$var$ReactSharedInternals.T = null;
            if (null === $e539f33816e64990$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $e539f33816e64990$var$pendingPassiveTransitions;
                $e539f33816e64990$var$pendingPassiveTransitions = null;
                var root = $e539f33816e64990$var$rootWithPendingPassiveEffects, lanes = $e539f33816e64990$var$pendingPassiveEffectsLanes;
                $e539f33816e64990$var$rootWithPendingPassiveEffects = null;
                $e539f33816e64990$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($e539f33816e64990$var$executionContext & 6)) throw Error($e539f33816e64990$var$formatProdErrorMessage(331));
                var prevExecutionContext = $e539f33816e64990$var$executionContext;
                $e539f33816e64990$var$executionContext |= 4;
                $e539f33816e64990$var$commitPassiveUnmountOnFiber(root.current);
                $e539f33816e64990$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $e539f33816e64990$var$executionContext = prevExecutionContext;
                $e539f33816e64990$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($e539f33816e64990$var$injectedHook && "function" === typeof $e539f33816e64990$var$injectedHook.onPostCommitFiberRoot) try {
                    $e539f33816e64990$var$injectedHook.onPostCommitFiberRoot($e539f33816e64990$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $e539f33816e64990$var$ReactDOMSharedInternals.p = previousPriority, $e539f33816e64990$var$ReactSharedInternals.T = prevTransition, $e539f33816e64990$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $e539f33816e64990$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $e539f33816e64990$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $e539f33816e64990$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $e539f33816e64990$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($e539f33816e64990$var$markRootUpdated$1(rootFiber, 2), $e539f33816e64990$var$ensureRootIsScheduled(rootFiber));
}
function $e539f33816e64990$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $e539f33816e64990$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $e539f33816e64990$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $e539f33816e64990$var$legacyErrorBoundariesThatAlreadyFailed || !$e539f33816e64990$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $e539f33816e64990$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $e539f33816e64990$var$createClassErrorUpdate(2);
                instance = $e539f33816e64990$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($e539f33816e64990$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $e539f33816e64990$var$markRootUpdated$1(instance, 2), $e539f33816e64990$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $e539f33816e64990$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $e539f33816e64990$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($e539f33816e64990$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $e539f33816e64990$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $e539f33816e64990$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $e539f33816e64990$var$workInProgressRoot === root && ($e539f33816e64990$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $e539f33816e64990$var$workInProgressRootExitStatus || 3 === $e539f33816e64990$var$workInProgressRootExitStatus && ($e539f33816e64990$var$workInProgressRootRenderLanes & 62914560) === $e539f33816e64990$var$workInProgressRootRenderLanes && 300 > $e539f33816e64990$var$now() - $e539f33816e64990$var$globalMostRecentFallbackTime ? 0 === ($e539f33816e64990$var$executionContext & 2) && $e539f33816e64990$var$prepareFreshStack(root, 0) : $e539f33816e64990$var$workInProgressRootPingedLanes |= pingedLanes, $e539f33816e64990$var$workInProgressSuspendedRetryLanes === $e539f33816e64990$var$workInProgressRootRenderLanes && ($e539f33816e64990$var$workInProgressSuspendedRetryLanes = 0));
    $e539f33816e64990$var$ensureRootIsScheduled(root);
}
function $e539f33816e64990$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $e539f33816e64990$var$claimNextRetryLane());
    boundaryFiber = $e539f33816e64990$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($e539f33816e64990$var$markRootUpdated$1(boundaryFiber, retryLane), $e539f33816e64990$var$ensureRootIsScheduled(boundaryFiber));
}
function $e539f33816e64990$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $e539f33816e64990$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $e539f33816e64990$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($e539f33816e64990$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $e539f33816e64990$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $e539f33816e64990$var$scheduleCallback$1(priorityLevel, callback) {
    return $e539f33816e64990$var$scheduleCallback$3(priorityLevel, callback);
}
var $e539f33816e64990$var$firstScheduledRoot = null, $e539f33816e64990$var$lastScheduledRoot = null, $e539f33816e64990$var$didScheduleMicrotask = !1, $e539f33816e64990$var$mightHavePendingSyncWork = !1, $e539f33816e64990$var$isFlushingWork = !1, $e539f33816e64990$var$currentEventTransitionLane = 0;
function $e539f33816e64990$var$ensureRootIsScheduled(root) {
    root !== $e539f33816e64990$var$lastScheduledRoot && null === root.next && (null === $e539f33816e64990$var$lastScheduledRoot ? $e539f33816e64990$var$firstScheduledRoot = $e539f33816e64990$var$lastScheduledRoot = root : $e539f33816e64990$var$lastScheduledRoot = $e539f33816e64990$var$lastScheduledRoot.next = root);
    $e539f33816e64990$var$mightHavePendingSyncWork = !0;
    $e539f33816e64990$var$didScheduleMicrotask || ($e539f33816e64990$var$didScheduleMicrotask = !0, $e539f33816e64990$var$scheduleImmediateTask($e539f33816e64990$var$processRootScheduleInMicrotask));
}
function $e539f33816e64990$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$e539f33816e64990$var$isFlushingWork && $e539f33816e64990$var$mightHavePendingSyncWork) {
        $e539f33816e64990$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $e539f33816e64990$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $e539f33816e64990$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $e539f33816e64990$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $e539f33816e64990$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $e539f33816e64990$var$getNextLanes(root$172, root$172 === $e539f33816e64990$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $e539f33816e64990$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $e539f33816e64990$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $e539f33816e64990$var$isFlushingWork = !1;
    }
}
function $e539f33816e64990$var$processRootScheduleInMicrotask() {
    $e539f33816e64990$var$mightHavePendingSyncWork = $e539f33816e64990$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $e539f33816e64990$var$currentEventTransitionLane && ($e539f33816e64990$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $e539f33816e64990$var$currentEventTransitionLane), $e539f33816e64990$var$currentEventTransitionLane = 0);
    for(var currentTime = $e539f33816e64990$var$now(), prev = null, root = $e539f33816e64990$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $e539f33816e64990$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $e539f33816e64990$var$firstScheduledRoot = next : prev.next = next, null === next && ($e539f33816e64990$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $e539f33816e64990$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $e539f33816e64990$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $e539f33816e64990$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $e539f33816e64990$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $e539f33816e64990$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $e539f33816e64990$var$workInProgressRoot;
    suspendedLanes = $e539f33816e64990$var$workInProgressRootRenderLanes;
    suspendedLanes = $e539f33816e64990$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $e539f33816e64990$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $e539f33816e64990$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $e539f33816e64990$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $e539f33816e64990$var$cancelCallback$1(pingedLanes);
        switch($e539f33816e64990$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $e539f33816e64990$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $e539f33816e64990$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $e539f33816e64990$var$IdlePriority;
                break;
            default:
                suspendedLanes = $e539f33816e64990$var$NormalPriority$1;
        }
        pingedLanes = $e539f33816e64990$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $e539f33816e64990$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $e539f33816e64990$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $e539f33816e64990$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($e539f33816e64990$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $e539f33816e64990$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $e539f33816e64990$var$getNextLanes(root, root === $e539f33816e64990$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $e539f33816e64990$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $e539f33816e64990$var$scheduleTaskForRootDuringMicrotask(root, $e539f33816e64990$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $e539f33816e64990$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $e539f33816e64990$var$performSyncWorkOnRoot(root, lanes) {
    if ($e539f33816e64990$var$flushPassiveEffects()) return null;
    $e539f33816e64990$var$performWorkOnRoot(root, lanes, !0);
}
function $e539f33816e64990$var$scheduleImmediateTask(cb) {
    $e539f33816e64990$var$scheduleMicrotask(function() {
        0 !== ($e539f33816e64990$var$executionContext & 6) ? $e539f33816e64990$var$scheduleCallback$3($e539f33816e64990$var$ImmediatePriority, cb) : cb();
    });
}
function $e539f33816e64990$var$requestTransitionLane() {
    0 === $e539f33816e64990$var$currentEventTransitionLane && ($e539f33816e64990$var$currentEventTransitionLane = $e539f33816e64990$var$claimNextTransitionLane());
    return $e539f33816e64990$var$currentEventTransitionLane;
}
function $e539f33816e64990$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $e539f33816e64990$var$sanitizeURL("" + actionProp);
}
function $e539f33816e64990$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $e539f33816e64990$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $e539f33816e64990$var$coerceFormActionProp((nativeEventTarget[$e539f33816e64990$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$e539f33816e64990$var$internalPropsKey] || null) ? $e539f33816e64990$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $e539f33816e64990$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $e539f33816e64990$var$currentEventTransitionLane) {
                                var formData = submitter ? $e539f33816e64990$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $e539f33816e64990$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $e539f33816e64990$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $e539f33816e64990$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $e539f33816e64990$var$i$jscomp$inline_1439 = 0; $e539f33816e64990$var$i$jscomp$inline_1439 < $e539f33816e64990$var$simpleEventPluginEvents.length; $e539f33816e64990$var$i$jscomp$inline_1439++){
    var $e539f33816e64990$var$eventName$jscomp$inline_1440 = $e539f33816e64990$var$simpleEventPluginEvents[$e539f33816e64990$var$i$jscomp$inline_1439], $e539f33816e64990$var$domEventName$jscomp$inline_1441 = $e539f33816e64990$var$eventName$jscomp$inline_1440.toLowerCase(), $e539f33816e64990$var$capitalizedEvent$jscomp$inline_1442 = $e539f33816e64990$var$eventName$jscomp$inline_1440[0].toUpperCase() + $e539f33816e64990$var$eventName$jscomp$inline_1440.slice(1);
    $e539f33816e64990$var$registerSimpleEvent($e539f33816e64990$var$domEventName$jscomp$inline_1441, "on" + $e539f33816e64990$var$capitalizedEvent$jscomp$inline_1442);
}
$e539f33816e64990$var$registerSimpleEvent($e539f33816e64990$var$ANIMATION_END, "onAnimationEnd");
$e539f33816e64990$var$registerSimpleEvent($e539f33816e64990$var$ANIMATION_ITERATION, "onAnimationIteration");
$e539f33816e64990$var$registerSimpleEvent($e539f33816e64990$var$ANIMATION_START, "onAnimationStart");
$e539f33816e64990$var$registerSimpleEvent("dblclick", "onDoubleClick");
$e539f33816e64990$var$registerSimpleEvent("focusin", "onFocus");
$e539f33816e64990$var$registerSimpleEvent("focusout", "onBlur");
$e539f33816e64990$var$registerSimpleEvent($e539f33816e64990$var$TRANSITION_RUN, "onTransitionRun");
$e539f33816e64990$var$registerSimpleEvent($e539f33816e64990$var$TRANSITION_START, "onTransitionStart");
$e539f33816e64990$var$registerSimpleEvent($e539f33816e64990$var$TRANSITION_CANCEL, "onTransitionCancel");
$e539f33816e64990$var$registerSimpleEvent($e539f33816e64990$var$TRANSITION_END, "onTransitionEnd");
$e539f33816e64990$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e539f33816e64990$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e539f33816e64990$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e539f33816e64990$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e539f33816e64990$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e539f33816e64990$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e539f33816e64990$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e539f33816e64990$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e539f33816e64990$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e539f33816e64990$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e539f33816e64990$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e539f33816e64990$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($e539f33816e64990$var$mediaEventTypes));
function $e539f33816e64990$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $e539f33816e64990$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $e539f33816e64990$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $e539f33816e64990$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$e539f33816e64990$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$e539f33816e64990$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($e539f33816e64990$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $e539f33816e64990$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $e539f33816e64990$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $e539f33816e64990$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $e539f33816e64990$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$e539f33816e64990$var$listeningMarker]) {
        rootContainerElement[$e539f33816e64990$var$listeningMarker] = !0;
        $e539f33816e64990$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($e539f33816e64990$var$nonDelegatedEvents.has(domEventName) || $e539f33816e64990$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $e539f33816e64990$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$e539f33816e64990$var$listeningMarker] || (ownerDocument[$e539f33816e64990$var$listeningMarker] = !0, $e539f33816e64990$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $e539f33816e64990$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($e539f33816e64990$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $e539f33816e64990$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $e539f33816e64990$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $e539f33816e64990$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$e539f33816e64990$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $e539f33816e64990$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $e539f33816e64990$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $e539f33816e64990$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $e539f33816e64990$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $e539f33816e64990$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $e539f33816e64990$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $e539f33816e64990$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticTouchEvent;
                        break;
                    case $e539f33816e64990$var$ANIMATION_END:
                    case $e539f33816e64990$var$ANIMATION_ITERATION:
                    case $e539f33816e64990$var$ANIMATION_START:
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticAnimationEvent;
                        break;
                    case $e539f33816e64990$var$TRANSITION_END:
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $e539f33816e64990$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $e539f33816e64990$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($e539f33816e64990$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $e539f33816e64990$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($e539f33816e64990$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$e539f33816e64990$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $e539f33816e64990$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $e539f33816e64990$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $e539f33816e64990$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $e539f33816e64990$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $e539f33816e64990$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $e539f33816e64990$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $e539f33816e64990$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $e539f33816e64990$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $e539f33816e64990$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $e539f33816e64990$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $e539f33816e64990$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $e539f33816e64990$var$getParent(inCapturePhase);
                                reactEventName = $e539f33816e64990$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $e539f33816e64990$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $e539f33816e64990$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $e539f33816e64990$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $e539f33816e64990$var$getTargetInstForChangeEvent;
                else if ($e539f33816e64990$var$isTextInputElement(reactName)) {
                    if ($e539f33816e64990$var$isInputEventSupported) getTargetInstFunc = $e539f33816e64990$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $e539f33816e64990$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $e539f33816e64990$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $e539f33816e64990$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $e539f33816e64990$var$getTargetInstForChangeEvent) : getTargetInstFunc = $e539f33816e64990$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $e539f33816e64990$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $e539f33816e64990$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $e539f33816e64990$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($e539f33816e64990$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $e539f33816e64990$var$activeElement = handleEventFunc, $e539f33816e64990$var$activeElementInst = targetInst, $e539f33816e64990$var$lastSelection = null;
                    break;
                case "focusout":
                    $e539f33816e64990$var$lastSelection = $e539f33816e64990$var$activeElementInst = $e539f33816e64990$var$activeElement = null;
                    break;
                case "mousedown":
                    $e539f33816e64990$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e539f33816e64990$var$mouseDown = !1;
                    $e539f33816e64990$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($e539f33816e64990$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $e539f33816e64990$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($e539f33816e64990$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $e539f33816e64990$var$isComposing ? $e539f33816e64990$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($e539f33816e64990$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($e539f33816e64990$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $e539f33816e64990$var$isComposing && (fallbackData = $e539f33816e64990$var$getData()) : ($e539f33816e64990$var$root = nativeEventTarget, $e539f33816e64990$var$startText = "value" in $e539f33816e64990$var$root ? $e539f33816e64990$var$root.value : $e539f33816e64990$var$root.textContent, $e539f33816e64990$var$isComposing = !0)), handleEventFunc = $e539f33816e64990$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $e539f33816e64990$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $e539f33816e64990$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $e539f33816e64990$var$canUseTextInputEvent ? $e539f33816e64990$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $e539f33816e64990$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $e539f33816e64990$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $e539f33816e64990$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $e539f33816e64990$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $e539f33816e64990$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $e539f33816e64990$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $e539f33816e64990$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $e539f33816e64990$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($e539f33816e64990$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $e539f33816e64990$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($e539f33816e64990$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $e539f33816e64990$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $e539f33816e64990$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $e539f33816e64990$var$getListener(target, registrationName), null != stateNode && listeners.unshift($e539f33816e64990$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $e539f33816e64990$var$getListener(target, registrationName), null != stateNode && listeners.push($e539f33816e64990$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $e539f33816e64990$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $e539f33816e64990$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $e539f33816e64990$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($e539f33816e64990$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($e539f33816e64990$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $e539f33816e64990$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $e539f33816e64990$var$normalizeMarkupForTextOrAttribute(clientText);
    return $e539f33816e64990$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $e539f33816e64990$var$noop$1() {}
function $e539f33816e64990$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $e539f33816e64990$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $e539f33816e64990$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $e539f33816e64990$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $e539f33816e64990$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $e539f33816e64990$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $e539f33816e64990$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $e539f33816e64990$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $e539f33816e64990$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $e539f33816e64990$var$setProp(domElement, tag, "name", props.name, props, null), $e539f33816e64990$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $e539f33816e64990$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $e539f33816e64990$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($e539f33816e64990$var$setProp(domElement, tag, "encType", props.encType, props, null), $e539f33816e64990$var$setProp(domElement, tag, "method", props.method, props, null), $e539f33816e64990$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $e539f33816e64990$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $e539f33816e64990$var$noop$1);
            break;
        case "onScroll":
            null != value && $e539f33816e64990$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $e539f33816e64990$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($e539f33816e64990$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($e539f33816e64990$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $e539f33816e64990$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $e539f33816e64990$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $e539f33816e64990$var$listenToNonDelegatedEvent("toggle", domElement);
            $e539f33816e64990$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $e539f33816e64990$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $e539f33816e64990$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $e539f33816e64990$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $e539f33816e64990$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $e539f33816e64990$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $e539f33816e64990$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $e539f33816e64990$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $e539f33816e64990$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $e539f33816e64990$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $e539f33816e64990$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $e539f33816e64990$var$aliases.get(key) || key, $e539f33816e64990$var$setValueForAttribute(domElement, key, value);
    }
}
function $e539f33816e64990$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $e539f33816e64990$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($e539f33816e64990$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($e539f33816e64990$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $e539f33816e64990$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $e539f33816e64990$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $e539f33816e64990$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $e539f33816e64990$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $e539f33816e64990$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$e539f33816e64990$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$e539f33816e64990$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $e539f33816e64990$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $e539f33816e64990$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $e539f33816e64990$var$listenToNonDelegatedEvent("error", domElement);
            $e539f33816e64990$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($e539f33816e64990$var$formatProdErrorMessage(137, tag));
                    default:
                        $e539f33816e64990$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $e539f33816e64990$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $e539f33816e64990$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $e539f33816e64990$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($e539f33816e64990$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $e539f33816e64990$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $e539f33816e64990$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $e539f33816e64990$var$track(domElement);
            return;
        case "select":
            $e539f33816e64990$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $e539f33816e64990$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $e539f33816e64990$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $e539f33816e64990$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $e539f33816e64990$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($e539f33816e64990$var$formatProdErrorMessage(91));
                    break;
                default:
                    $e539f33816e64990$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $e539f33816e64990$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $e539f33816e64990$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $e539f33816e64990$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $e539f33816e64990$var$listenToNonDelegatedEvent("cancel", domElement);
            $e539f33816e64990$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $e539f33816e64990$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $e539f33816e64990$var$mediaEventTypes.length; hasSrc++)$e539f33816e64990$var$listenToNonDelegatedEvent($e539f33816e64990$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $e539f33816e64990$var$listenToNonDelegatedEvent("error", domElement);
            $e539f33816e64990$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $e539f33816e64990$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $e539f33816e64990$var$listenToNonDelegatedEvent("error", domElement), $e539f33816e64990$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($e539f33816e64990$var$formatProdErrorMessage(137, tag));
                default:
                    $e539f33816e64990$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($e539f33816e64990$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $e539f33816e64990$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $e539f33816e64990$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $e539f33816e64990$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $e539f33816e64990$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($e539f33816e64990$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $e539f33816e64990$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $e539f33816e64990$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $e539f33816e64990$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $e539f33816e64990$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $e539f33816e64990$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $e539f33816e64990$var$updateOptions(domElement, !!lastProps, tag, !0) : $e539f33816e64990$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $e539f33816e64990$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($e539f33816e64990$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $e539f33816e64990$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $e539f33816e64990$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $e539f33816e64990$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $e539f33816e64990$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $e539f33816e64990$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($e539f33816e64990$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $e539f33816e64990$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($e539f33816e64990$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $e539f33816e64990$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $e539f33816e64990$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $e539f33816e64990$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $e539f33816e64990$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $e539f33816e64990$var$eventsEnabled = null, $e539f33816e64990$var$selectionInformation = null;
function $e539f33816e64990$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $e539f33816e64990$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $e539f33816e64990$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $e539f33816e64990$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $e539f33816e64990$var$currentPopstateTransitionEvent = null;
function $e539f33816e64990$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $e539f33816e64990$var$currentPopstateTransitionEvent) return !1;
        $e539f33816e64990$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $e539f33816e64990$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $e539f33816e64990$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $e539f33816e64990$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $e539f33816e64990$var$localPromise = "function" === typeof Promise ? Promise : void 0, $e539f33816e64990$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e539f33816e64990$var$localPromise ? function(callback) {
    return $e539f33816e64990$var$localPromise.resolve(null).then(callback).catch($e539f33816e64990$var$handleErrorInNextTick);
} : $e539f33816e64990$var$scheduleTimeout;
function $e539f33816e64990$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $e539f33816e64990$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $e539f33816e64990$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $e539f33816e64990$var$retryIfBlockedOn(suspenseInstance);
}
function $e539f33816e64990$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $e539f33816e64990$var$clearContainerSparingly(node);
                $e539f33816e64990$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $e539f33816e64990$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$e539f33816e64990$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $e539f33816e64990$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $e539f33816e64990$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $e539f33816e64990$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $e539f33816e64990$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $e539f33816e64990$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $e539f33816e64990$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $e539f33816e64990$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($e539f33816e64990$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($e539f33816e64990$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($e539f33816e64990$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($e539f33816e64990$var$formatProdErrorMessage(451));
    }
}
var $e539f33816e64990$var$preloadPropsMap = new Map(), $e539f33816e64990$var$preconnectsSet = new Set();
function $e539f33816e64990$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $e539f33816e64990$var$previousDispatcher = $e539f33816e64990$var$ReactDOMSharedInternals.d;
$e539f33816e64990$var$ReactDOMSharedInternals.d = {
    f: $e539f33816e64990$var$flushSyncWork,
    r: $e539f33816e64990$var$requestFormReset,
    D: $e539f33816e64990$var$prefetchDNS,
    C: $e539f33816e64990$var$preconnect,
    L: $e539f33816e64990$var$preload,
    m: $e539f33816e64990$var$preloadModule,
    X: $e539f33816e64990$var$preinitScript,
    S: $e539f33816e64990$var$preinitStyle,
    M: $e539f33816e64990$var$preinitModuleScript
};
function $e539f33816e64990$var$flushSyncWork() {
    var previousWasRendering = $e539f33816e64990$var$previousDispatcher.f(), wasRendering = $e539f33816e64990$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $e539f33816e64990$var$requestFormReset(form) {
    var formInst = $e539f33816e64990$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $e539f33816e64990$var$requestFormReset$1(formInst) : $e539f33816e64990$var$previousDispatcher.r(form);
}
var $e539f33816e64990$var$globalDocument = "undefined" === typeof document ? null : document;
function $e539f33816e64990$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $e539f33816e64990$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $e539f33816e64990$var$preconnectsSet.has(limitedEscapedHref) || ($e539f33816e64990$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $e539f33816e64990$var$setInitialProperties(href, "link", rel), $e539f33816e64990$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $e539f33816e64990$var$prefetchDNS(href) {
    $e539f33816e64990$var$previousDispatcher.D(href);
    $e539f33816e64990$var$preconnectAs("dns-prefetch", href, null);
}
function $e539f33816e64990$var$preconnect(href, crossOrigin) {
    $e539f33816e64990$var$previousDispatcher.C(href, crossOrigin);
    $e539f33816e64990$var$preconnectAs("preconnect", href, crossOrigin);
}
function $e539f33816e64990$var$preload(href, as, options) {
    $e539f33816e64990$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $e539f33816e64990$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $e539f33816e64990$var$getStyleKey(href);
                break;
            case "script":
                key = $e539f33816e64990$var$getScriptKey(href);
        }
        $e539f33816e64990$var$preloadPropsMap.has(key) || (href = $e539f33816e64990$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $e539f33816e64990$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($e539f33816e64990$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($e539f33816e64990$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $e539f33816e64990$var$setInitialProperties(as, "link", href), $e539f33816e64990$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $e539f33816e64990$var$preloadModule(href, options) {
    $e539f33816e64990$var$previousDispatcher.m(href, options);
    var ownerDocument = $e539f33816e64990$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $e539f33816e64990$var$getScriptKey(href);
        }
        if (!$e539f33816e64990$var$preloadPropsMap.has(key) && (href = $e539f33816e64990$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $e539f33816e64990$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($e539f33816e64990$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $e539f33816e64990$var$setInitialProperties(as, "link", href);
            $e539f33816e64990$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $e539f33816e64990$var$preinitStyle(href, precedence, options) {
    $e539f33816e64990$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $e539f33816e64990$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $e539f33816e64990$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $e539f33816e64990$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($e539f33816e64990$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $e539f33816e64990$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $e539f33816e64990$var$preloadPropsMap.get(key)) && $e539f33816e64990$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $e539f33816e64990$var$markNodeAsHoistable(link);
                $e539f33816e64990$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $e539f33816e64990$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $e539f33816e64990$var$preinitScript(src, options) {
    $e539f33816e64990$var$previousDispatcher.X(src, options);
    var ownerDocument = $e539f33816e64990$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $e539f33816e64990$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $e539f33816e64990$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($e539f33816e64990$var$getScriptSelectorFromKey(key)), resource || (src = $e539f33816e64990$var$assign({
            src: src,
            async: !0
        }, options), (options = $e539f33816e64990$var$preloadPropsMap.get(key)) && $e539f33816e64990$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $e539f33816e64990$var$markNodeAsHoistable(resource), $e539f33816e64990$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $e539f33816e64990$var$preinitModuleScript(src, options) {
    $e539f33816e64990$var$previousDispatcher.M(src, options);
    var ownerDocument = $e539f33816e64990$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $e539f33816e64990$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $e539f33816e64990$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($e539f33816e64990$var$getScriptSelectorFromKey(key)), resource || (src = $e539f33816e64990$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $e539f33816e64990$var$preloadPropsMap.get(key)) && $e539f33816e64990$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $e539f33816e64990$var$markNodeAsHoistable(resource), $e539f33816e64990$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $e539f33816e64990$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $e539f33816e64990$var$rootInstanceStackCursor.current) ? $e539f33816e64990$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($e539f33816e64990$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $e539f33816e64990$var$getStyleKey(pendingProps.href), pendingProps = $e539f33816e64990$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $e539f33816e64990$var$getStyleKey(pendingProps.href);
                var styles$242 = $e539f33816e64990$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($e539f33816e64990$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $e539f33816e64990$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $e539f33816e64990$var$preloadPropsMap.set(type, pendingProps), styles$242 || $e539f33816e64990$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($e539f33816e64990$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($e539f33816e64990$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $e539f33816e64990$var$getScriptKey(pendingProps), pendingProps = $e539f33816e64990$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($e539f33816e64990$var$formatProdErrorMessage(444, type));
    }
}
function $e539f33816e64990$var$getStyleKey(href) {
    return 'href="' + $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $e539f33816e64990$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $e539f33816e64990$var$stylesheetPropsFromRawProps(rawProps) {
    return $e539f33816e64990$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $e539f33816e64990$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $e539f33816e64990$var$setInitialProperties(key, "link", preloadProps), $e539f33816e64990$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $e539f33816e64990$var$getScriptKey(src) {
    return '[src="' + $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $e539f33816e64990$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $e539f33816e64990$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $e539f33816e64990$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $e539f33816e64990$var$markNodeAsHoistable(instance), instance;
            var styleProps = $e539f33816e64990$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $e539f33816e64990$var$markNodeAsHoistable(instance);
            $e539f33816e64990$var$setInitialProperties(instance, "style", styleProps);
            $e539f33816e64990$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $e539f33816e64990$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($e539f33816e64990$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $e539f33816e64990$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $e539f33816e64990$var$stylesheetPropsFromRawProps(props);
            (styleProps = $e539f33816e64990$var$preloadPropsMap.get(styleProps)) && $e539f33816e64990$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $e539f33816e64990$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $e539f33816e64990$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $e539f33816e64990$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $e539f33816e64990$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($e539f33816e64990$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $e539f33816e64990$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $e539f33816e64990$var$preloadPropsMap.get(instance$248)) instance = $e539f33816e64990$var$assign({}, props), $e539f33816e64990$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $e539f33816e64990$var$markNodeAsHoistable(styleProps);
            $e539f33816e64990$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($e539f33816e64990$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $e539f33816e64990$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $e539f33816e64990$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $e539f33816e64990$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $e539f33816e64990$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $e539f33816e64990$var$tagCaches = null;
function $e539f33816e64990$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $e539f33816e64990$var$tagCaches) {
        var cache = new Map();
        var caches = $e539f33816e64990$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $e539f33816e64990$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$e539f33816e64990$var$internalHoistableMarker] || node[$e539f33816e64990$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $e539f33816e64990$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $e539f33816e64990$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $e539f33816e64990$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $e539f33816e64990$var$suspendedState = null;
function $e539f33816e64990$var$noop() {}
function $e539f33816e64990$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $e539f33816e64990$var$suspendedState) throw Error($e539f33816e64990$var$formatProdErrorMessage(475));
    var state = $e539f33816e64990$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $e539f33816e64990$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($e539f33816e64990$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $e539f33816e64990$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $e539f33816e64990$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $e539f33816e64990$var$stylesheetPropsFromRawProps(props);
            (key = $e539f33816e64990$var$preloadPropsMap.get(key)) && $e539f33816e64990$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $e539f33816e64990$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $e539f33816e64990$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $e539f33816e64990$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $e539f33816e64990$var$waitForCommitToBeReady() {
    if (null === $e539f33816e64990$var$suspendedState) throw Error($e539f33816e64990$var$formatProdErrorMessage(475));
    var state = $e539f33816e64990$var$suspendedState;
    state.stylesheets && 0 === state.count && $e539f33816e64990$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $e539f33816e64990$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $e539f33816e64990$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $e539f33816e64990$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $e539f33816e64990$var$precedencesByRoot = null;
function $e539f33816e64990$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $e539f33816e64990$var$precedencesByRoot = new Map(), resources.forEach($e539f33816e64990$var$insertStylesheetIntoRoot, state), $e539f33816e64990$var$precedencesByRoot = null, $e539f33816e64990$var$onUnsuspend.call(state));
}
function $e539f33816e64990$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $e539f33816e64990$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $e539f33816e64990$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $e539f33816e64990$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $e539f33816e64990$var$HostTransitionContext = {
    $$typeof: $e539f33816e64990$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $e539f33816e64990$var$sharedNotPendingObject,
    _currentValue2: $e539f33816e64990$var$sharedNotPendingObject,
    _threadCount: 0
};
function $e539f33816e64990$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $e539f33816e64990$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e539f33816e64990$var$createLaneMap(0);
    this.hiddenUpdates = $e539f33816e64990$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $e539f33816e64990$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $e539f33816e64990$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $e539f33816e64990$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $e539f33816e64990$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $e539f33816e64990$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $e539f33816e64990$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $e539f33816e64990$var$emptyContextObject;
    parentComponent = $e539f33816e64990$var$emptyContextObject;
    return parentComponent;
}
function $e539f33816e64990$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $e539f33816e64990$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $e539f33816e64990$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $e539f33816e64990$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($e539f33816e64990$var$scheduleUpdateOnFiber(element, rootFiber, lane), $e539f33816e64990$var$entangleTransitions(element, rootFiber, lane));
}
function $e539f33816e64990$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $e539f33816e64990$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $e539f33816e64990$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $e539f33816e64990$var$markRetryLaneImpl(fiber, retryLane);
}
function $e539f33816e64990$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $e539f33816e64990$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $e539f33816e64990$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $e539f33816e64990$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $e539f33816e64990$var$_enabled = !0;
function $e539f33816e64990$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $e539f33816e64990$var$ReactSharedInternals.T;
    $e539f33816e64990$var$ReactSharedInternals.T = null;
    var previousPriority = $e539f33816e64990$var$ReactDOMSharedInternals.p;
    try {
        $e539f33816e64990$var$ReactDOMSharedInternals.p = 2, $e539f33816e64990$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $e539f33816e64990$var$ReactDOMSharedInternals.p = previousPriority, $e539f33816e64990$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e539f33816e64990$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $e539f33816e64990$var$ReactSharedInternals.T;
    $e539f33816e64990$var$ReactSharedInternals.T = null;
    var previousPriority = $e539f33816e64990$var$ReactDOMSharedInternals.p;
    try {
        $e539f33816e64990$var$ReactDOMSharedInternals.p = 8, $e539f33816e64990$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $e539f33816e64990$var$ReactDOMSharedInternals.p = previousPriority, $e539f33816e64990$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e539f33816e64990$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($e539f33816e64990$var$_enabled) {
        var blockedOn = $e539f33816e64990$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $e539f33816e64990$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $e539f33816e64990$var$return_targetInst, targetContainer), $e539f33816e64990$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($e539f33816e64990$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($e539f33816e64990$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $e539f33816e64990$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $e539f33816e64990$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $e539f33816e64990$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $e539f33816e64990$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $e539f33816e64990$var$ensureRootIsScheduled(fiber);
                                0 === ($e539f33816e64990$var$executionContext & 6) && ($e539f33816e64990$var$workInProgressRootRenderTargetTime = $e539f33816e64990$var$now() + 500, $e539f33816e64990$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $e539f33816e64990$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $e539f33816e64990$var$scheduleUpdateOnFiber(root, fiber, 2), $e539f33816e64990$var$flushSyncWork$1(), $e539f33816e64990$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $e539f33816e64990$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $e539f33816e64990$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $e539f33816e64990$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $e539f33816e64990$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $e539f33816e64990$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $e539f33816e64990$var$getEventTarget(nativeEvent);
    return $e539f33816e64990$var$findInstanceBlockingTarget(nativeEvent);
}
var $e539f33816e64990$var$return_targetInst = null;
function $e539f33816e64990$var$findInstanceBlockingTarget(targetNode) {
    $e539f33816e64990$var$return_targetInst = null;
    targetNode = $e539f33816e64990$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $e539f33816e64990$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $e539f33816e64990$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $e539f33816e64990$var$return_targetInst = targetNode;
    return null;
}
function $e539f33816e64990$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($e539f33816e64990$var$getCurrentPriorityLevel()){
                case $e539f33816e64990$var$ImmediatePriority:
                    return 2;
                case $e539f33816e64990$var$UserBlockingPriority:
                    return 8;
                case $e539f33816e64990$var$NormalPriority$1:
                case $e539f33816e64990$var$LowPriority:
                    return 32;
                case $e539f33816e64990$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $e539f33816e64990$var$hasScheduledReplayAttempt = !1, $e539f33816e64990$var$queuedFocus = null, $e539f33816e64990$var$queuedDrag = null, $e539f33816e64990$var$queuedMouse = null, $e539f33816e64990$var$queuedPointers = new Map(), $e539f33816e64990$var$queuedPointerCaptures = new Map(), $e539f33816e64990$var$queuedExplicitHydrationTargets = [], $e539f33816e64990$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $e539f33816e64990$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $e539f33816e64990$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $e539f33816e64990$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $e539f33816e64990$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $e539f33816e64990$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e539f33816e64990$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $e539f33816e64990$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $e539f33816e64990$var$getInstanceFromNode(blockedOn), null !== blockedOn && $e539f33816e64990$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $e539f33816e64990$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $e539f33816e64990$var$queuedFocus = $e539f33816e64990$var$accumulateOrCreateContinuousQueuedReplayableEvent($e539f33816e64990$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $e539f33816e64990$var$queuedDrag = $e539f33816e64990$var$accumulateOrCreateContinuousQueuedReplayableEvent($e539f33816e64990$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $e539f33816e64990$var$queuedMouse = $e539f33816e64990$var$accumulateOrCreateContinuousQueuedReplayableEvent($e539f33816e64990$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $e539f33816e64990$var$queuedPointers.set(pointerId, $e539f33816e64990$var$accumulateOrCreateContinuousQueuedReplayableEvent($e539f33816e64990$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $e539f33816e64990$var$queuedPointerCaptures.set(pointerId, $e539f33816e64990$var$accumulateOrCreateContinuousQueuedReplayableEvent($e539f33816e64990$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $e539f33816e64990$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $e539f33816e64990$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $e539f33816e64990$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $e539f33816e64990$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $e539f33816e64990$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $e539f33816e64990$var$requestUpdateLane(), root = $e539f33816e64990$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $e539f33816e64990$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $e539f33816e64990$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $e539f33816e64990$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $e539f33816e64990$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $e539f33816e64990$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $e539f33816e64990$var$currentReplayingEvent = null;
        } else return targetContainers = $e539f33816e64990$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $e539f33816e64990$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $e539f33816e64990$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $e539f33816e64990$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $e539f33816e64990$var$replayUnblockedEvents() {
    $e539f33816e64990$var$hasScheduledReplayAttempt = !1;
    null !== $e539f33816e64990$var$queuedFocus && $e539f33816e64990$var$attemptReplayContinuousQueuedEvent($e539f33816e64990$var$queuedFocus) && ($e539f33816e64990$var$queuedFocus = null);
    null !== $e539f33816e64990$var$queuedDrag && $e539f33816e64990$var$attemptReplayContinuousQueuedEvent($e539f33816e64990$var$queuedDrag) && ($e539f33816e64990$var$queuedDrag = null);
    null !== $e539f33816e64990$var$queuedMouse && $e539f33816e64990$var$attemptReplayContinuousQueuedEvent($e539f33816e64990$var$queuedMouse) && ($e539f33816e64990$var$queuedMouse = null);
    $e539f33816e64990$var$queuedPointers.forEach($e539f33816e64990$var$attemptReplayContinuousQueuedEventInMap);
    $e539f33816e64990$var$queuedPointerCaptures.forEach($e539f33816e64990$var$attemptReplayContinuousQueuedEventInMap);
}
function $e539f33816e64990$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $e539f33816e64990$var$hasScheduledReplayAttempt || ($e539f33816e64990$var$hasScheduledReplayAttempt = !0, $VGsl0.unstable_scheduleCallback($VGsl0.unstable_NormalPriority, $e539f33816e64990$var$replayUnblockedEvents)));
}
var $e539f33816e64990$var$lastScheduledReplayQueue = null;
function $e539f33816e64990$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $e539f33816e64990$var$lastScheduledReplayQueue !== formReplayingQueue && ($e539f33816e64990$var$lastScheduledReplayQueue = formReplayingQueue, $VGsl0.unstable_scheduleCallback($VGsl0.unstable_NormalPriority, function() {
        $e539f33816e64990$var$lastScheduledReplayQueue === formReplayingQueue && ($e539f33816e64990$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $e539f33816e64990$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $e539f33816e64990$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $e539f33816e64990$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $e539f33816e64990$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $e539f33816e64990$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $e539f33816e64990$var$queuedFocus && $e539f33816e64990$var$scheduleCallbackIfUnblocked($e539f33816e64990$var$queuedFocus, unblocked);
    null !== $e539f33816e64990$var$queuedDrag && $e539f33816e64990$var$scheduleCallbackIfUnblocked($e539f33816e64990$var$queuedDrag, unblocked);
    null !== $e539f33816e64990$var$queuedMouse && $e539f33816e64990$var$scheduleCallbackIfUnblocked($e539f33816e64990$var$queuedMouse, unblocked);
    $e539f33816e64990$var$queuedPointers.forEach(unblock);
    $e539f33816e64990$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $e539f33816e64990$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $e539f33816e64990$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $e539f33816e64990$var$queuedExplicitHydrationTargets.length && (i = $e539f33816e64990$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$e539f33816e64990$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $e539f33816e64990$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$e539f33816e64990$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $e539f33816e64990$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$e539f33816e64990$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $e539f33816e64990$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $e539f33816e64990$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $e539f33816e64990$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$e539f33816e64990$var$ReactDOMHydrationRoot.prototype.render = $e539f33816e64990$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($e539f33816e64990$var$formatProdErrorMessage(409));
    var current = root.current, lane = $e539f33816e64990$var$requestUpdateLane();
    $e539f33816e64990$var$updateContainerImpl(current, lane, children, root, null, null);
};
$e539f33816e64990$var$ReactDOMHydrationRoot.prototype.unmount = $e539f33816e64990$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $e539f33816e64990$var$flushPassiveEffects();
        $e539f33816e64990$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $e539f33816e64990$var$flushSyncWork$1();
        container[$e539f33816e64990$var$internalContainerInstanceKey] = null;
    }
};
function $e539f33816e64990$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$e539f33816e64990$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $e539f33816e64990$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $e539f33816e64990$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $e539f33816e64990$var$queuedExplicitHydrationTargets[i].priority; i++);
        $e539f33816e64990$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $e539f33816e64990$var$attemptExplicitHydrationTarget(target);
    }
};
var $e539f33816e64990$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $1Pgvo.version;
if ("19.0.0" !== $e539f33816e64990$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($e539f33816e64990$var$formatProdErrorMessage(527, $e539f33816e64990$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$e539f33816e64990$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($e539f33816e64990$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($e539f33816e64990$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $e539f33816e64990$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $e539f33816e64990$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $e539f33816e64990$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $e539f33816e64990$var$ReactSharedInternals,
    findFiberByHostInstance: $e539f33816e64990$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e539f33816e64990$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e539f33816e64990$var$hook$jscomp$inline_2166.isDisabled && $e539f33816e64990$var$hook$jscomp$inline_2166.supportsFiber) try {
        $e539f33816e64990$var$rendererID = $e539f33816e64990$var$hook$jscomp$inline_2166.inject($e539f33816e64990$var$internals$jscomp$inline_2165), $e539f33816e64990$var$injectedHook = $e539f33816e64990$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$e539f33816e64990$export$882461b6382ed46c = function(container, options) {
    if (!$e539f33816e64990$var$isValidContainer(container)) throw Error($e539f33816e64990$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $e539f33816e64990$var$defaultOnUncaughtError, onCaughtError = $e539f33816e64990$var$defaultOnCaughtError, onRecoverableError = $e539f33816e64990$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $e539f33816e64990$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$e539f33816e64990$var$internalContainerInstanceKey] = options.current;
    $e539f33816e64990$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $e539f33816e64990$var$ReactDOMRoot(options);
};
$e539f33816e64990$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$e539f33816e64990$var$isValidContainer(container)) throw Error($e539f33816e64990$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $e539f33816e64990$var$defaultOnUncaughtError, onCaughtError = $e539f33816e64990$var$defaultOnCaughtError, onRecoverableError = $e539f33816e64990$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $e539f33816e64990$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $e539f33816e64990$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $e539f33816e64990$var$requestUpdateLane();
    identifierPrefix = $e539f33816e64990$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $e539f33816e64990$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $e539f33816e64990$var$markRootUpdated$1(initialChildren, isStrictMode);
    $e539f33816e64990$var$ensureRootIsScheduled(initialChildren);
    container[$e539f33816e64990$var$internalContainerInstanceKey] = initialChildren.current;
    $e539f33816e64990$var$listenToAllSupportedEvents(container);
    return new $e539f33816e64990$var$ReactDOMHydrationRoot(initialChildren);
};
$e539f33816e64990$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("VGsl0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6cAXM"));

});
parcelRegister("6cAXM", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $4840893056105361$export$c4744153514ff05d; }, function (v) { return $4840893056105361$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $4840893056105361$export$3e506c1ccc9cc1a7; }, function (v) { return $4840893056105361$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $4840893056105361$export$e26fe2ed2fa76875; }, function (v) { return $4840893056105361$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $4840893056105361$export$502329bbf4b505b1; }, function (v) { return $4840893056105361$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $4840893056105361$export$6e3807111c4874c4; }, function (v) { return $4840893056105361$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $4840893056105361$export$c27134553091fb3a; }, function (v) { return $4840893056105361$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $4840893056105361$export$33ee1acdc04fd2a2; }, function (v) { return $4840893056105361$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $4840893056105361$export$b00a404bbd5edef2; }, function (v) { return $4840893056105361$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $4840893056105361$export$8352ce38b91d0c62; }, function (v) { return $4840893056105361$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $4840893056105361$export$d66a1c1c77bd778b; }, function (v) { return $4840893056105361$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $4840893056105361$export$d3dfb8e4810cb555; }, function (v) { return $4840893056105361$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $4840893056105361$export$839f9183b0465a69; }, function (v) { return $4840893056105361$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $4840893056105361$export$72fdf0e06517287b; }, function (v) { return $4840893056105361$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $4840893056105361$export$4b844e58a3e414b4; }, function (v) { return $4840893056105361$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $4840893056105361$export$816d2913ae6b83b1; }, function (v) { return $4840893056105361$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $4840893056105361$export$61bcfe829111a1d0; }, function (v) { return $4840893056105361$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $4840893056105361$export$7ee8c9beb337bc3f; }, function (v) { return $4840893056105361$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $4840893056105361$export$b5836b71941fa3ed; }, function (v) { return $4840893056105361$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $4840893056105361$export$cf845f2c119da08a; }, function (v) { return $4840893056105361$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4840893056105361$export$c4744153514ff05d;
var $4840893056105361$export$3e506c1ccc9cc1a7;
var $4840893056105361$export$e26fe2ed2fa76875;
var $4840893056105361$export$502329bbf4b505b1;
var $4840893056105361$export$6e3807111c4874c4;
var $4840893056105361$export$c27134553091fb3a;
var $4840893056105361$export$33ee1acdc04fd2a2;
var $4840893056105361$export$b00a404bbd5edef2;
var $4840893056105361$export$8352ce38b91d0c62;
var $4840893056105361$export$d66a1c1c77bd778b;
var $4840893056105361$export$d3dfb8e4810cb555;
var $4840893056105361$export$839f9183b0465a69;
var $4840893056105361$export$72fdf0e06517287b;
var $4840893056105361$export$4b844e58a3e414b4;
var $4840893056105361$export$816d2913ae6b83b1;
var $4840893056105361$export$61bcfe829111a1d0;
var $4840893056105361$export$7ee8c9beb337bc3f;
var $4840893056105361$export$b5836b71941fa3ed;
var $4840893056105361$export$cf845f2c119da08a;
"use strict";
function $4840893056105361$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $4840893056105361$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $4840893056105361$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $4840893056105361$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $4840893056105361$var$compare(left, last)) rightIndex < length && 0 > $4840893056105361$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $4840893056105361$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $4840893056105361$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$4840893056105361$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $4840893056105361$var$localPerformance = performance;
    $4840893056105361$export$c4744153514ff05d = function() {
        return $4840893056105361$var$localPerformance.now();
    };
} else {
    var $4840893056105361$var$localDate = Date, $4840893056105361$var$initialTime = $4840893056105361$var$localDate.now();
    $4840893056105361$export$c4744153514ff05d = function() {
        return $4840893056105361$var$localDate.now() - $4840893056105361$var$initialTime;
    };
}
var $4840893056105361$var$taskQueue = [], $4840893056105361$var$timerQueue = [], $4840893056105361$var$taskIdCounter = 1, $4840893056105361$var$currentTask = null, $4840893056105361$var$currentPriorityLevel = 3, $4840893056105361$var$isPerformingWork = !1, $4840893056105361$var$isHostCallbackScheduled = !1, $4840893056105361$var$isHostTimeoutScheduled = !1, $4840893056105361$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $4840893056105361$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $4840893056105361$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $4840893056105361$var$advanceTimers(currentTime) {
    for(var timer = $4840893056105361$var$peek($4840893056105361$var$timerQueue); null !== timer;){
        if (null === timer.callback) $4840893056105361$var$pop($4840893056105361$var$timerQueue);
        else if (timer.startTime <= currentTime) $4840893056105361$var$pop($4840893056105361$var$timerQueue), timer.sortIndex = timer.expirationTime, $4840893056105361$var$push($4840893056105361$var$taskQueue, timer);
        else break;
        timer = $4840893056105361$var$peek($4840893056105361$var$timerQueue);
    }
}
function $4840893056105361$var$handleTimeout(currentTime) {
    $4840893056105361$var$isHostTimeoutScheduled = !1;
    $4840893056105361$var$advanceTimers(currentTime);
    if (!$4840893056105361$var$isHostCallbackScheduled) {
        if (null !== $4840893056105361$var$peek($4840893056105361$var$taskQueue)) $4840893056105361$var$isHostCallbackScheduled = !0, $4840893056105361$var$requestHostCallback();
        else {
            var firstTimer = $4840893056105361$var$peek($4840893056105361$var$timerQueue);
            null !== firstTimer && $4840893056105361$var$requestHostTimeout($4840893056105361$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $4840893056105361$var$isMessageLoopRunning = !1, $4840893056105361$var$taskTimeoutID = -1, $4840893056105361$var$frameInterval = 5, $4840893056105361$var$startTime = -1;
function $4840893056105361$var$shouldYieldToHost() {
    return $4840893056105361$export$c4744153514ff05d() - $4840893056105361$var$startTime < $4840893056105361$var$frameInterval ? !1 : !0;
}
function $4840893056105361$var$performWorkUntilDeadline() {
    if ($4840893056105361$var$isMessageLoopRunning) {
        var currentTime = $4840893056105361$export$c4744153514ff05d();
        $4840893056105361$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $4840893056105361$var$isHostCallbackScheduled = !1;
                $4840893056105361$var$isHostTimeoutScheduled && ($4840893056105361$var$isHostTimeoutScheduled = !1, $4840893056105361$var$localClearTimeout($4840893056105361$var$taskTimeoutID), $4840893056105361$var$taskTimeoutID = -1);
                $4840893056105361$var$isPerformingWork = !0;
                var previousPriorityLevel = $4840893056105361$var$currentPriorityLevel;
                try {
                    b: {
                        $4840893056105361$var$advanceTimers(currentTime);
                        for($4840893056105361$var$currentTask = $4840893056105361$var$peek($4840893056105361$var$taskQueue); null !== $4840893056105361$var$currentTask && !($4840893056105361$var$currentTask.expirationTime > currentTime && $4840893056105361$var$shouldYieldToHost());){
                            var callback = $4840893056105361$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $4840893056105361$var$currentTask.callback = null;
                                $4840893056105361$var$currentPriorityLevel = $4840893056105361$var$currentTask.priorityLevel;
                                var continuationCallback = callback($4840893056105361$var$currentTask.expirationTime <= currentTime);
                                currentTime = $4840893056105361$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $4840893056105361$var$currentTask.callback = continuationCallback;
                                    $4840893056105361$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $4840893056105361$var$currentTask === $4840893056105361$var$peek($4840893056105361$var$taskQueue) && $4840893056105361$var$pop($4840893056105361$var$taskQueue);
                                $4840893056105361$var$advanceTimers(currentTime);
                            } else $4840893056105361$var$pop($4840893056105361$var$taskQueue);
                            $4840893056105361$var$currentTask = $4840893056105361$var$peek($4840893056105361$var$taskQueue);
                        }
                        if (null !== $4840893056105361$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $4840893056105361$var$peek($4840893056105361$var$timerQueue);
                            null !== firstTimer && $4840893056105361$var$requestHostTimeout($4840893056105361$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $4840893056105361$var$currentTask = null, $4840893056105361$var$currentPriorityLevel = previousPriorityLevel, $4840893056105361$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $4840893056105361$var$schedulePerformWorkUntilDeadline() : $4840893056105361$var$isMessageLoopRunning = !1;
        }
    }
}
var $4840893056105361$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $4840893056105361$var$localSetImmediate) $4840893056105361$var$schedulePerformWorkUntilDeadline = function() {
    $4840893056105361$var$localSetImmediate($4840893056105361$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $4840893056105361$var$channel = new MessageChannel(), $4840893056105361$var$port = $4840893056105361$var$channel.port2;
    $4840893056105361$var$channel.port1.onmessage = $4840893056105361$var$performWorkUntilDeadline;
    $4840893056105361$var$schedulePerformWorkUntilDeadline = function() {
        $4840893056105361$var$port.postMessage(null);
    };
} else $4840893056105361$var$schedulePerformWorkUntilDeadline = function() {
    $4840893056105361$var$localSetTimeout($4840893056105361$var$performWorkUntilDeadline, 0);
};
function $4840893056105361$var$requestHostCallback() {
    $4840893056105361$var$isMessageLoopRunning || ($4840893056105361$var$isMessageLoopRunning = !0, $4840893056105361$var$schedulePerformWorkUntilDeadline());
}
function $4840893056105361$var$requestHostTimeout(callback, ms) {
    $4840893056105361$var$taskTimeoutID = $4840893056105361$var$localSetTimeout(function() {
        callback($4840893056105361$export$c4744153514ff05d());
    }, ms);
}
$4840893056105361$export$3e506c1ccc9cc1a7 = 5;
$4840893056105361$export$e26fe2ed2fa76875 = 1;
$4840893056105361$export$502329bbf4b505b1 = 4;
$4840893056105361$export$6e3807111c4874c4 = 3;
$4840893056105361$export$c27134553091fb3a = null;
$4840893056105361$export$33ee1acdc04fd2a2 = 2;
$4840893056105361$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$4840893056105361$export$8352ce38b91d0c62 = function() {
    $4840893056105361$var$isHostCallbackScheduled || $4840893056105361$var$isPerformingWork || ($4840893056105361$var$isHostCallbackScheduled = !0, $4840893056105361$var$requestHostCallback());
};
$4840893056105361$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $4840893056105361$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$4840893056105361$export$d3dfb8e4810cb555 = function() {
    return $4840893056105361$var$currentPriorityLevel;
};
$4840893056105361$export$839f9183b0465a69 = function() {
    return $4840893056105361$var$peek($4840893056105361$var$taskQueue);
};
$4840893056105361$export$72fdf0e06517287b = function(eventHandler) {
    switch($4840893056105361$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $4840893056105361$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $4840893056105361$var$currentPriorityLevel;
    $4840893056105361$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $4840893056105361$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$4840893056105361$export$4b844e58a3e414b4 = function() {};
$4840893056105361$export$816d2913ae6b83b1 = function() {};
$4840893056105361$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $4840893056105361$var$currentPriorityLevel;
    $4840893056105361$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $4840893056105361$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$4840893056105361$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $4840893056105361$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $4840893056105361$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $4840893056105361$var$push($4840893056105361$var$timerQueue, priorityLevel), null === $4840893056105361$var$peek($4840893056105361$var$taskQueue) && priorityLevel === $4840893056105361$var$peek($4840893056105361$var$timerQueue) && ($4840893056105361$var$isHostTimeoutScheduled ? ($4840893056105361$var$localClearTimeout($4840893056105361$var$taskTimeoutID), $4840893056105361$var$taskTimeoutID = -1) : $4840893056105361$var$isHostTimeoutScheduled = !0, $4840893056105361$var$requestHostTimeout($4840893056105361$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $4840893056105361$var$push($4840893056105361$var$taskQueue, priorityLevel), $4840893056105361$var$isHostCallbackScheduled || $4840893056105361$var$isPerformingWork || ($4840893056105361$var$isHostCallbackScheduled = !0, $4840893056105361$var$requestHostCallback()));
    return priorityLevel;
};
$4840893056105361$export$b5836b71941fa3ed = $4840893056105361$var$shouldYieldToHost;
$4840893056105361$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $4840893056105361$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $4840893056105361$var$currentPriorityLevel;
        $4840893056105361$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $4840893056105361$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("kZ6Vu", function(module, exports) {
'use strict';
function $f46ee0897ddde675$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f46ee0897ddde675$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f46ee0897ddde675$var$checkDCE();

module.exports = (parcelRequire("f2RQl"));

});
parcelRegister("f2RQl", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $af40cf13b3ca887b$export$69ce8ef3fe5cead0; }, function (v) { return $af40cf13b3ca887b$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $af40cf13b3ca887b$export$d39a5bbd09211389; }, function (v) { return $af40cf13b3ca887b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $af40cf13b3ca887b$export$cd75ccfd720a3cd4; }, function (v) { return $af40cf13b3ca887b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $af40cf13b3ca887b$export$a0816fa17a9e79be; }, function (v) { return $af40cf13b3ca887b$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $af40cf13b3ca887b$export$7292efcadded39f3; }, function (v) { return $af40cf13b3ca887b$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $af40cf13b3ca887b$export$da407abadb9b8f86; }, function (v) { return $af40cf13b3ca887b$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $af40cf13b3ca887b$export$314cfea32580671c; }, function (v) { return $af40cf13b3ca887b$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $af40cf13b3ca887b$export$513ccb98c53b8039; }, function (v) { return $af40cf13b3ca887b$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $af40cf13b3ca887b$export$dbca993bc2d264a; }, function (v) { return $af40cf13b3ca887b$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $af40cf13b3ca887b$export$4797a8006f0655d0; }, function (v) { return $af40cf13b3ca887b$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $af40cf13b3ca887b$export$c78a37762a8d58e1; }, function (v) { return $af40cf13b3ca887b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $af40cf13b3ca887b$export$606f11b2eb45ecc6; }, function (v) { return $af40cf13b3ca887b$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $af40cf13b3ca887b$export$f7e8a0bf92324b1e; }, function (v) { return $af40cf13b3ca887b$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $af40cf13b3ca887b$export$83d89fbfd8236492; }, function (v) { return $af40cf13b3ca887b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $af40cf13b3ca887b$export$69ce8ef3fe5cead0;
var $af40cf13b3ca887b$export$d39a5bbd09211389;
var $af40cf13b3ca887b$export$cd75ccfd720a3cd4;
var $af40cf13b3ca887b$export$a0816fa17a9e79be;
var $af40cf13b3ca887b$export$7292efcadded39f3;
var $af40cf13b3ca887b$export$da407abadb9b8f86;
var $af40cf13b3ca887b$export$314cfea32580671c;
var $af40cf13b3ca887b$export$513ccb98c53b8039;
var $af40cf13b3ca887b$export$dbca993bc2d264a;
var $af40cf13b3ca887b$export$4797a8006f0655d0;
var $af40cf13b3ca887b$export$c78a37762a8d58e1;
var $af40cf13b3ca887b$export$606f11b2eb45ecc6;
var $af40cf13b3ca887b$export$f7e8a0bf92324b1e;
var $af40cf13b3ca887b$export$83d89fbfd8236492;
"use strict";

var $1Pgvo = parcelRequire("1Pgvo");
function $af40cf13b3ca887b$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $af40cf13b3ca887b$var$noop() {}
var $af40cf13b3ca887b$var$Internals = {
    d: {
        f: $af40cf13b3ca887b$var$noop,
        r: function() {
            throw Error($af40cf13b3ca887b$var$formatProdErrorMessage(522));
        },
        D: $af40cf13b3ca887b$var$noop,
        C: $af40cf13b3ca887b$var$noop,
        L: $af40cf13b3ca887b$var$noop,
        m: $af40cf13b3ca887b$var$noop,
        X: $af40cf13b3ca887b$var$noop,
        S: $af40cf13b3ca887b$var$noop,
        M: $af40cf13b3ca887b$var$noop
    },
    p: 0,
    findDOMNode: null
}, $af40cf13b3ca887b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $af40cf13b3ca887b$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $af40cf13b3ca887b$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $af40cf13b3ca887b$var$ReactSharedInternals = $1Pgvo.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $af40cf13b3ca887b$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$af40cf13b3ca887b$export$69ce8ef3fe5cead0 = $af40cf13b3ca887b$var$Internals;
$af40cf13b3ca887b$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($af40cf13b3ca887b$var$formatProdErrorMessage(299));
    return $af40cf13b3ca887b$var$createPortal$1(children, container, null, key);
};
$af40cf13b3ca887b$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $af40cf13b3ca887b$var$ReactSharedInternals.T, previousUpdatePriority = $af40cf13b3ca887b$var$Internals.p;
    try {
        if ($af40cf13b3ca887b$var$ReactSharedInternals.T = null, $af40cf13b3ca887b$var$Internals.p = 2, fn) return fn();
    } finally{
        $af40cf13b3ca887b$var$ReactSharedInternals.T = previousTransition, $af40cf13b3ca887b$var$Internals.p = previousUpdatePriority, $af40cf13b3ca887b$var$Internals.d.f();
    }
};
$af40cf13b3ca887b$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $af40cf13b3ca887b$var$Internals.d.C(href, options));
};
$af40cf13b3ca887b$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $af40cf13b3ca887b$var$Internals.d.D(href);
};
$af40cf13b3ca887b$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $af40cf13b3ca887b$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $af40cf13b3ca887b$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $af40cf13b3ca887b$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$af40cf13b3ca887b$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $af40cf13b3ca887b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $af40cf13b3ca887b$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $af40cf13b3ca887b$var$Internals.d.M(href);
    }
};
$af40cf13b3ca887b$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $af40cf13b3ca887b$var$getCrossOriginStringAs(as, options.crossOrigin);
        $af40cf13b3ca887b$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$af40cf13b3ca887b$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $af40cf13b3ca887b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $af40cf13b3ca887b$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $af40cf13b3ca887b$var$Internals.d.m(href);
    }
};
$af40cf13b3ca887b$export$4797a8006f0655d0 = function(form) {
    $af40cf13b3ca887b$var$Internals.d.r(form);
};
$af40cf13b3ca887b$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$af40cf13b3ca887b$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $af40cf13b3ca887b$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$af40cf13b3ca887b$export$f7e8a0bf92324b1e = function() {
    return $af40cf13b3ca887b$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$af40cf13b3ca887b$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("3ievm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $265e4de30888d8cb$export$2e2bcd8739ae039; });

var $hIcDp = parcelRequire("hIcDp");
// eslint-disable-next-line no-undef
var $265e4de30888d8cb$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $265e4de30888d8cb$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $hIcDp.default)(function(prop) {
    return $265e4de30888d8cb$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("hIcDp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce5058b6ce65e166$export$2e2bcd8739ae039; });
function $ce5058b6ce65e166$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("gY8Sm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c5a92275fe1d86f9$var$ReactIs, $c5a92275fe1d86f9$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("4PyrX"))();

});
parcelRegister("4PyrX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $j8FKo = parcelRequire("j8FKo");
function $3846a5dfa3380ba3$var$emptyFunction() {}
function $3846a5dfa3380ba3$var$emptyFunctionWithReset() {}
$3846a5dfa3380ba3$var$emptyFunctionWithReset.resetWarningCache = $3846a5dfa3380ba3$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $j8FKo) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $3846a5dfa3380ba3$var$emptyFunctionWithReset,
        resetWarningCache: $3846a5dfa3380ba3$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("j8FKo", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $deef25cd15aedc38$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $deef25cd15aedc38$var$ReactPropTypesSecret;

});



parcelRegister("2rX73", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $5db5d49a41c18394$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $5db5d49a41c18394$export$2e2bcd8739ae039; });
function $5db5d49a41c18394$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $5db5d49a41c18394$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $5db5d49a41c18394$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $5db5d49a41c18394$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $5db5d49a41c18394$export$2e2bcd8739ae039 = $5db5d49a41c18394$export$4f5d2d50c9deca37;

});

parcelRegister("kIDXC", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $f156ea06ee848044$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f156ea06ee848044$var$_resolveProps.default;
    }
});

var $f156ea06ee848044$var$_resolveProps = $f156ea06ee848044$require$_interopRequireDefault((parcelRequire("9GFS7")));

});
parcelRegister("9rMjh", function(module, exports) {
function $6e0c1c04787317df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $6e0c1c04787317df$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9GFS7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $01d1f19dad68d9f1$var$resolveProps;
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $01d1f19dad68d9f1$var$resolveProps(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $01d1f19dad68d9f1$var$resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});


parcelRegister("1g5DJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0eaba9049ae08e32$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $0eaba9049ae08e32$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("iKhyI", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $da5a24b9a1efb175$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $da5a24b9a1efb175$var$_formatMuiErrorMessage.default;
    }
});

var $da5a24b9a1efb175$var$_formatMuiErrorMessage = $da5a24b9a1efb175$require$_interopRequireDefault((parcelRequire("eWG07")));

});
parcelRegister("eWG07", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae170ffb6751cc98$var$formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $ae170ffb6751cc98$var$formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("60Ihj", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $460516e04b931778$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $460516e04b931778$var$_clamp.default;
    }
});

var $460516e04b931778$var$_clamp = $460516e04b931778$require$_interopRequireDefault((parcelRequire("hTGcG")));

});
parcelRegister("hTGcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $d0784f76124b4d42$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $d0784f76124b4d42$var$_default = module.exports.default = $d0784f76124b4d42$var$clamp;

});


parcelRegister("ek0e0", function(module, exports) {
"use strict";
'use client';

var $pArzt = parcelRequire("pArzt");
var $a6d31b96000efcef$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6d31b96000efcef$var$useId;

var $a6d31b96000efcef$var$React = $a6d31b96000efcef$require$_interopRequireWildcard((parcelRequire("1Pgvo")));
let $a6d31b96000efcef$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $a6d31b96000efcef$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $a6d31b96000efcef$var$React.useState(idOverride);
    const id = idOverride || defaultId;
    $a6d31b96000efcef$var$React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $a6d31b96000efcef$var$globalId += 1;
            setDefaultId(`mui-${$a6d31b96000efcef$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $a6d31b96000efcef$var$safeReact = {
    ...$a6d31b96000efcef$var$React
};
const $a6d31b96000efcef$var$maybeReactUseId = $a6d31b96000efcef$var$safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function $a6d31b96000efcef$var$useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($a6d31b96000efcef$var$maybeReactUseId !== undefined) {
        const reactId = $a6d31b96000efcef$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $a6d31b96000efcef$var$useGlobalId(idOverride);
}

});
parcelRegister("pArzt", function(module, exports) {

var $1Hk0E = parcelRequire("1Hk0E");
var $04ce9adf78ebc296$var$_typeof = $1Hk0E.default;
function $04ce9adf78ebc296$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (module.exports = $04ce9adf78ebc296$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != $04ce9adf78ebc296$var$_typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = $04ce9adf78ebc296$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1Hk0E", function(module, exports) {
function $13c9540bc6e183bf$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $13c9540bc6e183bf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $13c9540bc6e183bf$var$_typeof(o);
}
module.exports = $13c9540bc6e183bf$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("8WdHP", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $681e5f39b3a21883$require$_interopRequireDefault = $9rMjh.default;

var $pArzt = parcelRequire("pArzt");
var $681e5f39b3a21883$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $681e5f39b3a21883$var$createStyled;
module.exports.shouldForwardProp = $681e5f39b3a21883$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $681e5f39b3a21883$var$_styledEngine = $681e5f39b3a21883$require$_interopRequireWildcard((parcelRequire("1VcT5")));

var $cWnbn = parcelRequire("cWnbn");

var $681e5f39b3a21883$var$_capitalize = $681e5f39b3a21883$require$_interopRequireDefault((parcelRequire("bEhYY")));

var $681e5f39b3a21883$var$_getDisplayName = $681e5f39b3a21883$require$_interopRequireDefault((parcelRequire("gCVrD")));

var $681e5f39b3a21883$var$_createTheme = $681e5f39b3a21883$require$_interopRequireDefault((parcelRequire("cp4gV")));

var $681e5f39b3a21883$var$_styleFunctionSx = $681e5f39b3a21883$require$_interopRequireDefault((parcelRequire("a4tM1")));

var $681e5f39b3a21883$var$_preprocessStyles = $681e5f39b3a21883$require$_interopRequireDefault((parcelRequire("bgjRT")));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const $681e5f39b3a21883$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $681e5f39b3a21883$var$_createTheme.default)();
// Update /system/styled/#api in case if this changes
function $681e5f39b3a21883$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $681e5f39b3a21883$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $681e5f39b3a21883$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $681e5f39b3a21883$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $681e5f39b3a21883$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$681e5f39b3a21883$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $681e5f39b3a21883$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $681e5f39b3a21883$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $681e5f39b3a21883$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $681e5f39b3a21883$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $681e5f39b3a21883$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $681e5f39b3a21883$var$shouldForwardProp } = input;
    function styleAttachTheme(props) {
        $681e5f39b3a21883$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $681e5f39b3a21883$var$_styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== $681e5f39b3a21883$var$_styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $681e5f39b3a21883$var$defaultOverridesResolver($681e5f39b3a21883$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $681e5f39b3a21883$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($681e5f39b3a21883$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $681e5f39b3a21883$var$_styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $681e5f39b3a21883$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $681e5f39b3a21883$var$processStyle(props, style);
            };
            if ((0, $cWnbn.isPlainObject)(style)) {
                const serialized = (0, $681e5f39b3a21883$var$_preprocessStyles.default)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $681e5f39b3a21883$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $681e5f39b3a21883$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $681e5f39b3a21883$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push($681e5f39b3a21883$var$_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $681e5f39b3a21883$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $681e5f39b3a21883$var$_capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, $681e5f39b3a21883$var$_getDisplayName.default)(tag)})`;
}
function $681e5f39b3a21883$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $681e5f39b3a21883$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $681e5f39b3a21883$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $681e5f39b3a21883$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("1VcT5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $16651c7c53b5c21d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_mutateStyles", function () { return $16651c7c53b5c21d$export$592c7226e4cb0171; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $16651c7c53b5c21d$export$13a2d3ef13012b32; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("jjrEh")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("djYnP")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("djYnP")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("jokI8")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("fmb6q")).default; });
/**
 * @mui/styled-engine v7.1.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $3wQDH = parcelRequire("3wQDH");

var $iQFxy = parcelRequire("iQFxy");

var $djYnP = parcelRequire("djYnP");
var $jjrEh = parcelRequire("jjrEh");

var $jokI8 = parcelRequire("jokI8");

var $fmb6q = parcelRequire("fmb6q");
'use client';
function $16651c7c53b5c21d$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $3wQDH.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $16651c7c53b5c21d$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $16651c7c53b5c21d$var$wrapper = [];
function $16651c7c53b5c21d$export$13a2d3ef13012b32(styles) {
    $16651c7c53b5c21d$var$wrapper[0] = styles;
    return (0, $iQFxy.serializeStyles)($16651c7c53b5c21d$var$wrapper);
}

});
parcelRegister("3wQDH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $291d3153c923df4b$export$2e2bcd8739ae039; });

var $cFOS2 = parcelRequire("cFOS2");
parcelRequire("9IPVu");

parcelRequire("iQFxy");
parcelRequire("gUd5K");
parcelRequire("8Ur7X");
parcelRequire("1Pgvo");
parcelRequire("3ievm");
var $291d3153c923df4b$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $291d3153c923df4b$export$2e2bcd8739ae039 = (0, $cFOS2.default).bind(null);
$291d3153c923df4b$var$tags.forEach(function(tagName) {
    $291d3153c923df4b$export$2e2bcd8739ae039[tagName] = $291d3153c923df4b$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("cFOS2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93a0c635ca08376a$export$2e2bcd8739ae039; });

var $gAPAo = parcelRequire("gAPAo");
parcelRequire("djYnP");
var $jjrEh = parcelRequire("jjrEh");

var $iQFxy = parcelRequire("iQFxy");

var $gUd5K = parcelRequire("gUd5K");

var $8Ur7X = parcelRequire("8Ur7X");

var $1Pgvo = parcelRequire("1Pgvo");

var $3ievm = parcelRequire("3ievm");
var $93a0c635ca08376a$var$isBrowser = typeof document !== 'undefined';
var $93a0c635ca08376a$var$isDevelopment = false;
var $93a0c635ca08376a$var$testOmitPropsOnStringTag = (0, $3ievm.default);
var $93a0c635ca08376a$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $93a0c635ca08376a$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $93a0c635ca08376a$var$testOmitPropsOnStringTag : $93a0c635ca08376a$var$testOmitPropsOnComponent;
};
var $93a0c635ca08376a$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $93a0c635ca08376a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8Ur7X.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $gUd5K.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8Ur7X.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$93a0c635ca08376a$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $1Pgvo.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $93a0c635ca08376a$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $93a0c635ca08376a$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $93a0c635ca08376a$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $jjrEh.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $1Pgvo.useContext((0, $jjrEh.T));
            }
            if (typeof props.className === 'string') className = (0, $8Ur7X.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $iQFxy.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $93a0c635ca08376a$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $1Pgvo.createElement($1Pgvo.Fragment, null, /*#__PURE__*/ $1Pgvo.createElement($93a0c635ca08376a$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $1Pgvo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $93a0c635ca08376a$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $gAPAo.default)({}, options, nextOptions, {
                shouldForwardProp: $93a0c635ca08376a$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("gAPAo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c14806089f3eb9c2$export$2e2bcd8739ae039; });
function $c14806089f3eb9c2$export$2e2bcd8739ae039() {
    return $c14806089f3eb9c2$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c14806089f3eb9c2$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("djYnP", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $9b2be399c33e787c$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $9b2be399c33e787c$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $9b2be399c33e787c$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("jjrEh")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("jjrEh")).w; });

var $jjrEh = parcelRequire("jjrEh");

var $1Pgvo = parcelRequire("1Pgvo");

var $8Ur7X = parcelRequire("8Ur7X");

var $gUd5K = parcelRequire("gUd5K");

var $iQFxy = parcelRequire("iQFxy");
parcelRequire("68idG");
parcelRequire("9IPVu");
parcelRequire("3St5F");

parcelRequire("15YBk");
var $9b2be399c33e787c$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $jjrEh.h).call(props, 'css')) return $1Pgvo.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $jjrEh.E);
    createElementArgArray[1] = (0, $jjrEh.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $1Pgvo.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($9b2be399c33e787c$export$c8a8987d4410bf2d || ($9b2be399c33e787c$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $9b2be399c33e787c$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $jjrEh.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $iQFxy.serializeStyles)([
        styles
    ], undefined, $1Pgvo.useContext((0, $jjrEh.T)));
    if (!(0, $jjrEh.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $1Pgvo.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $1Pgvo.useRef();
    (0, $gUd5K.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $gUd5K.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8Ur7X.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $9b2be399c33e787c$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $iQFxy.serializeStyles)(args);
}
function $9b2be399c33e787c$export$d25ddfdf17c3ad3e() {
    var insertable = $9b2be399c33e787c$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $9b2be399c33e787c$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $9b2be399c33e787c$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8Ur7X.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $9b2be399c33e787c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $gUd5K.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8Ur7X.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $jjrEh.i) && res !== undefined) rules += res;
        }
        if (!(0, $jjrEh.i)) return rules;
    });
    if (!(0, $jjrEh.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $1Pgvo.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9b2be399c33e787c$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $jjrEh.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $jjrEh.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $iQFxy.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8Ur7X.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $jjrEh.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $9b2be399c33e787c$var$merge(cache.registered, css, $9b2be399c33e787c$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $1Pgvo.useContext((0, $jjrEh.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $1Pgvo.createElement($1Pgvo.Fragment, null, /*#__PURE__*/ $1Pgvo.createElement($9b2be399c33e787c$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("jjrEh", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $e0f53d1be8174f8d$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $e0f53d1be8174f8d$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $e0f53d1be8174f8d$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $e0f53d1be8174f8d$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $e0f53d1be8174f8d$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $e0f53d1be8174f8d$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $e0f53d1be8174f8d$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $e0f53d1be8174f8d$export$a9c23c6ac3fc3eca; });

var $1Pgvo = parcelRequire("1Pgvo");

var $68idG = parcelRequire("68idG");

var $gAPAo = parcelRequire("gAPAo");

var $3St5F = parcelRequire("3St5F");

var $cQM6f = parcelRequire("cQM6f");

var $8Ur7X = parcelRequire("8Ur7X");

var $iQFxy = parcelRequire("iQFxy");

var $gUd5K = parcelRequire("gUd5K");
var $e0f53d1be8174f8d$export$407448d2b89b1813 = false;
var $e0f53d1be8174f8d$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $e0f53d1be8174f8d$var$EmotionCacheContext = /* #__PURE__ */ $1Pgvo.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $68idG.default)({
    key: 'css'
}) : null);
var $e0f53d1be8174f8d$export$e7094788287c5e9b = $e0f53d1be8174f8d$var$EmotionCacheContext.Provider;
var $e0f53d1be8174f8d$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $1Pgvo.useContext)($e0f53d1be8174f8d$var$EmotionCacheContext);
};
var $e0f53d1be8174f8d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $1Pgvo.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $1Pgvo.useContext)($e0f53d1be8174f8d$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$e0f53d1be8174f8d$export$23f2a1d2818174ef) $e0f53d1be8174f8d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $1Pgvo.useContext)($e0f53d1be8174f8d$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $68idG.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $1Pgvo.createElement($e0f53d1be8174f8d$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $e0f53d1be8174f8d$export$971d5caa766a69d7 = /* #__PURE__ */ $1Pgvo.createContext({});
var $e0f53d1be8174f8d$export$3b14a55fb2447963 = function useTheme() {
    return $1Pgvo.useContext($e0f53d1be8174f8d$export$971d5caa766a69d7);
};
var $e0f53d1be8174f8d$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $gAPAo.default)({}, outerTheme, theme);
};
var $e0f53d1be8174f8d$var$createCacheWithTheme = /* #__PURE__ */ (0, $3St5F.default)(function(outerTheme) {
    return (0, $3St5F.default)(function(theme) {
        return $e0f53d1be8174f8d$var$getTheme(outerTheme, theme);
    });
});
var $e0f53d1be8174f8d$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $1Pgvo.useContext($e0f53d1be8174f8d$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $e0f53d1be8174f8d$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $1Pgvo.createElement($e0f53d1be8174f8d$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $e0f53d1be8174f8d$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $1Pgvo.forwardRef(function render(props, ref) {
        var theme = $1Pgvo.useContext($e0f53d1be8174f8d$export$971d5caa766a69d7);
        return /*#__PURE__*/ $1Pgvo.createElement(Component, (0, $gAPAo.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $cQM6f.default)(WithTheme, Component);
}
var $e0f53d1be8174f8d$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $e0f53d1be8174f8d$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $e0f53d1be8174f8d$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($e0f53d1be8174f8d$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$e0f53d1be8174f8d$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $e0f53d1be8174f8d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8Ur7X.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $gUd5K.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8Ur7X.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$e0f53d1be8174f8d$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $1Pgvo.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f53d1be8174f8d$var$Emotion = /* #__PURE__ */ $e0f53d1be8174f8d$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$e0f53d1be8174f8d$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8Ur7X.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $iQFxy.serializeStyles)(registeredStyles, undefined, $1Pgvo.useContext($e0f53d1be8174f8d$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($e0f53d1be8174f8d$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $e0f53d1be8174f8d$var$typePropName && !$e0f53d1be8174f8d$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $1Pgvo.createElement($1Pgvo.Fragment, null, /*#__PURE__*/ $1Pgvo.createElement($e0f53d1be8174f8d$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $1Pgvo.createElement(WrappedComponent, newProps));
});
var $e0f53d1be8174f8d$export$a9c23c6ac3fc3eca = $e0f53d1be8174f8d$var$Emotion;

});
parcelRegister("68idG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47719f790d5f7756$export$2e2bcd8739ae039; });

var $9J2xH = parcelRequire("9J2xH");

var $fQNjW = parcelRequire("fQNjW");

var $3St5F = parcelRequire("3St5F");

var $hIcDp = parcelRequire("hIcDp");
var $47719f790d5f7756$var$isBrowser = typeof document !== 'undefined';
var $47719f790d5f7756$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fQNjW.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fQNjW.token)(character)) break;
        (0, $fQNjW.next)();
    }
    return (0, $fQNjW.slice)(begin, (0, $fQNjW.position));
};
var $47719f790d5f7756$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fQNjW.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fQNjW.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $47719f790d5f7756$var$identifierWithPointTracking((0, $fQNjW.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fQNjW.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fQNjW.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fQNjW.from)(character);
    }
    while (character = (0, $fQNjW.next)());
    return parsed;
};
var $47719f790d5f7756$var$getRules = function getRules(value, points) {
    return (0, $fQNjW.dealloc)($47719f790d5f7756$var$toRules((0, $fQNjW.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $47719f790d5f7756$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $47719f790d5f7756$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$47719f790d5f7756$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $47719f790d5f7756$var$fixedElements.set(element, true);
    var points = [];
    var rules = $47719f790d5f7756$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $47719f790d5f7756$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $47719f790d5f7756$var$prefix(value, length) {
    switch((0, $fQNjW.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fQNjW.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fQNjW.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MOZ) + value + (0, $fQNjW.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MS) + value + value;
        // order
        case 6165:
            return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.replace)(value, /(\w+).+(:[^]+)/, (0, $fQNjW.WEBKIT) + 'box-$1$2' + (0, $fQNjW.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MS) + 'flex-item-' + (0, $fQNjW.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MS) + 'flex-line-pack' + (0, $fQNjW.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MS) + (0, $fQNjW.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MS) + (0, $fQNjW.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fQNjW.WEBKIT) + 'box-' + (0, $fQNjW.replace)(value, '-grow', '') + (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MS) + (0, $fQNjW.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fQNjW.WEBKIT) + (0, $fQNjW.replace)(value, /([^-])(transform)/g, '$1' + (0, $fQNjW.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fQNjW.replace)((0, $fQNjW.replace)((0, $fQNjW.replace)(value, /(zoom-|grab)/, (0, $fQNjW.WEBKIT) + '$1'), /(image-set)/, (0, $fQNjW.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fQNjW.replace)(value, /(image-set\([^]*)/, (0, $fQNjW.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fQNjW.replace)((0, $fQNjW.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fQNjW.WEBKIT) + 'box-pack:$3' + (0, $fQNjW.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fQNjW.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fQNjW.replace)(value, /(.+)-inline(.+)/, (0, $fQNjW.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fQNjW.strlen)(value) - 1 - length > 6) switch((0, $fQNjW.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fQNjW.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fQNjW.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fQNjW.WEBKIT) + '$2-$3' + '$1' + (0, $fQNjW.MOZ) + ((0, $fQNjW.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fQNjW.indexof)(value, 'stretch') ? $47719f790d5f7756$var$prefix((0, $fQNjW.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fQNjW.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fQNjW.charat)(value, (0, $fQNjW.strlen)(value) - 3 - (~(0, $fQNjW.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fQNjW.replace)(value, ':', ':' + (0, $fQNjW.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fQNjW.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fQNjW.WEBKIT) + ((0, $fQNjW.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fQNjW.WEBKIT) + '$2$3' + '$1' + (0, $fQNjW.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fQNjW.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MS) + (0, $fQNjW.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MS) + (0, $fQNjW.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MS) + (0, $fQNjW.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fQNjW.WEBKIT) + value + (0, $fQNjW.MS) + value + value;
    }
    return value;
}
var $47719f790d5f7756$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fQNjW.DECLARATION:
                element["return"] = $47719f790d5f7756$var$prefix(element.value, element.length);
                break;
            case 0, $fQNjW.KEYFRAMES:
                return (0, $fQNjW.serialize)([
                    (0, $fQNjW.copy)(element, {
                        value: (0, $fQNjW.replace)(element.value, '@', '@' + (0, $fQNjW.WEBKIT))
                    })
                ], callback);
            case 0, $fQNjW.RULESET:
                if (element.length) return (0, $fQNjW.combine)(element.props, function(value) {
                    switch((0, $fQNjW.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fQNjW.serialize)([
                                (0, $fQNjW.copy)(element, {
                                    props: [
                                        (0, $fQNjW.replace)(value, /:(read-\w+)/, ':' + (0, $fQNjW.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fQNjW.serialize)([
                                (0, $fQNjW.copy)(element, {
                                    props: [
                                        (0, $fQNjW.replace)(value, /:(plac\w+)/, ':' + (0, $fQNjW.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fQNjW.copy)(element, {
                                    props: [
                                        (0, $fQNjW.replace)(value, /:(plac\w+)/, ':' + (0, $fQNjW.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fQNjW.copy)(element, {
                                    props: [
                                        (0, $fQNjW.replace)(value, /:(plac\w+)/, (0, $fQNjW.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $47719f790d5f7756$var$getServerStylisCache = $47719f790d5f7756$var$isBrowser ? undefined : (0, $3St5F.default)(function() {
    return (0, $hIcDp.default)(function() {
        return {};
    });
});
var $47719f790d5f7756$var$defaultStylisPlugins = [
    $47719f790d5f7756$var$prefixer
];
var $47719f790d5f7756$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($47719f790d5f7756$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $47719f790d5f7756$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($47719f790d5f7756$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $47719f790d5f7756$var$compat,
        $47719f790d5f7756$var$removeLabel
    ];
    if (!$47719f790d5f7756$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fQNjW.stringify),
            (0, $fQNjW.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fQNjW.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fQNjW.serialize)((0, $fQNjW.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fQNjW.stringify)
        ];
        var _serializer = (0, $fQNjW.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fQNjW.serialize)((0, $fQNjW.compile)(styles), _serializer);
        };
        var serverStylisCache = $47719f790d5f7756$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $9J2xH.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("9J2xH", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $714a49f1644db3d6$export$9d753cd7ae895cce; });
var $714a49f1644db3d6$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $714a49f1644db3d6$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $714a49f1644db3d6$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $714a49f1644db3d6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$714a49f1644db3d6$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($714a49f1644db3d6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $714a49f1644db3d6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fQNjW", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $48bb63c5fa4ba7fa$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $48bb63c5fa4ba7fa$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $48bb63c5fa4ba7fa$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $48bb63c5fa4ba7fa$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $48bb63c5fa4ba7fa$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $48bb63c5fa4ba7fa$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $48bb63c5fa4ba7fa$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $48bb63c5fa4ba7fa$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $48bb63c5fa4ba7fa$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $48bb63c5fa4ba7fa$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $48bb63c5fa4ba7fa$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $48bb63c5fa4ba7fa$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $48bb63c5fa4ba7fa$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $48bb63c5fa4ba7fa$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $48bb63c5fa4ba7fa$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $48bb63c5fa4ba7fa$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $48bb63c5fa4ba7fa$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $48bb63c5fa4ba7fa$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $48bb63c5fa4ba7fa$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $48bb63c5fa4ba7fa$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $48bb63c5fa4ba7fa$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $48bb63c5fa4ba7fa$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $48bb63c5fa4ba7fa$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $48bb63c5fa4ba7fa$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $48bb63c5fa4ba7fa$export$38bcb760f1d4871c; });
var $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 = "-ms-";
var $48bb63c5fa4ba7fa$export$2c0f367103c8d01c = "-moz-";
var $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 = "-webkit-";
var $48bb63c5fa4ba7fa$export$a29989082612d0d9 = "comm";
var $48bb63c5fa4ba7fa$export$aa3a2e812ca8570d = "rule";
var $48bb63c5fa4ba7fa$export$527d108ccf083c2b = "decl";
var $48bb63c5fa4ba7fa$export$d3d35020fa5b54f0 = "@page";
var $48bb63c5fa4ba7fa$export$500415a86c544f73 = "@media";
var $48bb63c5fa4ba7fa$export$a763edbf796b780a = "@import";
var $48bb63c5fa4ba7fa$export$2790aeb8b4e5c826 = "@charset";
var $48bb63c5fa4ba7fa$export$1cc683e23b84b133 = "@viewport";
var $48bb63c5fa4ba7fa$export$9447a5efea57e862 = "@supports";
var $48bb63c5fa4ba7fa$export$ef011b4e114b1fba = "@document";
var $48bb63c5fa4ba7fa$export$6aad947bda0f3f46 = "@namespace";
var $48bb63c5fa4ba7fa$export$b44a8529a35fcb60 = "@keyframes";
var $48bb63c5fa4ba7fa$export$2c16de31893252e6 = "@font-face";
var $48bb63c5fa4ba7fa$export$3d846dd52e150c6f = "@counter-style";
var $48bb63c5fa4ba7fa$export$22314bfbb57653fe = "@font-feature-values";
var $48bb63c5fa4ba7fa$export$d773506282b3cfe6 = "@layer";
var $48bb63c5fa4ba7fa$export$2335f513bbd82c6d = Math.abs;
var $48bb63c5fa4ba7fa$export$6788812c4e6611e6 = String.fromCharCode;
var $48bb63c5fa4ba7fa$export$e6e34fd1f2686227 = Object.assign;
function $48bb63c5fa4ba7fa$export$d6af199866bfb566(e, r) {
    return $48bb63c5fa4ba7fa$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $48bb63c5fa4ba7fa$export$a9db5e087081082d(e, 0)) << 2 ^ $48bb63c5fa4ba7fa$export$a9db5e087081082d(e, 1)) << 2 ^ $48bb63c5fa4ba7fa$export$a9db5e087081082d(e, 2)) << 2 ^ $48bb63c5fa4ba7fa$export$a9db5e087081082d(e, 3) : 0;
}
function $48bb63c5fa4ba7fa$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $48bb63c5fa4ba7fa$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $48bb63c5fa4ba7fa$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $48bb63c5fa4ba7fa$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $48bb63c5fa4ba7fa$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $48bb63c5fa4ba7fa$export$36776f635604f274(e) {
    return e.length;
}
function $48bb63c5fa4ba7fa$export$f9084667e487ed46(e) {
    return e.length;
}
function $48bb63c5fa4ba7fa$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $48bb63c5fa4ba7fa$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $48bb63c5fa4ba7fa$export$53f1d5ea8de3d7c = 1;
var $48bb63c5fa4ba7fa$export$4e0c71f277ca26b3 = 1;
var $48bb63c5fa4ba7fa$export$f24224f1c91d8156 = 0;
var $48bb63c5fa4ba7fa$export$5880b8b5730aff45 = 0;
var $48bb63c5fa4ba7fa$export$c0306caf338ac095 = 0;
var $48bb63c5fa4ba7fa$export$30a86d91af8ff6e6 = "";
function $48bb63c5fa4ba7fa$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $48bb63c5fa4ba7fa$export$53f1d5ea8de3d7c,
        column: $48bb63c5fa4ba7fa$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $48bb63c5fa4ba7fa$export$784d13d8ee351f07(e, r) {
    return $48bb63c5fa4ba7fa$export$e6e34fd1f2686227($48bb63c5fa4ba7fa$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $48bb63c5fa4ba7fa$export$eba6f6f03b0a92e7() {
    return $48bb63c5fa4ba7fa$export$c0306caf338ac095;
}
function $48bb63c5fa4ba7fa$export$232faf9add678146() {
    $48bb63c5fa4ba7fa$export$c0306caf338ac095 = $48bb63c5fa4ba7fa$export$5880b8b5730aff45 > 0 ? $48bb63c5fa4ba7fa$export$a9db5e087081082d($48bb63c5fa4ba7fa$export$30a86d91af8ff6e6, --$48bb63c5fa4ba7fa$export$5880b8b5730aff45) : 0;
    if ($48bb63c5fa4ba7fa$export$4e0c71f277ca26b3--, $48bb63c5fa4ba7fa$export$c0306caf338ac095 === 10) $48bb63c5fa4ba7fa$export$4e0c71f277ca26b3 = 1, $48bb63c5fa4ba7fa$export$53f1d5ea8de3d7c--;
    return $48bb63c5fa4ba7fa$export$c0306caf338ac095;
}
function $48bb63c5fa4ba7fa$export$48cfd1e771a65c4f() {
    $48bb63c5fa4ba7fa$export$c0306caf338ac095 = $48bb63c5fa4ba7fa$export$5880b8b5730aff45 < $48bb63c5fa4ba7fa$export$f24224f1c91d8156 ? $48bb63c5fa4ba7fa$export$a9db5e087081082d($48bb63c5fa4ba7fa$export$30a86d91af8ff6e6, $48bb63c5fa4ba7fa$export$5880b8b5730aff45++) : 0;
    if ($48bb63c5fa4ba7fa$export$4e0c71f277ca26b3++, $48bb63c5fa4ba7fa$export$c0306caf338ac095 === 10) $48bb63c5fa4ba7fa$export$4e0c71f277ca26b3 = 1, $48bb63c5fa4ba7fa$export$53f1d5ea8de3d7c++;
    return $48bb63c5fa4ba7fa$export$c0306caf338ac095;
}
function $48bb63c5fa4ba7fa$export$4d3fb11e950abb9e() {
    return $48bb63c5fa4ba7fa$export$a9db5e087081082d($48bb63c5fa4ba7fa$export$30a86d91af8ff6e6, $48bb63c5fa4ba7fa$export$5880b8b5730aff45);
}
function $48bb63c5fa4ba7fa$export$e88cb2efb12ae807() {
    return $48bb63c5fa4ba7fa$export$5880b8b5730aff45;
}
function $48bb63c5fa4ba7fa$export$58adb3bec8346d0f(e, r) {
    return $48bb63c5fa4ba7fa$export$2f35ab04d2335697($48bb63c5fa4ba7fa$export$30a86d91af8ff6e6, e, r);
}
function $48bb63c5fa4ba7fa$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $48bb63c5fa4ba7fa$export$2de70f21292aac9e(e) {
    return $48bb63c5fa4ba7fa$export$53f1d5ea8de3d7c = $48bb63c5fa4ba7fa$export$4e0c71f277ca26b3 = 1, $48bb63c5fa4ba7fa$export$f24224f1c91d8156 = $48bb63c5fa4ba7fa$export$36776f635604f274($48bb63c5fa4ba7fa$export$30a86d91af8ff6e6 = e), $48bb63c5fa4ba7fa$export$5880b8b5730aff45 = 0, [];
}
function $48bb63c5fa4ba7fa$export$45918ac1574455b1(e) {
    return $48bb63c5fa4ba7fa$export$30a86d91af8ff6e6 = "", e;
}
function $48bb63c5fa4ba7fa$export$410ac95b9ec204b8(e) {
    return $48bb63c5fa4ba7fa$export$87c2784dc9fc4ab($48bb63c5fa4ba7fa$export$58adb3bec8346d0f($48bb63c5fa4ba7fa$export$5880b8b5730aff45 - 1, $48bb63c5fa4ba7fa$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $48bb63c5fa4ba7fa$export$660b2ee2d4fb4eff(e) {
    return $48bb63c5fa4ba7fa$export$45918ac1574455b1($48bb63c5fa4ba7fa$export$5f8c09e3ae6f64e1($48bb63c5fa4ba7fa$export$2de70f21292aac9e(e)));
}
function $48bb63c5fa4ba7fa$export$7af1228ff777d175(e) {
    while($48bb63c5fa4ba7fa$export$c0306caf338ac095 = $48bb63c5fa4ba7fa$export$4d3fb11e950abb9e())if ($48bb63c5fa4ba7fa$export$c0306caf338ac095 < 33) $48bb63c5fa4ba7fa$export$48cfd1e771a65c4f();
    else break;
    return $48bb63c5fa4ba7fa$export$9e1725a4cfeada27(e) > 2 || $48bb63c5fa4ba7fa$export$9e1725a4cfeada27($48bb63c5fa4ba7fa$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $48bb63c5fa4ba7fa$export$5f8c09e3ae6f64e1(e) {
    while($48bb63c5fa4ba7fa$export$48cfd1e771a65c4f())switch($48bb63c5fa4ba7fa$export$9e1725a4cfeada27($48bb63c5fa4ba7fa$export$c0306caf338ac095)){
        case 0:
            $48bb63c5fa4ba7fa$export$10d8903dec122b9d($48bb63c5fa4ba7fa$export$c2ab62c7bf24634($48bb63c5fa4ba7fa$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $48bb63c5fa4ba7fa$export$10d8903dec122b9d($48bb63c5fa4ba7fa$export$410ac95b9ec204b8($48bb63c5fa4ba7fa$export$c0306caf338ac095), e);
            break;
        default:
            $48bb63c5fa4ba7fa$export$10d8903dec122b9d($48bb63c5fa4ba7fa$export$6788812c4e6611e6($48bb63c5fa4ba7fa$export$c0306caf338ac095), e);
    }
    return e;
}
function $48bb63c5fa4ba7fa$export$955ba06d119e085e(e, r) {
    while(--r && $48bb63c5fa4ba7fa$export$48cfd1e771a65c4f())if ($48bb63c5fa4ba7fa$export$c0306caf338ac095 < 48 || $48bb63c5fa4ba7fa$export$c0306caf338ac095 > 102 || $48bb63c5fa4ba7fa$export$c0306caf338ac095 > 57 && $48bb63c5fa4ba7fa$export$c0306caf338ac095 < 65 || $48bb63c5fa4ba7fa$export$c0306caf338ac095 > 70 && $48bb63c5fa4ba7fa$export$c0306caf338ac095 < 97) break;
    return $48bb63c5fa4ba7fa$export$58adb3bec8346d0f(e, $48bb63c5fa4ba7fa$export$e88cb2efb12ae807() + (r < 6 && $48bb63c5fa4ba7fa$export$4d3fb11e950abb9e() == 32 && $48bb63c5fa4ba7fa$export$48cfd1e771a65c4f() == 32));
}
function $48bb63c5fa4ba7fa$export$c889f2fcc19dbf12(e) {
    while($48bb63c5fa4ba7fa$export$48cfd1e771a65c4f())switch($48bb63c5fa4ba7fa$export$c0306caf338ac095){
        case e:
            return $48bb63c5fa4ba7fa$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $48bb63c5fa4ba7fa$export$c889f2fcc19dbf12($48bb63c5fa4ba7fa$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $48bb63c5fa4ba7fa$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $48bb63c5fa4ba7fa$export$48cfd1e771a65c4f();
            break;
    }
    return $48bb63c5fa4ba7fa$export$5880b8b5730aff45;
}
function $48bb63c5fa4ba7fa$export$4254d4e2b3745c4c(e, r) {
    while($48bb63c5fa4ba7fa$export$48cfd1e771a65c4f())if (e + $48bb63c5fa4ba7fa$export$c0306caf338ac095 === 57) break;
    else if (e + $48bb63c5fa4ba7fa$export$c0306caf338ac095 === 84 && $48bb63c5fa4ba7fa$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $48bb63c5fa4ba7fa$export$58adb3bec8346d0f(r, $48bb63c5fa4ba7fa$export$5880b8b5730aff45 - 1) + "*" + $48bb63c5fa4ba7fa$export$6788812c4e6611e6(e === 47 ? e : $48bb63c5fa4ba7fa$export$48cfd1e771a65c4f());
}
function $48bb63c5fa4ba7fa$export$c2ab62c7bf24634(e) {
    while(!$48bb63c5fa4ba7fa$export$9e1725a4cfeada27($48bb63c5fa4ba7fa$export$4d3fb11e950abb9e()))$48bb63c5fa4ba7fa$export$48cfd1e771a65c4f();
    return $48bb63c5fa4ba7fa$export$58adb3bec8346d0f(e, $48bb63c5fa4ba7fa$export$5880b8b5730aff45);
}
function $48bb63c5fa4ba7fa$export$ef7acd7185315e22(e) {
    return $48bb63c5fa4ba7fa$export$45918ac1574455b1($48bb63c5fa4ba7fa$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $48bb63c5fa4ba7fa$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $48bb63c5fa4ba7fa$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $48bb63c5fa4ba7fa$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $48bb63c5fa4ba7fa$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($48bb63c5fa4ba7fa$export$f8e21b1e77979a08(j += $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed($48bb63c5fa4ba7fa$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $48bb63c5fa4ba7fa$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $48bb63c5fa4ba7fa$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $48bb63c5fa4ba7fa$export$955ba06d119e085e($48bb63c5fa4ba7fa$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($48bb63c5fa4ba7fa$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $48bb63c5fa4ba7fa$export$10d8903dec122b9d($48bb63c5fa4ba7fa$export$4a34f930e789283c($48bb63c5fa4ba7fa$export$4254d4e2b3745c4c($48bb63c5fa4ba7fa$export$48cfd1e771a65c4f(), $48bb63c5fa4ba7fa$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $48bb63c5fa4ba7fa$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $48bb63c5fa4ba7fa$export$36776f635604f274(j) - l) $48bb63c5fa4ba7fa$export$10d8903dec122b9d(p > 32 ? $48bb63c5fa4ba7fa$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $48bb63c5fa4ba7fa$export$f8483753829ec8f3($48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $48bb63c5fa4ba7fa$export$10d8903dec122b9d(y = $48bb63c5fa4ba7fa$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $48bb63c5fa4ba7fa$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $48bb63c5fa4ba7fa$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $48bb63c5fa4ba7fa$export$98e6a39c04603d36(e, y, y, n && $48bb63c5fa4ba7fa$export$10d8903dec122b9d($48bb63c5fa4ba7fa$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $48bb63c5fa4ba7fa$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $48bb63c5fa4ba7fa$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $48bb63c5fa4ba7fa$export$232faf9add678146() == 125) continue;
            }
            switch(j += $48bb63c5fa4ba7fa$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($48bb63c5fa4ba7fa$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($48bb63c5fa4ba7fa$export$4d3fb11e950abb9e() === 45) j += $48bb63c5fa4ba7fa$export$410ac95b9ec204b8($48bb63c5fa4ba7fa$export$48cfd1e771a65c4f());
                    v = $48bb63c5fa4ba7fa$export$4d3fb11e950abb9e(), o = l = $48bb63c5fa4ba7fa$export$36776f635604f274(g = j += $48bb63c5fa4ba7fa$export$c2ab62c7bf24634($48bb63c5fa4ba7fa$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $48bb63c5fa4ba7fa$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $48bb63c5fa4ba7fa$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $48bb63c5fa4ba7fa$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $48bb63c5fa4ba7fa$export$2f35ab04d2335697(e, v + 1, v = $48bb63c5fa4ba7fa$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $48bb63c5fa4ba7fa$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $48bb63c5fa4ba7fa$export$35059013cd4a06db(e, r, a, s === 0 ? $48bb63c5fa4ba7fa$export$aa3a2e812ca8570d : i, f, o, l);
}
function $48bb63c5fa4ba7fa$export$4a34f930e789283c(e, r, a) {
    return $48bb63c5fa4ba7fa$export$35059013cd4a06db(e, r, a, $48bb63c5fa4ba7fa$export$a29989082612d0d9, $48bb63c5fa4ba7fa$export$6788812c4e6611e6($48bb63c5fa4ba7fa$export$eba6f6f03b0a92e7()), $48bb63c5fa4ba7fa$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $48bb63c5fa4ba7fa$export$f8483753829ec8f3(e, r, a, n) {
    return $48bb63c5fa4ba7fa$export$35059013cd4a06db(e, r, a, $48bb63c5fa4ba7fa$export$527d108ccf083c2b, $48bb63c5fa4ba7fa$export$2f35ab04d2335697(e, 0, n), $48bb63c5fa4ba7fa$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $48bb63c5fa4ba7fa$export$82e9f45cca5ba907(n, c, s) {
    switch($48bb63c5fa4ba7fa$export$d6af199866bfb566(n, c)){
        case 5103:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $48bb63c5fa4ba7fa$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$2c0f367103c8d01c + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($48bb63c5fa4ba7fa$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "box-$1$2" + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + "flex-item-" + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$48bb63c5fa4ba7fa$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + "grid-row-" + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + "flex-line-pack" + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "box-" + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, "-grow", "") + $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed($48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed($48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed($48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "box-pack:$3" + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$48bb63c5fa4ba7fa$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + "grid-column-align" + $48bb63c5fa4ba7fa$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $48bb63c5fa4ba7fa$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$48bb63c5fa4ba7fa$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$48bb63c5fa4ba7fa$export$f8e21b1e77979a08(s, "span") ? $48bb63c5fa4ba7fa$export$4659b591c19bdf3d(s, /\d+/) : +$48bb63c5fa4ba7fa$export$4659b591c19bdf3d(s, /\d+/) - +$48bb63c5fa4ba7fa$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $48bb63c5fa4ba7fa$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed($48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($48bb63c5fa4ba7fa$export$36776f635604f274(n) - 1 - c > 6) switch($48bb63c5fa4ba7fa$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($48bb63c5fa4ba7fa$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $48bb63c5fa4ba7fa$export$2c0f367103c8d01c + ($48bb63c5fa4ba7fa$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$48bb63c5fa4ba7fa$export$f8e21b1e77979a08(n, "stretch") ? $48bb63c5fa4ba7fa$export$82e9f45cca5ba907($48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($48bb63c5fa4ba7fa$export$a9db5e087081082d(n, c + 6) === 121) return $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, ":", ":" + $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($48bb63c5fa4ba7fa$export$a9db5e087081082d(n, $48bb63c5fa4ba7fa$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + ($48bb63c5fa4ba7fa$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, ":", ":" + $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $48bb63c5fa4ba7fa$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $48bb63c5fa4ba7fa$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $48bb63c5fa4ba7fa$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $48bb63c5fa4ba7fa$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $48bb63c5fa4ba7fa$export$a763edbf796b780a:
        case $48bb63c5fa4ba7fa$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $48bb63c5fa4ba7fa$export$a29989082612d0d9:
            return "";
        case $48bb63c5fa4ba7fa$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $48bb63c5fa4ba7fa$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $48bb63c5fa4ba7fa$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $48bb63c5fa4ba7fa$export$36776f635604f274(a = $48bb63c5fa4ba7fa$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $48bb63c5fa4ba7fa$export$5a7767152ae0305f(e) {
    var r = $48bb63c5fa4ba7fa$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $48bb63c5fa4ba7fa$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $48bb63c5fa4ba7fa$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $48bb63c5fa4ba7fa$export$527d108ccf083c2b:
                n.return = $48bb63c5fa4ba7fa$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $48bb63c5fa4ba7fa$export$b44a8529a35fcb60:
                return $48bb63c5fa4ba7fa$export$dfdc1655ccc5b9cb([
                    $48bb63c5fa4ba7fa$export$784d13d8ee351f07(n, {
                        value: $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $48bb63c5fa4ba7fa$export$aa3a2e812ca8570d:
                if (n.length) return $48bb63c5fa4ba7fa$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($48bb63c5fa4ba7fa$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $48bb63c5fa4ba7fa$export$dfdc1655ccc5b9cb([
                                $48bb63c5fa4ba7fa$export$784d13d8ee351f07(n, {
                                    props: [
                                        $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $48bb63c5fa4ba7fa$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $48bb63c5fa4ba7fa$export$dfdc1655ccc5b9cb([
                                $48bb63c5fa4ba7fa$export$784d13d8ee351f07(n, {
                                    props: [
                                        $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $48bb63c5fa4ba7fa$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $48bb63c5fa4ba7fa$export$784d13d8ee351f07(n, {
                                    props: [
                                        $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $48bb63c5fa4ba7fa$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $48bb63c5fa4ba7fa$export$784d13d8ee351f07(n, {
                                    props: [
                                        $48bb63c5fa4ba7fa$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $48bb63c5fa4ba7fa$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $48bb63c5fa4ba7fa$export$76a88f7de6507443(e) {
    switch(e.type){
        case $48bb63c5fa4ba7fa$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $48bb63c5fa4ba7fa$export$1be1fc439b849fdf($48bb63c5fa4ba7fa$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($48bb63c5fa4ba7fa$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $48bb63c5fa4ba7fa$export$2f35ab04d2335697(r, 1, $48bb63c5fa4ba7fa$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $48bb63c5fa4ba7fa$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $48bb63c5fa4ba7fa$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $48bb63c5fa4ba7fa$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("3St5F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d2cfafa65c9c6fa$export$2e2bcd8739ae039; });
var $2d2cfafa65c9c6fa$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("cQM6f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95afa6fbfd930eb6$export$2e2bcd8739ae039; });

var $15YBk = parcelRequire("15YBk");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $95afa6fbfd930eb6$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($15YBk)))(targetComponent, sourceComponent);
};

});
parcelRegister("15YBk", function(module, exports) {
'use strict';

var $hmQha = parcelRequire("hmQha");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $0cc54433546b14dc$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $0cc54433546b14dc$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $0cc54433546b14dc$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $0cc54433546b14dc$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $0cc54433546b14dc$var$TYPE_STATICS = {};
$0cc54433546b14dc$var$TYPE_STATICS[$hmQha.ForwardRef] = $0cc54433546b14dc$var$FORWARD_REF_STATICS;
$0cc54433546b14dc$var$TYPE_STATICS[$hmQha.Memo] = $0cc54433546b14dc$var$MEMO_STATICS;
function $0cc54433546b14dc$var$getStatics(component) {
    // React v16.11 and below
    if ($hmQha.isMemo(component)) return $0cc54433546b14dc$var$MEMO_STATICS;
     // React v16.12 and above
    return $0cc54433546b14dc$var$TYPE_STATICS[component['$$typeof']] || $0cc54433546b14dc$var$REACT_STATICS;
}
var $0cc54433546b14dc$var$defineProperty = Object.defineProperty;
var $0cc54433546b14dc$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $0cc54433546b14dc$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $0cc54433546b14dc$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $0cc54433546b14dc$var$getPrototypeOf = Object.getPrototypeOf;
var $0cc54433546b14dc$var$objectPrototype = Object.prototype;
function $0cc54433546b14dc$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($0cc54433546b14dc$var$objectPrototype) {
            var inheritedComponent = $0cc54433546b14dc$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $0cc54433546b14dc$var$objectPrototype) $0cc54433546b14dc$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $0cc54433546b14dc$var$getOwnPropertyNames(sourceComponent);
        if ($0cc54433546b14dc$var$getOwnPropertySymbols) keys = keys.concat($0cc54433546b14dc$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $0cc54433546b14dc$var$getStatics(targetComponent);
        var sourceStatics = $0cc54433546b14dc$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$0cc54433546b14dc$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $0cc54433546b14dc$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $0cc54433546b14dc$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $0cc54433546b14dc$var$hoistNonReactStatics;

});
parcelRegister("hmQha", function(module, exports) {
'use strict';

module.exports = (parcelRequire("j70ee"));

});
parcelRegister("j70ee", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $de9ed923716d3bd3$export$2b8d127b894957b9; }, function (v) { return $de9ed923716d3bd3$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $de9ed923716d3bd3$export$cea3a54a6425200c; }, function (v) { return $de9ed923716d3bd3$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $de9ed923716d3bd3$export$a7c73072b1a182ae; }, function (v) { return $de9ed923716d3bd3$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $de9ed923716d3bd3$export$9f27bc3417b4524d; }, function (v) { return $de9ed923716d3bd3$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $de9ed923716d3bd3$export$db77ccec0bb4ccac; }, function (v) { return $de9ed923716d3bd3$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $de9ed923716d3bd3$export$8392c0c9d3dcbd35; }, function (v) { return $de9ed923716d3bd3$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $de9ed923716d3bd3$export$ffb0004e005737fa; }, function (v) { return $de9ed923716d3bd3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $de9ed923716d3bd3$export$b624eff549462981; }, function (v) { return $de9ed923716d3bd3$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $de9ed923716d3bd3$export$7897aa7841a5380c; }, function (v) { return $de9ed923716d3bd3$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $de9ed923716d3bd3$export$602eac185826482c; }, function (v) { return $de9ed923716d3bd3$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $de9ed923716d3bd3$export$e2c29f18771995cb; }, function (v) { return $de9ed923716d3bd3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $de9ed923716d3bd3$export$5f8d39834fd61797; }, function (v) { return $de9ed923716d3bd3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $de9ed923716d3bd3$export$74bf444e3cd11ea5; }, function (v) { return $de9ed923716d3bd3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $de9ed923716d3bd3$export$92387174baf9b227; }, function (v) { return $de9ed923716d3bd3$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $de9ed923716d3bd3$export$ec112efeb987d9c6; }, function (v) { return $de9ed923716d3bd3$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $de9ed923716d3bd3$export$b706b080d889d2c9; }, function (v) { return $de9ed923716d3bd3$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $de9ed923716d3bd3$export$5be5a87408f70ddc; }, function (v) { return $de9ed923716d3bd3$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $de9ed923716d3bd3$export$45a5e7f76e0caa8d; }, function (v) { return $de9ed923716d3bd3$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $de9ed923716d3bd3$export$455c2e768291efa6; }, function (v) { return $de9ed923716d3bd3$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $de9ed923716d3bd3$export$9522e17588c12572; }, function (v) { return $de9ed923716d3bd3$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $de9ed923716d3bd3$export$2110ac352bb060b9; }, function (v) { return $de9ed923716d3bd3$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $de9ed923716d3bd3$export$56885ab8b9c456ab; }, function (v) { return $de9ed923716d3bd3$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $de9ed923716d3bd3$export$d927fcb6adf8f9de; }, function (v) { return $de9ed923716d3bd3$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $de9ed923716d3bd3$export$b82d16f27459e05a; }, function (v) { return $de9ed923716d3bd3$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $de9ed923716d3bd3$export$522c17b4f5e123e8; }, function (v) { return $de9ed923716d3bd3$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $de9ed923716d3bd3$export$1aabd8a0274ecfd6; }, function (v) { return $de9ed923716d3bd3$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $de9ed923716d3bd3$export$9b621391a187a31a; }, function (v) { return $de9ed923716d3bd3$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $de9ed923716d3bd3$export$f5bbd400c2f4426f; }, function (v) { return $de9ed923716d3bd3$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $de9ed923716d3bd3$export$2b8d127b894957b9;
var $de9ed923716d3bd3$export$cea3a54a6425200c;
var $de9ed923716d3bd3$export$a7c73072b1a182ae;
var $de9ed923716d3bd3$export$9f27bc3417b4524d;
var $de9ed923716d3bd3$export$db77ccec0bb4ccac;
var $de9ed923716d3bd3$export$8392c0c9d3dcbd35;
var $de9ed923716d3bd3$export$ffb0004e005737fa;
var $de9ed923716d3bd3$export$b624eff549462981;
var $de9ed923716d3bd3$export$7897aa7841a5380c;
var $de9ed923716d3bd3$export$602eac185826482c;
var $de9ed923716d3bd3$export$e2c29f18771995cb;
var $de9ed923716d3bd3$export$5f8d39834fd61797;
var $de9ed923716d3bd3$export$74bf444e3cd11ea5;
var $de9ed923716d3bd3$export$92387174baf9b227;
var $de9ed923716d3bd3$export$ec112efeb987d9c6;
var $de9ed923716d3bd3$export$b706b080d889d2c9;
var $de9ed923716d3bd3$export$5be5a87408f70ddc;
var $de9ed923716d3bd3$export$45a5e7f76e0caa8d;
var $de9ed923716d3bd3$export$455c2e768291efa6;
var $de9ed923716d3bd3$export$9522e17588c12572;
var $de9ed923716d3bd3$export$2110ac352bb060b9;
var $de9ed923716d3bd3$export$56885ab8b9c456ab;
var $de9ed923716d3bd3$export$d927fcb6adf8f9de;
var $de9ed923716d3bd3$export$b82d16f27459e05a;
var $de9ed923716d3bd3$export$522c17b4f5e123e8;
var $de9ed923716d3bd3$export$1aabd8a0274ecfd6;
var $de9ed923716d3bd3$export$9b621391a187a31a;
var $de9ed923716d3bd3$export$f5bbd400c2f4426f;
'use strict';
var $de9ed923716d3bd3$var$b = "function" === typeof Symbol && Symbol.for, $de9ed923716d3bd3$var$c = $de9ed923716d3bd3$var$b ? Symbol.for("react.element") : 60103, $de9ed923716d3bd3$var$d = $de9ed923716d3bd3$var$b ? Symbol.for("react.portal") : 60106, $de9ed923716d3bd3$var$e = $de9ed923716d3bd3$var$b ? Symbol.for("react.fragment") : 60107, $de9ed923716d3bd3$var$f = $de9ed923716d3bd3$var$b ? Symbol.for("react.strict_mode") : 60108, $de9ed923716d3bd3$var$g = $de9ed923716d3bd3$var$b ? Symbol.for("react.profiler") : 60114, $de9ed923716d3bd3$var$h = $de9ed923716d3bd3$var$b ? Symbol.for("react.provider") : 60109, $de9ed923716d3bd3$var$k = $de9ed923716d3bd3$var$b ? Symbol.for("react.context") : 60110, $de9ed923716d3bd3$var$l = $de9ed923716d3bd3$var$b ? Symbol.for("react.async_mode") : 60111, $de9ed923716d3bd3$var$m = $de9ed923716d3bd3$var$b ? Symbol.for("react.concurrent_mode") : 60111, $de9ed923716d3bd3$var$n = $de9ed923716d3bd3$var$b ? Symbol.for("react.forward_ref") : 60112, $de9ed923716d3bd3$var$p = $de9ed923716d3bd3$var$b ? Symbol.for("react.suspense") : 60113, $de9ed923716d3bd3$var$q = $de9ed923716d3bd3$var$b ? Symbol.for("react.suspense_list") : 60120, $de9ed923716d3bd3$var$r = $de9ed923716d3bd3$var$b ? Symbol.for("react.memo") : 60115, $de9ed923716d3bd3$var$t = $de9ed923716d3bd3$var$b ? Symbol.for("react.lazy") : 60116, $de9ed923716d3bd3$var$v = $de9ed923716d3bd3$var$b ? Symbol.for("react.block") : 60121, $de9ed923716d3bd3$var$w = $de9ed923716d3bd3$var$b ? Symbol.for("react.fundamental") : 60117, $de9ed923716d3bd3$var$x = $de9ed923716d3bd3$var$b ? Symbol.for("react.responder") : 60118, $de9ed923716d3bd3$var$y = $de9ed923716d3bd3$var$b ? Symbol.for("react.scope") : 60119;
function $de9ed923716d3bd3$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $de9ed923716d3bd3$var$c:
                switch(a = a.type, a){
                    case $de9ed923716d3bd3$var$l:
                    case $de9ed923716d3bd3$var$m:
                    case $de9ed923716d3bd3$var$e:
                    case $de9ed923716d3bd3$var$g:
                    case $de9ed923716d3bd3$var$f:
                    case $de9ed923716d3bd3$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $de9ed923716d3bd3$var$k:
                            case $de9ed923716d3bd3$var$n:
                            case $de9ed923716d3bd3$var$t:
                            case $de9ed923716d3bd3$var$r:
                            case $de9ed923716d3bd3$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $de9ed923716d3bd3$var$d:
                return u;
        }
    }
}
function $de9ed923716d3bd3$var$A(a) {
    return $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$m;
}
$de9ed923716d3bd3$export$2b8d127b894957b9 = $de9ed923716d3bd3$var$l;
$de9ed923716d3bd3$export$cea3a54a6425200c = $de9ed923716d3bd3$var$m;
$de9ed923716d3bd3$export$a7c73072b1a182ae = $de9ed923716d3bd3$var$k;
$de9ed923716d3bd3$export$9f27bc3417b4524d = $de9ed923716d3bd3$var$h;
$de9ed923716d3bd3$export$db77ccec0bb4ccac = $de9ed923716d3bd3$var$c;
$de9ed923716d3bd3$export$8392c0c9d3dcbd35 = $de9ed923716d3bd3$var$n;
$de9ed923716d3bd3$export$ffb0004e005737fa = $de9ed923716d3bd3$var$e;
$de9ed923716d3bd3$export$b624eff549462981 = $de9ed923716d3bd3$var$t;
$de9ed923716d3bd3$export$7897aa7841a5380c = $de9ed923716d3bd3$var$r;
$de9ed923716d3bd3$export$602eac185826482c = $de9ed923716d3bd3$var$d;
$de9ed923716d3bd3$export$e2c29f18771995cb = $de9ed923716d3bd3$var$g;
$de9ed923716d3bd3$export$5f8d39834fd61797 = $de9ed923716d3bd3$var$f;
$de9ed923716d3bd3$export$74bf444e3cd11ea5 = $de9ed923716d3bd3$var$p;
$de9ed923716d3bd3$export$92387174baf9b227 = function(a) {
    return $de9ed923716d3bd3$var$A(a) || $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$l;
};
$de9ed923716d3bd3$export$ec112efeb987d9c6 = $de9ed923716d3bd3$var$A;
$de9ed923716d3bd3$export$b706b080d889d2c9 = function(a) {
    return $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$k;
};
$de9ed923716d3bd3$export$5be5a87408f70ddc = function(a) {
    return $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$h;
};
$de9ed923716d3bd3$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $de9ed923716d3bd3$var$c;
};
$de9ed923716d3bd3$export$455c2e768291efa6 = function(a) {
    return $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$n;
};
$de9ed923716d3bd3$export$9522e17588c12572 = function(a) {
    return $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$e;
};
$de9ed923716d3bd3$export$2110ac352bb060b9 = function(a) {
    return $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$t;
};
$de9ed923716d3bd3$export$56885ab8b9c456ab = function(a) {
    return $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$r;
};
$de9ed923716d3bd3$export$d927fcb6adf8f9de = function(a) {
    return $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$d;
};
$de9ed923716d3bd3$export$b82d16f27459e05a = function(a) {
    return $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$g;
};
$de9ed923716d3bd3$export$522c17b4f5e123e8 = function(a) {
    return $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$f;
};
$de9ed923716d3bd3$export$1aabd8a0274ecfd6 = function(a) {
    return $de9ed923716d3bd3$var$z(a) === $de9ed923716d3bd3$var$p;
};
$de9ed923716d3bd3$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $de9ed923716d3bd3$var$e || a === $de9ed923716d3bd3$var$m || a === $de9ed923716d3bd3$var$g || a === $de9ed923716d3bd3$var$f || a === $de9ed923716d3bd3$var$p || a === $de9ed923716d3bd3$var$q || "object" === typeof a && null !== a && (a.$$typeof === $de9ed923716d3bd3$var$t || a.$$typeof === $de9ed923716d3bd3$var$r || a.$$typeof === $de9ed923716d3bd3$var$h || a.$$typeof === $de9ed923716d3bd3$var$k || a.$$typeof === $de9ed923716d3bd3$var$n || a.$$typeof === $de9ed923716d3bd3$var$w || a.$$typeof === $de9ed923716d3bd3$var$x || a.$$typeof === $de9ed923716d3bd3$var$y || a.$$typeof === $de9ed923716d3bd3$var$v);
};
$de9ed923716d3bd3$export$f5bbd400c2f4426f = $de9ed923716d3bd3$var$z;

});




parcelRegister("8Ur7X", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $67c898a170a4d8cc$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $67c898a170a4d8cc$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $67c898a170a4d8cc$export$6f077d94b33a01aa; });
var $67c898a170a4d8cc$var$isBrowser = typeof document !== 'undefined';
function $67c898a170a4d8cc$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $67c898a170a4d8cc$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $67c898a170a4d8cc$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $67c898a170a4d8cc$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $67c898a170a4d8cc$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$67c898a170a4d8cc$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$67c898a170a4d8cc$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("iQFxy", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $db8d4e57985688ef$export$6321afa313b251b5; });

var $cxB5g = parcelRequire("cxB5g");

var $9LGRU = parcelRequire("9LGRU");

var $hIcDp = parcelRequire("hIcDp");
var $db8d4e57985688ef$var$isDevelopment = false;
var $db8d4e57985688ef$var$hyphenateRegex = /[A-Z]|^ms/g;
var $db8d4e57985688ef$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $db8d4e57985688ef$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $db8d4e57985688ef$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $db8d4e57985688ef$var$processStyleName = /* #__PURE__ */ (0, $hIcDp.default)(function(styleName) {
    return $db8d4e57985688ef$var$isCustomProperty(styleName) ? styleName : styleName.replace($db8d4e57985688ef$var$hyphenateRegex, '-$&').toLowerCase();
});
var $db8d4e57985688ef$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($db8d4e57985688ef$var$animationRegex, function(match, p1, p2) {
                $db8d4e57985688ef$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $db8d4e57985688ef$var$cursor
                };
                return p1;
            });
    }
    if ((0, $9LGRU.default)[key] !== 1 && !$db8d4e57985688ef$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $db8d4e57985688ef$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $db8d4e57985688ef$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $db8d4e57985688ef$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $db8d4e57985688ef$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $db8d4e57985688ef$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $db8d4e57985688ef$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $db8d4e57985688ef$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $db8d4e57985688ef$var$cursor;
                var result = interpolation(mergedProps);
                $db8d4e57985688ef$var$cursor = previousCursor;
                return $db8d4e57985688ef$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $db8d4e57985688ef$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $db8d4e57985688ef$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($db8d4e57985688ef$var$isProcessableValue(asString)) string += $db8d4e57985688ef$var$processStyleName(key) + ":" + $db8d4e57985688ef$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $db8d4e57985688ef$var$isDevelopment) throw new Error($db8d4e57985688ef$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($db8d4e57985688ef$var$isProcessableValue(value[_i])) string += $db8d4e57985688ef$var$processStyleName(key) + ":" + $db8d4e57985688ef$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $db8d4e57985688ef$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $db8d4e57985688ef$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $db8d4e57985688ef$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $db8d4e57985688ef$var$cursor;
function $db8d4e57985688ef$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $db8d4e57985688ef$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $db8d4e57985688ef$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $db8d4e57985688ef$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $db8d4e57985688ef$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $db8d4e57985688ef$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $cxB5g.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $db8d4e57985688ef$var$cursor
    };
}

});
parcelRegister("cxB5g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9215552ce79661dc$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $9215552ce79661dc$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("9LGRU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71c9c1a0f022c71a$export$2e2bcd8739ae039; });
var $71c9c1a0f022c71a$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("gUd5K", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $c4ec080df4a89115$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $c4ec080df4a89115$export$811a713a7276cb9d; });

var $1Pgvo = parcelRequire("1Pgvo");
var $c4ec080df4a89115$var$isBrowser = typeof document !== 'undefined';
var $c4ec080df4a89115$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c4ec080df4a89115$var$useInsertionEffect = $1Pgvo.useInsertionEffect ? $1Pgvo.useInsertionEffect : false;
var $c4ec080df4a89115$export$db21c7ffa21794e7 = !$c4ec080df4a89115$var$isBrowser ? $c4ec080df4a89115$var$syncFallback : $c4ec080df4a89115$var$useInsertionEffect || $c4ec080df4a89115$var$syncFallback;
var $c4ec080df4a89115$export$811a713a7276cb9d = $c4ec080df4a89115$var$useInsertionEffect || $1Pgvo.useLayoutEffect;

});


parcelRegister("9IPVu", function(module, exports) {
function $71408099ffb92b40$var$_extends() {
    return module.exports = $71408099ffb92b40$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $71408099ffb92b40$var$_extends.apply(null, arguments);
}
module.exports = $71408099ffb92b40$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("jokI8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1e052fb45b49e61$export$2e2bcd8739ae039; });

var $1Pgvo = parcelRequire("1Pgvo");


var $jjrEh = parcelRequire("jjrEh");

var $68idG = parcelRequire("68idG");

var $9J2xH = parcelRequire("9J2xH");

var $j6whP = parcelRequire("j6whP");
'use client';
const $e1e052fb45b49e61$var$cacheMap = new Map();
const $e1e052fb45b49e61$export$5a3f4e255fc47e86 = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $e1e052fb45b49e61$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $68idG.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $e1e052fb45b49e61$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $e1e052fb45b49e61$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$e1e052fb45b49e61$var$insertionPoint) {
        $e1e052fb45b49e61$var$insertionPoint = document.createElement('meta');
        $e1e052fb45b49e61$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $e1e052fb45b49e61$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($e1e052fb45b49e61$var$insertionPoint);
    }
}
function $e1e052fb45b49e61$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends (0, $9J2xH.StyleSheet) {
            insert(rule, options) {
                if ($e1e052fb45b49e61$export$5a3f4e255fc47e86.insert) return $e1e052fb45b49e61$export$5a3f4e255fc47e86.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $e1e052fb45b49e61$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $e1e052fb45b49e61$var$createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? $e1e052fb45b49e61$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.startsWith('@layer')) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $e1e052fb45b49e61$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $1Pgvo.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if ($e1e052fb45b49e61$var$cacheMap.has(cacheKey)) return $e1e052fb45b49e61$var$cacheMap.get(cacheKey);
        const fresh = $e1e052fb45b49e61$var$getCache(injectFirst, enableCssLayer);
        $e1e052fb45b49e61$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $j6whP.jsx)((0, $jjrEh.C), {
        value: cache,
        children: children
    }) : children;
}

});
parcelRegister("j6whP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9twll"));

});


parcelRegister("fmb6q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2e185d381466404$export$2e2bcd8739ae039; });
parcelRequire("1Pgvo");


var $djYnP = parcelRequire("djYnP");

var $j6whP = parcelRequire("j6whP");
'use client';
function $b2e185d381466404$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $b2e185d381466404$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($b2e185d381466404$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $djYnP.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("cWnbn", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $96bce259d6a7bd4d$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $96bce259d6a7bd4d$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $96bce259d6a7bd4d$var$_deepmerge.default;
    }
});

var $96bce259d6a7bd4d$var$_deepmerge = $96bce259d6a7bd4d$require$_interopRequireWildcard((parcelRequire("bEMuw")));
Object.keys($96bce259d6a7bd4d$var$_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($96bce259d6a7bd4d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $96bce259d6a7bd4d$var$_deepmerge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $96bce259d6a7bd4d$var$_deepmerge[key];
        }
    });
});

});
parcelRegister("bEMuw", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $87c90b7d4194768d$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $87c90b7d4194768d$var$deepmerge;
module.exports.isPlainObject = $87c90b7d4194768d$var$isPlainObject;

var $87c90b7d4194768d$var$React = $87c90b7d4194768d$require$_interopRequireWildcard((parcelRequire("1Pgvo")));

var $3ltko = parcelRequire("3ltko");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $87c90b7d4194768d$var$isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $87c90b7d4194768d$var$deepClone(source) {
    if (/*#__PURE__*/ $87c90b7d4194768d$var$React.isValidElement(source) || (0, $3ltko.isValidElementType)(source) || !$87c90b7d4194768d$var$isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $87c90b7d4194768d$var$deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function $87c90b7d4194768d$var$deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($87c90b7d4194768d$var$isPlainObject(target) && $87c90b7d4194768d$var$isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $87c90b7d4194768d$var$React.isValidElement(source[key]) || (0, $3ltko.isValidElementType)(source[key])) output[key] = source[key];
        else if ($87c90b7d4194768d$var$isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $87c90b7d4194768d$var$isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $87c90b7d4194768d$var$deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = $87c90b7d4194768d$var$isPlainObject(source[key]) ? $87c90b7d4194768d$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("3ltko", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cRVaQ"));

});
parcelRegister("cRVaQ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $95e6c8d3ebfcab00$export$a7c73072b1a182ae; }, function (v) { return $95e6c8d3ebfcab00$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $95e6c8d3ebfcab00$export$9f27bc3417b4524d; }, function (v) { return $95e6c8d3ebfcab00$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $95e6c8d3ebfcab00$export$db77ccec0bb4ccac; }, function (v) { return $95e6c8d3ebfcab00$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $95e6c8d3ebfcab00$export$8392c0c9d3dcbd35; }, function (v) { return $95e6c8d3ebfcab00$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $95e6c8d3ebfcab00$export$ffb0004e005737fa; }, function (v) { return $95e6c8d3ebfcab00$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $95e6c8d3ebfcab00$export$b624eff549462981; }, function (v) { return $95e6c8d3ebfcab00$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $95e6c8d3ebfcab00$export$7897aa7841a5380c; }, function (v) { return $95e6c8d3ebfcab00$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $95e6c8d3ebfcab00$export$602eac185826482c; }, function (v) { return $95e6c8d3ebfcab00$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $95e6c8d3ebfcab00$export$e2c29f18771995cb; }, function (v) { return $95e6c8d3ebfcab00$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $95e6c8d3ebfcab00$export$5f8d39834fd61797; }, function (v) { return $95e6c8d3ebfcab00$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $95e6c8d3ebfcab00$export$74bf444e3cd11ea5; }, function (v) { return $95e6c8d3ebfcab00$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $95e6c8d3ebfcab00$export$998bcd577473dd93; }, function (v) { return $95e6c8d3ebfcab00$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $95e6c8d3ebfcab00$export$b706b080d889d2c9; }, function (v) { return $95e6c8d3ebfcab00$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $95e6c8d3ebfcab00$export$5be5a87408f70ddc; }, function (v) { return $95e6c8d3ebfcab00$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $95e6c8d3ebfcab00$export$45a5e7f76e0caa8d; }, function (v) { return $95e6c8d3ebfcab00$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $95e6c8d3ebfcab00$export$455c2e768291efa6; }, function (v) { return $95e6c8d3ebfcab00$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $95e6c8d3ebfcab00$export$9522e17588c12572; }, function (v) { return $95e6c8d3ebfcab00$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $95e6c8d3ebfcab00$export$2110ac352bb060b9; }, function (v) { return $95e6c8d3ebfcab00$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $95e6c8d3ebfcab00$export$56885ab8b9c456ab; }, function (v) { return $95e6c8d3ebfcab00$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $95e6c8d3ebfcab00$export$d927fcb6adf8f9de; }, function (v) { return $95e6c8d3ebfcab00$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $95e6c8d3ebfcab00$export$b82d16f27459e05a; }, function (v) { return $95e6c8d3ebfcab00$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $95e6c8d3ebfcab00$export$522c17b4f5e123e8; }, function (v) { return $95e6c8d3ebfcab00$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $95e6c8d3ebfcab00$export$1aabd8a0274ecfd6; }, function (v) { return $95e6c8d3ebfcab00$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $95e6c8d3ebfcab00$export$3d6c20d97e46b957; }, function (v) { return $95e6c8d3ebfcab00$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $95e6c8d3ebfcab00$export$9b621391a187a31a; }, function (v) { return $95e6c8d3ebfcab00$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $95e6c8d3ebfcab00$export$f5bbd400c2f4426f; }, function (v) { return $95e6c8d3ebfcab00$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $95e6c8d3ebfcab00$export$a7c73072b1a182ae;
var $95e6c8d3ebfcab00$export$9f27bc3417b4524d;
var $95e6c8d3ebfcab00$export$db77ccec0bb4ccac;
var $95e6c8d3ebfcab00$export$8392c0c9d3dcbd35;
var $95e6c8d3ebfcab00$export$ffb0004e005737fa;
var $95e6c8d3ebfcab00$export$b624eff549462981;
var $95e6c8d3ebfcab00$export$7897aa7841a5380c;
var $95e6c8d3ebfcab00$export$602eac185826482c;
var $95e6c8d3ebfcab00$export$e2c29f18771995cb;
var $95e6c8d3ebfcab00$export$5f8d39834fd61797;
var $95e6c8d3ebfcab00$export$74bf444e3cd11ea5;
var $95e6c8d3ebfcab00$export$998bcd577473dd93;
var $95e6c8d3ebfcab00$export$b706b080d889d2c9;
var $95e6c8d3ebfcab00$export$5be5a87408f70ddc;
var $95e6c8d3ebfcab00$export$45a5e7f76e0caa8d;
var $95e6c8d3ebfcab00$export$455c2e768291efa6;
var $95e6c8d3ebfcab00$export$9522e17588c12572;
var $95e6c8d3ebfcab00$export$2110ac352bb060b9;
var $95e6c8d3ebfcab00$export$56885ab8b9c456ab;
var $95e6c8d3ebfcab00$export$d927fcb6adf8f9de;
var $95e6c8d3ebfcab00$export$b82d16f27459e05a;
var $95e6c8d3ebfcab00$export$522c17b4f5e123e8;
var $95e6c8d3ebfcab00$export$1aabd8a0274ecfd6;
var $95e6c8d3ebfcab00$export$3d6c20d97e46b957;
var $95e6c8d3ebfcab00$export$9b621391a187a31a;
var $95e6c8d3ebfcab00$export$f5bbd400c2f4426f;
"use strict";
var $95e6c8d3ebfcab00$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $95e6c8d3ebfcab00$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $95e6c8d3ebfcab00$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $95e6c8d3ebfcab00$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $95e6c8d3ebfcab00$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $95e6c8d3ebfcab00$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $95e6c8d3ebfcab00$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $95e6c8d3ebfcab00$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $95e6c8d3ebfcab00$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $95e6c8d3ebfcab00$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $95e6c8d3ebfcab00$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $95e6c8d3ebfcab00$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $95e6c8d3ebfcab00$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $95e6c8d3ebfcab00$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $95e6c8d3ebfcab00$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $95e6c8d3ebfcab00$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $95e6c8d3ebfcab00$var$REACT_FRAGMENT_TYPE:
                    case $95e6c8d3ebfcab00$var$REACT_PROFILER_TYPE:
                    case $95e6c8d3ebfcab00$var$REACT_STRICT_MODE_TYPE:
                    case $95e6c8d3ebfcab00$var$REACT_SUSPENSE_TYPE:
                    case $95e6c8d3ebfcab00$var$REACT_SUSPENSE_LIST_TYPE:
                    case $95e6c8d3ebfcab00$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $95e6c8d3ebfcab00$var$REACT_CONTEXT_TYPE:
                            case $95e6c8d3ebfcab00$var$REACT_FORWARD_REF_TYPE:
                            case $95e6c8d3ebfcab00$var$REACT_LAZY_TYPE:
                            case $95e6c8d3ebfcab00$var$REACT_MEMO_TYPE:
                                return object;
                            case $95e6c8d3ebfcab00$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $95e6c8d3ebfcab00$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$95e6c8d3ebfcab00$export$a7c73072b1a182ae = $95e6c8d3ebfcab00$var$REACT_CONSUMER_TYPE;
$95e6c8d3ebfcab00$export$9f27bc3417b4524d = $95e6c8d3ebfcab00$var$REACT_CONTEXT_TYPE;
$95e6c8d3ebfcab00$export$db77ccec0bb4ccac = $95e6c8d3ebfcab00$var$REACT_ELEMENT_TYPE;
$95e6c8d3ebfcab00$export$8392c0c9d3dcbd35 = $95e6c8d3ebfcab00$var$REACT_FORWARD_REF_TYPE;
$95e6c8d3ebfcab00$export$ffb0004e005737fa = $95e6c8d3ebfcab00$var$REACT_FRAGMENT_TYPE;
$95e6c8d3ebfcab00$export$b624eff549462981 = $95e6c8d3ebfcab00$var$REACT_LAZY_TYPE;
$95e6c8d3ebfcab00$export$7897aa7841a5380c = $95e6c8d3ebfcab00$var$REACT_MEMO_TYPE;
$95e6c8d3ebfcab00$export$602eac185826482c = $95e6c8d3ebfcab00$var$REACT_PORTAL_TYPE;
$95e6c8d3ebfcab00$export$e2c29f18771995cb = $95e6c8d3ebfcab00$var$REACT_PROFILER_TYPE;
$95e6c8d3ebfcab00$export$5f8d39834fd61797 = $95e6c8d3ebfcab00$var$REACT_STRICT_MODE_TYPE;
$95e6c8d3ebfcab00$export$74bf444e3cd11ea5 = $95e6c8d3ebfcab00$var$REACT_SUSPENSE_TYPE;
$95e6c8d3ebfcab00$export$998bcd577473dd93 = $95e6c8d3ebfcab00$var$REACT_SUSPENSE_LIST_TYPE;
$95e6c8d3ebfcab00$export$b706b080d889d2c9 = function(object) {
    return $95e6c8d3ebfcab00$var$typeOf(object) === $95e6c8d3ebfcab00$var$REACT_CONSUMER_TYPE;
};
$95e6c8d3ebfcab00$export$5be5a87408f70ddc = function(object) {
    return $95e6c8d3ebfcab00$var$typeOf(object) === $95e6c8d3ebfcab00$var$REACT_CONTEXT_TYPE;
};
$95e6c8d3ebfcab00$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $95e6c8d3ebfcab00$var$REACT_ELEMENT_TYPE;
};
$95e6c8d3ebfcab00$export$455c2e768291efa6 = function(object) {
    return $95e6c8d3ebfcab00$var$typeOf(object) === $95e6c8d3ebfcab00$var$REACT_FORWARD_REF_TYPE;
};
$95e6c8d3ebfcab00$export$9522e17588c12572 = function(object) {
    return $95e6c8d3ebfcab00$var$typeOf(object) === $95e6c8d3ebfcab00$var$REACT_FRAGMENT_TYPE;
};
$95e6c8d3ebfcab00$export$2110ac352bb060b9 = function(object) {
    return $95e6c8d3ebfcab00$var$typeOf(object) === $95e6c8d3ebfcab00$var$REACT_LAZY_TYPE;
};
$95e6c8d3ebfcab00$export$56885ab8b9c456ab = function(object) {
    return $95e6c8d3ebfcab00$var$typeOf(object) === $95e6c8d3ebfcab00$var$REACT_MEMO_TYPE;
};
$95e6c8d3ebfcab00$export$d927fcb6adf8f9de = function(object) {
    return $95e6c8d3ebfcab00$var$typeOf(object) === $95e6c8d3ebfcab00$var$REACT_PORTAL_TYPE;
};
$95e6c8d3ebfcab00$export$b82d16f27459e05a = function(object) {
    return $95e6c8d3ebfcab00$var$typeOf(object) === $95e6c8d3ebfcab00$var$REACT_PROFILER_TYPE;
};
$95e6c8d3ebfcab00$export$522c17b4f5e123e8 = function(object) {
    return $95e6c8d3ebfcab00$var$typeOf(object) === $95e6c8d3ebfcab00$var$REACT_STRICT_MODE_TYPE;
};
$95e6c8d3ebfcab00$export$1aabd8a0274ecfd6 = function(object) {
    return $95e6c8d3ebfcab00$var$typeOf(object) === $95e6c8d3ebfcab00$var$REACT_SUSPENSE_TYPE;
};
$95e6c8d3ebfcab00$export$3d6c20d97e46b957 = function(object) {
    return $95e6c8d3ebfcab00$var$typeOf(object) === $95e6c8d3ebfcab00$var$REACT_SUSPENSE_LIST_TYPE;
};
$95e6c8d3ebfcab00$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $95e6c8d3ebfcab00$var$REACT_FRAGMENT_TYPE || type === $95e6c8d3ebfcab00$var$REACT_PROFILER_TYPE || type === $95e6c8d3ebfcab00$var$REACT_STRICT_MODE_TYPE || type === $95e6c8d3ebfcab00$var$REACT_SUSPENSE_TYPE || type === $95e6c8d3ebfcab00$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $95e6c8d3ebfcab00$var$REACT_LAZY_TYPE || type.$$typeof === $95e6c8d3ebfcab00$var$REACT_MEMO_TYPE || type.$$typeof === $95e6c8d3ebfcab00$var$REACT_CONTEXT_TYPE || type.$$typeof === $95e6c8d3ebfcab00$var$REACT_CONSUMER_TYPE || type.$$typeof === $95e6c8d3ebfcab00$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $95e6c8d3ebfcab00$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$95e6c8d3ebfcab00$export$f5bbd400c2f4426f = $95e6c8d3ebfcab00$var$typeOf;

});




parcelRegister("bEhYY", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $87b161146c640ea8$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $87b161146c640ea8$var$_capitalize.default;
    }
});

var $87b161146c640ea8$var$_capitalize = $87b161146c640ea8$require$_interopRequireDefault((parcelRequire("fCJek")));

});
parcelRegister("fCJek", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $b5fd7d6826450ca2$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5fd7d6826450ca2$var$capitalize;

var $b5fd7d6826450ca2$var$_formatMuiErrorMessage = $b5fd7d6826450ca2$require$_interopRequireDefault((parcelRequire("iKhyI")));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function $b5fd7d6826450ca2$var$capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, $b5fd7d6826450ca2$var$_formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("gCVrD", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $c1acc14a5a2237fb$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c1acc14a5a2237fb$var$_getDisplayName.default;
    }
});

var $c1acc14a5a2237fb$var$_getDisplayName = $c1acc14a5a2237fb$require$_interopRequireDefault((parcelRequire("9jIhP")));

});
parcelRegister("9jIhP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6c883dcb7c165b88$var$getDisplayName;

var $3ltko = parcelRequire("3ltko");
function $6c883dcb7c165b88$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $6c883dcb7c165b88$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $6c883dcb7c165b88$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function $6c883dcb7c165b88$var$getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $6c883dcb7c165b88$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case $3ltko.ForwardRef:
            return $6c883dcb7c165b88$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case $3ltko.Memo:
            return $6c883dcb7c165b88$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("cp4gV", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $907b2228c0a7f999$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $907b2228c0a7f999$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $907b2228c0a7f999$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return $907b2228c0a7f999$var$_applyStyles.default;
    }
});

var $907b2228c0a7f999$var$_createTheme = $907b2228c0a7f999$require$_interopRequireDefault((parcelRequire("7yX6Y")));

var $907b2228c0a7f999$var$_createBreakpoints = $907b2228c0a7f999$require$_interopRequireDefault((parcelRequire("ferWf")));

var $907b2228c0a7f999$var$_applyStyles = $907b2228c0a7f999$require$_interopRequireDefault((parcelRequire("1JySr")));

});
parcelRegister("7yX6Y", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $58198fab98efdcf0$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58198fab98efdcf0$var$_deepmerge = $58198fab98efdcf0$require$_interopRequireDefault((parcelRequire("cWnbn")));

var $58198fab98efdcf0$var$_createBreakpoints = $58198fab98efdcf0$require$_interopRequireDefault((parcelRequire("ferWf")));

var $58198fab98efdcf0$var$_cssContainerQueries = $58198fab98efdcf0$require$_interopRequireDefault((parcelRequire("9aRtn")));

var $58198fab98efdcf0$var$_shape = $58198fab98efdcf0$require$_interopRequireDefault((parcelRequire("6FDPf")));

var $58198fab98efdcf0$var$_createSpacing = $58198fab98efdcf0$require$_interopRequireDefault((parcelRequire("2DbF2")));

var $58198fab98efdcf0$var$_styleFunctionSx = $58198fab98efdcf0$require$_interopRequireDefault((parcelRequire("a2Mzw")));

var $58198fab98efdcf0$var$_defaultSxConfig = $58198fab98efdcf0$require$_interopRequireDefault((parcelRequire("5Eqdm")));

var $58198fab98efdcf0$var$_applyStyles = $58198fab98efdcf0$require$_interopRequireDefault((parcelRequire("1JySr")));
function $58198fab98efdcf0$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $58198fab98efdcf0$var$_createBreakpoints.default)(breakpointsInput);
    const spacing = (0, $58198fab98efdcf0$var$_createSpacing.default)(spacingInput);
    let muiTheme = (0, $58198fab98efdcf0$var$_deepmerge.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...$58198fab98efdcf0$var$_shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $58198fab98efdcf0$var$_cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = $58198fab98efdcf0$var$_applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, $58198fab98efdcf0$var$_deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...$58198fab98efdcf0$var$_defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $58198fab98efdcf0$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $58198fab98efdcf0$var$_default = module.exports.default = $58198fab98efdcf0$var$createTheme;

});
parcelRegister("ferWf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.breakpointKeys = void 0;
module.exports.default = $b16dd5d8911e5d66$var$createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $b16dd5d8911e5d66$var$breakpointKeys = module.exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $b16dd5d8911e5d66$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function $b16dd5d8911e5d66$var$createBreakpoints(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $b16dd5d8911e5d66$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("9aRtn", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $6ade86d61b4170f3$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6ade86d61b4170f3$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return $6ade86d61b4170f3$var$_cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(module.exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return $6ade86d61b4170f3$var$_cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(module.exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return $6ade86d61b4170f3$var$_cssContainerQueries.sortContainerQueries;
    }
});

var $6ade86d61b4170f3$var$_cssContainerQueries = $6ade86d61b4170f3$require$_interopRequireWildcard((parcelRequire("3cNl1")));

});
parcelRegister("3cNl1", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $2558c39d8079d447$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2558c39d8079d447$var$cssContainerQueries;
module.exports.getContainerQuery = $2558c39d8079d447$var$getContainerQuery;
module.exports.isCqShorthand = $2558c39d8079d447$var$isCqShorthand;
module.exports.sortContainerQueries = $2558c39d8079d447$var$sortContainerQueries;

var $2558c39d8079d447$var$_formatMuiErrorMessage = $2558c39d8079d447$require$_interopRequireDefault((parcelRequire("iKhyI")));
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 eventhough 40rem > 300px
 */ function $2558c39d8079d447$var$sortContainerQueries(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $2558c39d8079d447$var$isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $2558c39d8079d447$var$getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $2558c39d8079d447$var$cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("6FDPf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $4db576eb053407cf$var$shape = {
    borderRadius: 4
};
var $4db576eb053407cf$var$_default = module.exports.default = $4db576eb053407cf$var$shape;

});

parcelRegister("2DbF2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1ea844e07d956fe7$var$createSpacing;

var $1pVSQ = parcelRequire("1pVSQ");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function $1ea844e07d956fe7$var$createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $1pVSQ.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("1pVSQ", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $108506b4e1f058b5$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $108506b4e1f058b5$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $108506b4e1f058b5$var$_spacing.default;
    }
});

var $108506b4e1f058b5$var$_spacing = $108506b4e1f058b5$require$_interopRequireWildcard((parcelRequire("cxqj8")));
Object.keys($108506b4e1f058b5$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($108506b4e1f058b5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $108506b4e1f058b5$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $108506b4e1f058b5$var$_spacing[key];
        }
    });
});

});
parcelRegister("cxqj8", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $920cf939fe883395$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnarySpacing = $920cf939fe883395$var$createUnarySpacing;
module.exports.createUnaryUnit = $920cf939fe883395$var$createUnaryUnit;
module.exports.default = void 0;
module.exports.getStyleFromPropValue = $920cf939fe883395$var$getStyleFromPropValue;
module.exports.getValue = $920cf939fe883395$var$getValue;
module.exports.margin = $920cf939fe883395$var$margin;
module.exports.marginKeys = void 0;
module.exports.padding = $920cf939fe883395$var$padding;
module.exports.paddingKeys = void 0;

var $920cf939fe883395$var$_responsivePropType = $920cf939fe883395$require$_interopRequireDefault((parcelRequire("89FYa")));

var $aKcCy = parcelRequire("aKcCy");

var $35Dob = parcelRequire("35Dob");

var $920cf939fe883395$var$_merge = $920cf939fe883395$require$_interopRequireDefault((parcelRequire("1M3A8")));

var $920cf939fe883395$var$_memoize = $920cf939fe883395$require$_interopRequireDefault((parcelRequire("i6Y0X")));
const $920cf939fe883395$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $920cf939fe883395$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $920cf939fe883395$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $920cf939fe883395$var$getCssProperties = (0, $920cf939fe883395$var$_memoize.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($920cf939fe883395$var$aliases[prop]) prop = $920cf939fe883395$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $920cf939fe883395$var$properties[a];
    const direction = $920cf939fe883395$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $920cf939fe883395$var$marginKeys = module.exports.marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $920cf939fe883395$var$paddingKeys = module.exports.paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $920cf939fe883395$var$spacingKeys = [
    ...$920cf939fe883395$var$marginKeys,
    ...$920cf939fe883395$var$paddingKeys
];
function $920cf939fe883395$var$createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $35Dob.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $920cf939fe883395$var$createUnarySpacing(theme) {
    return $920cf939fe883395$var$createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function $920cf939fe883395$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $920cf939fe883395$var$getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $920cf939fe883395$var$getValue(transformer, propValue);
            return acc;
        }, {});
}
function $920cf939fe883395$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $920cf939fe883395$var$getCssProperties(prop);
    const styleFromPropValue = $920cf939fe883395$var$getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $aKcCy.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $920cf939fe883395$var$style(props, keys) {
    const transformer = $920cf939fe883395$var$createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>$920cf939fe883395$var$resolveCssProperty(props, keys, prop, transformer)).reduce($920cf939fe883395$var$_merge.default, {});
}
function $920cf939fe883395$var$margin(props) {
    return $920cf939fe883395$var$style(props, $920cf939fe883395$var$marginKeys);
}
$920cf939fe883395$var$margin.propTypes = {};
$920cf939fe883395$var$margin.filterProps = $920cf939fe883395$var$marginKeys;
function $920cf939fe883395$var$padding(props) {
    return $920cf939fe883395$var$style(props, $920cf939fe883395$var$paddingKeys);
}
$920cf939fe883395$var$padding.propTypes = {};
$920cf939fe883395$var$padding.filterProps = $920cf939fe883395$var$paddingKeys;
function $920cf939fe883395$var$spacing(props) {
    return $920cf939fe883395$var$style(props, $920cf939fe883395$var$spacingKeys);
}
$920cf939fe883395$var$spacing.propTypes = {};
$920cf939fe883395$var$spacing.filterProps = $920cf939fe883395$var$spacingKeys;
var $920cf939fe883395$var$_default = module.exports.default = $920cf939fe883395$var$spacing;

});
parcelRegister("89FYa", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $5effb8459fed1369$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5effb8459fed1369$var$_responsivePropType.default;
    }
});

var $5effb8459fed1369$var$_responsivePropType = $5effb8459fed1369$require$_interopRequireDefault((parcelRequire("8bo3M")));

});
parcelRegister("8bo3M", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $5f5203a38f710934$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f5203a38f710934$var$_propTypes = $5f5203a38f710934$require$_interopRequireDefault((parcelRequire("gY8Sm")));
const $5f5203a38f710934$var$responsivePropType = {};
var $5f5203a38f710934$var$_default = module.exports.default = $5f5203a38f710934$var$responsivePropType;

});


parcelRegister("aKcCy", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $7d27fd8552a69bcc$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7d27fd8552a69bcc$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7d27fd8552a69bcc$var$_breakpoints.default;
    }
});

var $7d27fd8552a69bcc$var$_breakpoints = $7d27fd8552a69bcc$require$_interopRequireWildcard((parcelRequire("e8Y9c")));
Object.keys($7d27fd8552a69bcc$var$_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7d27fd8552a69bcc$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7d27fd8552a69bcc$var$_breakpoints[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7d27fd8552a69bcc$var$_breakpoints[key];
        }
    });
});

});
parcelRegister("e8Y9c", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $a4c0781048ecb1c5$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeBreakpointsBase = $a4c0781048ecb1c5$var$computeBreakpointsBase;
module.exports.createEmptyBreakpointObject = $a4c0781048ecb1c5$var$createEmptyBreakpointObject;
module.exports.default = void 0;
module.exports.handleBreakpoints = $a4c0781048ecb1c5$var$handleBreakpoints;
module.exports.mergeBreakpointsInOrder = $a4c0781048ecb1c5$var$mergeBreakpointsInOrder;
module.exports.removeUnusedBreakpoints = $a4c0781048ecb1c5$var$removeUnusedBreakpoints;
module.exports.resolveBreakpointValues = $a4c0781048ecb1c5$var$resolveBreakpointValues;
module.exports.values = void 0;

var $a4c0781048ecb1c5$var$_propTypes = $a4c0781048ecb1c5$require$_interopRequireDefault((parcelRequire("gY8Sm")));

var $a4c0781048ecb1c5$var$_deepmerge = $a4c0781048ecb1c5$require$_interopRequireDefault((parcelRequire("cWnbn")));

var $a4c0781048ecb1c5$var$_merge = $a4c0781048ecb1c5$require$_interopRequireDefault((parcelRequire("1M3A8")));

var $9aRtn = parcelRequire("9aRtn");
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const $a4c0781048ecb1c5$var$values = module.exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $a4c0781048ecb1c5$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$a4c0781048ecb1c5$var$values[key]}px)`
};
const $a4c0781048ecb1c5$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $a4c0781048ecb1c5$var$values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $a4c0781048ecb1c5$var$handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $a4c0781048ecb1c5$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $a4c0781048ecb1c5$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $9aRtn.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $9aRtn.getContainerQuery)(theme.containerQueries ? theme : $a4c0781048ecb1c5$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $a4c0781048ecb1c5$var$values).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $a4c0781048ecb1c5$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $a4c0781048ecb1c5$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $a4c0781048ecb1c5$var$_merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $a4c0781048ecb1c5$var$createEmptyBreakpointObject(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $a4c0781048ecb1c5$var$removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $a4c0781048ecb1c5$var$mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = $a4c0781048ecb1c5$var$createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $a4c0781048ecb1c5$var$_deepmerge.default)(prev, next), {});
    return $a4c0781048ecb1c5$var$removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function $a4c0781048ecb1c5$var$computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $a4c0781048ecb1c5$var$resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $a4c0781048ecb1c5$var$computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $a4c0781048ecb1c5$var$_default = module.exports.default = $a4c0781048ecb1c5$var$breakpoints;

});
parcelRegister("1M3A8", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $14ad0d643e941dfc$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $14ad0d643e941dfc$var$_merge.default;
    }
});

var $14ad0d643e941dfc$var$_merge = $14ad0d643e941dfc$require$_interopRequireDefault((parcelRequire("2zMod")));

});
parcelRegister("2zMod", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $1e0462d520ead33b$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e0462d520ead33b$var$_deepmerge = $1e0462d520ead33b$require$_interopRequireDefault((parcelRequire("cWnbn")));
function $1e0462d520ead33b$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $1e0462d520ead33b$var$_deepmerge.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $1e0462d520ead33b$var$_default = module.exports.default = $1e0462d520ead33b$var$merge;

});




parcelRegister("35Dob", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $240064990ec6c03b$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $240064990ec6c03b$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $240064990ec6c03b$var$_style.default;
    }
});

var $240064990ec6c03b$var$_style = $240064990ec6c03b$require$_interopRequireWildcard((parcelRequire("gNS9a")));
Object.keys($240064990ec6c03b$var$_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($240064990ec6c03b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $240064990ec6c03b$var$_style[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $240064990ec6c03b$var$_style[key];
        }
    });
});

});
parcelRegister("gNS9a", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $c3bb396109286800$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPath = $c3bb396109286800$var$getPath;
module.exports.getStyleValue = $c3bb396109286800$var$getStyleValue;

var $c3bb396109286800$var$_capitalize = $c3bb396109286800$require$_interopRequireDefault((parcelRequire("bEhYY")));

var $c3bb396109286800$var$_responsivePropType = $c3bb396109286800$require$_interopRequireDefault((parcelRequire("89FYa")));

var $aKcCy = parcelRequire("aKcCy");
function $c3bb396109286800$var$getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $c3bb396109286800$var$getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $c3bb396109286800$var$getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $c3bb396109286800$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $c3bb396109286800$var$getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $c3bb396109286800$var$getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $c3bb396109286800$var$getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $c3bb396109286800$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $aKcCy.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $c3bb396109286800$var$_default = module.exports.default = $c3bb396109286800$var$style;

});


parcelRegister("i6Y0X", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $d2f757221f82f4a8$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d2f757221f82f4a8$var$_memoize.default;
    }
});

var $d2f757221f82f4a8$var$_memoize = $d2f757221f82f4a8$require$_interopRequireDefault((parcelRequire("iQNTt")));

});
parcelRegister("iQNTt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $db93c9336ef5b78e$var$memoize;
function $db93c9336ef5b78e$var$memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});





parcelRegister("a2Mzw", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $74ffc4a5b9ff0b36$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createStyleFunctionSx = $74ffc4a5b9ff0b36$var$unstable_createStyleFunctionSx;

var $74ffc4a5b9ff0b36$var$_capitalize = $74ffc4a5b9ff0b36$require$_interopRequireDefault((parcelRequire("bEhYY")));

var $74ffc4a5b9ff0b36$var$_merge = $74ffc4a5b9ff0b36$require$_interopRequireDefault((parcelRequire("1M3A8")));

var $35Dob = parcelRequire("35Dob");

var $aKcCy = parcelRequire("aKcCy");

var $9aRtn = parcelRequire("9aRtn");

var $74ffc4a5b9ff0b36$var$_defaultSxConfig = $74ffc4a5b9ff0b36$require$_interopRequireDefault((parcelRequire("5Eqdm")));
function $74ffc4a5b9ff0b36$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $74ffc4a5b9ff0b36$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $74ffc4a5b9ff0b36$var$unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $35Dob.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $35Dob.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $35Dob.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $74ffc4a5b9ff0b36$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $aKcCy.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? $74ffc4a5b9ff0b36$var$_defaultSxConfig.default;
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $aKcCy.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $74ffc4a5b9ff0b36$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $74ffc4a5b9ff0b36$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $aKcCy.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($74ffc4a5b9ff0b36$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $74ffc4a5b9ff0b36$var$_merge.default)(css, breakpointsValues);
                        }
                    } else css = (0, $74ffc4a5b9ff0b36$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $9aRtn.sortContainerQueries)(theme, (0, $aKcCy.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $74ffc4a5b9ff0b36$var$styleFunctionSx = $74ffc4a5b9ff0b36$var$unstable_createStyleFunctionSx();
$74ffc4a5b9ff0b36$var$styleFunctionSx.filterProps = [
    'sx'
];
var $74ffc4a5b9ff0b36$var$_default = module.exports.default = $74ffc4a5b9ff0b36$var$styleFunctionSx;

});
parcelRegister("5Eqdm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1pVSQ = parcelRequire("1pVSQ");

var $8txDN = parcelRequire("8txDN");

var $5RPrC = parcelRequire("5RPrC");

var $lUwID = parcelRequire("lUwID");

var $8GRkr = parcelRequire("8GRkr");
const $41d505ce44257bdb$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: $8txDN.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: $8txDN.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: $8txDN.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: $8txDN.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: $8txDN.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: $8txDN.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: $8txDN.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: $lUwID.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: $lUwID.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: $lUwID.paletteTransform
    },
    // spacing
    p: {
        style: $1pVSQ.padding
    },
    pt: {
        style: $1pVSQ.padding
    },
    pr: {
        style: $1pVSQ.padding
    },
    pb: {
        style: $1pVSQ.padding
    },
    pl: {
        style: $1pVSQ.padding
    },
    px: {
        style: $1pVSQ.padding
    },
    py: {
        style: $1pVSQ.padding
    },
    padding: {
        style: $1pVSQ.padding
    },
    paddingTop: {
        style: $1pVSQ.padding
    },
    paddingRight: {
        style: $1pVSQ.padding
    },
    paddingBottom: {
        style: $1pVSQ.padding
    },
    paddingLeft: {
        style: $1pVSQ.padding
    },
    paddingX: {
        style: $1pVSQ.padding
    },
    paddingY: {
        style: $1pVSQ.padding
    },
    paddingInline: {
        style: $1pVSQ.padding
    },
    paddingInlineStart: {
        style: $1pVSQ.padding
    },
    paddingInlineEnd: {
        style: $1pVSQ.padding
    },
    paddingBlock: {
        style: $1pVSQ.padding
    },
    paddingBlockStart: {
        style: $1pVSQ.padding
    },
    paddingBlockEnd: {
        style: $1pVSQ.padding
    },
    m: {
        style: $1pVSQ.margin
    },
    mt: {
        style: $1pVSQ.margin
    },
    mr: {
        style: $1pVSQ.margin
    },
    mb: {
        style: $1pVSQ.margin
    },
    ml: {
        style: $1pVSQ.margin
    },
    mx: {
        style: $1pVSQ.margin
    },
    my: {
        style: $1pVSQ.margin
    },
    margin: {
        style: $1pVSQ.margin
    },
    marginTop: {
        style: $1pVSQ.margin
    },
    marginRight: {
        style: $1pVSQ.margin
    },
    marginBottom: {
        style: $1pVSQ.margin
    },
    marginLeft: {
        style: $1pVSQ.margin
    },
    marginX: {
        style: $1pVSQ.margin
    },
    marginY: {
        style: $1pVSQ.margin
    },
    marginInline: {
        style: $1pVSQ.margin
    },
    marginInlineStart: {
        style: $1pVSQ.margin
    },
    marginInlineEnd: {
        style: $1pVSQ.margin
    },
    marginBlock: {
        style: $1pVSQ.margin
    },
    marginBlockStart: {
        style: $1pVSQ.margin
    },
    marginBlockEnd: {
        style: $1pVSQ.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: $5RPrC.gap
    },
    rowGap: {
        style: $5RPrC.rowGap
    },
    columnGap: {
        style: $5RPrC.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: $8GRkr.sizingTransform
    },
    maxWidth: {
        style: $8GRkr.maxWidth
    },
    minWidth: {
        transform: $8GRkr.sizingTransform
    },
    height: {
        transform: $8GRkr.sizingTransform
    },
    maxHeight: {
        transform: $8GRkr.sizingTransform
    },
    minHeight: {
        transform: $8GRkr.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $41d505ce44257bdb$var$_default = module.exports.default = $41d505ce44257bdb$var$defaultSxConfig;

});
parcelRegister("8txDN", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $62bb20892c4e778a$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $62bb20892c4e778a$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $62bb20892c4e778a$var$_borders.default;
    }
});

var $62bb20892c4e778a$var$_borders = $62bb20892c4e778a$require$_interopRequireWildcard((parcelRequire("6H1NT")));
Object.keys($62bb20892c4e778a$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($62bb20892c4e778a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $62bb20892c4e778a$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $62bb20892c4e778a$var$_borders[key];
        }
    });
});

});
parcelRegister("6H1NT", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $4df8286524945e5f$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.borderTopColor = module.exports.borderTop = module.exports.borderRightColor = module.exports.borderRight = module.exports.borderRadius = module.exports.borderLeftColor = module.exports.borderLeft = module.exports.borderColor = module.exports.borderBottomColor = module.exports.borderBottom = module.exports.border = void 0;
module.exports.borderTransform = $4df8286524945e5f$var$borderTransform;
module.exports.outlineColor = module.exports.outline = module.exports.default = void 0;

var $4df8286524945e5f$var$_responsivePropType = $4df8286524945e5f$require$_interopRequireDefault((parcelRequire("89FYa")));

var $4df8286524945e5f$var$_style = $4df8286524945e5f$require$_interopRequireDefault((parcelRequire("35Dob")));

var $4df8286524945e5f$var$_compose = $4df8286524945e5f$require$_interopRequireDefault((parcelRequire("eO2EL")));

var $1pVSQ = parcelRequire("1pVSQ");

var $aKcCy = parcelRequire("aKcCy");
function $4df8286524945e5f$var$borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $4df8286524945e5f$var$createBorderStyle(prop, transform) {
    return (0, $4df8286524945e5f$var$_style.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $4df8286524945e5f$var$border = module.exports.border = $4df8286524945e5f$var$createBorderStyle('border', $4df8286524945e5f$var$borderTransform);
const $4df8286524945e5f$var$borderTop = module.exports.borderTop = $4df8286524945e5f$var$createBorderStyle('borderTop', $4df8286524945e5f$var$borderTransform);
const $4df8286524945e5f$var$borderRight = module.exports.borderRight = $4df8286524945e5f$var$createBorderStyle('borderRight', $4df8286524945e5f$var$borderTransform);
const $4df8286524945e5f$var$borderBottom = module.exports.borderBottom = $4df8286524945e5f$var$createBorderStyle('borderBottom', $4df8286524945e5f$var$borderTransform);
const $4df8286524945e5f$var$borderLeft = module.exports.borderLeft = $4df8286524945e5f$var$createBorderStyle('borderLeft', $4df8286524945e5f$var$borderTransform);
const $4df8286524945e5f$var$borderColor = module.exports.borderColor = $4df8286524945e5f$var$createBorderStyle('borderColor');
const $4df8286524945e5f$var$borderTopColor = module.exports.borderTopColor = $4df8286524945e5f$var$createBorderStyle('borderTopColor');
const $4df8286524945e5f$var$borderRightColor = module.exports.borderRightColor = $4df8286524945e5f$var$createBorderStyle('borderRightColor');
const $4df8286524945e5f$var$borderBottomColor = module.exports.borderBottomColor = $4df8286524945e5f$var$createBorderStyle('borderBottomColor');
const $4df8286524945e5f$var$borderLeftColor = module.exports.borderLeftColor = $4df8286524945e5f$var$createBorderStyle('borderLeftColor');
const $4df8286524945e5f$var$outline = module.exports.outline = $4df8286524945e5f$var$createBorderStyle('outline', $4df8286524945e5f$var$borderTransform);
const $4df8286524945e5f$var$outlineColor = module.exports.outlineColor = $4df8286524945e5f$var$createBorderStyle('outlineColor');
// false positive
// eslint-disable-next-line react/function-component-definition
const $4df8286524945e5f$var$borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $1pVSQ.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $1pVSQ.getValue)(transformer, propValue)
            });
        return (0, $aKcCy.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
module.exports.borderRadius = $4df8286524945e5f$var$borderRadius;
$4df8286524945e5f$var$borderRadius.propTypes = {};
$4df8286524945e5f$var$borderRadius.filterProps = [
    'borderRadius'
];
const $4df8286524945e5f$var$borders = (0, $4df8286524945e5f$var$_compose.default)($4df8286524945e5f$var$border, $4df8286524945e5f$var$borderTop, $4df8286524945e5f$var$borderRight, $4df8286524945e5f$var$borderBottom, $4df8286524945e5f$var$borderLeft, $4df8286524945e5f$var$borderColor, $4df8286524945e5f$var$borderTopColor, $4df8286524945e5f$var$borderRightColor, $4df8286524945e5f$var$borderBottomColor, $4df8286524945e5f$var$borderLeftColor, $4df8286524945e5f$var$borderRadius, $4df8286524945e5f$var$outline, $4df8286524945e5f$var$outlineColor);
var $4df8286524945e5f$var$_default = module.exports.default = $4df8286524945e5f$var$borders;

});
parcelRegister("eO2EL", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $ac77cbb5302b9ec8$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ac77cbb5302b9ec8$var$_compose.default;
    }
});

var $ac77cbb5302b9ec8$var$_compose = $ac77cbb5302b9ec8$require$_interopRequireDefault((parcelRequire("3emE2")));

});
parcelRegister("3emE2", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $25a43eac002c025d$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25a43eac002c025d$var$_merge = $25a43eac002c025d$require$_interopRequireDefault((parcelRequire("1M3A8")));
function $25a43eac002c025d$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $25a43eac002c025d$var$_merge.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $25a43eac002c025d$var$_default = module.exports.default = $25a43eac002c025d$var$compose;

});




parcelRegister("5RPrC", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $4459cec839a6a111$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4459cec839a6a111$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4459cec839a6a111$var$_cssGrid.default;
    }
});

var $4459cec839a6a111$var$_cssGrid = $4459cec839a6a111$require$_interopRequireWildcard((parcelRequire("bzrtd")));
Object.keys($4459cec839a6a111$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4459cec839a6a111$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4459cec839a6a111$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4459cec839a6a111$var$_cssGrid[key];
        }
    });
});

});
parcelRegister("bzrtd", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $86c84598fd214e65$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rowGap = module.exports.gridTemplateRows = module.exports.gridTemplateColumns = module.exports.gridTemplateAreas = module.exports.gridRow = module.exports.gridColumn = module.exports.gridAutoRows = module.exports.gridAutoFlow = module.exports.gridAutoColumns = module.exports.gridArea = module.exports.gap = module.exports.default = module.exports.columnGap = void 0;

var $86c84598fd214e65$var$_style = $86c84598fd214e65$require$_interopRequireDefault((parcelRequire("35Dob")));

var $86c84598fd214e65$var$_compose = $86c84598fd214e65$require$_interopRequireDefault((parcelRequire("eO2EL")));

var $1pVSQ = parcelRequire("1pVSQ");

var $aKcCy = parcelRequire("aKcCy");

var $86c84598fd214e65$var$_responsivePropType = $86c84598fd214e65$require$_interopRequireDefault((parcelRequire("89FYa")));
// false positive
// eslint-disable-next-line react/function-component-definition
const $86c84598fd214e65$var$gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $1pVSQ.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $1pVSQ.getValue)(transformer, propValue)
            });
        return (0, $aKcCy.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
module.exports.gap = $86c84598fd214e65$var$gap;
$86c84598fd214e65$var$gap.propTypes = {};
$86c84598fd214e65$var$gap.filterProps = [
    'gap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $86c84598fd214e65$var$columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $1pVSQ.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $1pVSQ.getValue)(transformer, propValue)
            });
        return (0, $aKcCy.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
module.exports.columnGap = $86c84598fd214e65$var$columnGap;
$86c84598fd214e65$var$columnGap.propTypes = {};
$86c84598fd214e65$var$columnGap.filterProps = [
    'columnGap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $86c84598fd214e65$var$rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $1pVSQ.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $1pVSQ.getValue)(transformer, propValue)
            });
        return (0, $aKcCy.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
module.exports.rowGap = $86c84598fd214e65$var$rowGap;
$86c84598fd214e65$var$rowGap.propTypes = {};
$86c84598fd214e65$var$rowGap.filterProps = [
    'rowGap'
];
const $86c84598fd214e65$var$gridColumn = module.exports.gridColumn = (0, $86c84598fd214e65$var$_style.default)({
    prop: 'gridColumn'
});
const $86c84598fd214e65$var$gridRow = module.exports.gridRow = (0, $86c84598fd214e65$var$_style.default)({
    prop: 'gridRow'
});
const $86c84598fd214e65$var$gridAutoFlow = module.exports.gridAutoFlow = (0, $86c84598fd214e65$var$_style.default)({
    prop: 'gridAutoFlow'
});
const $86c84598fd214e65$var$gridAutoColumns = module.exports.gridAutoColumns = (0, $86c84598fd214e65$var$_style.default)({
    prop: 'gridAutoColumns'
});
const $86c84598fd214e65$var$gridAutoRows = module.exports.gridAutoRows = (0, $86c84598fd214e65$var$_style.default)({
    prop: 'gridAutoRows'
});
const $86c84598fd214e65$var$gridTemplateColumns = module.exports.gridTemplateColumns = (0, $86c84598fd214e65$var$_style.default)({
    prop: 'gridTemplateColumns'
});
const $86c84598fd214e65$var$gridTemplateRows = module.exports.gridTemplateRows = (0, $86c84598fd214e65$var$_style.default)({
    prop: 'gridTemplateRows'
});
const $86c84598fd214e65$var$gridTemplateAreas = module.exports.gridTemplateAreas = (0, $86c84598fd214e65$var$_style.default)({
    prop: 'gridTemplateAreas'
});
const $86c84598fd214e65$var$gridArea = module.exports.gridArea = (0, $86c84598fd214e65$var$_style.default)({
    prop: 'gridArea'
});
const $86c84598fd214e65$var$grid = (0, $86c84598fd214e65$var$_compose.default)($86c84598fd214e65$var$gap, $86c84598fd214e65$var$columnGap, $86c84598fd214e65$var$rowGap, $86c84598fd214e65$var$gridColumn, $86c84598fd214e65$var$gridRow, $86c84598fd214e65$var$gridAutoFlow, $86c84598fd214e65$var$gridAutoColumns, $86c84598fd214e65$var$gridAutoRows, $86c84598fd214e65$var$gridTemplateColumns, $86c84598fd214e65$var$gridTemplateRows, $86c84598fd214e65$var$gridTemplateAreas, $86c84598fd214e65$var$gridArea);
var $86c84598fd214e65$var$_default = module.exports.default = $86c84598fd214e65$var$grid;

});


parcelRegister("lUwID", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $ff383535ee074152$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ff383535ee074152$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ff383535ee074152$var$_palette.default;
    }
});

var $ff383535ee074152$var$_palette = $ff383535ee074152$require$_interopRequireWildcard((parcelRequire("3hTtv")));
Object.keys($ff383535ee074152$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ff383535ee074152$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ff383535ee074152$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ff383535ee074152$var$_palette[key];
        }
    });
});

});
parcelRegister("3hTtv", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $264dfdccd9a61295$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.color = module.exports.bgcolor = module.exports.backgroundColor = void 0;
module.exports.paletteTransform = $264dfdccd9a61295$var$paletteTransform;

var $264dfdccd9a61295$var$_style = $264dfdccd9a61295$require$_interopRequireDefault((parcelRequire("35Dob")));

var $264dfdccd9a61295$var$_compose = $264dfdccd9a61295$require$_interopRequireDefault((parcelRequire("eO2EL")));
function $264dfdccd9a61295$var$paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $264dfdccd9a61295$var$color = module.exports.color = (0, $264dfdccd9a61295$var$_style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $264dfdccd9a61295$var$paletteTransform
});
const $264dfdccd9a61295$var$bgcolor = module.exports.bgcolor = (0, $264dfdccd9a61295$var$_style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $264dfdccd9a61295$var$paletteTransform
});
const $264dfdccd9a61295$var$backgroundColor = module.exports.backgroundColor = (0, $264dfdccd9a61295$var$_style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $264dfdccd9a61295$var$paletteTransform
});
const $264dfdccd9a61295$var$palette = (0, $264dfdccd9a61295$var$_compose.default)($264dfdccd9a61295$var$color, $264dfdccd9a61295$var$bgcolor, $264dfdccd9a61295$var$backgroundColor);
var $264dfdccd9a61295$var$_default = module.exports.default = $264dfdccd9a61295$var$palette;

});


parcelRegister("8GRkr", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $653b9cf0d6e381cf$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $653b9cf0d6e381cf$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $653b9cf0d6e381cf$var$_sizing.default;
    }
});

var $653b9cf0d6e381cf$var$_sizing = $653b9cf0d6e381cf$require$_interopRequireWildcard((parcelRequire("18SPM")));
Object.keys($653b9cf0d6e381cf$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($653b9cf0d6e381cf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $653b9cf0d6e381cf$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $653b9cf0d6e381cf$var$_sizing[key];
        }
    });
});

});
parcelRegister("18SPM", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $0d5112b77e176050$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sizeWidth = module.exports.sizeHeight = module.exports.minWidth = module.exports.minHeight = module.exports.maxWidth = module.exports.maxHeight = module.exports.height = module.exports.default = module.exports.boxSizing = void 0;
module.exports.sizingTransform = $0d5112b77e176050$var$sizingTransform;
module.exports.width = void 0;

var $0d5112b77e176050$var$_style = $0d5112b77e176050$require$_interopRequireDefault((parcelRequire("35Dob")));

var $0d5112b77e176050$var$_compose = $0d5112b77e176050$require$_interopRequireDefault((parcelRequire("eO2EL")));

var $aKcCy = parcelRequire("aKcCy");
function $0d5112b77e176050$var$sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $0d5112b77e176050$var$width = module.exports.width = (0, $0d5112b77e176050$var$_style.default)({
    prop: 'width',
    transform: $0d5112b77e176050$var$sizingTransform
});
const $0d5112b77e176050$var$maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $aKcCy.values[propValue];
            if (!breakpoint) return {
                maxWidth: $0d5112b77e176050$var$sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $aKcCy.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
module.exports.maxWidth = $0d5112b77e176050$var$maxWidth;
$0d5112b77e176050$var$maxWidth.filterProps = [
    'maxWidth'
];
const $0d5112b77e176050$var$minWidth = module.exports.minWidth = (0, $0d5112b77e176050$var$_style.default)({
    prop: 'minWidth',
    transform: $0d5112b77e176050$var$sizingTransform
});
const $0d5112b77e176050$var$height = module.exports.height = (0, $0d5112b77e176050$var$_style.default)({
    prop: 'height',
    transform: $0d5112b77e176050$var$sizingTransform
});
const $0d5112b77e176050$var$maxHeight = module.exports.maxHeight = (0, $0d5112b77e176050$var$_style.default)({
    prop: 'maxHeight',
    transform: $0d5112b77e176050$var$sizingTransform
});
const $0d5112b77e176050$var$minHeight = module.exports.minHeight = (0, $0d5112b77e176050$var$_style.default)({
    prop: 'minHeight',
    transform: $0d5112b77e176050$var$sizingTransform
});
const $0d5112b77e176050$var$sizeWidth = module.exports.sizeWidth = (0, $0d5112b77e176050$var$_style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $0d5112b77e176050$var$sizingTransform
});
const $0d5112b77e176050$var$sizeHeight = module.exports.sizeHeight = (0, $0d5112b77e176050$var$_style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $0d5112b77e176050$var$sizingTransform
});
const $0d5112b77e176050$var$boxSizing = module.exports.boxSizing = (0, $0d5112b77e176050$var$_style.default)({
    prop: 'boxSizing'
});
const $0d5112b77e176050$var$sizing = (0, $0d5112b77e176050$var$_compose.default)($0d5112b77e176050$var$width, $0d5112b77e176050$var$maxWidth, $0d5112b77e176050$var$minWidth, $0d5112b77e176050$var$height, $0d5112b77e176050$var$maxHeight, $0d5112b77e176050$var$minHeight, $0d5112b77e176050$var$boxSizing);
var $0d5112b77e176050$var$_default = module.exports.default = $0d5112b77e176050$var$sizing;

});




parcelRegister("1JySr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $14350c476df037e4$var$applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $14350c476df037e4$var$applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("a4tM1", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $75515f881882abe6$require$_interopRequireDefault = $9rMjh.default;

var $pArzt = parcelRequire("pArzt");
var $75515f881882abe6$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $75515f881882abe6$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return $75515f881882abe6$var$_extendSxProp.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $75515f881882abe6$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $75515f881882abe6$var$_defaultSxConfig.default;
    }
});

var $75515f881882abe6$var$_styleFunctionSx = $75515f881882abe6$require$_interopRequireWildcard((parcelRequire("a2Mzw")));

var $75515f881882abe6$var$_extendSxProp = $75515f881882abe6$require$_interopRequireDefault((parcelRequire("ADXV8")));

var $75515f881882abe6$var$_defaultSxConfig = $75515f881882abe6$require$_interopRequireDefault((parcelRequire("5Eqdm")));

});
parcelRegister("ADXV8", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $06e25d372c7e1369$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06e25d372c7e1369$var$extendSxProp;

var $cWnbn = parcelRequire("cWnbn");

var $06e25d372c7e1369$var$_defaultSxConfig = $06e25d372c7e1369$require$_interopRequireDefault((parcelRequire("5Eqdm")));
const $06e25d372c7e1369$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? $06e25d372c7e1369$var$_defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $06e25d372c7e1369$var$extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $06e25d372c7e1369$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $cWnbn.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("bgjRT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $833099bf4ead6d6a$var$preprocessStyles;

var $1VcT5 = parcelRequire("1VcT5");
function $833099bf4ead6d6a$var$preprocessStyles(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $1VcT5.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $1VcT5.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("c7Ata", function(module, exports) {
"use strict";
'use client';

var $9rMjh = parcelRequire("9rMjh");
var $8d326d88eadd2288$require$_interopRequireDefault = $9rMjh.default;

var $pArzt = parcelRequire("pArzt");
var $8d326d88eadd2288$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DISABLE_CSS_TRANSITION = void 0;
module.exports.default = $8d326d88eadd2288$var$createCssVarsProvider;

var $8d326d88eadd2288$var$React = $8d326d88eadd2288$require$_interopRequireWildcard((parcelRequire("1Pgvo")));

var $8d326d88eadd2288$var$_propTypes = $8d326d88eadd2288$require$_interopRequireDefault((parcelRequire("gY8Sm")));

var $fmb6q = parcelRequire("fmb6q");

var $6bJlR = parcelRequire("6bJlR");

var $8d326d88eadd2288$var$_useEnhancedEffect = $8d326d88eadd2288$require$_interopRequireDefault((parcelRequire("hWrnM")));

var $8d326d88eadd2288$var$_ThemeProvider = $8d326d88eadd2288$require$_interopRequireDefault((parcelRequire("3sn8B")));

var $8d326d88eadd2288$var$_InitColorSchemeScript = $8d326d88eadd2288$require$_interopRequireWildcard((parcelRequire("ghh97")));

var $8d326d88eadd2288$var$_useCurrentColorScheme = $8d326d88eadd2288$require$_interopRequireDefault((parcelRequire("etJ8Q")));

var $j6whP = parcelRequire("j6whP");
const $8d326d88eadd2288$var$DISABLE_CSS_TRANSITION = module.exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $8d326d88eadd2288$var$createCssVarsProvider(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = $8d326d88eadd2288$var$_InitColorSchemeScript.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = $8d326d88eadd2288$var$_InitColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $8d326d88eadd2288$var$React.createContext(undefined);
    const useColorScheme = ()=>$8d326d88eadd2288$var$React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $8d326d88eadd2288$var$React.useRef(false);
        const upperTheme = (0, $6bJlR.default)();
        const ctx = $8d326d88eadd2288$var$React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $8d326d88eadd2288$var$React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $8d326d88eadd2288$var$React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $8d326d88eadd2288$var$_useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $8d326d88eadd2288$var$React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $8d326d88eadd2288$var$_useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $8d326d88eadd2288$var$React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($8d326d88eadd2288$var$DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $8d326d88eadd2288$var$React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $8d326d88eadd2288$var$React.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $j6whP.jsxs)($8d326d88eadd2288$var$React.Fragment, {
            children: [
                /*#__PURE__*/ (0, $j6whP.jsx)($8d326d88eadd2288$var$_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $j6whP.jsx)($fmb6q.default, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $j6whP.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $8d326d88eadd2288$var$_InitColorSchemeScript.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("6bJlR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4816f309672c98d3$export$2e2bcd8739ae039; });

var $1Pgvo = parcelRequire("1Pgvo");

var $aXxed = parcelRequire("aXxed");
function $4816f309672c98d3$export$2e2bcd8739ae039() {
    const theme = $1Pgvo.useContext((0, $aXxed.default));
    return theme;
}

});
parcelRegister("aXxed", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fa9308462ea3d05$export$2e2bcd8739ae039; });

var $1Pgvo = parcelRequire("1Pgvo");
'use client';
const $7fa9308462ea3d05$var$ThemeContext = /*#__PURE__*/ $1Pgvo.createContext(null);
var $7fa9308462ea3d05$export$2e2bcd8739ae039 = $7fa9308462ea3d05$var$ThemeContext;

});


parcelRegister("hWrnM", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $d0fd1811ccdc5355$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d0fd1811ccdc5355$var$_useEnhancedEffect.default;
    }
});

var $d0fd1811ccdc5355$var$_useEnhancedEffect = $d0fd1811ccdc5355$require$_interopRequireDefault((parcelRequire("3LUZM")));

});
parcelRegister("3LUZM", function(module, exports) {
"use strict";
'use client';

var $pArzt = parcelRequire("pArzt");
var $2bf1f90444f05025$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2bf1f90444f05025$var$React = $2bf1f90444f05025$require$_interopRequireWildcard((parcelRequire("1Pgvo")));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $2bf1f90444f05025$var$useEnhancedEffect = typeof window !== 'undefined' ? $2bf1f90444f05025$var$React.useLayoutEffect : $2bf1f90444f05025$var$React.useEffect;
var $2bf1f90444f05025$var$_default = module.exports.default = $2bf1f90444f05025$var$useEnhancedEffect;

});


parcelRegister("3sn8B", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $2845ef5213303db4$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2845ef5213303db4$var$_ThemeProvider.default;
    }
});

var $2845ef5213303db4$var$_ThemeProvider = $2845ef5213303db4$require$_interopRequireDefault((parcelRequire("ezZqZ")));

});
parcelRegister("ezZqZ", function(module, exports) {
"use strict";
'use client';

var $9rMjh = parcelRequire("9rMjh");
var $a9d3fd20ff2448c1$require$_interopRequireDefault = $9rMjh.default;

var $pArzt = parcelRequire("pArzt");
var $a9d3fd20ff2448c1$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9d3fd20ff2448c1$var$React = $a9d3fd20ff2448c1$require$_interopRequireWildcard((parcelRequire("1Pgvo")));

var $a9d3fd20ff2448c1$var$_propTypes = $a9d3fd20ff2448c1$require$_interopRequireDefault((parcelRequire("gY8Sm")));

var $cULuB = parcelRequire("cULuB");
var $6bJlR = parcelRequire("6bJlR");

var $a9d3fd20ff2448c1$var$_exactProp = $a9d3fd20ff2448c1$require$_interopRequireDefault((parcelRequire("8OcmO")));
parcelRequire("djYnP");
var $jjrEh = parcelRequire("jjrEh");

var $a9d3fd20ff2448c1$var$_useThemeWithoutDefault = $a9d3fd20ff2448c1$require$_interopRequireDefault((parcelRequire("9X6vv")));

var $a9d3fd20ff2448c1$var$_RtlProvider = $a9d3fd20ff2448c1$require$_interopRequireDefault((parcelRequire("23LRt")));

var $a9d3fd20ff2448c1$var$_DefaultPropsProvider = $a9d3fd20ff2448c1$require$_interopRequireDefault((parcelRequire("5TkU6")));

var $j6whP = parcelRequire("j6whP");
const $a9d3fd20ff2448c1$var$EMPTY_THEME = {};
function $a9d3fd20ff2448c1$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $a9d3fd20ff2448c1$var$React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $a9d3fd20ff2448c1$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $a9d3fd20ff2448c1$var$_useThemeWithoutDefault.default)($a9d3fd20ff2448c1$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $6bJlR.default)() || $a9d3fd20ff2448c1$var$EMPTY_THEME;
    const engineTheme = $a9d3fd20ff2448c1$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $a9d3fd20ff2448c1$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    return /*#__PURE__*/ (0, $j6whP.jsx)($cULuB.default, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $j6whP.jsx)($jjrEh.T.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $j6whP.jsx)($a9d3fd20ff2448c1$var$_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $j6whP.jsx)($a9d3fd20ff2448c1$var$_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $a9d3fd20ff2448c1$var$_default = module.exports.default = $a9d3fd20ff2448c1$var$ThemeProvider;

});
parcelRegister("cULuB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $966f8e0a1050cf5a$export$2e2bcd8739ae039; });

var $1Pgvo = parcelRequire("1Pgvo");



var $aXxed = parcelRequire("aXxed");

var $6bJlR = parcelRequire("6bJlR");

var $jBDHy = parcelRequire("jBDHy");

var $j6whP = parcelRequire("j6whP");
function $966f8e0a1050cf5a$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $966f8e0a1050cf5a$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $6bJlR.default)();
    const theme = $1Pgvo.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $966f8e0a1050cf5a$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $jBDHy.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $aXxed.default).Provider, {
        value: theme,
        children: children
    });
}
var $966f8e0a1050cf5a$export$2e2bcd8739ae039 = $966f8e0a1050cf5a$var$ThemeProvider;

});
parcelRegister("jBDHy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e46044e91df1b186$export$2e2bcd8739ae039; });
const $e46044e91df1b186$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $e46044e91df1b186$export$2e2bcd8739ae039 = $e46044e91df1b186$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("8OcmO", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $669c9611d496c245$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $669c9611d496c245$var$_exactProp.default;
    }
});

var $669c9611d496c245$var$_exactProp = $669c9611d496c245$require$_interopRequireDefault((parcelRequire("dU8Hk")));

});
parcelRegister("dU8Hk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a1f7408a305f8fda$var$exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $a1f7408a305f8fda$var$specialProperty = 'exact-prop: \u200b';
function $a1f7408a305f8fda$var$exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

});


parcelRegister("9X6vv", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $73eeabee61651a61$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $73eeabee61651a61$var$_useThemeWithoutDefault.default;
    }
});

var $73eeabee61651a61$var$_useThemeWithoutDefault = $73eeabee61651a61$require$_interopRequireDefault((parcelRequire("dLfsG")));

});
parcelRegister("dLfsG", function(module, exports) {
"use strict";
'use client';

var $pArzt = parcelRequire("pArzt");
var $a04ba87d4af47e44$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a04ba87d4af47e44$var$React = $a04ba87d4af47e44$require$_interopRequireWildcard((parcelRequire("1Pgvo")));
parcelRequire("djYnP");
var $jjrEh = parcelRequire("jjrEh");
function $a04ba87d4af47e44$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $a04ba87d4af47e44$var$useTheme(defaultTheme = null) {
    const contextTheme = $a04ba87d4af47e44$var$React.useContext($jjrEh.T);
    return !contextTheme || $a04ba87d4af47e44$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $a04ba87d4af47e44$var$_default = module.exports.default = $a04ba87d4af47e44$var$useTheme;

});


parcelRegister("23LRt", function(module, exports) {
"use strict";
'use client';

var $9rMjh = parcelRequire("9rMjh");
var $1800fce5f1e47b11$require$_interopRequireDefault = $9rMjh.default;

var $pArzt = parcelRequire("pArzt");
var $1800fce5f1e47b11$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRtl = module.exports.default = void 0;

var $1800fce5f1e47b11$var$React = $1800fce5f1e47b11$require$_interopRequireWildcard((parcelRequire("1Pgvo")));

var $1800fce5f1e47b11$var$_propTypes = $1800fce5f1e47b11$require$_interopRequireDefault((parcelRequire("gY8Sm")));

var $j6whP = parcelRequire("j6whP");
const $1800fce5f1e47b11$var$RtlContext = /*#__PURE__*/ $1800fce5f1e47b11$var$React.createContext();
function $1800fce5f1e47b11$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $j6whP.jsx)($1800fce5f1e47b11$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $1800fce5f1e47b11$var$useRtl = ()=>{
    const value = $1800fce5f1e47b11$var$React.useContext($1800fce5f1e47b11$var$RtlContext);
    return value ?? false;
};
module.exports.useRtl = $1800fce5f1e47b11$var$useRtl;
var $1800fce5f1e47b11$var$_default = module.exports.default = $1800fce5f1e47b11$var$RtlProvider;

});

parcelRegister("5TkU6", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $44a24de7a8c00df7$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $44a24de7a8c00df7$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $44a24de7a8c00df7$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $44a24de7a8c00df7$var$_DefaultPropsProvider = $44a24de7a8c00df7$require$_interopRequireWildcard((parcelRequire("dmKeB")));

});
parcelRegister("dmKeB", function(module, exports) {
"use strict";
'use client';

var $9rMjh = parcelRequire("9rMjh");
var $0282dba3c6d51e6f$require$_interopRequireDefault = $9rMjh.default;

var $pArzt = parcelRequire("pArzt");
var $0282dba3c6d51e6f$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $0282dba3c6d51e6f$var$useDefaultProps;

var $0282dba3c6d51e6f$var$React = $0282dba3c6d51e6f$require$_interopRequireWildcard((parcelRequire("1Pgvo")));

var $0282dba3c6d51e6f$var$_propTypes = $0282dba3c6d51e6f$require$_interopRequireDefault((parcelRequire("gY8Sm")));

var $0282dba3c6d51e6f$var$_resolveProps = $0282dba3c6d51e6f$require$_interopRequireDefault((parcelRequire("kIDXC")));

var $j6whP = parcelRequire("j6whP");
const $0282dba3c6d51e6f$var$PropsContext = /*#__PURE__*/ $0282dba3c6d51e6f$var$React.createContext(undefined);
function $0282dba3c6d51e6f$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $j6whP.jsx)($0282dba3c6d51e6f$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $0282dba3c6d51e6f$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $0282dba3c6d51e6f$var$_resolveProps.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $0282dba3c6d51e6f$var$_resolveProps.default)(config, props);
    return props;
}
function $0282dba3c6d51e6f$var$useDefaultProps({ props: props, name: name }) {
    const ctx = $0282dba3c6d51e6f$var$React.useContext($0282dba3c6d51e6f$var$PropsContext);
    return $0282dba3c6d51e6f$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $0282dba3c6d51e6f$var$_default = module.exports.default = $0282dba3c6d51e6f$var$DefaultPropsProvider;

});




parcelRegister("ghh97", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $bd9b88b76c0afc77$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_ATTRIBUTE = void 0;
module.exports.default = $bd9b88b76c0afc77$var$InitColorSchemeScript;

var $bd9b88b76c0afc77$var$React = $bd9b88b76c0afc77$require$_interopRequireWildcard((parcelRequire("1Pgvo")));

var $j6whP = parcelRequire("j6whP");
/**
 * Split this component for RSC import
 */ const $bd9b88b76c0afc77$var$DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const $bd9b88b76c0afc77$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const $bd9b88b76c0afc77$var$DEFAULT_ATTRIBUTE = module.exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
function $bd9b88b76c0afc77$var$InitColorSchemeScript(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $bd9b88b76c0afc77$var$DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $bd9b88b76c0afc77$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = $bd9b88b76c0afc77$var$DEFAULT_ATTRIBUTE, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $j6whP.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("etJ8Q", function(module, exports) {
"use strict";
'use client';

var $9rMjh = parcelRequire("9rMjh");
var $a8a6ca4f6572ad1b$require$_interopRequireDefault = $9rMjh.default;

var $pArzt = parcelRequire("pArzt");
var $a8a6ca4f6572ad1b$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8a6ca4f6572ad1b$var$useCurrentColorScheme;
module.exports.getColorScheme = $a8a6ca4f6572ad1b$var$getColorScheme;
module.exports.getSystemMode = $a8a6ca4f6572ad1b$var$getSystemMode;

var $a8a6ca4f6572ad1b$var$React = $a8a6ca4f6572ad1b$require$_interopRequireWildcard((parcelRequire("1Pgvo")));

var $ghh97 = parcelRequire("ghh97");

var $a8a6ca4f6572ad1b$var$_localStorageManager = $a8a6ca4f6572ad1b$require$_interopRequireDefault((parcelRequire("kNAnw")));
function $a8a6ca4f6572ad1b$var$noop() {}
function $a8a6ca4f6572ad1b$var$getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $a8a6ca4f6572ad1b$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $a8a6ca4f6572ad1b$var$getColorScheme(state) {
    return $a8a6ca4f6572ad1b$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $a8a6ca4f6572ad1b$var$useCurrentColorScheme(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = $ghh97.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $ghh97.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = $a8a6ca4f6572ad1b$var$_localStorageManager.default, noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $a8a6ca4f6572ad1b$var$React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $a8a6ca4f6572ad1b$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $a8a6ca4f6572ad1b$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $a8a6ca4f6572ad1b$var$React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $a8a6ca4f6572ad1b$var$getSystemMode(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $a8a6ca4f6572ad1b$var$React.useState(noSsr || !isMultiSchemes);
    $a8a6ca4f6572ad1b$var$React.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $a8a6ca4f6572ad1b$var$getColorScheme(state);
    const setMode = $a8a6ca4f6572ad1b$var$React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $a8a6ca4f6572ad1b$var$getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $a8a6ca4f6572ad1b$var$React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $a8a6ca4f6572ad1b$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $a8a6ca4f6572ad1b$var$React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $a8a6ca4f6572ad1b$var$React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $a8a6ca4f6572ad1b$var$React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $a8a6ca4f6572ad1b$var$React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $a8a6ca4f6572ad1b$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $a8a6ca4f6572ad1b$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $a8a6ca4f6572ad1b$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("kNAnw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $f2449a3f6a1c4a5c$var$noop() {}
const $f2449a3f6a1c4a5c$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $f2449a3f6a1c4a5c$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $f2449a3f6a1c4a5c$var$_default = module.exports.default = $f2449a3f6a1c4a5c$var$localStorageManager;

});



parcelRegister("goShU", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $bf08ffadd30d89d4$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf08ffadd30d89d4$var$_deepmerge = $bf08ffadd30d89d4$require$_interopRequireDefault((parcelRequire("cWnbn")));

var $bf08ffadd30d89d4$var$_cssVarsParser = $bf08ffadd30d89d4$require$_interopRequireDefault((parcelRequire("3g4mT")));
function $bf08ffadd30d89d4$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $bf08ffadd30d89d4$var$_cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $bf08ffadd30d89d4$var$_cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, $bf08ffadd30d89d4$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $bf08ffadd30d89d4$var$_cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, $bf08ffadd30d89d4$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $bf08ffadd30d89d4$var$_deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $bf08ffadd30d89d4$var$_default = module.exports.default = $bf08ffadd30d89d4$var$prepareCssVars;

});
parcelRegister("3g4mT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignNestedKeys = void 0;
module.exports.default = $25f6412895ff70be$var$cssVarsParser;
module.exports.walkObjectDeep = void 0;
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $25f6412895ff70be$var$assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ module.exports.assignNestedKeys = $25f6412895ff70be$var$assignNestedKeys;
const $25f6412895ff70be$var$walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
module.exports.walkObjectDeep = $25f6412895ff70be$var$walkObjectDeep;
const $25f6412895ff70be$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function $25f6412895ff70be$var$cssVarsParser(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $25f6412895ff70be$var$walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $25f6412895ff70be$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $25f6412895ff70be$var$assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                $25f6412895ff70be$var$assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("kPJDY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2abf9f664b87b18$var$prepareTypographyVars;
function $f2abf9f664b87b18$var$prepareTypographyVars(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("fupmt", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $b46d54a231f5fbe6$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b46d54a231f5fbe6$var$_prepareCssVars = $b46d54a231f5fbe6$require$_interopRequireDefault((parcelRequire("goShU")));

var $47W0g = parcelRequire("47W0g");

var $ghh97 = parcelRequire("ghh97");
function $b46d54a231f5fbe6$var$createCssVarsTheme({ colorSchemeSelector: colorSchemeSelector = `[${$ghh97.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, $b46d54a231f5fbe6$var$_prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector: colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, $47W0g.createGetColorSchemeSelector)(colorSchemeSelector);
    return output;
}
var $b46d54a231f5fbe6$var$_default = module.exports.default = $b46d54a231f5fbe6$var$createCssVarsTheme;

});
parcelRegister("47W0g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetColorSchemeSelector = $3014cf1e55da1d48$var$createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function $3014cf1e55da1d48$var$createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});


parcelRegister("cxjEl", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $9207cf2510441a2b$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9207cf2510441a2b$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9207cf2510441a2b$var$_generateUtilityClass.default;
    }
});

var $9207cf2510441a2b$var$_generateUtilityClass = $9207cf2510441a2b$require$_interopRequireWildcard((parcelRequire("e8joA")));
Object.keys($9207cf2510441a2b$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9207cf2510441a2b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9207cf2510441a2b$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9207cf2510441a2b$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("e8joA", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $a4a0db96b39d7c35$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4a0db96b39d7c35$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $a4a0db96b39d7c35$var$isGlobalState;

var $a4a0db96b39d7c35$var$_ClassNameGenerator = $a4a0db96b39d7c35$require$_interopRequireDefault((parcelRequire("aDBIy")));
const $a4a0db96b39d7c35$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $a4a0db96b39d7c35$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $a4a0db96b39d7c35$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$a4a0db96b39d7c35$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $a4a0db96b39d7c35$var$isGlobalState(slot) {
    return $a4a0db96b39d7c35$var$globalStateClasses[slot] !== undefined;
}

});
parcelRegister("aDBIy", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $7beacdd96fe75c85$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7beacdd96fe75c85$var$_ClassNameGenerator.default;
    }
});

var $7beacdd96fe75c85$var$_ClassNameGenerator = $7beacdd96fe75c85$require$_interopRequireDefault((parcelRequire("dYDCN")));

});
parcelRegister("dYDCN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $02a0407a4e1552a1$var$defaultGenerator = (componentName)=>componentName;
const $02a0407a4e1552a1$var$createClassNameGenerator = ()=>{
    let generate = $02a0407a4e1552a1$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $02a0407a4e1552a1$var$defaultGenerator;
        }
    };
};
const $02a0407a4e1552a1$var$ClassNameGenerator = $02a0407a4e1552a1$var$createClassNameGenerator();
var $02a0407a4e1552a1$var$_default = module.exports.default = $02a0407a4e1552a1$var$ClassNameGenerator;

});




parcelRegister("3Re6K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2cf143dbb94d4024$var$isFocusVisible;
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $2cf143dbb94d4024$var$isFocusVisible(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});

parcelRegister("aMDvQ", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $7d9d097b0a7b1440$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7d9d097b0a7b1440$var$_useForkRef.default;
    }
});

var $7d9d097b0a7b1440$var$_useForkRef = $7d9d097b0a7b1440$require$_interopRequireDefault((parcelRequire("3A6Ki")));

});
parcelRegister("3A6Ki", function(module, exports) {
"use strict";
'use client';

var $pArzt = parcelRequire("pArzt");
var $29b9f76dc758d748$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $29b9f76dc758d748$var$useForkRef;

var $29b9f76dc758d748$var$React = $29b9f76dc758d748$require$_interopRequireWildcard((parcelRequire("1Pgvo")));
/**
 * Merges refs into a single memoized callback ref or `null`.
 *
 * ```tsx
 * const rootRef = React.useRef<Instance>(null);
 * const refFork = useForkRef(rootRef, props.ref);
 *
 * return (
 *   <Root {...props} ref={refFork} />
 * );
 * ```
 *
 * @param {Array<React.Ref<Instance> | undefined>} refs The ref array.
 * @returns {React.RefCallback<Instance> | null} The new ref callback.
 */ function $29b9f76dc758d748$var$useForkRef(...refs) {
    const cleanupRef = $29b9f76dc758d748$var$React.useRef(undefined);
    const refEffect = $29b9f76dc758d748$var$React.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $29b9f76dc758d748$var$React.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});


parcelRegister("bs5tN", function(module, exports) {
"use strict";
'use client';

var $9rMjh = parcelRequire("9rMjh");
var $85668f60edd2e629$require$_interopRequireDefault = $9rMjh.default;

var $pArzt = parcelRequire("pArzt");
var $85668f60edd2e629$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85668f60edd2e629$var$React = $85668f60edd2e629$require$_interopRequireWildcard((parcelRequire("1Pgvo")));

var $85668f60edd2e629$var$_useEnhancedEffect = $85668f60edd2e629$require$_interopRequireDefault((parcelRequire("hWrnM")));
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $85668f60edd2e629$var$useEventCallback(fn) {
    const ref = $85668f60edd2e629$var$React.useRef(fn);
    (0, $85668f60edd2e629$var$_useEnhancedEffect.default)(()=>{
        ref.current = fn;
    });
    return $85668f60edd2e629$var$React.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $85668f60edd2e629$var$_default = module.exports.default = $85668f60edd2e629$var$useEventCallback;

});

parcelRegister("dr5dP", function(module, exports) {
"use strict";
'use client';

var $pArzt = parcelRequire("pArzt");
var $9c81d8f25036bd39$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c81d8f25036bd39$var$useLazyRef;

var $9c81d8f25036bd39$var$React = $9c81d8f25036bd39$require$_interopRequireWildcard((parcelRequire("1Pgvo")));
const $9c81d8f25036bd39$var$UNINITIALIZED = {};
/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */ function $9c81d8f25036bd39$var$useLazyRef(init, initArg) {
    const ref = $9c81d8f25036bd39$var$React.useRef($9c81d8f25036bd39$var$UNINITIALIZED);
    if (ref.current === $9c81d8f25036bd39$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("cX22W", function(module, exports) {
"use strict";
'use client';

var $9rMjh = parcelRequire("9rMjh");
var $96dc9517e13b0f45$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
module.exports.default = $96dc9517e13b0f45$var$useTimeout;

var $96dc9517e13b0f45$var$_useLazyRef = $96dc9517e13b0f45$require$_interopRequireDefault((parcelRequire("dr5dP")));

var $96dc9517e13b0f45$var$_useOnMount = $96dc9517e13b0f45$require$_interopRequireDefault((parcelRequire("e3Qtv")));
class $96dc9517e13b0f45$var$Timeout {
    static create() {
        return new $96dc9517e13b0f45$var$Timeout();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
module.exports.Timeout = $96dc9517e13b0f45$var$Timeout;
function $96dc9517e13b0f45$var$useTimeout() {
    const timeout = (0, $96dc9517e13b0f45$var$_useLazyRef.default)($96dc9517e13b0f45$var$Timeout.create).current;
    (0, $96dc9517e13b0f45$var$_useOnMount.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("e3Qtv", function(module, exports) {
"use strict";
'use client';

var $pArzt = parcelRequire("pArzt");
var $a3ca0cec8fa13303$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a3ca0cec8fa13303$var$useOnMount;

var $a3ca0cec8fa13303$var$React = $a3ca0cec8fa13303$require$_interopRequireWildcard((parcelRequire("1Pgvo")));
const $a3ca0cec8fa13303$var$EMPTY = [];
/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */ function $a3ca0cec8fa13303$var$useOnMount(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $a3ca0cec8fa13303$var$React.useEffect(fn, $a3ca0cec8fa13303$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("6y44x", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $4c4913b239ba13e3$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4c4913b239ba13e3$var$generateUtilityClasses;

var $4c4913b239ba13e3$var$_generateUtilityClass = $4c4913b239ba13e3$require$_interopRequireDefault((parcelRequire("cxjEl")));
function $4c4913b239ba13e3$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4c4913b239ba13e3$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});

parcelRegister("2c14b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $198d878eafd58d9d$var$debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $198d878eafd58d9d$var$debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("87hkp", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $5e8c6b2aade2d5a9$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5e8c6b2aade2d5a9$var$ownerWindow;

var $5e8c6b2aade2d5a9$var$_ownerDocument = $5e8c6b2aade2d5a9$require$_interopRequireDefault((parcelRequire("2LKgM")));
function $5e8c6b2aade2d5a9$var$ownerWindow(node) {
    const doc = (0, $5e8c6b2aade2d5a9$var$_ownerDocument.default)(node);
    return doc.defaultView || window;
}

});
parcelRegister("2LKgM", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $2043dcbeef5caafe$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2043dcbeef5caafe$var$_ownerDocument.default;
    }
});

var $2043dcbeef5caafe$var$_ownerDocument = $2043dcbeef5caafe$require$_interopRequireDefault((parcelRequire("1yKHZ")));

});
parcelRegister("1yKHZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $122d32c02bc618cf$var$ownerDocument;
function $122d32c02bc618cf$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}

});



parcelRegister("eJe9g", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $ab903e3951d3a04f$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ab903e3951d3a04f$var$_appendOwnerState.default;
    }
});

var $ab903e3951d3a04f$var$_appendOwnerState = $ab903e3951d3a04f$require$_interopRequireDefault((parcelRequire("iUk3q")));

});
parcelRegister("iUk3q", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $dc3d034a928cc52b$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc3d034a928cc52b$var$_isHostComponent = $dc3d034a928cc52b$require$_interopRequireDefault((parcelRequire("8JxnB")));
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $dc3d034a928cc52b$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $dc3d034a928cc52b$var$_isHostComponent.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $dc3d034a928cc52b$var$_default = module.exports.default = $dc3d034a928cc52b$var$appendOwnerState;

});
parcelRegister("8JxnB", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $65bc6b3a442132f8$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $65bc6b3a442132f8$var$_isHostComponent.default;
    }
});

var $65bc6b3a442132f8$var$_isHostComponent = $65bc6b3a442132f8$require$_interopRequireDefault((parcelRequire("hDKjd")));

});
parcelRegister("hDKjd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $cd7a00308116fa02$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $cd7a00308116fa02$var$_default = module.exports.default = $cd7a00308116fa02$var$isHostComponent;

});




parcelRegister("cF2vv", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $937b42409c8d9425$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $937b42409c8d9425$var$_resolveComponentProps.default;
    }
});

var $937b42409c8d9425$var$_resolveComponentProps = $937b42409c8d9425$require$_interopRequireDefault((parcelRequire("2xTbf")));

});
parcelRegister("2xTbf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $1da9778260d128e4$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $1da9778260d128e4$var$_default = module.exports.default = $1da9778260d128e4$var$resolveComponentProps;

});


parcelRegister("bM7Uf", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $892a4f658654be78$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $892a4f658654be78$var$_mergeSlotProps.default;
    }
});

var $892a4f658654be78$var$_mergeSlotProps = $892a4f658654be78$require$_interopRequireDefault((parcelRequire("h2Ycj")));

});
parcelRegister("h2Ycj", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $c691518bedcb54bc$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c691518bedcb54bc$var$_clsx = $c691518bedcb54bc$require$_interopRequireDefault((parcelRequire("2rX73")));

var $c691518bedcb54bc$var$_extractEventHandlers = $c691518bedcb54bc$require$_interopRequireDefault((parcelRequire("aVTDW")));

var $c691518bedcb54bc$var$_omitEventHandlers = $c691518bedcb54bc$require$_interopRequireDefault((parcelRequire("k9dMw")));
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $c691518bedcb54bc$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $c691518bedcb54bc$var$_clsx.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $c691518bedcb54bc$var$_extractEventHandlers.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $c691518bedcb54bc$var$_omitEventHandlers.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $c691518bedcb54bc$var$_omitEventHandlers.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $c691518bedcb54bc$var$_clsx.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $c691518bedcb54bc$var$_default = module.exports.default = $c691518bedcb54bc$var$mergeSlotProps;

});
parcelRegister("aVTDW", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $7f5a63d731798e5e$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7f5a63d731798e5e$var$_extractEventHandlers.default;
    }
});

var $7f5a63d731798e5e$var$_extractEventHandlers = $7f5a63d731798e5e$require$_interopRequireDefault((parcelRequire("iFI82")));

});
parcelRegister("iFI82", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $d97e495829b116dc$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $d97e495829b116dc$var$_default = module.exports.default = $d97e495829b116dc$var$extractEventHandlers;

});


parcelRegister("k9dMw", function(module, exports) {
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $eaaf56a2771b2d4f$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $eaaf56a2771b2d4f$var$_omitEventHandlers.default;
    }
});

var $eaaf56a2771b2d4f$var$_omitEventHandlers = $eaaf56a2771b2d4f$require$_interopRequireDefault((parcelRequire("9XoAl")));

});
parcelRegister("9XoAl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $73fcb1db56171a93$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $73fcb1db56171a93$var$_default = module.exports.default = $73fcb1db56171a93$var$omitEventHandlers;

});




parcelRegister("5X3ju", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $45550865ac26e458$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45550865ac26e458$var$isMuiElement;

var $45550865ac26e458$var$React = $45550865ac26e458$require$_interopRequireWildcard((parcelRequire("1Pgvo")));
function $45550865ac26e458$var$isMuiElement(element, muiNames) {
    return /*#__PURE__*/ $45550865ac26e458$var$React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});

parcelRegister("9OT8I", function(module, exports) {
"use strict";

var $pArzt = parcelRequire("pArzt");
var $72638e22fc33215b$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72638e22fc33215b$var$getReactElementRef;

var $72638e22fc33215b$var$React = $72638e22fc33215b$require$_interopRequireWildcard((parcelRequire("1Pgvo")));
/**
 * Returns the ref of a React element handling differences between React 19 and older versions.
 * It will throw runtime error if the element is not a valid React element.
 *
 * @param element React.ReactElement
 * @returns React.Ref<any> | null
 */ function $72638e22fc33215b$var$getReactElementRef(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($72638e22fc33215b$var$React.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

});

parcelRegister("lFsgz", function(module, exports) {
"use strict";
'use client';

var $9rMjh = parcelRequire("9rMjh");
var $fc635a67e4869e16$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc635a67e4869e16$var$_useForkRef = $fc635a67e4869e16$require$_interopRequireDefault((parcelRequire("aMDvQ")));

var $fc635a67e4869e16$var$_appendOwnerState = $fc635a67e4869e16$require$_interopRequireDefault((parcelRequire("eJe9g")));

var $fc635a67e4869e16$var$_mergeSlotProps = $fc635a67e4869e16$require$_interopRequireDefault((parcelRequire("bM7Uf")));

var $fc635a67e4869e16$var$_resolveComponentProps = $fc635a67e4869e16$require$_interopRequireDefault((parcelRequire("cF2vv")));
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $fc635a67e4869e16$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $fc635a67e4869e16$var$_resolveComponentProps.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $fc635a67e4869e16$var$_mergeSlotProps.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $fc635a67e4869e16$var$_useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $fc635a67e4869e16$var$_appendOwnerState.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $fc635a67e4869e16$var$_default = module.exports.default = $fc635a67e4869e16$var$useSlotProps;

});

parcelRegister("iFm5Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d96d31942543e602$var$getScrollbarSize;
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $d96d31942543e602$var$getScrollbarSize(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});

parcelRegister("eSg3S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad42914b8d1bd127$var$setRef;
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $ad42914b8d1bd127$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});

parcelRegister("2MPZL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2078659bd77e2759$var$createChainedFunction;
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $2078659bd77e2759$var$createChainedFunction(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("GrFNn", function(module, exports) {
"use strict";
'use client';

var $pArzt = parcelRequire("pArzt");
var $07f963a9ec94413a$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07f963a9ec94413a$var$useControlled;

var $07f963a9ec94413a$var$React = $07f963a9ec94413a$require$_interopRequireWildcard((parcelRequire("1Pgvo")));
function $07f963a9ec94413a$var$useControlled(props) {
    const { controlled: controlled, default: defaultProp, name: name, state: state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $07f963a9ec94413a$var$React.useRef(controlled !== undefined);
    const [valueState, setValue] = $07f963a9ec94413a$var$React.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $07f963a9ec94413a$var$React.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefiend.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

var $bd35c3c2c1275e70$exports = {};


(parcelRequire("hltpo")).register((parcelRequire("7Hfbu")).getBundleURL('hYViF'), JSON.parse("[\"hYViF\",\"index.2d6180da.js\",\"jj2cm\",\"returns-wealth-logo.f9bc96de.png\",\"2bhiU\",\"logo-black.393d1d6e.webp\",\"4JaOh\",\"failed.33341481.webm\",\"FGIUW\",\"arrow.cb81dc10.svg\",\"fhw8V\",\"unlock.8f71d399.png\",\"6md61\",\"opening-home.d6aa14e0.webp\",\"7U7TA\",\"qr-code.7f400d1d.svg\",\"6iNsf\",\"call-icon.bf3352ee.png\",\"1PHf1\",\"idea-icon.c163bf1c.png\",\"aAHE0\",\"portfolio-icon.d7bca1bf.png\",\"g9Wha\",\"call-icon-inactive.6556993b.png\",\"8DZKN\",\"idea-icon-inactive.79ebf5a4.png\",\"ahzdw\",\"portfolio-icon-inactive.aa3daca7.png\",\"275An\",\"call-image.3daf7759.webp\",\"9tCdr\",\"cimage.abf484d4.png\",\"ciXrX\",\"pimage.63fc694e.png\",\"2I28d\",\"call-image-mobile.fe2ac963.webp\",\"7VftH\",\"stock-idea-image-mobile.60520f83.webp\",\"iOCao\",\"portfolio-image-mobile.df9e7483.png\",\"8jWp2\",\"contact-detail.fb0c7734.png\",\"ahwOV\",\"index.579ccbac.css\"]"));


var $j6whP = parcelRequire("j6whP");
parcelRequire("1Pgvo");
var $cb66d78021bfafed$exports = {};
'use strict';
function $cb66d78021bfafed$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($cb66d78021bfafed$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$cb66d78021bfafed$var$checkDCE();

$cb66d78021bfafed$exports = (parcelRequire("jGakj"));



var $j6whP = parcelRequire("j6whP");
/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $1Pgvo = parcelRequire("1Pgvo");

var $kZ6Vu = parcelRequire("kZ6Vu");
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $fdfac8a1aae2b1ce$var$_extends() {
    $fdfac8a1aae2b1ce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fdfac8a1aae2b1ce$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($fdfac8a1aae2b1ce$export$e19cd5f9376f8cee || ($fdfac8a1aae2b1ce$export$e19cd5f9376f8cee = {}));
const $fdfac8a1aae2b1ce$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $fdfac8a1aae2b1ce$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $fdfac8a1aae2b1ce$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $fdfac8a1aae2b1ce$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $fdfac8a1aae2b1ce$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $fdfac8a1aae2b1ce$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $fdfac8a1aae2b1ce$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $fdfac8a1aae2b1ce$export$fe53371bee54353d(to);
    }
    return $fdfac8a1aae2b1ce$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $fdfac8a1aae2b1ce$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $fdfac8a1aae2b1ce$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $fdfac8a1aae2b1ce$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $fdfac8a1aae2b1ce$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $fdfac8a1aae2b1ce$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $fdfac8a1aae2b1ce$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $fdfac8a1aae2b1ce$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $fdfac8a1aae2b1ce$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $fdfac8a1aae2b1ce$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $fdfac8a1aae2b1ce$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $fdfac8a1aae2b1ce$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $fdfac8a1aae2b1ce$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $fdfac8a1aae2b1ce$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $fdfac8a1aae2b1ce$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($fdfac8a1aae2b1ce$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Push;
        let location = $fdfac8a1aae2b1ce$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $fdfac8a1aae2b1ce$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Replace;
        let location = $fdfac8a1aae2b1ce$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $fdfac8a1aae2b1ce$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $fdfac8a1aae2b1ce$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($fdfac8a1aae2b1ce$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($fdfac8a1aae2b1ce$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $fdfac8a1aae2b1ce$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($fdfac8a1aae2b1ce$var$ResultType || ($fdfac8a1aae2b1ce$var$ResultType = {}));
const $fdfac8a1aae2b1ce$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $fdfac8a1aae2b1ce$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $fdfac8a1aae2b1ce$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($fdfac8a1aae2b1ce$var$isIndexRoute(route)) {
            let indexRoute = $fdfac8a1aae2b1ce$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $fdfac8a1aae2b1ce$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $fdfac8a1aae2b1ce$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $fdfac8a1aae2b1ce$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $fdfac8a1aae2b1ce$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $fdfac8a1aae2b1ce$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $fdfac8a1aae2b1ce$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $fdfac8a1aae2b1ce$var$flattenRoutes(routes);
    $fdfac8a1aae2b1ce$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $fdfac8a1aae2b1ce$export$30d21fd6d7295f52(pathname);
        matches = $fdfac8a1aae2b1ce$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $fdfac8a1aae2b1ce$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $fdfac8a1aae2b1ce$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $fdfac8a1aae2b1ce$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $fdfac8a1aae2b1ce$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $fdfac8a1aae2b1ce$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $fdfac8a1aae2b1ce$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $fdfac8a1aae2b1ce$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $fdfac8a1aae2b1ce$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $fdfac8a1aae2b1ce$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $fdfac8a1aae2b1ce$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $fdfac8a1aae2b1ce$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $fdfac8a1aae2b1ce$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $fdfac8a1aae2b1ce$var$paramRe = /^:[\w-]+$/;
const $fdfac8a1aae2b1ce$var$dynamicSegmentValue = 3;
const $fdfac8a1aae2b1ce$var$indexRouteValue = 2;
const $fdfac8a1aae2b1ce$var$emptySegmentValue = 1;
const $fdfac8a1aae2b1ce$var$staticSegmentValue = 10;
const $fdfac8a1aae2b1ce$var$splatPenalty = -2;
const $fdfac8a1aae2b1ce$var$isSplat = (s)=>s === "*";
function $fdfac8a1aae2b1ce$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($fdfac8a1aae2b1ce$var$isSplat)) initialScore += $fdfac8a1aae2b1ce$var$splatPenalty;
    if (index) initialScore += $fdfac8a1aae2b1ce$var$indexRouteValue;
    return segments.filter((s)=>!$fdfac8a1aae2b1ce$var$isSplat(s)).reduce((score, segment)=>score + ($fdfac8a1aae2b1ce$var$paramRe.test(segment) ? $fdfac8a1aae2b1ce$var$dynamicSegmentValue : segment === "" ? $fdfac8a1aae2b1ce$var$emptySegmentValue : $fdfac8a1aae2b1ce$var$staticSegmentValue), initialScore);
}
function $fdfac8a1aae2b1ce$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $fdfac8a1aae2b1ce$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $fdfac8a1aae2b1ce$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $fdfac8a1aae2b1ce$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $fdfac8a1aae2b1ce$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $fdfac8a1aae2b1ce$export$a5c6d149b50c1d86($fdfac8a1aae2b1ce$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $fdfac8a1aae2b1ce$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $fdfac8a1aae2b1ce$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $fdfac8a1aae2b1ce$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $fdfac8a1aae2b1ce$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $fdfac8a1aae2b1ce$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $fdfac8a1aae2b1ce$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $fdfac8a1aae2b1ce$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $fdfac8a1aae2b1ce$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $fdfac8a1aae2b1ce$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $fdfac8a1aae2b1ce$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $fdfac8a1aae2b1ce$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $fdfac8a1aae2b1ce$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $fdfac8a1aae2b1ce$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $fdfac8a1aae2b1ce$var$normalizeSearch(search),
        hash: $fdfac8a1aae2b1ce$var$normalizeHash(hash)
    };
}
function $fdfac8a1aae2b1ce$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $fdfac8a1aae2b1ce$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $fdfac8a1aae2b1ce$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $fdfac8a1aae2b1ce$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $fdfac8a1aae2b1ce$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $fdfac8a1aae2b1ce$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0(toArg);
    else {
        to = $fdfac8a1aae2b1ce$var$_extends({}, toArg);
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $fdfac8a1aae2b1ce$var$getInvalidPathError("?", "pathname", "search", to));
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $fdfac8a1aae2b1ce$var$getInvalidPathError("#", "pathname", "hash", to));
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $fdfac8a1aae2b1ce$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $fdfac8a1aae2b1ce$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $fdfac8a1aae2b1ce$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $fdfac8a1aae2b1ce$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $fdfac8a1aae2b1ce$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $fdfac8a1aae2b1ce$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $fdfac8a1aae2b1ce$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $fdfac8a1aae2b1ce$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $fdfac8a1aae2b1ce$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $fdfac8a1aae2b1ce$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $fdfac8a1aae2b1ce$export$4051a07651545597(data, init) {
    return new $fdfac8a1aae2b1ce$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $fdfac8a1aae2b1ce$export$42a99a7a4bc0e76a extends Error {
}
class $fdfac8a1aae2b1ce$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $fdfac8a1aae2b1ce$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $fdfac8a1aae2b1ce$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $fdfac8a1aae2b1ce$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $fdfac8a1aae2b1ce$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $fdfac8a1aae2b1ce$var$unwrapTrackedPromise(value) {
    if (!$fdfac8a1aae2b1ce$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $fdfac8a1aae2b1ce$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $fdfac8a1aae2b1ce$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fdfac8a1aae2b1ce$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $fdfac8a1aae2b1ce$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fdfac8a1aae2b1ce$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $fdfac8a1aae2b1ce$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fdfac8a1aae2b1ce$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $fdfac8a1aae2b1ce$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $fdfac8a1aae2b1ce$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $fdfac8a1aae2b1ce$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $fdfac8a1aae2b1ce$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $fdfac8a1aae2b1ce$var$validMutationMethods = new Set($fdfac8a1aae2b1ce$var$validMutationMethodsArr);
const $fdfac8a1aae2b1ce$var$validRequestMethodsArr = [
    "get",
    ...$fdfac8a1aae2b1ce$var$validMutationMethodsArr
];
const $fdfac8a1aae2b1ce$var$validRequestMethods = new Set($fdfac8a1aae2b1ce$var$validRequestMethodsArr);
const $fdfac8a1aae2b1ce$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $fdfac8a1aae2b1ce$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $fdfac8a1aae2b1ce$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $fdfac8a1aae2b1ce$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $fdfac8a1aae2b1ce$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $fdfac8a1aae2b1ce$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $fdfac8a1aae2b1ce$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $fdfac8a1aae2b1ce$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $fdfac8a1aae2b1ce$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $fdfac8a1aae2b1ce$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $fdfac8a1aae2b1ce$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $fdfac8a1aae2b1ce$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $fdfac8a1aae2b1ce$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $fdfac8a1aae2b1ce$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $fdfac8a1aae2b1ce$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $fdfac8a1aae2b1ce$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $fdfac8a1aae2b1ce$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$fdfac8a1aae2b1ce$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$fdfac8a1aae2b1ce$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $fdfac8a1aae2b1ce$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $fdfac8a1aae2b1ce$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $fdfac8a1aae2b1ce$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $fdfac8a1aae2b1ce$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$fdfac8a1aae2b1ce$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $fdfac8a1aae2b1ce$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $fdfac8a1aae2b1ce$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $fdfac8a1aae2b1ce$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $fdfac8a1aae2b1ce$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $fdfac8a1aae2b1ce$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($fdfac8a1aae2b1ce$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $fdfac8a1aae2b1ce$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $fdfac8a1aae2b1ce$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $fdfac8a1aae2b1ce$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $fdfac8a1aae2b1ce$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $fdfac8a1aae2b1ce$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $fdfac8a1aae2b1ce$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $fdfac8a1aae2b1ce$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $fdfac8a1aae2b1ce$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $fdfac8a1aae2b1ce$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $fdfac8a1aae2b1ce$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $fdfac8a1aae2b1ce$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $fdfac8a1aae2b1ce$var$findNearestBoundary(matches).route.id,
            {
                type: $fdfac8a1aae2b1ce$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $fdfac8a1aae2b1ce$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($fdfac8a1aae2b1ce$var$isErrorResult(result) && $fdfac8a1aae2b1ce$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $fdfac8a1aae2b1ce$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $fdfac8a1aae2b1ce$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $fdfac8a1aae2b1ce$var$_extends({
            matches: updatedMatches || matches
        }, $fdfac8a1aae2b1ce$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $fdfac8a1aae2b1ce$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $fdfac8a1aae2b1ce$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $fdfac8a1aae2b1ce$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $fdfac8a1aae2b1ce$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $fdfac8a1aae2b1ce$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $fdfac8a1aae2b1ce$var$ResultType.error,
            error: $fdfac8a1aae2b1ce$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($fdfac8a1aae2b1ce$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $fdfac8a1aae2b1ce$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($fdfac8a1aae2b1ce$var$isDeferredResult(result)) throw $fdfac8a1aae2b1ce$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($fdfac8a1aae2b1ce$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $fdfac8a1aae2b1ce$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $fdfac8a1aae2b1ce$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $fdfac8a1aae2b1ce$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($fdfac8a1aae2b1ce$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $fdfac8a1aae2b1ce$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $fdfac8a1aae2b1ce$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $fdfac8a1aae2b1ce$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $fdfac8a1aae2b1ce$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $fdfac8a1aae2b1ce$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $fdfac8a1aae2b1ce$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $fdfac8a1aae2b1ce$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $fdfac8a1aae2b1ce$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $fdfac8a1aae2b1ce$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $fdfac8a1aae2b1ce$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$fdfac8a1aae2b1ce$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $fdfac8a1aae2b1ce$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $fdfac8a1aae2b1ce$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $fdfac8a1aae2b1ce$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $fdfac8a1aae2b1ce$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $fdfac8a1aae2b1ce$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $fdfac8a1aae2b1ce$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $fdfac8a1aae2b1ce$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $fdfac8a1aae2b1ce$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fdfac8a1aae2b1ce$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fdfac8a1aae2b1ce$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fdfac8a1aae2b1ce$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $fdfac8a1aae2b1ce$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($fdfac8a1aae2b1ce$var$isRedirectResult(actionResult) || $fdfac8a1aae2b1ce$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $fdfac8a1aae2b1ce$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($fdfac8a1aae2b1ce$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $fdfac8a1aae2b1ce$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $fdfac8a1aae2b1ce$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($fdfac8a1aae2b1ce$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($fdfac8a1aae2b1ce$var$isDeferredResult(actionResult)) throw $fdfac8a1aae2b1ce$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $fdfac8a1aae2b1ce$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $fdfac8a1aae2b1ce$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $fdfac8a1aae2b1ce$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $fdfac8a1aae2b1ce$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $fdfac8a1aae2b1ce$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $fdfac8a1aae2b1ce$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $fdfac8a1aae2b1ce$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $fdfac8a1aae2b1ce$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $fdfac8a1aae2b1ce$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $fdfac8a1aae2b1ce$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $fdfac8a1aae2b1ce$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fdfac8a1aae2b1ce$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fdfac8a1aae2b1ce$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fdfac8a1aae2b1ce$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $fdfac8a1aae2b1ce$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($fdfac8a1aae2b1ce$var$isDeferredResult(result)) result = await $fdfac8a1aae2b1ce$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $fdfac8a1aae2b1ce$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($fdfac8a1aae2b1ce$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $fdfac8a1aae2b1ce$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($fdfac8a1aae2b1ce$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(!$fdfac8a1aae2b1ce$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $fdfac8a1aae2b1ce$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $fdfac8a1aae2b1ce$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $fdfac8a1aae2b1ce$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($fdfac8a1aae2b1ce$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $fdfac8a1aae2b1ce$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Replace : $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $fdfac8a1aae2b1ce$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($fdfac8a1aae2b1ce$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $fdfac8a1aae2b1ce$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $fdfac8a1aae2b1ce$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $fdfac8a1aae2b1ce$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $fdfac8a1aae2b1ce$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $fdfac8a1aae2b1ce$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($fdfac8a1aae2b1ce$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $fdfac8a1aae2b1ce$var$ResultType.redirect,
                response: $fdfac8a1aae2b1ce$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $fdfac8a1aae2b1ce$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $fdfac8a1aae2b1ce$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $fdfac8a1aae2b1ce$var$ResultType.error,
                    error: $fdfac8a1aae2b1ce$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $fdfac8a1aae2b1ce$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $fdfac8a1aae2b1ce$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $fdfac8a1aae2b1ce$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $fdfac8a1aae2b1ce$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $fdfac8a1aae2b1ce$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $fdfac8a1aae2b1ce$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $fdfac8a1aae2b1ce$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $fdfac8a1aae2b1ce$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $fdfac8a1aae2b1ce$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $fdfac8a1aae2b1ce$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $fdfac8a1aae2b1ce$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $fdfac8a1aae2b1ce$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $fdfac8a1aae2b1ce$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$fdfac8a1aae2b1ce$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $fdfac8a1aae2b1ce$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $fdfac8a1aae2b1ce$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $fdfac8a1aae2b1ce$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $fdfac8a1aae2b1ce$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $fdfac8a1aae2b1ce$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $fdfac8a1aae2b1ce$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $fdfac8a1aae2b1ce$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $fdfac8a1aae2b1ce$export$4d0306f8f6a4585b = Symbol("deferred");
function $fdfac8a1aae2b1ce$export$3336b097a6fbc59a(routes, opts) {
    $fdfac8a1aae2b1ce$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $fdfac8a1aae2b1ce$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $fdfac8a1aae2b1ce$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $fdfac8a1aae2b1ce$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $fdfac8a1aae2b1ce$var$createLocation("", $fdfac8a1aae2b1ce$export$fe53371bee54353d(url), null, "default");
        let matches = $fdfac8a1aae2b1ce$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$fdfac8a1aae2b1ce$var$isValidMethod(method) && method !== "HEAD") {
            let error = $fdfac8a1aae2b1ce$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $fdfac8a1aae2b1ce$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $fdfac8a1aae2b1ce$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $fdfac8a1aae2b1ce$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($fdfac8a1aae2b1ce$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $fdfac8a1aae2b1ce$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $fdfac8a1aae2b1ce$var$createLocation("", $fdfac8a1aae2b1ce$export$fe53371bee54353d(url), null, "default");
        let matches = $fdfac8a1aae2b1ce$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$fdfac8a1aae2b1ce$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $fdfac8a1aae2b1ce$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $fdfac8a1aae2b1ce$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $fdfac8a1aae2b1ce$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $fdfac8a1aae2b1ce$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $fdfac8a1aae2b1ce$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($fdfac8a1aae2b1ce$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$fdfac8a1aae2b1ce$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($fdfac8a1aae2b1ce$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $fdfac8a1aae2b1ce$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $fdfac8a1aae2b1ce$var$isResponse(result) ? result : $fdfac8a1aae2b1ce$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($fdfac8a1aae2b1ce$var$isDataStrategyResult(e) && $fdfac8a1aae2b1ce$var$isResponse(e.result)) {
                if (e.type === $fdfac8a1aae2b1ce$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($fdfac8a1aae2b1ce$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $fdfac8a1aae2b1ce$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $fdfac8a1aae2b1ce$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $fdfac8a1aae2b1ce$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($fdfac8a1aae2b1ce$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($fdfac8a1aae2b1ce$var$isDeferredResult(result)) {
            let error = $fdfac8a1aae2b1ce$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $fdfac8a1aae2b1ce$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($fdfac8a1aae2b1ce$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($fdfac8a1aae2b1ce$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $fdfac8a1aae2b1ce$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $fdfac8a1aae2b1ce$var$_extends({}, context, {
                statusCode: $fdfac8a1aae2b1ce$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $fdfac8a1aae2b1ce$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $fdfac8a1aae2b1ce$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $fdfac8a1aae2b1ce$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $fdfac8a1aae2b1ce$var$isErrorResult(pendingActionResult[1]) ? $fdfac8a1aae2b1ce$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $fdfac8a1aae2b1ce$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $fdfac8a1aae2b1ce$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $fdfac8a1aae2b1ce$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $fdfac8a1aae2b1ce$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $fdfac8a1aae2b1ce$var$callDataStrategyImpl(dataStrategy || $fdfac8a1aae2b1ce$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($fdfac8a1aae2b1ce$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $fdfac8a1aae2b1ce$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($fdfac8a1aae2b1ce$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $fdfac8a1aae2b1ce$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $fdfac8a1aae2b1ce$export$fec11da027c70692(routes, context, error) {
    let newContext = $fdfac8a1aae2b1ce$var$_extends({}, context, {
        statusCode: $fdfac8a1aae2b1ce$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $fdfac8a1aae2b1ce$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $fdfac8a1aae2b1ce$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $fdfac8a1aae2b1ce$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $fdfac8a1aae2b1ce$export$cae722b0cc860f13(to ? to : ".", $fdfac8a1aae2b1ce$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $fdfac8a1aae2b1ce$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $fdfac8a1aae2b1ce$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $fdfac8a1aae2b1ce$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $fdfac8a1aae2b1ce$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $fdfac8a1aae2b1ce$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$fdfac8a1aae2b1ce$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$fdfac8a1aae2b1ce$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $fdfac8a1aae2b1ce$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $fdfac8a1aae2b1ce$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $fdfac8a1aae2b1ce$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$fdfac8a1aae2b1ce$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$fdfac8a1aae2b1ce$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $fdfac8a1aae2b1ce$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $fdfac8a1aae2b1ce$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $fdfac8a1aae2b1ce$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $fdfac8a1aae2b1ce$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $fdfac8a1aae2b1ce$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($fdfac8a1aae2b1ce$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $fdfac8a1aae2b1ce$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $fdfac8a1aae2b1ce$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $fdfac8a1aae2b1ce$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $fdfac8a1aae2b1ce$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $fdfac8a1aae2b1ce$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $fdfac8a1aae2b1ce$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $fdfac8a1aae2b1ce$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $fdfac8a1aae2b1ce$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $fdfac8a1aae2b1ce$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($fdfac8a1aae2b1ce$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $fdfac8a1aae2b1ce$var$shouldRevalidateLoader(match, $fdfac8a1aae2b1ce$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $fdfac8a1aae2b1ce$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $fdfac8a1aae2b1ce$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $fdfac8a1aae2b1ce$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $fdfac8a1aae2b1ce$var$shouldRevalidateLoader(fetcherMatch, $fdfac8a1aae2b1ce$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $fdfac8a1aae2b1ce$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $fdfac8a1aae2b1ce$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $fdfac8a1aae2b1ce$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $fdfac8a1aae2b1ce$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $fdfac8a1aae2b1ce$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$fdfac8a1aae2b1ce$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $fdfac8a1aae2b1ce$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $fdfac8a1aae2b1ce$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$fdfac8a1aae2b1ce$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $fdfac8a1aae2b1ce$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $fdfac8a1aae2b1ce$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $fdfac8a1aae2b1ce$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$fdfac8a1aae2b1ce$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $fdfac8a1aae2b1ce$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $fdfac8a1aae2b1ce$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $fdfac8a1aae2b1ce$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $fdfac8a1aae2b1ce$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $fdfac8a1aae2b1ce$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $fdfac8a1aae2b1ce$var$ResultType.data,
                result: undefined
            });
        };
        return $fdfac8a1aae2b1ce$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $fdfac8a1aae2b1ce$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $fdfac8a1aae2b1ce$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $fdfac8a1aae2b1ce$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $fdfac8a1aae2b1ce$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $fdfac8a1aae2b1ce$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $fdfac8a1aae2b1ce$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($fdfac8a1aae2b1ce$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $fdfac8a1aae2b1ce$var$ResultType.error,
                error: e
            };
        }
        if (type === $fdfac8a1aae2b1ce$var$ResultType.error) return {
            type: $fdfac8a1aae2b1ce$var$ResultType.error,
            error: new $fdfac8a1aae2b1ce$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $fdfac8a1aae2b1ce$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $fdfac8a1aae2b1ce$var$ResultType.error) {
        if ($fdfac8a1aae2b1ce$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $fdfac8a1aae2b1ce$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $fdfac8a1aae2b1ce$var$ResultType.error,
                error: new $fdfac8a1aae2b1ce$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $fdfac8a1aae2b1ce$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $fdfac8a1aae2b1ce$var$ResultType.error,
            error: result,
            statusCode: $fdfac8a1aae2b1ce$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($fdfac8a1aae2b1ce$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $fdfac8a1aae2b1ce$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($fdfac8a1aae2b1ce$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $fdfac8a1aae2b1ce$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $fdfac8a1aae2b1ce$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $fdfac8a1aae2b1ce$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $fdfac8a1aae2b1ce$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$fdfac8a1aae2b1ce$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $fdfac8a1aae2b1ce$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $fdfac8a1aae2b1ce$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($fdfac8a1aae2b1ce$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $fdfac8a1aae2b1ce$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $fdfac8a1aae2b1ce$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($fdfac8a1aae2b1ce$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $fdfac8a1aae2b1ce$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $fdfac8a1aae2b1ce$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $fdfac8a1aae2b1ce$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $fdfac8a1aae2b1ce$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $fdfac8a1aae2b1ce$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $fdfac8a1aae2b1ce$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(!$fdfac8a1aae2b1ce$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($fdfac8a1aae2b1ce$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $fdfac8a1aae2b1ce$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $fdfac8a1aae2b1ce$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($fdfac8a1aae2b1ce$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $fdfac8a1aae2b1ce$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $fdfac8a1aae2b1ce$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($fdfac8a1aae2b1ce$var$isErrorResult(result)) {
            let boundaryMatch = $fdfac8a1aae2b1ce$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $fdfac8a1aae2b1ce$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($fdfac8a1aae2b1ce$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($fdfac8a1aae2b1ce$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $fdfac8a1aae2b1ce$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $fdfac8a1aae2b1ce$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $fdfac8a1aae2b1ce$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $fdfac8a1aae2b1ce$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $fdfac8a1aae2b1ce$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $fdfac8a1aae2b1ce$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $fdfac8a1aae2b1ce$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $fdfac8a1aae2b1ce$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $fdfac8a1aae2b1ce$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $fdfac8a1aae2b1ce$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $fdfac8a1aae2b1ce$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($fdfac8a1aae2b1ce$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $fdfac8a1aae2b1ce$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0(path) : path;
    return $fdfac8a1aae2b1ce$export$fe53371bee54353d($fdfac8a1aae2b1ce$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $fdfac8a1aae2b1ce$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $fdfac8a1aae2b1ce$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $fdfac8a1aae2b1ce$var$ResultType.data || result.type === $fdfac8a1aae2b1ce$var$ResultType.error);
}
function $fdfac8a1aae2b1ce$var$isRedirectDataStrategyResultResult(result) {
    return $fdfac8a1aae2b1ce$var$isResponse(result.result) && $fdfac8a1aae2b1ce$var$redirectStatusCodes.has(result.result.status);
}
function $fdfac8a1aae2b1ce$var$isDeferredResult(result) {
    return result.type === $fdfac8a1aae2b1ce$var$ResultType.deferred;
}
function $fdfac8a1aae2b1ce$var$isErrorResult(result) {
    return result.type === $fdfac8a1aae2b1ce$var$ResultType.error;
}
function $fdfac8a1aae2b1ce$var$isRedirectResult(result) {
    return (result && result.type) === $fdfac8a1aae2b1ce$var$ResultType.redirect;
}
function $fdfac8a1aae2b1ce$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $fdfac8a1aae2b1ce$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $fdfac8a1aae2b1ce$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $fdfac8a1aae2b1ce$var$isRedirectResponse(result) {
    if (!$fdfac8a1aae2b1ce$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $fdfac8a1aae2b1ce$var$isValidMethod(method) {
    return $fdfac8a1aae2b1ce$var$validRequestMethods.has(method.toLowerCase());
}
function $fdfac8a1aae2b1ce$var$isMutationMethod(method) {
    return $fdfac8a1aae2b1ce$var$validMutationMethods.has(method.toLowerCase());
}
async function $fdfac8a1aae2b1ce$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$fdfac8a1aae2b1ce$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($fdfac8a1aae2b1ce$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $fdfac8a1aae2b1ce$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $fdfac8a1aae2b1ce$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($fdfac8a1aae2b1ce$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $fdfac8a1aae2b1ce$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $fdfac8a1aae2b1ce$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $fdfac8a1aae2b1ce$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $fdfac8a1aae2b1ce$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $fdfac8a1aae2b1ce$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $fdfac8a1aae2b1ce$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $fdfac8a1aae2b1ce$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $fdfac8a1aae2b1ce$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $fdfac8a1aae2b1ce$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $fdfac8a1aae2b1ce$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $fdfac8a1aae2b1ce$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $fdfac8a1aae2b1ce$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $fdfac8a1aae2b1ce$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $fdfac8a1aae2b1ce$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $fdfac8a1aae2b1ce$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $fdfac8a1aae2b1ce$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $fdfac8a1aae2b1ce$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($fdfac8a1aae2b1ce$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $fdfac8a1aae2b1ce$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($fdfac8a1aae2b1ce$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $fdfac8a1aae2b1ce$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $1Pgvo = parcelRequire("1Pgvo");

function $3a01a64de9a26688$var$_extends() {
    $3a01a64de9a26688$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3a01a64de9a26688$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $3a01a64de9a26688$export$3add0d5dce533e2e = /*#__PURE__*/ $1Pgvo.createContext(null);
const $3a01a64de9a26688$export$145dfa71566a64dc = /*#__PURE__*/ $1Pgvo.createContext(null);
const $3a01a64de9a26688$var$AwaitContext = /*#__PURE__*/ $1Pgvo.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $3a01a64de9a26688$export$26749e8557646306 = /*#__PURE__*/ $1Pgvo.createContext(null);
const $3a01a64de9a26688$export$c7914228fb69b0f5 = /*#__PURE__*/ $1Pgvo.createContext(null);
const $3a01a64de9a26688$export$9072aa6dd1f93057 = /*#__PURE__*/ $1Pgvo.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $3a01a64de9a26688$var$RouteErrorContext = /*#__PURE__*/ $1Pgvo.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $3a01a64de9a26688$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$3a01a64de9a26688$export$9c954a9d03d32f4a() && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $1Pgvo.useContext($3a01a64de9a26688$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $3a01a64de9a26688$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $fdfac8a1aae2b1ce$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $3a01a64de9a26688$export$9c954a9d03d32f4a() {
    return $1Pgvo.useContext($3a01a64de9a26688$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $3a01a64de9a26688$export$45d76561a5302f2b() {
    !$3a01a64de9a26688$export$9c954a9d03d32f4a() && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    return $1Pgvo.useContext($3a01a64de9a26688$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $3a01a64de9a26688$export$1b3f31771c5d07c() {
    return $1Pgvo.useContext($3a01a64de9a26688$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $3a01a64de9a26688$export$6c330e8992e8a295(pattern) {
    !$3a01a64de9a26688$export$9c954a9d03d32f4a() && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $3a01a64de9a26688$export$45d76561a5302f2b();
    return $1Pgvo.useMemo(()=>(0, $fdfac8a1aae2b1ce$export$81336c211d5ff295)(pattern, (0, $fdfac8a1aae2b1ce$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $3a01a64de9a26688$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $3a01a64de9a26688$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $1Pgvo.useContext($3a01a64de9a26688$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $1Pgvo.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $3a01a64de9a26688$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $1Pgvo.useContext($3a01a64de9a26688$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $3a01a64de9a26688$var$useNavigateStable() : $3a01a64de9a26688$var$useNavigateUnstable();
}
function $3a01a64de9a26688$var$useNavigateUnstable() {
    !$3a01a64de9a26688$export$9c954a9d03d32f4a() && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    let dataRouterContext = $1Pgvo.useContext($3a01a64de9a26688$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $1Pgvo.useContext($3a01a64de9a26688$export$26749e8557646306);
    let { matches: matches } = $1Pgvo.useContext($3a01a64de9a26688$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3a01a64de9a26688$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fdfac8a1aae2b1ce$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $1Pgvo.useRef(false);
    $3a01a64de9a26688$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $1Pgvo.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $fdfac8a1aae2b1ce$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fdfac8a1aae2b1ce$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $3a01a64de9a26688$var$OutletContext = /*#__PURE__*/ $1Pgvo.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $3a01a64de9a26688$export$4138103a3ae699cc() {
    return $1Pgvo.useContext($3a01a64de9a26688$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $3a01a64de9a26688$export$a3be3530d8e40d0b(context) {
    let outlet = $1Pgvo.useContext($3a01a64de9a26688$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $3a01a64de9a26688$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $1Pgvo.useContext($3a01a64de9a26688$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $3a01a64de9a26688$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $1Pgvo.useContext($3a01a64de9a26688$export$26749e8557646306);
    let { matches: matches } = $1Pgvo.useContext($3a01a64de9a26688$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3a01a64de9a26688$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fdfac8a1aae2b1ce$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $1Pgvo.useMemo(()=>(0, $fdfac8a1aae2b1ce$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $3a01a64de9a26688$export$5d3fca4a98652595(routes, locationArg) {
    return $3a01a64de9a26688$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $3a01a64de9a26688$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$3a01a64de9a26688$export$9c954a9d03d32f4a() && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $1Pgvo.useContext($3a01a64de9a26688$export$26749e8557646306);
    let { matches: parentMatches } = $1Pgvo.useContext($3a01a64de9a26688$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $3a01a64de9a26688$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $fdfac8a1aae2b1ce$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $3a01a64de9a26688$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $fdfac8a1aae2b1ce$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $fdfac8a1aae2b1ce$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $3a01a64de9a26688$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $3a01a64de9a26688$var$DefaultErrorComponent() {
    let error = $3a01a64de9a26688$export$ed527bf60f6e05f2();
    let message = (0, $fdfac8a1aae2b1ce$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $1Pgvo.createElement($1Pgvo.Fragment, null, /*#__PURE__*/ $1Pgvo.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $1Pgvo.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $1Pgvo.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $3a01a64de9a26688$var$defaultErrorElement = /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$var$DefaultErrorComponent, null);
class $3a01a64de9a26688$var$RenderErrorBoundary extends $1Pgvo.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $3a01a64de9a26688$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $1Pgvo.useContext($3a01a64de9a26688$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $3a01a64de9a26688$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $3a01a64de9a26688$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $3a01a64de9a26688$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $1Pgvo.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $3a01a64de9a26688$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($3a01a64de9a26688$var$DataRouterHook || {});
var $3a01a64de9a26688$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($3a01a64de9a26688$var$DataRouterStateHook || {});
function $3a01a64de9a26688$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $3a01a64de9a26688$var$useDataRouterContext(hookName) {
    let ctx = $1Pgvo.useContext($3a01a64de9a26688$export$3add0d5dce533e2e);
    !ctx && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    return ctx;
}
function $3a01a64de9a26688$var$useDataRouterState(hookName) {
    let state = $1Pgvo.useContext($3a01a64de9a26688$export$145dfa71566a64dc);
    !state && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    return state;
}
function $3a01a64de9a26688$var$useRouteContext(hookName) {
    let route = $1Pgvo.useContext($3a01a64de9a26688$export$9072aa6dd1f93057);
    !route && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $3a01a64de9a26688$var$useCurrentRouteId(hookName) {
    let route = $3a01a64de9a26688$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $3a01a64de9a26688$export$5fc8298006ad9e58() {
    return $3a01a64de9a26688$var$useCurrentRouteId($3a01a64de9a26688$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $3a01a64de9a26688$export$d0fd4b7106de2769() {
    let state = $3a01a64de9a26688$var$useDataRouterState($3a01a64de9a26688$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $3a01a64de9a26688$export$600dc272ed516c15() {
    let dataRouterContext = $3a01a64de9a26688$var$useDataRouterContext($3a01a64de9a26688$var$DataRouterHook.UseRevalidator);
    let state = $3a01a64de9a26688$var$useDataRouterState($3a01a64de9a26688$var$DataRouterStateHook.UseRevalidator);
    return $1Pgvo.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $3a01a64de9a26688$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $3a01a64de9a26688$var$useDataRouterState($3a01a64de9a26688$var$DataRouterStateHook.UseMatches);
    return $1Pgvo.useMemo(()=>matches.map((m)=>(0, $fdfac8a1aae2b1ce$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $3a01a64de9a26688$export$1448a5050d252c4d() {
    let state = $3a01a64de9a26688$var$useDataRouterState($3a01a64de9a26688$var$DataRouterStateHook.UseLoaderData);
    let routeId = $3a01a64de9a26688$var$useCurrentRouteId($3a01a64de9a26688$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $3a01a64de9a26688$export$fd5d37484eab868d(routeId) {
    let state = $3a01a64de9a26688$var$useDataRouterState($3a01a64de9a26688$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $3a01a64de9a26688$export$fdc00f3f26066d5e() {
    let state = $3a01a64de9a26688$var$useDataRouterState($3a01a64de9a26688$var$DataRouterStateHook.UseActionData);
    let routeId = $3a01a64de9a26688$var$useCurrentRouteId($3a01a64de9a26688$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $3a01a64de9a26688$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $1Pgvo.useContext($3a01a64de9a26688$var$RouteErrorContext);
    let state = $3a01a64de9a26688$var$useDataRouterState($3a01a64de9a26688$var$DataRouterStateHook.UseRouteError);
    let routeId = $3a01a64de9a26688$var$useCurrentRouteId($3a01a64de9a26688$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $3a01a64de9a26688$export$78a72ddb39bdd145() {
    let value = $1Pgvo.useContext($3a01a64de9a26688$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $3a01a64de9a26688$export$17f53340677d5831() {
    let value = $1Pgvo.useContext($3a01a64de9a26688$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $3a01a64de9a26688$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $3a01a64de9a26688$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $3a01a64de9a26688$var$useDataRouterContext($3a01a64de9a26688$var$DataRouterHook.UseBlocker);
    let state = $3a01a64de9a26688$var$useDataRouterState($3a01a64de9a26688$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $1Pgvo.useState("");
    let blockerFunction = $1Pgvo.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $3a01a64de9a26688$var$_extends({}, currentLocation, {
                pathname: (0, $fdfac8a1aae2b1ce$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $3a01a64de9a26688$var$_extends({}, nextLocation, {
                pathname: (0, $fdfac8a1aae2b1ce$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $1Pgvo.useEffect(()=>{
        let key = String(++$3a01a64de9a26688$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $1Pgvo.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $fdfac8a1aae2b1ce$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $3a01a64de9a26688$var$useNavigateStable() {
    let { router: router } = $3a01a64de9a26688$var$useDataRouterContext($3a01a64de9a26688$var$DataRouterHook.UseNavigateStable);
    let id = $3a01a64de9a26688$var$useCurrentRouteId($3a01a64de9a26688$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $1Pgvo.useRef(false);
    $3a01a64de9a26688$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $1Pgvo.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $3a01a64de9a26688$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $3a01a64de9a26688$var$alreadyWarned$1 = {};
function $3a01a64de9a26688$var$warningOnce(key, cond, message) {
    if (!cond && !$3a01a64de9a26688$var$alreadyWarned$1[key]) $3a01a64de9a26688$var$alreadyWarned$1[key] = true;
}
const $3a01a64de9a26688$var$alreadyWarned = {};
function $3a01a64de9a26688$var$warnOnce(key, message) {}
const $3a01a64de9a26688$var$logDeprecation = (flag, msg, link)=>$3a01a64de9a26688$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $3a01a64de9a26688$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $3a01a64de9a26688$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $3a01a64de9a26688$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $3a01a64de9a26688$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $3a01a64de9a26688$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $3a01a64de9a26688$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $3a01a64de9a26688$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $3a01a64de9a26688$var$START_TRANSITION = "startTransition";
const $3a01a64de9a26688$var$startTransitionImpl = $1Pgvo[$3a01a64de9a26688$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $3a01a64de9a26688$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $1Pgvo.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1Pgvo.useCallback((newState)=>{
        if (v7_startTransition && $3a01a64de9a26688$var$startTransitionImpl) $3a01a64de9a26688$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $1Pgvo.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $1Pgvo.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $1Pgvo.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $1Pgvo.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $1Pgvo.useEffect(()=>$3a01a64de9a26688$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $1Pgvo.createElement($1Pgvo.Fragment, null, /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $3a01a64de9a26688$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $3a01a64de9a26688$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $3a01a64de9a26688$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $1Pgvo.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fdfac8a1aae2b1ce$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1Pgvo.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1Pgvo.useCallback((newState)=>{
        v7_startTransition && $3a01a64de9a26688$var$startTransitionImpl ? $3a01a64de9a26688$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1Pgvo.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $1Pgvo.useEffect(()=>$3a01a64de9a26688$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $3a01a64de9a26688$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$3a01a64de9a26688$export$9c954a9d03d32f4a() && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $1Pgvo.useContext($3a01a64de9a26688$export$26749e8557646306);
    let { matches: matches } = $1Pgvo.useContext($3a01a64de9a26688$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3a01a64de9a26688$export$45d76561a5302f2b();
    let navigate = $3a01a64de9a26688$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $fdfac8a1aae2b1ce$export$cae722b0cc860f13)(to, (0, $fdfac8a1aae2b1ce$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $1Pgvo.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $3a01a64de9a26688$export$910ae8079b2c2852(props) {
    return $3a01a64de9a26688$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $3a01a64de9a26688$export$e7b0ac011bb776c6(_props) {
    (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $3a01a64de9a26688$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $fdfac8a1aae2b1ce$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$3a01a64de9a26688$export$9c954a9d03d32f4a() && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $1Pgvo.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $3a01a64de9a26688$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $fdfac8a1aae2b1ce$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $1Pgvo.useMemo(()=>{
        let trailingPathname = (0, $fdfac8a1aae2b1ce$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $3a01a64de9a26688$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $3a01a64de9a26688$export$5d3fca4a98652595($3a01a64de9a26688$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $3a01a64de9a26688$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$var$ResolveAwait, null, children));
}
var $3a01a64de9a26688$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($3a01a64de9a26688$var$AwaitRenderStatus || {});
const $3a01a64de9a26688$var$neverSettledPromise = new Promise(()=>{});
class $3a01a64de9a26688$var$AwaitErrorBoundary extends $1Pgvo.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $3a01a64de9a26688$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $3a01a64de9a26688$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $3a01a64de9a26688$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $3a01a64de9a26688$var$AwaitRenderStatus.error : "_data" in promise ? $3a01a64de9a26688$var$AwaitRenderStatus.success : $3a01a64de9a26688$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $3a01a64de9a26688$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $3a01a64de9a26688$var$AwaitRenderStatus.error && promise._error instanceof (0, $fdfac8a1aae2b1ce$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $3a01a64de9a26688$var$neverSettledPromise;
        if (status === $3a01a64de9a26688$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $3a01a64de9a26688$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $3a01a64de9a26688$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $1Pgvo.createElement($3a01a64de9a26688$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $3a01a64de9a26688$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $3a01a64de9a26688$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $1Pgvo.createElement($1Pgvo.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $3a01a64de9a26688$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $1Pgvo.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $1Pgvo.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $1Pgvo.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $3a01a64de9a26688$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $3a01a64de9a26688$export$e7b0ac011bb776c6) && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $3a01a64de9a26688$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $3a01a64de9a26688$export$daf73786167a7f72(matches) {
    return $3a01a64de9a26688$var$_renderMatches(matches);
}
function $3a01a64de9a26688$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $1Pgvo.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $1Pgvo.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $1Pgvo.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $3a01a64de9a26688$export$f30f7e456d254e83(routes, opts) {
    return (0, $fdfac8a1aae2b1ce$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $3a01a64de9a26688$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fdfac8a1aae2b1ce$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $3a01a64de9a26688$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $bd69baf2ae763c6c$var$_extends() {
    $bd69baf2ae763c6c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bd69baf2ae763c6c$var$_extends.apply(this, arguments);
}
function $bd69baf2ae763c6c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $bd69baf2ae763c6c$var$defaultMethod = "get";
const $bd69baf2ae763c6c$var$defaultEncType = "application/x-www-form-urlencoded";
function $bd69baf2ae763c6c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $bd69baf2ae763c6c$var$isButtonElement(object) {
    return $bd69baf2ae763c6c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $bd69baf2ae763c6c$var$isFormElement(object) {
    return $bd69baf2ae763c6c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $bd69baf2ae763c6c$var$isInputElement(object) {
    return $bd69baf2ae763c6c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $bd69baf2ae763c6c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $bd69baf2ae763c6c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$bd69baf2ae763c6c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $bd69baf2ae763c6c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $bd69baf2ae763c6c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $bd69baf2ae763c6c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $bd69baf2ae763c6c$var$_formDataSupportsSubmitter = null;
function $bd69baf2ae763c6c$var$isFormDataSubmitterSupported() {
    if ($bd69baf2ae763c6c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $bd69baf2ae763c6c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $bd69baf2ae763c6c$var$_formDataSupportsSubmitter = true;
    }
    return $bd69baf2ae763c6c$var$_formDataSupportsSubmitter;
}
const $bd69baf2ae763c6c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $bd69baf2ae763c6c$var$getFormEncType(encType) {
    if (encType != null && !$bd69baf2ae763c6c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $bd69baf2ae763c6c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($bd69baf2ae763c6c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $fdfac8a1aae2b1ce$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $bd69baf2ae763c6c$var$defaultMethod;
        encType = $bd69baf2ae763c6c$var$getFormEncType(target.getAttribute("enctype")) || $bd69baf2ae763c6c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($bd69baf2ae763c6c$var$isButtonElement(target) || $bd69baf2ae763c6c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $fdfac8a1aae2b1ce$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $bd69baf2ae763c6c$var$defaultMethod;
        encType = $bd69baf2ae763c6c$var$getFormEncType(target.getAttribute("formenctype")) || $bd69baf2ae763c6c$var$getFormEncType(form.getAttribute("enctype")) || $bd69baf2ae763c6c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$bd69baf2ae763c6c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($bd69baf2ae763c6c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $bd69baf2ae763c6c$var$defaultMethod;
        action = null;
        encType = $bd69baf2ae763c6c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $bd69baf2ae763c6c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $bd69baf2ae763c6c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $bd69baf2ae763c6c$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $bd69baf2ae763c6c$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $bd69baf2ae763c6c$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $bd69baf2ae763c6c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $fdfac8a1aae2b1ce$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $bd69baf2ae763c6c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fdfac8a1aae2b1ce$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $bd69baf2ae763c6c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3a01a64de9a26688$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $bd69baf2ae763c6c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $fdfac8a1aae2b1ce$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $bd69baf2ae763c6c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fdfac8a1aae2b1ce$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $bd69baf2ae763c6c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3a01a64de9a26688$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $bd69baf2ae763c6c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $bd69baf2ae763c6c$var$_extends({}, state, {
        errors: $bd69baf2ae763c6c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $bd69baf2ae763c6c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $fdfac8a1aae2b1ce$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $bd69baf2ae763c6c$export$7ad602f0e94e62d1 = /*#__PURE__*/ $1Pgvo.createContext({
    isTransitioning: false
});
const $bd69baf2ae763c6c$export$148fd98d095596d4 = /*#__PURE__*/ $1Pgvo.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $bd69baf2ae763c6c$var$START_TRANSITION = "startTransition";
const $bd69baf2ae763c6c$var$startTransitionImpl = $1Pgvo[$bd69baf2ae763c6c$var$START_TRANSITION];
const $bd69baf2ae763c6c$var$FLUSH_SYNC = "flushSync";
const $bd69baf2ae763c6c$var$flushSyncImpl = $kZ6Vu[$bd69baf2ae763c6c$var$FLUSH_SYNC];
const $bd69baf2ae763c6c$var$USE_ID = "useId";
const $bd69baf2ae763c6c$var$useIdImpl = $1Pgvo[$bd69baf2ae763c6c$var$USE_ID];
function $bd69baf2ae763c6c$var$startTransitionSafe(cb) {
    if ($bd69baf2ae763c6c$var$startTransitionImpl) $bd69baf2ae763c6c$var$startTransitionImpl(cb);
    else cb();
}
function $bd69baf2ae763c6c$var$flushSyncSafe(cb) {
    if ($bd69baf2ae763c6c$var$flushSyncImpl) $bd69baf2ae763c6c$var$flushSyncImpl(cb);
    else cb();
}
class $bd69baf2ae763c6c$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $bd69baf2ae763c6c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $1Pgvo.useState(router.state);
    let [pendingState, setPendingState] = $1Pgvo.useState();
    let [vtContext, setVtContext] = $1Pgvo.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $1Pgvo.useState();
    let [transition, setTransition] = $1Pgvo.useState();
    let [interruption, setInterruption] = $1Pgvo.useState();
    let fetcherData = $1Pgvo.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $1Pgvo.useCallback((cb)=>{
        if (v7_startTransition) $bd69baf2ae763c6c$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $1Pgvo.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $bd69baf2ae763c6c$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $bd69baf2ae763c6c$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $bd69baf2ae763c6c$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $bd69baf2ae763c6c$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $bd69baf2ae763c6c$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $1Pgvo.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $1Pgvo.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $bd69baf2ae763c6c$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $1Pgvo.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $1Pgvo.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $1Pgvo.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $1Pgvo.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $1Pgvo.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $1Pgvo.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $1Pgvo.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $1Pgvo.useEffect(()=>(0, $3a01a64de9a26688$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $1Pgvo.createElement($1Pgvo.Fragment, null, /*#__PURE__*/ $1Pgvo.createElement((0, $3a01a64de9a26688$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $1Pgvo.createElement((0, $3a01a64de9a26688$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $1Pgvo.createElement($bd69baf2ae763c6c$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $1Pgvo.createElement($bd69baf2ae763c6c$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $1Pgvo.createElement((0, $3a01a64de9a26688$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $1Pgvo.createElement($bd69baf2ae763c6c$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $bd69baf2ae763c6c$var$MemoizedDataRoutes = /*#__PURE__*/ $1Pgvo.memo($bd69baf2ae763c6c$var$DataRoutes);
function $bd69baf2ae763c6c$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $3a01a64de9a26688$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $bd69baf2ae763c6c$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $1Pgvo.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fdfac8a1aae2b1ce$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1Pgvo.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1Pgvo.useCallback((newState)=>{
        v7_startTransition && $bd69baf2ae763c6c$var$startTransitionImpl ? $bd69baf2ae763c6c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1Pgvo.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $1Pgvo.useEffect(()=>(0, $3a01a64de9a26688$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $1Pgvo.createElement((0, $3a01a64de9a26688$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $bd69baf2ae763c6c$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $1Pgvo.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fdfac8a1aae2b1ce$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1Pgvo.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1Pgvo.useCallback((newState)=>{
        v7_startTransition && $bd69baf2ae763c6c$var$startTransitionImpl ? $bd69baf2ae763c6c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1Pgvo.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $1Pgvo.useEffect(()=>(0, $3a01a64de9a26688$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $1Pgvo.createElement((0, $3a01a64de9a26688$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $bd69baf2ae763c6c$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $1Pgvo.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1Pgvo.useCallback((newState)=>{
        v7_startTransition && $bd69baf2ae763c6c$var$startTransitionImpl ? $bd69baf2ae763c6c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1Pgvo.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $1Pgvo.useEffect(()=>(0, $3a01a64de9a26688$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $1Pgvo.createElement((0, $3a01a64de9a26688$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $bd69baf2ae763c6c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $bd69baf2ae763c6c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $bd69baf2ae763c6c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $1Pgvo.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $bd69baf2ae763c6c$var$_objectWithoutPropertiesLoose(_ref7, $bd69baf2ae763c6c$var$_excluded);
    let { basename: basename } = $1Pgvo.useContext((0, $3a01a64de9a26688$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $bd69baf2ae763c6c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($bd69baf2ae763c6c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $fdfac8a1aae2b1ce$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $3a01a64de9a26688$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $bd69baf2ae763c6c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $1Pgvo.createElement("a", $bd69baf2ae763c6c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $bd69baf2ae763c6c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $1Pgvo.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $bd69baf2ae763c6c$var$_objectWithoutPropertiesLoose(_ref8, $bd69baf2ae763c6c$var$_excluded2);
    let path = (0, $3a01a64de9a26688$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $3a01a64de9a26688$export$45d76561a5302f2b)();
    let routerState = $1Pgvo.useContext((0, $3a01a64de9a26688$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $1Pgvo.useContext((0, $3a01a64de9a26688$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bd69baf2ae763c6c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $fdfac8a1aae2b1ce$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $1Pgvo.createElement($bd69baf2ae763c6c$export$a6c7ac8248d6e38a, $bd69baf2ae763c6c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $bd69baf2ae763c6c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $1Pgvo.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $bd69baf2ae763c6c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $bd69baf2ae763c6c$var$_objectWithoutPropertiesLoose(_ref9, $bd69baf2ae763c6c$var$_excluded3);
    let submit = $bd69baf2ae763c6c$export$47c85c6e3a081d3();
    let formAction = $bd69baf2ae763c6c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $1Pgvo.createElement("form", $bd69baf2ae763c6c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $bd69baf2ae763c6c$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $bd69baf2ae763c6c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $bd69baf2ae763c6c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($bd69baf2ae763c6c$var$DataRouterHook || ($bd69baf2ae763c6c$var$DataRouterHook = {}));
var $bd69baf2ae763c6c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($bd69baf2ae763c6c$var$DataRouterStateHook || ($bd69baf2ae763c6c$var$DataRouterStateHook = {}));
// Internal hooks
function $bd69baf2ae763c6c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $bd69baf2ae763c6c$var$useDataRouterContext(hookName) {
    let ctx = $1Pgvo.useContext((0, $3a01a64de9a26688$export$3add0d5dce533e2e));
    !ctx && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    return ctx;
}
function $bd69baf2ae763c6c$var$useDataRouterState(hookName) {
    let state = $1Pgvo.useContext((0, $3a01a64de9a26688$export$145dfa71566a64dc));
    !state && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $bd69baf2ae763c6c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    let location = (0, $3a01a64de9a26688$export$45d76561a5302f2b)();
    let path = (0, $3a01a64de9a26688$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $1Pgvo.useCallback((event)=>{
        if ($bd69baf2ae763c6c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $fdfac8a1aae2b1ce$export$fe53371bee54353d)(location) === (0, $fdfac8a1aae2b1ce$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $bd69baf2ae763c6c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $1Pgvo.useRef($bd69baf2ae763c6c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $1Pgvo.useRef(false);
    let location = (0, $3a01a64de9a26688$export$45d76561a5302f2b)();
    let searchParams = $1Pgvo.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $bd69baf2ae763c6c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    let setSearchParams = $1Pgvo.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $bd69baf2ae763c6c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $bd69baf2ae763c6c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $bd69baf2ae763c6c$var$fetcherId = 0;
let $bd69baf2ae763c6c$var$getUniqueFetcherId = ()=>"__" + String(++$bd69baf2ae763c6c$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $bd69baf2ae763c6c$export$47c85c6e3a081d3() {
    let { router: router } = $bd69baf2ae763c6c$var$useDataRouterContext($bd69baf2ae763c6c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $1Pgvo.useContext((0, $3a01a64de9a26688$export$26749e8557646306));
    let currentRouteId = (0, $3a01a64de9a26688$export$5fc8298006ad9e58)();
    return $1Pgvo.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $bd69baf2ae763c6c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $bd69baf2ae763c6c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $bd69baf2ae763c6c$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $bd69baf2ae763c6c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $1Pgvo.useContext((0, $3a01a64de9a26688$export$26749e8557646306));
    let routeContext = $1Pgvo.useContext((0, $3a01a64de9a26688$export$9072aa6dd1f93057));
    !routeContext && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $bd69baf2ae763c6c$var$_extends({}, (0, $3a01a64de9a26688$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $3a01a64de9a26688$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fdfac8a1aae2b1ce$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $fdfac8a1aae2b1ce$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $bd69baf2ae763c6c$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $bd69baf2ae763c6c$var$useDataRouterContext($bd69baf2ae763c6c$var$DataRouterHook.UseFetcher);
    let state = $bd69baf2ae763c6c$var$useDataRouterState($bd69baf2ae763c6c$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $1Pgvo.useContext($bd69baf2ae763c6c$export$148fd98d095596d4);
    let route = $1Pgvo.useContext((0, $3a01a64de9a26688$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    !route && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $bd69baf2ae763c6c$var$useIdImpl ? $bd69baf2ae763c6c$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $1Pgvo.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($bd69baf2ae763c6c$var$getUniqueFetcherId());
    // Registration/cleanup
    $1Pgvo.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $1Pgvo.useCallback((href, opts)=>{
        !routeId && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $bd69baf2ae763c6c$export$47c85c6e3a081d3();
    let submit = $1Pgvo.useCallback((target, opts)=>{
        submitImpl(target, $bd69baf2ae763c6c$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $1Pgvo.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $1Pgvo.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $1Pgvo.createElement($bd69baf2ae763c6c$export$a7fed597f4b8afd8, $bd69baf2ae763c6c$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $fdfac8a1aae2b1ce$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $1Pgvo.useMemo(()=>$bd69baf2ae763c6c$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $bd69baf2ae763c6c$export$fa996778a3a31087() {
    let state = $bd69baf2ae763c6c$var$useDataRouterState($bd69baf2ae763c6c$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $bd69baf2ae763c6c$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $bd69baf2ae763c6c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $bd69baf2ae763c6c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $bd69baf2ae763c6c$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $bd69baf2ae763c6c$var$useDataRouterContext($bd69baf2ae763c6c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $bd69baf2ae763c6c$var$useDataRouterState($bd69baf2ae763c6c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $1Pgvo.useContext((0, $3a01a64de9a26688$export$26749e8557646306));
    let location = (0, $3a01a64de9a26688$export$45d76561a5302f2b)();
    let matches = (0, $3a01a64de9a26688$export$2378eb7f5ff86053)();
    let navigation = (0, $3a01a64de9a26688$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $1Pgvo.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $bd69baf2ae763c6c$var$usePageHide($1Pgvo.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $bd69baf2ae763c6c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $bd69baf2ae763c6c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($bd69baf2ae763c6c$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1Pgvo.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $bd69baf2ae763c6c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $bd69baf2ae763c6c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1Pgvo.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($bd69baf2ae763c6c$var$_extends({}, location, {
                    pathname: (0, $fdfac8a1aae2b1ce$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($bd69baf2ae763c6c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1Pgvo.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $bd69baf2ae763c6c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $1Pgvo.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $bd69baf2ae763c6c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $1Pgvo.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $bd69baf2ae763c6c$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $3a01a64de9a26688$export$b273b3273281a049)(when);
    $1Pgvo.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $1Pgvo.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $bd69baf2ae763c6c$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $1Pgvo.useContext($bd69baf2ae763c6c$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $fdfac8a1aae2b1ce$export$3e9cee6b33872309)(false);
    let { basename: basename } = $bd69baf2ae763c6c$var$useDataRouterContext($bd69baf2ae763c6c$var$DataRouterHook.useViewTransitionState);
    let path = (0, $3a01a64de9a26688$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $fdfac8a1aae2b1ce$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $fdfac8a1aae2b1ce$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $fdfac8a1aae2b1ce$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $fdfac8a1aae2b1ce$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $j6whP = parcelRequire("j6whP");
var $e22492923ca88a8b$export$40bbbdce49b45a9a;
var $e22492923ca88a8b$export$8c340391aa403e92;
var $e22492923ca88a8b$export$278ed4abea745bfb;
$e22492923ca88a8b$export$40bbbdce49b45a9a = `MqZHCq_logoParent`;
$e22492923ca88a8b$export$8c340391aa403e92 = `MqZHCq_returnsWealth`;
$e22492923ca88a8b$export$278ed4abea745bfb = `MqZHCq_returnsWealthLogo`;


var $ccee0ee317a1ad4c$exports = {};

$ccee0ee317a1ad4c$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "returns-wealth-logo.f9bc96de.png";


const $a68432c350589148$var$Header = ()=>{
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $j6whP.Fragment), {
        children: /*#__PURE__*/ (0, $j6whP.jsx)("div", {
            className: $e22492923ca88a8b$export$40bbbdce49b45a9a,
            children: /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ccee0ee317a1ad4c$exports))),
                alt: "Returns",
                className: $e22492923ca88a8b$export$278ed4abea745bfb
            })
        })
    });
};
var $a68432c350589148$export$2e2bcd8739ae039 = $a68432c350589148$var$Header;



var $j6whP = parcelRequire("j6whP");
var $3ea24f2fdb2b0724$export$d73ba76fbf89849b;
var $3ea24f2fdb2b0724$export$df44ffccac22cd79;
var $3ea24f2fdb2b0724$export$d201f0ee6d10d236;
var $3ea24f2fdb2b0724$export$4fa6d27c1c862db7;
var $3ea24f2fdb2b0724$export$9d258e38d78c4993;
var $3ea24f2fdb2b0724$export$30a8bfb63a8b520a;
var $3ea24f2fdb2b0724$export$79a29376087ecf60;
var $3ea24f2fdb2b0724$export$ac96a2a951168044;
var $3ea24f2fdb2b0724$export$92edf48bf3158b7a;
var $3ea24f2fdb2b0724$export$4ee63e4d1813145c;
var $3ea24f2fdb2b0724$export$9e84aec49aaf1e0f;
var $3ea24f2fdb2b0724$export$facd55b1022954e0;
var $3ea24f2fdb2b0724$export$6906297b15b9f5f0;
var $3ea24f2fdb2b0724$export$f92d76d135115694;
var $3ea24f2fdb2b0724$export$687fc4f52cf31e36;
var $3ea24f2fdb2b0724$export$362e26412028e062;
var $3ea24f2fdb2b0724$export$18fb3db69671e58b;
$3ea24f2fdb2b0724$export$d73ba76fbf89849b = `BOBUQq_CTA`;
$3ea24f2fdb2b0724$export$df44ffccac22cd79 = `BOBUQq_CTADesc`;
$3ea24f2fdb2b0724$export$d201f0ee6d10d236 = `BOBUQq_contactCTA`;
$3ea24f2fdb2b0724$export$4fa6d27c1c862db7 = `BOBUQq_contactParent`;
$3ea24f2fdb2b0724$export$9d258e38d78c4993 = `BOBUQq_copyrightLicence`;
$3ea24f2fdb2b0724$export$30a8bfb63a8b520a = `BOBUQq_extraDetails`;
$3ea24f2fdb2b0724$export$79a29376087ecf60 = `BOBUQq_footerContact`;
$3ea24f2fdb2b0724$export$ac96a2a951168044 = `BOBUQq_footerContainer`;
$3ea24f2fdb2b0724$export$92edf48bf3158b7a = `BOBUQq_footerLine`;
$3ea24f2fdb2b0724$export$4ee63e4d1813145c = `BOBUQq_hr1`;
$3ea24f2fdb2b0724$export$9e84aec49aaf1e0f = `BOBUQq_hr2`;
$3ea24f2fdb2b0724$export$facd55b1022954e0 = `BOBUQq_hr3`;
$3ea24f2fdb2b0724$export$6906297b15b9f5f0 = `BOBUQq_importantLinks`;
$3ea24f2fdb2b0724$export$f92d76d135115694 = `BOBUQq_importantLinksCopyright`;
$3ea24f2fdb2b0724$export$687fc4f52cf31e36 = `BOBUQq_legalitiesParent`;
$3ea24f2fdb2b0724$export$362e26412028e062 = `BOBUQq_returnsDetailsFooter`;
$3ea24f2fdb2b0724$export$18fb3db69671e58b = `BOBUQq_returnsLogo`;


var $39ea85e8599a41c0$exports = {};

$39ea85e8599a41c0$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "logo-black.393d1d6e.webp";



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");
var $501530cdea7e9b50$exports = {};

$parcel$export($501530cdea7e9b50$exports, "closeButton", function () { return $501530cdea7e9b50$export$efe229eab43a9869; }, function (v) { return $501530cdea7e9b50$export$efe229eab43a9869 = v; });
$parcel$export($501530cdea7e9b50$exports, "contactInput", function () { return $501530cdea7e9b50$export$653e39302ebd0136; }, function (v) { return $501530cdea7e9b50$export$653e39302ebd0136 = v; });
$parcel$export($501530cdea7e9b50$exports, "contactParent", function () { return $501530cdea7e9b50$export$4fa6d27c1c862db7; }, function (v) { return $501530cdea7e9b50$export$4fa6d27c1c862db7 = v; });
$parcel$export($501530cdea7e9b50$exports, "contactWrapper", function () { return $501530cdea7e9b50$export$26ed9dfcff0506e4; }, function (v) { return $501530cdea7e9b50$export$26ed9dfcff0506e4 = v; });
$parcel$export($501530cdea7e9b50$exports, "countryCode", function () { return $501530cdea7e9b50$export$e795f858b6a66dc0; }, function (v) { return $501530cdea7e9b50$export$e795f858b6a66dc0 = v; });
$parcel$export($501530cdea7e9b50$exports, "ctaParent", function () { return $501530cdea7e9b50$export$2aa02422b862ff0d; }, function (v) { return $501530cdea7e9b50$export$2aa02422b862ff0d = v; });
$parcel$export($501530cdea7e9b50$exports, "ctaParentDownload", function () { return $501530cdea7e9b50$export$155718a9fc0344a7; }, function (v) { return $501530cdea7e9b50$export$155718a9fc0344a7 = v; });
$parcel$export($501530cdea7e9b50$exports, "disabledReward", function () { return $501530cdea7e9b50$export$29b44403d096c8cb; }, function (v) { return $501530cdea7e9b50$export$29b44403d096c8cb = v; });
$parcel$export($501530cdea7e9b50$exports, "errorAnim", function () { return $501530cdea7e9b50$export$28a87abe8e72e801; }, function (v) { return $501530cdea7e9b50$export$28a87abe8e72e801 = v; });
$parcel$export($501530cdea7e9b50$exports, "errorMessage", function () { return $501530cdea7e9b50$export$493b5823483d2c4e; }, function (v) { return $501530cdea7e9b50$export$493b5823483d2c4e = v; });
$parcel$export($501530cdea7e9b50$exports, "fadeIn", function () { return $501530cdea7e9b50$export$82e6205b15e6c637; }, function (v) { return $501530cdea7e9b50$export$82e6205b15e6c637 = v; });
$parcel$export($501530cdea7e9b50$exports, "fadeOut", function () { return $501530cdea7e9b50$export$c091916f1530334c; }, function (v) { return $501530cdea7e9b50$export$c091916f1530334c = v; });
$parcel$export($501530cdea7e9b50$exports, "free", function () { return $501530cdea7e9b50$export$13e2de3c33d99539; }, function (v) { return $501530cdea7e9b50$export$13e2de3c33d99539 = v; });
$parcel$export($501530cdea7e9b50$exports, "large", function () { return $501530cdea7e9b50$export$f09585a853dddd32; }, function (v) { return $501530cdea7e9b50$export$f09585a853dddd32 = v; });
$parcel$export($501530cdea7e9b50$exports, "loader", function () { return $501530cdea7e9b50$export$f4c5de44377d2946; }, function (v) { return $501530cdea7e9b50$export$f4c5de44377d2946 = v; });
$parcel$export($501530cdea7e9b50$exports, "modalBg", function () { return $501530cdea7e9b50$export$39c0db8a213d7f9b; }, function (v) { return $501530cdea7e9b50$export$39c0db8a213d7f9b = v; });
$parcel$export($501530cdea7e9b50$exports, "modalContent", function () { return $501530cdea7e9b50$export$add244bda2f9423c; }, function (v) { return $501530cdea7e9b50$export$add244bda2f9423c = v; });
$parcel$export($501530cdea7e9b50$exports, "modalContentMain", function () { return $501530cdea7e9b50$export$71eca6118ac8c32e; }, function (v) { return $501530cdea7e9b50$export$71eca6118ac8c32e = v; });
$parcel$export($501530cdea7e9b50$exports, "modalHeading", function () { return $501530cdea7e9b50$export$252095ae0091fa8; }, function (v) { return $501530cdea7e9b50$export$252095ae0091fa8 = v; });
$parcel$export($501530cdea7e9b50$exports, "modalHeadingParent", function () { return $501530cdea7e9b50$export$3311cdfe2d15598b; }, function (v) { return $501530cdea7e9b50$export$3311cdfe2d15598b = v; });
$parcel$export($501530cdea7e9b50$exports, "modalInput", function () { return $501530cdea7e9b50$export$6f8c81355c5fd548; }, function (v) { return $501530cdea7e9b50$export$6f8c81355c5fd548 = v; });
$parcel$export($501530cdea7e9b50$exports, "modalInputWrapper", function () { return $501530cdea7e9b50$export$c4b73737f9b3e878; }, function (v) { return $501530cdea7e9b50$export$c4b73737f9b3e878 = v; });
$parcel$export($501530cdea7e9b50$exports, "modalOverlay", function () { return $501530cdea7e9b50$export$70c017da01953e13; }, function (v) { return $501530cdea7e9b50$export$70c017da01953e13 = v; });
$parcel$export($501530cdea7e9b50$exports, "reward", function () { return $501530cdea7e9b50$export$7abfebf4aa86b126; }, function (v) { return $501530cdea7e9b50$export$7abfebf4aa86b126 = v; });
$parcel$export($501530cdea7e9b50$exports, "rewardSvg", function () { return $501530cdea7e9b50$export$9383c4c7aad43ec6; }, function (v) { return $501530cdea7e9b50$export$9383c4c7aad43ec6 = v; });
$parcel$export($501530cdea7e9b50$exports, "small", function () { return $501530cdea7e9b50$export$3c17b0e969a90510; }, function (v) { return $501530cdea7e9b50$export$3c17b0e969a90510 = v; });
$parcel$export($501530cdea7e9b50$exports, "spin", function () { return $501530cdea7e9b50$export$c82e186cf428d56d; }, function (v) { return $501530cdea7e9b50$export$c82e186cf428d56d = v; });
$parcel$export($501530cdea7e9b50$exports, "successAnim", function () { return $501530cdea7e9b50$export$b99b2edf7569065a; }, function (v) { return $501530cdea7e9b50$export$b99b2edf7569065a = v; });
$parcel$export($501530cdea7e9b50$exports, "tooltip", function () { return $501530cdea7e9b50$export$4e6f96734dfe12f4; }, function (v) { return $501530cdea7e9b50$export$4e6f96734dfe12f4 = v; });
var $501530cdea7e9b50$export$efe229eab43a9869;
var $501530cdea7e9b50$export$653e39302ebd0136;
var $501530cdea7e9b50$export$4fa6d27c1c862db7;
var $501530cdea7e9b50$export$26ed9dfcff0506e4;
var $501530cdea7e9b50$export$e795f858b6a66dc0;
var $501530cdea7e9b50$export$2aa02422b862ff0d;
var $501530cdea7e9b50$export$155718a9fc0344a7;
var $501530cdea7e9b50$export$29b44403d096c8cb;
var $501530cdea7e9b50$export$28a87abe8e72e801;
var $501530cdea7e9b50$export$493b5823483d2c4e;
var $501530cdea7e9b50$export$82e6205b15e6c637;
var $501530cdea7e9b50$export$c091916f1530334c;
var $501530cdea7e9b50$export$13e2de3c33d99539;
var $501530cdea7e9b50$export$f09585a853dddd32;
var $501530cdea7e9b50$export$f4c5de44377d2946;
var $501530cdea7e9b50$export$39c0db8a213d7f9b;
var $501530cdea7e9b50$export$add244bda2f9423c;
var $501530cdea7e9b50$export$71eca6118ac8c32e;
var $501530cdea7e9b50$export$252095ae0091fa8;
var $501530cdea7e9b50$export$3311cdfe2d15598b;
var $501530cdea7e9b50$export$6f8c81355c5fd548;
var $501530cdea7e9b50$export$c4b73737f9b3e878;
var $501530cdea7e9b50$export$70c017da01953e13;
var $501530cdea7e9b50$export$7abfebf4aa86b126;
var $501530cdea7e9b50$export$9383c4c7aad43ec6;
var $501530cdea7e9b50$export$3c17b0e969a90510;
var $501530cdea7e9b50$export$c82e186cf428d56d;
var $501530cdea7e9b50$export$b99b2edf7569065a;
var $501530cdea7e9b50$export$4e6f96734dfe12f4;
$501530cdea7e9b50$export$efe229eab43a9869 = `v1Wvda_closeButton`;
$501530cdea7e9b50$export$653e39302ebd0136 = `v1Wvda_contactInput`;
$501530cdea7e9b50$export$4fa6d27c1c862db7 = `v1Wvda_contactParent`;
$501530cdea7e9b50$export$26ed9dfcff0506e4 = `v1Wvda_contactWrapper`;
$501530cdea7e9b50$export$e795f858b6a66dc0 = `v1Wvda_countryCode`;
$501530cdea7e9b50$export$2aa02422b862ff0d = `v1Wvda_ctaParent`;
$501530cdea7e9b50$export$155718a9fc0344a7 = `v1Wvda_ctaParentDownload`;
$501530cdea7e9b50$export$29b44403d096c8cb = `v1Wvda_disabledReward`;
$501530cdea7e9b50$export$28a87abe8e72e801 = `v1Wvda_errorAnim`;
$501530cdea7e9b50$export$493b5823483d2c4e = `v1Wvda_errorMessage`;
$501530cdea7e9b50$export$82e6205b15e6c637 = `v1Wvda_fadeIn`;
$501530cdea7e9b50$export$82e6205b15e6c637;
$501530cdea7e9b50$export$c091916f1530334c = `v1Wvda_fadeOut`;
$501530cdea7e9b50$export$c091916f1530334c;
$501530cdea7e9b50$export$13e2de3c33d99539 = `v1Wvda_free`;
$501530cdea7e9b50$export$f09585a853dddd32 = `v1Wvda_large`;
$501530cdea7e9b50$export$f4c5de44377d2946 = `v1Wvda_loader`;
$501530cdea7e9b50$export$39c0db8a213d7f9b = `v1Wvda_modalBg`;
$501530cdea7e9b50$export$add244bda2f9423c = `v1Wvda_modalContent`;
$501530cdea7e9b50$export$71eca6118ac8c32e = `v1Wvda_modalContentMain`;
$501530cdea7e9b50$export$252095ae0091fa8 = `v1Wvda_modalHeading`;
$501530cdea7e9b50$export$3311cdfe2d15598b = `v1Wvda_modalHeadingParent`;
$501530cdea7e9b50$export$6f8c81355c5fd548 = `v1Wvda_modalInput`;
$501530cdea7e9b50$export$c4b73737f9b3e878 = `v1Wvda_modalInputWrapper`;
$501530cdea7e9b50$export$70c017da01953e13 = `v1Wvda_modalOverlay`;
$501530cdea7e9b50$export$7abfebf4aa86b126 = `v1Wvda_reward`;
$501530cdea7e9b50$export$9383c4c7aad43ec6 = `v1Wvda_rewardSvg`;
$501530cdea7e9b50$export$3c17b0e969a90510 = `v1Wvda_small`;
$501530cdea7e9b50$export$c82e186cf428d56d = `v1Wvda_spin`;
$501530cdea7e9b50$export$c82e186cf428d56d;
$501530cdea7e9b50$export$b99b2edf7569065a = `v1Wvda_successAnim`;
$501530cdea7e9b50$export$4e6f96734dfe12f4 = `v1Wvda_tooltip`;


var $f0d8ba5a1940ec37$exports = {};

$f0d8ba5a1940ec37$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "failed.33341481.webm";


var $07382137637ba534$exports = {};

$07382137637ba534$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "arrow.cb81dc10.svg";


var $3d94a64ce4d37aec$exports = {};

$3d94a64ce4d37aec$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "unlock.8f71d399.png";


const $3cecc3b9cc79fe3d$export$d73ba76fbf89849b = ({ variant: variant, status: status, setStatus: setStatus })=>{
    const [phone, setPhone] = (0, $1Pgvo.useState)("");
    const [isValid, setIsValid] = (0, $1Pgvo.useState)(false);
    const [isLoading, setIsLoading] = (0, $1Pgvo.useState)(false);
    const [tooltip, setTooltip] = (0, $1Pgvo.useState)({
        visible: false,
        x: 0,
        y: 0
    });
    const [placeholder, setPlaceholder] = (0, $1Pgvo.useState)("Enter phone number");
    const [isModalOpen, setIsModalOpen] = (0, $1Pgvo.useState)(false);
    const [isFadingOut, setIsFadingOut] = (0, $1Pgvo.useState)(false);
    const [keyboardHeight, setKeyboardHeight] = (0, $1Pgvo.useState)(0);
    const API_URL = "https://tradeinsights.co.in/v1/api/users/contact";
    const CONTACT_DETAILS = {
        large: {
            name: "Home Page Landing Area",
            email: "contactuser@gmail.com"
        },
        small: {
            name: "Footer",
            email: "contactuser@gmail.com"
        }
    };
    const formatPhoneNumber = (value)=>{
        let formatted = value.replace(/\D/g, "").slice(0, 10);
        if (formatted.length > 5) formatted = formatted.replace(/^(\d{5})(\d{0,5})$/, "$1$2");
        return formatted;
    };
    const handleChange = (e)=>{
        const rawValue = e.target.value;
        const formattedValue = formatPhoneNumber(rawValue);
        setPhone(formattedValue);
        const plainNumber = formattedValue.replace(/\s/g, "");
        setIsValid(/^[6-9]\d{9}$/.test(plainNumber));
    };
    const handleRewardClick = async ()=>{
        if (!isValid || isLoading) return;
        setIsLoading(true);
        setStatus("idle");
        setTimeout(()=>{
            setStatus("success");
            handleCloseModal();
            setIsLoading(false);
        }, 500);
        const { name: name, email: email } = CONTACT_DETAILS[variant];
        try {
            const response = await fetch(API_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: name,
                    email: email,
                    message: phone.replace(/\s/g, "")
                })
            });
            if (!response.ok) throw new Error("Failed to send contact request");
            setStatus("success");
            handleCloseModal();
        } catch (error) {
            console.error(error);
            setStatus("error");
        } finally{
            setIsLoading(false);
        }
    };
    const handleMouseMove = (e)=>{
        if (!isValid) setTooltip({
            visible: true,
            x: e.clientX,
            y: e.clientY + 40
        });
    };
    const handleMouseLeave = ()=>{
        setTooltip((prev)=>({
                ...prev,
                visible: false
            }));
    };
    (0, $1Pgvo.useEffect)(()=>{
        const updatePlaceholder = ()=>{
            setPlaceholder(window.innerWidth <= 600 ? "Phone number" : "Enter phone number");
        };
        updatePlaceholder();
        window.addEventListener("resize", updatePlaceholder);
        return ()=>window.removeEventListener("resize", updatePlaceholder);
    }, []);
    const handleInputClick = ()=>{
    // if (variant === "large" && window.innerWidth <= 600) {
    //   setIsModalOpen(true);
    // }
    };
    const handleCloseModal = ()=>{
        setIsFadingOut(true);
        setTimeout(()=>{
            setIsModalOpen(false);
            setIsFadingOut(false);
        }, 300);
    };
    (0, $1Pgvo.useEffect)(()=>{
        if (isModalOpen) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "";
        return ()=>{
            document.body.style.overflow = "";
        };
    }, [
        isModalOpen
    ]);
    (0, $1Pgvo.useEffect)(()=>{
        const handleResize = ()=>{
            const innerHeight = window.innerHeight;
            const clientHeight = document.documentElement.clientHeight;
            if (innerHeight < clientHeight) setKeyboardHeight(clientHeight - innerHeight);
            else setKeyboardHeight(0);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        className: $501530cdea7e9b50$exports.ctaContainer,
        children: [
            status === "success" && variant != "small" ? /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                className: `${$501530cdea7e9b50$exports.ctaParent} ${$501530cdea7e9b50$exports[variant]} ctaParentDownloadParent`,
                children: /*#__PURE__*/ (0, $j6whP.jsxs)("button", {
                    className: $501530cdea7e9b50$exports.ctaParentDownload,
                    onClick: ()=>{
                        const userAgent = navigator.userAgent || navigator.vendor;
                        if (/android/i.test(userAgent)) window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
                        else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
                        else window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692"; // Default to App Store
                    },
                    children: [
                        "Download Returns App",
                        /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($07382137637ba534$exports))),
                            alt: "Arrow Icon",
                            style: {
                                width: "14px",
                                height: "14px",
                                fontWeight: "400"
                            }
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                className: `${$501530cdea7e9b50$exports.ctaParent} ${$501530cdea7e9b50$exports[variant]}`,
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsxs)("span", {
                        className: $501530cdea7e9b50$exports.contactParent,
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                className: $501530cdea7e9b50$exports.countryCode,
                                children: "+91"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                className: $501530cdea7e9b50$exports.contactWrapper,
                                children: /*#__PURE__*/ (0, $j6whP.jsx)("input", {
                                    className: $501530cdea7e9b50$exports.contactInput,
                                    type: "tel",
                                    value: phone,
                                    onChange: handleChange,
                                    placeholder: placeholder,
                                    onClick: handleInputClick,
                                    inputMode: "numeric"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("button", {
                        className: `${$501530cdea7e9b50$exports.reward} ${!isValid ? $501530cdea7e9b50$exports.disabledReward : ""}`,
                        onClick: handleRewardClick,
                        onMouseMove: handleMouseMove,
                        onMouseLeave: handleMouseLeave,
                        children: [
                            variant === "large" && /*#__PURE__*/ (0, $j6whP.jsxs)((0, $j6whP.Fragment), {
                                children: [
                                    "Claim 3 ",
                                    /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                        className: $501530cdea7e9b50$exports.free,
                                        children: "free"
                                    }),
                                    " stocks"
                                ]
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                className: $501530cdea7e9b50$exports.rewardSvg,
                                children: isLoading ? /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                    className: $501530cdea7e9b50$exports.loader
                                }) : status === "error" ? /*#__PURE__*/ (0, $j6whP.jsx)("video", {
                                    src: `${(0, (/*@__PURE__*/$parcel$interopDefault($f0d8ba5a1940ec37$exports)))}?t=${Date.now()}`,
                                    autoPlay: true,
                                    loop: true,
                                    muted: true,
                                    playsInline: true,
                                    className: $501530cdea7e9b50$exports.errorAnim
                                }, status) : /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($07382137637ba534$exports))),
                                    alt: "Arrow Icon",
                                    style: {
                                        width: "14px",
                                        height: "14px",
                                        fontWeight: "400"
                                    }
                                })
                            })
                        ]
                    }),
                    tooltip.visible && /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                        className: $501530cdea7e9b50$exports.tooltip,
                        style: {
                            left: `${tooltip.x}px`,
                            top: `${tooltip.y}px`
                        },
                        children: "Enter valid phone number"
                    })
                ]
            }),
            isModalOpen && /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                className: `${$501530cdea7e9b50$exports.modalOverlay} ${isFadingOut ? $501530cdea7e9b50$exports.fadeOut : $501530cdea7e9b50$exports.fadeIn}`,
                onClick: handleCloseModal,
                children: /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                    className: $501530cdea7e9b50$exports.modalContent,
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                            className: $501530cdea7e9b50$exports.closeButton,
                            onClick: handleCloseModal,
                            children: "\u2715"
                        }),
                        /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                            className: $501530cdea7e9b50$exports.modalContentMain,
                            style: {
                                position: keyboardHeight ? 'absolute' : 'relative',
                                bottom: keyboardHeight ? `${keyboardHeight + 10}px` : 'auto'
                            },
                            children: [
                                /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                    className: $501530cdea7e9b50$exports.modalHeadingParent,
                                    children: /*#__PURE__*/ (0, $j6whP.jsx)("h1", {
                                        className: $501530cdea7e9b50$exports.modalHeading,
                                        children: "Get 3 free Stocks worth \u20B9300"
                                    })
                                }),
                                /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3d94a64ce4d37aec$exports))),
                                    alt: "Background",
                                    className: $501530cdea7e9b50$exports.modalBg
                                }),
                                /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                                    className: `${$501530cdea7e9b50$exports.ctaParent} ${$501530cdea7e9b50$exports[variant]}`,
                                    children: [
                                        /*#__PURE__*/ (0, $j6whP.jsxs)("span", {
                                            className: $501530cdea7e9b50$exports.contactParent,
                                            children: [
                                                /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                                    className: $501530cdea7e9b50$exports.countryCode,
                                                    children: "+91"
                                                }),
                                                /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                                    className: $501530cdea7e9b50$exports.contactWrapper,
                                                    children: /*#__PURE__*/ (0, $j6whP.jsx)("input", {
                                                        className: $501530cdea7e9b50$exports.contactInput,
                                                        type: "tel",
                                                        value: phone,
                                                        onChange: handleChange,
                                                        placeholder: placeholder,
                                                        autoFocus: true,
                                                        inputMode: "numeric"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $j6whP.jsxs)("button", {
                                            className: `${$501530cdea7e9b50$exports.reward} ${!isValid ? $501530cdea7e9b50$exports.disabledReward : ""}`,
                                            onClick: ()=>{
                                                handleRewardClick();
                                                const userAgent = navigator.userAgent || navigator.vendor;
                                                if (/android/i.test(userAgent)) window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
                                                else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
                                                else window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
                                            },
                                            onMouseMove: handleMouseMove,
                                            onMouseLeave: handleMouseLeave,
                                            children: [
                                                variant === "large" && /*#__PURE__*/ (0, $j6whP.jsxs)((0, $j6whP.Fragment), {
                                                    children: [
                                                        "Claim 3 ",
                                                        /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                                            className: $501530cdea7e9b50$exports.free,
                                                            children: "free"
                                                        }),
                                                        " stocks"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                                    className: $501530cdea7e9b50$exports.rewardSvg,
                                                    children: isLoading ? /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                                        className: $501530cdea7e9b50$exports.loader
                                                    }) : status === "error" ? /*#__PURE__*/ (0, $j6whP.jsx)("video", {
                                                        src: `${(0, (/*@__PURE__*/$parcel$interopDefault($f0d8ba5a1940ec37$exports)))}?t=${Date.now()}`,
                                                        autoPlay: true,
                                                        loop: true,
                                                        muted: true,
                                                        playsInline: true,
                                                        className: $501530cdea7e9b50$exports.errorAnim
                                                    }, status) : /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($07382137637ba534$exports))),
                                                        alt: "Arrow Icon",
                                                        style: {
                                                            width: "14px",
                                                            height: "14px",
                                                            fontWeight: "400"
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



var $1Pgvo = parcelRequire("1Pgvo");
const $d1b921ff84700f03$var$Footer = ()=>{
    const [ctaStatus, setCtaStatus] = (0, $1Pgvo.useState)("idle");
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $j6whP.Fragment), {
        children: /*#__PURE__*/ (0, $j6whP.jsxs)("footer", {
            className: $3ea24f2fdb2b0724$export$ac96a2a951168044,
            children: [
                /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                    className: $3ea24f2fdb2b0724$export$18fb3db69671e58b,
                    children: /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($39ea85e8599a41c0$exports))),
                        alt: "Returns Logo"
                    })
                }),
                /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                    className: $3ea24f2fdb2b0724$export$d201f0ee6d10d236,
                    children: [
                        /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                            className: $3ea24f2fdb2b0724$export$4fa6d27c1c862db7,
                            children: [
                                /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                                    className: $3ea24f2fdb2b0724$export$362e26412028e062,
                                    children: "Returns is an all in one app that let\u2019s you diversify into multi-asset investments, protect your wealth and provide institutional level infrastructure & tools."
                                }),
                                /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                                    className: $3ea24f2fdb2b0724$export$79a29376087ecf60,
                                    children: [
                                        /*#__PURE__*/ (0, $j6whP.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $j6whP.jsx)("i", {
                                                    className: "ri-mail-send-line"
                                                }),
                                                /*#__PURE__*/ (0, $j6whP.jsx)("a", {
                                                    href: "mailto:support@returns.trade",
                                                    children: "support@returns.trade"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $j6whP.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $j6whP.jsx)("i", {
                                                    className: "ri-phone-line"
                                                }),
                                                /*#__PURE__*/ (0, $j6whP.jsx)("a", {
                                                    href: "tel:+917669428166",
                                                    children: "+91-76694 28166"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                            className: $3ea24f2fdb2b0724$export$d73ba76fbf89849b,
                            children: [
                                /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                    className: $3ea24f2fdb2b0724$export$df44ffccac22cd79,
                                    children: "Get a callback!"
                                }),
                                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3cecc3b9cc79fe3d$export$d73ba76fbf89849b), {
                                    variant: "small",
                                    status: ctaStatus,
                                    setStatus: setCtaStatus
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)("hr", {
                    className: `${$3ea24f2fdb2b0724$export$92edf48bf3158b7a}`
                }),
                /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                    className: $3ea24f2fdb2b0724$export$f92d76d135115694,
                    children: [
                        /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                            className: $3ea24f2fdb2b0724$export$6906297b15b9f5f0,
                            children: [
                                /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $j6whP.jsx)("a", {
                                        href: "https://docs.google.com/document/u/0/d/107oGESPJbd231S9_EKlYOFqG6jjUkrGcJDBCD8wKW_4/mobilebasic?pli=1",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Terms & conditions"
                                    })
                                }),
                                /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $j6whP.jsx)("a", {
                                        href: "https://docs.google.com/document/u/5/d/10_9GANOQ1rBtdjlIKuaRwco_TikyA9WAdAna0hodylg/mobilebasic",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Privacy policy"
                                    })
                                }),
                                /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $j6whP.jsx)("a", {
                                        href: "https://docs.google.com/document/d/15fbRIZHwOLvguDbm4cf7kG1LOacvaWJ5x5OeKl0Q94E/mobilebasic",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Disclaimers"
                                    })
                                }),
                                /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $j6whP.jsx)("a", {
                                        href: "https://docs.google.com/document/d/14qSyH2Oy6bYxSRZl4twWTuTpaDOgCpXRRpmWLdPRHP8/mobilebasic",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Grievances"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                            className: $3ea24f2fdb2b0724$export$687fc4f52cf31e36,
                            children: /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                                className: $3ea24f2fdb2b0724$export$9d258e38d78c4993,
                                children: /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                                    children: [
                                        "\xa9Copyright ",
                                        new Date().getFullYear(),
                                        " Rathi Equity Research All Rights Reserved"
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                    className: $3ea24f2fdb2b0724$export$30a8bfb63a8b520a,
                    children: [
                        /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                            children: 'Returns is a product of Rathi Equity Research, serving as a technology platform that connects users with SEBI-registered professionals. Returns does not provide direct financial advice or recommendations, and all investment decisions are made at the user\'s discretion and risk. Returns operates as an Authorized Person (AP) of Enrich Financial Market Pvt Ltd (SEBI Registration Number: INZ000078632), a SEBI-registered broker. The term "Returns" solely refers to the product name and does not imply or guarantee any financial returns or profits. Research services, including those offered by SEBI-registered Research Analyst Krishnkanth Rathi (INH000014492), are independent and comply with regulatory oversight. Subscription payments for these services are made directly to licensed entities or individuals. Past performance is not indicative of future results, and Returns is not responsible for any losses arising from recommendations made by SEBI-registered professionals.'
                        }),
                        /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                            children: "For any inquiries, contact us at Phone: +91-76694 28166 or Grievance Officer: grievance@returns.trade. Our registered address is 315, Galleria Tower, Galleria Market, DLF Galleria Rd, Sector 28, DLF Phase IV, Gurugram, Haryana 122009."
                        })
                    ]
                })
            ]
        })
    });
};
var $d1b921ff84700f03$export$2e2bcd8739ae039 = $d1b921ff84700f03$var$Footer;



var $j6whP = parcelRequire("j6whP");

var $j6whP = parcelRequire("j6whP");
var $145bd01da1e91cfa$export$6a15f8f670d57b0;
var $145bd01da1e91cfa$export$5b918073c17c1d45;
var $145bd01da1e91cfa$export$cc691aa163a3c278;
var $145bd01da1e91cfa$export$de35f23bc4efd4c7;
var $145bd01da1e91cfa$export$1e3fb8626c787b6d;
var $145bd01da1e91cfa$export$9ae72fe925ff8f96;
var $145bd01da1e91cfa$export$3551c92a09bdc8f8;
var $145bd01da1e91cfa$export$2d2e5aa253e33f00;
var $145bd01da1e91cfa$export$e76f2cf4fa83f217;
var $145bd01da1e91cfa$export$6291e281fea9cbf5;
var $145bd01da1e91cfa$export$efcdeaf5087320cf;
$145bd01da1e91cfa$export$6a15f8f670d57b0 = `_9EMo_a_heroHomeContainer`;
$145bd01da1e91cfa$export$5b918073c17c1d45 = `_9EMo_a_hiddenOpeningContainer`;
$145bd01da1e91cfa$export$cc691aa163a3c278 = `_9EMo_a_openingContainer`;
$145bd01da1e91cfa$export$de35f23bc4efd4c7 = `_9EMo_a_openingDescription`;
$145bd01da1e91cfa$export$1e3fb8626c787b6d = `_9EMo_a_openingImage`;
$145bd01da1e91cfa$export$9ae72fe925ff8f96 = `_9EMo_a_openingParent`;
$145bd01da1e91cfa$export$3551c92a09bdc8f8 = `_9EMo_a_openingText`;
$145bd01da1e91cfa$export$2d2e5aa253e33f00 = `_9EMo_a_openingTextGold`;
$145bd01da1e91cfa$export$e76f2cf4fa83f217 = `_9EMo_a_openingTextParent`;
$145bd01da1e91cfa$export$6291e281fea9cbf5 = `_9EMo_a_unlockContainer`;
$145bd01da1e91cfa$export$efcdeaf5087320cf = `_9EMo_a_unlockImage`;


var $a9f97fec7e2adca7$exports = {};

$a9f97fec7e2adca7$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "opening-home.d6aa14e0.webp";




var $1Pgvo = parcelRequire("1Pgvo");

var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");
var $c6d3d7358a625b25$export$8a40e5669d3698bc;
var $c6d3d7358a625b25$export$17fe9d1403c5b12f;
var $c6d3d7358a625b25$export$801863722a97d1fa;
var $c6d3d7358a625b25$export$286fcf25398eb85a;
var $c6d3d7358a625b25$export$8334095c4da561a6;
var $c6d3d7358a625b25$export$3b690bef424e3403;
var $c6d3d7358a625b25$export$6eddf9bc7f2b7d80;
var $c6d3d7358a625b25$export$fb184b623420d9be;
var $c6d3d7358a625b25$export$523c0b569236b342;
var $c6d3d7358a625b25$export$2ab9a8f9f1186f14;
$c6d3d7358a625b25$export$8a40e5669d3698bc = `_2ADNwq_digit`;
$c6d3d7358a625b25$export$17fe9d1403c5b12f = `_2ADNwq_digitWrapper`;
$c6d3d7358a625b25$export$801863722a97d1fa = `_2ADNwq_marqueeContainer`;
$c6d3d7358a625b25$export$286fcf25398eb85a = `_2ADNwq_marqueeContent`;
$c6d3d7358a625b25$export$8334095c4da561a6 = `_2ADNwq_marqueeItem`;
$c6d3d7358a625b25$export$3b690bef424e3403 = `_2ADNwq_marqueeOverlay`;
$c6d3d7358a625b25$export$6eddf9bc7f2b7d80 = `_2ADNwq_scrollLeft`;
$c6d3d7358a625b25$export$6eddf9bc7f2b7d80;
$c6d3d7358a625b25$export$fb184b623420d9be = `_2ADNwq_title`;
$c6d3d7358a625b25$export$523c0b569236b342 = `_2ADNwq_unit`;
$c6d3d7358a625b25$export$2ab9a8f9f1186f14 = `_2ADNwq_value`;


var $6c8051b9e08b0728$exports = {};
$6c8051b9e08b0728$exports = JSON.parse("[{\"title\":\"Team experience\",\"value\":\"20\",\"unit\":\"Years\"},{\"title\":\"Stocks analysed\",\"value\":\"1098\",\"unit\":\" /s\"},{\"title\":\"Quant parameters\",\"value\":\"3240\",\"unit\":\" /s\"},{\"title\":\"Throughput\",\"value\":\"3.21\",\"unit\":\" Gb\"},{\"title\":\"Order execution\",\"value\":\"<100\",\"unit\":\" ms\"},{\"title\":\"Data latency\",\"value\":\"<5\",\"unit\":\" ms\"}]");



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

var $1Pgvo = parcelRequire("1Pgvo");
"use client";
const $0e95141f62ee0beb$export$a3579ca508007a95 = (0, $1Pgvo.createContext)({});



var $1Pgvo = parcelRequire("1Pgvo");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $24c068ca23c223da$export$fe4300aa8eebea86(init) {
    const ref = (0, $1Pgvo.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $1Pgvo = parcelRequire("1Pgvo");
const $eb26638a1ff129db$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $8ba01f17ad46b6a6$export$700979bc83e7db82 = (0, $eb26638a1ff129db$export$4e09c449d6c407f7) ? (0, $1Pgvo.useLayoutEffect) : (0, $1Pgvo.useEffect);



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

var $1Pgvo = parcelRequire("1Pgvo");
"use client";
/**
 * @public
 */ const $b9c0da3bd9c84b40$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $1Pgvo.createContext)(null);




var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

var $1Pgvo = parcelRequire("1Pgvo");
"use client";
/**
 * @public
 */ const $9e704e023ee7d3d9$export$22a697fb29aac98d = (0, $1Pgvo.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});


"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $175997614a0a6132$var$PopChildMeasure extends $1Pgvo.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const parent = element.offsetParent;
            const parentWidth = parent instanceof HTMLElement ? parent.offsetWidth || 0 : 0;
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
            size.right = parentWidth - size.width - size.left;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $175997614a0a6132$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent, anchorX: anchorX }) {
    const id = (0, $1Pgvo.useId)();
    const ref = (0, $1Pgvo.useRef)(null);
    const size = (0, $1Pgvo.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0
    });
    const { nonce: nonce } = (0, $1Pgvo.useContext)((0, $9e704e023ee7d3d9$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $1Pgvo.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left, right: right } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        const x = anchorX === "left" ? `left: ${left}` : `right: ${right}`;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            ${x}px !important;
            top: ${top}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $j6whP.jsx)($175997614a0a6132$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $1Pgvo.cloneElement(children, {
            ref: ref
        })
    });
}


"use client";
const $b37cf78b82ad487c$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode, anchorX: anchorX })=>{
    const presenceChildren = (0, $24c068ca23c223da$export$fe4300aa8eebea86)($b37cf78b82ad487c$var$newChildrenMap);
    const id = (0, $1Pgvo.useId)();
    const memoizedOnExitComplete = (0, $1Pgvo.useCallback)((childId)=>{
        presenceChildren.set(childId, true);
        for (const isComplete of presenceChildren.values()){
            if (!isComplete) return; // can stop searching when any is incomplete
        }
        onExitComplete && onExitComplete();
    }, [
        presenceChildren,
        onExitComplete
    ]);
    const context = (0, $1Pgvo.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: memoizedOnExitComplete,
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random(),
        memoizedOnExitComplete
    ] : [
        isPresent,
        memoizedOnExitComplete
    ]);
    (0, $1Pgvo.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $1Pgvo.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $j6whP.jsx)((0, $175997614a0a6132$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        anchorX: anchorX,
        children: children
    });
    return (0, $j6whP.jsx)((0, $b9c0da3bd9c84b40$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $b37cf78b82ad487c$var$newChildrenMap() {
    return new Map();
}



var $1Pgvo = parcelRequire("1Pgvo");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $8bd779e86f53bc83$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $1Pgvo.useContext)((0, $b9c0da3bd9c84b40$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $1Pgvo.useId)();
    (0, $1Pgvo.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $1Pgvo.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $8bd779e86f53bc83$export$8249053f690ea39a() {
    return $8bd779e86f53bc83$export$ee27c052bca048fb((0, $1Pgvo.useContext)((0, $b9c0da3bd9c84b40$export$f224e4635b6f8ce2)));
}
function $8bd779e86f53bc83$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $1Pgvo = parcelRequire("1Pgvo");
const $957bec19f8c16502$export$10e61aed958678dd = (child)=>child.key || "";
function $957bec19f8c16502$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $1Pgvo.Children).forEach(children, (child)=>{
        if ((0, $1Pgvo.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}


"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $024f5eaf0c2de36b$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync", propagate: propagate = false, anchorX: anchorX = "left" })=>{
    const [isParentPresent, safeToRemove] = (0, $8bd779e86f53bc83$export$2a8c16d82a0a0e26)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $1Pgvo.useMemo)(()=>(0, $957bec19f8c16502$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $957bec19f8c16502$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $1Pgvo.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $1Pgvo.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $24c068ca23c223da$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $1Pgvo.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $1Pgvo.useState)(presentChildren);
    (0, $8ba01f17ad46b6a6$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $957bec19f8c16502$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $957bec19f8c16502$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $957bec19f8c16502$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return null;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $1Pgvo.useContext)((0, $0e95141f62ee0beb$export$a3579ca508007a95));
    return (0, $j6whP.jsx)((0, $j6whP.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $957bec19f8c16502$export$10e61aed958678dd)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && (safeToRemove === null || safeToRemove === void 0 || safeToRemove());
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $j6whP.jsx)((0, $b37cf78b82ad487c$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                children: child
            }, key);
        })
    });
};

function $4b4dec95d1dbfbd3$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $4b4dec95d1dbfbd3$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $4b4dec95d1dbfbd3$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


/*#__NO_SIDE_EFFECTS__*/ const $5d869bf5b7e31014$export$8793edee2d425525 = (any)=>any;


let $f6c3d1780c7f8ff9$export$491112666e282270 = (0, $5d869bf5b7e31014$export$8793edee2d425525);
let $f6c3d1780c7f8ff9$export$f5708dca728d7177 = (0, $5d869bf5b7e31014$export$8793edee2d425525);
var $f6c3d1780c7f8ff9$var$check, $f6c3d1780c7f8ff9$var$message, $f6c3d1780c7f8ff9$var$check1, $f6c3d1780c7f8ff9$var$message1;


const $dbb240237456a315$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


/*#__NO_SIDE_EFFECTS__*/ function $1db93006ee53587a$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $483094981a1afc3a$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



class $92a9f7aaf33d26aa$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $4b4dec95d1dbfbd3$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $4b4dec95d1dbfbd3$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $c68b6b1dcf81df29$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $1e7f112201d564c5$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $dff4c532ddc87e5f$var$warned = new Set();
function $dff4c532ddc87e5f$export$1adc410501177663(message) {
    return $dff4c532ddc87e5f$var$warned.has(message);
}
function $dff4c532ddc87e5f$export$5b28268982f175ba(condition, message, element) {
    if (condition || $dff4c532ddc87e5f$var$warned.has(message)) return;
    console.warn(message);
    if (element) console.warn(element);
    $dff4c532ddc87e5f$var$warned.add(message);
}




function $22b6140473e534e3$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}


function $b37798457ef74195$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


function $fdc230da1cbdafde$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $fdc230da1cbdafde$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $fdc230da1cbdafde$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $fdc230da1cbdafde$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $71f1638127255b9d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $fdc230da1cbdafde$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}



const $952da621fe0a2c34$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $1db93006ee53587a$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $314f7e96d8ad6df4$export$4d0c371993b9283e {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    get finished() {
        // Support for new finished Promise and legacy thennable API
        return Promise.all(this.animations.map((animation)=>"finished" in animation ? animation.finished : animation));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $952da621fe0a2c34$export$20d68f04f30763a5)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else if (typeof fallback === "function") return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    flatten() {
        this.runAll("flatten");
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


/**
 * TODO: This is a temporary class to support the legacy
 * thennable API
 */ class $7d48114fece9e632$export$c1e41718f71efe41 extends (0, $314f7e96d8ad6df4$export$4d0c371993b9283e) {
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
}


function $b8f540ed65e01b25$export$7c1391340308742e(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $72aef2dce0c959c8$export$f4ff70a5b4808fd8 = 20000;
function $72aef2dce0c959c8$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $72aef2dce0c959c8$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $72aef2dce0c959c8$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $511e72c32bf15c47$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $72aef2dce0c959c8$export$cbdd6b3d40ea54e2)(generator), (0, $72aef2dce0c959c8$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(duration)
    };
}


function $6f99742e6f7262c4$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}



function $1892622a42edf7f1$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}


class $0dc55d80f8af296d$export$a361fbe706f8c9b {
    constructor(animation){
        this.animation = animation;
    }
    get duration() {
        var _a, _b, _c;
        const durationInMs = ((_b = (_a = this.animation) === null || _a === void 0 ? void 0 : _a.effect) === null || _b === void 0 ? void 0 : _b.getComputedTiming().duration) || ((_c = this.options) === null || _c === void 0 ? void 0 : _c.duration) || 300;
        return (0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(Number(durationInMs));
    }
    get time() {
        var _a;
        if (this.animation) return (0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(((_a = this.animation) === null || _a === void 0 ? void 0 : _a.currentTime) || 0);
        return 0;
    }
    set time(newTime) {
        if (this.animation) this.animation.currentTime = (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        return this.animation ? this.animation.playbackRate : 1;
    }
    set speed(newSpeed) {
        if (this.animation) this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.animation ? this.animation.playState : "finished";
    }
    get startTime() {
        return this.animation ? this.animation.startTime : null;
    }
    get finished() {
        return this.animation ? this.animation.finished : Promise.resolve();
    }
    play() {
        this.animation && this.animation.play();
    }
    pause() {
        this.animation && this.animation.pause();
    }
    stop() {
        if (!this.animation || this.state === "idle" || this.state === "finished") return;
        if (this.animation.commitStyles) this.animation.commitStyles();
        this.cancel();
    }
    flatten() {
        var _a, _b;
        if (!this.animation || !((_a = this.options) === null || _a === void 0 ? void 0 : _a.allowFlatten)) return;
        (_b = this.animation.effect) === null || _b === void 0 || _b.updateTiming({
            easing: "linear"
        });
    }
    attachTimeline(timeline) {
        if (this.animation) (0, $1892622a42edf7f1$export$5bd0fcbc73622e13)(this.animation, timeline);
        return 0, $5d869bf5b7e31014$export$8793edee2d425525;
    }
    complete() {
        this.animation && this.animation.finish();
    }
    cancel() {
        try {
            this.animation && this.animation.cancel();
        } catch (e) {}
    }
}



const $ee7f744bb4237d91$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";



/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $f2502df108fca924$export$e3ad02c335474dee = {
    linearEasing: undefined
};


function $537c720a7ce938a3$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $1db93006ee53587a$export$7c73462e0d25e514)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $f2502df108fca924$export$e3ad02c335474dee)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}


const $9a7b7d1e08229c2a$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $537c720a7ce938a3$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");



const $a60388297ed1e724$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $483094981a1afc3a$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


function $cda7ad74a3797f3a$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $9a7b7d1e08229c2a$export$866c1d07a1ac2ab)() || !easing || typeof easing === "string" && (easing in $cda7ad74a3797f3a$export$2cf569f5e2221176 || (0, $9a7b7d1e08229c2a$export$866c1d07a1ac2ab)()) || (0, $ee7f744bb4237d91$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($cda7ad74a3797f3a$export$fcdd8f3f2160beda));
}
const $cda7ad74a3797f3a$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $cda7ad74a3797f3a$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $cda7ad74a3797f3a$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $cda7ad74a3797f3a$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $cda7ad74a3797f3a$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $cda7ad74a3797f3a$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $cda7ad74a3797f3a$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $9a7b7d1e08229c2a$export$866c1d07a1ac2ab)()) return (0, $a60388297ed1e724$export$66d3851e2b1ec912)(easing, duration);
    else if ((0, $ee7f744bb4237d91$export$ff43f99925d7366b)(easing)) return $cda7ad74a3797f3a$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$cda7ad74a3797f3a$export$916ea73bcd3a6030(segmentEasing, duration) || $cda7ad74a3797f3a$export$2cf569f5e2221176.easeOut);
    else return $cda7ad74a3797f3a$export$2cf569f5e2221176[easing];
}





const $cff8d6a02e97866b$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $d35bb1a817255f19$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $491300dc4b35db23$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $d35bb1a817255f19$export$84ce9a476f53d110).value) (0, $d35bb1a817255f19$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $73d75d214be4e12e$var$maxElapsed = 40;
function $73d75d214be4e12e$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $cff8d6a02e97866b$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $491300dc4b35db23$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $dbb240237456a315$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, $dbb240237456a315$export$dd826089e3c5e502).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $73d75d214be4e12e$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $cff8d6a02e97866b$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $cff8d6a02e97866b$export$71ecace0a033b35a).length; i++)steps[(0, $cff8d6a02e97866b$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $153ac5076757d0fe$export$2cef06c20297c17d, cancel: $153ac5076757d0fe$export$ec99c0ef4978dccb, state: $153ac5076757d0fe$export$fff89137e9e818ce, steps: $153ac5076757d0fe$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $73d75d214be4e12e$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $5d869bf5b7e31014$export$8793edee2d425525), true);




const { schedule: $0e393082e3dd9181$export$bb76eed83315504c, cancel: $0e393082e3dd9181$export$3252729004b8456e } = /* @__PURE__ */ (0, $73d75d214be4e12e$export$510b0596a933801a)(queueMicrotask, false);




let $8fa0eb8b37097f3c$var$now;
function $8fa0eb8b37097f3c$var$clearTime() {
    $8fa0eb8b37097f3c$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $8fa0eb8b37097f3c$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($8fa0eb8b37097f3c$var$now === undefined) $8fa0eb8b37097f3c$export$2da9be4cfdb689b1.set((0, $153ac5076757d0fe$export$fff89137e9e818ce).isProcessing || (0, $dbb240237456a315$export$dd826089e3c5e502).useManualTiming ? (0, $153ac5076757d0fe$export$fff89137e9e818ce).timestamp : performance.now());
        return $8fa0eb8b37097f3c$var$now;
    },
    set: (newTime)=>{
        $8fa0eb8b37097f3c$var$now = newTime;
        queueMicrotask($8fa0eb8b37097f3c$var$clearTime);
    }
};


const $833dbdd94a537cba$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $833dbdd94a537cba$export$1b3dd616664938e4() {
    return $833dbdd94a537cba$export$9e9bc3c487fccc00.x || $833dbdd94a537cba$export$9e9bc3c487fccc00.y;
}



function $bc1869f08faf4999$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $833dbdd94a537cba$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $833dbdd94a537cba$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $833dbdd94a537cba$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $833dbdd94a537cba$export$9e9bc3c487fccc00).x || (0, $833dbdd94a537cba$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $833dbdd94a537cba$export$9e9bc3c487fccc00).x = (0, $833dbdd94a537cba$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $833dbdd94a537cba$export$9e9bc3c487fccc00).x = (0, $833dbdd94a537cba$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}



function $708d946a9d38ec7a$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    var _a;
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) // TODO: Refactor to utils package
        // invariant(
        //     Boolean(scope.current),
        //     "Scope provided, but no element detected."
        // )
        root = scope.current;
        const elements = (_a = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a !== void 0 ? _a : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $a41e1c242f36e26a$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $708d946a9d38ec7a$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $6878860b54ca295d$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $833dbdd94a537cba$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $6878860b54ca295d$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $a41e1c242f36e26a$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const onPointerEnter = (enterEvent)=>{
        if (!$6878860b54ca295d$var$isValidHover(enterEvent)) return;
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = (leaveEvent)=>{
            if (!$6878860b54ca295d$var$isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}



function $166c13fee8804834$export$198da4f2fc5a41d0(event, action) {
    const actionName = `${action}PointerCapture`;
    if (event.target instanceof Element && actionName in event.target && event.pointerId !== undefined) try {
        event.target[actionName](event.pointerId);
    } catch (e) {}
}


/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $c2298670d3ee7c3c$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $c2298670d3ee7c3c$export$e841ada32ff745b(parent, child.parentElement);
};


const $09d80ff1af4e2a66$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};



const $a0de5a578900e0ee$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $a0de5a578900e0ee$export$5f6976e2f961e8b7(element) {
    return $a0de5a578900e0ee$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}


const $0bc0e0cd346ab5fe$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $0d3522008785783d$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $0d3522008785783d$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $0d3522008785783d$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $0d3522008785783d$var$filterEvents(()=>{
        if ((0, $0bc0e0cd346ab5fe$export$7987404a4e35b84b).has(element)) return;
        $0d3522008785783d$var$firePointerEvent(element, "down");
        const handleKeyup = $0d3522008785783d$var$filterEvents(()=>{
            $0d3522008785783d$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$0d3522008785783d$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $5da6e464a2d52466$var$isValidPressEvent(event) {
    return (0, $09d80ff1af4e2a66$export$a4cf9c8a4b063a6e)(event) && !(0, $833dbdd94a537cba$export$1b3dd616664938e4)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $5da6e464a2d52466$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $a41e1c242f36e26a$export$edc0ace9d5e7e842)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!target || !$5da6e464a2d52466$var$isValidPressEvent(startEvent) || (0, $0bc0e0cd346ab5fe$export$7987404a4e35b84b).has(target)) return;
        (0, $0bc0e0cd346ab5fe$export$7987404a4e35b84b).add(target);
        (0, $166c13fee8804834$export$198da4f2fc5a41d0)(startEvent, "set");
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            target.removeEventListener("pointerup", onPointerUp);
            target.removeEventListener("pointercancel", onPointerCancel);
            (0, $166c13fee8804834$export$198da4f2fc5a41d0)(endEvent, "release");
            if (!$5da6e464a2d52466$var$isValidPressEvent(endEvent) || !(0, $0bc0e0cd346ab5fe$export$7987404a4e35b84b).has(target)) return;
            (0, $0bc0e0cd346ab5fe$export$7987404a4e35b84b).delete(target);
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            const isOutside = !upEvent.isTrusted ? false : $5da6e464a2d52466$var$checkOutside(upEvent, target instanceof Element ? target.getBoundingClientRect() : {
                left: 0,
                top: 0,
                right: window.innerWidth,
                bottom: window.innerHeight
            });
            if (isOutside) onPointerEnd(upEvent, false);
            else onPointerEnd(upEvent, !(target instanceof Element) || (0, $c2298670d3ee7c3c$export$e841ada32ff745b)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        target.addEventListener("pointerup", onPointerUp, eventOptions);
        target.addEventListener("pointercancel", onPointerCancel, eventOptions);
        target.addEventListener("lostpointercapture", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        target = options.useGlobalTarget ? window : target;
        let canAddKeyboardAccessibility = false;
        if (target instanceof HTMLElement) {
            canAddKeyboardAccessibility = true;
            if (!(0, $a0de5a578900e0ee$export$5f6976e2f961e8b7)(target) && target.getAttribute("tabindex") === null) target.tabIndex = 0;
        }
        target.addEventListener("pointerdown", startPress, eventOptions);
        if (canAddKeyboardAccessibility) target.addEventListener("focus", (event)=>(0, $0d3522008785783d$export$4b5790288fe12a79)(event, eventOptions), eventOptions);
    });
    return cancelEvents;
}
function $5da6e464a2d52466$var$checkOutside(event, rect) {
    return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
}






const $bed173d670311b7b$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};



function $2b1cd4281f0b4a69$var$record() {
    const { value: value } = (0, $d35bb1a817255f19$export$84ce9a476f53d110);
    if (value === null) {
        (0, $153ac5076757d0fe$export$ec99c0ef4978dccb)($2b1cd4281f0b4a69$var$record);
        return;
    }
    value.frameloop.rate.push((0, $153ac5076757d0fe$export$fff89137e9e818ce).delta);
    value.animations.mainThread.push((0, $bed173d670311b7b$export$d921fb2475e2900c).mainThread);
    value.animations.waapi.push((0, $bed173d670311b7b$export$d921fb2475e2900c).waapi);
    value.animations.layout.push((0, $bed173d670311b7b$export$d921fb2475e2900c).layout);
}
function $2b1cd4281f0b4a69$var$mean(values) {
    return values.reduce((acc, value)=>acc + value, 0) / values.length;
}
function $2b1cd4281f0b4a69$var$summarise(values, calcAverage = $2b1cd4281f0b4a69$var$mean) {
    if (values.length === 0) return {
        min: 0,
        max: 0,
        avg: 0
    };
    return {
        min: Math.min(...values),
        max: Math.max(...values),
        avg: calcAverage(values)
    };
}
const $2b1cd4281f0b4a69$var$msToFps = (ms)=>Math.round(1000 / ms);
function $2b1cd4281f0b4a69$var$clearStatsBuffer() {
    (0, $d35bb1a817255f19$export$84ce9a476f53d110).value = null;
    (0, $d35bb1a817255f19$export$84ce9a476f53d110).addProjectionMetrics = null;
}
function $2b1cd4281f0b4a69$var$reportStats() {
    const { value: value } = (0, $d35bb1a817255f19$export$84ce9a476f53d110);
    if (!value) throw new Error("Stats are not being measured");
    $2b1cd4281f0b4a69$var$clearStatsBuffer();
    (0, $153ac5076757d0fe$export$ec99c0ef4978dccb)($2b1cd4281f0b4a69$var$record);
    const summary = {
        frameloop: {
            rate: $2b1cd4281f0b4a69$var$summarise(value.frameloop.rate),
            read: $2b1cd4281f0b4a69$var$summarise(value.frameloop.read),
            resolveKeyframes: $2b1cd4281f0b4a69$var$summarise(value.frameloop.resolveKeyframes),
            update: $2b1cd4281f0b4a69$var$summarise(value.frameloop.update),
            preRender: $2b1cd4281f0b4a69$var$summarise(value.frameloop.preRender),
            render: $2b1cd4281f0b4a69$var$summarise(value.frameloop.render),
            postRender: $2b1cd4281f0b4a69$var$summarise(value.frameloop.postRender)
        },
        animations: {
            mainThread: $2b1cd4281f0b4a69$var$summarise(value.animations.mainThread),
            waapi: $2b1cd4281f0b4a69$var$summarise(value.animations.waapi),
            layout: $2b1cd4281f0b4a69$var$summarise(value.animations.layout)
        },
        layoutProjection: {
            nodes: $2b1cd4281f0b4a69$var$summarise(value.layoutProjection.nodes),
            calculatedTargetDeltas: $2b1cd4281f0b4a69$var$summarise(value.layoutProjection.calculatedTargetDeltas),
            calculatedProjections: $2b1cd4281f0b4a69$var$summarise(value.layoutProjection.calculatedProjections)
        }
    };
    /**
     * Convert the rate to FPS
     */ const { rate: rate } = summary.frameloop;
    rate.min = $2b1cd4281f0b4a69$var$msToFps(rate.min);
    rate.max = $2b1cd4281f0b4a69$var$msToFps(rate.max);
    rate.avg = $2b1cd4281f0b4a69$var$msToFps(rate.avg);
    [rate.min, rate.max] = [
        rate.max,
        rate.min
    ];
    return summary;
}
function $2b1cd4281f0b4a69$export$cb5deee36b9e348d() {
    if ((0, $d35bb1a817255f19$export$84ce9a476f53d110).value) {
        $2b1cd4281f0b4a69$var$clearStatsBuffer();
        throw new Error("Stats are already being measured");
    }
    const newStatsBuffer = (0, $d35bb1a817255f19$export$84ce9a476f53d110);
    newStatsBuffer.value = {
        frameloop: {
            rate: [],
            read: [],
            resolveKeyframes: [],
            update: [],
            preRender: [],
            render: [],
            postRender: []
        },
        animations: {
            mainThread: [],
            waapi: [],
            layout: []
        },
        layoutProjection: {
            nodes: [],
            calculatedTargetDeltas: [],
            calculatedProjections: []
        }
    };
    newStatsBuffer.addProjectionMetrics = (metrics)=>{
        const { layoutProjection: layoutProjection } = newStatsBuffer.value;
        layoutProjection.nodes.push(metrics.nodes);
        layoutProjection.calculatedTargetDeltas.push(metrics.calculatedTargetDeltas);
        layoutProjection.calculatedProjections.push(metrics.calculatedProjections);
    };
    (0, $153ac5076757d0fe$export$2cef06c20297c17d).postRender($2b1cd4281f0b4a69$var$record, true);
    return $2b1cd4281f0b4a69$var$reportStats;
}












/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $735f2f1a5fe1a553$var$MAX_VELOCITY_DELTA = 30;
const $735f2f1a5fe1a553$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $735f2f1a5fe1a553$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $735f2f1a5fe1a553$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "12.5.0";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $8fa0eb8b37097f3c$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $8fa0eb8b37097f3c$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $735f2f1a5fe1a553$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $92a9f7aaf33d26aa$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $153ac5076757d0fe$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($735f2f1a5fe1a553$export$67fcd818a264039d.current) $735f2f1a5fe1a553$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $8fa0eb8b37097f3c$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $735f2f1a5fe1a553$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $735f2f1a5fe1a553$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $1e7f112201d564c5$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $735f2f1a5fe1a553$export$ce8bdc721e76545f(init, options) {
    return new $735f2f1a5fe1a553$export$8cea36d14ee64562(init, options);
}













const $658bc5f569e62849$var$defaultEasing = "easeOut";
function $658bc5f569e62849$export$a31269144d66b4a(options) {
    var _a;
    if ((0, $6f99742e6f7262c4$export$6ab7812f1bac68be)(options.type)) {
        const generatorOptions = (0, $511e72c32bf15c47$export$7f1511d09ee75a99)(options, 100, options.type);
        options.ease = (0, $9a7b7d1e08229c2a$export$866c1d07a1ac2ab)() ? generatorOptions.ease : $658bc5f569e62849$var$defaultEasing;
        options.duration = (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
        options.type = "keyframes";
    } else {
        options.duration = (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)((_a = options.duration) !== null && _a !== void 0 ? _a : 0.3);
        options.ease = options.ease || $658bc5f569e62849$var$defaultEasing;
    }
}
// TODO: Reuse for NativeAnimation
function $658bc5f569e62849$export$f837a3b7321adfa5(valueName, keyframes, options) {
    var _a;
    const nativeKeyframes = {};
    const nativeOptions = {
        fill: "both",
        easing: "linear",
        composite: "replace"
    };
    nativeOptions.delay = (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)((_a = options.delay) !== null && _a !== void 0 ? _a : 0);
    $658bc5f569e62849$export$a31269144d66b4a(options);
    nativeOptions.duration = options.duration;
    const { ease: ease, times: times } = options;
    if (times) nativeKeyframes.offset = times;
    nativeKeyframes[valueName] = keyframes;
    const easing = (0, $cda7ad74a3797f3a$export$916ea73bcd3a6030)(ease, options.duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) nativeKeyframes.easing = easing;
    else nativeOptions.easing = easing;
    return {
        keyframes: nativeKeyframes,
        options: nativeOptions
    };
}


class $607bc354ecb54e97$export$bd39eb4d1b05262c extends (0, $0dc55d80f8af296d$export$a361fbe706f8c9b) {
    constructor(target, pseudoElement, valueName, keyframes, options){
        const animationOptions = (0, $658bc5f569e62849$export$f837a3b7321adfa5)(valueName, keyframes, options);
        const animation = target.animate(animationOptions.keyframes, {
            pseudoElement: pseudoElement,
            ...animationOptions.options
        });
        super(animation);
    }
}




function $aeddd9501da637f7$export$f156731db478ee9e(valueName) {
    if (valueName === "layout") return "group";
    if (valueName === "enter" || valueName === "new") return "new";
    if (valueName === "exit" || valueName === "old") return "old";
    return "group";
}


let $ad0a902a140e4c2d$var$pendingRules = {};
let $ad0a902a140e4c2d$var$style = null;
const $ad0a902a140e4c2d$export$dbf350e5966cf602 = {
    set: (selector, values)=>{
        $ad0a902a140e4c2d$var$pendingRules[selector] = values;
    },
    commit: ()=>{
        if (!$ad0a902a140e4c2d$var$style) {
            $ad0a902a140e4c2d$var$style = document.createElement("style");
            $ad0a902a140e4c2d$var$style.id = "motion-view";
        }
        let cssText = "";
        for(const selector in $ad0a902a140e4c2d$var$pendingRules){
            const rule = $ad0a902a140e4c2d$var$pendingRules[selector];
            cssText += `${selector} {\n`;
            for (const [property, value] of Object.entries(rule))cssText += `  ${property}: ${value};\n`;
            cssText += "}\n";
        }
        $ad0a902a140e4c2d$var$style.textContent = cssText;
        document.head.appendChild($ad0a902a140e4c2d$var$style);
        $ad0a902a140e4c2d$var$pendingRules = {};
    },
    remove: ()=>{
        if ($ad0a902a140e4c2d$var$style && $ad0a902a140e4c2d$var$style.parentElement) $ad0a902a140e4c2d$var$style.parentElement.removeChild($ad0a902a140e4c2d$var$style);
    }
};


function $34d4d1c0e70e9235$export$318a4a45ce9f2d6a(pseudoElement) {
    const match = pseudoElement.match(/::view-transition-(old|new|group|image-pair)\((.*?)\)/);
    if (!match) return null;
    return {
        layer: match[2],
        type: match[1]
    };
}


function $c228d6dcc94d0ed3$var$filterViewAnimations(animation) {
    var _a;
    const { effect: effect } = animation;
    if (!effect) return false;
    return effect.target === document.documentElement && ((_a = effect.pseudoElement) === null || _a === void 0 ? void 0 : _a.startsWith("::view-transition"));
}
function $c228d6dcc94d0ed3$export$8d6316dd934b3f3b() {
    return document.getAnimations().filter($c228d6dcc94d0ed3$var$filterViewAnimations);
}


function $965b1e203636b51f$export$cb29cf2b8e0a8ae1(target, targets) {
    return targets.has(target) && Object.keys(targets.get(target)).length > 0;
}


const $c91f85dbc959387f$var$definitionNames = [
    "layout",
    "enter",
    "exit",
    "new",
    "old"
];
function $c91f85dbc959387f$export$43cd2edcbb51216c(update, defaultOptions, targets) {
    if (!document.startViewTransition) return new Promise(async (resolve)=>{
        await update();
        resolve(new (0, $314f7e96d8ad6df4$export$4d0c371993b9283e)([]));
    });
    // TODO: Go over existing targets and ensure they all have ids
    /**
     * If we don't have any animations defined for the root target,
     * remove it from being captured.
     */ if (!(0, $965b1e203636b51f$export$cb29cf2b8e0a8ae1)("root", targets)) (0, $ad0a902a140e4c2d$export$dbf350e5966cf602).set(":root", {
        "view-transition-name": "none"
    });
    /**
     * Set the timing curve to linear for all view transition layers.
     * This gets baked into the keyframes, which can't be changed
     * without breaking the generated animation.
     *
     * This allows us to set easing via updateTiming - which can be changed.
     */ (0, $ad0a902a140e4c2d$export$dbf350e5966cf602).set("::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*)", {
        "animation-timing-function": "linear !important"
    });
    (0, $ad0a902a140e4c2d$export$dbf350e5966cf602).commit(); // Write
    const transition = document.startViewTransition(async ()=>{
        await update();
    // TODO: Go over new targets and ensure they all have ids
    });
    transition.finished.finally(()=>{
        (0, $ad0a902a140e4c2d$export$dbf350e5966cf602).remove(); // Write
    });
    return new Promise((resolve)=>{
        transition.ready.then(()=>{
            var _a;
            const generatedViewAnimations = (0, $c228d6dcc94d0ed3$export$8d6316dd934b3f3b)();
            const animations = [];
            /**
             * Create animations for our definitions
             */ targets.forEach((definition, target)=>{
                // TODO: If target is not "root", resolve elements
                // and iterate over each
                for (const key of $c91f85dbc959387f$var$definitionNames){
                    if (!definition[key]) continue;
                    const { keyframes: keyframes, options: options } = definition[key];
                    for (let [valueName, valueKeyframes] of Object.entries(keyframes)){
                        if (!valueKeyframes) continue;
                        const valueOptions = {
                            ...(0, $b8f540ed65e01b25$export$7c1391340308742e)(defaultOptions, valueName),
                            ...(0, $b8f540ed65e01b25$export$7c1391340308742e)(options, valueName)
                        };
                        const type = (0, $aeddd9501da637f7$export$f156731db478ee9e)(key);
                        /**
                         * If this is an opacity animation, and keyframes are not an array,
                         * we need to convert them into an array and set an initial value.
                         */ if (valueName === "opacity" && !Array.isArray(valueKeyframes)) {
                            const initialValue = type === "new" ? 0 : 1;
                            valueKeyframes = [
                                initialValue,
                                valueKeyframes
                            ];
                        }
                        /**
                         * Resolve stagger function if provided.
                         */ if (typeof valueOptions.delay === "function") valueOptions.delay = valueOptions.delay(0, 1);
                        const animation = new (0, $607bc354ecb54e97$export$bd39eb4d1b05262c)(document.documentElement, `::view-transition-${type}(${target})`, valueName, valueKeyframes, valueOptions);
                        animations.push(animation);
                    }
                }
            });
            /**
             * Handle browser generated animations
             */ for (const animation of generatedViewAnimations){
                if (animation.playState === "finished") continue;
                const { effect: effect } = animation;
                if (!effect || !(effect instanceof KeyframeEffect)) continue;
                const { pseudoElement: pseudoElement } = effect;
                if (!pseudoElement) continue;
                const name = (0, $34d4d1c0e70e9235$export$318a4a45ce9f2d6a)(pseudoElement);
                if (!name) continue;
                const targetDefinition = targets.get(name.layer);
                if (!targetDefinition) {
                    /**
                     * If transition name is group then update the timing of the animation
                     * whereas if it's old or new then we could possibly replace it using
                     * the above method.
                     */ const transitionName = name.type === "group" ? "layout" : "";
                    const animationTransition = {
                        ...(0, $b8f540ed65e01b25$export$7c1391340308742e)(defaultOptions, transitionName)
                    };
                    (0, $658bc5f569e62849$export$a31269144d66b4a)(animationTransition);
                    const easing = (0, $cda7ad74a3797f3a$export$916ea73bcd3a6030)(animationTransition.ease, animationTransition.duration);
                    effect.updateTiming({
                        delay: (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)((_a = animationTransition.delay) !== null && _a !== void 0 ? _a : 0),
                        duration: animationTransition.duration,
                        easing: easing
                    });
                    animations.push(new (0, $0dc55d80f8af296d$export$a361fbe706f8c9b)(animation));
                } else if ($c91f85dbc959387f$var$hasOpacity(targetDefinition, "enter") && $c91f85dbc959387f$var$hasOpacity(targetDefinition, "exit") && effect.getKeyframes().some((keyframe)=>keyframe.mixBlendMode)) animations.push(new (0, $0dc55d80f8af296d$export$a361fbe706f8c9b)(animation));
                else animation.cancel();
            }
            resolve(new (0, $314f7e96d8ad6df4$export$4d0c371993b9283e)(animations));
        });
    });
}
function $c91f85dbc959387f$var$hasOpacity(target, key) {
    var _a;
    return (_a = target === null || target === void 0 ? void 0 : target[key]) === null || _a === void 0 ? void 0 : _a.keyframes.opacity;
}


/**
 * TODO:
 * - Create view transition on next tick
 * - Replace animations with Motion animations
 * - Return GroupAnimation on next tick
 */ class $c4db9f64a24b1c69$export$a25c8c3ef5e625d7 {
    constructor(update, options = {}){
        this.currentTarget = "root";
        this.targets = new Map();
        this.notifyReady = (0, $5d869bf5b7e31014$export$8793edee2d425525);
        this.readyPromise = new Promise((resolve)=>{
            this.notifyReady = resolve;
        });
        queueMicrotask(()=>{
            (0, $c91f85dbc959387f$export$43cd2edcbb51216c)(update, options, this.targets).then((animation)=>this.notifyReady(animation));
        });
    }
    get(selector) {
        this.currentTarget = selector;
        return this;
    }
    layout(keyframes, options) {
        this.updateTarget("layout", keyframes, options);
        return this;
    }
    new(keyframes, options) {
        this.updateTarget("new", keyframes, options);
        return this;
    }
    old(keyframes, options) {
        this.updateTarget("old", keyframes, options);
        return this;
    }
    enter(keyframes, options) {
        this.updateTarget("enter", keyframes, options);
        return this;
    }
    exit(keyframes, options) {
        this.updateTarget("exit", keyframes, options);
        return this;
    }
    crossfade(options) {
        this.updateTarget("enter", {
            opacity: 1
        }, options);
        this.updateTarget("exit", {
            opacity: 0
        }, options);
        return this;
    }
    updateTarget(target, keyframes, options = {}) {
        const { currentTarget: currentTarget, targets: targets } = this;
        if (!targets.has(currentTarget)) targets.set(currentTarget, {});
        const targetData = targets.get(currentTarget);
        targetData[target] = {
            keyframes: keyframes,
            options: options
        };
    }
    then(resolve, reject) {
        return this.readyPromise.then(resolve, reject);
    }
}
function $c4db9f64a24b1c69$export$c4ddc81c7b2c8d7a(update, defaultOptions = {}) {
    return new $c4db9f64a24b1c69$export$a25c8c3ef5e625d7(update, defaultOptions);
}




/**
 * Generate a list of every possible transform key.
 */ const $d552ae0de57fd093$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $d552ae0de57fd093$export$7b42a0094fb00b6e = new Set($d552ae0de57fd093$export$280dc01950909d86);


const $54fa9aefcec198bb$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $d552ae0de57fd093$export$280dc01950909d86)
]);



const $04161a9a103171f5$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $3ffe1af99bd441fd$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $3ffe1af99bd441fd$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $04161a9a103171f5$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $67a5bde6bc581381$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $735f2f1a5fe1a553$export$ce8bdc721e76545f)(value));
}
function $67a5bde6bc581381$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $71f1638127255b9d$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $3ffe1af99bd441fd$export$5485128c47bd48bb)(target[key]);
        $67a5bde6bc581381$var$setMotionValue(visualElement, key, value);
    }
}


const $b71f6c9e56e01afa$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $a72f6e0d17605284$export$98397f3adbf6259f(value) {
    return Boolean((0, $b71f6c9e56e01afa$export$605d60a2578142d3)(value) && value.add);
}


function $a36122130b835162$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $a72f6e0d17605284$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}


/**
 * Convert camelCase to dash-case properties.
 */ const $3b50b5f4e58b8bb2$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $aa94e5971c3fdaa4$export$ed7b8fa9dbf0105d = "framerAppearId";
const $aa94e5971c3fdaa4$export$8592e1c077c890a6 = "data-" + (0, $3b50b5f4e58b8bb2$export$9fd24a634729c672)($aa94e5971c3fdaa4$export$ed7b8fa9dbf0105d);


function $f7787f5932cd778a$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $aa94e5971c3fdaa4$export$8592e1c077c890a6];
}




const $360a664cb4c5651a$export$888a3d84909f9e3d = {
    current: false
};





/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $9fb3482de047dfc7$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $9fb3482de047dfc7$var$subdivisionPrecision = 0.0000001;
const $9fb3482de047dfc7$var$subdivisionMaxIterations = 12;
function $9fb3482de047dfc7$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $9fb3482de047dfc7$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $9fb3482de047dfc7$var$subdivisionPrecision && ++i < $9fb3482de047dfc7$var$subdivisionMaxIterations);
    return currentT;
}
function $9fb3482de047dfc7$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $5d869bf5b7e31014$export$8793edee2d425525;
    const getTForX = (aX)=>$9fb3482de047dfc7$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $9fb3482de047dfc7$var$calcBezier(getTForX(t), mY1, mY2);
}


// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $cb0387d3232b50b2$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $b4ba2592a9aa9d69$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $77c2afcc942e57b0$export$77edfce482316a60 = /*@__PURE__*/ (0, $9fb3482de047dfc7$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $77c2afcc942e57b0$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $b4ba2592a9aa9d69$export$2c07eeff45156d4d)($77c2afcc942e57b0$export$77edfce482316a60);
const $77c2afcc942e57b0$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $cb0387d3232b50b2$export$f946554fb8aeaf0d)($77c2afcc942e57b0$export$b01116c84cdfe1a2);


const $b45c69455df4981a$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $77c2afcc942e57b0$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $2b88f354a2a0498c$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $2b88f354a2a0498c$export$c8d67a19199d1a50 = (0, $b4ba2592a9aa9d69$export$2c07eeff45156d4d)($2b88f354a2a0498c$export$e444123e42d03385);
const $2b88f354a2a0498c$export$30d3455eee55bed5 = (0, $cb0387d3232b50b2$export$f946554fb8aeaf0d)($2b88f354a2a0498c$export$e444123e42d03385);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $63eaa8019ce2d5f9$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $5a0752c3998de980$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $63eaa8019ce2d5f9$export$ade84c85e44a6cb1)(value);
    else return true;
}



const $eea5cbf12f43c97b$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};



const $987b0d727a4f9e89$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $987b0d727a4f9e89$export$58f0f39f63f3cf42 = {
    ...$987b0d727a4f9e89$export$98e628dec113755e,
    transform: (v)=>(0, $eea5cbf12f43c97b$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $987b0d727a4f9e89$export$dcdf75081b88279d = {
    ...$987b0d727a4f9e89$export$98e628dec113755e,
    default: 1
};


// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $fdcf1d6fec77e445$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $917420d5d6439837$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $b676f516081a7ed6$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $ee852fbea06b7a81$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $474793532bdca059$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $ee852fbea06b7a81$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $b676f516081a7ed6$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $474793532bdca059$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $917420d5d6439837$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $6a6f497e7a724059$var$clampRgbUnit = (v)=>(0, $eea5cbf12f43c97b$export$7d15b64cf5a3a4c4)(0, 255, v);
const $6a6f497e7a724059$export$7a99c86b5b1f4c9e = {
    ...(0, $987b0d727a4f9e89$export$98e628dec113755e),
    transform: (v)=>Math.round($6a6f497e7a724059$var$clampRgbUnit(v))
};
const $6a6f497e7a724059$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $474793532bdca059$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $474793532bdca059$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $6a6f497e7a724059$export$7a99c86b5b1f4c9e.transform(red) + ", " + $6a6f497e7a724059$export$7a99c86b5b1f4c9e.transform(green) + ", " + $6a6f497e7a724059$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $fdcf1d6fec77e445$export$83d2e9e3e4ee39ed)((0, $987b0d727a4f9e89$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $e36aaadb6d20d80d$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $e36aaadb6d20d80d$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $474793532bdca059$export$2c8400d58aca05e)("#"),
    parse: $e36aaadb6d20d80d$var$parseHex,
    transform: (0, $6a6f497e7a724059$export$4e46ac54fc82cf3b).transform
};



const $e18c6140bf42e2cc$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $e18c6140bf42e2cc$export$41fc368e1a942b97 = /*@__PURE__*/ $e18c6140bf42e2cc$var$createUnitType("deg");
const $e18c6140bf42e2cc$export$626336c2cd4b14de = /*@__PURE__*/ $e18c6140bf42e2cc$var$createUnitType("%");
const $e18c6140bf42e2cc$export$91c0eda1d06bf008 = /*@__PURE__*/ $e18c6140bf42e2cc$var$createUnitType("px");
const $e18c6140bf42e2cc$export$f91e8c45a95a32f2 = /*@__PURE__*/ $e18c6140bf42e2cc$var$createUnitType("vh");
const $e18c6140bf42e2cc$export$aed3d7b7d206c196 = /*@__PURE__*/ $e18c6140bf42e2cc$var$createUnitType("vw");
const $e18c6140bf42e2cc$export$44e2e1705876d7ed = {
    ...$e18c6140bf42e2cc$export$626336c2cd4b14de,
    parse: (v)=>$e18c6140bf42e2cc$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$e18c6140bf42e2cc$export$626336c2cd4b14de.transform(v * 100)
};




const $c31c37e9c7c9bce8$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $474793532bdca059$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $474793532bdca059$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $e18c6140bf42e2cc$export$626336c2cd4b14de).transform((0, $fdcf1d6fec77e445$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $e18c6140bf42e2cc$export$626336c2cd4b14de).transform((0, $fdcf1d6fec77e445$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $fdcf1d6fec77e445$export$83d2e9e3e4ee39ed)((0, $987b0d727a4f9e89$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $e777867103193158$export$35e9368ef982300f = {
    test: (v)=>(0, $6a6f497e7a724059$export$4e46ac54fc82cf3b).test(v) || (0, $e36aaadb6d20d80d$export$834dfc94dde4b3d8).test(v) || (0, $c31c37e9c7c9bce8$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $6a6f497e7a724059$export$4e46ac54fc82cf3b).test(v)) return (0, $6a6f497e7a724059$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $c31c37e9c7c9bce8$export$810b04175080204c).test(v)) return (0, $c31c37e9c7c9bce8$export$810b04175080204c).parse(v);
        else return (0, $e36aaadb6d20d80d$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $6a6f497e7a724059$export$4e46ac54fc82cf3b).transform(v) : (0, $c31c37e9c7c9bce8$export$810b04175080204c).transform(v);
    }
};


const $ef64836132771b54$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $d5617791562c6f4d$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $917420d5d6439837$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $ef64836132771b54$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $d5617791562c6f4d$var$NUMBER_TOKEN = "number";
const $d5617791562c6f4d$var$COLOR_TOKEN = "color";
const $d5617791562c6f4d$var$VAR_TOKEN = "var";
const $d5617791562c6f4d$var$VAR_FUNCTION_TOKEN = "var(";
const $d5617791562c6f4d$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $d5617791562c6f4d$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $d5617791562c6f4d$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($d5617791562c6f4d$var$complexRegex, (parsedValue)=>{
        if ((0, $e777867103193158$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($d5617791562c6f4d$var$COLOR_TOKEN);
            values.push((0, $e777867103193158$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($d5617791562c6f4d$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($d5617791562c6f4d$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($d5617791562c6f4d$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $d5617791562c6f4d$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($d5617791562c6f4d$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $d5617791562c6f4d$var$parseComplexValue(v) {
    return $d5617791562c6f4d$export$b61fc7c44bf646d5(v).values;
}
function $d5617791562c6f4d$var$createTransformer(source) {
    const { split: split, types: types } = $d5617791562c6f4d$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $d5617791562c6f4d$var$NUMBER_TOKEN) output += (0, $fdcf1d6fec77e445$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $d5617791562c6f4d$var$COLOR_TOKEN) output += (0, $e777867103193158$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $d5617791562c6f4d$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $d5617791562c6f4d$var$getAnimatableNone(v) {
    const parsed = $d5617791562c6f4d$var$parseComplexValue(v);
    const transformer = $d5617791562c6f4d$var$createTransformer(v);
    return transformer(parsed.map($d5617791562c6f4d$var$convertNumbersToZero));
}
const $d5617791562c6f4d$export$83a0e34f1302825b = {
    test: $d5617791562c6f4d$var$test,
    parse: $d5617791562c6f4d$var$parseComplexValue,
    createTransformer: $d5617791562c6f4d$var$createTransformer,
    getAnimatableNone: $d5617791562c6f4d$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $2dd1b754a52afb1d$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $2dd1b754a52afb1d$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $917420d5d6439837$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $2dd1b754a52afb1d$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $2dd1b754a52afb1d$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $2dd1b754a52afb1d$export$3dea766d36a8935f = {
    ...(0, $d5617791562c6f4d$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($2dd1b754a52afb1d$var$functionRegex);
        return functions ? functions.map($2dd1b754a52afb1d$var$applyDefaultFilter).join(" ") : v;
    }
};







const $ff9502711c6c7ba7$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    borderTopWidth: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    borderRightWidth: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    borderRadius: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    radius: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    maxWidth: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    height: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    maxHeight: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    top: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    right: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    bottom: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    left: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    paddingTop: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    paddingRight: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    paddingBottom: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    paddingLeft: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    margin: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    marginTop: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    marginRight: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    marginBottom: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    marginLeft: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008)
};




const $8ac00b03d9635e81$export$f2e4285fee37e26 = {
    rotate: (0, $e18c6140bf42e2cc$export$41fc368e1a942b97),
    rotateX: (0, $e18c6140bf42e2cc$export$41fc368e1a942b97),
    rotateY: (0, $e18c6140bf42e2cc$export$41fc368e1a942b97),
    rotateZ: (0, $e18c6140bf42e2cc$export$41fc368e1a942b97),
    scale: $987b0d727a4f9e89$export$dcdf75081b88279d,
    scaleX: (0, $987b0d727a4f9e89$export$dcdf75081b88279d),
    scaleY: (0, $987b0d727a4f9e89$export$dcdf75081b88279d),
    scaleZ: (0, $987b0d727a4f9e89$export$dcdf75081b88279d),
    skew: (0, $e18c6140bf42e2cc$export$41fc368e1a942b97),
    skewX: (0, $e18c6140bf42e2cc$export$41fc368e1a942b97),
    skewY: (0, $e18c6140bf42e2cc$export$41fc368e1a942b97),
    distance: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    translateX: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    translateY: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    translateZ: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    x: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    y: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    z: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    perspective: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    transformPerspective: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    opacity: (0, $987b0d727a4f9e89$export$58f0f39f63f3cf42),
    originX: (0, $e18c6140bf42e2cc$export$44e2e1705876d7ed),
    originY: (0, $e18c6140bf42e2cc$export$44e2e1705876d7ed),
    originZ: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008)
};



const $bc83181139240571$export$7d260a2a5f8bc19e = {
    ...(0, $987b0d727a4f9e89$export$98e628dec113755e),
    transform: Math.round
};


const $6d969a5b0b148ec5$export$eec14432cd1cb67b = {
    ...(0, $ff9502711c6c7ba7$export$2fb74b0a4e7d7c4a),
    ...(0, $8ac00b03d9635e81$export$f2e4285fee37e26),
    zIndex: (0, $bc83181139240571$export$7d260a2a5f8bc19e),
    size: (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $987b0d727a4f9e89$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $987b0d727a4f9e89$export$58f0f39f63f3cf42),
    numOctaves: (0, $bc83181139240571$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $2d99f37764fc545c$export$98cd7c72c5a731fb = {
    ...(0, $6d969a5b0b148ec5$export$eec14432cd1cb67b),
    color: // Color props
    $e777867103193158$export$35e9368ef982300f,
    backgroundColor: (0, $e777867103193158$export$35e9368ef982300f),
    outlineColor: (0, $e777867103193158$export$35e9368ef982300f),
    fill: (0, $e777867103193158$export$35e9368ef982300f),
    stroke: (0, $e777867103193158$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $e777867103193158$export$35e9368ef982300f),
    borderTopColor: (0, $e777867103193158$export$35e9368ef982300f),
    borderRightColor: (0, $e777867103193158$export$35e9368ef982300f),
    borderBottomColor: (0, $e777867103193158$export$35e9368ef982300f),
    borderLeftColor: (0, $e777867103193158$export$35e9368ef982300f),
    filter: $2dd1b754a52afb1d$export$3dea766d36a8935f,
    WebkitFilter: (0, $2dd1b754a52afb1d$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $2d99f37764fc545c$export$67d1babe0338d23b = (key)=>$2d99f37764fc545c$export$98cd7c72c5a731fb[key];


function $e04d7e0eabad2ed4$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $2d99f37764fc545c$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $2dd1b754a52afb1d$export$3dea766d36a8935f)) defaultValueType = (0, $d5617791562c6f4d$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $e858c4832548278d$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $e858c4832548278d$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$e858c4832548278d$var$invalidTemplates.has(keyframe) && (0, $d5617791562c6f4d$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $e04d7e0eabad2ed4$export$cea0cedcb94873b5)(name, animatableTemplate);
}






const $742823ccddbbb2fb$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $742823ccddbbb2fb$var$rotate = (v)=>{
    const angle = $742823ccddbbb2fb$var$radToDeg(Math.atan2(v[1], v[0]));
    return $742823ccddbbb2fb$var$rebaseAngle(angle);
};
const $742823ccddbbb2fb$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $742823ccddbbb2fb$var$rotate,
    rotateZ: $742823ccddbbb2fb$var$rotate,
    skewX: (v)=>$742823ccddbbb2fb$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$742823ccddbbb2fb$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $742823ccddbbb2fb$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $742823ccddbbb2fb$var$rotateZ = $742823ccddbbb2fb$var$rotate;
const $742823ccddbbb2fb$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $742823ccddbbb2fb$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $742823ccddbbb2fb$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $742823ccddbbb2fb$var$scaleX,
    scaleY: $742823ccddbbb2fb$var$scaleY,
    scale: (v)=>($742823ccddbbb2fb$var$scaleX(v) + $742823ccddbbb2fb$var$scaleY(v)) / 2,
    rotateX: (v)=>$742823ccddbbb2fb$var$rebaseAngle($742823ccddbbb2fb$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$742823ccddbbb2fb$var$rebaseAngle($742823ccddbbb2fb$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $742823ccddbbb2fb$var$rotateZ,
    rotate: $742823ccddbbb2fb$var$rotateZ,
    skewX: (v)=>$742823ccddbbb2fb$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$742823ccddbbb2fb$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $742823ccddbbb2fb$var$defaultTransformValue(name) {
    return name.includes("scale") ? 1 : 0;
}
function $742823ccddbbb2fb$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $742823ccddbbb2fb$var$defaultTransformValue(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $742823ccddbbb2fb$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $742823ccddbbb2fb$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $742823ccddbbb2fb$var$defaultTransformValue(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($742823ccddbbb2fb$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $742823ccddbbb2fb$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $742823ccddbbb2fb$export$f9111f9e16b73a26(transform, name);
};
function $742823ccddbbb2fb$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}


const $1196a6860d72e03d$export$8e5250d1aa9bf370 = (v)=>v === (0, $987b0d727a4f9e89$export$98e628dec113755e) || v === (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008);
const $1196a6860d72e03d$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $1196a6860d72e03d$var$nonTranslationalTransformKeys = (0, $d552ae0de57fd093$export$280dc01950909d86).filter((key)=>!$1196a6860d72e03d$var$transformKeys.has(key));
function $1196a6860d72e03d$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $1196a6860d72e03d$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $1196a6860d72e03d$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $742823ccddbbb2fb$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $742823ccddbbb2fb$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$1196a6860d72e03d$export$781d46a8aa670d52.translateX = $1196a6860d72e03d$export$781d46a8aa670d52.x;
$1196a6860d72e03d$export$781d46a8aa670d52.translateY = $1196a6860d72e03d$export$781d46a8aa670d52.y;


const $885fd3b0e5f1cbf9$var$toResolve = new Set();
let $885fd3b0e5f1cbf9$var$isScheduled = false;
let $885fd3b0e5f1cbf9$var$anyNeedsMeasurement = false;
function $885fd3b0e5f1cbf9$var$measureAllKeyframes() {
    if ($885fd3b0e5f1cbf9$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($885fd3b0e5f1cbf9$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $1196a6860d72e03d$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $885fd3b0e5f1cbf9$var$anyNeedsMeasurement = false;
    $885fd3b0e5f1cbf9$var$isScheduled = false;
    $885fd3b0e5f1cbf9$var$toResolve.forEach((resolver)=>resolver.complete());
    $885fd3b0e5f1cbf9$var$toResolve.clear();
}
function $885fd3b0e5f1cbf9$var$readAllKeyframes() {
    $885fd3b0e5f1cbf9$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $885fd3b0e5f1cbf9$var$anyNeedsMeasurement = true;
    });
}
function $885fd3b0e5f1cbf9$export$78b96d2a12593b05() {
    $885fd3b0e5f1cbf9$var$readAllKeyframes();
    $885fd3b0e5f1cbf9$var$measureAllKeyframes();
}
class $885fd3b0e5f1cbf9$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $885fd3b0e5f1cbf9$var$toResolve.add(this);
            if (!$885fd3b0e5f1cbf9$var$isScheduled) {
                $885fd3b0e5f1cbf9$var$isScheduled = true;
                (0, $153ac5076757d0fe$export$2cef06c20297c17d).read($885fd3b0e5f1cbf9$var$readAllKeyframes);
                (0, $153ac5076757d0fe$export$2cef06c20297c17d).resolveKeyframes($885fd3b0e5f1cbf9$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $885fd3b0e5f1cbf9$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $885fd3b0e5f1cbf9$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}



/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $24342c27c7cce494$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


const $8b31393e88a7536d$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $8b31393e88a7536d$export$9de1236619d9e756 = /*@__PURE__*/ $8b31393e88a7536d$var$checkStringStartsWith("--");
const $8b31393e88a7536d$var$startsAsVariableToken = /*@__PURE__*/ $8b31393e88a7536d$var$checkStringStartsWith("var(--");
const $8b31393e88a7536d$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $8b31393e88a7536d$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $8b31393e88a7536d$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $8b31393e88a7536d$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $9dad2df2a2eb8c84$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $9dad2df2a2eb8c84$export$b9f0c1f373aee2b0(current) {
    const match = $9dad2df2a2eb8c84$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $9dad2df2a2eb8c84$var$maxDepth = 4;
function $9dad2df2a2eb8c84$export$289398774300c991(current, element, depth = 1) {
    (0, $f6c3d1780c7f8ff9$export$f5708dca728d7177)(depth <= $9dad2df2a2eb8c84$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $9dad2df2a2eb8c84$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $24342c27c7cce494$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $8b31393e88a7536d$export$31f9caa2600b5723)(fallback) ? $9dad2df2a2eb8c84$export$289398774300c991(fallback, element, depth + 1) : fallback;
}






/**
 * Tests a provided value against a ValueType
 */ const $333eec5e2cdb2e0b$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $50935f6f27c2f14f$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $7f281c484af60633$export$d176691c1998a1f5 = [
    (0, $987b0d727a4f9e89$export$98e628dec113755e),
    (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008),
    (0, $e18c6140bf42e2cc$export$626336c2cd4b14de),
    (0, $e18c6140bf42e2cc$export$41fc368e1a942b97),
    (0, $e18c6140bf42e2cc$export$aed3d7b7d206c196),
    (0, $e18c6140bf42e2cc$export$f91e8c45a95a32f2),
    (0, $50935f6f27c2f14f$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $7f281c484af60633$export$eefdd52e3ccae428 = (v)=>$7f281c484af60633$export$d176691c1998a1f5.find((0, $333eec5e2cdb2e0b$export$6eae4d0a6a7ca7cd)(v));


class $17d31589e5f469ad$export$4983792d11b61017 extends (0, $885fd3b0e5f1cbf9$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $8b31393e88a7536d$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $9dad2df2a2eb8c84$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $54fa9aefcec198bb$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $7f281c484af60633$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $7f281c484af60633$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $1196a6860d72e03d$export$8e5250d1aa9bf370)(originType) && (0, $1196a6860d72e03d$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $5a0752c3998de980$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $e858c4832548278d$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $1196a6860d72e03d$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $1196a6860d72e03d$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}








/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $84123af7171cadf8$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $d5617791562c6f4d$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $d490c930361f4ca2$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $d490c930361f4ca2$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $84123af7171cadf8$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $84123af7171cadf8$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $f6c3d1780c7f8ff9$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $d490c930361f4ca2$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $6f99742e6f7262c4$export$6ab7812f1bac68be)(type)) && velocity;
}


const $67cc5e4362df6d13$var$isNotNull = (value)=>value !== null;
function $67cc5e4362df6d13$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($67cc5e4362df6d13$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $f348b8a069fc0d82$var$MAX_RESOLVE_DELAY = 40;
class $f348b8a069fc0d82$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $8fa0eb8b37097f3c$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $f348b8a069fc0d82$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $885fd3b0e5f1cbf9$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $8fa0eb8b37097f3c$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $d490c930361f4ca2$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $360a664cb4c5651a$export$888a3d84909f9e3d).current || !delay) {
                onUpdate && onUpdate((0, $67cc5e4362df6d13$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete && onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    flatten() {
        if (!this.options.allowFlatten) return;
        this.options.type = "keyframes";
        this.options.ease = "linear";
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}






/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $1e171c617f2ae46b$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $1e171c617f2ae46b$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $1e171c617f2ae46b$var$hueToRgb(p, q, hue + 1 / 3);
        green = $1e171c617f2ae46b$var$hueToRgb(p, q, hue);
        blue = $1e171c617f2ae46b$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $622d0fe333cd3a6c$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $c381fcad2a709041$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $c381fcad2a709041$var$colorTypes = [
    (0, $e36aaadb6d20d80d$export$834dfc94dde4b3d8),
    (0, $6a6f497e7a724059$export$4e46ac54fc82cf3b),
    (0, $c31c37e9c7c9bce8$export$810b04175080204c)
];
const $c381fcad2a709041$var$getColorType = (v)=>$c381fcad2a709041$var$colorTypes.find((type)=>type.test(v));
function $c381fcad2a709041$var$asRGBA(color) {
    const type = $c381fcad2a709041$var$getColorType(color);
    (0, $f6c3d1780c7f8ff9$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $c31c37e9c7c9bce8$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $1e171c617f2ae46b$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $c381fcad2a709041$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $c381fcad2a709041$var$asRGBA(from);
    const toRGBA = $c381fcad2a709041$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $622d0fe333cd3a6c$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $c381fcad2a709041$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $c381fcad2a709041$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $c381fcad2a709041$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $6a6f497e7a724059$export$4e46ac54fc82cf3b).transform(blended);
    };
};


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $13c7fc820f1beb48$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $13c7fc820f1beb48$export$a4627e546088548d = (...transformers)=>transformers.reduce($13c7fc820f1beb48$var$combineFunctions);






const $cdf4f4a460ac058d$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $cdf4f4a460ac058d$export$fed62ccc3fb1a568(origin, target) {
    if ($cdf4f4a460ac058d$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $0b19f62ba975d507$var$mixNumber(a, b) {
    return (p)=>(0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $0b19f62ba975d507$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $0b19f62ba975d507$var$mixNumber;
    else if (typeof a === "string") return (0, $8b31393e88a7536d$export$31f9caa2600b5723)(a) ? (0, $622d0fe333cd3a6c$export$a6f92d4bae65c0f1) : (0, $e777867103193158$export$35e9368ef982300f).test(a) ? (0, $c381fcad2a709041$export$51e568cf5c039bac) : $0b19f62ba975d507$export$65516310a87d8205;
    else if (Array.isArray(a)) return $0b19f62ba975d507$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $e777867103193158$export$35e9368ef982300f).test(a) ? (0, $c381fcad2a709041$export$51e568cf5c039bac) : $0b19f62ba975d507$export$ebc23b6840c51ba1;
    return 0, $622d0fe333cd3a6c$export$a6f92d4bae65c0f1;
}
function $0b19f62ba975d507$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$0b19f62ba975d507$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $0b19f62ba975d507$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $0b19f62ba975d507$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $0b19f62ba975d507$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $0b19f62ba975d507$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $d5617791562c6f4d$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $d5617791562c6f4d$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $d5617791562c6f4d$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $cdf4f4a460ac058d$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $cdf4f4a460ac058d$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $cdf4f4a460ac058d$export$fed62ccc3fb1a568)(origin, target);
        return (0, $13c7fc820f1beb48$export$a4627e546088548d)($0b19f62ba975d507$export$3bbefa2f402845c4($0b19f62ba975d507$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $f6c3d1780c7f8ff9$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $622d0fe333cd3a6c$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $54e7e890f9f6d955$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $0b19f62ba975d507$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}







const $c1160806d11e94ab$var$velocitySampleDuration = 5; // ms
function $c1160806d11e94ab$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $c1160806d11e94ab$var$velocitySampleDuration, 0);
    return (0, $1e7f112201d564c5$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $e6303fbed1a3b2a5$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};





const $6022946b566b488b$var$safeMin = 0.001;
function $6022946b566b488b$export$b15f158dc6d6f458({ duration: duration = (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).duration, bounce: bounce = (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).bounce, velocity: velocity = (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).velocity, mass: mass = (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).mass }) {
    let envelope;
    let derivative;
    (0, $f6c3d1780c7f8ff9$export$491112666e282270)(duration <= (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)((0, $e6303fbed1a3b2a5$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $eea5cbf12f43c97b$export$7d15b64cf5a3a4c4)((0, $e6303fbed1a3b2a5$export$86436497e7b05d16).minDamping, (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $eea5cbf12f43c97b$export$7d15b64cf5a3a4c4)((0, $e6303fbed1a3b2a5$export$86436497e7b05d16).minDuration, (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).maxDuration, (0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $6022946b566b488b$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $6022946b566b488b$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $6022946b566b488b$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $6022946b566b488b$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$6022946b566b488b$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $6022946b566b488b$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).stiffness,
        damping: (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $6022946b566b488b$var$rootIterations = 12;
function $6022946b566b488b$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $6022946b566b488b$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $6022946b566b488b$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $1e823635bb2f8a17$var$durationKeys = [
    "duration",
    "bounce"
];
const $1e823635bb2f8a17$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $1e823635bb2f8a17$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $1e823635bb2f8a17$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).velocity,
        stiffness: (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).stiffness,
        damping: (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).damping,
        mass: (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$1e823635bb2f8a17$var$isSpringType(options, $1e823635bb2f8a17$var$physicsKeys) && $1e823635bb2f8a17$var$isSpringType(options, $1e823635bb2f8a17$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $eea5cbf12f43c97b$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $6022946b566b488b$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $1e823635bb2f8a17$export$b36281d89752ae66(optionsOrVisualDuration = (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).visualDuration, bounce = (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $1e823635bb2f8a17$var$getSpringOptions({
        ...options,
        velocity: -(0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).restSpeed.granular : (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).restDelta.granular : (0, $e6303fbed1a3b2a5$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $6022946b566b488b$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $c1160806d11e94ab$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $72aef2dce0c959c8$export$cbdd6b3d40ea54e2)(generator), (0, $72aef2dce0c959c8$export$f4ff70a5b4808fd8));
            const easing = (0, $a60388297ed1e724$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        }
    };
    return generator;
}



function $1a2c904ee5c11db8$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $1e823635bb2f8a17$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $c1160806d11e94ab$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $c6fa4f6778033ecb$export$929e5a82286172a6 = /*@__PURE__*/ (0, $9fb3482de047dfc7$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $c6fa4f6778033ecb$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $9fb3482de047dfc7$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $c6fa4f6778033ecb$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $9fb3482de047dfc7$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $55e53ca96de283d8$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};









const $0114f4fb90a023b9$var$easingLookup = {
    linear: (0, $5d869bf5b7e31014$export$8793edee2d425525),
    easeIn: $c6fa4f6778033ecb$export$929e5a82286172a6,
    easeInOut: $c6fa4f6778033ecb$export$c07234257a03d5e9,
    easeOut: $c6fa4f6778033ecb$export$57636bb43b1ccbb0,
    circIn: $2b88f354a2a0498c$export$e444123e42d03385,
    circInOut: $2b88f354a2a0498c$export$30d3455eee55bed5,
    circOut: $2b88f354a2a0498c$export$c8d67a19199d1a50,
    backIn: $77c2afcc942e57b0$export$b01116c84cdfe1a2,
    backInOut: $77c2afcc942e57b0$export$ddc5fd596f6c71b2,
    backOut: $77c2afcc942e57b0$export$77edfce482316a60,
    anticipate: $b45c69455df4981a$export$6b0af63b873d419e
};
const $0114f4fb90a023b9$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $ee7f744bb4237d91$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $f6c3d1780c7f8ff9$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $9fb3482de047dfc7$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $f6c3d1780c7f8ff9$export$f5708dca728d7177)($0114f4fb90a023b9$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $0114f4fb90a023b9$var$easingLookup[definition];
    }
    return definition;
};






function $b54b8ff05fff6749$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $54e7e890f9f6d955$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $5d869bf5b7e31014$export$8793edee2d425525) : ease;
            mixer = (0, $13c7fc820f1beb48$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $b54b8ff05fff6749$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $f6c3d1780c7f8ff9$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $b54b8ff05fff6749$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $483094981a1afc3a$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $eea5cbf12f43c97b$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $00fd58cb2c1fe694$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $483094981a1afc3a$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $40c48f154e7f8609$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $00fd58cb2c1fe694$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $085834524a0c7726$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $5f8c13d2a79c42b7$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c6fa4f6778033ecb$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $5f8c13d2a79c42b7$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $55e53ca96de283d8$export$216948827bbdc797)(ease) ? ease.map((0, $0114f4fb90a023b9$export$ef97fe084f156ca4)) : (0, $0114f4fb90a023b9$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $085834524a0c7726$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $40c48f154e7f8609$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $b54b8ff05fff6749$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $5f8c13d2a79c42b7$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





const $c8d4940266136b94$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $153ac5076757d0fe$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $153ac5076757d0fe$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $153ac5076757d0fe$export$fff89137e9e818ce).isProcessing ? (0, $153ac5076757d0fe$export$fff89137e9e818ce).timestamp : (0, $8fa0eb8b37097f3c$export$2da9be4cfdb689b1).now()
    };
};



const $fcd94b29fa11edb0$var$generators = {
    decay: (0, $1a2c904ee5c11db8$export$ee3ff3a17106998),
    inertia: $1a2c904ee5c11db8$export$ee3ff3a17106998,
    tween: (0, $5f8c13d2a79c42b7$export$d25ddfdf17c3ad3e),
    keyframes: (0, $5f8c13d2a79c42b7$export$d25ddfdf17c3ad3e),
    spring: $1e823635bb2f8a17$export$b36281d89752ae66
};
const $fcd94b29fa11edb0$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $fcd94b29fa11edb0$export$fd98d9cca67a58bc extends (0, $f348b8a069fc0d82$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $885fd3b0e5f1cbf9$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    flatten() {
        super.flatten();
        // If we've already resolved the animation, re-initialise it
        if (this._resolved) Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = (0, $6f99742e6f7262c4$export$6ab7812f1bac68be)(type) ? type : $fcd94b29fa11edb0$var$generators[type] || (0, $5f8c13d2a79c42b7$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $5f8c13d2a79c42b7$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $13c7fc820f1beb48$export$a4627e546088548d)($fcd94b29fa11edb0$var$percentToProgress, (0, $54e7e890f9f6d955$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $72aef2dce0c959c8$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        (0, $bed173d670311b7b$export$d921fb2475e2900c).mainThread++;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $eea5cbf12f43c97b$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $67cc5e4362df6d13$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $c8d4940266136b94$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
        (0, $bed173d670311b7b$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $fcd94b29fa11edb0$export$ee9b76de7353d815(options) {
    return new $fcd94b29fa11edb0$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $175b1a7e2462d237$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);



function $c5d1a4c480da05fd$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeInOut", times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $cda7ad74a3797f3a$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $d35bb1a817255f19$export$84ce9a476f53d110).value) (0, $bed173d670311b7b$export$d921fb2475e2900c).waapi++;
    const animation = element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
    if ((0, $d35bb1a817255f19$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $bed173d670311b7b$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}




const $02c482714379d1c9$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $1db93006ee53587a$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $711cf5ba023b2926$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $711cf5ba023b2926$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $711cf5ba023b2926$var$requiresPregeneratedKeyframes(options) {
    return (0, $6f99742e6f7262c4$export$6ab7812f1bac68be)(options.type) || options.type === "spring" || !(0, $cda7ad74a3797f3a$export$fcdd8f3f2160beda)(options.ease);
}
function $711cf5ba023b2926$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $fcd94b29fa11edb0$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $711cf5ba023b2926$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $711cf5ba023b2926$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $711cf5ba023b2926$var$sampleDelta,
        ease: "linear"
    };
}
const $711cf5ba023b2926$var$unsupportedEasingFunctions = {
    anticipate: $b45c69455df4981a$export$6b0af63b873d419e,
    backInOut: $77c2afcc942e57b0$export$ddc5fd596f6c71b2,
    circInOut: $2b88f354a2a0498c$export$30d3455eee55bed5
};
function $711cf5ba023b2926$var$isUnsupportedEase(key) {
    return key in $711cf5ba023b2926$var$unsupportedEasingFunctions;
}
class $711cf5ba023b2926$export$2a45abb4e6513325 extends (0, $f348b8a069fc0d82$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $17d31589e5f469ad$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!motionValue.owner || !motionValue.owner.current) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $9a7b7d1e08229c2a$export$866c1d07a1ac2ab)() && $711cf5ba023b2926$var$isUnsupportedEase(ease)) ease = $711cf5ba023b2926$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($711cf5ba023b2926$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $711cf5ba023b2926$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $c5d1a4c480da05fd$export$d896de52f97cb615)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $1892622a42edf7f1$export$5bd0fcbc73622e13)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $67cc5e4362df6d13$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $5d869bf5b7e31014$export$8793edee2d425525;
            const { animation: animation } = resolved;
            (0, $1892622a42edf7f1$export$5bd0fcbc73622e13)(animation, timeline);
        }
        return 0, $5d869bf5b7e31014$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $fcd94b29fa11edb0$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $711cf5ba023b2926$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $711cf5ba023b2926$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        if (!motionValue || !motionValue.owner || !(motionValue.owner.current instanceof HTMLElement)) return false;
        const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
        return (0, $02c482714379d1c9$export$51ea9b46fb7a8c5d)() && name && (0, $175b1a7e2462d237$export$a27eefbd8fb5e404).has(name) && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !onUpdate && !transformTemplate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}





const $b5af62004a313267$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $b5af62004a313267$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $b5af62004a313267$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $b5af62004a313267$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $b5af62004a313267$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $b5af62004a313267$var$keyframesTransition;
    else if ((0, $d552ae0de57fd093$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $b5af62004a313267$var$criticallyDampedSpring(keyframes[1]) : $b5af62004a313267$var$underDampedSpring;
    return $b5af62004a313267$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $b75c7cf69e3cf4f0$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


const $72929d0b87b6a468$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $b8f540ed65e01b25$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $b75c7cf69e3cf4f0$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $b5af62004a313267$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $360a664cb4c5651a$export$888a3d84909f9e3d).current || (0, $dbb240237456a315$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $67cc5e4362df6d13$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $153ac5076757d0fe$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $7d48114fece9e632$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $711cf5ba023b2926$export$2a45abb4e6513325).supports(options)) return new (0, $711cf5ba023b2926$export$2a45abb4e6513325)(options);
        else return new (0, $fcd94b29fa11edb0$export$fd98d9cca67a58bc)(options);
    };


/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $04c4c8d26bb18f7e$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $04c4c8d26bb18f7e$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $04c4c8d26bb18f7e$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $b8f540ed65e01b25$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $f7787f5932cd778a$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $153ac5076757d0fe$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $a36122130b835162$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $72929d0b87b6a468$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $54fa9aefcec198bb$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $153ac5076757d0fe$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $67a5bde6bc581381$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $0e36fbe3528acb5b$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $71f1638127255b9d$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $04c4c8d26bb18f7e$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $0e36fbe3528acb5b$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $0e36fbe3528acb5b$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($0e36fbe3528acb5b$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($0e36fbe3528acb5b$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $0e36fbe3528acb5b$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $85563ec7392a9681$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $0e36fbe3528acb5b$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $0e36fbe3528acb5b$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $71f1638127255b9d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $04c4c8d26bb18f7e$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}




function $33ebe3116bab65af$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $a1cc7c7d5fedb08f$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $c34459889ad5228e$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $c34459889ad5228e$export$1405a65085f40b9 = [
    "initial",
    ...$c34459889ad5228e$export$16e45afcc206d3a8
];


const $40cbdc22400ac840$var$numVariantProps = (0, $c34459889ad5228e$export$1405a65085f40b9).length;
function $40cbdc22400ac840$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $40cbdc22400ac840$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $40cbdc22400ac840$var$numVariantProps; i++){
        const name = (0, $c34459889ad5228e$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $a1cc7c7d5fedb08f$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}





const $c340042a5602de29$var$reversePriorityOrder = [
    ...(0, $c34459889ad5228e$export$16e45afcc206d3a8)
].reverse();
const $c340042a5602de29$var$numAnimationTypes = (0, $c34459889ad5228e$export$16e45afcc206d3a8).length;
function $c340042a5602de29$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $85563ec7392a9681$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $c340042a5602de29$export$bb53502b7a672aa8(visualElement) {
    let animate = $c340042a5602de29$var$animateList(visualElement);
    let state = $c340042a5602de29$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $71f1638127255b9d$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $40cbdc22400ac840$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $c340042a5602de29$var$numAnimationTypes; i++){
            const type = $c340042a5602de29$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $a1cc7c7d5fedb08f$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $b37798457ef74195$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $c340042a5602de29$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $04161a9a103171f5$export$9153ad4c4999f4a0)(next) && (0, $04161a9a103171f5$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $33ebe3116bab65af$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $71f1638127255b9d$export$7b1b1c981f4f0558)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $c340042a5602de29$var$createState();
            isInitialRender = true;
        }
    };
}
function $c340042a5602de29$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $33ebe3116bab65af$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $c340042a5602de29$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $c340042a5602de29$var$createState() {
    return {
        animate: $c340042a5602de29$var$createTypeState(true),
        whileInView: $c340042a5602de29$var$createTypeState(),
        whileHover: $c340042a5602de29$var$createTypeState(),
        whileTap: $c340042a5602de29$var$createTypeState(),
        whileDrag: $c340042a5602de29$var$createTypeState(),
        whileFocus: $c340042a5602de29$var$createTypeState(),
        exit: $c340042a5602de29$var$createTypeState()
    };
}


class $44c9f8ee479fe99e$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $4b7a2a7b4ab0fd09$export$b45b3fe5caabdca extends (0, $44c9f8ee479fe99e$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $c340042a5602de29$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $b37798457ef74195$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $717a5ca6c4df16ad$var$id = 0;
class $717a5ca6c4df16ad$export$4989d1eb6104cc6c extends (0, $44c9f8ee479fe99e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $717a5ca6c4df16ad$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $b9d39d7c57d5f6b5$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $4b7a2a7b4ab0fd09$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $717a5ca6c4df16ad$export$4989d1eb6104cc6c)
    }
};







function $6d8a6e367a53f8d7$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}




function $3f3fdffc5c959b77$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $3f3fdffc5c959b77$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $09d80ff1af4e2a66$export$a4cf9c8a4b063a6e)(event) && handler(event, $3f3fdffc5c959b77$export$12f84bb882d06e1a(event));
};


function $bb22ae81b44b6685$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $6d8a6e367a53f8d7$export$b1d829ddf82884aa)(target, eventName, (0, $3f3fdffc5c959b77$export$c404e80f92c98d29)(handler), options);
}



/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $bc436f258404da72$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $bc436f258404da72$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $bc436f258404da72$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



const $72fe8a0bcc14ccca$var$SCALE_PRECISION = 0.0001;
const $72fe8a0bcc14ccca$var$SCALE_MIN = 1 - $72fe8a0bcc14ccca$var$SCALE_PRECISION;
const $72fe8a0bcc14ccca$var$SCALE_MAX = 1 + $72fe8a0bcc14ccca$var$SCALE_PRECISION;
const $72fe8a0bcc14ccca$var$TRANSLATE_PRECISION = 0.01;
const $72fe8a0bcc14ccca$var$TRANSLATE_MIN = 0 - $72fe8a0bcc14ccca$var$TRANSLATE_PRECISION;
const $72fe8a0bcc14ccca$var$TRANSLATE_MAX = 0 + $72fe8a0bcc14ccca$var$TRANSLATE_PRECISION;
function $72fe8a0bcc14ccca$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $72fe8a0bcc14ccca$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $72fe8a0bcc14ccca$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $72fe8a0bcc14ccca$export$c1c127004b72a37(target) / $72fe8a0bcc14ccca$export$c1c127004b72a37(source);
    delta.translate = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $72fe8a0bcc14ccca$var$SCALE_MIN && delta.scale <= $72fe8a0bcc14ccca$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $72fe8a0bcc14ccca$var$TRANSLATE_MIN && delta.translate <= $72fe8a0bcc14ccca$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $72fe8a0bcc14ccca$export$c0d25e96fc67d310(delta, source, target, origin) {
    $72fe8a0bcc14ccca$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $72fe8a0bcc14ccca$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $72fe8a0bcc14ccca$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $72fe8a0bcc14ccca$export$c1c127004b72a37(relative);
}
function $72fe8a0bcc14ccca$export$426154f9d100f99(target, relative, parent) {
    $72fe8a0bcc14ccca$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $72fe8a0bcc14ccca$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $72fe8a0bcc14ccca$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $72fe8a0bcc14ccca$export$c1c127004b72a37(layout);
}
function $72fe8a0bcc14ccca$export$2785bfcc929c5650(target, layout, parent) {
    $72fe8a0bcc14ccca$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $72fe8a0bcc14ccca$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}


const $10c424f93d7dba80$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $10c424f93d7dba80$export$3d227df54007d73a = ()=>({
        x: $10c424f93d7dba80$export$ff25708b37f72782(),
        y: $10c424f93d7dba80$export$ff25708b37f72782()
    });
const $10c424f93d7dba80$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $10c424f93d7dba80$export$6459fc9e86be362e = ()=>({
        x: $10c424f93d7dba80$export$6db76765312617ac(),
        y: $10c424f93d7dba80$export$6db76765312617ac()
    });


function $74c495ef5148912f$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}




function $60d46afc048fe110$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $60d46afc048fe110$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$60d46afc048fe110$var$isIdentityScale(scale) || !$60d46afc048fe110$var$isIdentityScale(scaleX) || !$60d46afc048fe110$var$isIdentityScale(scaleY);
}
function $60d46afc048fe110$export$a545127cf1fbb600(values) {
    return $60d46afc048fe110$export$bdf30dca883ea463(values) || $60d46afc048fe110$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $60d46afc048fe110$export$bf80f5f8f4dc327f(values) {
    return $60d46afc048fe110$var$is2DTranslate(values.x) || $60d46afc048fe110$var$is2DTranslate(values.y);
}
function $60d46afc048fe110$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $2320bec329eac7c3$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $2320bec329eac7c3$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $2320bec329eac7c3$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $2320bec329eac7c3$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $2320bec329eac7c3$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $2320bec329eac7c3$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $2320bec329eac7c3$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $2320bec329eac7c3$export$d80074982803af5c(box, { x: x, y: y }) {
    $2320bec329eac7c3$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $2320bec329eac7c3$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $2320bec329eac7c3$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $2320bec329eac7c3$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $2320bec329eac7c3$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $2320bec329eac7c3$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $2320bec329eac7c3$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $60d46afc048fe110$export$a545127cf1fbb600)(node.latestValues)) $2320bec329eac7c3$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $2320bec329eac7c3$var$TREE_SCALE_SNAP_MAX && treeScale.x > $2320bec329eac7c3$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $2320bec329eac7c3$var$TREE_SCALE_SNAP_MAX && treeScale.y > $2320bec329eac7c3$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $2320bec329eac7c3$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $2320bec329eac7c3$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $2320bec329eac7c3$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $2320bec329eac7c3$export$58b16271041fbfb(box, transform) {
    $2320bec329eac7c3$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $2320bec329eac7c3$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $facb3467d71d9801$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $bc436f258404da72$export$d3955c6a8f65a36b)((0, $bc436f258404da72$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $facb3467d71d9801$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $facb3467d71d9801$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $2320bec329eac7c3$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $2320bec329eac7c3$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}


// Fixes https://github.com/motiondivision/motion/issues/2270
const $20d9edb8d4a1499c$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};


function $3c2af749636abbc7$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}









const $0daca1d8fd6273e6$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $0daca1d8fd6273e6$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $0daca1d8fd6273e6$export$9f17032d917177de(a.x, b.x);
    const yDelta = $0daca1d8fd6273e6$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}



/**
 * @internal
 */ class $9f6a283fc9984ed5$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $9f6a283fc9984ed5$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $0daca1d8fd6273e6$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $153ac5076757d0fe$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $9f6a283fc9984ed5$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $153ac5076757d0fe$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $9f6a283fc9984ed5$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $9f6a283fc9984ed5$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $09d80ff1af4e2a66$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $3f3fdffc5c959b77$export$12f84bb882d06e1a)(event);
        const initialInfo = $9f6a283fc9984ed5$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $153ac5076757d0fe$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $9f6a283fc9984ed5$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $13c7fc820f1beb48$export$a4627e546088548d)((0, $bb22ae81b44b6685$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $bb22ae81b44b6685$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $bb22ae81b44b6685$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $153ac5076757d0fe$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $9f6a283fc9984ed5$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $9f6a283fc9984ed5$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $9f6a283fc9984ed5$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $9f6a283fc9984ed5$var$subtractPoint(point, $9f6a283fc9984ed5$var$lastDevicePoint(history)),
        offset: $9f6a283fc9984ed5$var$subtractPoint(point, $9f6a283fc9984ed5$var$startDevicePoint(history)),
        velocity: $9f6a283fc9984ed5$var$getVelocity(history, 0.1)
    };
}
function $9f6a283fc9984ed5$var$startDevicePoint(history) {
    return history[0];
}
function $9f6a283fc9984ed5$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $9f6a283fc9984ed5$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $9f6a283fc9984ed5$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $c68b6b1dcf81df29$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}






/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $b5c1426faec48304$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $b5c1426faec48304$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $b5c1426faec48304$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $b5c1426faec48304$export$690c180aa5775042(layoutBox.x, left, right),
        y: $b5c1426faec48304$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $b5c1426faec48304$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $b5c1426faec48304$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $b5c1426faec48304$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $b5c1426faec48304$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $b5c1426faec48304$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $72fe8a0bcc14ccca$export$c1c127004b72a37)(source);
    const targetLength = (0, $72fe8a0bcc14ccca$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $483094981a1afc3a$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $483094981a1afc3a$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $eea5cbf12f43c97b$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $b5c1426faec48304$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $b5c1426faec48304$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $b5c1426faec48304$export$7c5eaef8f4723d22(dragElastic = $b5c1426faec48304$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $b5c1426faec48304$export$a3366d3bac43a742;
    return {
        x: $b5c1426faec48304$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $b5c1426faec48304$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $b5c1426faec48304$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $b5c1426faec48304$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $b5c1426faec48304$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $b5c1426faec48304$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $5546d36756a876b4$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $5546d36756a876b4$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $3f3fdffc5c959b77$export$12f84bb882d06e1a)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $bc1869f08faf4999$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $e18c6140bf42e2cc$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $72fe8a0bcc14ccca$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $153ac5076757d0fe$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $a36122130b835162$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $5546d36756a876b4$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $9f6a283fc9984ed5$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $20d9edb8d4a1499c$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $153ac5076757d0fe$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$5546d36756a876b4$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $b5c1426faec48304$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $3c2af749636abbc7$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $b5c1426faec48304$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $b5c1426faec48304$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $b5c1426faec48304$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $3c2af749636abbc7$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $f6c3d1780c7f8ff9$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $facb3467d71d9801$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $b5c1426faec48304$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $bc436f258404da72$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $bc436f258404da72$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>{
            if (!$5546d36756a876b4$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $a36122130b835162$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $72929d0b87b6a468$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$5546d36756a876b4$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $3c2af749636abbc7$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $b5c1426faec48304$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>{
            if (!$5546d36756a876b4$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $5546d36756a876b4$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $bb22ae81b44b6685$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $3c2af749636abbc7$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $153ac5076757d0fe$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $6d8a6e367a53f8d7$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $b5c1426faec48304$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $5546d36756a876b4$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $5546d36756a876b4$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $fc6624c04f59833f$export$5d97dc2872682820 extends (0, $44c9f8ee479fe99e$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $5d869bf5b7e31014$export$8793edee2d425525);
        this.removeListeners = (0, $5d869bf5b7e31014$export$8793edee2d425525);
        this.controls = new (0, $5546d36756a876b4$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $5d869bf5b7e31014$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $014c8e18b8a5eae2$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $153ac5076757d0fe$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $014c8e18b8a5eae2$export$b4f8f1ee75ce5859 extends (0, $44c9f8ee479fe99e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $5d869bf5b7e31014$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $9f6a283fc9984ed5$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $20d9edb8d4a1499c$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $014c8e18b8a5eae2$var$asyncHandler(onPanSessionStart),
            onStart: $014c8e18b8a5eae2$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $153ac5076757d0fe$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $bb22ae81b44b6685$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $j6whP = parcelRequire("j6whP");


var $1Pgvo = parcelRequire("1Pgvo");



var $1Pgvo = parcelRequire("1Pgvo");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $cd0d27606c82650b$export$da5f7b802957459a = (0, $1Pgvo.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $c141f4aa6ad44a86$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $1252a9c6c683a74f$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $1252a9c6c683a74f$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $e18c6140bf42e2cc$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $1252a9c6c683a74f$export$fafff692be55225d(latest, node.target.x);
        const y = $1252a9c6c683a74f$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $2654f7db8b6b0a1f$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $d5617791562c6f4d$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $d5617791562c6f4d$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};



const $a402fe686c581a5e$export$91ddd985b97788d1 = {};
function $a402fe686c581a5e$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $a402fe686c581a5e$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $8b31393e88a7536d$export$9de1236619d9e756)(key)) $a402fe686c581a5e$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}


"use client";
class $9767cc420cee2786$var$MeasureLayoutWithContext extends (0, $1Pgvo.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $a402fe686c581a5e$export$de9e7791c71225fd)($9767cc420cee2786$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $c141f4aa6ad44a86$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $153ac5076757d0fe$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $0e393082e3dd9181$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $9767cc420cee2786$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $8bd779e86f53bc83$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $1Pgvo.useContext)((0, $0e95141f62ee0beb$export$a3579ca508007a95));
    return (0, $j6whP.jsx)($9767cc420cee2786$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $1Pgvo.useContext)((0, $cd0d27606c82650b$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $9767cc420cee2786$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $1252a9c6c683a74f$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $1252a9c6c683a74f$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $1252a9c6c683a74f$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $1252a9c6c683a74f$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $1252a9c6c683a74f$export$5eafb6257a5844c),
    boxShadow: (0, $2654f7db8b6b0a1f$export$eb0bc629e74dcf8)
};







function $3d502e4edf0beea7$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $b71f6c9e56e01afa$export$605d60a2578142d3)(value) ? value : (0, $735f2f1a5fe1a553$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $72929d0b87b6a468$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}



function $f067df360cfb1f05$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}



const $ea25a5dd54bec8c4$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $31ab84b2c56bad49$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $4b4dec95d1dbfbd3$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $4b4dec95d1dbfbd3$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $ea25a5dd54bec8c4$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $3b95c2fd5f287552$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $8fa0eb8b37097f3c$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $153ac5076757d0fe$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $153ac5076757d0fe$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $153ac5076757d0fe$export$ec99c0ef4978dccb)(checkElapsed);
}
function $3b95c2fd5f287552$export$fcd451ca460f8a2a(callback, timeout) {
    return $3b95c2fd5f287552$export$1391212d75b2ee65(callback, (0, $c68b6b1dcf81df29$export$fc3e7e8557f8c8c7)(timeout));
}





/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $f746190fbd51d28a$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $b71f6c9e56e01afa$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $3ffe1af99bd441fd$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}






const $3badeeb97f52257e$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $3badeeb97f52257e$var$numBorders = $3badeeb97f52257e$var$borders.length;
const $3badeeb97f52257e$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $3badeeb97f52257e$var$isPx = (value)=>typeof value === "number" || (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008).test(value);
function $3badeeb97f52257e$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $3badeeb97f52257e$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $3badeeb97f52257e$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $3badeeb97f52257e$var$numBorders; i++){
        const borderLabel = `border${$3badeeb97f52257e$var$borders[i]}Radius`;
        let followRadius = $3badeeb97f52257e$var$getRadius(follow, borderLabel);
        let leadRadius = $3badeeb97f52257e$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $3badeeb97f52257e$var$isPx(followRadius) === $3badeeb97f52257e$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)($3badeeb97f52257e$var$asNumber(followRadius), $3badeeb97f52257e$var$asNumber(leadRadius), progress), 0);
            if ((0, $e18c6140bf42e2cc$export$626336c2cd4b14de).test(leadRadius) || (0, $e18c6140bf42e2cc$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $3badeeb97f52257e$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $3badeeb97f52257e$var$easeCrossfadeIn = /*@__PURE__*/ $3badeeb97f52257e$var$compress(0, 0.5, (0, $2b88f354a2a0498c$export$c8d67a19199d1a50));
const $3badeeb97f52257e$var$easeCrossfadeOut = /*@__PURE__*/ $3badeeb97f52257e$var$compress(0.5, 0.95, (0, $5d869bf5b7e31014$export$8793edee2d425525));
function $3badeeb97f52257e$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $483094981a1afc3a$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $ef6f9adb08092d04$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $ef6f9adb08092d04$export$c53fd88f45d77e4b(box, originBox) {
    $ef6f9adb08092d04$export$a0230ae482601ae8(box.x, originBox.x);
    $ef6f9adb08092d04$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $ef6f9adb08092d04$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $64375547130ca800$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $2320bec329eac7c3$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $2320bec329eac7c3$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $64375547130ca800$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $e18c6140bf42e2cc$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $64375547130ca800$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $64375547130ca800$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $64375547130ca800$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $64375547130ca800$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $64375547130ca800$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $64375547130ca800$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $64375547130ca800$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $64375547130ca800$export$42b76f1d0d16d5b(box.x, transforms, $64375547130ca800$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $64375547130ca800$export$42b76f1d0d16d5b(box.y, transforms, $64375547130ca800$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $8cbb44f74c791d28$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $8cbb44f74c791d28$export$a7ec7642fe550fb6(delta) {
    return $8cbb44f74c791d28$var$isAxisDeltaZero(delta.x) && $8cbb44f74c791d28$var$isAxisDeltaZero(delta.y);
}
function $8cbb44f74c791d28$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $8cbb44f74c791d28$export$8d5cf76bb7daff09(a, b) {
    return $8cbb44f74c791d28$export$7a9a6f114ddd0fdb(a.x, b.x) && $8cbb44f74c791d28$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $8cbb44f74c791d28$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $8cbb44f74c791d28$export$ef641b782d85522(a, b) {
    return $8cbb44f74c791d28$export$22adf28bfca1c186(a.x, b.x) && $8cbb44f74c791d28$export$22adf28bfca1c186(a.y, b.y);
}
function $8cbb44f74c791d28$export$c5706146bc63213(box) {
    return (0, $72fe8a0bcc14ccca$export$c1c127004b72a37)(box.x) / (0, $72fe8a0bcc14ccca$export$c1c127004b72a37)(box.y);
}
function $8cbb44f74c791d28$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $301e63c86030cc95$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $4b4dec95d1dbfbd3$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $4b4dec95d1dbfbd3$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $a6262ae2c2914f8a$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $6c0205c3713482f0$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $6c0205c3713482f0$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $6c0205c3713482f0$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $6c0205c3713482f0$var$animationTarget = 1000;
let $6c0205c3713482f0$var$id = 0;
function $6c0205c3713482f0$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $6c0205c3713482f0$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $f7787f5932cd778a$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $153ac5076757d0fe$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $6c0205c3713482f0$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $6c0205c3713482f0$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $6c0205c3713482f0$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $d35bb1a817255f19$export$84ce9a476f53d110).value) $6c0205c3713482f0$var$metrics.nodes = $6c0205c3713482f0$var$metrics.calculatedTargetDeltas = $6c0205c3713482f0$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($6c0205c3713482f0$export$131f2f0cc5fe9609);
                this.nodes.forEach($6c0205c3713482f0$var$resolveTargetDelta);
                this.nodes.forEach($6c0205c3713482f0$var$calcProjection);
                this.nodes.forEach($6c0205c3713482f0$export$c2664f37bc951031);
                if ((0, $d35bb1a817255f19$export$84ce9a476f53d110).addProjectionMetrics) (0, $d35bb1a817255f19$export$84ce9a476f53d110).addProjectionMetrics($6c0205c3713482f0$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $31ab84b2c56bad49$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $92a9f7aaf33d26aa$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $f067df360cfb1f05$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $3b95c2fd5f287552$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $c141f4aa6ad44a86$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $c141f4aa6ad44a86$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($6c0205c3713482f0$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $6c0205c3713482f0$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $8cbb44f74c791d28$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $b8f540ed65e01b25$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $6c0205c3713482f0$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $153ac5076757d0fe$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($6c0205c3713482f0$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $6c0205c3713482f0$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($6c0205c3713482f0$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($6c0205c3713482f0$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($6c0205c3713482f0$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($6c0205c3713482f0$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($6c0205c3713482f0$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $8fa0eb8b37097f3c$export$2da9be4cfdb689b1).now();
            (0, $153ac5076757d0fe$export$fff89137e9e818ce).delta = (0, $eea5cbf12f43c97b$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $153ac5076757d0fe$export$fff89137e9e818ce).timestamp);
            (0, $153ac5076757d0fe$export$fff89137e9e818ce).timestamp = now;
            (0, $153ac5076757d0fe$export$fff89137e9e818ce).isProcessing = true;
            (0, $153ac5076757d0fe$export$1811c3a7e3af92f0).update.process((0, $153ac5076757d0fe$export$fff89137e9e818ce));
            (0, $153ac5076757d0fe$export$1811c3a7e3af92f0).preRender.process((0, $153ac5076757d0fe$export$fff89137e9e818ce));
            (0, $153ac5076757d0fe$export$1811c3a7e3af92f0).render.process((0, $153ac5076757d0fe$export$fff89137e9e818ce));
            (0, $153ac5076757d0fe$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $0e393082e3dd9181$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($6c0205c3713482f0$var$clearSnapshot);
            this.sharedNodes.forEach($6c0205c3713482f0$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $153ac5076757d0fe$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $153ac5076757d0fe$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $72fe8a0bcc14ccca$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $72fe8a0bcc14ccca$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $8cbb44f74c791d28$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $60d46afc048fe110$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $6c0205c3713482f0$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($6c0205c3713482f0$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $2320bec329eac7c3$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $2320bec329eac7c3$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
            (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $2320bec329eac7c3$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $2320bec329eac7c3$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
            (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $2320bec329eac7c3$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $60d46afc048fe110$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $2320bec329eac7c3$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $60d46afc048fe110$export$a545127cf1fbb600)(this.latestValues)) (0, $2320bec329eac7c3$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
            (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $60d46afc048fe110$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $60d46afc048fe110$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $64375547130ca800$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $60d46afc048fe110$export$a545127cf1fbb600)(this.latestValues)) (0, $64375547130ca800$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $153ac5076757d0fe$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $153ac5076757d0fe$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
                    (0, $72fe8a0bcc14ccca$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $72fe8a0bcc14ccca$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $2320bec329eac7c3$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
                    (0, $72fe8a0bcc14ccca$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $d35bb1a817255f19$export$84ce9a476f53d110).value) $6c0205c3713482f0$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $60d46afc048fe110$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $60d46afc048fe110$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $153ac5076757d0fe$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $2320bec329eac7c3$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $ef6f9adb08092d04$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $ef6f9adb08092d04$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $72fe8a0bcc14ccca$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $8cbb44f74c791d28$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $8cbb44f74c791d28$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $d35bb1a817255f19$export$84ce9a476f53d110).value) $6c0205c3713482f0$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $10c424f93d7dba80$export$3d227df54007d73a)();
            this.projectionDelta = (0, $10c424f93d7dba80$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $10c424f93d7dba80$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $10c424f93d7dba80$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($6c0205c3713482f0$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $6c0205c3713482f0$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $6c0205c3713482f0$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $72fe8a0bcc14ccca$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $6c0205c3713482f0$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $8cbb44f74c791d28$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
                    (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $3badeeb97f52257e$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $153ac5076757d0fe$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $153ac5076757d0fe$export$2cef06c20297c17d).update(()=>{
                (0, $c141f4aa6ad44a86$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                (0, $bed173d670311b7b$export$d921fb2475e2900c).layout++;
                this.currentAnimation = (0, $3d502e4edf0beea7$export$335a17c977067b99)(0, $6c0205c3713482f0$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $bed173d670311b7b$export$d921fb2475e2900c).layout--;
                    },
                    onComplete: ()=>{
                        (0, $bed173d670311b7b$export$d921fb2475e2900c).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($6c0205c3713482f0$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $6c0205c3713482f0$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
                const xLength = (0, $72fe8a0bcc14ccca$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $72fe8a0bcc14ccca$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $ef6f9adb08092d04$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $2320bec329eac7c3$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $72fe8a0bcc14ccca$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $301e63c86030cc95$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $6c0205c3713482f0$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $6c0205c3713482f0$var$transformAxes.length; i++){
                $6c0205c3713482f0$var$resetDistortingTransform(`rotate${$6c0205c3713482f0$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $6c0205c3713482f0$var$resetDistortingTransform(`skew${$6c0205c3713482f0$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $6c0205c3713482f0$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $f746190fbd51d28a$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $f746190fbd51d28a$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $60d46afc048fe110$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $a6262ae2c2914f8a$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $a402fe686c581a5e$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $a402fe686c581a5e$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $f746190fbd51d28a$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($6c0205c3713482f0$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $6c0205c3713482f0$var$updateLayout(node) {
    node.updateLayout();
}
function $6c0205c3713482f0$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $72fe8a0bcc14ccca$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($6c0205c3713482f0$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $74c495ef5148912f$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $72fe8a0bcc14ccca$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $10c424f93d7dba80$export$3d227df54007d73a)();
        (0, $72fe8a0bcc14ccca$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $10c424f93d7dba80$export$3d227df54007d73a)();
        if (isShared) (0, $72fe8a0bcc14ccca$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $72fe8a0bcc14ccca$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $8cbb44f74c791d28$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
                    (0, $72fe8a0bcc14ccca$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
                    (0, $72fe8a0bcc14ccca$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $8cbb44f74c791d28$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $6c0205c3713482f0$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $d35bb1a817255f19$export$84ce9a476f53d110).value) $6c0205c3713482f0$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $6c0205c3713482f0$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $6c0205c3713482f0$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $6c0205c3713482f0$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $6c0205c3713482f0$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $6c0205c3713482f0$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $6c0205c3713482f0$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $6c0205c3713482f0$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $6c0205c3713482f0$var$calcProjection(node) {
    node.calcProjection();
}
function $6c0205c3713482f0$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $6c0205c3713482f0$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $6c0205c3713482f0$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $6c0205c3713482f0$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $bb4a5d6c3467454e$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $6c0205c3713482f0$export$6ffd3e6ae339a132(output, from, to, p) {
    $6c0205c3713482f0$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $6c0205c3713482f0$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $6c0205c3713482f0$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $6c0205c3713482f0$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $6c0205c3713482f0$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $6c0205c3713482f0$var$roundPoint = $6c0205c3713482f0$var$userAgentContains("applewebkit/") && !$6c0205c3713482f0$var$userAgentContains("chrome/") ? Math.round : (0, $5d869bf5b7e31014$export$8793edee2d425525);
function $6c0205c3713482f0$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $6c0205c3713482f0$var$roundPoint(axis.min);
    axis.max = $6c0205c3713482f0$var$roundPoint(axis.max);
}
function $6c0205c3713482f0$var$roundBox(box) {
    $6c0205c3713482f0$var$roundAxis(box.x);
    $6c0205c3713482f0$var$roundAxis(box.y);
}
function $6c0205c3713482f0$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $72fe8a0bcc14ccca$export$28d0384c4b79bde2)((0, $8cbb44f74c791d28$export$c5706146bc63213)(snapshot), (0, $8cbb44f74c791d28$export$c5706146bc63213)(layout), 0.2);
}
function $6c0205c3713482f0$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $fe8df352554f5c1c$export$2d029a49a09b6177 = (0, $6c0205c3713482f0$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $6d8a6e367a53f8d7$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $59707ae4fffa5373$export$b91509fcf893b648 = {
    current: undefined
};
const $59707ae4fffa5373$export$b61a9eb3dbde8858 = (0, $6c0205c3713482f0$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$59707ae4fffa5373$export$b91509fcf893b648.current) {
            const documentNode = new (0, $fe8df352554f5c1c$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $59707ae4fffa5373$export$b91509fcf893b648.current = documentNode;
        }
        return $59707ae4fffa5373$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $4eadc1fa48dd57bd$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $014c8e18b8a5eae2$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $fc6624c04f59833f$export$5d97dc2872682820),
        ProjectionNode: (0, $59707ae4fffa5373$export$b61a9eb3dbde8858),
        MeasureLayout: $9767cc420cee2786$export$779f5fb01ad751cd
    }
};





function $ff5ba470c0c2b078$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $153ac5076757d0fe$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $3f3fdffc5c959b77$export$12f84bb882d06e1a)(event)));
}
class $ff5ba470c0c2b078$export$93a81ea037eac456 extends (0, $44c9f8ee479fe99e$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $6878860b54ca295d$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $ff5ba470c0c2b078$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$ff5ba470c0c2b078$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}





class $fbc40104bfca5af9$export$d4826db40d47595b extends (0, $44c9f8ee479fe99e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $13c7fc820f1beb48$export$a4627e546088548d)((0, $6d8a6e367a53f8d7$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $6d8a6e367a53f8d7$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}





function $2118bcce64125ad3$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $153ac5076757d0fe$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $3f3fdffc5c959b77$export$12f84bb882d06e1a)(event)));
}
class $2118bcce64125ad3$export$f026abdbba7f0c9e extends (0, $44c9f8ee479fe99e$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $5da6e464a2d52466$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $2118bcce64125ad3$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$2118bcce64125ad3$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $88290d3625e2471b$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $88290d3625e2471b$var$observers = new WeakMap();
const $88290d3625e2471b$var$fireObserverCallback = (entry)=>{
    const callback = $88290d3625e2471b$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $88290d3625e2471b$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($88290d3625e2471b$var$fireObserverCallback);
};
function $88290d3625e2471b$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$88290d3625e2471b$var$observers.has(lookupRoot)) $88290d3625e2471b$var$observers.set(lookupRoot, {});
    const rootObservers = $88290d3625e2471b$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($88290d3625e2471b$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $88290d3625e2471b$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $88290d3625e2471b$var$initIntersectionObserver(options);
    $88290d3625e2471b$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $88290d3625e2471b$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $c49a3808e4354b2c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $c49a3808e4354b2c$export$150851c8cc2f0c72 extends (0, $44c9f8ee479fe99e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $c49a3808e4354b2c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $88290d3625e2471b$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($c49a3808e4354b2c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $c49a3808e4354b2c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $4d88287fec4f32f1$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $c49a3808e4354b2c$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $2118bcce64125ad3$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $fbc40104bfca5af9$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $ff5ba470c0c2b078$export$93a81ea037eac456)
    }
};




const $f526eea4c2cae6da$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $59707ae4fffa5373$export$b61a9eb3dbde8858),
        MeasureLayout: $9767cc420cee2786$export$779f5fb01ad751cd
    }
};



var $j6whP = parcelRequire("j6whP");


var $1Pgvo = parcelRequire("1Pgvo");


var $1Pgvo = parcelRequire("1Pgvo");
"use client";
const $47acf16ee66cff05$export$40f10139ecf1f171 = (0, $1Pgvo.createContext)({
    strict: false
});




var $1Pgvo = parcelRequire("1Pgvo");
"use client";
const $f5a240e0d9127b7b$export$2285bbca2c666415 = /* @__PURE__ */ (0, $1Pgvo.createContext)({});



var $1Pgvo = parcelRequire("1Pgvo");




function $5b4e88f4dcf0498d$export$4b3c3bd8d910d78d(props) {
    return (0, $b37798457ef74195$export$aa71198ceeaf53ce)(props.animate) || (0, $c34459889ad5228e$export$1405a65085f40b9).some((name)=>(0, $a1cc7c7d5fedb08f$export$720b90e312cea233)(props[name]));
}
function $5b4e88f4dcf0498d$export$ce46fa4165cdec40(props) {
    return Boolean($5b4e88f4dcf0498d$export$4b3c3bd8d910d78d(props) || props.variants);
}



function $277f07ef1191f732$export$12fc32fc096a04a3(props, context) {
    if ((0, $5b4e88f4dcf0498d$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $a1cc7c7d5fedb08f$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $a1cc7c7d5fedb08f$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $34fc6c09b6aa73d6$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $277f07ef1191f732$export$12fc32fc096a04a3)(props, (0, $1Pgvo.useContext)((0, $f5a240e0d9127b7b$export$2285bbca2c666415)));
    return (0, $1Pgvo.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $34fc6c09b6aa73d6$var$variantLabelsAsDependency(initial),
        $34fc6c09b6aa73d6$var$variantLabelsAsDependency(animate)
    ]);
}
function $34fc6c09b6aa73d6$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}



const $a345efdb9ed096b1$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a345efdb9ed096b1$export$65570e08d843624d = {};
for(const key in $a345efdb9ed096b1$var$featureProps)$a345efdb9ed096b1$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a345efdb9ed096b1$var$featureProps[key].some((name)=>!!props[name])
};



function $c793d72771cc1c3f$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $a345efdb9ed096b1$export$65570e08d843624d)[key] = {
        ...(0, $a345efdb9ed096b1$export$65570e08d843624d)[key],
        ...features[key]
    };
}


const $9e96e0dfe19ac9df$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $1Pgvo = parcelRequire("1Pgvo");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $d0cced075e09fcbd$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $1Pgvo.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $3c2af749636abbc7$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}




var $1Pgvo = parcelRequire("1Pgvo");








function $8af86af38a88e9cc$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent } = (0, $1Pgvo.useContext)((0, $f5a240e0d9127b7b$export$2285bbca2c666415));
    const lazyContext = (0, $1Pgvo.useContext)((0, $47acf16ee66cff05$export$40f10139ecf1f171));
    const presenceContext = (0, $1Pgvo.useContext)((0, $b9c0da3bd9c84b40$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $1Pgvo.useContext)((0, $9e704e023ee7d3d9$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $1Pgvo.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $1Pgvo.useContext)((0, $cd0d27606c82650b$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $8af86af38a88e9cc$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $1Pgvo.useRef)(false);
    (0, $1Pgvo.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $aa94e5971c3fdaa4$export$8592e1c077c890a6];
    const wantsHandoff = (0, $1Pgvo.useRef)(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    (0, $8ba01f17ad46b6a6$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $0e393082e3dd9181$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $1Pgvo.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 || _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $8af86af38a88e9cc$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $8af86af38a88e9cc$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $3c2af749636abbc7$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $8af86af38a88e9cc$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $8af86af38a88e9cc$var$getClosestProjectingNode(visualElement.parent);
}


"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $fe70ebc26191f76f$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    var _a, _b;
    preloadedFeatures && (0, $c793d72771cc1c3f$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $1Pgvo.useContext)((0, $9e704e023ee7d3d9$export$22a697fb29aac98d)),
            ...props,
            layoutId: $fe70ebc26191f76f$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $34fc6c09b6aa73d6$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $eb26638a1ff129db$export$4e09c449d6c407f7)) {
            $fe70ebc26191f76f$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $fe70ebc26191f76f$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $8af86af38a88e9cc$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $j6whP.jsxs)((0, $f5a240e0d9127b7b$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $j6whP.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $d0cced075e09fcbd$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    MotionComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${(_b = (_a = Component.displayName) !== null && _a !== void 0 ? _a : Component.name) !== null && _b !== void 0 ? _b : ""})`}`;
    const ForwardRefMotionComponent = (0, $1Pgvo.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $9e96e0dfe19ac9df$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $fe70ebc26191f76f$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $1Pgvo.useContext)((0, $0e95141f62ee0beb$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $fe70ebc26191f76f$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $1Pgvo.useContext)((0, $47acf16ee66cff05$export$40f10139ecf1f171)).strict;
}
function $fe70ebc26191f76f$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $a345efdb9ed096b1$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}



var $1Pgvo = parcelRequire("1Pgvo");

var $1Pgvo = parcelRequire("1Pgvo");


function $4083ab6e0abe281c$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $d552ae0de57fd093$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $a402fe686c581a5e$export$91ddd985b97788d1)[key] || key === "opacity");
}




/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $a15b0e328abf9497$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};






const $f7aa4cd973995c41$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $f7aa4cd973995c41$var$numTransforms = (0, $d552ae0de57fd093$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $f7aa4cd973995c41$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $f7aa4cd973995c41$var$numTransforms; i++){
        const key = (0, $d552ae0de57fd093$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $a15b0e328abf9497$export$453ef540a9a1bd6b)(value, (0, $6d969a5b0b148ec5$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $f7aa4cd973995c41$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}



function $6bbd1781ec9b01d4$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $d552ae0de57fd093$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $8b31393e88a7536d$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $a15b0e328abf9497$export$453ef540a9a1bd6b)(value, (0, $6d969a5b0b148ec5$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $f7aa4cd973995c41$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $7a38946ff84f47ee$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $faca586b17ba8fd3$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $b71f6c9e56e01afa$export$605d60a2578142d3)(source[key]) && !(0, $4083ab6e0abe281c$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $faca586b17ba8fd3$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $1Pgvo.useMemo)(()=>{
        const state = (0, $7a38946ff84f47ee$export$8940b483cf52eeda)();
        (0, $6bbd1781ec9b01d4$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $faca586b17ba8fd3$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $faca586b17ba8fd3$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $faca586b17ba8fd3$var$useInitialMotionValues(props, visualState));
    return style;
}
function $faca586b17ba8fd3$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $faca586b17ba8fd3$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $f044174567d50417$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $f044174567d50417$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $f044174567d50417$var$validMotionProps.has(key);
}


let $0d43a6efbd1207a9$var$shouldForward = (key)=>!(0, $f044174567d50417$export$2f9c46555243bf04)(key);
function $0d43a6efbd1207a9$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $0d43a6efbd1207a9$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $f044174567d50417$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $0d43a6efbd1207a9$export$59d6962c470509a5((parcelRequire("3ievm")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $0d43a6efbd1207a9$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($0d43a6efbd1207a9$var$shouldForward(key) || forwardMotionProps === true && (0, $f044174567d50417$export$2f9c46555243bf04)(key) || !isDom && !(0, $f044174567d50417$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $a735aef55c0c6691$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $75cd0803e11b3148$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $a735aef55c0c6691$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



var $1Pgvo = parcelRequire("1Pgvo");



const $e5b8887f2cc0cff1$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $e5b8887f2cc0cff1$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $e5b8887f2cc0cff1$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $e5b8887f2cc0cff1$var$dashKeys : $e5b8887f2cc0cff1$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}



function $31231dbab2a7762e$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $e18c6140bf42e2cc$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $31231dbab2a7762e$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $31231dbab2a7762e$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $31231dbab2a7762e$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $dbca299cc9299349$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $6bbd1781ec9b01d4$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $31231dbab2a7762e$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $e5b8887f2cc0cff1$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $5545ee13470ff398$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $7a38946ff84f47ee$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $368e88b6894224f6$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $a6bb46178163a4a5$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $1Pgvo.useMemo)(()=>{
        const state = (0, $5545ee13470ff398$export$41be8b43e1c4d4f9)();
        (0, $dbca299cc9299349$export$5475d24f125d7053)(state, visualState, (0, $368e88b6894224f6$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $faca586b17ba8fd3$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $0d273931add24108$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $75cd0803e11b3148$export$88f3fc2fd3766989)(Component) ? (0, $a6bb46178163a4a5$export$84309c4f53cb1bd5) : (0, $faca586b17ba8fd3$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $0d43a6efbd1207a9$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $1Pgvo.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $1Pgvo.useMemo)(()=>(0, $b71f6c9e56e01afa$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $1Pgvo.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}




var $1Pgvo = parcelRequire("1Pgvo");







function $720d1bd72c0b5d61$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onUpdate: onUpdate }, props, context, presenceContext) {
    const state = {
        latestValues: $720d1bd72c0b5d61$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onUpdate) {
        /**
         * onMount works without the VisualElement because it could be
         * called before the VisualElement payload has been hydrated.
         * (e.g. if someone is using m components <m.circle />)
         */ state.onMount = (instance)=>onUpdate({
                props: props,
                current: instance,
                ...state
            });
        state.onUpdate = (visualElement)=>onUpdate(visualElement);
    }
    return state;
}
const $720d1bd72c0b5d61$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $1Pgvo.useContext)((0, $f5a240e0d9127b7b$export$2285bbca2c666415));
        const presenceContext = (0, $1Pgvo.useContext)((0, $b9c0da3bd9c84b40$export$f224e4635b6f8ce2));
        const make = ()=>$720d1bd72c0b5d61$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $24c068ca23c223da$export$fe4300aa8eebea86)(make);
    };
function $720d1bd72c0b5d61$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $f746190fbd51d28a$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $5b4e88f4dcf0498d$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $5b4e88f4dcf0498d$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $b37798457ef74195$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $fdc230da1cbdafde$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}




function $95aff7078df917bc$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $b71f6c9e56e01afa$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $b71f6c9e56e01afa$export$605d60a2578142d3)(prevProps.style[key]) || (0, $4083ab6e0abe281c$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}



const $ca0309b129836122$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $720d1bd72c0b5d61$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $95aff7078df917bc$export$16da615486abaa45,
        createRenderState: (0, $7a38946ff84f47ee$export$8940b483cf52eeda)
    })
};








function $818862a665ef5854$export$c01c3c7cdbf4420c(instance, renderState) {
    try {
        renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
    } catch (e) {
        // Most likely trying to measure an unrendered element under Firefox
        renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}



function $a7e8a66f9dd43f56$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $9a8c48df9a3d6540$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $0985231593ed7611$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $a7e8a66f9dd43f56$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $9a8c48df9a3d6540$export$28931db5d57958e5).has(key) ? (0, $3b50b5f4e58b8bb2$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $208ed81e507ec82e$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $95aff7078df917bc$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $b71f6c9e56e01afa$export$605d60a2578142d3)(props[key]) || (0, $b71f6c9e56e01afa$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $d552ae0de57fd093$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


const $beeb4e9f48661458$var$layoutProps = [
    "x",
    "y",
    "width",
    "height",
    "cx",
    "cy",
    "r"
];
const $beeb4e9f48661458$export$44dabd3fae512e85 = {
    useVisualState: (0, $720d1bd72c0b5d61$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $208ed81e507ec82e$export$16da615486abaa45),
        createRenderState: (0, $5545ee13470ff398$export$41be8b43e1c4d4f9),
        onUpdate: ({ props: props, prevProps: prevProps, current: current, renderState: renderState, latestValues: latestValues })=>{
            if (!current) return;
            let hasTransform = !!props.drag;
            if (!hasTransform) {
                for(const key in latestValues)if ((0, $d552ae0de57fd093$export$7b42a0094fb00b6e).has(key)) {
                    hasTransform = true;
                    break;
                }
            }
            if (!hasTransform) return;
            let needsMeasure = !prevProps;
            if (prevProps) /**
                 * Check the layout props for changes, if any are found we need to
                 * measure the element again.
                 */ for(let i = 0; i < $beeb4e9f48661458$var$layoutProps.length; i++){
                const key = $beeb4e9f48661458$var$layoutProps[i];
                if (props[key] !== prevProps[key]) needsMeasure = true;
            }
            if (!needsMeasure) return;
            (0, $153ac5076757d0fe$export$2cef06c20297c17d).read(()=>{
                (0, $818862a665ef5854$export$c01c3c7cdbf4420c)(current, renderState);
                (0, $153ac5076757d0fe$export$2cef06c20297c17d).render(()=>{
                    (0, $dbca299cc9299349$export$5475d24f125d7053)(renderState, latestValues, (0, $368e88b6894224f6$export$6328ce7565ea1049)(current.tagName), props.transformTemplate);
                    (0, $0985231593ed7611$export$c5f8399d19a7394b)(current, renderState);
                });
            });
        }
    })
};


function $049c3f070476060d$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $75cd0803e11b3148$export$88f3fc2fd3766989)(Component) ? (0, $beeb4e9f48661458$export$44dabd3fae512e85) : (0, $ca0309b129836122$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $0d273931add24108$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $fe70ebc26191f76f$export$c3ad4a902bccc2d8)(config);
    };
}



var $1Pgvo = parcelRequire("1Pgvo");









// Does this device prefer reduced motion? Returns `null` server-side.
const $6e55f2f32a448767$export$ff7706047246b98b = {
    current: null
};
const $6e55f2f32a448767$export$6476d16e2fd2d0db = {
    current: false
};


function $f6f77bf711715746$export$ca9f41fb23dded3d() {
    (0, $6e55f2f32a448767$export$6476d16e2fd2d0db).current = true;
    if (!(0, $eb26638a1ff129db$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $6e55f2f32a448767$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $6e55f2f32a448767$export$ff7706047246b98b).current = false;
}










/**
 * A list of all ValueTypes
 */ const $cd42c5fdc43c8285$var$valueTypes = [
    ...(0, $7f281c484af60633$export$d176691c1998a1f5),
    (0, $e777867103193158$export$35e9368ef982300f),
    (0, $d5617791562c6f4d$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $cd42c5fdc43c8285$export$950e7e59ea1ffed7 = (v)=>$cd42c5fdc43c8285$var$valueTypes.find((0, $333eec5e2cdb2e0b$export$6eae4d0a6a7ca7cd)(v));



const $4556aeb57e4ec0e9$export$bc2a978a17abfdde = new WeakMap();







function $a4e06d4698b520ce$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $b71f6c9e56e01afa$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $b71f6c9e56e01afa$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $735f2f1a5fe1a553$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $735f2f1a5fe1a553$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}



const $bf87d9f327f3d868$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $bf87d9f327f3d868$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $885fd3b0e5f1cbf9$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $8fa0eb8b37097f3c$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $153ac5076757d0fe$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState, onUpdate: onUpdate } = visualState;
        this.onUpdate = onUpdate;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $5b4e88f4dcf0498d$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $5b4e88f4dcf0498d$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $b71f6c9e56e01afa$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $4556aeb57e4ec0e9$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $6e55f2f32a448767$export$6476d16e2fd2d0db).current) (0, $f6f77bf711715746$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $6e55f2f32a448767$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $153ac5076757d0fe$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $153ac5076757d0fe$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $d552ae0de57fd093$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $153ac5076757d0fe$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $a345efdb9ed096b1$export$65570e08d843624d){
            const featureDefinition = (0, $a345efdb9ed096b1$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $10c424f93d7dba80$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $bf87d9f327f3d868$var$propEventHandlers.length; i++){
            const key = $bf87d9f327f3d868$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $a4e06d4698b520ce$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
        this.onUpdate && this.onUpdate(this);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $735f2f1a5fe1a553$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $24342c27c7cce494$export$65583ed5a868f2d9)(value) || (0, $63eaa8019ce2d5f9$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $cd42c5fdc43c8285$export$950e7e59ea1ffed7)(value) && (0, $d5617791562c6f4d$export$83a0e34f1302825b).test(target)) value = (0, $e04d7e0eabad2ed4$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $b71f6c9e56e01afa$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $b71f6c9e56e01afa$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $fdc230da1cbdafde$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $b71f6c9e56e01afa$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $92a9f7aaf33d26aa$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}



class $0babdd945d5bf370$export$e49735c2a366bdc7 extends (0, $bf87d9f327f3d868$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $17d31589e5f469ad$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $b71f6c9e56e01afa$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}








function $ccbf7316e995cb98$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $ccbf7316e995cb98$export$23fea75b03ac16b3 extends (0, $0babdd945d5bf370$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $a7e8a66f9dd43f56$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $d552ae0de57fd093$export$7b42a0094fb00b6e).has(key)) return (0, $742823ccddbbb2fb$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $ccbf7316e995cb98$export$3735103072e4a80(instance);
            const value = ((0, $8b31393e88a7536d$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $facb3467d71d9801$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $6bbd1781ec9b01d4$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $95aff7078df917bc$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}














class $39fd83766107019b$export$86bcdffbaf733d84 extends (0, $0babdd945d5bf370$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $10c424f93d7dba80$export$6459fc9e86be362e);
        this.updateDimensions = ()=>{
            if (this.current && !this.renderState.dimensions) (0, $818862a665ef5854$export$c01c3c7cdbf4420c)(this.current, this.renderState);
        };
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $d552ae0de57fd093$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $2d99f37764fc545c$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $9a8c48df9a3d6540$export$28931db5d57958e5).has(key) ? (0, $3b50b5f4e58b8bb2$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $208ed81e507ec82e$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    onBindTransform() {
        if (this.current && !this.renderState.dimensions) (0, $153ac5076757d0fe$export$2cef06c20297c17d).postRender(this.updateDimensions);
    }
    build(renderState, latestValues, props) {
        (0, $dbca299cc9299349$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $0985231593ed7611$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $368e88b6894224f6$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $c694e2cb9bd70dac$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $75cd0803e11b3148$export$88f3fc2fd3766989)(Component) ? new (0, $39fd83766107019b$export$86bcdffbaf733d84)(options) : new (0, $ccbf7316e995cb98$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $1Pgvo.Fragment)
    });
};


const $4e754e08e906a91c$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $049c3f070476060d$export$d86feac869a7f0d5)({
    ...(0, $b9d39d7c57d5f6b5$export$7f9953c70dacfd7f),
    ...(0, $4d88287fec4f32f1$export$e5b72898e5a201f1),
    ...(0, $4eadc1fa48dd57bd$export$d7d5d435647ed5a0),
    ...(0, $f526eea4c2cae6da$export$b3219800bda33a1f)
}, (0, $c694e2cb9bd70dac$export$56ba0183203348f5));


const $b8ce06c5a83cbe7c$export$e25e478948902b8b = /*@__PURE__*/ (0, $22b6140473e534e3$export$3af29c0efb268f04)((0, $4e754e08e906a91c$export$46b7e4b9dc6110c3));


const $c795a803b0c56278$var$getRandomValue = (title, baseValue)=>{
    switch(title){
        case "Stocks Analysed":
            return `${Math.floor(Math.random() * 250 + 950)}`;
        case "Quant Parameters":
            return `${Math.floor(Math.random() * 500 + 3000)}`;
        case "Throughput":
            return `${(Math.random() * (3.5 - 2.8) + 2.8).toFixed(2)}`;
        default:
            return baseValue;
    }
};
const $c795a803b0c56278$var$HighlightsSlider = ()=>{
    const [dynamicData, setDynamicData] = (0, $1Pgvo.useState)((0, (/*@__PURE__*/$parcel$interopDefault($6c8051b9e08b0728$exports))));
    (0, $1Pgvo.useEffect)(()=>{
        const updateMetric = (title)=>{
            setDynamicData((prevData)=>prevData.map((item)=>item.title === title ? {
                        ...item,
                        value: $c795a803b0c56278$var$getRandomValue(item.title, item.value)
                    } : item));
        };
        const stocksInterval = setInterval(()=>updateMetric("Stocks Analysed"), Math.random() * 2000 + 2000);
        const quantInterval = setInterval(()=>updateMetric("Quant Parameters"), Math.random() * 6000 + 2000);
        const throughputInterval = setInterval(()=>updateMetric("Throughput"), Math.random() * 5000 + 2000);
        return ()=>{
            clearInterval(stocksInterval);
            clearInterval(quantInterval);
            clearInterval(throughputInterval);
        };
    }, []);
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        className: $c6d3d7358a625b25$export$801863722a97d1fa,
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                className: $c6d3d7358a625b25$export$286fcf25398eb85a,
                children: [
                    ...dynamicData,
                    ...dynamicData
                ].map((item, i)=>/*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        className: $c6d3d7358a625b25$export$8334095c4da561a6,
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                                className: $c6d3d7358a625b25$export$fb184b623420d9be,
                                children: item.title
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsxs)("h2", {
                                className: $c6d3d7358a625b25$export$2ab9a8f9f1186f14,
                                children: [
                                    item.value.split("").map((digit, index)=>{
                                        const isEven = index % 2 === 0;
                                        const initialY = isEven ? "100%" : "-100%";
                                        const exitY = isEven ? "-100%" : "100%";
                                        return /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                                            className: $c6d3d7358a625b25$export$17fe9d1403c5b12f,
                                            children: /*#__PURE__*/ (0, $j6whP.jsx)((0, $024f5eaf0c2de36b$export$3ae376d12526dd6f), {
                                                mode: "sync",
                                                children: /*#__PURE__*/ (0, $j6whP.jsx)((0, $b8ce06c5a83cbe7c$export$e25e478948902b8b).span, {
                                                    className: $c6d3d7358a625b25$export$8a40e5669d3698bc,
                                                    initial: {
                                                        y: initialY,
                                                        opacity: 0
                                                    },
                                                    animate: {
                                                        y: "0%",
                                                        opacity: 1
                                                    },
                                                    exit: {
                                                        y: exitY,
                                                        opacity: 0
                                                    },
                                                    transition: {
                                                        duration: 0.2,
                                                        ease: "linear"
                                                    },
                                                    children: digit
                                                }, digit + index)
                                            })
                                        }, index);
                                    }),
                                    /*#__PURE__*/ (0, $j6whP.jsxs)("span", {
                                        className: $c6d3d7358a625b25$export$523c0b569236b342,
                                        children: [
                                            " ",
                                            item.unit
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                className: $c6d3d7358a625b25$export$3b690bef424e3403
            })
        ]
    });
};
var $c795a803b0c56278$export$2e2bcd8739ae039 = $c795a803b0c56278$var$HighlightsSlider;




var $j6whP = parcelRequire("j6whP");
var $45d46b700a441597$export$e9a215fca2db19a3;
var $45d46b700a441597$export$fcdd6f3a5d5f39b2;
var $45d46b700a441597$export$8caf4b08e0f84129;
var $45d46b700a441597$export$9f938600c1ff539c;
var $45d46b700a441597$export$b60d6dac5af5488;
$45d46b700a441597$export$e9a215fca2db19a3 = `J5Ts4a_QRCodeContent`;
$45d46b700a441597$export$fcdd6f3a5d5f39b2 = `J5Ts4a_QRCodeDesc`;
$45d46b700a441597$export$8caf4b08e0f84129 = `J5Ts4a_QRCodeHeading`;
$45d46b700a441597$export$9f938600c1ff539c = `J5Ts4a_QRCodeParent`;
$45d46b700a441597$export$b60d6dac5af5488 = `J5Ts4a_qrCode`;


var $17c56ebb4e71fccc$exports = {};

$17c56ebb4e71fccc$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "qr-code.7f400d1d.svg";


const $a784e2eec089eb83$var$QRCode = ()=>{
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        className: $45d46b700a441597$export$9f938600c1ff539c,
        children: [
            /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                className: $45d46b700a441597$export$e9a215fca2db19a3,
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("h3", {
                        className: $45d46b700a441597$export$8caf4b08e0f84129,
                        children: "Claim 3 free stocks ~\u20B9300"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        className: $45d46b700a441597$export$fcdd6f3a5d5f39b2,
                        children: "Download Returns"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                className: $45d46b700a441597$export$b60d6dac5af5488,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($17c56ebb4e71fccc$exports))),
                alt: ""
            })
        ]
    });
};
var $a784e2eec089eb83$export$2e2bcd8739ae039 = $a784e2eec089eb83$var$QRCode;


const $1f95b3ed544e448b$var$HeroHome = ()=>{
    const [ctaStatus, setCtaStatus] = (0, $1Pgvo.useState)("idle");
    const [isMobile, setIsMobile] = (0, $1Pgvo.useState)(window.innerWidth <= 768);
    (0, $1Pgvo.useEffect)(()=>{
        const handleResize = ()=>setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $j6whP.Fragment), {
        children: /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
            className: $145bd01da1e91cfa$export$6a15f8f670d57b0,
            children: [
                /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                    className: `${$145bd01da1e91cfa$export$cc691aa163a3c278} ${ctaStatus === "success" ? $145bd01da1e91cfa$export$5b918073c17c1d45 : ""}`,
                    children: /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        className: $145bd01da1e91cfa$export$9ae72fe925ff8f96,
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                                className: $145bd01da1e91cfa$export$e76f2cf4fa83f217,
                                children: [
                                    /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a9f97fec7e2adca7$exports))),
                                        alt: "Returns",
                                        className: $145bd01da1e91cfa$export$1e3fb8626c787b6d
                                    }),
                                    /*#__PURE__*/ (0, $j6whP.jsxs)("h1", {
                                        className: $145bd01da1e91cfa$export$3551c92a09bdc8f8,
                                        children: [
                                            /*#__PURE__*/ (0, $j6whP.jsxs)("span", {
                                                className: "span-block",
                                                children: [
                                                    "Your ",
                                                    /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                                        className: $145bd01da1e91cfa$export$2d2e5aa253e33f00,
                                                        children: "wealth"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                                className: "span-block",
                                                children: "building team"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                                className: $145bd01da1e91cfa$export$de35f23bc4efd4c7,
                                children: "You relax! We analyze & fine-tune opportunities for wealth creation"
                            })
                        ]
                    })
                }),
                ctaStatus === "success" && /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                    className: $145bd01da1e91cfa$export$6291e281fea9cbf5,
                    children: /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        className: $145bd01da1e91cfa$export$9ae72fe925ff8f96,
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                                className: $145bd01da1e91cfa$export$e76f2cf4fa83f217,
                                children: [
                                    /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3d94a64ce4d37aec$exports))),
                                        alt: "Unlock 3 stocks",
                                        className: $145bd01da1e91cfa$export$efcdeaf5087320cf
                                    }),
                                    /*#__PURE__*/ (0, $j6whP.jsxs)("h1", {
                                        className: $145bd01da1e91cfa$export$3551c92a09bdc8f8,
                                        children: [
                                            /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                                className: "span-block",
                                                children: "You\u2019ve unlocked"
                                            }),
                                            /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                                className: $145bd01da1e91cfa$export$2d2e5aa253e33f00,
                                                children: "3 free"
                                            }),
                                            /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                                children: " stocks ~\u20B9300"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                                className: $145bd01da1e91cfa$export$de35f23bc4efd4c7,
                                children: "Signup on Returns App to claim them!"
                            })
                        ]
                    })
                }),
                ctaStatus === "success" ? isMobile ? /*#__PURE__*/ (0, $j6whP.jsx)((0, $3cecc3b9cc79fe3d$export$d73ba76fbf89849b), {
                    variant: "large",
                    status: ctaStatus,
                    setStatus: setCtaStatus
                }) : /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                    children: /*#__PURE__*/ (0, $j6whP.jsx)((0, $a784e2eec089eb83$export$2e2bcd8739ae039), {})
                }) : /*#__PURE__*/ (0, $j6whP.jsx)((0, $3cecc3b9cc79fe3d$export$d73ba76fbf89849b), {
                    variant: "large",
                    status: ctaStatus,
                    setStatus: setCtaStatus
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                    className: "highlightsSliderParent",
                    children: /*#__PURE__*/ (0, $j6whP.jsx)((0, $c795a803b0c56278$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
};
var $1f95b3ed544e448b$export$2e2bcd8739ae039 = $1f95b3ed544e448b$var$HeroHome;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");
var $8af40cd9eab90ade$export$89da14300d534261;
var $8af40cd9eab90ade$export$d5b53e8b3e00dc65;
var $8af40cd9eab90ade$export$a3b9b213fa74e4fd;
var $8af40cd9eab90ade$export$4aae642d10d55117;
var $8af40cd9eab90ade$export$166cdd594250a057;
var $8af40cd9eab90ade$export$f8f4867693752cd4;
var $8af40cd9eab90ade$export$7424f314fd49c590;
var $8af40cd9eab90ade$export$8c62ad1d5ee878b;
var $8af40cd9eab90ade$export$5793ae4811dedbe5;
var $8af40cd9eab90ade$export$1ca1ec8b29a4ce27;
var $8af40cd9eab90ade$export$9ad1c597e1c51702;
var $8af40cd9eab90ade$export$d4e62fcf1416d69c;
var $8af40cd9eab90ade$export$9d1298853f0e77f7;
var $8af40cd9eab90ade$export$4662439d93cf9393;
$8af40cd9eab90ade$export$89da14300d534261 = `NuTXPG_active`;
$8af40cd9eab90ade$export$d5b53e8b3e00dc65 = `NuTXPG_activeImage`;
$8af40cd9eab90ade$export$a3b9b213fa74e4fd = `NuTXPG_buttonWrapper`;
$8af40cd9eab90ade$export$4aae642d10d55117 = `NuTXPG_carouselButton`;
$8af40cd9eab90ade$export$166cdd594250a057 = `NuTXPG_carouselButtonName`;
$8af40cd9eab90ade$export$f8f4867693752cd4 = `NuTXPG_carouselButtons`;
$8af40cd9eab90ade$export$7424f314fd49c590 = `NuTXPG_carouselContainer`;
$8af40cd9eab90ade$export$8c62ad1d5ee878b = `NuTXPG_carouselContent`;
$8af40cd9eab90ade$export$5793ae4811dedbe5 = `NuTXPG_carouselImage`;
$8af40cd9eab90ade$export$1ca1ec8b29a4ce27 = `NuTXPG_icon`;
$8af40cd9eab90ade$export$9ad1c597e1c51702 = `NuTXPG_productDetailsContainer`;
$8af40cd9eab90ade$export$d4e62fcf1416d69c = `NuTXPG_progressBackground`;
$8af40cd9eab90ade$export$9d1298853f0e77f7 = `NuTXPG_progressBar`;
$8af40cd9eab90ade$export$4662439d93cf9393 = `NuTXPG_progressCircle`;



var $45ed150365a69b8f$exports = {};

$45ed150365a69b8f$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "call-icon.bf3352ee.png";


var $8af90d041128432a$exports = {};

$8af90d041128432a$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "idea-icon.c163bf1c.png";


var $450e426372929c74$exports = {};

$450e426372929c74$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "portfolio-icon.d7bca1bf.png";


var $c34674b1046f676c$exports = {};

$c34674b1046f676c$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "call-icon-inactive.6556993b.png";


var $f14c746fbd8955f5$exports = {};

$f14c746fbd8955f5$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "idea-icon-inactive.79ebf5a4.png";


var $8b117e601f0dad36$exports = {};

$8b117e601f0dad36$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "portfolio-icon-inactive.aa3daca7.png";


var $c61b94c237aee2dc$exports = {};

$c61b94c237aee2dc$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "call-image.3daf7759.webp";


var $4ec4ca8a58e41128$exports = {};

$4ec4ca8a58e41128$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "cimage.abf484d4.png";


var $6c9386ea76579a55$exports = {};

$6c9386ea76579a55$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "pimage.63fc694e.png";


var $b0db547673bb1188$exports = {};

$b0db547673bb1188$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "call-image-mobile.fe2ac963.webp";


var $86a92f38955c1fb8$exports = {};

$86a92f38955c1fb8$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "stock-idea-image-mobile.60520f83.webp";


var $bac89e5d3d5b94ea$exports = {};

$bac89e5d3d5b94ea$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "portfolio-image-mobile.df9e7483.png";


const $956a291d4b8a52b8$var$slides = [
    {
        id: 1,
        title: "Connect with experts",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($45ed150365a69b8f$exports))),
        inactiveIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c34674b1046f676c$exports))),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($c61b94c237aee2dc$exports))),
        mobileImage: (0, (/*@__PURE__*/$parcel$interopDefault($b0db547673bb1188$exports)))
    },
    {
        id: 2,
        title: "Stock Ideas",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8af90d041128432a$exports))),
        inactiveIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f14c746fbd8955f5$exports))),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($4ec4ca8a58e41128$exports))),
        mobileImage: (0, (/*@__PURE__*/$parcel$interopDefault($86a92f38955c1fb8$exports)))
    },
    {
        id: 3,
        title: "Automated Portfolio",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($450e426372929c74$exports))),
        inactiveIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8b117e601f0dad36$exports))),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($6c9386ea76579a55$exports))),
        mobileImage: (0, (/*@__PURE__*/$parcel$interopDefault($bac89e5d3d5b94ea$exports)))
    }
];
const $956a291d4b8a52b8$var$TIMER_DURATION = 5000;
const $956a291d4b8a52b8$var$RADIUS = 19;
const $956a291d4b8a52b8$var$CIRCUMFERENCE = 2 * Math.PI * $956a291d4b8a52b8$var$RADIUS;
const $956a291d4b8a52b8$var$ProductDetails = ()=>{
    const [activeIndex, setActiveIndex] = (0, $1Pgvo.useState)(1);
    const [progress, setProgress] = (0, $1Pgvo.useState)(100);
    const [isMobile, setIsMobile] = (0, $1Pgvo.useState)(window.innerWidth <= 600);
    const touchStartX = (0, $1Pgvo.useRef)(null);
    const touchEndX = (0, $1Pgvo.useRef)(null);
    (0, $1Pgvo.useEffect)(()=>{
        const timer = setInterval(()=>{
            setProgress((prev)=>{
                if (prev <= 0) {
                    setActiveIndex((prevIndex)=>(prevIndex + 1) % $956a291d4b8a52b8$var$slides.length);
                    return 100;
                }
                return prev - 2;
            });
        }, 100);
        return ()=>clearInterval(timer);
    }, []);
    (0, $1Pgvo.useEffect)(()=>{
        const handleResize = ()=>{
            const mobileView = window.innerWidth <= 600;
            setIsMobile(mobileView);
        };
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    const handleClick = (index)=>{
        setActiveIndex(index);
        setProgress(100);
    };
    const handleTouchStart = (e)=>{
        touchStartX.current = e.touches[0].clientX;
    };
    const handleTouchEnd = (e)=>{
        touchEndX.current = e.changedTouches[0].clientX;
        if (touchStartX.current !== null && touchEndX.current !== null) {
            const swipeDistance = touchStartX.current - touchEndX.current;
            if (swipeDistance > 50) {
                setActiveIndex((prevIndex)=>(prevIndex + 1) % $956a291d4b8a52b8$var$slides.length);
                setProgress(100);
            } else if (swipeDistance < -50) {
                setActiveIndex((prevIndex)=>prevIndex === 0 ? $956a291d4b8a52b8$var$slides.length - 1 : prevIndex - 1);
                setProgress(100);
            }
        }
        touchStartX.current = null;
        touchEndX.current = null;
    };
    return /*#__PURE__*/ (0, $j6whP.jsx)("div", {
        className: `${$8af40cd9eab90ade$export$9ad1c597e1c51702} pt-100`,
        onTouchStart: handleTouchStart,
        onTouchEnd: handleTouchEnd,
        children: /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
            className: $8af40cd9eab90ade$export$7424f314fd49c590,
            children: [
                /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                    className: $8af40cd9eab90ade$export$f8f4867693752cd4,
                    children: $956a291d4b8a52b8$var$slides.map((slide, index)=>/*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                            className: $8af40cd9eab90ade$export$a3b9b213fa74e4fd,
                            children: [
                                /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                                    className: `${$8af40cd9eab90ade$export$4aae642d10d55117} ${index === activeIndex ? $8af40cd9eab90ade$export$89da14300d534261 : ""}`,
                                    onClick: ()=>handleClick(index),
                                    children: [
                                        /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                                            src: index === activeIndex ? slide.icon : slide.inactiveIcon,
                                            alt: slide.title,
                                            className: $8af40cd9eab90ade$export$1ca1ec8b29a4ce27
                                        }),
                                        /*#__PURE__*/ (0, $j6whP.jsx)("svg", {
                                            className: $8af40cd9eab90ade$export$4662439d93cf9393,
                                            viewBox: "0 0 40 40",
                                            children: index === activeIndex && /*#__PURE__*/ (0, $j6whP.jsx)((0, $b8ce06c5a83cbe7c$export$e25e478948902b8b).circle, {
                                                className: $8af40cd9eab90ade$export$9d1298853f0e77f7,
                                                cx: "20",
                                                cy: "20",
                                                r: $956a291d4b8a52b8$var$RADIUS,
                                                strokeWidth: "2",
                                                strokeDasharray: $956a291d4b8a52b8$var$CIRCUMFERENCE,
                                                strokeDashoffset: (1 - progress / 100) * $956a291d4b8a52b8$var$CIRCUMFERENCE,
                                                animate: {
                                                    strokeDashoffset: (1 - progress / 100) * $956a291d4b8a52b8$var$CIRCUMFERENCE
                                                },
                                                transition: {
                                                    ease: "linear",
                                                    duration: 0.1
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                    className: $8af40cd9eab90ade$export$166cdd594250a057,
                                    children: slide.title
                                })
                            ]
                        }, slide.id))
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                    className: $8af40cd9eab90ade$export$8c62ad1d5ee878b,
                    children: $956a291d4b8a52b8$var$slides.map((slide, index)=>/*#__PURE__*/ (0, $j6whP.jsx)("img", {
                            src: isMobile ? slide.mobileImage : slide.image,
                            alt: slide.title,
                            className: `${$8af40cd9eab90ade$export$5793ae4811dedbe5} ${index === activeIndex ? $8af40cd9eab90ade$export$d5b53e8b3e00dc65 : ""}`
                        }, slide.id))
                })
            ]
        })
    });
};
var $956a291d4b8a52b8$export$2e2bcd8739ae039 = $956a291d4b8a52b8$var$ProductDetails;


const $ca6d0f1d2250f9b3$var$Home = ()=>{
    return /*#__PURE__*/ (0, $j6whP.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)((0, $1f95b3ed544e448b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $j6whP.jsx)((0, $956a291d4b8a52b8$export$2e2bcd8739ae039), {})
        ]
    });
};
var $ca6d0f1d2250f9b3$export$2e2bcd8739ae039 = $ca6d0f1d2250f9b3$var$Home;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

var $6b1721c40a71bd4a$exports = {};
(function(global, factory) {
    $6b1721c40a71bd4a$exports = factory();
})($6b1721c40a71bd4a$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});


const $8bc6cc3654b81cfa$var$Install = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const location = (0, $3a01a64de9a26688$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(location.search);
    const adSource = searchParams.get('adSource');
    const [ip, setIp] = (0, $1Pgvo.useState)(null);
    const [fbc, setFbc] = (0, $1Pgvo.useState)(null);
    const [fbp, setFbp] = (0, $1Pgvo.useState)(null);
    const [userAgent, setUserAgent] = (0, $1Pgvo.useState)(null);
    (0, $1Pgvo.useEffect)(()=>{
        // Get the _fbc and _fbp cookies
        const fbc = (0, (/*@__PURE__*/$parcel$interopDefault($6b1721c40a71bd4a$exports))).get('_fbc') || null; // Facebook Click ID (fbc)
        const fbp = (0, (/*@__PURE__*/$parcel$interopDefault($6b1721c40a71bd4a$exports))).get('_fbp') || null; // Facebook Pixel ID (fbp)
        const ua = navigator.userAgent || null;
        setFbc(fbc);
        setFbp(fbp);
        setUserAgent(ua);
        // Log the values to the console
        console.log("Facebook Click ID (fbc):", fbc);
        console.log("Facebook Pixel ID (fbp):", fbp);
        console.log("User Agent:", ua);
        fetch('https://api.ipify.org?format=json').then((response)=>response.json()).then((data)=>{
            const userIp = data.ip;
            setIp(userIp);
            console.log("User IP:", userIp);
            if (isValidData(userIp, fbc, fbp)) // If valid, send the API request
            sendApiRequest(userIp, fbc, fbp, ua);
            else {
                console.log("One or more required values are missing or invalid.");
                redirect(ua || "");
            }
        }).catch((error)=>{
            console.log("Error fetching IP address:", error);
            redirect(ua || "");
        });
    }, [
        navigate
    ]);
    // Function to validate if the data is not null, empty, or undefined
    const isValidData = (ip, fbc, fbp)=>{
        return ip && fbc && fbp && ip.trim() !== "" && fbc.trim() !== "" && fbp.trim() !== "";
    };
    const redirect = (userAgent)=>{
        console.log("Redirecting to App Store");
        console.log("User Agent:", userAgent);
        if (/android/i.test(userAgent)) window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
        else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        else window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln"; // Default to App Store
    };
    // Function to send the API request
    const sendApiRequest = (ip, fbc, fbp, ua)=>{
        const apiUrl = "https://tradeinsights.co.in/v1/api/metas/create";
        const payload = {
            ip: ip,
            fbc: fbc,
            fbp: fbp,
            user_agent: ua
        };
        if (adSource) {
            payload.ad_source = adSource;
            if (window.fbq && adSource == "tamil") {
                console.log("Attempting to send TamilAd event to Facebook Pixel");
                window.fbq('track', 'TamilAd');
                console.log("TamilAd event sent");
            } else console.log("Facebook Pixel not initialized or adSource is not 'tamil'");
        }
        fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json()).then((data)=>{
            console.log("API response:", data);
            // Redirect after API request is completed
            redirect(ua || "");
        }).catch((error)=>{
            console.log("Error sending API request:", error);
            redirect(ua || "");
        });
    };
    return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
};
var $8bc6cc3654b81cfa$export$2e2bcd8739ae039 = $8bc6cc3654b81cfa$var$Install;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

'use strict';
function $92356c31d031346a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $8HpnZ = parcelRequire("8HpnZ");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $78d097998daecff3$var$toString } = Object.prototype;
const { getPrototypeOf: $78d097998daecff3$var$getPrototypeOf } = Object;
const { iterator: $78d097998daecff3$var$iterator, toStringTag: $78d097998daecff3$var$toStringTag } = Symbol;
const $78d097998daecff3$var$kindOf = ((cache)=>(thing)=>{
        const str = $78d097998daecff3$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $78d097998daecff3$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$78d097998daecff3$var$kindOf(thing) === type;
};
const $78d097998daecff3$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $78d097998daecff3$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $78d097998daecff3$var$isUndefined = $78d097998daecff3$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $78d097998daecff3$var$isBuffer(val) {
    return val !== null && !$78d097998daecff3$var$isUndefined(val) && val.constructor !== null && !$78d097998daecff3$var$isUndefined(val.constructor) && $78d097998daecff3$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $78d097998daecff3$var$isArrayBuffer = $78d097998daecff3$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $78d097998daecff3$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $78d097998daecff3$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $78d097998daecff3$var$isString = $78d097998daecff3$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $78d097998daecff3$var$isFunction = $78d097998daecff3$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $78d097998daecff3$var$isNumber = $78d097998daecff3$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $78d097998daecff3$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $78d097998daecff3$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $78d097998daecff3$var$isPlainObject = (val)=>{
    if ($78d097998daecff3$var$kindOf(val) !== 'object') return false;
    const prototype = $78d097998daecff3$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($78d097998daecff3$var$toStringTag in val) && !($78d097998daecff3$var$iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $78d097998daecff3$var$isDate = $78d097998daecff3$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $78d097998daecff3$var$isFile = $78d097998daecff3$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $78d097998daecff3$var$isBlob = $78d097998daecff3$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $78d097998daecff3$var$isFileList = $78d097998daecff3$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $78d097998daecff3$var$isStream = (val)=>$78d097998daecff3$var$isObject(val) && $78d097998daecff3$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $78d097998daecff3$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $78d097998daecff3$var$isFunction(thing.append) && ((kind = $78d097998daecff3$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $78d097998daecff3$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $78d097998daecff3$var$isURLSearchParams = $78d097998daecff3$var$kindOfTest('URLSearchParams');
const [$78d097998daecff3$var$isReadableStream, $78d097998daecff3$var$isRequest, $78d097998daecff3$var$isResponse, $78d097998daecff3$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($78d097998daecff3$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $78d097998daecff3$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $78d097998daecff3$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($78d097998daecff3$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $78d097998daecff3$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $78d097998daecff3$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $78d097998daecff3$var$isContextDefined = (context)=>!$78d097998daecff3$var$isUndefined(context) && context !== $78d097998daecff3$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $78d097998daecff3$var$merge() {
    const { caseless: caseless } = $78d097998daecff3$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $78d097998daecff3$var$findKey(result, key) || key;
        if ($78d097998daecff3$var$isPlainObject(result[targetKey]) && $78d097998daecff3$var$isPlainObject(val)) result[targetKey] = $78d097998daecff3$var$merge(result[targetKey], val);
        else if ($78d097998daecff3$var$isPlainObject(val)) result[targetKey] = $78d097998daecff3$var$merge({}, val);
        else if ($78d097998daecff3$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $78d097998daecff3$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $78d097998daecff3$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $78d097998daecff3$var$forEach(b, (val, key)=>{
        if (thisArg && $78d097998daecff3$var$isFunction(val)) a[key] = (0, $92356c31d031346a$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $78d097998daecff3$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $78d097998daecff3$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $78d097998daecff3$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $78d097998daecff3$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $78d097998daecff3$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $78d097998daecff3$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($78d097998daecff3$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$78d097998daecff3$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $78d097998daecff3$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $78d097998daecff3$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $78d097998daecff3$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$78d097998daecff3$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $78d097998daecff3$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $78d097998daecff3$var$isHTMLForm = $78d097998daecff3$var$kindOfTest('HTMLFormElement');
const $78d097998daecff3$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $78d097998daecff3$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $78d097998daecff3$var$isRegExp = $78d097998daecff3$var$kindOfTest('RegExp');
const $78d097998daecff3$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $78d097998daecff3$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $78d097998daecff3$var$freezeMethods = (obj)=>{
    $78d097998daecff3$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($78d097998daecff3$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$78d097998daecff3$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $78d097998daecff3$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $78d097998daecff3$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $78d097998daecff3$var$noop = ()=>{};
const $78d097998daecff3$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $78d097998daecff3$var$isSpecCompliantForm(thing) {
    return !!(thing && $78d097998daecff3$var$isFunction(thing.append) && thing[$78d097998daecff3$var$toStringTag] === 'FormData' && thing[$78d097998daecff3$var$iterator]);
}
const $78d097998daecff3$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($78d097998daecff3$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $78d097998daecff3$var$isArray(source) ? [] : {};
                $78d097998daecff3$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$78d097998daecff3$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $78d097998daecff3$var$isAsyncFn = $78d097998daecff3$var$kindOfTest('AsyncFunction');
const $78d097998daecff3$var$isThenable = (thing)=>thing && ($78d097998daecff3$var$isObject(thing) || $78d097998daecff3$var$isFunction(thing)) && $78d097998daecff3$var$isFunction(thing.then) && $78d097998daecff3$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $78d097998daecff3$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $78d097998daecff3$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $78d097998daecff3$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $78d097998daecff3$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $78d097998daecff3$var$isFunction($78d097998daecff3$var$_global.postMessage));
const $78d097998daecff3$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($78d097998daecff3$var$_global) : typeof $8HpnZ !== 'undefined' && $8HpnZ.nextTick || $78d097998daecff3$var$_setImmediate;
// *********************
const $78d097998daecff3$var$isIterable = (thing)=>thing != null && $78d097998daecff3$var$isFunction(thing[$78d097998daecff3$var$iterator]);
var $78d097998daecff3$export$2e2bcd8739ae039 = {
    isArray: $78d097998daecff3$var$isArray,
    isArrayBuffer: $78d097998daecff3$var$isArrayBuffer,
    isBuffer: $78d097998daecff3$var$isBuffer,
    isFormData: $78d097998daecff3$var$isFormData,
    isArrayBufferView: $78d097998daecff3$var$isArrayBufferView,
    isString: $78d097998daecff3$var$isString,
    isNumber: $78d097998daecff3$var$isNumber,
    isBoolean: $78d097998daecff3$var$isBoolean,
    isObject: $78d097998daecff3$var$isObject,
    isPlainObject: $78d097998daecff3$var$isPlainObject,
    isReadableStream: $78d097998daecff3$var$isReadableStream,
    isRequest: $78d097998daecff3$var$isRequest,
    isResponse: $78d097998daecff3$var$isResponse,
    isHeaders: $78d097998daecff3$var$isHeaders,
    isUndefined: $78d097998daecff3$var$isUndefined,
    isDate: $78d097998daecff3$var$isDate,
    isFile: $78d097998daecff3$var$isFile,
    isBlob: $78d097998daecff3$var$isBlob,
    isRegExp: $78d097998daecff3$var$isRegExp,
    isFunction: $78d097998daecff3$var$isFunction,
    isStream: $78d097998daecff3$var$isStream,
    isURLSearchParams: $78d097998daecff3$var$isURLSearchParams,
    isTypedArray: $78d097998daecff3$var$isTypedArray,
    isFileList: $78d097998daecff3$var$isFileList,
    forEach: $78d097998daecff3$var$forEach,
    merge: $78d097998daecff3$var$merge,
    extend: $78d097998daecff3$var$extend,
    trim: $78d097998daecff3$var$trim,
    stripBOM: $78d097998daecff3$var$stripBOM,
    inherits: $78d097998daecff3$var$inherits,
    toFlatObject: $78d097998daecff3$var$toFlatObject,
    kindOf: $78d097998daecff3$var$kindOf,
    kindOfTest: $78d097998daecff3$var$kindOfTest,
    endsWith: $78d097998daecff3$var$endsWith,
    toArray: $78d097998daecff3$var$toArray,
    forEachEntry: $78d097998daecff3$var$forEachEntry,
    matchAll: $78d097998daecff3$var$matchAll,
    isHTMLForm: $78d097998daecff3$var$isHTMLForm,
    hasOwnProperty: $78d097998daecff3$var$hasOwnProperty,
    hasOwnProp: $78d097998daecff3$var$hasOwnProperty,
    reduceDescriptors: $78d097998daecff3$var$reduceDescriptors,
    freezeMethods: $78d097998daecff3$var$freezeMethods,
    toObjectSet: $78d097998daecff3$var$toObjectSet,
    toCamelCase: $78d097998daecff3$var$toCamelCase,
    noop: $78d097998daecff3$var$noop,
    toFiniteNumber: $78d097998daecff3$var$toFiniteNumber,
    findKey: $78d097998daecff3$var$findKey,
    global: $78d097998daecff3$var$_global,
    isContextDefined: $78d097998daecff3$var$isContextDefined,
    isSpecCompliantForm: $78d097998daecff3$var$isSpecCompliantForm,
    toJSONObject: $78d097998daecff3$var$toJSONObject,
    isAsyncFn: $78d097998daecff3$var$isAsyncFn,
    isThenable: $78d097998daecff3$var$isThenable,
    setImmediate: $78d097998daecff3$var$_setImmediate,
    asap: $78d097998daecff3$var$asap,
    isIterable: $78d097998daecff3$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $63cec14df7019cd3$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $78d097998daecff3$export$2e2bcd8739ae039).inherits($63cec14df7019cd3$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $78d097998daecff3$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $63cec14df7019cd3$var$prototype = $63cec14df7019cd3$var$AxiosError.prototype;
const $63cec14df7019cd3$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $63cec14df7019cd3$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($63cec14df7019cd3$var$AxiosError, $63cec14df7019cd3$var$descriptors);
Object.defineProperty($63cec14df7019cd3$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$63cec14df7019cd3$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($63cec14df7019cd3$var$prototype);
    (0, $78d097998daecff3$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $63cec14df7019cd3$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $63cec14df7019cd3$export$2e2bcd8739ae039 = $63cec14df7019cd3$var$AxiosError;


// eslint-disable-next-line strict
var $bc8ed6826e20ddf1$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $128b1bde7f3e4fd5$export$a143d493d941bafc;
var $128b1bde7f3e4fd5$export$e4cf37d7f6fb9e0a;
var $128b1bde7f3e4fd5$export$f99ded8fe4b79145;
var $128b1bde7f3e4fd5$export$599f31c3813fae4d;
'use strict';
var $635016bb95fc918f$export$a48f0734ac7c2329;
var $635016bb95fc918f$export$d622b2ad8d90c771;
var $635016bb95fc918f$export$6100ba28696e12de;
'use strict';
$635016bb95fc918f$export$a48f0734ac7c2329 = $635016bb95fc918f$var$byteLength;
$635016bb95fc918f$export$d622b2ad8d90c771 = $635016bb95fc918f$var$toByteArray;
$635016bb95fc918f$export$6100ba28696e12de = $635016bb95fc918f$var$fromByteArray;
var $635016bb95fc918f$var$lookup = [];
var $635016bb95fc918f$var$revLookup = [];
var $635016bb95fc918f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $635016bb95fc918f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $635016bb95fc918f$var$i = 0, $635016bb95fc918f$var$len = $635016bb95fc918f$var$code.length; $635016bb95fc918f$var$i < $635016bb95fc918f$var$len; ++$635016bb95fc918f$var$i){
    $635016bb95fc918f$var$lookup[$635016bb95fc918f$var$i] = $635016bb95fc918f$var$code[$635016bb95fc918f$var$i];
    $635016bb95fc918f$var$revLookup[$635016bb95fc918f$var$code.charCodeAt($635016bb95fc918f$var$i)] = $635016bb95fc918f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$635016bb95fc918f$var$revLookup['-'.charCodeAt(0)] = 62;
$635016bb95fc918f$var$revLookup['_'.charCodeAt(0)] = 63;
function $635016bb95fc918f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $635016bb95fc918f$var$byteLength(b64) {
    var lens = $635016bb95fc918f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $635016bb95fc918f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $635016bb95fc918f$var$toByteArray(b64) {
    var tmp;
    var lens = $635016bb95fc918f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $635016bb95fc918f$var$Arr($635016bb95fc918f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $635016bb95fc918f$var$revLookup[b64.charCodeAt(i)] << 18 | $635016bb95fc918f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $635016bb95fc918f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $635016bb95fc918f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $635016bb95fc918f$var$revLookup[b64.charCodeAt(i)] << 2 | $635016bb95fc918f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $635016bb95fc918f$var$revLookup[b64.charCodeAt(i)] << 10 | $635016bb95fc918f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $635016bb95fc918f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $635016bb95fc918f$var$tripletToBase64(num) {
    return $635016bb95fc918f$var$lookup[num >> 18 & 0x3F] + $635016bb95fc918f$var$lookup[num >> 12 & 0x3F] + $635016bb95fc918f$var$lookup[num >> 6 & 0x3F] + $635016bb95fc918f$var$lookup[num & 0x3F];
}
function $635016bb95fc918f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($635016bb95fc918f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $635016bb95fc918f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($635016bb95fc918f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($635016bb95fc918f$var$lookup[tmp >> 2] + $635016bb95fc918f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($635016bb95fc918f$var$lookup[tmp >> 10] + $635016bb95fc918f$var$lookup[tmp >> 4 & 0x3F] + $635016bb95fc918f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $eef092a82e37a0c8$export$aafa59e2e03f2942;
var $eef092a82e37a0c8$export$68d8715fc104d294;
$eef092a82e37a0c8$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$eef092a82e37a0c8$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $128b1bde7f3e4fd5$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$128b1bde7f3e4fd5$export$a143d493d941bafc = $128b1bde7f3e4fd5$var$Buffer;
$128b1bde7f3e4fd5$export$e4cf37d7f6fb9e0a = $128b1bde7f3e4fd5$var$SlowBuffer;
$128b1bde7f3e4fd5$export$f99ded8fe4b79145 = 50;
const $128b1bde7f3e4fd5$var$K_MAX_LENGTH = 0x7fffffff;
$128b1bde7f3e4fd5$export$599f31c3813fae4d = $128b1bde7f3e4fd5$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $128b1bde7f3e4fd5$var$Buffer.TYPED_ARRAY_SUPPORT = $128b1bde7f3e4fd5$var$typedArraySupport();
if (!$128b1bde7f3e4fd5$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $128b1bde7f3e4fd5$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($128b1bde7f3e4fd5$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$128b1bde7f3e4fd5$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($128b1bde7f3e4fd5$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$128b1bde7f3e4fd5$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $128b1bde7f3e4fd5$var$createBuffer(length) {
    if (length > $128b1bde7f3e4fd5$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $128b1bde7f3e4fd5$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $128b1bde7f3e4fd5$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $128b1bde7f3e4fd5$var$allocUnsafe(arg);
    }
    return $128b1bde7f3e4fd5$var$from(arg, encodingOrOffset, length);
}
$128b1bde7f3e4fd5$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $128b1bde7f3e4fd5$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $128b1bde7f3e4fd5$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $128b1bde7f3e4fd5$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($128b1bde7f3e4fd5$var$isInstance(value, ArrayBuffer) || value && $128b1bde7f3e4fd5$var$isInstance(value.buffer, ArrayBuffer)) return $128b1bde7f3e4fd5$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($128b1bde7f3e4fd5$var$isInstance(value, SharedArrayBuffer) || value && $128b1bde7f3e4fd5$var$isInstance(value.buffer, SharedArrayBuffer))) return $128b1bde7f3e4fd5$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $128b1bde7f3e4fd5$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $128b1bde7f3e4fd5$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $128b1bde7f3e4fd5$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $128b1bde7f3e4fd5$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $128b1bde7f3e4fd5$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($128b1bde7f3e4fd5$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($128b1bde7f3e4fd5$var$Buffer, Uint8Array);
function $128b1bde7f3e4fd5$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $128b1bde7f3e4fd5$var$alloc(size, fill, encoding) {
    $128b1bde7f3e4fd5$var$assertSize(size);
    if (size <= 0) return $128b1bde7f3e4fd5$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $128b1bde7f3e4fd5$var$createBuffer(size).fill(fill, encoding) : $128b1bde7f3e4fd5$var$createBuffer(size).fill(fill);
    return $128b1bde7f3e4fd5$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $128b1bde7f3e4fd5$var$Buffer.alloc = function(size, fill, encoding) {
    return $128b1bde7f3e4fd5$var$alloc(size, fill, encoding);
};
function $128b1bde7f3e4fd5$var$allocUnsafe(size) {
    $128b1bde7f3e4fd5$var$assertSize(size);
    return $128b1bde7f3e4fd5$var$createBuffer(size < 0 ? 0 : $128b1bde7f3e4fd5$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $128b1bde7f3e4fd5$var$Buffer.allocUnsafe = function(size) {
    return $128b1bde7f3e4fd5$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $128b1bde7f3e4fd5$var$Buffer.allocUnsafeSlow = function(size) {
    return $128b1bde7f3e4fd5$var$allocUnsafe(size);
};
function $128b1bde7f3e4fd5$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$128b1bde7f3e4fd5$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $128b1bde7f3e4fd5$var$byteLength(string, encoding) | 0;
    let buf = $128b1bde7f3e4fd5$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $128b1bde7f3e4fd5$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $128b1bde7f3e4fd5$var$checked(array.length) | 0;
    const buf = $128b1bde7f3e4fd5$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $128b1bde7f3e4fd5$var$fromArrayView(arrayView) {
    if ($128b1bde7f3e4fd5$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $128b1bde7f3e4fd5$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $128b1bde7f3e4fd5$var$fromArrayLike(arrayView);
}
function $128b1bde7f3e4fd5$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $128b1bde7f3e4fd5$var$Buffer.prototype);
    return buf;
}
function $128b1bde7f3e4fd5$var$fromObject(obj) {
    if ($128b1bde7f3e4fd5$var$Buffer.isBuffer(obj)) {
        const len = $128b1bde7f3e4fd5$var$checked(obj.length) | 0;
        const buf = $128b1bde7f3e4fd5$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $128b1bde7f3e4fd5$var$numberIsNaN(obj.length)) return $128b1bde7f3e4fd5$var$createBuffer(0);
        return $128b1bde7f3e4fd5$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $128b1bde7f3e4fd5$var$fromArrayLike(obj.data);
}
function $128b1bde7f3e4fd5$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $128b1bde7f3e4fd5$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $128b1bde7f3e4fd5$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $128b1bde7f3e4fd5$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $128b1bde7f3e4fd5$var$Buffer.alloc(+length);
}
$128b1bde7f3e4fd5$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $128b1bde7f3e4fd5$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$128b1bde7f3e4fd5$var$Buffer.compare = function compare(a, b) {
    if ($128b1bde7f3e4fd5$var$isInstance(a, Uint8Array)) a = $128b1bde7f3e4fd5$var$Buffer.from(a, a.offset, a.byteLength);
    if ($128b1bde7f3e4fd5$var$isInstance(b, Uint8Array)) b = $128b1bde7f3e4fd5$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$128b1bde7f3e4fd5$var$Buffer.isBuffer(a) || !$128b1bde7f3e4fd5$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$128b1bde7f3e4fd5$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$128b1bde7f3e4fd5$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $128b1bde7f3e4fd5$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $128b1bde7f3e4fd5$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($128b1bde7f3e4fd5$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$128b1bde7f3e4fd5$var$Buffer.isBuffer(buf)) buf = $128b1bde7f3e4fd5$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$128b1bde7f3e4fd5$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $128b1bde7f3e4fd5$var$byteLength(string, encoding) {
    if ($128b1bde7f3e4fd5$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $128b1bde7f3e4fd5$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $128b1bde7f3e4fd5$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $128b1bde7f3e4fd5$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $128b1bde7f3e4fd5$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$128b1bde7f3e4fd5$var$Buffer.byteLength = $128b1bde7f3e4fd5$var$byteLength;
function $128b1bde7f3e4fd5$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $128b1bde7f3e4fd5$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $128b1bde7f3e4fd5$var$utf8Slice(this, start, end);
        case 'ascii':
            return $128b1bde7f3e4fd5$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $128b1bde7f3e4fd5$var$latin1Slice(this, start, end);
        case 'base64':
            return $128b1bde7f3e4fd5$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $128b1bde7f3e4fd5$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$128b1bde7f3e4fd5$var$Buffer.prototype._isBuffer = true;
function $128b1bde7f3e4fd5$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$128b1bde7f3e4fd5$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$128b1bde7f3e4fd5$var$swap(this, i, i + 1);
    return this;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $128b1bde7f3e4fd5$var$swap(this, i, i + 3);
        $128b1bde7f3e4fd5$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $128b1bde7f3e4fd5$var$swap(this, i, i + 7);
        $128b1bde7f3e4fd5$var$swap(this, i + 1, i + 6);
        $128b1bde7f3e4fd5$var$swap(this, i + 2, i + 5);
        $128b1bde7f3e4fd5$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $128b1bde7f3e4fd5$var$utf8Slice(this, 0, length);
    return $128b1bde7f3e4fd5$var$slowToString.apply(this, arguments);
};
$128b1bde7f3e4fd5$var$Buffer.prototype.toLocaleString = $128b1bde7f3e4fd5$var$Buffer.prototype.toString;
$128b1bde7f3e4fd5$var$Buffer.prototype.equals = function equals(b) {
    if (!$128b1bde7f3e4fd5$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $128b1bde7f3e4fd5$var$Buffer.compare(this, b) === 0;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $128b1bde7f3e4fd5$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($128b1bde7f3e4fd5$var$customInspectSymbol) $128b1bde7f3e4fd5$var$Buffer.prototype[$128b1bde7f3e4fd5$var$customInspectSymbol] = $128b1bde7f3e4fd5$var$Buffer.prototype.inspect;
$128b1bde7f3e4fd5$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($128b1bde7f3e4fd5$var$isInstance(target, Uint8Array)) target = $128b1bde7f3e4fd5$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$128b1bde7f3e4fd5$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $128b1bde7f3e4fd5$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($128b1bde7f3e4fd5$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $128b1bde7f3e4fd5$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($128b1bde7f3e4fd5$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $128b1bde7f3e4fd5$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $128b1bde7f3e4fd5$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $128b1bde7f3e4fd5$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$128b1bde7f3e4fd5$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $128b1bde7f3e4fd5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$128b1bde7f3e4fd5$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $128b1bde7f3e4fd5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $128b1bde7f3e4fd5$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($128b1bde7f3e4fd5$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $128b1bde7f3e4fd5$var$utf8Write(buf, string, offset, length) {
    return $128b1bde7f3e4fd5$var$blitBuffer($128b1bde7f3e4fd5$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $128b1bde7f3e4fd5$var$asciiWrite(buf, string, offset, length) {
    return $128b1bde7f3e4fd5$var$blitBuffer($128b1bde7f3e4fd5$var$asciiToBytes(string), buf, offset, length);
}
function $128b1bde7f3e4fd5$var$base64Write(buf, string, offset, length) {
    return $128b1bde7f3e4fd5$var$blitBuffer($128b1bde7f3e4fd5$var$base64ToBytes(string), buf, offset, length);
}
function $128b1bde7f3e4fd5$var$ucs2Write(buf, string, offset, length) {
    return $128b1bde7f3e4fd5$var$blitBuffer($128b1bde7f3e4fd5$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$128b1bde7f3e4fd5$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $128b1bde7f3e4fd5$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $128b1bde7f3e4fd5$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $128b1bde7f3e4fd5$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $128b1bde7f3e4fd5$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $128b1bde7f3e4fd5$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$128b1bde7f3e4fd5$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $128b1bde7f3e4fd5$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $635016bb95fc918f$export$6100ba28696e12de(buf);
    else return $635016bb95fc918f$export$6100ba28696e12de(buf.slice(start, end));
}
function $128b1bde7f3e4fd5$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $128b1bde7f3e4fd5$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $128b1bde7f3e4fd5$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $128b1bde7f3e4fd5$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $128b1bde7f3e4fd5$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $128b1bde7f3e4fd5$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $128b1bde7f3e4fd5$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $128b1bde7f3e4fd5$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $128b1bde7f3e4fd5$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $128b1bde7f3e4fd5$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $128b1bde7f3e4fd5$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$128b1bde7f3e4fd5$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $128b1bde7f3e4fd5$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $128b1bde7f3e4fd5$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$128b1bde7f3e4fd5$var$Buffer.prototype.readUintLE = $128b1bde7f3e4fd5$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readUintBE = $128b1bde7f3e4fd5$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readUint8 = $128b1bde7f3e4fd5$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readUint16LE = $128b1bde7f3e4fd5$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readUint16BE = $128b1bde7f3e4fd5$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readUint32LE = $128b1bde7f3e4fd5$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readUint32BE = $128b1bde7f3e4fd5$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readBigUInt64LE = $128b1bde7f3e4fd5$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $128b1bde7f3e4fd5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $128b1bde7f3e4fd5$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$128b1bde7f3e4fd5$var$Buffer.prototype.readBigUInt64BE = $128b1bde7f3e4fd5$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $128b1bde7f3e4fd5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $128b1bde7f3e4fd5$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$128b1bde7f3e4fd5$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readBigInt64LE = $128b1bde7f3e4fd5$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $128b1bde7f3e4fd5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $128b1bde7f3e4fd5$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$128b1bde7f3e4fd5$var$Buffer.prototype.readBigInt64BE = $128b1bde7f3e4fd5$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $128b1bde7f3e4fd5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $128b1bde7f3e4fd5$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$128b1bde7f3e4fd5$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 4, this.length);
    return $eef092a82e37a0c8$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 4, this.length);
    return $eef092a82e37a0c8$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 8, this.length);
    return $eef092a82e37a0c8$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$128b1bde7f3e4fd5$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkOffset(offset, 8, this.length);
    return $eef092a82e37a0c8$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $128b1bde7f3e4fd5$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$128b1bde7f3e4fd5$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$128b1bde7f3e4fd5$var$Buffer.prototype.writeUintLE = $128b1bde7f3e4fd5$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $128b1bde7f3e4fd5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeUintBE = $128b1bde7f3e4fd5$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $128b1bde7f3e4fd5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeUint8 = $128b1bde7f3e4fd5$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeUint16LE = $128b1bde7f3e4fd5$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeUint16BE = $128b1bde7f3e4fd5$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeUint32LE = $128b1bde7f3e4fd5$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeUint32BE = $128b1bde7f3e4fd5$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $128b1bde7f3e4fd5$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $128b1bde7f3e4fd5$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $128b1bde7f3e4fd5$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $128b1bde7f3e4fd5$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$128b1bde7f3e4fd5$var$Buffer.prototype.writeBigUInt64LE = $128b1bde7f3e4fd5$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $128b1bde7f3e4fd5$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$128b1bde7f3e4fd5$var$Buffer.prototype.writeBigUInt64BE = $128b1bde7f3e4fd5$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $128b1bde7f3e4fd5$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$128b1bde7f3e4fd5$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $128b1bde7f3e4fd5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $128b1bde7f3e4fd5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeBigInt64LE = $128b1bde7f3e4fd5$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $128b1bde7f3e4fd5$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$128b1bde7f3e4fd5$var$Buffer.prototype.writeBigInt64BE = $128b1bde7f3e4fd5$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $128b1bde7f3e4fd5$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $128b1bde7f3e4fd5$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $128b1bde7f3e4fd5$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $eef092a82e37a0c8$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$128b1bde7f3e4fd5$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $128b1bde7f3e4fd5$var$writeFloat(this, value, offset, true, noAssert);
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $128b1bde7f3e4fd5$var$writeFloat(this, value, offset, false, noAssert);
};
function $128b1bde7f3e4fd5$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $128b1bde7f3e4fd5$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $eef092a82e37a0c8$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$128b1bde7f3e4fd5$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $128b1bde7f3e4fd5$var$writeDouble(this, value, offset, true, noAssert);
};
$128b1bde7f3e4fd5$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $128b1bde7f3e4fd5$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$128b1bde7f3e4fd5$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$128b1bde7f3e4fd5$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$128b1bde7f3e4fd5$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$128b1bde7f3e4fd5$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $128b1bde7f3e4fd5$var$Buffer.isBuffer(val) ? val : $128b1bde7f3e4fd5$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $128b1bde7f3e4fd5$var$errors = {};
function $128b1bde7f3e4fd5$var$E(sym, getMessage, Base) {
    $128b1bde7f3e4fd5$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$128b1bde7f3e4fd5$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$128b1bde7f3e4fd5$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$128b1bde7f3e4fd5$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $128b1bde7f3e4fd5$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $128b1bde7f3e4fd5$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $128b1bde7f3e4fd5$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $128b1bde7f3e4fd5$var$checkBounds(buf, offset, byteLength) {
    $128b1bde7f3e4fd5$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $128b1bde7f3e4fd5$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $128b1bde7f3e4fd5$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $128b1bde7f3e4fd5$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $128b1bde7f3e4fd5$var$checkBounds(buf, offset, byteLength);
}
function $128b1bde7f3e4fd5$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $128b1bde7f3e4fd5$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $128b1bde7f3e4fd5$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $128b1bde7f3e4fd5$var$validateNumber(value, type);
        throw new $128b1bde7f3e4fd5$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $128b1bde7f3e4fd5$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $128b1bde7f3e4fd5$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $128b1bde7f3e4fd5$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $128b1bde7f3e4fd5$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($128b1bde7f3e4fd5$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $128b1bde7f3e4fd5$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $128b1bde7f3e4fd5$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $128b1bde7f3e4fd5$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $128b1bde7f3e4fd5$var$base64ToBytes(str) {
    return $635016bb95fc918f$export$d622b2ad8d90c771($128b1bde7f3e4fd5$var$base64clean(str));
}
function $128b1bde7f3e4fd5$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $128b1bde7f3e4fd5$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $128b1bde7f3e4fd5$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $128b1bde7f3e4fd5$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $128b1bde7f3e4fd5$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $128b1bde7f3e4fd5$var$BufferBigIntNotDefined : fn;
}
function $128b1bde7f3e4fd5$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $84cbb2a477baae82$require$Buffer = $128b1bde7f3e4fd5$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $84cbb2a477baae82$var$isVisitable(thing) {
    return (0, $78d097998daecff3$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $84cbb2a477baae82$var$removeBrackets(key) {
    return (0, $78d097998daecff3$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $84cbb2a477baae82$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $84cbb2a477baae82$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $84cbb2a477baae82$var$isFlatArray(arr) {
    return (0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(arr) && !arr.some($84cbb2a477baae82$var$isVisitable);
}
const $84cbb2a477baae82$var$predicates = (0, $78d097998daecff3$export$2e2bcd8739ae039).toFlatObject((0, $78d097998daecff3$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $84cbb2a477baae82$var$toFormData(obj, formData, options) {
    if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $bc8ed6826e20ddf1$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $78d097998daecff3$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $78d097998daecff3$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $78d097998daecff3$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $78d097998daecff3$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $78d097998daecff3$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $84cbb2a477baae82$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $78d097998daecff3$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(value) && $84cbb2a477baae82$var$isFlatArray(value) || ((0, $78d097998daecff3$export$2e2bcd8739ae039).isFileList(value) || (0, $78d097998daecff3$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $78d097998daecff3$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $84cbb2a477baae82$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $78d097998daecff3$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $84cbb2a477baae82$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($84cbb2a477baae82$var$isVisitable(value)) return true;
        formData.append($84cbb2a477baae82$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($84cbb2a477baae82$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $84cbb2a477baae82$var$isVisitable
    });
    function build(value, path) {
        if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $78d097998daecff3$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $78d097998daecff3$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $78d097998daecff3$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $84cbb2a477baae82$export$2e2bcd8739ae039 = $84cbb2a477baae82$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $37cbef8d44d3154f$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $37cbef8d44d3154f$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $84cbb2a477baae82$export$2e2bcd8739ae039)(params, this, options);
}
const $37cbef8d44d3154f$var$prototype = $37cbef8d44d3154f$var$AxiosURLSearchParams.prototype;
$37cbef8d44d3154f$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$37cbef8d44d3154f$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $37cbef8d44d3154f$var$encode);
    } : $37cbef8d44d3154f$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $37cbef8d44d3154f$export$2e2bcd8739ae039 = $37cbef8d44d3154f$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $0c81bbe428969e5d$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $0c81bbe428969e5d$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $0c81bbe428969e5d$var$encode;
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $78d097998daecff3$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $37cbef8d44d3154f$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $6fc1764a9c4de2f3$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $78d097998daecff3$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $6fc1764a9c4de2f3$export$2e2bcd8739ae039 = $6fc1764a9c4de2f3$var$InterceptorManager;





'use strict';
var $5607e13f3be2c8d9$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $ce76068b847123b0$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $37cbef8d44d3154f$export$2e2bcd8739ae039);


'use strict';
var $eac54e51873c5cea$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $dca1604f055ca549$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $5229a31dcc602dd2$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $ce76068b847123b0$export$2e2bcd8739ae039,
        FormData: $eac54e51873c5cea$export$2e2bcd8739ae039,
        Blob: $dca1604f055ca549$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $129fef9cd3834baa$exports = {};

$parcel$export($129fef9cd3834baa$exports, "hasBrowserEnv", function () { return $129fef9cd3834baa$export$c4996c4b7b93b0bf; });
$parcel$export($129fef9cd3834baa$exports, "navigator", function () { return $129fef9cd3834baa$export$ec7c8efa7f5790ae; });
$parcel$export($129fef9cd3834baa$exports, "hasStandardBrowserEnv", function () { return $129fef9cd3834baa$export$c0bcc9250309d66; });
$parcel$export($129fef9cd3834baa$exports, "hasStandardBrowserWebWorkerEnv", function () { return $129fef9cd3834baa$export$c81692cf5af97dac; });
$parcel$export($129fef9cd3834baa$exports, "origin", function () { return $129fef9cd3834baa$export$f710a83a91838a36; });
const $129fef9cd3834baa$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $129fef9cd3834baa$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $129fef9cd3834baa$export$c0bcc9250309d66 = $129fef9cd3834baa$export$c4996c4b7b93b0bf && (!$129fef9cd3834baa$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($129fef9cd3834baa$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $129fef9cd3834baa$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $129fef9cd3834baa$export$f710a83a91838a36 = $129fef9cd3834baa$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $94196277001e1b77$export$2e2bcd8739ae039 = {
    ...$129fef9cd3834baa$exports,
    ...(0, $5229a31dcc602dd2$export$2e2bcd8739ae039)
};


'use strict';
function $2791f2cf55ff5dd6$export$2e2bcd8739ae039(data, options) {
    return (0, $84cbb2a477baae82$export$2e2bcd8739ae039)(data, new (0, $94196277001e1b77$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $94196277001e1b77$export$2e2bcd8739ae039).isNode && (0, $78d097998daecff3$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $ad6589769dfea67d$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $78d097998daecff3$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $ad6589769dfea67d$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $ad6589769dfea67d$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $78d097998daecff3$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $78d097998daecff3$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $ad6589769dfea67d$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isFormData(formData) && (0, $78d097998daecff3$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $78d097998daecff3$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($ad6589769dfea67d$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $ad6589769dfea67d$export$2e2bcd8739ae039 = $ad6589769dfea67d$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $00882ed47bcc1c13$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $78d097998daecff3$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $00882ed47bcc1c13$var$defaults = {
    transitional: (0, $5607e13f3be2c8d9$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $78d097998daecff3$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $78d097998daecff3$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $78d097998daecff3$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $ad6589769dfea67d$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $78d097998daecff3$export$2e2bcd8739ae039).isBuffer(data) || (0, $78d097998daecff3$export$2e2bcd8739ae039).isStream(data) || (0, $78d097998daecff3$export$2e2bcd8739ae039).isFile(data) || (0, $78d097998daecff3$export$2e2bcd8739ae039).isBlob(data) || (0, $78d097998daecff3$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $2791f2cf55ff5dd6$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $78d097998daecff3$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $84cbb2a477baae82$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $00882ed47bcc1c13$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $00882ed47bcc1c13$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isResponse(data) || (0, $78d097998daecff3$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $78d097998daecff3$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $63cec14df7019cd3$export$2e2bcd8739ae039).from(e, (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $94196277001e1b77$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $94196277001e1b77$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $78d097998daecff3$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $00882ed47bcc1c13$var$defaults.headers[method] = {};
});
var $00882ed47bcc1c13$export$2e2bcd8739ae039 = $00882ed47bcc1c13$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $afc1a86007973020$var$ignoreDuplicateOf = (0, $78d097998daecff3$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $afc1a86007973020$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $afc1a86007973020$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $c5555279aa297c80$var$$internals = Symbol('internals');
function $c5555279aa297c80$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c5555279aa297c80$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(value) ? value.map($c5555279aa297c80$var$normalizeValue) : String(value);
}
function $c5555279aa297c80$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c5555279aa297c80$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c5555279aa297c80$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c5555279aa297c80$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c5555279aa297c80$var$buildAccessors(obj, header) {
    const accessorName = (0, $78d097998daecff3$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c5555279aa297c80$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c5555279aa297c80$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $78d097998daecff3$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c5555279aa297c80$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $78d097998daecff3$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c5555279aa297c80$var$isValidHeaderName(header)) setHeaders((0, $afc1a86007973020$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isObject(header) && (0, $78d097998daecff3$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c5555279aa297c80$var$normalizeHeader(header);
        if (header) {
            const key = (0, $78d097998daecff3$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c5555279aa297c80$var$parseTokens(value);
                if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $c5555279aa297c80$var$normalizeHeader(header);
        if (header) {
            const key = (0, $78d097998daecff3$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c5555279aa297c80$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c5555279aa297c80$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $78d097998daecff3$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c5555279aa297c80$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c5555279aa297c80$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $78d097998daecff3$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $78d097998daecff3$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c5555279aa297c80$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c5555279aa297c80$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c5555279aa297c80$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $78d097998daecff3$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c5555279aa297c80$var$$internals] = this[$c5555279aa297c80$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c5555279aa297c80$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c5555279aa297c80$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c5555279aa297c80$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $78d097998daecff3$export$2e2bcd8739ae039).reduceDescriptors($c5555279aa297c80$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $78d097998daecff3$export$2e2bcd8739ae039).freezeMethods($c5555279aa297c80$var$AxiosHeaders);
var $c5555279aa297c80$export$2e2bcd8739ae039 = $c5555279aa297c80$var$AxiosHeaders;


'use strict';
function $657c64f3abc21d54$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $00882ed47bcc1c13$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c5555279aa297c80$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $78d097998daecff3$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $8ada1211d073acd1$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $d7710a8d967d432b$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $63cec14df7019cd3$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $78d097998daecff3$export$2e2bcd8739ae039).inherits($d7710a8d967d432b$var$CanceledError, (0, $63cec14df7019cd3$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $d7710a8d967d432b$export$2e2bcd8739ae039 = $d7710a8d967d432b$var$CanceledError;







'use strict';
function $5ca5e7791ff51224$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $4dd98203b4a5d463$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $386d27dfbc7fa910$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $386d27dfbc7fa910$export$2e2bcd8739ae039 = $386d27dfbc7fa910$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $2b92d51acf7685c1$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $2b92d51acf7685c1$export$2e2bcd8739ae039 = $2b92d51acf7685c1$var$throttle;



const $3bcd6d05dc22fcfe$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $386d27dfbc7fa910$export$2e2bcd8739ae039)(50, 250);
    return (0, $2b92d51acf7685c1$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $3bcd6d05dc22fcfe$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $3bcd6d05dc22fcfe$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $78d097998daecff3$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $2fda08d7bf369e17$export$2e2bcd8739ae039 = (0, $94196277001e1b77$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $94196277001e1b77$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $94196277001e1b77$export$2e2bcd8739ae039).origin), (0, $94196277001e1b77$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $94196277001e1b77$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $d9c8cce0303f4146$export$2e2bcd8739ae039 = (0, $94196277001e1b77$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $78d097998daecff3$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $78d097998daecff3$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $78d097998daecff3$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $a3cc7b5b8447edfe$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $6af419607aae9bcc$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $448fdcfc4cfec978$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $a3cc7b5b8447edfe$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $6af419607aae9bcc$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $22029fa0d769cc39$var$headersToObject = (thing)=>thing instanceof (0, $c5555279aa297c80$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $22029fa0d769cc39$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isPlainObject(target) && (0, $78d097998daecff3$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $78d097998daecff3$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $78d097998daecff3$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($22029fa0d769cc39$var$headersToObject(a), $22029fa0d769cc39$var$headersToObject(b), prop, true)
    };
    (0, $78d097998daecff3$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $78d097998daecff3$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $946f6395b9af620b$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $22029fa0d769cc39$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $c5555279aa297c80$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $0c81bbe428969e5d$export$2e2bcd8739ae039)((0, $448fdcfc4cfec978$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $94196277001e1b77$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $94196277001e1b77$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $94196277001e1b77$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $78d097998daecff3$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $2fda08d7bf369e17$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $d9c8cce0303f4146$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $4a3057f2c82bfade$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $4a3057f2c82bfade$export$2e2bcd8739ae039 = $4a3057f2c82bfade$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $946f6395b9af620b$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $c5555279aa297c80$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c5555279aa297c80$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $5ca5e7791ff51224$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)('Request aborted', (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)('Network Error', (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $5607e13f3be2c8d9$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ETIMEDOUT : (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $78d097998daecff3$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $3bcd6d05dc22fcfe$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $3bcd6d05dc22fcfe$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $d7710a8d967d432b$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $4dd98203b4a5d463$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $94196277001e1b77$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $423dae7d34cb15b1$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $63cec14df7019cd3$export$2e2bcd8739ae039) ? err : new (0, $d7710a8d967d432b$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $78d097998daecff3$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $423dae7d34cb15b1$export$2e2bcd8739ae039 = $423dae7d34cb15b1$var$composeSignals;


const $e8ba94358d3d781e$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $e8ba94358d3d781e$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $e8ba94358d3d781e$var$readStream(iterable))yield* $e8ba94358d3d781e$export$71b051935044bd5d(chunk, chunkSize);
};
const $e8ba94358d3d781e$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $e8ba94358d3d781e$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $e8ba94358d3d781e$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $476261531bb8fadd$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $476261531bb8fadd$var$isReadableStreamSupported = $476261531bb8fadd$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $476261531bb8fadd$var$encodeText = $476261531bb8fadd$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $476261531bb8fadd$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $476261531bb8fadd$var$supportsRequestStream = $476261531bb8fadd$var$isReadableStreamSupported && $476261531bb8fadd$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $94196277001e1b77$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $476261531bb8fadd$var$DEFAULT_CHUNK_SIZE = 65536;
const $476261531bb8fadd$var$supportsResponseStream = $476261531bb8fadd$var$isReadableStreamSupported && $476261531bb8fadd$var$test(()=>(0, $78d097998daecff3$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $476261531bb8fadd$var$resolvers = {
    stream: $476261531bb8fadd$var$supportsResponseStream && ((res)=>res.body)
};
$476261531bb8fadd$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$476261531bb8fadd$var$resolvers[type] && ($476261531bb8fadd$var$resolvers[type] = (0, $78d097998daecff3$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $476261531bb8fadd$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $94196277001e1b77$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $78d097998daecff3$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isString(body)) return (await $476261531bb8fadd$var$encodeText(body)).byteLength;
};
const $476261531bb8fadd$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $78d097998daecff3$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $476261531bb8fadd$var$getBodyLength(body) : length;
};
var $476261531bb8fadd$export$2e2bcd8739ae039 = $476261531bb8fadd$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $946f6395b9af620b$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $423dae7d34cb15b1$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $476261531bb8fadd$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $476261531bb8fadd$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $3bcd6d05dc22fcfe$export$d9fadd12586c18d6)(requestContentLength, (0, $3bcd6d05dc22fcfe$export$c1b28109d46c3592)((0, $3bcd6d05dc22fcfe$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $e8ba94358d3d781e$export$b0119225647bd83)(_request.body, $476261531bb8fadd$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $78d097998daecff3$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $476261531bb8fadd$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($476261531bb8fadd$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $78d097998daecff3$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $3bcd6d05dc22fcfe$export$d9fadd12586c18d6)(responseContentLength, (0, $3bcd6d05dc22fcfe$export$c1b28109d46c3592)((0, $3bcd6d05dc22fcfe$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $e8ba94358d3d781e$export$b0119225647bd83)(response.body, $476261531bb8fadd$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $476261531bb8fadd$var$resolvers[(0, $78d097998daecff3$export$2e2bcd8739ae039).findKey($476261531bb8fadd$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $5ca5e7791ff51224$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $c5555279aa297c80$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)('Network Error', (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $63cec14df7019cd3$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $1d77ab52d1bc743d$var$knownAdapters = {
    http: (0, $bc8ed6826e20ddf1$export$2e2bcd8739ae039),
    xhr: (0, $4a3057f2c82bfade$export$2e2bcd8739ae039),
    fetch: (0, $476261531bb8fadd$export$2e2bcd8739ae039)
};
(0, $78d097998daecff3$export$2e2bcd8739ae039).forEach($1d77ab52d1bc743d$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $1d77ab52d1bc743d$var$renderReason = (reason)=>`- ${reason}`;
const $1d77ab52d1bc743d$var$isResolvedHandle = (adapter)=>(0, $78d097998daecff3$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $1d77ab52d1bc743d$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $78d097998daecff3$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$1d77ab52d1bc743d$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $1d77ab52d1bc743d$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($1d77ab52d1bc743d$var$renderReason).join('\n') : ' ' + $1d77ab52d1bc743d$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $1d77ab52d1bc743d$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $557b9c7a6bda694e$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $d7710a8d967d432b$export$2e2bcd8739ae039)(null, config);
}
function $557b9c7a6bda694e$export$2e2bcd8739ae039(config) {
    $557b9c7a6bda694e$var$throwIfCancellationRequested(config);
    config.headers = (0, $c5555279aa297c80$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $657c64f3abc21d54$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $1d77ab52d1bc743d$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $00882ed47bcc1c13$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $557b9c7a6bda694e$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $657c64f3abc21d54$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c5555279aa297c80$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $8ada1211d073acd1$export$2e2bcd8739ae039)(reason)) {
            $557b9c7a6bda694e$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $657c64f3abc21d54$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c5555279aa297c80$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $e39071d1212ceab6$export$a4ad2735b021c132 = "1.9.0";



'use strict';
const $51637f6a9786430d$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $51637f6a9786430d$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $51637f6a9786430d$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $51637f6a9786430d$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $e39071d1212ceab6$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$51637f6a9786430d$var$deprecatedWarnings[opt]) {
            $51637f6a9786430d$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$51637f6a9786430d$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $51637f6a9786430d$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)('options must be an object', (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $63cec14df7019cd3$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $63cec14df7019cd3$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $51637f6a9786430d$export$2e2bcd8739ae039 = {
    assertOptions: $51637f6a9786430d$var$assertOptions,
    validators: $51637f6a9786430d$var$validators
};



'use strict';
const $3efafb3dd13d0ccf$var$validators = (0, $51637f6a9786430d$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $3efafb3dd13d0ccf$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $6fc1764a9c4de2f3$export$2e2bcd8739ae039)(),
            response: new (0, $6fc1764a9c4de2f3$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $22029fa0d769cc39$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $51637f6a9786430d$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $3efafb3dd13d0ccf$var$validators.transitional($3efafb3dd13d0ccf$var$validators.boolean),
            forcedJSONParsing: $3efafb3dd13d0ccf$var$validators.transitional($3efafb3dd13d0ccf$var$validators.boolean),
            clarifyTimeoutError: $3efafb3dd13d0ccf$var$validators.transitional($3efafb3dd13d0ccf$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $78d097998daecff3$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $51637f6a9786430d$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $3efafb3dd13d0ccf$var$validators.function,
                serialize: $3efafb3dd13d0ccf$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $51637f6a9786430d$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $3efafb3dd13d0ccf$var$validators.spelling('baseURL'),
            withXsrfToken: $3efafb3dd13d0ccf$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $78d097998daecff3$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $78d097998daecff3$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c5555279aa297c80$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $557b9c7a6bda694e$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $557b9c7a6bda694e$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $22029fa0d769cc39$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $448fdcfc4cfec978$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $0c81bbe428969e5d$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $78d097998daecff3$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $3efafb3dd13d0ccf$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $22029fa0d769cc39$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $78d097998daecff3$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $22029fa0d769cc39$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $3efafb3dd13d0ccf$var$Axios.prototype[method] = generateHTTPMethod();
    $3efafb3dd13d0ccf$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $3efafb3dd13d0ccf$export$2e2bcd8739ae039 = $3efafb3dd13d0ccf$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $99dfc43aeb5f5b1c$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $d7710a8d967d432b$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $99dfc43aeb5f5b1c$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $99dfc43aeb5f5b1c$export$2e2bcd8739ae039 = $99dfc43aeb5f5b1c$var$CancelToken;






'use strict';
function $1d83fef3fd96ae46$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $1e8208bf5e866159$export$2e2bcd8739ae039(payload) {
    return (0, $78d097998daecff3$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $59b1e4e0c3b3ac08$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($59b1e4e0c3b3ac08$var$HttpStatusCode).forEach(([key, value])=>{
    $59b1e4e0c3b3ac08$var$HttpStatusCode[value] = key;
});
var $59b1e4e0c3b3ac08$export$2e2bcd8739ae039 = $59b1e4e0c3b3ac08$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $ae1c9ad610ade460$var$createInstance(defaultConfig) {
    const context = new (0, $3efafb3dd13d0ccf$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $92356c31d031346a$export$2e2bcd8739ae039)((0, $3efafb3dd13d0ccf$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $78d097998daecff3$export$2e2bcd8739ae039).extend(instance, (0, $3efafb3dd13d0ccf$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $78d097998daecff3$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $ae1c9ad610ade460$var$createInstance((0, $22029fa0d769cc39$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $ae1c9ad610ade460$var$axios = $ae1c9ad610ade460$var$createInstance((0, $00882ed47bcc1c13$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$ae1c9ad610ade460$var$axios.Axios = (0, $3efafb3dd13d0ccf$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$ae1c9ad610ade460$var$axios.CanceledError = (0, $d7710a8d967d432b$export$2e2bcd8739ae039);
$ae1c9ad610ade460$var$axios.CancelToken = (0, $99dfc43aeb5f5b1c$export$2e2bcd8739ae039);
$ae1c9ad610ade460$var$axios.isCancel = (0, $8ada1211d073acd1$export$2e2bcd8739ae039);
$ae1c9ad610ade460$var$axios.VERSION = (0, $e39071d1212ceab6$export$a4ad2735b021c132);
$ae1c9ad610ade460$var$axios.toFormData = (0, $84cbb2a477baae82$export$2e2bcd8739ae039);
// Expose AxiosError class
$ae1c9ad610ade460$var$axios.AxiosError = (0, $63cec14df7019cd3$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$ae1c9ad610ade460$var$axios.Cancel = $ae1c9ad610ade460$var$axios.CanceledError;
// Expose all/spread
$ae1c9ad610ade460$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$ae1c9ad610ade460$var$axios.spread = (0, $1d83fef3fd96ae46$export$2e2bcd8739ae039);
// Expose isAxiosError
$ae1c9ad610ade460$var$axios.isAxiosError = (0, $1e8208bf5e866159$export$2e2bcd8739ae039);
// Expose mergeConfig
$ae1c9ad610ade460$var$axios.mergeConfig = (0, $22029fa0d769cc39$export$2e2bcd8739ae039);
$ae1c9ad610ade460$var$axios.AxiosHeaders = (0, $c5555279aa297c80$export$2e2bcd8739ae039);
$ae1c9ad610ade460$var$axios.formToJSON = (thing)=>(0, $ad6589769dfea67d$export$2e2bcd8739ae039)((0, $78d097998daecff3$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$ae1c9ad610ade460$var$axios.getAdapter = (0, $1d77ab52d1bc743d$export$2e2bcd8739ae039).getAdapter;
$ae1c9ad610ade460$var$axios.HttpStatusCode = (0, $59b1e4e0c3b3ac08$export$2e2bcd8739ae039);
$ae1c9ad610ade460$var$axios.default = $ae1c9ad610ade460$var$axios;
var // this module should only have a default export
$ae1c9ad610ade460$export$2e2bcd8739ae039 = $ae1c9ad610ade460$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $ea9080e8a5b70f43$export$1c00760e9e5a4e95, AxiosError: $ea9080e8a5b70f43$export$c1fbed17c2f6a328, CanceledError: $ea9080e8a5b70f43$export$1ab0c6b20d94fa14, isCancel: $ea9080e8a5b70f43$export$3b22524397b493c6, CancelToken: $ea9080e8a5b70f43$export$fd08e3cb425f0d61, VERSION: $ea9080e8a5b70f43$export$a4ad2735b021c132, all: $ea9080e8a5b70f43$export$84bf76cd7afc7469, Cancel: $ea9080e8a5b70f43$export$848c9b7ead0df967, isAxiosError: $ea9080e8a5b70f43$export$fbafdbe06a5b5a9a, spread: $ea9080e8a5b70f43$export$3ae0fd4797ed47c8, toFormData: $ea9080e8a5b70f43$export$10ae0d317ea97f8b, AxiosHeaders: $ea9080e8a5b70f43$export$4e7d6ff0f3e6520, HttpStatusCode: $ea9080e8a5b70f43$export$a972f69c851492b3, formToJSON: $ea9080e8a5b70f43$export$86d7c59254d6a2c9, getAdapter: $ea9080e8a5b70f43$export$17ddc20a97d669e2, mergeConfig: $ea9080e8a5b70f43$export$7ec1ebcfa9d8bd6a } = (0, $ae1c9ad610ade460$export$2e2bcd8739ae039);



var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");

var $kIDXC = parcelRequire("kIDXC");
var $5d016a5f2c179b96$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $5d016a5f2c179b96$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($5d016a5f2c179b96$exports, "__esModule", {
    value: true
});
Object.defineProperty($5d016a5f2c179b96$exports, "default", {
    enumerable: true,
    get: function() {
        return $5d016a5f2c179b96$var$_composeClasses.default;
    }
});

var $5d016a5f2c179b96$var$_composeClasses = $5d016a5f2c179b96$require$_interopRequireDefault((parcelRequire("1g5DJ")));


var $8a2c9660dd4393d2$exports = {};
"use strict";
Object.defineProperty($8a2c9660dd4393d2$exports, "__esModule", {
    value: true
});
var $9f7c2fc7ad289fc3$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $9f7c2fc7ad289fc3$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($9f7c2fc7ad289fc3$exports, "__esModule", {
    value: true
});
$9f7c2fc7ad289fc3$exports.alpha = $9f7c2fc7ad289fc3$var$alpha;
$9f7c2fc7ad289fc3$exports.blend = $9f7c2fc7ad289fc3$var$blend;
$9f7c2fc7ad289fc3$exports.colorChannel = void 0;
$9f7c2fc7ad289fc3$exports.darken = $9f7c2fc7ad289fc3$var$darken;
$9f7c2fc7ad289fc3$exports.decomposeColor = $9f7c2fc7ad289fc3$var$decomposeColor;
$9f7c2fc7ad289fc3$exports.emphasize = $9f7c2fc7ad289fc3$var$emphasize;
$9f7c2fc7ad289fc3$exports.getContrastRatio = $9f7c2fc7ad289fc3$var$getContrastRatio;
$9f7c2fc7ad289fc3$exports.getLuminance = $9f7c2fc7ad289fc3$var$getLuminance;
$9f7c2fc7ad289fc3$exports.hexToRgb = $9f7c2fc7ad289fc3$var$hexToRgb;
$9f7c2fc7ad289fc3$exports.hslToRgb = $9f7c2fc7ad289fc3$var$hslToRgb;
$9f7c2fc7ad289fc3$exports.lighten = $9f7c2fc7ad289fc3$var$lighten;
$9f7c2fc7ad289fc3$exports.private_safeAlpha = $9f7c2fc7ad289fc3$var$private_safeAlpha;
$9f7c2fc7ad289fc3$exports.private_safeColorChannel = void 0;
$9f7c2fc7ad289fc3$exports.private_safeDarken = $9f7c2fc7ad289fc3$var$private_safeDarken;
$9f7c2fc7ad289fc3$exports.private_safeEmphasize = $9f7c2fc7ad289fc3$var$private_safeEmphasize;
$9f7c2fc7ad289fc3$exports.private_safeLighten = $9f7c2fc7ad289fc3$var$private_safeLighten;
$9f7c2fc7ad289fc3$exports.recomposeColor = $9f7c2fc7ad289fc3$var$recomposeColor;
$9f7c2fc7ad289fc3$exports.rgbToHex = $9f7c2fc7ad289fc3$var$rgbToHex;

var $9f7c2fc7ad289fc3$var$_formatMuiErrorMessage = $9f7c2fc7ad289fc3$require$_interopRequireDefault((parcelRequire("iKhyI")));

var $9f7c2fc7ad289fc3$var$_clamp = $9f7c2fc7ad289fc3$require$_interopRequireDefault((parcelRequire("60Ihj")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $9f7c2fc7ad289fc3$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $9f7c2fc7ad289fc3$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $9f7c2fc7ad289fc3$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $9f7c2fc7ad289fc3$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $9f7c2fc7ad289fc3$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $9f7c2fc7ad289fc3$var$decomposeColor($9f7c2fc7ad289fc3$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $9f7c2fc7ad289fc3$var$_formatMuiErrorMessage.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $9f7c2fc7ad289fc3$var$_formatMuiErrorMessage.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $9f7c2fc7ad289fc3$var$colorChannel = (color)=>{
    const decomposedColor = $9f7c2fc7ad289fc3$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
$9f7c2fc7ad289fc3$exports.colorChannel = $9f7c2fc7ad289fc3$var$colorChannel;
const $9f7c2fc7ad289fc3$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $9f7c2fc7ad289fc3$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ $9f7c2fc7ad289fc3$exports.private_safeColorChannel = $9f7c2fc7ad289fc3$var$private_safeColorChannel;
function $9f7c2fc7ad289fc3$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $9f7c2fc7ad289fc3$var$rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $9f7c2fc7ad289fc3$var$decomposeColor(color);
    return `#${values.map((n, i)=>$9f7c2fc7ad289fc3$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $9f7c2fc7ad289fc3$var$hslToRgb(color) {
    color = $9f7c2fc7ad289fc3$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $9f7c2fc7ad289fc3$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $9f7c2fc7ad289fc3$var$getLuminance(color) {
    color = $9f7c2fc7ad289fc3$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $9f7c2fc7ad289fc3$var$decomposeColor($9f7c2fc7ad289fc3$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $9f7c2fc7ad289fc3$var$getContrastRatio(foreground, background) {
    const lumA = $9f7c2fc7ad289fc3$var$getLuminance(foreground);
    const lumB = $9f7c2fc7ad289fc3$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $9f7c2fc7ad289fc3$var$alpha(color, value) {
    color = $9f7c2fc7ad289fc3$var$decomposeColor(color);
    value = $9f7c2fc7ad289fc3$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $9f7c2fc7ad289fc3$var$recomposeColor(color);
}
function $9f7c2fc7ad289fc3$var$private_safeAlpha(color, value, warning) {
    try {
        return $9f7c2fc7ad289fc3$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $9f7c2fc7ad289fc3$var$darken(color, coefficient) {
    color = $9f7c2fc7ad289fc3$var$decomposeColor(color);
    coefficient = $9f7c2fc7ad289fc3$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $9f7c2fc7ad289fc3$var$recomposeColor(color);
}
function $9f7c2fc7ad289fc3$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $9f7c2fc7ad289fc3$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $9f7c2fc7ad289fc3$var$lighten(color, coefficient) {
    color = $9f7c2fc7ad289fc3$var$decomposeColor(color);
    coefficient = $9f7c2fc7ad289fc3$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $9f7c2fc7ad289fc3$var$recomposeColor(color);
}
function $9f7c2fc7ad289fc3$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $9f7c2fc7ad289fc3$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $9f7c2fc7ad289fc3$var$emphasize(color, coefficient = 0.15) {
    return $9f7c2fc7ad289fc3$var$getLuminance(color) > 0.5 ? $9f7c2fc7ad289fc3$var$darken(color, coefficient) : $9f7c2fc7ad289fc3$var$lighten(color, coefficient);
}
function $9f7c2fc7ad289fc3$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $9f7c2fc7ad289fc3$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $9f7c2fc7ad289fc3$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $9f7c2fc7ad289fc3$var$decomposeColor(background);
    const overlayColor = $9f7c2fc7ad289fc3$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $9f7c2fc7ad289fc3$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}


Object.keys($9f7c2fc7ad289fc3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $8a2c9660dd4393d2$exports && $8a2c9660dd4393d2$exports[key] === $9f7c2fc7ad289fc3$exports[key]) return;
    Object.defineProperty($8a2c9660dd4393d2$exports, key, {
        enumerable: true,
        get: function() {
            return $9f7c2fc7ad289fc3$exports[key];
        }
    });
});


var $77cd97fe312eba76$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $77cd97fe312eba76$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($77cd97fe312eba76$exports, "__esModule", {
    value: true
});
Object.defineProperty($77cd97fe312eba76$exports, "default", {
    enumerable: true,
    get: function() {
        return $77cd97fe312eba76$var$_useId.default;
    }
});

var $77cd97fe312eba76$var$_useId = $77cd97fe312eba76$require$_interopRequireDefault((parcelRequire("ek0e0")));


'use client';
var $11dde830dc4c8a7a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($77cd97fe312eba76$exports)));


// copied from @mui/system/createStyled
function $776dc3289a896a7d$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $776dc3289a896a7d$export$2e2bcd8739ae039 = $776dc3289a896a7d$var$slotShouldForwardProp;


const $c67b4c535d9075aa$var$rootShouldForwardProp = (prop)=>(0, $776dc3289a896a7d$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $c67b4c535d9075aa$export$2e2bcd8739ae039 = $c67b4c535d9075aa$var$rootShouldForwardProp;


var $baf81d03d5492ef6$exports = {};
"use strict";

var $pArzt = parcelRequire("pArzt");
var $baf81d03d5492ef6$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty($baf81d03d5492ef6$exports, "__esModule", {
    value: true
});
var $baf81d03d5492ef6$var$_exportNames = {};
Object.defineProperty($baf81d03d5492ef6$exports, "default", {
    enumerable: true,
    get: function() {
        return $baf81d03d5492ef6$var$_createStyled.default;
    }
});

var $baf81d03d5492ef6$var$_createStyled = $baf81d03d5492ef6$require$_interopRequireWildcard((parcelRequire("8WdHP")));
Object.keys($baf81d03d5492ef6$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($baf81d03d5492ef6$var$_exportNames, key)) return;
    if (key in $baf81d03d5492ef6$exports && $baf81d03d5492ef6$exports[key] === $baf81d03d5492ef6$var$_createStyled[key]) return;
    Object.defineProperty($baf81d03d5492ef6$exports, key, {
        enumerable: true,
        get: function() {
            return $baf81d03d5492ef6$var$_createStyled[key];
        }
    });
});



var $iKhyI = parcelRequire("iKhyI");

var $cWnbn = parcelRequire("cWnbn");

const $f8775acfa101f17e$var$common = {
    black: '#000',
    white: '#fff'
};
var $f8775acfa101f17e$export$2e2bcd8739ae039 = $f8775acfa101f17e$var$common;


const $775b28f95a68251e$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $775b28f95a68251e$export$2e2bcd8739ae039 = $775b28f95a68251e$var$grey;


const $d5302b4b1bf48a2c$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $d5302b4b1bf48a2c$export$2e2bcd8739ae039 = $d5302b4b1bf48a2c$var$purple;


const $1d5cf6fb379c2122$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $1d5cf6fb379c2122$export$2e2bcd8739ae039 = $1d5cf6fb379c2122$var$red;


const $44d66a06bb34d010$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $44d66a06bb34d010$export$2e2bcd8739ae039 = $44d66a06bb34d010$var$orange;


const $3d8dd9e33596fcb4$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $3d8dd9e33596fcb4$export$2e2bcd8739ae039 = $3d8dd9e33596fcb4$var$blue;


const $b75c2669668e7296$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $b75c2669668e7296$export$2e2bcd8739ae039 = $b75c2669668e7296$var$lightBlue;


const $b2dbd1bdd7a86183$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $b2dbd1bdd7a86183$export$2e2bcd8739ae039 = $b2dbd1bdd7a86183$var$green;


function $10655427721c80aa$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $f8775acfa101f17e$export$2e2bcd8739ae039).white,
            default: (0, $f8775acfa101f17e$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $10655427721c80aa$export$a43af521ac8c3202 = $10655427721c80aa$var$getLight();
function $10655427721c80aa$var$getDark() {
    return {
        text: {
            primary: (0, $f8775acfa101f17e$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $f8775acfa101f17e$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $10655427721c80aa$export$55ce6f3a06c59543 = $10655427721c80aa$var$getDark();
function $10655427721c80aa$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $8a2c9660dd4393d2$exports.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $8a2c9660dd4393d2$exports.darken)(intent.main, tonalOffsetDark);
    }
}
function $10655427721c80aa$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $3d8dd9e33596fcb4$export$2e2bcd8739ae039)[200],
        light: (0, $3d8dd9e33596fcb4$export$2e2bcd8739ae039)[50],
        dark: (0, $3d8dd9e33596fcb4$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $3d8dd9e33596fcb4$export$2e2bcd8739ae039)[700],
        light: (0, $3d8dd9e33596fcb4$export$2e2bcd8739ae039)[400],
        dark: (0, $3d8dd9e33596fcb4$export$2e2bcd8739ae039)[800]
    };
}
function $10655427721c80aa$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $d5302b4b1bf48a2c$export$2e2bcd8739ae039)[200],
        light: (0, $d5302b4b1bf48a2c$export$2e2bcd8739ae039)[50],
        dark: (0, $d5302b4b1bf48a2c$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $d5302b4b1bf48a2c$export$2e2bcd8739ae039)[500],
        light: (0, $d5302b4b1bf48a2c$export$2e2bcd8739ae039)[300],
        dark: (0, $d5302b4b1bf48a2c$export$2e2bcd8739ae039)[700]
    };
}
function $10655427721c80aa$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $1d5cf6fb379c2122$export$2e2bcd8739ae039)[500],
        light: (0, $1d5cf6fb379c2122$export$2e2bcd8739ae039)[300],
        dark: (0, $1d5cf6fb379c2122$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $1d5cf6fb379c2122$export$2e2bcd8739ae039)[700],
        light: (0, $1d5cf6fb379c2122$export$2e2bcd8739ae039)[400],
        dark: (0, $1d5cf6fb379c2122$export$2e2bcd8739ae039)[800]
    };
}
function $10655427721c80aa$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $b75c2669668e7296$export$2e2bcd8739ae039)[400],
        light: (0, $b75c2669668e7296$export$2e2bcd8739ae039)[300],
        dark: (0, $b75c2669668e7296$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $b75c2669668e7296$export$2e2bcd8739ae039)[700],
        light: (0, $b75c2669668e7296$export$2e2bcd8739ae039)[500],
        dark: (0, $b75c2669668e7296$export$2e2bcd8739ae039)[900]
    };
}
function $10655427721c80aa$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $b2dbd1bdd7a86183$export$2e2bcd8739ae039)[400],
        light: (0, $b2dbd1bdd7a86183$export$2e2bcd8739ae039)[300],
        dark: (0, $b2dbd1bdd7a86183$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $b2dbd1bdd7a86183$export$2e2bcd8739ae039)[800],
        light: (0, $b2dbd1bdd7a86183$export$2e2bcd8739ae039)[500],
        dark: (0, $b2dbd1bdd7a86183$export$2e2bcd8739ae039)[900]
    };
}
function $10655427721c80aa$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $44d66a06bb34d010$export$2e2bcd8739ae039)[400],
        light: (0, $44d66a06bb34d010$export$2e2bcd8739ae039)[300],
        dark: (0, $44d66a06bb34d010$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $44d66a06bb34d010$export$2e2bcd8739ae039)[500],
        dark: (0, $44d66a06bb34d010$export$2e2bcd8739ae039)[900]
    };
}
function $10655427721c80aa$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $10655427721c80aa$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $10655427721c80aa$var$getDefaultSecondary(mode);
    const error = palette.error || $10655427721c80aa$var$getDefaultError(mode);
    const info = palette.info || $10655427721c80aa$var$getDefaultInfo(mode);
    const success = palette.success || $10655427721c80aa$var$getDefaultSuccess(mode);
    const warning = palette.warning || $10655427721c80aa$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $8a2c9660dd4393d2$exports.getContrastRatio)(background, $10655427721c80aa$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $10655427721c80aa$export$55ce6f3a06c59543.text.primary : $10655427721c80aa$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($iKhyI)))(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($iKhyI)))(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $10655427721c80aa$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $10655427721c80aa$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $10655427721c80aa$var$getLight();
    else if (mode === 'dark') modeHydrated = $10655427721c80aa$var$getDark();
    const paletteOutput = (0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))({
        // A collection of common colors.
        common: {
            ...(0, $f8775acfa101f17e$export$2e2bcd8739ae039)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $775b28f95a68251e$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}



var $iKhyI = parcelRequire("iKhyI");

var $cWnbn = parcelRequire("cWnbn");



var $cWnbn = parcelRequire("cWnbn");

var $cWnbn = parcelRequire("cWnbn");
function $f62f292d3e4d1545$var$merge(acc, item) {
    if (!item) return acc;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $f62f292d3e4d1545$export$2e2bcd8739ae039 = $f62f292d3e4d1545$var$merge;



function $ba8f192cfa30a178$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $ba8f192cfa30a178$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $ba8f192cfa30a178$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $ba8f192cfa30a178$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $ae6c3eef95e7a204$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $ae6c3eef95e7a204$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$ae6c3eef95e7a204$export$68c286be0e7e55b7[key]}px)`
};
const $ae6c3eef95e7a204$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $ae6c3eef95e7a204$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $ae6c3eef95e7a204$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $ae6c3eef95e7a204$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $ae6c3eef95e7a204$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $ba8f192cfa30a178$export$77c7c3e357f440e7)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $ba8f192cfa30a178$export$10a9745dfa00d15)(theme.containerQueries ? theme : $ae6c3eef95e7a204$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $ae6c3eef95e7a204$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $ae6c3eef95e7a204$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $ae6c3eef95e7a204$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $f62f292d3e4d1545$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $ae6c3eef95e7a204$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $ae6c3eef95e7a204$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $ae6c3eef95e7a204$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $ae6c3eef95e7a204$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))(prev, next), {});
    return $ae6c3eef95e7a204$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $ae6c3eef95e7a204$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $ae6c3eef95e7a204$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $ae6c3eef95e7a204$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $ae6c3eef95e7a204$export$2e2bcd8739ae039 = $ae6c3eef95e7a204$var$breakpoints;



var $bEhYY = parcelRequire("bEhYY");


function $a6c9783532d5ed2a$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $a6c9783532d5ed2a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $a6c9783532d5ed2a$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $a6c9783532d5ed2a$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $a6c9783532d5ed2a$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $a6c9783532d5ed2a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $a6c9783532d5ed2a$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($bEhYY)))(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $ae6c3eef95e7a204$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $a6c9783532d5ed2a$export$2e2bcd8739ae039 = $a6c9783532d5ed2a$var$style;



function $e55308c46f7e4e45$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $36c1e5a0db50a2e0$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $36c1e5a0db50a2e0$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $36c1e5a0db50a2e0$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $36c1e5a0db50a2e0$var$getCssProperties = (0, $e55308c46f7e4e45$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($36c1e5a0db50a2e0$var$aliases[prop]) prop = $36c1e5a0db50a2e0$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $36c1e5a0db50a2e0$var$properties[a];
    const direction = $36c1e5a0db50a2e0$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $36c1e5a0db50a2e0$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $36c1e5a0db50a2e0$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $36c1e5a0db50a2e0$var$spacingKeys = [
    ...$36c1e5a0db50a2e0$export$aab52a0dde05ad8a,
    ...$36c1e5a0db50a2e0$export$f8397d44f03ab6ad
];
function $36c1e5a0db50a2e0$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $a6c9783532d5ed2a$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $36c1e5a0db50a2e0$export$1def6f833384e3d1(theme) {
    return $36c1e5a0db50a2e0$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $36c1e5a0db50a2e0$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $36c1e5a0db50a2e0$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $36c1e5a0db50a2e0$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $36c1e5a0db50a2e0$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $36c1e5a0db50a2e0$var$getCssProperties(prop);
    const styleFromPropValue = $36c1e5a0db50a2e0$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $ae6c3eef95e7a204$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $36c1e5a0db50a2e0$var$style(props, keys) {
    const transformer = $36c1e5a0db50a2e0$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$36c1e5a0db50a2e0$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $f62f292d3e4d1545$export$2e2bcd8739ae039), {});
}
function $36c1e5a0db50a2e0$export$7ede87f9b603dd3c(props) {
    return $36c1e5a0db50a2e0$var$style(props, $36c1e5a0db50a2e0$export$aab52a0dde05ad8a);
}
$36c1e5a0db50a2e0$export$7ede87f9b603dd3c.propTypes = {};
$36c1e5a0db50a2e0$export$7ede87f9b603dd3c.filterProps = $36c1e5a0db50a2e0$export$aab52a0dde05ad8a;
function $36c1e5a0db50a2e0$export$6f98e8eaf0be1996(props) {
    return $36c1e5a0db50a2e0$var$style(props, $36c1e5a0db50a2e0$export$f8397d44f03ab6ad);
}
$36c1e5a0db50a2e0$export$6f98e8eaf0be1996.propTypes = {};
$36c1e5a0db50a2e0$export$6f98e8eaf0be1996.filterProps = $36c1e5a0db50a2e0$export$f8397d44f03ab6ad;
function $36c1e5a0db50a2e0$var$spacing(props) {
    return $36c1e5a0db50a2e0$var$style(props, $36c1e5a0db50a2e0$var$spacingKeys);
}
$36c1e5a0db50a2e0$var$spacing.propTypes = {};
$36c1e5a0db50a2e0$var$spacing.filterProps = $36c1e5a0db50a2e0$var$spacingKeys;
var $36c1e5a0db50a2e0$export$2e2bcd8739ae039 = $36c1e5a0db50a2e0$var$spacing;


function $ceed81bef47f4750$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $36c1e5a0db50a2e0$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $ef536040a5d9bad5$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}



var $1pVSQ = parcelRequire("1pVSQ");
var $ce0658e8ab54cebb$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $ce0658e8ab54cebb$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($ce0658e8ab54cebb$exports, "__esModule", {
    value: true
});
Object.defineProperty($ce0658e8ab54cebb$exports, "createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $ce0658e8ab54cebb$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty($ce0658e8ab54cebb$exports, "createGetColorSchemeSelector", {
    enumerable: true,
    get: function() {
        return $47W0g.createGetColorSchemeSelector;
    }
});
Object.defineProperty($ce0658e8ab54cebb$exports, "default", {
    enumerable: true,
    get: function() {
        return $ce0658e8ab54cebb$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty($ce0658e8ab54cebb$exports, "prepareCssVars", {
    enumerable: true,
    get: function() {
        return $ce0658e8ab54cebb$var$_prepareCssVars.default;
    }
});
Object.defineProperty($ce0658e8ab54cebb$exports, "prepareTypographyVars", {
    enumerable: true,
    get: function() {
        return $ce0658e8ab54cebb$var$_prepareTypographyVars.default;
    }
});

var $ce0658e8ab54cebb$var$_createCssVarsProvider = $ce0658e8ab54cebb$require$_interopRequireDefault((parcelRequire("c7Ata")));

var $ce0658e8ab54cebb$var$_prepareCssVars = $ce0658e8ab54cebb$require$_interopRequireDefault((parcelRequire("goShU")));

var $ce0658e8ab54cebb$var$_prepareTypographyVars = $ce0658e8ab54cebb$require$_interopRequireDefault((parcelRequire("kPJDY")));

var $ce0658e8ab54cebb$var$_createCssVarsTheme = $ce0658e8ab54cebb$require$_interopRequireDefault((parcelRequire("fupmt")));

var $47W0g = parcelRequire("47W0g");



var $a4tM1 = parcelRequire("a4tM1");


var $iKhyI = parcelRequire("iKhyI");

var $cWnbn = parcelRequire("cWnbn");

var $a4tM1 = parcelRequire("a4tM1");

var $cp4gV = parcelRequire("cp4gV");

function $8746fce562b428d8$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}




var $cWnbn = parcelRequire("cWnbn");
function $659c8ccfa9a5ed5d$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $659c8ccfa9a5ed5d$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $659c8ccfa9a5ed5d$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $659c8ccfa9a5ed5d$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $659c8ccfa9a5ed5d$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $659c8ccfa9a5ed5d$var$defaultFontFamily ? {
                letterSpacing: `${$659c8ccfa9a5ed5d$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $659c8ccfa9a5ed5d$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $659c8ccfa9a5ed5d$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}


const $0647c72cb26d3b89$var$shadowKeyUmbraOpacity = 0.2;
const $0647c72cb26d3b89$var$shadowKeyPenumbraOpacity = 0.14;
const $0647c72cb26d3b89$var$shadowAmbientShadowOpacity = 0.12;
function $0647c72cb26d3b89$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$0647c72cb26d3b89$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$0647c72cb26d3b89$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$0647c72cb26d3b89$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $0647c72cb26d3b89$var$shadows = [
    'none',
    $0647c72cb26d3b89$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $0647c72cb26d3b89$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $0647c72cb26d3b89$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $0647c72cb26d3b89$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $0647c72cb26d3b89$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $0647c72cb26d3b89$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $0647c72cb26d3b89$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $0647c72cb26d3b89$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $0647c72cb26d3b89$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $0647c72cb26d3b89$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $0647c72cb26d3b89$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $0647c72cb26d3b89$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $0647c72cb26d3b89$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $0647c72cb26d3b89$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $0647c72cb26d3b89$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $0647c72cb26d3b89$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $0647c72cb26d3b89$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $0647c72cb26d3b89$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $0647c72cb26d3b89$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $0647c72cb26d3b89$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $0647c72cb26d3b89$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $0647c72cb26d3b89$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $0647c72cb26d3b89$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $0647c72cb26d3b89$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $0647c72cb26d3b89$export$2e2bcd8739ae039 = $0647c72cb26d3b89$var$shadows;


// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $054c7d9a90fbcbc4$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $054c7d9a90fbcbc4$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $054c7d9a90fbcbc4$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $054c7d9a90fbcbc4$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $054c7d9a90fbcbc4$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$054c7d9a90fbcbc4$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$054c7d9a90fbcbc4$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $054c7d9a90fbcbc4$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $054c7d9a90fbcbc4$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $054c7d9a90fbcbc4$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $39ab78bacdb74744$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $39ab78bacdb74744$export$2e2bcd8739ae039 = $39ab78bacdb74744$var$zIndex;


/* eslint-disable import/prefer-default-export */ 
var $cWnbn = parcelRequire("cWnbn");
function $baa833de956ca218$var$isSerializable(val) {
    return (0, $cWnbn.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $baa833de956ca218$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$baa833de956ca218$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $cWnbn.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}


function $607fb776d736226c$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($iKhyI)))(20));
    const palette = (0, $10655427721c80aa$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, (/*@__PURE__*/$parcel$interopDefault($cp4gV)))(options);
    let muiTheme = (0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))(systemTheme, {
        mixins: (0, $8746fce562b428d8$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $0647c72cb26d3b89$export$2e2bcd8739ae039).slice(),
        typography: (0, $659c8ccfa9a5ed5d$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $054c7d9a90fbcbc4$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: {
            ...(0, $39ab78bacdb74744$export$2e2bcd8739ae039)
        }
    });
    muiTheme = (0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $a4tM1.unstable_defaultSxConfig),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a4tM1)))({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $baa833de956ca218$export$32c2afa5f91892aa); // for Pigment CSS integration
    return muiTheme;
}
var $607fb776d736226c$export$2e2bcd8739ae039 = $607fb776d736226c$var$createThemeNoVars;



// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $c043fba43cee01ca$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $305da3492fb1a2a8$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $c043fba43cee01ca$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $305da3492fb1a2a8$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $305da3492fb1a2a8$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $305da3492fb1a2a8$var$defaultDarkOverlays : [];
}
function $305da3492fb1a2a8$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $10655427721c80aa$export$2e2bcd8739ae039)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$305da3492fb1a2a8$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $305da3492fb1a2a8$export$dd191566510330d3(palette.mode),
        ...rest
    };
}


function $606f8907c64e65f6$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}


/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $58304d06be0a5b71$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $58304d06be0a5b71$export$2e2bcd8739ae039 = $58304d06be0a5b71$var$excludeVariablesFromRoot;


var $33d5d2dc5ce27ba2$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $58304d06be0a5b71$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };



function $bafadceaf3bab86e$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $bafadceaf3bab86e$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $bafadceaf3bab86e$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $8a2c9660dd4393d2$exports.hslToRgb)(color);
}
function $bafadceaf3bab86e$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $8a2c9660dd4393d2$exports.private_safeColorChannel)($bafadceaf3bab86e$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $bafadceaf3bab86e$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $bafadceaf3bab86e$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $bafadceaf3bab86e$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $ef536040a5d9bad5$export$2e2bcd8739ae039)(cssVarPrefix);
function $bafadceaf3bab86e$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $305da3492fb1a2a8$export$2e2bcd8739ae039)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $607fb776d736226c$export$2e2bcd8739ae039)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $305da3492fb1a2a8$export$c85e0347fceb69ba)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $305da3492fb1a2a8$export$dd191566510330d3)(mode)
    };
    return muiTheme;
}
function $bafadceaf3bab86e$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $606f8907c64e65f6$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $bafadceaf3bab86e$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($iKhyI)))(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $bafadceaf3bab86e$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $bafadceaf3bab86e$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $bafadceaf3bab86e$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $ce0658e8ab54cebb$exports.prepareTypographyVars)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $bafadceaf3bab86e$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $bafadceaf3bab86e$var$setColor(palette.common, 'background', '#fff');
            $bafadceaf3bab86e$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $bafadceaf3bab86e$var$setColor(palette.common, 'background', '#000');
            $bafadceaf3bab86e$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $bafadceaf3bab86e$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'errorColor', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.error.light, 0.6));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'infoColor', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.info.light, 0.6));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'successColor', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.success.light, 0.6));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'warningColor', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.warning.light, 0.6));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'errorFilledColor', $bafadceaf3bab86e$var$silent(()=>palette.getContrastText(palette.error.main)));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'infoFilledColor', $bafadceaf3bab86e$var$silent(()=>palette.getContrastText(palette.info.main)));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'successFilledColor', $bafadceaf3bab86e$var$silent(()=>palette.getContrastText(palette.success.main)));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'warningFilledColor', $bafadceaf3bab86e$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'errorStandardBg', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.error.light, 0.9));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'infoStandardBg', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.info.light, 0.9));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'successStandardBg', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.success.light, 0.9));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'warningStandardBg', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.warning.light, 0.9));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $bafadceaf3bab86e$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $bafadceaf3bab86e$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $bafadceaf3bab86e$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $bafadceaf3bab86e$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $bafadceaf3bab86e$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $bafadceaf3bab86e$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $bafadceaf3bab86e$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $bafadceaf3bab86e$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $bafadceaf3bab86e$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $bafadceaf3bab86e$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'primaryBg', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.primary.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.secondary.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'errorBg', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.error.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'infoBg', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.info.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'successBg', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.success.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'warningBg', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.warning.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'primaryTrack', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.primary.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'secondaryTrack', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.secondary.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'errorTrack', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.error.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'infoTrack', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.info.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'successTrack', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.success.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'warningTrack', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $8a2c9660dd4393d2$exports.private_safeEmphasize)(palette.background.default, 0.8);
            $bafadceaf3bab86e$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $bafadceaf3bab86e$var$setColor(palette.SnackbarContent, 'color', $bafadceaf3bab86e$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $bafadceaf3bab86e$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $8a2c9660dd4393d2$exports.private_safeEmphasize)(palette.background.paper, 0.15));
            $bafadceaf3bab86e$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $bafadceaf3bab86e$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.primary.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.secondary.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'errorDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.error.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'infoDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.info.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'successDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.success.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'warningDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.warning.main, 0.62));
            $bafadceaf3bab86e$var$setColor(palette.TableCell, 'border', (0, $8a2c9660dd4393d2$exports.private_safeLighten)((0, $8a2c9660dd4393d2$exports.private_safeAlpha)(palette.divider, 1), 0.88));
            $bafadceaf3bab86e$var$setColor(palette.Tooltip, 'bg', (0, $8a2c9660dd4393d2$exports.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'errorColor', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.error.light, 0.6));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'infoColor', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.info.light, 0.6));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'successColor', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.success.light, 0.6));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'warningColor', (0, $8a2c9660dd4393d2$exports.private_safeLighten)(palette.warning.light, 0.6));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'errorFilledColor', $bafadceaf3bab86e$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'infoFilledColor', $bafadceaf3bab86e$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'successFilledColor', $bafadceaf3bab86e$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'warningFilledColor', $bafadceaf3bab86e$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'errorStandardBg', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.error.light, 0.9));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'infoStandardBg', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.info.light, 0.9));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'successStandardBg', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.success.light, 0.9));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'warningStandardBg', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.warning.light, 0.9));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $bafadceaf3bab86e$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $bafadceaf3bab86e$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $bafadceaf3bab86e$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $bafadceaf3bab86e$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $bafadceaf3bab86e$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $bafadceaf3bab86e$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $bafadceaf3bab86e$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $bafadceaf3bab86e$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $bafadceaf3bab86e$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $bafadceaf3bab86e$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $bafadceaf3bab86e$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $bafadceaf3bab86e$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $bafadceaf3bab86e$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'primaryBg', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.primary.main, 0.5));
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.secondary.main, 0.5));
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'errorBg', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.error.main, 0.5));
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'infoBg', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.info.main, 0.5));
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'successBg', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.success.main, 0.5));
            $bafadceaf3bab86e$var$setColor(palette.LinearProgress, 'warningBg', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.warning.main, 0.5));
            $bafadceaf3bab86e$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'primaryTrack', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.primary.main, 0.5));
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'secondaryTrack', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.secondary.main, 0.5));
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'errorTrack', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.error.main, 0.5));
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'infoTrack', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.info.main, 0.5));
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'successTrack', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.success.main, 0.5));
            $bafadceaf3bab86e$var$setColor(palette.Slider, 'warningTrack', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $8a2c9660dd4393d2$exports.private_safeEmphasize)(palette.background.default, 0.98);
            $bafadceaf3bab86e$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $bafadceaf3bab86e$var$setColor(palette.SnackbarContent, 'color', $bafadceaf3bab86e$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $bafadceaf3bab86e$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $8a2c9660dd4393d2$exports.private_safeEmphasize)(palette.background.paper, 0.15));
            $bafadceaf3bab86e$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $bafadceaf3bab86e$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.primary.main, 0.55));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.secondary.main, 0.55));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'errorDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.error.main, 0.55));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'infoDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.info.main, 0.55));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'successDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.success.main, 0.55));
            $bafadceaf3bab86e$var$setColor(palette.Switch, 'warningDisabledColor', (0, $8a2c9660dd4393d2$exports.private_safeDarken)(palette.warning.main, 0.55));
            $bafadceaf3bab86e$var$setColor(palette.TableCell, 'border', (0, $8a2c9660dd4393d2$exports.private_safeDarken)((0, $8a2c9660dd4393d2$exports.private_safeAlpha)(palette.divider, 1), 0.68));
            $bafadceaf3bab86e$var$setColor(palette.Tooltip, 'bg', (0, $8a2c9660dd4393d2$exports.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $bafadceaf3bab86e$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $bafadceaf3bab86e$var$setColorChannel(palette.background, 'paper');
        $bafadceaf3bab86e$var$setColorChannel(palette.common, 'background');
        $bafadceaf3bab86e$var$setColorChannel(palette.common, 'onBackground');
        $bafadceaf3bab86e$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $bafadceaf3bab86e$var$setColor(palette[color], 'mainChannel', (0, $8a2c9660dd4393d2$exports.private_safeColorChannel)($bafadceaf3bab86e$var$toRgb(colors.main)));
                if (colors.light) $bafadceaf3bab86e$var$setColor(palette[color], 'lightChannel', (0, $8a2c9660dd4393d2$exports.private_safeColorChannel)($bafadceaf3bab86e$var$toRgb(colors.light)));
                if (colors.dark) $bafadceaf3bab86e$var$setColor(palette[color], 'darkChannel', (0, $8a2c9660dd4393d2$exports.private_safeColorChannel)($bafadceaf3bab86e$var$toRgb(colors.dark)));
                if (colors.contrastText) $bafadceaf3bab86e$var$setColor(palette[color], 'contrastTextChannel', (0, $8a2c9660dd4393d2$exports.private_safeColorChannel)($bafadceaf3bab86e$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $bafadceaf3bab86e$var$setColorChannel(palette[color], 'primary');
                    $bafadceaf3bab86e$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $bafadceaf3bab86e$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $bafadceaf3bab86e$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $33d5d2dc5ce27ba2$export$2e2bcd8739ae039)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $ce0658e8ab54cebb$exports.prepareCssVars)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $ceed81bef47f4750$export$2e2bcd8739ae039)(input.spacing, (0, $1pVSQ.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $ce0658e8ab54cebb$exports.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $a4tM1.unstable_defaultSxConfig),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a4tM1)))({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $baa833de956ca218$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $0db12d36a06dab18$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $10655427721c80aa$export$2e2bcd8739ae039)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $0db12d36a06dab18$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $607fb776d736226c$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $607fb776d736226c$export$2e2bcd8739ae039)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $0db12d36a06dab18$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $0db12d36a06dab18$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $bafadceaf3bab86e$export$2e2bcd8739ae039)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}


'use client';
const $4828a42d7a53d2e5$var$defaultTheme = (0, $0db12d36a06dab18$export$2e2bcd8739ae039)();
var $4828a42d7a53d2e5$export$2e2bcd8739ae039 = $4828a42d7a53d2e5$var$defaultTheme;


var $e01b19e3fab8f92b$export$2e2bcd8739ae039 = '$$material';




'use client';
const $843c443210106c30$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($baf81d03d5492ef6$exports)))({
    themeId: (0, $e01b19e3fab8f92b$export$2e2bcd8739ae039),
    defaultTheme: $4828a42d7a53d2e5$export$2e2bcd8739ae039,
    rootShouldForwardProp: $c67b4c535d9075aa$export$2e2bcd8739ae039
});
var $843c443210106c30$export$2e2bcd8739ae039 = $843c443210106c30$var$styled;



var $1VcT5 = parcelRequire("1VcT5");
function $c084cbe8ef6a37be$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $1VcT5.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $1VcT5.internal_serializeStyles)(variant.style);
    });
    return result;
}


/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $319c15a41ae71256$var$arg = {
    theme: undefined
};
function $319c15a41ae71256$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $319c15a41ae71256$var$arg.theme = props.theme;
            value = (0, $c084cbe8ef6a37be$export$2e2bcd8739ae039)(styleFn($319c15a41ae71256$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}


const $69ec0b9cd117e3a9$var$memoTheme = (0, $319c15a41ae71256$export$2e2bcd8739ae039);
var $69ec0b9cd117e3a9$export$2e2bcd8739ae039 = $69ec0b9cd117e3a9$var$memoTheme;


parcelRequire("1Pgvo");


var $5TkU6 = parcelRequire("5TkU6");

var $j6whP = parcelRequire("j6whP");
'use client';
function $5c0a70bfa8e38664$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5TkU6))), {
        ...props
    });
}
var $5c0a70bfa8e38664$export$2e2bcd8739ae039 = $5c0a70bfa8e38664$var$DefaultPropsProvider;
function $5c0a70bfa8e38664$export$2440da353cedad43(params) {
    return (0, $5TkU6.useDefaultProps)(params);
}



var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");



var $448bba3f542d9053$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $448bba3f542d9053$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($448bba3f542d9053$exports, "__esModule", {
    value: true
});
Object.defineProperty($448bba3f542d9053$exports, "default", {
    enumerable: true,
    get: function() {
        return $448bba3f542d9053$var$_isFocusVisible.default;
    }
});

var $448bba3f542d9053$var$_isFocusVisible = $448bba3f542d9053$require$_interopRequireDefault((parcelRequire("3Re6K")));





var $aMDvQ = parcelRequire("aMDvQ");
'use client';
var $4c40965b9645751b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aMDvQ)));


var $3970405edc15cfc3$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $3970405edc15cfc3$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($3970405edc15cfc3$exports, "__esModule", {
    value: true
});
Object.defineProperty($3970405edc15cfc3$exports, "default", {
    enumerable: true,
    get: function() {
        return $3970405edc15cfc3$var$_useEventCallback.default;
    }
});

var $3970405edc15cfc3$var$_useEventCallback = $3970405edc15cfc3$require$_interopRequireDefault((parcelRequire("bs5tN")));


'use client';
var $6c1a5998fda37ac1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($3970405edc15cfc3$exports)));



var $1Pgvo = parcelRequire("1Pgvo");
var $3acfabeb7975dbd9$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $3acfabeb7975dbd9$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($3acfabeb7975dbd9$exports, "__esModule", {
    value: true
});
Object.defineProperty($3acfabeb7975dbd9$exports, "default", {
    enumerable: true,
    get: function() {
        return $3acfabeb7975dbd9$var$_useLazyRef.default;
    }
});

var $3acfabeb7975dbd9$var$_useLazyRef = $3acfabeb7975dbd9$require$_interopRequireDefault((parcelRequire("dr5dP")));


'use client';
class $643f0b2affc90cb3$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $643f0b2affc90cb3$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, (/*@__PURE__*/$parcel$interopDefault($3acfabeb7975dbd9$exports)))($643f0b2affc90cb3$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $1Pgvo.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $1Pgvo.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $643f0b2affc90cb3$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $643f0b2affc90cb3$export$2e2bcd8739ae039() {
    return $643f0b2affc90cb3$export$f5de0641c7db4154.use();
}
function $643f0b2affc90cb3$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $1Pgvo = parcelRequire("1Pgvo");

function $8563c9073014810c$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $gAPAo = parcelRequire("gAPAo");
function $6d60b1ff7bee44b7$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $aa8d85f938bde632$export$2e2bcd8739ae039(t, e) {
    return $aa8d85f938bde632$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $aa8d85f938bde632$export$2e2bcd8739ae039(t, e);
}


function $677389a38ff712f3$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $aa8d85f938bde632$export$2e2bcd8739ae039)(t, o);
}




var $1Pgvo = parcelRequire("1Pgvo");

var $1Pgvo = parcelRequire("1Pgvo");
var $4c1a3e5c472a4459$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($1Pgvo))).createContext(null);



var $1Pgvo = parcelRequire("1Pgvo");
function $851c81515f82a58c$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $1Pgvo.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $1Pgvo.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $851c81515f82a58c$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $851c81515f82a58c$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $851c81515f82a58c$export$fa71e2345c31d7a2(props, onExited) {
    return $851c81515f82a58c$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $1Pgvo.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $851c81515f82a58c$var$getProp(child, 'appear', props),
            enter: $851c81515f82a58c$var$getProp(child, 'enter', props),
            exit: $851c81515f82a58c$var$getProp(child, 'exit', props)
        });
    });
}
function $851c81515f82a58c$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $851c81515f82a58c$export$bbc8a025727ea824(nextProps.children);
    var children = $851c81515f82a58c$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $1Pgvo.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $1Pgvo.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $1Pgvo.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $851c81515f82a58c$var$getProp(child, 'exit', nextProps),
            enter: $851c81515f82a58c$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $1Pgvo.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $1Pgvo.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $1Pgvo.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $851c81515f82a58c$var$getProp(child, 'exit', nextProps),
            enter: $851c81515f82a58c$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $6afb1ba75c5d8e28$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $6afb1ba75c5d8e28$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $6afb1ba75c5d8e28$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $677389a38ff712f3$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $6d60b1ff7bee44b7$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $851c81515f82a58c$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $851c81515f82a58c$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $851c81515f82a58c$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $gAPAo.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $8563c9073014810c$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $6afb1ba75c5d8e28$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Pgvo))).createElement((0, $4c1a3e5c472a4459$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Pgvo))).createElement((0, $4c1a3e5c472a4459$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Pgvo))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Pgvo))).Component);
$6afb1ba75c5d8e28$var$TransitionGroup.propTypes = {};
$6afb1ba75c5d8e28$var$TransitionGroup.defaultProps = $6afb1ba75c5d8e28$var$defaultProps;
var $6afb1ba75c5d8e28$export$2e2bcd8739ae039 = $6afb1ba75c5d8e28$var$TransitionGroup;



var $2rX73 = parcelRequire("2rX73");
var $d5c72e85e84e724b$exports = {};
"use strict";

var $pArzt = parcelRequire("pArzt");
var $d5c72e85e84e724b$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty($d5c72e85e84e724b$exports, "__esModule", {
    value: true
});
Object.defineProperty($d5c72e85e84e724b$exports, "Timeout", {
    enumerable: true,
    get: function() {
        return $d5c72e85e84e724b$var$_useTimeout.Timeout;
    }
});
Object.defineProperty($d5c72e85e84e724b$exports, "default", {
    enumerable: true,
    get: function() {
        return $d5c72e85e84e724b$var$_useTimeout.default;
    }
});

var $d5c72e85e84e724b$var$_useTimeout = $d5c72e85e84e724b$require$_interopRequireWildcard((parcelRequire("cX22W")));



var $djYnP = parcelRequire("djYnP");


var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");

var $j6whP = parcelRequire("j6whP");
'use client';
function $c85cf26396b4dca6$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $1Pgvo.useState(false);
    const rippleClassName = (0, $2rX73.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $2rX73.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $1Pgvo.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $j6whP.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $j6whP.jsx)("span", {
            className: childClassName
        })
    });
}
var $c85cf26396b4dca6$export$2e2bcd8739ae039 = $c85cf26396b4dca6$var$Ripple;


var $3a7c4934f6f39f3a$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $3a7c4934f6f39f3a$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($3a7c4934f6f39f3a$exports, "__esModule", {
    value: true
});
Object.defineProperty($3a7c4934f6f39f3a$exports, "default", {
    enumerable: true,
    get: function() {
        return $3a7c4934f6f39f3a$var$_generateUtilityClasses.default;
    }
});

var $3a7c4934f6f39f3a$var$_generateUtilityClasses = $3a7c4934f6f39f3a$require$_interopRequireDefault((parcelRequire("6y44x")));



var $cxjEl = parcelRequire("cxjEl");
function $832d30439852f693$export$b464606f735ab902(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiTouchRipple', slot);
}
const $832d30439852f693$var$touchRippleClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $832d30439852f693$export$2e2bcd8739ae039 = $832d30439852f693$var$touchRippleClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
const $c3aad81b227188e0$var$DURATION = 550;
const $c3aad81b227188e0$export$95d0c9356b2231a3 = 80;
const $c3aad81b227188e0$var$enterKeyframe = (0, $djYnP.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $c3aad81b227188e0$var$exitKeyframe = (0, $djYnP.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $c3aad81b227188e0$var$pulsateKeyframe = (0, $djYnP.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $c3aad81b227188e0$export$f6b7418508c72c25 = (0, $843c443210106c30$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $c3aad81b227188e0$export$676cfe7b12693c4b = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $c85cf26396b4dca6$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $832d30439852f693$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$c3aad81b227188e0$var$enterKeyframe};
    animation-duration: ${$c3aad81b227188e0$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $832d30439852f693$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $832d30439852f693$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $832d30439852f693$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$c3aad81b227188e0$var$exitKeyframe};
    animation-duration: ${$c3aad81b227188e0$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $832d30439852f693$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$c3aad81b227188e0$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $c3aad81b227188e0$var$TouchRipple = /*#__PURE__*/ $1Pgvo.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $1Pgvo.useState([]);
    const nextKey = $1Pgvo.useRef(0);
    const rippleCallback = $1Pgvo.useRef(null);
    $1Pgvo.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $1Pgvo.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, (/*@__PURE__*/$parcel$interopDefault($d5c72e85e84e724b$exports)))();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $1Pgvo.useRef(null);
    const container = $1Pgvo.useRef(null);
    const startCommit = $1Pgvo.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $j6whP.jsx)($c3aad81b227188e0$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $2rX73.default)(classes.ripple, (0, $832d30439852f693$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $2rX73.default)(classes.rippleVisible, (0, $832d30439852f693$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $2rX73.default)(classes.ripplePulsate, (0, $832d30439852f693$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $2rX73.default)(classes.child, (0, $832d30439852f693$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $2rX73.default)(classes.childLeaving, (0, $832d30439852f693$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $2rX73.default)(classes.childPulsate, (0, $832d30439852f693$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $c3aad81b227188e0$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $1Pgvo.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($c3aad81b227188e0$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $1Pgvo.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $1Pgvo.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $1Pgvo.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $j6whP.jsx)($c3aad81b227188e0$export$f6b7418508c72c25, {
        className: (0, $2rX73.default)((0, $832d30439852f693$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $j6whP.jsx)((0, $6afb1ba75c5d8e28$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $c3aad81b227188e0$export$2e2bcd8739ae039 = $c3aad81b227188e0$var$TouchRipple;




var $cxjEl = parcelRequire("cxjEl");
function $1f660c34d115b59e$export$fccb0498dcd99783(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiButtonBase', slot);
}
const $1f660c34d115b59e$var$buttonBaseClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $1f660c34d115b59e$export$2e2bcd8739ae039 = $1f660c34d115b59e$var$buttonBaseClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
const $2f0bf7c15e1bf8e3$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $1f660c34d115b59e$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $2f0bf7c15e1bf8e3$export$7ec0dcc5e3cdcd36 = (0, $843c443210106c30$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $1f660c34d115b59e$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $2f0bf7c15e1bf8e3$var$ButtonBase = /*#__PURE__*/ $1Pgvo.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $1Pgvo.useRef(null);
    const ripple = (0, $643f0b2affc90cb3$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $4c40965b9645751b$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $1Pgvo.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $1Pgvo.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $1Pgvo.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $2f0bf7c15e1bf8e3$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $2f0bf7c15e1bf8e3$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $2f0bf7c15e1bf8e3$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $2f0bf7c15e1bf8e3$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $2f0bf7c15e1bf8e3$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $2f0bf7c15e1bf8e3$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $2f0bf7c15e1bf8e3$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $2f0bf7c15e1bf8e3$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $2f0bf7c15e1bf8e3$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($448bba3f542d9053$exports)))(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $6c1a5998fda37ac1$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($448bba3f542d9053$exports)))(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $6c1a5998fda37ac1$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $6c1a5998fda37ac1$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $4c40965b9645751b$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $2f0bf7c15e1bf8e3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $j6whP.jsxs)($2f0bf7c15e1bf8e3$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $2rX73.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $j6whP.jsx)((0, $c3aad81b227188e0$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $2f0bf7c15e1bf8e3$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $6c1a5998fda37ac1$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $2f0bf7c15e1bf8e3$export$2e2bcd8739ae039 = $2f0bf7c15e1bf8e3$var$ButtonBase;



var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");



var $djYnP = parcelRequire("djYnP");



var $bEhYY = parcelRequire("bEhYY");
var $f20308847ed204aa$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bEhYY)));


/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $52ba33dfeda69b95$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $52ba33dfeda69b95$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$52ba33dfeda69b95$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $52ba33dfeda69b95$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $52ba33dfeda69b95$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}




var $cxjEl = parcelRequire("cxjEl");
function $76f75d6e904197c8$export$29cad1383b3f235d(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiCircularProgress', slot);
}
const $76f75d6e904197c8$var$circularProgressClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $76f75d6e904197c8$export$2e2bcd8739ae039 = $76f75d6e904197c8$var$circularProgressClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
const $cdfdb16a910e3746$var$SIZE = 44;
const $cdfdb16a910e3746$var$circularRotateKeyframe = (0, $djYnP.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $cdfdb16a910e3746$var$circularDashKeyframe = (0, $djYnP.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $cdfdb16a910e3746$var$rotateAnimation = typeof $cdfdb16a910e3746$var$circularRotateKeyframe !== 'string' ? (0, $djYnP.css)`
        animation: ${$cdfdb16a910e3746$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $cdfdb16a910e3746$var$dashAnimation = typeof $cdfdb16a910e3746$var$circularDashKeyframe !== 'string' ? (0, $djYnP.css)`
        animation: ${$cdfdb16a910e3746$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $cdfdb16a910e3746$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $76f75d6e904197c8$export$29cad1383b3f235d), classes);
};
const $cdfdb16a910e3746$var$CircularProgressRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $cdfdb16a910e3746$var$rotateAnimation || {
                    animation: `${$cdfdb16a910e3746$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $52ba33dfeda69b95$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $cdfdb16a910e3746$var$CircularProgressSVG = (0, $843c443210106c30$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $cdfdb16a910e3746$var$CircularProgressCircle = (0, $843c443210106c30$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $cdfdb16a910e3746$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$cdfdb16a910e3746$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $cdfdb16a910e3746$var$CircularProgress = /*#__PURE__*/ $1Pgvo.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $cdfdb16a910e3746$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($cdfdb16a910e3746$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $j6whP.jsx)($cdfdb16a910e3746$var$CircularProgressRoot, {
        className: (0, $2rX73.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $j6whP.jsx)($cdfdb16a910e3746$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$cdfdb16a910e3746$var$SIZE / 2} ${$cdfdb16a910e3746$var$SIZE / 2} ${$cdfdb16a910e3746$var$SIZE} ${$cdfdb16a910e3746$var$SIZE}`,
            children: /*#__PURE__*/ (0, $j6whP.jsx)($cdfdb16a910e3746$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $cdfdb16a910e3746$var$SIZE,
                cy: $cdfdb16a910e3746$var$SIZE,
                r: ($cdfdb16a910e3746$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $cdfdb16a910e3746$export$2e2bcd8739ae039 = $cdfdb16a910e3746$var$CircularProgress;






var $cxjEl = parcelRequire("cxjEl");
function $2232bf09aaa88a73$export$5a6f9035944c8119(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiButton', slot);
}
const $2232bf09aaa88a73$var$buttonClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $2232bf09aaa88a73$export$2e2bcd8739ae039 = $2232bf09aaa88a73$var$buttonClasses;



var $1Pgvo = parcelRequire("1Pgvo");
'use client';
/**
 * @ignore - internal component.
 */ const $c7ff1d31a47a22d6$var$ButtonGroupContext = /*#__PURE__*/ $1Pgvo.createContext({});
var $c7ff1d31a47a22d6$export$2e2bcd8739ae039 = $c7ff1d31a47a22d6$var$ButtonGroupContext;



var $1Pgvo = parcelRequire("1Pgvo");
'use client';
/**
 * @ignore - internal component.
 */ const $fcf3acea5820320c$var$ButtonGroupButtonContext = /*#__PURE__*/ $1Pgvo.createContext(undefined);
var $fcf3acea5820320c$export$2e2bcd8739ae039 = $fcf3acea5820320c$var$ButtonGroupButtonContext;



var $j6whP = parcelRequire("j6whP");
'use client';
const $58c32298ee832f7f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $2232bf09aaa88a73$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $58c32298ee832f7f$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $58c32298ee832f7f$var$ButtonRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $2f0bf7c15e1bf8e3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $c67b4c535d9075aa$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $2232bf09aaa88a73$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $2232bf09aaa88a73$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $2232bf09aaa88a73$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $2232bf09aaa88a73$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $52ba33dfeda69b95$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $8a2c9660dd4393d2$exports.alpha)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8a2c9660dd4393d2$exports.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8a2c9660dd4393d2$exports.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8a2c9660dd4393d2$exports.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8a2c9660dd4393d2$exports.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $2232bf09aaa88a73$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $2232bf09aaa88a73$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $2232bf09aaa88a73$export$2e2bcd8739ae039).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $58c32298ee832f7f$var$ButtonStartIcon = (0, $843c443210106c30$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$58c32298ee832f7f$var$commonIconStyles
        ]
    }));
const $58c32298ee832f7f$var$ButtonEndIcon = (0, $843c443210106c30$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$58c32298ee832f7f$var$commonIconStyles
        ]
    }));
const $58c32298ee832f7f$var$ButtonLoadingIndicator = (0, $843c443210106c30$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $58c32298ee832f7f$var$ButtonLoadingIconPlaceholder = (0, $843c443210106c30$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $58c32298ee832f7f$var$Button = /*#__PURE__*/ $1Pgvo.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $1Pgvo.useContext((0, $c7ff1d31a47a22d6$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $1Pgvo.useContext((0, $fcf3acea5820320c$export$2e2bcd8739ae039));
    const resolvedProps = (0, (/*@__PURE__*/$parcel$interopDefault($kIDXC)))(contextProps, inProps);
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $11dde830dc4c8a7a$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $j6whP.jsx)((0, $cdfdb16a910e3746$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $58c32298ee832f7f$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $j6whP.jsx)($58c32298ee832f7f$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $j6whP.jsx)($58c32298ee832f7f$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $j6whP.jsx)($58c32298ee832f7f$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $j6whP.jsx)($58c32298ee832f7f$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $j6whP.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $j6whP.jsx)($58c32298ee832f7f$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $j6whP.jsxs)($58c32298ee832f7f$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $2rX73.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $2rX73.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $58c32298ee832f7f$export$2e2bcd8739ae039 = $58c32298ee832f7f$var$Button;


var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");






var $1Pgvo = parcelRequire("1Pgvo");



var $cWnbn = parcelRequire("cWnbn");


var $iKhyI = parcelRequire("iKhyI");

var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");




var $1Pgvo = parcelRequire("1Pgvo");

var $dc560c09a746725e$exports = {};
"use strict";

var $pArzt = parcelRequire("pArzt");
var $dc560c09a746725e$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty($dc560c09a746725e$exports, "__esModule", {
    value: true
});
var $dc560c09a746725e$var$_exportNames = {};
Object.defineProperty($dc560c09a746725e$exports, "default", {
    enumerable: true,
    get: function() {
        return $dc560c09a746725e$var$_debounce.default;
    }
});

var $dc560c09a746725e$var$_debounce = $dc560c09a746725e$require$_interopRequireWildcard((parcelRequire("2c14b")));
Object.keys($dc560c09a746725e$var$_debounce).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dc560c09a746725e$var$_exportNames, key)) return;
    if (key in $dc560c09a746725e$exports && $dc560c09a746725e$exports[key] === $dc560c09a746725e$var$_debounce[key]) return;
    Object.defineProperty($dc560c09a746725e$exports, key, {
        enumerable: true,
        get: function() {
            return $dc560c09a746725e$var$_debounce[key];
        }
    });
});



var $aMDvQ = parcelRequire("aMDvQ");

var $hWrnM = parcelRequire("hWrnM");

var $6dc8856edafa4ded$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $6dc8856edafa4ded$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($6dc8856edafa4ded$exports, "__esModule", {
    value: true
});
Object.defineProperty($6dc8856edafa4ded$exports, "default", {
    enumerable: true,
    get: function() {
        return $6dc8856edafa4ded$var$_ownerWindow.default;
    }
});

var $6dc8856edafa4ded$var$_ownerWindow = $6dc8856edafa4ded$require$_interopRequireDefault((parcelRequire("87hkp")));



var $j6whP = parcelRequire("j6whP");
'use client';
function $9208d96e11a196f3$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $9208d96e11a196f3$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $9208d96e11a196f3$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $9208d96e11a196f3$var$isEmpty(obj) {
    return $9208d96e11a196f3$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $9208d96e11a196f3$var$TextareaAutosize = /*#__PURE__*/ $1Pgvo.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $1Pgvo.useRef(value != null);
    const textareaRef = $1Pgvo.useRef(null);
    const handleRef = (0, (/*@__PURE__*/$parcel$interopDefault($aMDvQ)))(forwardedRef, textareaRef);
    const heightRef = $1Pgvo.useRef(null);
    const hiddenTextareaRef = $1Pgvo.useRef(null);
    const calculateTextareaStyles = $1Pgvo.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, (/*@__PURE__*/$parcel$interopDefault($6dc8856edafa4ded$exports)))(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $9208d96e11a196f3$var$getStyleValue(computedStyle.paddingBottom) + $9208d96e11a196f3$var$getStyleValue(computedStyle.paddingTop);
        const border = $9208d96e11a196f3$var$getStyleValue(computedStyle.borderBottomWidth) + $9208d96e11a196f3$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, (/*@__PURE__*/$parcel$interopDefault($3970405edc15cfc3$exports)))(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $9208d96e11a196f3$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $1Pgvo.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $9208d96e11a196f3$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $1Pgvo.useRef(-1);
    (0, (/*@__PURE__*/$parcel$interopDefault($hWrnM)))(()=>{
        const debouncedHandleResize = (0, (/*@__PURE__*/$parcel$interopDefault($dc560c09a746725e$exports)))(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, (/*@__PURE__*/$parcel$interopDefault($6dc8856edafa4ded$exports)))(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($hWrnM)))(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $j6whP.jsxs)($1Pgvo.Fragment, {
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$9208d96e11a196f3$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $9208d96e11a196f3$export$2e2bcd8739ae039 = $9208d96e11a196f3$var$TextareaAutosize;


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $0c54251f72a22d9a$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $0c54251f72a22d9a$export$2e2bcd8739ae039 = $0c54251f72a22d9a$var$isHostComponent;


function $20df67a4de76db0b$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $1Pgvo = parcelRequire("1Pgvo");
'use client';
/**
 * @ignore - internal component.
 */ const $6640e91aa3c72c88$var$FormControlContext = /*#__PURE__*/ $1Pgvo.createContext(undefined);
var $6640e91aa3c72c88$export$2e2bcd8739ae039 = $6640e91aa3c72c88$var$FormControlContext;



var $1Pgvo = parcelRequire("1Pgvo");

'use client';
function $d2905474c3ea892d$export$2e2bcd8739ae039() {
    return $1Pgvo.useContext((0, $6640e91aa3c72c88$export$2e2bcd8739ae039));
}


parcelRequire("1Pgvo");

var $a4tM1 = parcelRequire("a4tM1");
parcelRequire("1Pgvo");

var $cWnbn = parcelRequire("cWnbn");
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $7de0f25cbf5d0813$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $7de0f25cbf5d0813$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $7de0f25cbf5d0813$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $7de0f25cbf5d0813$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}



const $8fc65a2797a5fddf$var$shape = {
    borderRadius: 4
};
var $8fc65a2797a5fddf$export$2e2bcd8739ae039 = $8fc65a2797a5fddf$var$shape;




var $bEhYY = parcelRequire("bEhYY");








function $66794eb7f5b2e51a$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $f62f292d3e4d1545$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $66794eb7f5b2e51a$export$2e2bcd8739ae039 = $66794eb7f5b2e51a$var$compose;




function $84c615e2162c2a36$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $84c615e2162c2a36$var$createBorderStyle(prop, transform) {
    return (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $84c615e2162c2a36$export$1edee58a52776cd9 = $84c615e2162c2a36$var$createBorderStyle('border', $84c615e2162c2a36$export$34e2febe53ae29cc);
const $84c615e2162c2a36$export$f9a7b6bd24892946 = $84c615e2162c2a36$var$createBorderStyle('borderTop', $84c615e2162c2a36$export$34e2febe53ae29cc);
const $84c615e2162c2a36$export$5abca33e6be905d2 = $84c615e2162c2a36$var$createBorderStyle('borderRight', $84c615e2162c2a36$export$34e2febe53ae29cc);
const $84c615e2162c2a36$export$e2ce9f12a980a822 = $84c615e2162c2a36$var$createBorderStyle('borderBottom', $84c615e2162c2a36$export$34e2febe53ae29cc);
const $84c615e2162c2a36$export$47658cca1a909427 = $84c615e2162c2a36$var$createBorderStyle('borderLeft', $84c615e2162c2a36$export$34e2febe53ae29cc);
const $84c615e2162c2a36$export$e7fb0694ba2404fc = $84c615e2162c2a36$var$createBorderStyle('borderColor');
const $84c615e2162c2a36$export$126a92c968acdb85 = $84c615e2162c2a36$var$createBorderStyle('borderTopColor');
const $84c615e2162c2a36$export$85cc51cb8fbb8c0e = $84c615e2162c2a36$var$createBorderStyle('borderRightColor');
const $84c615e2162c2a36$export$340b0327727f6d1a = $84c615e2162c2a36$var$createBorderStyle('borderBottomColor');
const $84c615e2162c2a36$export$60beef91a985b4bf = $84c615e2162c2a36$var$createBorderStyle('borderLeftColor');
const $84c615e2162c2a36$export$f9258c55612cbed7 = $84c615e2162c2a36$var$createBorderStyle('outline', $84c615e2162c2a36$export$34e2febe53ae29cc);
const $84c615e2162c2a36$export$621fe586efeb64b9 = $84c615e2162c2a36$var$createBorderStyle('outlineColor');
const $84c615e2162c2a36$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $36c1e5a0db50a2e0$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $36c1e5a0db50a2e0$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $ae6c3eef95e7a204$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$84c615e2162c2a36$export$7a57f79000377ca2.propTypes = {};
$84c615e2162c2a36$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $84c615e2162c2a36$var$borders = (0, $66794eb7f5b2e51a$export$2e2bcd8739ae039)($84c615e2162c2a36$export$1edee58a52776cd9, $84c615e2162c2a36$export$f9a7b6bd24892946, $84c615e2162c2a36$export$5abca33e6be905d2, $84c615e2162c2a36$export$e2ce9f12a980a822, $84c615e2162c2a36$export$47658cca1a909427, $84c615e2162c2a36$export$e7fb0694ba2404fc, $84c615e2162c2a36$export$126a92c968acdb85, $84c615e2162c2a36$export$85cc51cb8fbb8c0e, $84c615e2162c2a36$export$340b0327727f6d1a, $84c615e2162c2a36$export$60beef91a985b4bf, $84c615e2162c2a36$export$7a57f79000377ca2, $84c615e2162c2a36$export$f9258c55612cbed7, $84c615e2162c2a36$export$621fe586efeb64b9);
var $84c615e2162c2a36$export$2e2bcd8739ae039 = $84c615e2162c2a36$var$borders;







const $23af366bb4a16dc8$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $36c1e5a0db50a2e0$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $36c1e5a0db50a2e0$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $ae6c3eef95e7a204$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$23af366bb4a16dc8$export$5df9adcb0db95e1e.propTypes = {};
$23af366bb4a16dc8$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $23af366bb4a16dc8$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $36c1e5a0db50a2e0$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $36c1e5a0db50a2e0$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $ae6c3eef95e7a204$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$23af366bb4a16dc8$export$ec60d70ff941a580.propTypes = {};
$23af366bb4a16dc8$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $23af366bb4a16dc8$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $36c1e5a0db50a2e0$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $36c1e5a0db50a2e0$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $ae6c3eef95e7a204$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$23af366bb4a16dc8$export$8a833ffa5f5dbeda.propTypes = {};
$23af366bb4a16dc8$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $23af366bb4a16dc8$export$baf44164ca3a34e8 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $23af366bb4a16dc8$export$8f7213a1cd01e832 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $23af366bb4a16dc8$export$b0e0abbc49ba668 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $23af366bb4a16dc8$export$bcd8b929d4b4142 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $23af366bb4a16dc8$export$e5039a674e14c828 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $23af366bb4a16dc8$export$42bd9088661ffb03 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $23af366bb4a16dc8$export$920682ae05b999bc = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $23af366bb4a16dc8$export$1b88fbdd482fd33a = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $23af366bb4a16dc8$export$bdb486e40d52d26f = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $23af366bb4a16dc8$var$grid = (0, $66794eb7f5b2e51a$export$2e2bcd8739ae039)($23af366bb4a16dc8$export$5df9adcb0db95e1e, $23af366bb4a16dc8$export$ec60d70ff941a580, $23af366bb4a16dc8$export$8a833ffa5f5dbeda, $23af366bb4a16dc8$export$baf44164ca3a34e8, $23af366bb4a16dc8$export$8f7213a1cd01e832, $23af366bb4a16dc8$export$b0e0abbc49ba668, $23af366bb4a16dc8$export$bcd8b929d4b4142, $23af366bb4a16dc8$export$e5039a674e14c828, $23af366bb4a16dc8$export$42bd9088661ffb03, $23af366bb4a16dc8$export$920682ae05b999bc, $23af366bb4a16dc8$export$1b88fbdd482fd33a, $23af366bb4a16dc8$export$bdb486e40d52d26f);
var $23af366bb4a16dc8$export$2e2bcd8739ae039 = $23af366bb4a16dc8$var$grid;




function $4270960b5d602574$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $4270960b5d602574$export$35e9368ef982300f = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $4270960b5d602574$export$dbaffd4420ea0ac6
});
const $4270960b5d602574$export$2506f56c10355b33 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $4270960b5d602574$export$dbaffd4420ea0ac6
});
const $4270960b5d602574$export$8c5a050822fd698c = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $4270960b5d602574$export$dbaffd4420ea0ac6
});
const $4270960b5d602574$var$palette = (0, $66794eb7f5b2e51a$export$2e2bcd8739ae039)($4270960b5d602574$export$35e9368ef982300f, $4270960b5d602574$export$2506f56c10355b33, $4270960b5d602574$export$8c5a050822fd698c);
var $4270960b5d602574$export$2e2bcd8739ae039 = $4270960b5d602574$var$palette;





function $997aed6c5c22587f$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $997aed6c5c22587f$export$7e3df82ee760448c = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $997aed6c5c22587f$export$8afece71750ec241
});
const $997aed6c5c22587f$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $ae6c3eef95e7a204$export$68c286be0e7e55b7)[propValue];
            if (!breakpoint) return {
                maxWidth: $997aed6c5c22587f$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $ae6c3eef95e7a204$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$997aed6c5c22587f$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $997aed6c5c22587f$export$ee148fbbe8357dd2 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $997aed6c5c22587f$export$8afece71750ec241
});
const $997aed6c5c22587f$export$ac607276a8fe9f0a = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $997aed6c5c22587f$export$8afece71750ec241
});
const $997aed6c5c22587f$export$dc0d8bd0b94f8570 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $997aed6c5c22587f$export$8afece71750ec241
});
const $997aed6c5c22587f$export$a43cf604e12f3b17 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $997aed6c5c22587f$export$8afece71750ec241
});
const $997aed6c5c22587f$export$ffed9f14fb65e276 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $997aed6c5c22587f$export$8afece71750ec241
});
const $997aed6c5c22587f$export$905076ed6620e671 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $997aed6c5c22587f$export$8afece71750ec241
});
const $997aed6c5c22587f$export$6ccc93f785106a58 = (0, $a6c9783532d5ed2a$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $997aed6c5c22587f$var$sizing = (0, $66794eb7f5b2e51a$export$2e2bcd8739ae039)($997aed6c5c22587f$export$7e3df82ee760448c, $997aed6c5c22587f$export$488fda99655ff65a, $997aed6c5c22587f$export$ee148fbbe8357dd2, $997aed6c5c22587f$export$ac607276a8fe9f0a, $997aed6c5c22587f$export$dc0d8bd0b94f8570, $997aed6c5c22587f$export$a43cf604e12f3b17, $997aed6c5c22587f$export$6ccc93f785106a58);
var $997aed6c5c22587f$export$2e2bcd8739ae039 = $997aed6c5c22587f$var$sizing;


const $af2a522242e1d147$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $84c615e2162c2a36$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $84c615e2162c2a36$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $84c615e2162c2a36$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $84c615e2162c2a36$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $84c615e2162c2a36$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $84c615e2162c2a36$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $84c615e2162c2a36$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $4270960b5d602574$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $4270960b5d602574$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $4270960b5d602574$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $36c1e5a0db50a2e0$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $36c1e5a0db50a2e0$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $23af366bb4a16dc8$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $23af366bb4a16dc8$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $23af366bb4a16dc8$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $997aed6c5c22587f$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $997aed6c5c22587f$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $997aed6c5c22587f$export$8afece71750ec241)
    },
    height: {
        transform: (0, $997aed6c5c22587f$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $997aed6c5c22587f$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $997aed6c5c22587f$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $af2a522242e1d147$export$2e2bcd8739ae039 = $af2a522242e1d147$var$defaultSxConfig;


function $c9649f19b9f2bca0$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $c9649f19b9f2bca0$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $c9649f19b9f2bca0$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $a6c9783532d5ed2a$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $a6c9783532d5ed2a$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $a6c9783532d5ed2a$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($bEhYY)))(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $ae6c3eef95e7a204$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $af2a522242e1d147$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $ae6c3eef95e7a204$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $c9649f19b9f2bca0$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $f62f292d3e4d1545$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $ae6c3eef95e7a204$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($c9649f19b9f2bca0$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $f62f292d3e4d1545$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $f62f292d3e4d1545$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $ba8f192cfa30a178$export$456f6c1142f990db)(theme, (0, $ae6c3eef95e7a204$export$8922c90b6e020726)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $c9649f19b9f2bca0$var$styleFunctionSx = $c9649f19b9f2bca0$export$7d53d8bf2911e013();
$c9649f19b9f2bca0$var$styleFunctionSx.filterProps = [
    'sx'
];
var $c9649f19b9f2bca0$export$2e2bcd8739ae039 = $c9649f19b9f2bca0$var$styleFunctionSx;



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $7e6bc739dd906db9$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


function $56232bd12c63a3fe$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $7de0f25cbf5d0813$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $ceed81bef47f4750$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $8fc65a2797a5fddf$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $ba8f192cfa30a178$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $7e6bc739dd906db9$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $af2a522242e1d147$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $c9649f19b9f2bca0$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $56232bd12c63a3fe$export$2e2bcd8739ae039 = $56232bd12c63a3fe$var$createTheme;



var $1Pgvo = parcelRequire("1Pgvo");
parcelRequire("djYnP");
var $jjrEh = parcelRequire("jjrEh");
'use client';
function $739199b61139c9cc$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $739199b61139c9cc$var$useTheme(defaultTheme = null) {
    const contextTheme = $1Pgvo.useContext((0, $jjrEh.T));
    return !contextTheme || $739199b61139c9cc$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $739199b61139c9cc$export$2e2bcd8739ae039 = $739199b61139c9cc$var$useTheme;


'use client';
const $83ce811553e4e4bf$export$35e57303dbd8a66 = (0, $56232bd12c63a3fe$export$2e2bcd8739ae039)();
function $83ce811553e4e4bf$var$useTheme(defaultTheme = $83ce811553e4e4bf$export$35e57303dbd8a66) {
    return (0, $739199b61139c9cc$export$2e2bcd8739ae039)(defaultTheme);
}
var $83ce811553e4e4bf$export$2e2bcd8739ae039 = $83ce811553e4e4bf$var$useTheme;




'use client';
function $103054d1cadc4a60$export$2e2bcd8739ae039() {
    const theme = (0, $83ce811553e4e4bf$export$2e2bcd8739ae039)((0, $4828a42d7a53d2e5$export$2e2bcd8739ae039));
    return theme[0, $e01b19e3fab8f92b$export$2e2bcd8739ae039] || theme;
}


parcelRequire("1Pgvo");

parcelRequire("1Pgvo");


var $fmb6q = parcelRequire("fmb6q");


var $j6whP = parcelRequire("j6whP");
'use client';
function $f91b70b90a3796eb$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $83ce811553e4e4bf$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $fmb6q.default), {
        styles: globalStyles
    });
}
var $f91b70b90a3796eb$export$2e2bcd8739ae039 = $f91b70b90a3796eb$var$GlobalStyles;





var $j6whP = parcelRequire("j6whP");
'use client';
function $f45580e82a3cdc36$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $f91b70b90a3796eb$export$2e2bcd8739ae039), {
        ...props,
        defaultTheme: (0, $4828a42d7a53d2e5$export$2e2bcd8739ae039),
        themeId: (0, $e01b19e3fab8f92b$export$2e2bcd8739ae039)
    });
}
var $f45580e82a3cdc36$export$2e2bcd8739ae039 = $f45580e82a3cdc36$var$GlobalStyles;



var $j6whP = parcelRequire("j6whP");

var $djYnP = parcelRequire("djYnP");

function $f62d128e5fcadad6$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $j6whP.jsx)((0, $f45580e82a3cdc36$export$2e2bcd8739ae039), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $f62d128e5fcadad6$export$7e7f5719ff4debb1() {
    return 0, $a4tM1.extendSxProp;
}







var $hWrnM = parcelRequire("hWrnM");
'use client';
var $469979860900a653$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($hWrnM)));


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $ed65b54480c0c34c$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $ed65b54480c0c34c$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($ed65b54480c0c34c$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $ed65b54480c0c34c$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $ed65b54480c0c34c$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




var $cxjEl = parcelRequire("cxjEl");
function $a965d0dc22735507$export$ef57d5c8ca2278f6(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiInputBase', slot);
}
const $a965d0dc22735507$var$inputBaseClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $a965d0dc22735507$export$2e2bcd8739ae039 = $a965d0dc22735507$var$inputBaseClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
var $45dd472de8f51029$var$_InputGlobalStyles;
const $45dd472de8f51029$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $45dd472de8f51029$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $45dd472de8f51029$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $a965d0dc22735507$export$ef57d5c8ca2278f6), classes);
};
const $45dd472de8f51029$export$298a043133d72a38 = (0, $843c443210106c30$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $45dd472de8f51029$export$965edad20a84fa75
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $a965d0dc22735507$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $45dd472de8f51029$export$ee10465db6ff6017 = (0, $843c443210106c30$export$2e2bcd8739ae039)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $45dd472de8f51029$export$cf507b112810e72d
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $a965d0dc22735507$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $a965d0dc22735507$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $45dd472de8f51029$var$InputGlobalStyles = (0, $f62d128e5fcadad6$export$db53682eef82cc11)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $45dd472de8f51029$var$InputBase = /*#__PURE__*/ $1Pgvo.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $1Pgvo.useRef(value != null);
    const inputRef = $1Pgvo.useRef();
    const handleInputRefWarning = $1Pgvo.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $4c40965b9645751b$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $1Pgvo.useState(false);
    const muiFormControl = (0, $d2905474c3ea892d$export$2e2bcd8739ae039)();
    const fcs = (0, $20df67a4de76db0b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $1Pgvo.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $1Pgvo.useCallback((obj)=>{
        if ((0, $ed65b54480c0c34c$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $469979860900a653$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($iKhyI)))(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $1Pgvo.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $9208d96e11a196f3$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $1Pgvo.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $45dd472de8f51029$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $45dd472de8f51029$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $45dd472de8f51029$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $j6whP.jsxs)($1Pgvo.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $45dd472de8f51029$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($45dd472de8f51029$var$_InputGlobalStyles || ($45dd472de8f51029$var$_InputGlobalStyles = /*#__PURE__*/ (0, $j6whP.jsx)($45dd472de8f51029$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $j6whP.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $0c54251f72a22d9a$export$2e2bcd8739ae039)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $2rX73.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $j6whP.jsx)((0, $6640e91aa3c72c88$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $j6whP.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $0c54251f72a22d9a$export$2e2bcd8739ae039)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $2rX73.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $45dd472de8f51029$export$2e2bcd8739ae039 = $45dd472de8f51029$var$InputBase;









var $cxjEl = parcelRequire("cxjEl");

function $c234f365e81ed64c$export$cdb270390122322b(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiInput', slot);
}
const $c234f365e81ed64c$var$inputClasses = {
    ...(0, $a965d0dc22735507$export$2e2bcd8739ae039),
    ...(0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $c234f365e81ed64c$export$2e2bcd8739ae039 = $c234f365e81ed64c$var$inputClasses;




var $j6whP = parcelRequire("j6whP");
'use client';
const $3dcdf4e0d79a87f2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $c234f365e81ed64c$export$cdb270390122322b), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $3dcdf4e0d79a87f2$var$InputRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $45dd472de8f51029$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $c67b4c535d9075aa$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $45dd472de8f51029$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $c234f365e81ed64c$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $c234f365e81ed64c$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $c234f365e81ed64c$export$2e2bcd8739ae039).disabled}, .${(0, $c234f365e81ed64c$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $c234f365e81ed64c$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $52ba33dfeda69b95$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $3dcdf4e0d79a87f2$var$InputInput = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $45dd472de8f51029$export$ee10465db6ff6017), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $45dd472de8f51029$export$cf507b112810e72d)
})({});
const $3dcdf4e0d79a87f2$var$Input = /*#__PURE__*/ $1Pgvo.forwardRef(function Input(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $3dcdf4e0d79a87f2$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $3dcdf4e0d79a87f2$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $3dcdf4e0d79a87f2$var$InputInput;
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $45dd472de8f51029$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$3dcdf4e0d79a87f2$var$Input.muiName = 'Input';
var $3dcdf4e0d79a87f2$export$2e2bcd8739ae039 = $3dcdf4e0d79a87f2$var$Input;



var $1Pgvo = parcelRequire("1Pgvo");

var $cWnbn = parcelRequire("cWnbn");











var $cxjEl = parcelRequire("cxjEl");

function $55c11e87e69d354f$export$3331e419f1a48437(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiFilledInput', slot);
}
const $55c11e87e69d354f$var$filledInputClasses = {
    ...(0, $a965d0dc22735507$export$2e2bcd8739ae039),
    ...(0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $55c11e87e69d354f$export$2e2bcd8739ae039 = $55c11e87e69d354f$var$filledInputClasses;





var $j6whP = parcelRequire("j6whP");
'use client';
const $239de2fd46b8c07f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $55c11e87e69d354f$export$3331e419f1a48437), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $239de2fd46b8c07f$var$FilledInputRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $45dd472de8f51029$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $c67b4c535d9075aa$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $45dd472de8f51029$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $55c11e87e69d354f$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $55c11e87e69d354f$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $55c11e87e69d354f$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $55c11e87e69d354f$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $55c11e87e69d354f$export$2e2bcd8739ae039).disabled}, .${(0, $55c11e87e69d354f$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $55c11e87e69d354f$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $52ba33dfeda69b95$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $239de2fd46b8c07f$var$FilledInputInput = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $45dd472de8f51029$export$ee10465db6ff6017), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $45dd472de8f51029$export$cf507b112810e72d)
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $239de2fd46b8c07f$var$FilledInput = /*#__PURE__*/ $1Pgvo.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $239de2fd46b8c07f$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $239de2fd46b8c07f$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $239de2fd46b8c07f$var$FilledInputInput;
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $45dd472de8f51029$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$239de2fd46b8c07f$var$FilledInput.muiName = 'Input';
var $239de2fd46b8c07f$export$2e2bcd8739ae039 = $239de2fd46b8c07f$var$FilledInput;



var $1Pgvo = parcelRequire("1Pgvo");



parcelRequire("1Pgvo");





var $j6whP = parcelRequire("j6whP");
'use client';
var $71a9e9131bbd6bb5$var$_span;
const $71a9e9131bbd6bb5$var$NotchedOutlineRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)('fieldset', {
    shouldForwardProp: (0, $c67b4c535d9075aa$export$2e2bcd8739ae039)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $71a9e9131bbd6bb5$var$NotchedOutlineLegend = (0, $843c443210106c30$export$2e2bcd8739ae039)('legend', {
    shouldForwardProp: (0, $c67b4c535d9075aa$export$2e2bcd8739ae039)
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $71a9e9131bbd6bb5$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $j6whP.jsx)($71a9e9131bbd6bb5$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $j6whP.jsx)($71a9e9131bbd6bb5$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                children: label
            }) : $71a9e9131bbd6bb5$var$_span || ($71a9e9131bbd6bb5$var$_span = /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}











var $cxjEl = parcelRequire("cxjEl");

function $98643f714ce152a8$export$89922944c7227687(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiOutlinedInput', slot);
}
const $98643f714ce152a8$var$outlinedInputClasses = {
    ...(0, $a965d0dc22735507$export$2e2bcd8739ae039),
    ...(0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $98643f714ce152a8$export$2e2bcd8739ae039 = $98643f714ce152a8$var$outlinedInputClasses;




var $aMDvQ = parcelRequire("aMDvQ");

var $eJe9g = parcelRequire("eJe9g");

var $cF2vv = parcelRequire("cF2vv");

var $bM7Uf = parcelRequire("bM7Uf");
'use client';
function $f75f95dbace8cca3$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, (/*@__PURE__*/$parcel$interopDefault($cF2vv)))(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, (/*@__PURE__*/$parcel$interopDefault($bM7Uf)))({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($aMDvQ)))(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, (/*@__PURE__*/$parcel$interopDefault($eJe9g)))(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}



var $j6whP = parcelRequire("j6whP");
'use client';
const $6730b7889d9edb8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $98643f714ce152a8$export$89922944c7227687), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $6730b7889d9edb8e$var$OutlinedInputRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $45dd472de8f51029$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $c67b4c535d9075aa$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $45dd472de8f51029$export$965edad20a84fa75)
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $98643f714ce152a8$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $98643f714ce152a8$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $98643f714ce152a8$export$2e2bcd8739ae039).focused} .${(0, $98643f714ce152a8$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $52ba33dfeda69b95$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $98643f714ce152a8$export$2e2bcd8739ae039).focused} .${(0, $98643f714ce152a8$export$2e2bcd8739ae039).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${(0, $98643f714ce152a8$export$2e2bcd8739ae039).error} .${(0, $98643f714ce152a8$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $98643f714ce152a8$export$2e2bcd8739ae039).disabled} .${(0, $98643f714ce152a8$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $6730b7889d9edb8e$var$NotchedOutlineRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $71a9e9131bbd6bb5$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const $6730b7889d9edb8e$var$OutlinedInputInput = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $45dd472de8f51029$export$ee10465db6ff6017), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $45dd472de8f51029$export$cf507b112810e72d)
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $6730b7889d9edb8e$var$OutlinedInput = /*#__PURE__*/ $1Pgvo.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $6730b7889d9edb8e$var$useUtilityClasses(props);
    const muiFormControl = (0, $d2905474c3ea892d$export$2e2bcd8739ae039)();
    const fcs = (0, $20df67a4de76db0b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $6730b7889d9edb8e$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $6730b7889d9edb8e$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('notchedOutline', {
        elementType: $6730b7889d9edb8e$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $j6whP.jsxs)($1Pgvo.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $45dd472de8f51029$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $j6whP.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$6730b7889d9edb8e$var$OutlinedInput.muiName = 'Input';
var $6730b7889d9edb8e$export$2e2bcd8739ae039 = $6730b7889d9edb8e$var$OutlinedInput;



var $1Pgvo = parcelRequire("1Pgvo");



var $2rX73 = parcelRequire("2rX73");



var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");










var $cxjEl = parcelRequire("cxjEl");
function $dc4d2229b5e51252$export$f7d501e40371cd17(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiFormLabel', slot);
}
const $dc4d2229b5e51252$var$formLabelClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $dc4d2229b5e51252$export$2e2bcd8739ae039 = $dc4d2229b5e51252$var$formLabelClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
const $2aa603e2ceab697b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $dc4d2229b5e51252$export$f7d501e40371cd17), classes);
};
const $2aa603e2ceab697b$export$aa5bc7f8a4705b27 = (0, $843c443210106c30$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $52ba33dfeda69b95$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $dc4d2229b5e51252$export$2e2bcd8739ae039).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $dc4d2229b5e51252$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $dc4d2229b5e51252$export$2e2bcd8739ae039).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $2aa603e2ceab697b$var$AsteriskComponent = (0, $843c443210106c30$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $dc4d2229b5e51252$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $2aa603e2ceab697b$var$FormLabel = /*#__PURE__*/ $1Pgvo.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $d2905474c3ea892d$export$2e2bcd8739ae039)();
    const fcs = (0, $20df67a4de76db0b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $2aa603e2ceab697b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $j6whP.jsxs)($2aa603e2ceab697b$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $2rX73.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $j6whP.jsxs)($2aa603e2ceab697b$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $2aa603e2ceab697b$export$2e2bcd8739ae039 = $2aa603e2ceab697b$var$FormLabel;









var $cxjEl = parcelRequire("cxjEl");
function $a82a6fbd470ad70e$export$c1c4b4545ad2ea5f(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiInputLabel', slot);
}
const $a82a6fbd470ad70e$var$inputLabelClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $a82a6fbd470ad70e$export$2e2bcd8739ae039 = $a82a6fbd470ad70e$var$inputLabelClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
const $a8d882f2ceb26126$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $a82a6fbd470ad70e$export$c1c4b4545ad2ea5f), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $a8d882f2ceb26126$var$InputLabelRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $2aa603e2ceab697b$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $c67b4c535d9075aa$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $dc4d2229b5e51252$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $a8d882f2ceb26126$var$InputLabel = /*#__PURE__*/ $1Pgvo.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $d2905474c3ea892d$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $20df67a4de76db0b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $a8d882f2ceb26126$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $j6whP.jsx)($a8d882f2ceb26126$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $2rX73.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $a8d882f2ceb26126$export$2e2bcd8739ae039 = $a8d882f2ceb26126$var$InputLabel;



var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");





var $dba13d37d53ec1f8$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $dba13d37d53ec1f8$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($dba13d37d53ec1f8$exports, "__esModule", {
    value: true
});
Object.defineProperty($dba13d37d53ec1f8$exports, "default", {
    enumerable: true,
    get: function() {
        return $dba13d37d53ec1f8$var$_isMuiElement.default;
    }
});

var $dba13d37d53ec1f8$var$_isMuiElement = $dba13d37d53ec1f8$require$_interopRequireDefault((parcelRequire("5X3ju")));


var $472cd7308537b9ed$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dba13d37d53ec1f8$exports)));





var $cxjEl = parcelRequire("cxjEl");
function $5ebba08398e20506$export$149c8b8bab2289d1(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiFormControl', slot);
}
const $5ebba08398e20506$var$formControlClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $5ebba08398e20506$export$2e2bcd8739ae039 = $5ebba08398e20506$var$formControlClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
const $968f69239ccd16a0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $5ebba08398e20506$export$149c8b8bab2289d1), classes);
};
const $968f69239ccd16a0$var$FormControlRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $968f69239ccd16a0$var$FormControl = /*#__PURE__*/ $1Pgvo.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $968f69239ccd16a0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $1Pgvo.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $1Pgvo.Children.forEach(children, (child)=>{
            if (!(0, $472cd7308537b9ed$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $472cd7308537b9ed$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $ed65b54480c0c34c$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $1Pgvo.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $1Pgvo.Children.forEach(children, (child)=>{
            if (!(0, $472cd7308537b9ed$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $ed65b54480c0c34c$export$d652b828d7fdeff8)(child.props, true) || (0, $ed65b54480c0c34c$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $1Pgvo.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $1Pgvo.useRef(false);
    const onFilled = $1Pgvo.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $1Pgvo.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $1Pgvo.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $6640e91aa3c72c88$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $j6whP.jsx)($968f69239ccd16a0$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $2rX73.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $968f69239ccd16a0$export$2e2bcd8739ae039 = $968f69239ccd16a0$var$FormControl;



var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");









var $cxjEl = parcelRequire("cxjEl");
function $2090f82bfc77e314$export$a394fa61b1d583a9(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiFormHelperText', slot);
}
const $2090f82bfc77e314$var$formHelperTextClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $2090f82bfc77e314$export$2e2bcd8739ae039 = $2090f82bfc77e314$var$formHelperTextClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
var $d3cd7e89a7b7c403$var$_span;
const $d3cd7e89a7b7c403$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $2090f82bfc77e314$export$a394fa61b1d583a9), classes);
};
const $d3cd7e89a7b7c403$var$FormHelperTextRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $2090f82bfc77e314$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $2090f82bfc77e314$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $d3cd7e89a7b7c403$var$FormHelperText = /*#__PURE__*/ $1Pgvo.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $d2905474c3ea892d$export$2e2bcd8739ae039)();
    const fcs = (0, $20df67a4de76db0b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $d3cd7e89a7b7c403$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $j6whP.jsx)($d3cd7e89a7b7c403$var$FormHelperTextRoot, {
        as: component,
        className: (0, $2rX73.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $d3cd7e89a7b7c403$var$_span || ($d3cd7e89a7b7c403$var$_span = /*#__PURE__*/ (0, $j6whP.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $d3cd7e89a7b7c403$export$2e2bcd8739ae039 = $d3cd7e89a7b7c403$var$FormHelperText;



var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");

var $cWnbn = parcelRequire("cWnbn");

var $d229a88e462bf412$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $d229a88e462bf412$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($d229a88e462bf412$exports, "__esModule", {
    value: true
});
Object.defineProperty($d229a88e462bf412$exports, "default", {
    enumerable: true,
    get: function() {
        return $d229a88e462bf412$var$_getReactElementRef.default;
    }
});

var $d229a88e462bf412$var$_getReactElementRef = $d229a88e462bf412$require$_interopRequireDefault((parcelRequire("9OT8I")));



var $iKhyI = parcelRequire("iKhyI");

var $1Pgvo = parcelRequire("1Pgvo");



var $2rX73 = parcelRequire("2rX73");




var $2LKgM = parcelRequire("2LKgM");
var $ac809f62ae6fdd5d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($2LKgM)));




var $1Pgvo = parcelRequire("1Pgvo");



var $2rX73 = parcelRequire("2rX73");



var $23LRt = parcelRequire("23LRt");
var $cf2e88f5209236a9$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $cf2e88f5209236a9$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($cf2e88f5209236a9$exports, "__esModule", {
    value: true
});
Object.defineProperty($cf2e88f5209236a9$exports, "default", {
    enumerable: true,
    get: function() {
        return $cf2e88f5209236a9$var$_useSlotProps.default;
    }
});

var $cf2e88f5209236a9$var$_useSlotProps = $cf2e88f5209236a9$require$_interopRequireDefault((parcelRequire("lFsgz")));



var $1Pgvo = parcelRequire("1Pgvo");




var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");




var $1Pgvo = parcelRequire("1Pgvo");
'use client';
/**
 * @ignore - internal component.
 */ const $89a54c6025b10af8$var$ListContext = /*#__PURE__*/ $1Pgvo.createContext({});
var $89a54c6025b10af8$export$2e2bcd8739ae039 = $89a54c6025b10af8$var$ListContext;




var $cxjEl = parcelRequire("cxjEl");
function $bd1aee9e9b0699c0$export$c6bd6795ed6e3203(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiList', slot);
}
const $bd1aee9e9b0699c0$var$listClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $bd1aee9e9b0699c0$export$2e2bcd8739ae039 = $bd1aee9e9b0699c0$var$listClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
const $5485c0fefbda9041$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $bd1aee9e9b0699c0$export$c6bd6795ed6e3203), classes);
};
const $5485c0fefbda9041$var$ListRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $5485c0fefbda9041$var$List = /*#__PURE__*/ $1Pgvo.forwardRef(function List(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $1Pgvo.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $5485c0fefbda9041$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $89a54c6025b10af8$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $j6whP.jsxs)($5485c0fefbda9041$var$ListRoot, {
            as: component,
            className: (0, $2rX73.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $5485c0fefbda9041$export$2e2bcd8739ae039 = $5485c0fefbda9041$var$List;


var $1f4e65231c225fe6$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $1f4e65231c225fe6$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($1f4e65231c225fe6$exports, "__esModule", {
    value: true
});
Object.defineProperty($1f4e65231c225fe6$exports, "default", {
    enumerable: true,
    get: function() {
        return $1f4e65231c225fe6$var$_getScrollbarSize.default;
    }
});

var $1f4e65231c225fe6$var$_getScrollbarSize = $1f4e65231c225fe6$require$_interopRequireDefault((parcelRequire("iFm5Q")));


var $e1ce6ba6bcfeab2d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($1f4e65231c225fe6$exports)));





var $4dca0afae910f8d7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($6dc8856edafa4ded$exports)));



var $j6whP = parcelRequire("j6whP");
'use client';
function $564311dc9ceddf4b$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $564311dc9ceddf4b$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $564311dc9ceddf4b$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $564311dc9ceddf4b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$564311dc9ceddf4b$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $564311dc9ceddf4b$var$MenuList = /*#__PURE__*/ $1Pgvo.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $1Pgvo.useRef(null);
    const textCriteriaRef = $1Pgvo.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $469979860900a653$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $1Pgvo.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $e1ce6ba6bcfeab2d$export$2e2bcd8739ae039)((0, $4dca0afae910f8d7$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $ac809f62ae6fdd5d$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $564311dc9ceddf4b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $564311dc9ceddf4b$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $564311dc9ceddf4b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $564311dc9ceddf4b$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $564311dc9ceddf4b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $564311dc9ceddf4b$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $564311dc9ceddf4b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $564311dc9ceddf4b$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $564311dc9ceddf4b$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $564311dc9ceddf4b$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $564311dc9ceddf4b$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $4c40965b9645751b$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $1Pgvo.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $1Pgvo.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $1Pgvo.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $1Pgvo.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $5485c0fefbda9041$export$2e2bcd8739ae039), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $564311dc9ceddf4b$export$2e2bcd8739ae039 = $564311dc9ceddf4b$var$MenuList;



var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");










var $364e514de9dee404$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dc560c09a746725e$exports)));





var $1Pgvo = parcelRequire("1Pgvo");








var $1Pgvo = parcelRequire("1Pgvo");

var $kZ6Vu = parcelRequire("kZ6Vu");
var $d038ce42e2e55765$export$2e2bcd8739ae039 = {
    disabled: false
};




var $4a0c5f9d286f442b$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $c0c811aad529f1e8$export$bb38bb9a1161268 = 'unmounted';
var $c0c811aad529f1e8$export$84cbff306f539230 = 'exited';
var $c0c811aad529f1e8$export$df38205c966be359 = 'entering';
var $c0c811aad529f1e8$export$78e9e6e3e014d60a = 'entered';
var $c0c811aad529f1e8$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $c0c811aad529f1e8$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $677389a38ff712f3$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $c0c811aad529f1e8$export$84cbff306f539230;
                _this.appearStatus = $c0c811aad529f1e8$export$df38205c966be359;
            } else initialStatus = $c0c811aad529f1e8$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $c0c811aad529f1e8$export$bb38bb9a1161268;
        else initialStatus = $c0c811aad529f1e8$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $c0c811aad529f1e8$export$bb38bb9a1161268) return {
            status: $c0c811aad529f1e8$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $c0c811aad529f1e8$export$df38205c966be359 && status !== $c0c811aad529f1e8$export$78e9e6e3e014d60a) nextStatus = $c0c811aad529f1e8$export$df38205c966be359;
            } else if (status === $c0c811aad529f1e8$export$df38205c966be359 || status === $c0c811aad529f1e8$export$78e9e6e3e014d60a) nextStatus = $c0c811aad529f1e8$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $c0c811aad529f1e8$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($kZ6Vu))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4a0c5f9d286f442b$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $c0c811aad529f1e8$export$84cbff306f539230) this.setState({
            status: $c0c811aad529f1e8$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($kZ6Vu))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $d038ce42e2e55765$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $c0c811aad529f1e8$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $c0c811aad529f1e8$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $c0c811aad529f1e8$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($kZ6Vu))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $d038ce42e2e55765$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $c0c811aad529f1e8$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $c0c811aad529f1e8$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $c0c811aad529f1e8$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($kZ6Vu))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $c0c811aad529f1e8$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $8563c9073014810c$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($1Pgvo))).createElement((0, $4c1a3e5c472a4459$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($1Pgvo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($1Pgvo))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Pgvo))).Component);
$c0c811aad529f1e8$var$Transition.contextType = (0, $4c1a3e5c472a4459$export$2e2bcd8739ae039);
$c0c811aad529f1e8$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $c0c811aad529f1e8$var$noop() {}
$c0c811aad529f1e8$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $c0c811aad529f1e8$var$noop,
    onEntering: $c0c811aad529f1e8$var$noop,
    onEntered: $c0c811aad529f1e8$var$noop,
    onExit: $c0c811aad529f1e8$var$noop,
    onExiting: $c0c811aad529f1e8$var$noop,
    onExited: $c0c811aad529f1e8$var$noop
};
$c0c811aad529f1e8$var$Transition.UNMOUNTED = $c0c811aad529f1e8$export$bb38bb9a1161268;
$c0c811aad529f1e8$var$Transition.EXITED = $c0c811aad529f1e8$export$84cbff306f539230;
$c0c811aad529f1e8$var$Transition.ENTERING = $c0c811aad529f1e8$export$df38205c966be359;
$c0c811aad529f1e8$var$Transition.ENTERED = $c0c811aad529f1e8$export$78e9e6e3e014d60a;
$c0c811aad529f1e8$var$Transition.EXITING = $c0c811aad529f1e8$export$4aacc83d4d59139f;
var $c0c811aad529f1e8$export$2e2bcd8739ae039 = $c0c811aad529f1e8$var$Transition;



const $d195f3842a8817d2$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $d195f3842a8817d2$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}




var $j6whP = parcelRequire("j6whP");
'use client';
function $612829528e6a0d5f$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $612829528e6a0d5f$var$styles = {
    entering: {
        opacity: 1,
        transform: $612829528e6a0d5f$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $612829528e6a0d5f$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $612829528e6a0d5f$var$Grow = /*#__PURE__*/ $1Pgvo.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $c0c811aad529f1e8$export$2e2bcd8739ae039), ...other } = props;
    const timer = (0, (/*@__PURE__*/$parcel$interopDefault($d5c72e85e84e724b$exports)))();
    const autoTimeout = $1Pgvo.useRef();
    const theme = (0, $103054d1cadc4a60$export$2e2bcd8739ae039)();
    const nodeRef = $1Pgvo.useRef(null);
    const handleRef = (0, $4c40965b9645751b$export$2e2bcd8739ae039)(nodeRef, (0, (/*@__PURE__*/$parcel$interopDefault($d229a88e462bf412$exports)))(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $d195f3842a8817d2$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $d195f3842a8817d2$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $612829528e6a0d5f$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $d195f3842a8817d2$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $612829528e6a0d5f$var$isWebKit154 ? duration : duration * 0.666,
                delay: $612829528e6a0d5f$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $612829528e6a0d5f$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $j6whP.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $1Pgvo.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $612829528e6a0d5f$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$612829528e6a0d5f$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($612829528e6a0d5f$var$Grow) $612829528e6a0d5f$var$Grow.muiSupportAuto = true;
var $612829528e6a0d5f$export$2e2bcd8739ae039 = $612829528e6a0d5f$var$Grow;



var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");




var $1Pgvo = parcelRequire("1Pgvo");


var $aMDvQ = parcelRequire("aMDvQ");

var $2LKgM = parcelRequire("2LKgM");




var $j6whP = parcelRequire("j6whP");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $26674c22d44cb754$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $26674c22d44cb754$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $26674c22d44cb754$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $26674c22d44cb754$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $26674c22d44cb754$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $26674c22d44cb754$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($26674c22d44cb754$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $26674c22d44cb754$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$26674c22d44cb754$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $26674c22d44cb754$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $26674c22d44cb754$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $26674c22d44cb754$var$defaultGetTabbable, isEnabled: isEnabled = $26674c22d44cb754$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $1Pgvo.useRef(false);
    const sentinelStart = $1Pgvo.useRef(null);
    const sentinelEnd = $1Pgvo.useRef(null);
    const nodeToRestore = $1Pgvo.useRef(null);
    const reactFocusEventTarget = $1Pgvo.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $1Pgvo.useRef(false);
    const rootRef = $1Pgvo.useRef(null);
    const handleRef = (0, (/*@__PURE__*/$parcel$interopDefault($aMDvQ)))((0, (/*@__PURE__*/$parcel$interopDefault($d229a88e462bf412$exports)))(children), rootRef);
    const lastKeydown = $1Pgvo.useRef(null);
    $1Pgvo.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $1Pgvo.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, (/*@__PURE__*/$parcel$interopDefault($2LKgM)))(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $1Pgvo.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, (/*@__PURE__*/$parcel$interopDefault($2LKgM)))(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $j6whP.jsxs)($1Pgvo.Fragment, {
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $1Pgvo.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $26674c22d44cb754$export$2e2bcd8739ae039 = $26674c22d44cb754$var$FocusTrap;



var $1Pgvo = parcelRequire("1Pgvo");

var $kZ6Vu = parcelRequire("kZ6Vu");


var $hWrnM = parcelRequire("hWrnM");

var $aMDvQ = parcelRequire("aMDvQ");
var $bbe2f0f674cfcd79$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $bbe2f0f674cfcd79$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($bbe2f0f674cfcd79$exports, "__esModule", {
    value: true
});
Object.defineProperty($bbe2f0f674cfcd79$exports, "default", {
    enumerable: true,
    get: function() {
        return $bbe2f0f674cfcd79$var$_setRef.default;
    }
});

var $bbe2f0f674cfcd79$var$_setRef = $bbe2f0f674cfcd79$require$_interopRequireDefault((parcelRequire("eSg3S")));





'use client';
function $0951a49609db4447$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $0951a49609db4447$var$Portal = /*#__PURE__*/ $1Pgvo.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $1Pgvo.useState(null);
    const handleRef = (0, (/*@__PURE__*/$parcel$interopDefault($aMDvQ)))(/*#__PURE__*/ $1Pgvo.isValidElement(children) ? (0, (/*@__PURE__*/$parcel$interopDefault($d229a88e462bf412$exports)))(children) : null, forwardedRef);
    (0, (/*@__PURE__*/$parcel$interopDefault($hWrnM)))(()=>{
        if (!disablePortal) setMountNode($0951a49609db4447$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($hWrnM)))(()=>{
        if (mountNode && !disablePortal) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bbe2f0f674cfcd79$exports)))(forwardedRef, mountNode);
            return ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bbe2f0f674cfcd79$exports)))(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $1Pgvo.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $1Pgvo.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $kZ6Vu.createPortal(children, mountNode) : mountNode;
});
var $0951a49609db4447$export$2e2bcd8739ae039 = $0951a49609db4447$var$Portal;






var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");





var $1Pgvo = parcelRequire("1Pgvo");








var $j6whP = parcelRequire("j6whP");
'use client';
const $5cb2fa446aa3795e$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5cb2fa446aa3795e$var$Fade = /*#__PURE__*/ $1Pgvo.forwardRef(function Fade(props, ref) {
    const theme = (0, $103054d1cadc4a60$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $c0c811aad529f1e8$export$2e2bcd8739ae039), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $1Pgvo.useRef(null);
    const handleRef = (0, $4c40965b9645751b$export$2e2bcd8739ae039)(nodeRef, (0, (/*@__PURE__*/$parcel$interopDefault($d229a88e462bf412$exports)))(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $d195f3842a8817d2$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $d195f3842a8817d2$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $d195f3842a8817d2$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $j6whP.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $1Pgvo.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$5cb2fa446aa3795e$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $5cb2fa446aa3795e$export$2e2bcd8739ae039 = $5cb2fa446aa3795e$var$Fade;




var $cxjEl = parcelRequire("cxjEl");
function $cdd68bb49f62db8e$export$9927a91fd93152bd(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiBackdrop', slot);
}
const $cdd68bb49f62db8e$var$backdropClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiBackdrop', [
    'root',
    'invisible'
]);
var $cdd68bb49f62db8e$export$2e2bcd8739ae039 = $cdd68bb49f62db8e$var$backdropClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
const $86e1a391842b0619$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $cdd68bb49f62db8e$export$9927a91fd93152bd), classes);
};
const $86e1a391842b0619$var$BackdropRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $86e1a391842b0619$var$Backdrop = /*#__PURE__*/ $1Pgvo.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $86e1a391842b0619$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('root', {
        elementType: $86e1a391842b0619$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $2rX73.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $5cb2fa446aa3795e$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $j6whP.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $j6whP.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $86e1a391842b0619$export$2e2bcd8739ae039 = $86e1a391842b0619$var$Backdrop;



var $1Pgvo = parcelRequire("1Pgvo");

var $2LKgM = parcelRequire("2LKgM");

var $aMDvQ = parcelRequire("aMDvQ");

var $e180fe78288b9b7a$exports = {};
"use strict";

var $9rMjh = parcelRequire("9rMjh");
var $e180fe78288b9b7a$require$_interopRequireDefault = $9rMjh.default;
Object.defineProperty($e180fe78288b9b7a$exports, "__esModule", {
    value: true
});
Object.defineProperty($e180fe78288b9b7a$exports, "default", {
    enumerable: true,
    get: function() {
        return $e180fe78288b9b7a$var$_createChainedFunction.default;
    }
});

var $e180fe78288b9b7a$var$_createChainedFunction = $e180fe78288b9b7a$require$_interopRequireDefault((parcelRequire("2MPZL")));



var $aVTDW = parcelRequire("aVTDW");


var $2LKgM = parcelRequire("2LKgM");

// Is a vertical scrollbar displayed?
function $674a865e2113069a$var$isOverflowing(container) {
    const doc = (0, (/*@__PURE__*/$parcel$interopDefault($2LKgM)))(container);
    if (doc.body === container) return (0, (/*@__PURE__*/$parcel$interopDefault($6dc8856edafa4ded$exports)))(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $674a865e2113069a$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $674a865e2113069a$var$getPaddingRight(element) {
    return parseInt((0, (/*@__PURE__*/$parcel$interopDefault($6dc8856edafa4ded$exports)))(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $674a865e2113069a$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $674a865e2113069a$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$674a865e2113069a$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $674a865e2113069a$export$e1bd0c6150f13d96(element, hide);
    });
}
function $674a865e2113069a$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $674a865e2113069a$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($674a865e2113069a$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, (/*@__PURE__*/$parcel$interopDefault($1f4e65231c225fe6$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6dc8856edafa4ded$exports)))(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$674a865e2113069a$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, (/*@__PURE__*/$parcel$interopDefault($2LKgM)))(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$674a865e2113069a$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, (/*@__PURE__*/$parcel$interopDefault($2LKgM)))(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, (/*@__PURE__*/$parcel$interopDefault($6dc8856edafa4ded$exports)))(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $674a865e2113069a$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $674a865e2113069a$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $674a865e2113069a$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $674a865e2113069a$var$getHiddenSiblings(container);
        $674a865e2113069a$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $674a865e2113069a$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $674a865e2113069a$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $674a865e2113069a$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $674a865e2113069a$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $674a865e2113069a$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $674a865e2113069a$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $674a865e2113069a$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $fbc5de4a10dcb85d$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $fbc5de4a10dcb85d$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $fbc5de4a10dcb85d$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $fbc5de4a10dcb85d$var$manager = new (0, $674a865e2113069a$export$ce11c4ecd08cea67)();
function $fbc5de4a10dcb85d$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $1Pgvo.useRef({});
    const mountNodeRef = $1Pgvo.useRef(null);
    const modalRef = $1Pgvo.useRef(null);
    const handleRef = (0, (/*@__PURE__*/$parcel$interopDefault($aMDvQ)))(modalRef, rootRef);
    const [exited, setExited] = $1Pgvo.useState(!open);
    const hasTransition = $fbc5de4a10dcb85d$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($2LKgM)))(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $fbc5de4a10dcb85d$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, (/*@__PURE__*/$parcel$interopDefault($3970405edc15cfc3$exports)))(()=>{
        const resolvedContainer = $fbc5de4a10dcb85d$var$getContainer(container) || getDoc().body;
        $fbc5de4a10dcb85d$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$fbc5de4a10dcb85d$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, (/*@__PURE__*/$parcel$interopDefault($3970405edc15cfc3$exports)))((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $674a865e2113069a$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $1Pgvo.useCallback(()=>{
        $fbc5de4a10dcb85d$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $1Pgvo.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $1Pgvo.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($aVTDW)))(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($e180fe78288b9b7a$exports)))(handleEnter, children?.props.onEnter ?? $fbc5de4a10dcb85d$var$noop),
            onExited: (0, (/*@__PURE__*/$parcel$interopDefault($e180fe78288b9b7a$exports)))(handleExited, children?.props.onExited ?? $fbc5de4a10dcb85d$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $fbc5de4a10dcb85d$export$2e2bcd8739ae039 = $fbc5de4a10dcb85d$var$useModal;




var $cxjEl = parcelRequire("cxjEl");
function $d80f206f4961237a$export$67960e22b12a638d(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiModal', slot);
}
const $d80f206f4961237a$var$modalClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $d80f206f4961237a$export$2e2bcd8739ae039 = $d80f206f4961237a$var$modalClasses;




var $j6whP = parcelRequire("j6whP");
'use client';
const $4fffe85562487335$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $d80f206f4961237a$export$67960e22b12a638d), classes);
};
const $4fffe85562487335$var$ModalRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $4fffe85562487335$var$ModalBackdrop = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $86e1a391842b0619$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $4fffe85562487335$var$Modal = /*#__PURE__*/ $1Pgvo.forwardRef(function Modal(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $4fffe85562487335$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $fbc5de4a10dcb85d$export$2e2bcd8739ae039)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $4fffe85562487335$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $4fffe85562487335$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $2rX73.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $2rX73.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $0951a49609db4447$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $j6whP.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $j6whP.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $26674c22d44cb754$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $1Pgvo.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $4fffe85562487335$export$2e2bcd8739ae039 = $4fffe85562487335$var$Modal;



var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");










var $cxjEl = parcelRequire("cxjEl");
function $b915a081e503e472$export$29cdb466b9b6f20b(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiPaper', slot);
}
const $b915a081e503e472$var$paperClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $b915a081e503e472$export$2e2bcd8739ae039 = $b915a081e503e472$var$paperClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
const $3bedb33fd7c42213$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $b915a081e503e472$export$29cdb466b9b6f20b), classes);
};
const $3bedb33fd7c42213$var$PaperRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $3bedb33fd7c42213$var$Paper = /*#__PURE__*/ $1Pgvo.forwardRef(function Paper(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $103054d1cadc4a60$export$2e2bcd8739ae039)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $3bedb33fd7c42213$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $j6whP.jsx)($3bedb33fd7c42213$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $2rX73.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $8a2c9660dd4393d2$exports.alpha)('#fff', (0, $c043fba43cee01ca$export$2e2bcd8739ae039)(elevation))}, ${(0, $8a2c9660dd4393d2$exports.alpha)('#fff', (0, $c043fba43cee01ca$export$2e2bcd8739ae039)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $3bedb33fd7c42213$export$2e2bcd8739ae039 = $3bedb33fd7c42213$var$Paper;




var $cxjEl = parcelRequire("cxjEl");
function $ef581edf0ec6e93d$export$88f455dd56c95edb(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiPopover', slot);
}
const $ef581edf0ec6e93d$var$popoverClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiPopover', [
    'root',
    'paper'
]);
var $ef581edf0ec6e93d$export$2e2bcd8739ae039 = $ef581edf0ec6e93d$var$popoverClasses;




var $2rX73 = parcelRequire("2rX73");
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $025bb787ac94ce2c$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $025bb787ac94ce2c$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($025bb787ac94ce2c$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $2rX73.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $2rX73.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}



var $j6whP = parcelRequire("j6whP");
'use client';
function $1e6a8b3796c8d2d9$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $1e6a8b3796c8d2d9$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $1e6a8b3796c8d2d9$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $1e6a8b3796c8d2d9$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $1e6a8b3796c8d2d9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $ef581edf0ec6e93d$export$88f455dd56c95edb), classes);
};
const $1e6a8b3796c8d2d9$export$bcce13685275fc99 = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $4fffe85562487335$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const $1e6a8b3796c8d2d9$export$821346c38a2d9390 = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $3bedb33fd7c42213$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $1e6a8b3796c8d2d9$var$Popover = /*#__PURE__*/ $1Pgvo.forwardRef(function Popover(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $1Pgvo.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $1e6a8b3796c8d2d9$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $1Pgvo.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $1e6a8b3796c8d2d9$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $ac809f62ae6fdd5d$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $1e6a8b3796c8d2d9$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $1e6a8b3796c8d2d9$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $1Pgvo.useCallback((elemRect)=>{
        return {
            vertical: $1e6a8b3796c8d2d9$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $1e6a8b3796c8d2d9$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $1Pgvo.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $1e6a8b3796c8d2d9$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $4dca0afae910f8d7$export$2e2bcd8739ae039)($1e6a8b3796c8d2d9$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $1e6a8b3796c8d2d9$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $1Pgvo.useState(open);
    const setPositioningStyles = $1Pgvo.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $1Pgvo.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $1Pgvo.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $1Pgvo.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $1Pgvo.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $364e514de9dee404$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $4dca0afae910f8d7$export$2e2bcd8739ae039)($1e6a8b3796c8d2d9$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $612829528e6a0d5f$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $ac809f62ae6fdd5d$export$2e2bcd8739ae039)($1e6a8b3796c8d2d9$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $1e6a8b3796c8d2d9$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $025bb787ac94ce2c$export$2e2bcd8739ae039)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $2rX73.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $1e6a8b3796c8d2d9$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $j6whP.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $0c54251f72a22d9a$export$2e2bcd8739ae039)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $j6whP.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $j6whP.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $1e6a8b3796c8d2d9$export$2e2bcd8739ae039 = $1e6a8b3796c8d2d9$var$Popover;







var $cxjEl = parcelRequire("cxjEl");
function $1aa30fe2f96f0d09$export$2cf86a63a84fe23d(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiMenu', slot);
}
const $1aa30fe2f96f0d09$var$menuClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $1aa30fe2f96f0d09$export$2e2bcd8739ae039 = $1aa30fe2f96f0d09$var$menuClasses;




var $j6whP = parcelRequire("j6whP");
'use client';
const $da0c9611f8250fc2$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $da0c9611f8250fc2$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $da0c9611f8250fc2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $1aa30fe2f96f0d09$export$2cf86a63a84fe23d), classes);
};
const $da0c9611f8250fc2$var$MenuRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $1e6a8b3796c8d2d9$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $c67b4c535d9075aa$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const $da0c9611f8250fc2$export$4f7c51a5920c9f33 = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $1e6a8b3796c8d2d9$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $da0c9611f8250fc2$var$MenuMenuList = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $564311dc9ceddf4b$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $da0c9611f8250fc2$var$Menu = /*#__PURE__*/ $1Pgvo.forwardRef(function Menu(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $23LRt.useRtl)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $da0c9611f8250fc2$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $1Pgvo.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $1Pgvo.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $1Pgvo.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, (/*@__PURE__*/$parcel$interopDefault($cf2e88f5209236a9$exports)))({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('paper', {
        className: classes.paper,
        elementType: $da0c9611f8250fc2$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('list', {
        className: (0, $2rX73.default)(classes.list, MenuListProps.className),
        elementType: $da0c9611f8250fc2$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $j6whP.jsx)($da0c9611f8250fc2$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $da0c9611f8250fc2$var$RTL_ORIGIN : $da0c9611f8250fc2$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $j6whP.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $da0c9611f8250fc2$export$2e2bcd8739ae039 = $da0c9611f8250fc2$var$Menu;



var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");





var $cxjEl = parcelRequire("cxjEl");
function $60894770f6b57c0d$export$1ee13051fd9e2ab5(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiNativeSelect', slot);
}
const $60894770f6b57c0d$var$nativeSelectClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $60894770f6b57c0d$export$2e2bcd8739ae039 = $60894770f6b57c0d$var$nativeSelectClasses;





var $j6whP = parcelRequire("j6whP");
'use client';
const $87457e3017baea66$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $60894770f6b57c0d$export$1ee13051fd9e2ab5), classes);
};
const $87457e3017baea66$export$50b3545a8ccd87af = (0, $843c443210106c30$export$2e2bcd8739ae039)('select')(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $60894770f6b57c0d$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $87457e3017baea66$var$NativeSelectSelect = (0, $843c443210106c30$export$2e2bcd8739ae039)($87457e3017baea66$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $c67b4c535d9075aa$export$2e2bcd8739ae039),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $60894770f6b57c0d$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $87457e3017baea66$export$7dd4d92f143902e3 = (0, $843c443210106c30$export$2e2bcd8739ae039)('svg')(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $60894770f6b57c0d$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $87457e3017baea66$var$NativeSelectIcon = (0, $843c443210106c30$export$2e2bcd8739ae039)($87457e3017baea66$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $87457e3017baea66$var$NativeSelectInput = /*#__PURE__*/ $1Pgvo.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $87457e3017baea66$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $j6whP.jsxs)($1Pgvo.Fragment, {
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)($87457e3017baea66$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $2rX73.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $j6whP.jsx)($87457e3017baea66$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $87457e3017baea66$export$2e2bcd8739ae039 = $87457e3017baea66$var$NativeSelectInput;






var $9f83533d1ea2c651$exports = {};
"use strict";

var $pArzt = parcelRequire("pArzt");
var $9f83533d1ea2c651$require$_interopRequireWildcard = $pArzt.default;
Object.defineProperty($9f83533d1ea2c651$exports, "__esModule", {
    value: true
});
var $9f83533d1ea2c651$var$_exportNames = {};
Object.defineProperty($9f83533d1ea2c651$exports, "default", {
    enumerable: true,
    get: function() {
        return $9f83533d1ea2c651$var$_useControlled.default;
    }
});

var $9f83533d1ea2c651$var$_useControlled = $9f83533d1ea2c651$require$_interopRequireWildcard((parcelRequire("GrFNn")));
Object.keys($9f83533d1ea2c651$var$_useControlled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9f83533d1ea2c651$var$_exportNames, key)) return;
    if (key in $9f83533d1ea2c651$exports && $9f83533d1ea2c651$exports[key] === $9f83533d1ea2c651$var$_useControlled[key]) return;
    Object.defineProperty($9f83533d1ea2c651$exports, key, {
        enumerable: true,
        get: function() {
            return $9f83533d1ea2c651$var$_useControlled[key];
        }
    });
});


'use client';
var $87cfffc3a84da9cc$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($9f83533d1ea2c651$exports)));




var $cxjEl = parcelRequire("cxjEl");
function $7dd80201381b8702$export$2c0c1ee5a3392e(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiSelect', slot);
}
const $7dd80201381b8702$var$selectClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $7dd80201381b8702$export$2e2bcd8739ae039 = $7dd80201381b8702$var$selectClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
var $514e3b67e4e0b2ea$var$_span;
const $514e3b67e4e0b2ea$var$SelectSelect = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $87457e3017baea66$export$50b3545a8ccd87af), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $7dd80201381b8702$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $7dd80201381b8702$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $7dd80201381b8702$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $7dd80201381b8702$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $7dd80201381b8702$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $514e3b67e4e0b2ea$var$SelectIcon = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $87457e3017baea66$export$7dd4d92f143902e3), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $514e3b67e4e0b2ea$var$SelectNativeInput = (0, $843c443210106c30$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (prop)=>(0, $776dc3289a896a7d$export$2e2bcd8739ae039)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $514e3b67e4e0b2ea$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $514e3b67e4e0b2ea$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $514e3b67e4e0b2ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $7dd80201381b8702$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $514e3b67e4e0b2ea$var$SelectInput = /*#__PURE__*/ $1Pgvo.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $87cfffc3a84da9cc$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $87cfffc3a84da9cc$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $1Pgvo.useRef(null);
    const displayRef = $1Pgvo.useRef(null);
    const [displayNode, setDisplayNode] = $1Pgvo.useState(null);
    const { current: isOpenControlled } = $1Pgvo.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $1Pgvo.useState();
    const handleRef = (0, $4c40965b9645751b$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $1Pgvo.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $1Pgvo.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $1Pgvo.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $1Pgvo.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $1Pgvo.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $ac809f62ae6fdd5d$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $1Pgvo.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $ed65b54480c0c34c$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $1Pgvo.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($iKhyI)))(2));
            selected = value.some((v)=>$514e3b67e4e0b2ea$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $514e3b67e4e0b2ea$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $1Pgvo.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $514e3b67e4e0b2ea$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, (/*@__PURE__*/$parcel$interopDefault($77cd97fe312eba76$exports)))();
    return /*#__PURE__*/ (0, $j6whP.jsxs)($1Pgvo.Fragment, {
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)($514e3b67e4e0b2ea$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $2rX73.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $514e3b67e4e0b2ea$var$isEmpty(display) ? $514e3b67e4e0b2ea$var$_span || ($514e3b67e4e0b2ea$var$_span = /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)($514e3b67e4e0b2ea$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)($514e3b67e4e0b2ea$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)((0, $da0c9611f8250fc2$export$2e2bcd8739ae039), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...MenuProps.MenuListProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $514e3b67e4e0b2ea$export$2e2bcd8739ae039 = $514e3b67e4e0b2ea$var$SelectInput;




parcelRequire("1Pgvo");

var $1Pgvo = parcelRequire("1Pgvo");

var $1Pgvo = parcelRequire("1Pgvo");


var $2rX73 = parcelRequire("2rX73");







var $cxjEl = parcelRequire("cxjEl");
function $cd1c6309f58f0b6f$export$c7c50641356bdfa5(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiSvgIcon', slot);
}
const $cd1c6309f58f0b6f$var$svgIconClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $cd1c6309f58f0b6f$export$2e2bcd8739ae039 = $cd1c6309f58f0b6f$var$svgIconClasses;



var $j6whP = parcelRequire("j6whP");
'use client';
const $30985ea12203936f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $cd1c6309f58f0b6f$export$c7c50641356bdfa5), classes);
};
const $30985ea12203936f$var$SvgIconRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $f20308847ed204aa$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})((0, $69ec0b9cd117e3a9$export$2e2bcd8739ae039)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $30985ea12203936f$var$SvgIcon = /*#__PURE__*/ $1Pgvo.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $1Pgvo.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $30985ea12203936f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $j6whP.jsxs)($30985ea12203936f$var$SvgIconRoot, {
        as: component,
        className: (0, $2rX73.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $j6whP.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$30985ea12203936f$var$SvgIcon.muiName = 'SvgIcon';
var $30985ea12203936f$export$2e2bcd8739ae039 = $30985ea12203936f$var$SvgIcon;



var $j6whP = parcelRequire("j6whP");
'use client';
function $e57cc017c5b7c886$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $j6whP.jsx)((0, $30985ea12203936f$export$2e2bcd8739ae039), {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $30985ea12203936f$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $1Pgvo.memo(/*#__PURE__*/ $1Pgvo.forwardRef(Component));
}



var $j6whP = parcelRequire("j6whP");
'use client';
var $b20c034dd37a24e3$export$2e2bcd8739ae039 = (0, $e57cc017c5b7c886$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $j6whP.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');












var $j6whP = parcelRequire("j6whP");
'use client';
const $21725e80eadce9c7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $7dd80201381b8702$export$2c0c1ee5a3392e), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $21725e80eadce9c7$var$styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $c67b4c535d9075aa$export$2e2bcd8739ae039)(prop) && prop !== 'variant'
};
const $21725e80eadce9c7$var$StyledInput = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $3dcdf4e0d79a87f2$export$2e2bcd8739ae039), $21725e80eadce9c7$var$styledRootConfig)('');
const $21725e80eadce9c7$var$StyledOutlinedInput = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $6730b7889d9edb8e$export$2e2bcd8739ae039), $21725e80eadce9c7$var$styledRootConfig)('');
const $21725e80eadce9c7$var$StyledFilledInput = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $239de2fd46b8c07f$export$2e2bcd8739ae039), $21725e80eadce9c7$var$styledRootConfig)('');
const $21725e80eadce9c7$var$Select = /*#__PURE__*/ $1Pgvo.forwardRef(function Select(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $b20c034dd37a24e3$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $87457e3017baea66$export$2e2bcd8739ae039) : (0, $514e3b67e4e0b2ea$export$2e2bcd8739ae039);
    const muiFormControl = (0, $d2905474c3ea892d$export$2e2bcd8739ae039)();
    const fcs = (0, $20df67a4de76db0b$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $21725e80eadce9c7$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $j6whP.jsx)($21725e80eadce9c7$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $j6whP.jsx)($21725e80eadce9c7$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $j6whP.jsx)($21725e80eadce9c7$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $4c40965b9645751b$export$2e2bcd8739ae039)(ref, (0, (/*@__PURE__*/$parcel$interopDefault($d229a88e462bf412$exports)))(InputComponent));
    return /*#__PURE__*/ (0, $j6whP.jsx)($1Pgvo.Fragment, {
        children: /*#__PURE__*/ $1Pgvo.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, (/*@__PURE__*/$parcel$interopDefault($cWnbn)))(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $2rX73.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$21725e80eadce9c7$var$Select.muiName = 'Select';
var $21725e80eadce9c7$export$2e2bcd8739ae039 = $21725e80eadce9c7$var$Select;




var $cxjEl = parcelRequire("cxjEl");
function $fa78d966b40d4f12$export$c1bdcbaf0596aeda(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cxjEl)))('MuiTextField', slot);
}
const $fa78d966b40d4f12$var$textFieldClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3a7c4934f6f39f3a$exports)))('MuiTextField', [
    'root'
]);
var $fa78d966b40d4f12$export$2e2bcd8739ae039 = $fa78d966b40d4f12$var$textFieldClasses;




var $j6whP = parcelRequire("j6whP");
'use client';
const $11094ad181443e85$var$variantComponent = {
    standard: (0, $3dcdf4e0d79a87f2$export$2e2bcd8739ae039),
    filled: (0, $239de2fd46b8c07f$export$2e2bcd8739ae039),
    outlined: (0, $6730b7889d9edb8e$export$2e2bcd8739ae039)
};
const $11094ad181443e85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d016a5f2c179b96$exports)))(slots, (0, $fa78d966b40d4f12$export$c1bdcbaf0596aeda), classes);
};
const $11094ad181443e85$var$TextFieldRoot = (0, $843c443210106c30$export$2e2bcd8739ae039)((0, $968f69239ccd16a0$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $11094ad181443e85$var$TextField = /*#__PURE__*/ $1Pgvo.forwardRef(function TextField(inProps, ref) {
    const props = (0, $5c0a70bfa8e38664$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $11094ad181443e85$var$useUtilityClasses(ownerState);
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($77cd97fe312eba76$exports)))(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $11094ad181443e85$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('root', {
        elementType: $11094ad181443e85$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $2rX73.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('inputLabel', {
        elementType: (0, $a8d882f2ceb26126$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('formHelperText', {
        elementType: (0, $d3cd7e89a7b7c403$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $f75f95dbace8cca3$export$2e2bcd8739ae039)('select', {
        elementType: (0, $21725e80eadce9c7$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $j6whP.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $j6whP.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $j6whP.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $j6whP.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $j6whP.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $11094ad181443e85$export$2e2bcd8739ae039 = $11094ad181443e85$var$TextField;



const $febdd877049e1a64$var$Invite = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const { invite_id: invite_id } = (0, $3a01a64de9a26688$export$99eaa27ddbbb95ef)();
    const [isConfirmed, setIsConfirmed] = (0, $1Pgvo.useState)(false);
    const [isLoading, setIsLoading] = (0, $1Pgvo.useState)(false);
    const [phoneNumber, setPhoneNumber] = (0, $1Pgvo.useState)("");
    const [error, setError] = (0, $1Pgvo.useState)("");
    const validatePhoneNumber = (number)=>{
        return /^[0-9]{10}$/.test(number);
    };
    const handleConfirm = async ()=>{
        if (!validatePhoneNumber(phoneNumber)) {
            setError("Please enter a valid 10-digit phone number");
            return;
        }
        setError("");
        setIsLoading(true);
        try {
            const currentDate = new Date().toISOString();
            await (0, $ae1c9ad610ade460$export$2e2bcd8739ae039).post("https://tradeinsights.co.in/v1/api/invites/updateacceptedmerge", {
                invite_id: invite_id,
                accepted: {
                    [phoneNumber]: currentDate
                }
            }, {
                headers: {
                    Authorization: "ffjngfbfbvfkw4865427959249"
                }
            });
            setIsConfirmed(true);
        } catch (error) {
            console.error("Error accepting invite:", error);
            setError("Failed to accept invitation. Please try again.");
        }
        setIsLoading(false);
    };
    (0, $1Pgvo.useEffect)(()=>{
        if (isConfirmed) {
            const userAgent = navigator.userAgent || navigator.vendor;
            if (/android/i.test(userAgent)) window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
            else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
            else window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        }
    }, [
        isConfirmed
    ]);
    if (!invite_id) return /*#__PURE__*/ (0, $j6whP.jsx)("div", {
        className: "error",
        children: "Invalid invite link"
    });
    return /*#__PURE__*/ (0, $j6whP.jsx)("div", {
        className: "min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center p-4",
        children: /*#__PURE__*/ (0, $j6whP.jsx)("div", {
            className: "w-full max-w-md",
            children: /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                className: "bg-white/10 backdrop-blur-lg rounded-2xl shadow-2xl overflow-hidden border border-white/20",
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            marginTop: '26px',
                            marginBottom: '48px',
                            padding: '0 32px',
                            textAlign: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                                style: {
                                    marginBottom: '24px'
                                },
                                children: /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ccee0ee317a1ad4c$exports))),
                                    alt: "Returns",
                                    style: {
                                        height: '32px',
                                        margin: '0 auto',
                                        marginBottom: '12px'
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
                                style: {
                                    fontSize: '30px',
                                    fontWeight: 'bold',
                                    color: 'white',
                                    marginBottom: '12px',
                                    opacity: '0.8'
                                },
                                children: "Exclusive Invite Access!"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                                style: {
                                    color: '#D1D5DB'
                                },
                                children: "You're one step away from joining our community."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                        className: "p-8 pt-0 bg-white/5",
                        children: /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                            className: "flex flex-col items-center w-full",
                            children: [
                                /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                                    className: "flex justify-center w-full mb-6",
                                    children: /*#__PURE__*/ (0, $j6whP.jsx)((0, $11094ad181443e85$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        label: "Phone Number",
                                        value: phoneNumber,
                                        onChange: (e)=>setPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10)),
                                        placeholder: "Enter your 10-digit phone number",
                                        InputProps: {
                                            startAdornment: /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                                className: "text-gray-400 mr-2",
                                                children: "+91"
                                            }),
                                            className: "bg-white/10 text-white"
                                        },
                                        InputLabelProps: {
                                            className: "text-gray-300"
                                        },
                                        error: !!error,
                                        helperText: error,
                                        sx: {
                                            width: '300px',
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: 'rgba(255, 255, 255, 0.2)'
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: 'rgba(255, 255, 255, 0.3)'
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: 'rgba(255, 255, 255, 0.5)'
                                                }
                                            },
                                            '& .MuiInputBase-input': {
                                                color: 'white',
                                                '&::placeholder': {
                                                    color: 'rgba(255, 255, 255, 0.5)',
                                                    opacity: 1
                                                }
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: 'rgba(255, 255, 255, 0.7)',
                                                '&.Mui-focused': {
                                                    color: 'rgba(255, 255, 255, 0.7)'
                                                }
                                            }
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                                    className: "flex justify-center w-full",
                                    children: /*#__PURE__*/ (0, $j6whP.jsx)((0, $58c32298ee832f7f$export$2e2bcd8739ae039), {
                                        variant: "contained",
                                        onClick: handleConfirm,
                                        disabled: isLoading || phoneNumber.length !== 10,
                                        sx: {
                                            width: '300px',
                                            py: 1.5,
                                            background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.15) 30%, rgba(255, 255, 255, 0.25) 90%)',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            '&:hover': {
                                                background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.2) 30%, rgba(255, 255, 255, 0.3) 90%)',
                                                color: 'white'
                                            },
                                            '&.Mui-disabled': {
                                                background: 'rgba(255, 255, 255, 0.12)',
                                                color: 'rgba(255, 255, 255, 0.3)'
                                            }
                                        },
                                        children: isLoading ? /*#__PURE__*/ (0, $j6whP.jsx)((0, $cdfdb16a910e3746$export$2e2bcd8739ae039), {
                                            size: 24,
                                            sx: {
                                                color: 'black'
                                            }
                                        }) : 'Join Returns'
                                    })
                                }),
                                /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                                    className: "flex justify-center w-full mt-6",
                                    children: /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                                        className: "w-[80%] max-w-[400px]",
                                        children: /*#__PURE__*/ (0, $j6whP.jsxs)("p", {
                                            className: "text-center text-gray-400",
                                            style: {
                                                fontSize: '10px'
                                            },
                                            children: [
                                                "By joining, you agree to our",
                                                ' ',
                                                /*#__PURE__*/ (0, $j6whP.jsx)("a", {
                                                    href: "https://docs.google.com/document/u/0/d/107oGESPJbd231S9_EKlYOFqG6jjUkrGcJDBCD8wKW_4/mobilebasic?pli=1",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "text-gray-300 hover:text-white",
                                                    style: {
                                                        fontSize: '10px'
                                                    },
                                                    children: "Terms of Service"
                                                }),
                                                ' ',
                                                "and",
                                                ' ',
                                                /*#__PURE__*/ (0, $j6whP.jsx)("a", {
                                                    href: "https://docs.google.com/document/u/5/d/10_9GANOQ1rBtdjlIKuaRwco_TikyA9WAdAna0hodylg/mobilebasic",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "text-gray-300 hover:text-white",
                                                    style: {
                                                        fontSize: '10px'
                                                    },
                                                    children: "Privacy Policy"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $febdd877049e1a64$export$2e2bcd8739ae039 = $febdd877049e1a64$var$Invite;






var $1Pgvo = parcelRequire("1Pgvo");


var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

const $ef78f34faf6dbdec$var$Stock = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const { status: status } = (0, $3a01a64de9a26688$export$99eaa27ddbbb95ef)();
    const [showFallback, setShowFallback] = (0, $1Pgvo.useState)(false);
    const [platform, setPlatform] = (0, $1Pgvo.useState)('web');
    (0, $1Pgvo.useEffect)(()=>{
        const userAgent = navigator.userAgent || navigator.vendor;
        // Detect platform
        if (/android/i.test(userAgent)) {
            setPlatform('android');
            // Show fallback options for Android after a short delay
            const timer = setTimeout(()=>{
                setShowFallback(true);
            }, 1000);
            return ()=>clearTimeout(timer);
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            setPlatform('ios');
            // Redirect iOS to App Store
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            setPlatform('web');
            // Redirect web to website
            window.location.href = "https://returns.trade";
        }
    }, []);
    const openApp = ()=>{
        // Try to open the app with the status from URL
        const statusParam = status || 'live'; // Default to 'live' if no status provided
        window.location.href = `returns://stocks/${statusParam}`;
    };
    const downloadApp = ()=>{
        // Redirect to Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
    };
    // Don't render anything for iOS or web as they redirect immediately
    if (platform === 'ios' || platform === 'web') return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            textAlign: 'center',
            padding: '50px 20px',
            fontFamily: 'Arial, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
                children: "Opening Returns App..."
            }),
            showFallback && /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    marginTop: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        children: "If the app didn't open automatically, you can:"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            marginTop: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: openApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Open App"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: downloadApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Download App"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ef78f34faf6dbdec$export$2e2bcd8739ae039 = $ef78f34faf6dbdec$var$Stock;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

const $0b95f4edb2f272a6$var$Main = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const [showFallback, setShowFallback] = (0, $1Pgvo.useState)(false);
    const [platform, setPlatform] = (0, $1Pgvo.useState)('web');
    (0, $1Pgvo.useEffect)(()=>{
        const userAgent = navigator.userAgent || navigator.vendor;
        // Detect platform
        if (/android/i.test(userAgent)) {
            setPlatform('android');
            // Show fallback options for Android after a short delay
            const timer = setTimeout(()=>{
                setShowFallback(true);
            }, 1000);
            return ()=>clearTimeout(timer);
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            setPlatform('ios');
            // Redirect iOS to App Store
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            setPlatform('web');
            // Redirect web to website
            window.location.href = "https://returns.trade";
        }
    }, []);
    const openApp = ()=>{
        window.location.href = `returns://home`;
    };
    const downloadApp = ()=>{
        // Redirect to Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
    };
    // Don't render anything for iOS or web as they redirect immediately
    if (platform === 'ios' || platform === 'web') return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            textAlign: 'center',
            padding: '50px 20px',
            fontFamily: 'Arial, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
                children: "Opening Returns App..."
            }),
            showFallback && /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    marginTop: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        children: "If the app didn't open automatically, you can:"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            marginTop: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: openApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Open App"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: downloadApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Download App"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $0b95f4edb2f272a6$export$2e2bcd8739ae039 = $0b95f4edb2f272a6$var$Main;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

const $fe41dd5ae32ed3df$var$Subscribe = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const [showFallback, setShowFallback] = (0, $1Pgvo.useState)(false);
    const [platform, setPlatform] = (0, $1Pgvo.useState)('web');
    (0, $1Pgvo.useEffect)(()=>{
        const userAgent = navigator.userAgent || navigator.vendor;
        // Detect platform
        if (/android/i.test(userAgent)) {
            setPlatform('android');
            // Show fallback options for Android after a short delay
            const timer = setTimeout(()=>{
                setShowFallback(true);
            }, 1000);
            return ()=>clearTimeout(timer);
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            setPlatform('ios');
            // Redirect iOS to App Store
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            setPlatform('web');
            // Redirect web to website
            window.location.href = "https://returns.trade";
        }
    }, []);
    const openApp = ()=>{
        window.location.href = `returns://subscribe`;
    };
    const downloadApp = ()=>{
        // Redirect to Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
    };
    // Don't render anything for iOS or web as they redirect immediately
    if (platform === 'ios' || platform === 'web') return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            textAlign: 'center',
            padding: '50px 20px',
            fontFamily: 'Arial, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
                children: "Opening Returns App..."
            }),
            showFallback && /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    marginTop: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        children: "If the app didn't open automatically, you can:"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            marginTop: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: openApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Open App"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: downloadApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Download App"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fe41dd5ae32ed3df$export$2e2bcd8739ae039 = $fe41dd5ae32ed3df$var$Subscribe;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

const $4a83fc2474eb4c2d$var$Analyze = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const [showFallback, setShowFallback] = (0, $1Pgvo.useState)(false);
    const [platform, setPlatform] = (0, $1Pgvo.useState)('web');
    (0, $1Pgvo.useEffect)(()=>{
        const userAgent = navigator.userAgent || navigator.vendor;
        // Detect platform
        if (/android/i.test(userAgent)) {
            setPlatform('android');
            // Show fallback options for Android after a short delay
            const timer = setTimeout(()=>{
                setShowFallback(true);
            }, 1000);
            return ()=>clearTimeout(timer);
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            setPlatform('ios');
            // Redirect iOS to App Store
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            setPlatform('web');
            // Redirect web to website
            window.location.href = "https://returns.trade";
        }
    }, []);
    const openApp = ()=>{
        window.location.href = `returns://analyze`;
    };
    const downloadApp = ()=>{
        // Redirect to Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
    };
    // Don't render anything for iOS or web as they redirect immediately
    if (platform === 'ios' || platform === 'web') return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            textAlign: 'center',
            padding: '50px 20px',
            fontFamily: 'Arial, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
                children: "Opening Returns App..."
            }),
            showFallback && /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    marginTop: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        children: "If the app didn't open automatically, you can:"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            marginTop: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: openApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Open App"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: downloadApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Download App"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4a83fc2474eb4c2d$export$2e2bcd8739ae039 = $4a83fc2474eb4c2d$var$Analyze;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

const $4af39e7840e6f6ca$var$Portfolio = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const [showFallback, setShowFallback] = (0, $1Pgvo.useState)(false);
    const [platform, setPlatform] = (0, $1Pgvo.useState)('web');
    (0, $1Pgvo.useEffect)(()=>{
        const userAgent = navigator.userAgent || navigator.vendor;
        // Detect platform
        if (/android/i.test(userAgent)) {
            setPlatform('android');
            // Show fallback options for Android after a short delay
            const timer = setTimeout(()=>{
                setShowFallback(true);
            }, 1000);
            return ()=>clearTimeout(timer);
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            setPlatform('ios');
            // Redirect iOS to App Store
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            setPlatform('web');
            // Redirect web to website
            window.location.href = "https://returns.trade";
        }
    }, []);
    const openApp = ()=>{
        window.location.href = `returns://portfolio`;
    };
    const downloadApp = ()=>{
        // Redirect to Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
    };
    // Don't render anything for iOS or web as they redirect immediately
    if (platform === 'ios' || platform === 'web') return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            textAlign: 'center',
            padding: '50px 20px',
            fontFamily: 'Arial, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
                children: "Opening Returns App..."
            }),
            showFallback && /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    marginTop: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        children: "If the app didn't open automatically, you can:"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            marginTop: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: openApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Open App"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: downloadApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Download App"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4af39e7840e6f6ca$export$2e2bcd8739ae039 = $4af39e7840e6f6ca$var$Portfolio;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

const $9d953152f0bb5235$var$AutomatedPortfolio = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const [showFallback, setShowFallback] = (0, $1Pgvo.useState)(false);
    const [platform, setPlatform] = (0, $1Pgvo.useState)('web');
    (0, $1Pgvo.useEffect)(()=>{
        const userAgent = navigator.userAgent || navigator.vendor;
        // Detect platform
        if (/android/i.test(userAgent)) {
            setPlatform('android');
            // Show fallback options for Android after a short delay
            const timer = setTimeout(()=>{
                setShowFallback(true);
            }, 1000);
            return ()=>clearTimeout(timer);
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            setPlatform('ios');
            // Redirect iOS to App Store
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            setPlatform('web');
            // Redirect web to website
            window.location.href = "https://returns.trade";
        }
    }, []);
    const openApp = ()=>{
        window.location.href = `returns://automated-portfolio`;
    };
    const downloadApp = ()=>{
        // Redirect to Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
    };
    // Don't render anything for iOS or web as they redirect immediately
    if (platform === 'ios' || platform === 'web') return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            textAlign: 'center',
            padding: '50px 20px',
            fontFamily: 'Arial, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
                children: "Opening Returns App..."
            }),
            showFallback && /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    marginTop: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        children: "If the app didn't open automatically, you can:"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            marginTop: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: openApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Open App"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: downloadApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Download App"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9d953152f0bb5235$export$2e2bcd8739ae039 = $9d953152f0bb5235$var$AutomatedPortfolio;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

const $a3d8275856d532bc$var$Kyc = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const [showFallback, setShowFallback] = (0, $1Pgvo.useState)(false);
    const [platform, setPlatform] = (0, $1Pgvo.useState)('web');
    (0, $1Pgvo.useEffect)(()=>{
        const userAgent = navigator.userAgent || navigator.vendor;
        // Detect platform
        if (/android/i.test(userAgent)) {
            setPlatform('android');
            // Show fallback options for Android after a short delay
            const timer = setTimeout(()=>{
                setShowFallback(true);
            }, 1000);
            return ()=>clearTimeout(timer);
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            setPlatform('ios');
            // Redirect iOS to App Store
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            setPlatform('web');
            // Redirect web to website
            window.location.href = "https://returns.trade";
        }
    }, []);
    const openApp = ()=>{
        window.location.href = `returns://kyc`;
    };
    const downloadApp = ()=>{
        // Redirect to Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
    };
    // Don't render anything for iOS or web as they redirect immediately
    if (platform === 'ios' || platform === 'web') return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            textAlign: 'center',
            padding: '50px 20px',
            fontFamily: 'Arial, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
                children: "Opening Returns App..."
            }),
            showFallback && /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    marginTop: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        children: "If the app didn't open automatically, you can:"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            marginTop: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: openApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Open App"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: downloadApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Download App"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a3d8275856d532bc$export$2e2bcd8739ae039 = $a3d8275856d532bc$var$Kyc;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

const $c0d2ff97da0661bf$var$Options = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const { status: status } = (0, $3a01a64de9a26688$export$99eaa27ddbbb95ef)();
    const [showFallback, setShowFallback] = (0, $1Pgvo.useState)(false);
    const [platform, setPlatform] = (0, $1Pgvo.useState)('web');
    (0, $1Pgvo.useEffect)(()=>{
        const userAgent = navigator.userAgent || navigator.vendor;
        // Detect platform
        if (/android/i.test(userAgent)) {
            setPlatform('android');
            // Show fallback options for Android after a short delay
            const timer = setTimeout(()=>{
                setShowFallback(true);
            }, 1000);
            return ()=>clearTimeout(timer);
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            setPlatform('ios');
            // Redirect iOS to App Store
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            setPlatform('web');
            // Redirect web to website
            window.location.href = "https://returns.trade";
        }
    }, []);
    const openApp = ()=>{
        // Try to open the app with the status from URL
        const statusParam = status || 'live'; // Default to 'live' if no status provided
        window.location.href = `returns://options/${statusParam}`;
    };
    const downloadApp = ()=>{
        // Redirect to Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
    };
    // Don't render anything for iOS or web as they redirect immediately
    if (platform === 'ios' || platform === 'web') return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            textAlign: 'center',
            padding: '50px 20px',
            fontFamily: 'Arial, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
                children: "Opening Returns App..."
            }),
            showFallback && /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    marginTop: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        children: "If the app didn't open automatically, you can:"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            marginTop: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: openApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Open App"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: downloadApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Download App"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $c0d2ff97da0661bf$export$2e2bcd8739ae039 = $c0d2ff97da0661bf$var$Options;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

const $8bc3d46308beaceb$var$Futures = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const { status: status } = (0, $3a01a64de9a26688$export$99eaa27ddbbb95ef)();
    const [showFallback, setShowFallback] = (0, $1Pgvo.useState)(false);
    const [platform, setPlatform] = (0, $1Pgvo.useState)('web');
    (0, $1Pgvo.useEffect)(()=>{
        const userAgent = navigator.userAgent || navigator.vendor;
        // Detect platform
        if (/android/i.test(userAgent)) {
            setPlatform('android');
            // Show fallback options for Android after a short delay
            const timer = setTimeout(()=>{
                setShowFallback(true);
            }, 1000);
            return ()=>clearTimeout(timer);
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            setPlatform('ios');
            // Redirect iOS to App Store
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            setPlatform('web');
            // Redirect web to website
            window.location.href = "https://returns.trade";
        }
    }, []);
    const openApp = ()=>{
        // Try to open the app with the status from URL
        const statusParam = status || 'live'; // Default to 'live' if no status provided
        window.location.href = `returns://futures/${statusParam}`;
    };
    const downloadApp = ()=>{
        // Redirect to Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
    };
    // Don't render anything for iOS or web as they redirect immediately
    if (platform === 'ios' || platform === 'web') return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            textAlign: 'center',
            padding: '50px 20px',
            fontFamily: 'Arial, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
                children: "Opening Returns App..."
            }),
            showFallback && /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    marginTop: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        children: "If the app didn't open automatically, you can:"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            marginTop: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: openApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Open App"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: downloadApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Download App"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $8bc3d46308beaceb$export$2e2bcd8739ae039 = $8bc3d46308beaceb$var$Futures;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");

const $ab40b1b05eee4168$var$Multibagger = ()=>{
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const { status: status } = (0, $3a01a64de9a26688$export$99eaa27ddbbb95ef)();
    const [showFallback, setShowFallback] = (0, $1Pgvo.useState)(false);
    const [platform, setPlatform] = (0, $1Pgvo.useState)('web');
    (0, $1Pgvo.useEffect)(()=>{
        const userAgent = navigator.userAgent || navigator.vendor;
        // Detect platform
        if (/android/i.test(userAgent)) {
            setPlatform('android');
            // Show fallback options for Android after a short delay
            const timer = setTimeout(()=>{
                setShowFallback(true);
            }, 1000);
            return ()=>clearTimeout(timer);
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            setPlatform('ios');
            // Redirect iOS to App Store
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            setPlatform('web');
            // Redirect web to website
            window.location.href = "https://returns.trade";
        }
    }, []);
    const openApp = ()=>{
        // Try to open the app with the status from URL
        const statusParam = status || 'live'; // Default to 'live' if no status provided
        window.location.href = `returns://multibagger/${statusParam}`;
    };
    const downloadApp = ()=>{
        // Redirect to Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
    };
    // Don't render anything for iOS or web as they redirect immediately
    if (platform === 'ios' || platform === 'web') return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            textAlign: 'center',
            padding: '50px 20px',
            fontFamily: 'Arial, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
                children: "Opening Returns App..."
            }),
            showFallback && /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    marginTop: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        children: "If the app didn't open automatically, you can:"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            marginTop: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: openApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Open App"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                                onClick: downloadApp,
                                style: {
                                    padding: '12px 24px',
                                    margin: '0 10px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                },
                                children: "Download App"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ab40b1b05eee4168$export$2e2bcd8739ae039 = $ab40b1b05eee4168$var$Multibagger;


// import { useEffect, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import Cookies from 'js-cookie';
// declare global {
//   interface Window {
//     fbq: (...args: any[]) => void;
//   }
// }

var $j6whP = parcelRequire("j6whP");
const $583fd55fdc9db950$var$Install2 = ()=>{
    return /*#__PURE__*/ (0, $j6whP.jsx)("h2", {
        children: "Redirecting..."
    });
};
var $583fd55fdc9db950$export$2e2bcd8739ae039 = $583fd55fdc9db950$var$Install2;



var $j6whP = parcelRequire("j6whP");

var $1Pgvo = parcelRequire("1Pgvo");
var $bba670f99310b7d5$exports = {};

$bba670f99310b7d5$exports = (parcelRequire("7Hfbu")).getBundleURL('hYViF') + "contact-detail.fb0c7734.png";



function $3a19ea2f5e2aa678$export$2e2bcd8739ae039() {
    const [agreed, setAgreed] = (0, $1Pgvo.useState)(false);
    const [showError, setShowError] = (0, $1Pgvo.useState)(false);
    const navigate = (0, $3a01a64de9a26688$export$9770f232ac06a008)();
    const handleCheckboxChange = (e)=>{
        setAgreed(e.target.checked);
        if (e.target.checked) setShowError(false);
    };
    const handleSubmit = ()=>{
        if (!agreed) {
            setShowError(true);
            return;
        }
        // Handle submission logic here
        navigate("/under-review");
    };
    const termsContent = [
        {
            title: "1. Availing the Research Services",
            content: "By accepting the delivery of the research service, I confirm that I have voluntarily elected to subscribe to the research services of the Research Analyst (RA) at my sole discretion. I acknowledge that these services shall be rendered in accordance with the applicable provisions of the SEBI (Research Analyst) Regulations, 2014."
        },
        {
            title: "2. Obligations on RA",
            content: "The RA and I shall be bound by the SEBI Act and all applicable rules and regulations of SEBI, including the Research Analyst Regulations and relevant notifications issued from time to time."
        },
        {
            title: "3. Client Information and KYC",
            content: "I agree to furnish all required information and documents as mandated by SEBI/RAASB from time to time. I acknowledge that the RA shall collect, store, upload."
        },
        {
            title: "4. Standard Terms of Service",
            content: "I have read and understood the terms and conditions applicable to research analysts as defined under Regulation 2(1)(u) of the SEBI (Research Analyst) Regulations, 2014, including the fee structure. I am subscribing to the research services for my own benefit and consumption, and any reliance placed on the research report provided by the RA shall be based on my own judgment and assessment of the conclusions therein."
        },
        {
            title: "5. Investment Risks",
            content: "I understand that any investment made based on the recommendations in the research report is subject to market risks. Recommendations in the research report do not provide any assurance of returns. There is no recourse to claim any losses incurred based on such recommendations."
        },
        {
            title: "6. Research Analyst's Declaration",
            content: "The RA is duly registered with SEBI under the SEBI (Research Analyst) Regulations, 2014 (SEBI Registration No.: INH000014492, Registration Date: 12 Jan 2024). The RA possesses the required qualifications and complies with relevant legal provisions. The maximum fee charged by the RA is \u20B91.51 lakhs per annum per family of clients."
        },
        {
            title: "",
            content: "The recommendations provided by RA do not provide any assurance of returns"
        },
        {
            title: "7. Risk Factors",
            content: "Investments in securities market are subject to market risks. Read all the related documents carefully before investing. Registration granted by SEBI and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investor. We do not provide any guaranteed profit or fixed returns or any other services. We charge fixed fees and do not operate on any profit-sharing model. Images if any, shared with you are for illustration purposes only. We are not responsible for any financial loss or any other loss incurred by the client. Please be fully informed about the risk and costs involved in trading and investing. Please consult your investment advisor before trading. Trade only as per your risk appetite and risk profile. Trading/investing in stock market is risky due to its volatile nature. Upon accepting our service, you hereby accept that you fully understand the risks involved in trading/investing. We advise the viewers to apply own discretion while referring testimonials shared by the client. Past performances and results are no guarantee of future performance. All Report or recommendations shared are confidential and for the reference of paid members only. Any unapproved distribution of sensitive data will be considered as a breach of confidentiality and appropriate legal action shall be initiated. The Research Report or recommendations must not be used as a singular basis of any investment decision. The views do not consider the risk appetite or the particular circumstances of an individual investor; readers are requested to take professional advice before investing and trading. Our recommendations should not be construed as investment advice. Reports based on technical and derivative analysis centre on studying charts of a stock's price movement, outstanding positions and trading volume, as opposed to focusing on a company's fundamentals and, as such, may not match with a report on a company's fundamentals."
        },
        {
            title: "8. Conflict of Interest",
            content: "a. Disclosure Document - The particulars given in this Disclosure Document have been prepared in accordance with SEBI (Research Analyst) Regulations, 2014.The purpose of the Document is to provide essential information about the Research and recommendation Services in a manner to assist and enable the perspective client/client in making an informed decision for engaging in Research and recommendation services before investing. For the purpose of this Disclosure Document, Research Analyst is Mr Krushnakant sudhirkumar rathi Individual Research analyst (here in after referred as \u201CResearch Analyst\u201D). \n b. Descriptions about \u201CResearch Analyst\u201D - Terms and conditions of Research and Recommendation Services are detailed in the terms and condition document. Please refer to the same for details. No penalties/directions have been issued by SEBI under the SEBI Act or Regulations made there under against the Research Analyst relating to Research Analyst services. There are no pending material litigations or legal proceedings, findings of inspections or investigations for which action has been taken or initiated by any regulatory authority against the Research Analyst or its employees. \n c. Details of its associates - No associates. \n d. Disclosures with respect to Research and Recommendations Services - Research Analyst may have financial interest or actual/beneficial ownership in the securities recommended in its personal portfolio. Details of the same may be referred through the disclosures made at the time of advice. \n There are no actual or potential conflicts of interest arising from any connection to or association with any issuer of products/securities, including any material information or facts that might compromise its objectivity or independence in the carrying on of Research Analyst services. Such conflict of interest shall be disclosed to the client as and when they arise. \n Research Analyst or its employee or its associates have not received any compensation from the subject company in past 12 months. \n Research Analyst or its employee or its associates have not managed or co-managed the public offering of Subject Company in past 12 months. \n Research Analyst or its employee or its associates have received any compensation for investment banking or merchant banking of brokerage services from the subject company in past 12 months. \n Research Analyst or its employee or its associates have not received any compensation for products or services other than above from the subject company in past 12 months. \n Research Analyst or its employee or its associates have not received any compensation or other benefits from the Subject Company or 3rd party in connection with the research report/recommendation. \n The subject company was not a client of Research Analyst or its employee or its associates during twelve months preceding the date of distribution of the research report and recommendation services provided. \n Research Analysts or its employee or its associates has not served as an officer, director or employee of the subject company. \n Research Analysts has not been engaged in market making activity of the subject company \n The RA agrees to comply with all applicable SEBI regulations, circulars, and directions concerning the disclosure and mitigation of any actual or potential conflicts of interest."
        },
        {
            title: "9. Termination of Service and Refund of Fees",
            content: "Disclosure \n RA may suspend or terminate rendering of research services to client on account of suspension/ cancellation of registration of RA by SEBI and shall refund the residual amount to the client. \n In case of suspension of certificate of registration of the RA for more than 60 (sixty) days or cancellation of the RA registration, RA shall refund the fees, on a pro rata basis for the period from the effective date of cancellation/ suspension to end of the subscription period"
        },
        {
            title: "10. Additional Clauses",
            content: "The RA reserves the right to introduce additional voluntary clauses that comply with SEBI\u2019s rules, regulations, and circulars. Any changes to such clauses will be notified to the Client with a 15-day notice."
        },
        {
            title: "11. Mandatory Notice",
            content: "The Client acknowledges the receipt and understanding of the \u201CDo\u2019s and Don\u2019ts\u201D as specified in SEBI Master Circular SEBI/HO/MIRSD-POD1/P/CIR/2024/49 dated May 21, 2024 or as may be revised by SEBI from time to time."
        },
        {
            title: "12. Most Important Terms and Conditions (MITC)",
            content: "The RA will provide the Client with the Most Important Terms and Conditions (MITC) as standardized by the Industry Standards Forum (ISF) in consultation with SEBI and RAASB. \n a. These terms and conditions, and consent thereon are for the research services provided by the Research Analyst (RA) and RA cannot execute/carry out any trade (purchase/sell transaction) on behalf of, the client. Thus, the clients are advised not to permit RA to execute any trade on their behalf. \n b. The fee charged by RA to the client will be subject to the maximum of amount prescribed by SEBI/ Research Analyst Administration and Supervisory Body (RAASB) from time to time (applicable only for Individual and HUF Clients). \n Note- The current fee limit is Rs 1,51,000/- per annum per family of client for all research services of the RA. The fee limit does not include statutory charges. The fee limits do not apply to a non-individual client / accredited investor. \n c. RA may charge fees in advance if agreed by the client. Such advance	shall not exceed the period stipulated by SEBI; presently it is one quarter. In case of pre-mature termination of the RA services by either the client or the RA, the client shall be entitled to seek refund of proportionate fees only for unexpired period. \n d. Fees to RA may be paid by the client through any of the specified modes like cheque, online bank transfer, UPI, etc. Cash payment is not allowed. Optionally the client can make payments through Centralized Fee Collection Mechanism (CeFCoM) managed by BSE Limited (i.e. currently recognized RAASB). \n e. The RA is required to abide by the applicable regulations/ circulars/ directions specified by SEBI and RAASB from time to time in relation to disclosure and mitigation of any actual or potential conflict of interest. The RA will endeavour to promptly inform the client of any conflict of interest that may affect the services being rendered to the client. \n f. Any assured/guaranteed/fixed returns schemes or any other schemes of similar nature are prohibited by law. No scheme of this nature shall be offered to the client by the RA. \n g. The RA cannot guarantee returns, profits, accuracy, or risk-free investments from the use of the RA\u2019s research services. All opinions, projections, estimates of the RA are based on the analysis of available data under certain assumptions as of the date of preparation/publication of research report. \n h. If any executive or sales representative provides assurances of guaranteed returns, engages in profit-sharing arrangements, or offers unauthorized services such as handling your demat account, please note that such actions are strictly prohibited by law. \n We strongly advise clients not to act on such advice under any circumstances. Should you come across any such conduct, please report it immediately to us at via email at rathiequity6031@gmail.com	so that appropriate disciplinary measures can be taken against the responsible individual. \n If a client acts on any unauthorized recommendations during or after the expiry of their subscription, Krushnakant Sudhirkumar Rathi Proprietor of Rathi Equity Research shall not be held responsible for any resulting losses, and no refunds shall be issued for services whose validity has lapsed. \n Furthermore, we strongly recommend that all clients implement a stop-loss while trading to manage risk appropriately. Please be advised that does not bear responsibility for any profits or losses arising from your individual trading or investment decisions. \n i. Any investment made based on recommendations in research reports are subject to market risks, and recommendations do not provide any assurance of returns. There is no recourse to claim any losses incurred on the investments made based on the recommendations in the research report. Any reliance placed on the research report provided by the RA shall be as per the client\u2019s own judgement and assessment of the conclusions contained in the research report. \n j. The SEBI registration, Enlistment with RAASB, and NISM certification do not guarantee the performance of the RA or assure any returns to the client. \n k. For any grievances, \n Step 1: the client should first contact the RA using the details on its website or following contact details (at bottom) \n Step 2: If the resolution is unsatisfactory, the client can also lodge grievances through SEBI\u2019s SCORES platform at www.scores.sebi.gov.in \nStep 3: The client may also consider the Online Dispute Resolution (ODR) through the Smart ODR portal at https://smartodr.in \n l. Clients are required to keep contact details, including email id and mobile number/s updated with the RA at all times. \n m. The RA shall never ask for the client\u2019s login credentials and OTPs for the client\u2019s Trading Account Demat Account and Bank Account. Never share such information with anyone including RA."
        }
    ];
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            minHeight: '100vh',
            maxWidth: '500px',
            backgroundColor: 'var(--background-color)',
            color: 'var(--text-color-5)',
            display: 'flex',
            marginLeft: 'auto',
            marginRight: 'auto',
            flexDirection: 'column',
            fontFamily: 'Inter, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    padding: '1rem 1rem 1.25rem',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    backgroundColor: 'var(--background-color)',
                    position: 'sticky',
                    top: 0,
                    zIndex: 10
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("h1", {
                        style: {
                            color: 'var(--text-color-1)',
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            margin: '0 0 0.25rem 0',
                            fontFamily: 'Denton Test, sans-serif'
                        },
                        children: "Terms & Conditions"
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                        style: {
                            color: 'var(--text-color-2)',
                            fontSize: '0.875rem',
                            margin: '0',
                            fontFamily: 'Denton Test, sans-serif'
                        },
                        children: "Most Important Terms and Conditions (MITC)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    flex: 1,
                    overflowY: 'auto',
                    padding: '1rem',
                    WebkitOverflowScrolling: 'touch'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsx)("style", {
                        children: `
            div::-webkit-scrollbar {
              width: 6px;
            }
            div::-webkit-scrollbar-track {
              background: transparent;
            }
            div::-webkit-scrollbar-thumb {
              background: var(--primary-color);
              border-radius: 10px;
            }
          `
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            backgroundColor: 'rgba(255, 255, 255, 0.03)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            borderRadius: '8px',
                            padding: '1rem',
                            marginBottom: '3rem',
                            textAlign: 'left'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsx)("h3", {
                                style: {
                                    color: 'var(--text-color-1)',
                                    fontSize: '0.9375rem',
                                    fontWeight: '600',
                                    marginBottom: '0.75rem',
                                    marginTop: '0',
                                    fontFamily: 'Inter, sans-serif'
                                },
                                children: "Research Analyst Details"
                            }),
                            /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                                style: {
                                    fontSize: '0.8125rem',
                                    color: 'var(--text-color-2)',
                                    lineHeight: '1.6'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $j6whP.jsxs)("p", {
                                        style: {
                                            margin: '0 0 0.375rem 0'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $j6whP.jsx)("strong", {
                                                style: {
                                                    color: 'var(--text-color-4)'
                                                },
                                                children: "Name:"
                                            }),
                                            " Krushnakant Sudhirkumar Rathi (Proprietor of Rathi Equity Research)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $j6whP.jsxs)("p", {
                                        style: {
                                            margin: '0 0 0.375rem 0'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $j6whP.jsx)("strong", {
                                                style: {
                                                    color: 'var(--text-color-4)'
                                                },
                                                children: "SEBI Registration No.:"
                                            }),
                                            " INH000014492"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $j6whP.jsxs)("p", {
                                        style: {
                                            margin: '0'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $j6whP.jsx)("strong", {
                                                style: {
                                                    color: 'var(--text-color-4)'
                                                },
                                                children: "Address:"
                                            }),
                                            " 317, Third Floor, Galleria Tower, DLF City Phase 4, Gurugram - 122009"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    termsContent.map((section, index)=>/*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                            style: {
                                marginBottom: '1.5rem',
                                paddingBottom: '1.5rem',
                                borderBottom: index < termsContent.length - 1 ? '1px solid rgba(255, 255, 255, 0.05)' : 'none',
                                textAlign: 'left'
                            },
                            children: [
                                /*#__PURE__*/ (0, $j6whP.jsx)("h3", {
                                    style: {
                                        color: 'var(--text-color-1)',
                                        fontSize: '0.9375rem',
                                        fontWeight: '600',
                                        marginBottom: '0.5rem',
                                        fontFamily: 'Inter, sans-serif'
                                    },
                                    children: section.title
                                }),
                                /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                                    style: {
                                        color: 'var(--text-color-2)',
                                        fontSize: '0.8125rem',
                                        lineHeight: '1.6',
                                        margin: '0',
                                        whiteSpace: 'pre-line'
                                    },
                                    children: section.content
                                })
                            ]
                        }, index)),
                    /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                        style: {
                            textAlign: 'center',
                            marginTop: '1rem',
                            paddingBottom: '1rem'
                        },
                        children: /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                            style: {
                                color: 'var(--text-color-6)',
                                fontSize: '0.75rem',
                                lineHeight: '1.5',
                                margin: '0'
                            },
                            children: "Registration granted by SEBI and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                style: {
                    padding: '0 10px'
                },
                children: /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bba670f99310b7d5$exports))),
                    alt: "",
                    style: {
                        width: '100%'
                    }
                })
            }),
            /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                style: {
                    backgroundColor: 'var(--background-color)',
                    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                    padding: '1rem',
                    boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.3)'
                },
                children: [
                    /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                        style: {
                            backgroundColor: 'rgba(255, 255, 255, 0.03)',
                            border: `1.5px solid ${showError ? 'var(--primary-color)' : 'rgba(255, 255, 255, 0.15)'}`,
                            borderRadius: '10px',
                            padding: '1rem',
                            marginBottom: '1rem',
                            transition: 'all 0.3s ease',
                            textAlign: 'left'
                        },
                        children: [
                            /*#__PURE__*/ (0, $j6whP.jsxs)("label", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    cursor: 'pointer',
                                    gap: '0.75rem',
                                    WebkitTapHighlightColor: 'transparent'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $j6whP.jsx)("input", {
                                        type: "checkbox",
                                        checked: agreed,
                                        onChange: handleCheckboxChange,
                                        style: {
                                            width: '20px',
                                            height: '20px',
                                            minWidth: '20px',
                                            accentColor: 'var(--primary-color)',
                                            cursor: 'pointer',
                                            marginTop: '1px'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $j6whP.jsx)("span", {
                                        style: {
                                            color: 'var(--text-color-1)',
                                            fontSize: '0.9375rem',
                                            lineHeight: '1.5',
                                            userSelect: 'none'
                                        },
                                        children: "I have read, understood, and agree to abide by the Most Important Terms and Conditions (MITC) for availing the services of Rathi Equity Research. I acknowledge that I am fully aware of the risks and responsibilities associated with trading and investing based on research services."
                                    })
                                ]
                            }),
                            showError && /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
                                style: {
                                    color: 'var(--primary-color)',
                                    fontSize: '0.8125rem',
                                    marginTop: '0.625rem',
                                    marginLeft: '1.75rem',
                                    animation: 'shake 0.3s ease-in-out'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $j6whP.jsx)("style", {
                                        children: `
                  @keyframes shake {
                    0%, 100% { transform: translateX(0); }
                    25% { transform: translateX(-5px); }
                    75% { transform: translateX(5px); }
                  }
                `
                                    }),
                                    "Please accept the terms to continue"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column-reverse',
                            gap: '0.75rem'
                        },
                        children: /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                            onClick: handleSubmit,
                            disabled: !agreed,
                            style: {
                                width: '100%',
                                padding: '1rem',
                                background: agreed ? 'var(--primary-color)' : 'rgba(255, 255, 255, 0.1)',
                                color: agreed ? 'var(--text-color-1)' : 'var(--text-color-3)',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '1rem',
                                fontWeight: '600',
                                cursor: agreed ? 'pointer' : 'not-allowed',
                                transition: 'all 0.2s ease',
                                opacity: agreed ? '1' : '0.5',
                                fontFamily: 'Inter, sans-serif',
                                boxShadow: agreed ? 'var(--box-shadow-1)' : 'none',
                                WebkitTapHighlightColor: 'transparent',
                                touchAction: 'manipulation'
                            },
                            children: "Accept & Continue"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)("style", {
                children: `
          @media (min-width: 768px) {
            .user-agreement-container {
              max-width: 900px;
              margin: 0 auto;
              padding: 2rem 1.5rem;
            }
          }
        `
            })
        ]
    });
}



var $j6whP = parcelRequire("j6whP");
function $5512456b368383b8$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $j6whP.jsxs)("div", {
        style: {
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'var(--background-color, #0C0C0C)',
            color: 'var(--text-color-1, #FFFFFF)',
            fontFamily: 'Poppins, sans-serif',
            padding: '1rem',
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)("div", {
                style: {
                    width: 96,
                    height: 96,
                    borderRadius: '50%',
                    backgroundColor: '#049567',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '1.5rem'
                },
                children: /*#__PURE__*/ (0, $j6whP.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "48",
                    height: "48",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "white",
                    strokeWidth: "3",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0, $j6whP.jsx)("polyline", {
                        points: "20 6 9 17 4 12"
                    })
                })
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)("h1", {
                style: {
                    fontSize: '1.5rem',
                    fontWeight: 700,
                    marginBottom: '0.5rem',
                    color: 'var(--text-color-1, #FFFFFF)'
                },
                children: "Thank You!"
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)("p", {
                style: {
                    fontSize: '1rem',
                    fontWeight: 400,
                    color: 'var(--text-color-2, #BBBBBB)',
                    maxWidth: 400,
                    lineHeight: 1.5
                },
                children: "Your request has been successfully registered and is currently under review. We will notify you once it has been processed."
            }),
            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                onClick: ()=>window.location.href = '/',
                style: {
                    marginTop: '2rem',
                    padding: '0.75rem 1.5rem',
                    fontSize: '1rem',
                    fontWeight: 600,
                    backgroundColor: '#049567',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                },
                children: "Go to Home"
            })
        ]
    });
}



var $j6whP = parcelRequire("j6whP");
var $3d100543a6be796a$exports = {};

$parcel$export($3d100543a6be796a$exports, "container", function () { return $3d100543a6be796a$export$34e0f9847d4c02dd; }, function (v) { return $3d100543a6be796a$export$34e0f9847d4c02dd = v; });
$parcel$export($3d100543a6be796a$exports, "loader", function () { return $3d100543a6be796a$export$f4c5de44377d2946; }, function (v) { return $3d100543a6be796a$export$f4c5de44377d2946 = v; });
$parcel$export($3d100543a6be796a$exports, "spin", function () { return $3d100543a6be796a$export$c82e186cf428d56d; }, function (v) { return $3d100543a6be796a$export$c82e186cf428d56d = v; });
var $3d100543a6be796a$export$34e0f9847d4c02dd;
var $3d100543a6be796a$export$f4c5de44377d2946;
var $3d100543a6be796a$export$c82e186cf428d56d;
$3d100543a6be796a$export$34e0f9847d4c02dd = `SFNfsq_container`;
$3d100543a6be796a$export$f4c5de44377d2946 = `SFNfsq_loader`;
$3d100543a6be796a$export$c82e186cf428d56d = `SFNfsq_spin`;
$3d100543a6be796a$export$c82e186cf428d56d;


const $d443e6380b1b8c86$var$Loader = ()=>{
    return /*#__PURE__*/ (0, $j6whP.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3d100543a6be796a$exports))).container,
        children: /*#__PURE__*/ (0, $j6whP.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($3d100543a6be796a$exports))).loader
        })
    });
};
var $d443e6380b1b8c86$export$2e2bcd8739ae039 = $d443e6380b1b8c86$var$Loader;


const $80e79a765b17bf18$var$Layout = ({ children: children })=>{
    const location = (0, $3a01a64de9a26688$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(location.search);
    const adSource = searchParams.get('adSource');
    const hideLayout = location.pathname === "/install";
    const [ip, setIp] = (0, $1Pgvo.useState)(null);
    const [fbc, setFbc] = (0, $1Pgvo.useState)(null);
    const [fbp, setFbp] = (0, $1Pgvo.useState)(null);
    const [userAgent, setUserAgent] = (0, $1Pgvo.useState)(null);
    (0, $1Pgvo.useEffect)(()=>{
        // Get the _fbc and _fbp cookies
        const fbc = (0, (/*@__PURE__*/$parcel$interopDefault($6b1721c40a71bd4a$exports))).get('_fbc') || null; // Facebook Click ID (fbc)
        const fbp = (0, (/*@__PURE__*/$parcel$interopDefault($6b1721c40a71bd4a$exports))).get('_fbp') || null; // Facebook Pixel ID (fbp)
        const ua = navigator.userAgent || null;
        setFbc(fbc);
        setFbp(fbp);
        setUserAgent(ua);
        // Log the values to the console
        console.log("Facebook Click ID (fbc):", fbc);
        console.log("Facebook Pixel ID (fbp):", fbp);
        console.log("User Agent:", ua);
        fetch('https://api.ipify.org?format=json').then((response)=>response.json()).then((data)=>{
            const userIp = data.ip;
            setIp(userIp);
            console.log("User IP:", userIp);
            if (isValidData(userIp, fbc, fbp)) // If valid, send the API request
            sendApiRequest(userIp, fbc, fbp, ua);
            else console.error("One or more required values are missing or invalid.");
        }).catch((error)=>{
            console.error("Error fetching IP address:", error);
        });
    }, []);
    // Function to validate if the data is not null, empty, or undefined
    const isValidData = (ip, fbc, fbp)=>{
        return ip && fbc && fbp && ip.trim() !== "" && fbc.trim() !== "" && fbp.trim() !== "";
    };
    // Function to send the API request
    const sendApiRequest = (ip, fbc, fbp, ua)=>{
        const apiUrl = "https://tradeinsights.co.in/v1/api/metas/create";
        const payload = {
            ip: ip,
            fbc: fbc,
            fbp: fbp,
            user_agent: ua
        };
        // Include adSource in the payload if it exists
        if (adSource) payload.ad_source = adSource;
        fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json()).then((data)=>{
            console.log("API response:", data);
        }).catch((error)=>{
            console.error("Error sending API request:", error);
        });
    };
    return hideLayout ? /*#__PURE__*/ (0, $j6whP.jsx)((0, $j6whP.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $j6whP.jsxs)((0, $j6whP.Fragment), {
        children: [
            /*#__PURE__*/ (0, $j6whP.jsx)((0, $a68432c350589148$export$2e2bcd8739ae039), {}),
            children,
            /*#__PURE__*/ (0, $j6whP.jsx)((0, $d1b921ff84700f03$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $j6whP.jsx)("button", {
                onClick: ()=>{
                    const userAgent = navigator.userAgent || navigator.vendor;
                    if (/android/i.test(userAgent)) window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
                    else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
                    else window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692"; // Default to App Store
                },
                className: "downloadNowParent",
                children: /*#__PURE__*/ (0, $j6whP.jsxs)("span", {
                    className: "downloadContent",
                    children: [
                        "Download",
                        " ",
                        /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ccee0ee317a1ad4c$exports))),
                            alt: "Returns",
                            className: "returnsWealthLogo"
                        }),
                        " ",
                        "App",
                        /*#__PURE__*/ (0, $j6whP.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($07382137637ba534$exports))),
                            alt: "Arrow Icon",
                            style: {
                                width: "14px",
                                height: "14px",
                                fontWeight: "400",
                                marginLeft: "4px",
                                verticalAlign: "middle"
                            }
                        })
                    ]
                })
            })
        ]
    });
};
const $80e79a765b17bf18$var$App = ()=>{
    return /*#__PURE__*/ (0, $j6whP.jsx)((0, $bd69baf2ae763c6c$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $j6whP.jsxs)((0, $3a01a64de9a26688$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/install",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $8bc6cc3654b81cfa$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/install2",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $583fd55fdc9db950$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/invite/:invite_id",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $febdd877049e1a64$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/stocks/:status",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $ef78f34faf6dbdec$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/options/:status",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $c0d2ff97da0661bf$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/futures/:status",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $8bc3d46308beaceb$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/multibagger/:status",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $ab40b1b05eee4168$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/subscribe",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $fe41dd5ae32ed3df$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/analyze",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $4a83fc2474eb4c2d$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/portfolio",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $4af39e7840e6f6ca$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/automated-portfolio",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $9d953152f0bb5235$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/kyc",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $a3d8275856d532bc$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/user-agreement",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a19ea2f5e2aa678$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/home",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $0b95f4edb2f272a6$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/under-review",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $5512456b368383b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "/loader",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)((0, $d443e6380b1b8c86$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $j6whP.jsx)((0, $3a01a64de9a26688$export$e7b0ac011bb776c6), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $j6whP.jsx)($80e79a765b17bf18$var$Layout, {
                        children: /*#__PURE__*/ (0, $j6whP.jsx)((0, $ca6d0f1d2250f9b3$export$2e2bcd8739ae039), {})
                    })
                })
            ]
        })
    });
};
var $80e79a765b17bf18$export$2e2bcd8739ae039 = $80e79a765b17bf18$var$App;




const $684e34f676c77ca4$var$root = (0, $cb66d78021bfafed$exports.createRoot)(document.getElementById("root"));
$684e34f676c77ca4$var$root.render(/*#__PURE__*/ (0, $j6whP.jsx)((0, $80e79a765b17bf18$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.2d6180da.js.map
